/**
 * 미국 주식 티커 데이터 (자동 생성)
 * 총 6425개 종목
 */

export const US_TICKERS = new Set([
  "A", "AA", "AACB", "AACG", "AACI", "AACO", "AACP", "AADX", "AAL", "AAME", "AAMI", "AAOI", "AAON", "AAP", "AAPG", "AAPL", "AARD", "AAT", "AAUC", "AB",
  "ABAT", "ABBV", "ABCB", "ABCL", "ABEO", "ABEV", "ABG", "ABLV", "ABM", "ABNB", "ABOS", "ABR", "ABR-P-D", "ABR-P-E", "ABR-P-F", "ABSI", "ABT", "ABTC", "ABTS", "ABUS",
  "ABVC", "ABVX", "ABX", "ACA", "ACAA", "ACAD", "ACB", "ACCL", "ACCO", "ACCS", "ACDC", "ACEL", "ACET", "ACFN", "ACGC", "ACGL", "ACGLN", "ACGLO", "ACH", "ACHC",
  "ACHR", "ACHV", "ACI", "ACIC", "ACIU", "ACIW", "ACLS", "ACM", "ACMR", "ACN", "ACNB", "ACNT", "ACOG", "ACON", "ACP", "ACP-P-A", "ACR", "ACR-P-C", "ACR-P-D", "ACRE",
  "ACRS", "ACRV", "ACT", "ACTG", "ACTU", "ACU", "ACV", "ACVA", "ACXP", "AD", "ADAC", "ADAG", "ADAM", "ADAML", "ADAMM", "ADAMN", "ADAMZ", "ADBE", "ADC", "ADC-P-A",
  "ADCT", "ADEA", "ADGM", "ADI", "ADIG", "ADIL", "ADM", "ADMA", "ADNT", "ADP", "ADPT", "ADSE", "ADSK", "ADT", "ADTN", "ADUR", "ADUS", "ADV", "ADVB", "ADX",
  "ADXN", "AEAQ", "AEBI", "AEC", "AEE", "AEF", "AEG", "AEHL", "AEHR", "AEI", "AEIS", "AEM", "AEMD", "AENT", "AEO", "AEON", "AEP", "AER", "AERO", "AERT",
  "AES", "AESI", "AESP", "AEVA", "AEXA", "AEYE", "AFB", "AFCG", "AFG", "AFJK", "AFL", "AFRI", "AFRM", "AFYA", "AG", "AGBK", "AGCC", "AGCO", "AGD", "AGEN",
  "AGI", "AGIG", "AGIO", "AGL", "AGM", "AGM-A", "AGM-P-D", "AGM-P-E", "AGM-P-F", "AGM-P-G", "AGM-P-H", "AGM-P-I", "AGMB", "AGMH", "AGNC", "AGNCL", "AGNCM", "AGNCN", "AGNCO", "AGNCP",
  "AGNCZ", "AGNT", "AGO", "AGPU", "AGRO", "AGRZ", "AGX", "AGYS", "AHCO", "AHG", "AHL-P-D", "AHL-P-E", "AHL-P-F", "AHMA", "AHR", "AHRT", "AHRT-P-A", "AHT", "AHT-P-D", "AHT-P-F",
  "AHT-P-G", "AHT-P-H", "AHT-P-I", "AI", "AIAI", "AIB", "AIBZ", "AIDX", "AIFA", "AIFC", "AIFF", "AIFU", "AIG", "AIHS", "AII", "AIIA", "AIIO", "AIIR", "AIM", "AIMD",
  "AIN", "AIO", "AIOS", "AIOT", "AIP", "AIR", "AIRE", "AIRG", "AIRI", "AIRJ", "AIRO", "AIRS", "AIRT", "AIRTP", "AISP", "AIT", "AIV", "AIXC", "AIXI", "AIZ",
  "AJG", "AKA", "AKAM", "AKAN", "AKBA", "AKO-A", "AKO-B", "AKR", "AKTS", "AKTX", "ALAB", "ALAR", "ALB", "ALB-P-A", "ALC", "ALCO", "ALDF", "ALDX", "ALEC", "ALF",
  "ALG", "ALGM", "ALGN", "ALGS", "ALGT", "ALH", "ALHC", "ALIS", "ALIT", "ALK", "ALKS", "ALKT", "ALL", "ALL-P-H", "ALL-P-I", "ALL-P-J", "ALLE", "ALLO", "ALLR", "ALLT",
  "ALLY", "ALM", "ALMR", "ALMS", "ALMU", "ALNT", "ALNY", "ALOT", "ALOV", "ALOY", "ALP", "ALPS", "ALPX", "ALRM", "ALRS", "ALSN", "ALT", "ALTG", "ALTG-P-A", "ALTI",
  "ALTO", "ALUB", "ALV", "ALVO", "ALX", "ALXO", "ALZN", "AM", "AMAL", "AMAN", "AMAT", "AMBA", "AMBO", "AMBP", "AMBQ", "AMBR", "AMC", "AMCI", "AMCR", "AMCX",
  "AMD", "AME", "AMG", "AMGN", "AMH", "AMH-P-G", "AMH-P-H", "AMIX", "AMKR", "AMLX", "AMN", "AMOD", "AMP", "AMPG", "AMPH", "AMPL", "AMPX", "AMPY", "AMR", "AMRC",
  "AMRN", "AMRX", "AMRZ", "AMS", "AMSC", "AMSF", "AMSS", "AMST", "AMT", "AMTB", "AMTD", "AMTM", "AMTX", "AMWL", "AMX", "AMZE", "AMZN", "AN", "ANAB", "ANDE",
  "ANDG", "ANET", "ANF", "ANG-P-D", "ANGH", "ANGI", "ANGO", "ANGX", "ANIK", "ANIP", "ANIX", "ANL", "ANNA", "ANNX", "ANPA", "ANRO", "ANSC", "ANTA", "ANTX", "ANVS",
  "ANY", "AOD", "AOMR", "AON", "AORT", "AOS", "AOSL", "AOUT", "AP", "APA", "APAC", "APAM", "APC", "APD", "APEI", "APG", "APGE", "APH", "API", "APLD",
  "APLE", "APLM", "APMC", "APMD", "APO", "APOG", "APP", "APPF", "APPN", "APPS", "APRE", "APT", "APTV", "APUR", "APUS", "APVO", "APWC", "APXT", "APYX", "AQB",
  "AQMS", "AQN", "AQST", "AR", "ARAI", "ARAY", "ARBB", "ARBE", "ARBK", "ARCB", "ARCC", "ARCI", "ARCL", "ARCO", "ARCT", "ARDC", "ARDT", "ARDX", "ARE", "AREC",
  "AREN", "ARES", "ARES-P-B", "ARGX", "ARHS", "ARI", "ARIS", "ARKO", "ARKR", "ARL", "ARLO", "ARLP", "ARM", "ARMK", "ARMP", "AROC", "AROW", "ARQ", "ARQQ", "ARQT",
  "ARR", "ARR-P-C", "ARRY", "ARTC", "ARTL", "ARTNA", "ARTV", "ARTW", "ARVN", "ARW", "ARWR", "ARX", "ARXS", "AS", "ASA", "ASAN", "ASB", "ASB-P-E", "ASB-P-F", "ASBP",
  "ASC", "ASG", "ASGI", "ASH", "ASIC", "ASIX", "ASLE", "ASM", "ASMB", "ASML", "ASND", "ASO", "ASPC", "ASPI", "ASPN", "ASPS", "ASR", "ASRV", "ASST", "ASTC",
  "ASTE", "ASTH", "ASTI", "ASTL", "ASTS", "ASUR", "ASX", "ASYS", "ATAI", "ATAT", "ATCH", "ATCX", "ATEC", "ATEN", "ATER", "ATEX", "ATGL", "ATH-P-A", "ATH-P-B", "ATH-P-D",
  "ATH-P-E", "ATHE", "ATHM", "ATHR", "ATI", "ATII", "ATKR", "ATLC", "ATLCP", "ATLO", "ATLX", "ATMU", "ATNI", "ATNM", "ATO", "ATOM", "ATOS", "ATPC", "ATR", "ATRA",
  "ATRC", "ATRO", "ATS", "ATTO", "ATXG", "ATYR", "AU", "AUB", "AUB-P-A", "AUBN", "AUC", "AUDC", "AUGO", "AUID", "AUNA", "AUPH", "AUR", "AURA", "AURE", "AUST",
  "AUTL", "AUUD", "AVA", "AVAH", "AVAL", "AVAT", "AVAV", "AVB", "AVBC", "AVBH", "AVBP", "AVD", "AVEX", "AVGO", "AVIR", "AVK", "AVLN", "AVNT", "AVNW", "AVO",
  "AVPT", "AVR", "AVT", "AVTR", "AVTX", "AVX", "AVXL", "AVY", "AWF", "AWI", "AWK", "AWP", "AWR", "AWRE", "AWX", "AX", "AXG", "AXGN", "AXIL", "AXIN",
  "AXON", "AXP", "AXR", "AXS", "AXS-P-E", "AXSM", "AXTA", "AXTI", "AYA", "AYI", "AYTU", "AZ", "AZI", "AZIO", "AZN", "AZO", "AZTA", "AZTR", "AZUL", "AZZ",
  "B", "BA", "BA-P-A", "BABA", "BAC", "BAC-P-B", "BAC-P-E", "BAC-P-K", "BAC-P-L", "BAC-P-M", "BAC-P-N", "BAC-P-O", "BAC-P-P", "BAC-P-Q", "BAC-P-S", "BACC", "BAER", "BAFN", "BAH", "BAK",
  "BALL", "BALY", "BAM", "BANC", "BANC-P-F", "BAND", "BANF", "BANFP", "BANL", "BANR", "BANX", "BAOS", "BAP", "BARK", "BATL", "BATRA", "BATRK", "BAX", "BB", "BBAI",
  "BBAR", "BBBY", "BBCP", "BBCQ", "BBD", "BBDC", "BBDO", "BBGI", "BBIO", "BBLG", "BBN", "BBNX", "BBOT", "BBSI", "BBT", "BBUC", "BBVA", "BBW", "BBWI", "BBY",
  "BC", "BCAB", "BCAL", "BCAR", "BCAT", "BCAX", "BCBP", "BCC", "BCCQ", "BCDA", "BCE", "BCG", "BCH", "BCHT", "BCIC", "BCML", "BCO", "BCPC", "BCRX", "BCS",
  "BCSF", "BCSS", "BCTX", "BCV", "BCV-P-A", "BCX", "BCYC", "BDC", "BDCI", "BDJ", "BDL", "BDMD", "BDN", "BDRX", "BDSX", "BDTX", "BDX", "BE", "BEAG", "BEAM",
  "BEAT", "BEBE", "BEEM", "BEEP", "BEKE", "BELFA", "BELFB", "BEN", "BENF", "BEP", "BEP-P-A", "BEPC", "BESS", "BETA", "BETR", "BF-A", "BF-B", "BFAM", "BFC", "BFH",
  "BFH-P-A", "BFH-P-B", "BFLY", "BFRG", "BFRI", "BFS", "BFS-P-D", "BFS-P-E", "BFST", "BG", "BGB", "BGC", "BGDE", "BGH", "BGI", "BGIN", "BGL", "BGLC", "BGM", "BGMS",
  "BGR", "BGS", "BGSF", "BGSI", "BGT", "BGX", "BGY", "BH", "BH-A", "BHAV", "BHB", "BHC", "BHE", "BHF", "BHFAM", "BHFAN", "BHFAO", "BHFAP", "BHK", "BHM",
  "BHP", "BHR", "BHR-P-B", "BHR-P-D", "BHRB", "BHST", "BHV", "BHVN", "BIAF", "BID", "BIDU", "BIIB", "BIII", "BILI", "BILL", "BIO", "BIO-B", "BIOA", "BIOT", "BIOX",
  "BIP", "BIP-P-A", "BIP-P-B", "BIPC", "BIRD", "BIRK", "BIT", "BIVI", "BIXI", "BIYA", "BJ", "BJDX", "BJRI", "BKD", "BKE", "BKH", "BKHA", "BKKT", "BKNG", "BKR",
  "BKSY", "BKT", "BKTI", "BKU", "BKV", "BKYI", "BL", "BLBD", "BLCO", "BLDP", "BLDR", "BLFS", "BLIN", "BLIV", "BLK", "BLKB", "BLLN", "BLMN", "BLND", "BLNE",
  "BLNK", "BLRK", "BLRX", "BLSH", "BLSM", "BLTE", "BLUW", "BLW", "BLX", "BLZE", "BLZR", "BMA", "BMBL", "BME", "BMEA", "BMEZ", "BMGL", "BMHL", "BMI", "BML-P-G",
  "BML-P-H", "BML-P-J", "BML-P-L", "BMM", "BMN", "BMNP", "BMNR", "BMO", "BMR", "BMRA", "BMRC", "BMRN", "BMY", "BN", "BNAI", "BNC", "BNED", "BNGO", "BNKK", "BNL",
  "BNR", "BNRG", "BNS", "BNT", "BNTC", "BNTX", "BNY", "BNY-P-K", "BOBS", "BOC", "BODI", "BOE", "BOF", "BOH", "BOH-P-A", "BOH-P-B", "BOKF", "BOLD", "BOLT", "BON",
  "BOOM", "BOOT", "BORR", "BOSC", "BOT", "BOTJ", "BOW", "BOX", "BOXL", "BP", "BPAC", "BPOP", "BPOPM", "BPRE", "BPRN", "BQ", "BR", "BRAG", "BRAI", "BRBI",
  "BRBR", "BRBS", "BRC", "BRCB", "BRCC", "BREZ", "BRFH", "BRIA", "BRID", "BRK-A", "BRK-B", "BRKH", "BRKR", "BRKRP", "BRLS", "BRLT", "BRN", "BRNS", "BRO", "BROS",
  "BRR", "BRSL", "BRSP", "BRT", "BRTX", "BRUN", "BRVE", "BRW", "BRX", "BRZE", "BSAA", "BSAC", "BSBK", "BSBR", "BSEM", "BSET", "BSIN", "BSL", "BSM", "BSP",
  "BSRR", "BST", "BSTZ", "BSVN", "BSX", "BSY", "BTAI", "BTBD", "BTBT", "BTCS", "BTCT", "BTDR", "BTE", "BTG", "BTGO", "BTI", "BTMD", "BTO", "BTOC", "BTOG",
  "BTQ", "BTSG", "BTT", "BTTC", "BTU", "BTX", "BTZ", "BUD", "BUDA", "BUI", "BULL", "BUR", "BURL", "BUSE", "BUSEP", "BUUU", "BV", "BVC", "BVFL", "BVN",
  "BVS", "BW", "BW-P-A", "BWA", "BWAY", "BWB", "BWBBP", "BWEN", "BWFG", "BWG", "BWIN", "BWIV", "BWLP", "BWMN", "BWMX", "BWXT", "BX", "BXBL", "BXC", "BXDC",
  "BXMT", "BXP", "BXSL", "BY", "BYAH", "BYD", "BYFC", "BYND", "BYRN", "BYSI", "BZ", "BZAI", "BZFD", "BZH", "BZUN", "C", "C-P-N", "C-P-R", "CAAP", "CAAS",
  "CABA", "CABO", "CABR", "CAC", "CACC", "CACI", "CADL", "CAE", "CAES", "CAF", "CAG", "CAH", "CAI", "CAII", "CAKE", "CAL", "CALC", "CALM", "CALX", "CALY",
  "CAMP", "CAMT", "CAN", "CANF", "CANG", "CAPL", "CAPN", "CAPR", "CAPS", "CAQ", "CAR", "CARE", "CARG", "CARL", "CARR", "CARS", "CART", "CASH", "CASS", "CAST",
  "CASY", "CAT", "CATO", "CATX", "CATY", "CAVA", "CB", "CBAN", "CBAT", "CBC", "CBFV", "CBIO", "CBK", "CBL", "CBLL", "CBNA", "CBNK", "CBOE", "CBRE", "CBRL",
  "CBRS", "CBSH", "CBT", "CBU", "CBUS", "CBZ", "CC", "CCAP", "CCAQ", "CCB", "CCBG", "CCC", "CCCC", "CCCT", "CCD", "CCEC", "CCEL", "CCEP", "CCG", "CCHH",
  "CCI", "CCID", "CCIF", "CCII", "CCJ", "CCK", "CCL", "CCLD", "CCM", "CCNE", "CCNEP", "CCO", "CCOI", "CCS", "CCSI", "CCTG", "CCU", "CCXI", "CCZ", "CD",
  "CDE", "CDIO", "CDLR", "CDLX", "CDNA", "CDNL", "CDNS", "CDP", "CDR-P-B", "CDR-P-C", "CDRE", "CDRO", "CDT", "CDTG", "CDW", "CDXS", "CDZI", "CDZIP", "CE", "CECO",
  "CEE", "CEG", "CELC", "CELH", "CELU", "CELZ", "CENN", "CENT", "CENTA", "CENX", "CEPF", "CEPL", "CEPO", "CEPS", "CEPU", "CEPV", "CERS", "CERT", "CET", "CETX",
  "CETY", "CEV", "CEVA", "CF", "CFBK", "CFFI", "CFFN", "CFG", "CFG-P-E", "CFG-P-H", "CFG-P-I", "CFND", "CFR", "CFR-P-B", "CFTR-P-A", "CG", "CGAU", "CGBD", "CGC", "CGEM",
  "CGEN", "CGNT", "CGNX", "CGO", "CGON", "CGTL", "CGTX", "CHA", "CHAI", "CHAR", "CHCI", "CHCO", "CHCT", "CHD", "CHDN", "CHE", "CHEC", "CHEF", "CHGA", "CHGG",
  "CHH", "CHI", "CHKP", "CHMG", "CHMI", "CHMI-P-A", "CHMI-P-B", "CHNR", "CHOW", "CHPG", "CHPT", "CHR", "CHRD", "CHRN", "CHRS", "CHRW", "CHSCL", "CHSCM", "CHSCN", "CHSCO",
  "CHSCP", "CHSN", "CHT", "CHTR", "CHW", "CHWY", "CHY", "CHYM", "CI", "CIA", "CIB", "CIEN", "CIFR", "CIG", "CIG-C", "CIGI", "CIGL", "CII", "CIIT", "CIK",
  "CIM", "CIM-P-A", "CIM-P-B", "CIM-P-C", "CIM-P-D", "CINF", "CING", "CINT", "CION", "CIRC", "CISO", "CISS", "CITR", "CIVB", "CIX", "CJMB", "CKX", "CL", "CLAR", "CLB",
  "CLBK", "CLBR", "CLBT", "CLDI", "CLDT", "CLDT-P-A", "CLDX", "CLF", "CLFD", "CLGN", "CLH", "CLIK", "CLIR", "CLLS", "CLM", "CLMB", "CLMT", "CLNE", "CLNN", "CLOV",
  "CLPR", "CLPS", "CLPT", "CLRB", "CLRO", "CLS", "CLSK", "CLST", "CLVT", "CLW", "CLWT", "CLX", "CLYM", "CM", "CMBT", "CMC", "CMCL", "CMCM", "CMCO", "CMCSA",
  "CMCT", "CMDB", "CME", "CMG", "CMI", "CMII", "CMMB", "CMND", "CMP", "CMPR", "CMPS", "CMPX", "CMRC", "CMRE", "CMRE-P-B", "CMRE-P-C", "CMRE-P-D", "CMS", "CMS-P-B", "CMS-P-C",
  "CMT", "CMTG", "CMTL", "CMTV", "CNA", "CNC", "CNCK", "CNDT", "CNET", "CNEY", "CNF", "CNH", "CNI", "CNK", "CNL", "CNM", "CNMD", "CNNE", "CNO", "CNOB",
  "CNOBP", "CNP", "CNQ", "CNR", "CNS", "CNSP", "CNSY", "CNTB", "CNTN", "CNTX", "CNTY", "CNVS", "CNX", "CNXC", "CNXN", "CNXU", "COAG", "COCH", "COCO", "COCP",
  "CODA", "CODI", "CODI-P-A", "CODI-P-B", "CODI-P-C", "CODX", "COE", "COF", "COF-P-I", "COF-P-J", "COF-P-K", "COF-P-L", "COF-P-N", "COFS", "COGT", "COHN", "COHR", "COHU", "COIN", "COKE",
  "COLA", "COLB", "COLD", "COLL", "COLM", "COMP", "CON", "COO", "COOK", "COOT", "COP", "COPL", "COPR", "COR", "CORT", "CORZ", "COSM", "COSO", "COST", "COTY",
  "COUR", "COYA", "CP", "CPA", "CPAC", "CPAY", "CPB", "CPBI", "CPF", "CPHC", "CPHI", "CPIX", "CPK", "CPNG", "CPOP", "CPRI", "CPRT", "CPS", "CPSH", "CPSS",
  "CPT", "CPZ", "CQP", "CR", "CRAC", "CRAI", "CRAN", "CRAQ", "CRBG", "CRBP", "CRBU", "CRC", "CRCL", "CRCT", "CRD-A", "CRD-B", "CRDF", "CRDL", "CRDO", "CRE",
  "CRESY", "CREX", "CRF", "CRGO", "CRGY", "CRH", "CRI", "CRIS", "CRK", "CRL", "CRM", "CRMD", "CRML", "CRMT", "CRNC", "CRNT", "CRNX", "CRON", "CROX", "CRS",
  "CRSP", "CRSR", "CRT", "CRTO", "CRUS", "CRVL", "CRVO", "CRVS", "CRWD", "CRWS", "CRWV", "CSAI", "CSAN", "CSBR", "CSCO", "CSGP", "CSHR", "CSIQ", "CSL", "CSPI",
  "CSQ", "CSQR", "CSR", "CSTE", "CSTL", "CSTM", "CSV", "CSW", "CSWC", "CSX", "CTA-P-A", "CTA-P-B", "CTAA", "CTAS", "CTBI", "CTEV", "CTGO", "CTKB", "CTM", "CTMX",
  "CTNM", "CTNT", "CTO", "CTO-P-A", "CTOR", "CTOS", "CTRE", "CTRI", "CTRM", "CTRN", "CTS", "CTSH", "CTSO", "CTVA", "CTW", "CTXR", "CUB", "CUBE", "CUBI", "CUE",
  "CULP", "CUPR", "CURB", "CURI", "CURR", "CURV", "CURX", "CUVL", "CUZ", "CV", "CVBF", "CVCO", "CVE", "CVEO", "CVGI", "CVI", "CVKD", "CVLG", "CVLT", "CVM",
  "CVNA", "CVR", "CVRX", "CVS", "CVSA", "CVU", "CVV", "CVX", "CW", "CWBC", "CWCO", "CWD", "CWEN", "CWH", "CWK", "CWST", "CWT", "CX", "CXAI", "CXDO",
  "CXII", "CXM", "CXT", "CXW", "CYAB", "CYCN", "CYCU", "CYD", "CYH", "CYN", "CYPH", "CYRX", "CYTK", "CZFS", "CZNC", "CZR", "CZWI", "D", "DAAQ", "DAC",
  "DAIC", "DAIO", "DAKT", "DAL", "DAN", "DAO", "DAR", "DARE", "DASH", "DAVA", "DAVE", "DB", "DBCA", "DBD", "DBGI", "DBI", "DBL", "DBRG", "DBRG-P-H", "DBRG-P-I",
  "DBRG-P-J", "DBVT", "DBX", "DC", "DCBO", "DCGO", "DCH", "DCI", "DCO", "DCOM", "DCOM-P", "DCOY", "DCTH", "DCX", "DD", "DDC", "DDD", "DDI", "DDL", "DDOG",
  "DDS", "DDT", "DE", "DEA", "DEC", "DECK", "DEFT", "DEI", "DELL", "DEO", "DERM", "DETX", "DFDV", "DFH", "DFIN", "DFLI", "DFNS", "DFP", "DFSC", "DFTX",
  "DG", "DGAC", "DGICA", "DGICB", "DGII", "DGNX", "DGX", "DGXX", "DH", "DHC", "DHF", "DHI", "DHR", "DHT", "DHX", "DHY", "DIBS", "DIN", "DINO", "DIOD",
  "DIS", "DIT", "DJCO", "DJT", "DK", "DKI", "DKL", "DKNG", "DKS", "DLB", "DLHC", "DLNG", "DLO", "DLPN", "DLR", "DLR-P-J", "DLR-P-K", "DLR-P-L", "DLTH", "DLTR",
  "DLX", "DLXY", "DLY", "DMA", "DMAA", "DMAC", "DMB", "DMC", "DMII", "DMLP", "DMO", "DMRA", "DMRC", "DNA", "DNLI", "DNMX", "DNN", "DNOW", "DNP", "DNTH",
  "DNUT", "DOC", "DOCN", "DOCS", "DOCU", "DOGZ", "DOLE", "DOMH", "DOMO", "DOO", "DORM", "DOUG", "DOV", "DOW", "DOX", "DOYU", "DPC", "DPG", "DPRO", "DPU",
  "DPZ", "DQ", "DRCT", "DRD", "DRDB", "DRH", "DRI", "DRIO", "DRMA", "DRS", "DRTS", "DRUG", "DRVN", "DSAC", "DSC", "DSGN", "DSGR", "DSGX", "DSL", "DSM",
  "DSP", "DSS", "DSU", "DSWL", "DSX", "DSX-P-B", "DSY", "DT", "DTCX", "DTE", "DTF", "DTI", "DTIL", "DTM", "DTSQ", "DTSS", "DTST", "DUK", "DUK-P-A", "DUKR",
  "DUO", "DUOL", "DUOT", "DV", "DVA", "DVLT", "DVN", "DWSN", "DWTX", "DX", "DX-P-C", "DXC", "DXCM", "DXF", "DXLG", "DXPE", "DXR", "DXST", "DXYZ", "DY",
  "DYAI", "DYN", "DYNC", "DYOR", "E", "EAD", "EAF", "EAI", "EARN", "EAT", "EBAY", "EBC", "EBF", "EBMT", "EBON", "EBS", "EC", "ECAT", "ECBK", "ECC",
  "ECC-P-D", "ECCC", "ECF", "ECF-P-A", "ECG", "ECHO", "ECL", "ECO", "ECOR", "ECPG", "ECVT", "ECX", "ED", "EDBL", "EDD", "EDF", "EDHL", "EDIT", "EDN", "EDRY",
  "EDSA", "EDTK", "EDU", "EDUC", "EE", "EEA", "EEFT", "EEIQ", "EFC", "EFC-P-B", "EFC-P-C", "EFC-P-D", "EFOI", "EFOR", "EFR", "EFSC", "EFSCP", "EFSI", "EFT", "EFTY",
  "EFX", "EFXT", "EG", "EGAN", "EGBN", "EGG", "EGHA", "EGHT", "EGO", "EGP", "EGY", "EH", "EHC", "EHGO", "EHI", "EHLD", "EHTH", "EIC", "EICA", "EIG",
  "EIIA", "EIKN", "EIM", "EIX", "EJH", "EL", "ELA", "ELAB", "ELAN", "ELBM", "ELC", "ELDN", "ELE", "ELF", "ELLO", "ELMD", "ELME", "ELMT", "ELOG", "ELOX",
  "ELPC", "ELPW", "ELS", "ELTK", "ELTX", "ELUT", "ELV", "ELVA", "ELVN", "ELVR", "ELWT", "EMA", "EMAT", "EMBC", "EMBJ", "EMD", "EME", "EMF", "EMIS", "EML",
  "EMN", "EMO", "EMP", "EMPD", "EMR", "ENB", "ENGN", "ENGS", "ENHA", "ENIC", "ENJ", "ENLT", "ENLV", "ENO", "ENOV", "ENPH", "ENR", "ENRD", "ENS", "ENSC",
  "ENSG", "ENTA", "ENTG", "ENTX", "ENVA", "ENVB", "ENVX", "EOD", "EOG", "EOI", "EOLS", "EONR", "EOS", "EOSE", "EOT", "EP", "EP-P-C", "EPAC", "EPAM", "EPC",
  "EPD", "EPM", "EPOW", "EPR", "EPR-P-C", "EPR-P-E", "EPR-P-G", "EPRT", "EPRX", "EPSM", "EPSN", "EQ", "EQBK", "EQH", "EQH-P-A", "EQH-P-C", "EQIX", "EQNR", "EQPT", "EQR",
  "EQS", "EQT", "EQX", "ERAS", "ERC", "ERH", "ERIC", "ERIE", "ERII", "ERNA", "ERO", "EROC", "EROK", "ES", "ESAB", "ESBA", "ESCA", "ESE", "ESEA", "ESI",
  "ESLA", "ESLT", "ESNT", "ESOA", "ESP", "ESQ", "ESRT", "ESS", "ESTA", "ESTC", "ET", "ETB", "ETD", "ETG", "ETI-P", "ETJ", "ETN", "ETO", "ETON", "ETOR",
  "ETR", "ETS", "ETSS", "ETSY", "ETV", "ETW", "ETX", "ETY", "EU", "EUDA", "EURK", "EVAC", "EVAX", "EVC", "EVCM", "EVER", "EVEX", "EVF", "EVG", "EVGN",
  "EVGO", "EVH", "EVI", "EVLV", "EVMN", "EVN", "EVO", "EVOX", "EVR", "EVRG", "EVT", "EVTC", "EVTL", "EVV", "EW", "EWBC", "EWTX", "EXC", "EXE", "EXEL",
  "EXFY", "EXG", "EXK", "EXLS", "EXOD", "EXOZ", "EXP", "EXPD", "EXPE", "EXPO", "EXR", "EXTR", "EXYN", "EYE", "EYPT", "EZGO", "EZPW", "EZRA", "F", "FA",
  "FABC", "FAC", "FACT", "FAF", "FAMI", "FANG", "FAST", "FATE", "FATN", "FAX", "FBGL", "FBIN", "FBIO", "FBIOP", "FBIZ", "FBK", "FBLA", "FBLG", "FBNC", "FBP",
  "FBRT", "FBRT-P-E", "FBRX", "FBYD", "FBYDP", "FC", "FCAP", "FCBC", "FCBM", "FCCO", "FCEL", "FCF", "FCFS", "FCHL", "FCN", "FCNCA", "FCNCN", "FCNCO", "FCNCP", "FCPT",
  "FCRS", "FCT", "FCUV", "FCX", "FDBC", "FDMM", "FDMT", "FDS", "FDSB", "FDUS", "FDX", "FDXF", "FE", "FEAM", "FEBO", "FEDU", "FEED", "FEIM", "FELE", "FEMY",
  "FENC", "FENG", "FER", "FERA", "FERG", "FET", "FF", "FFA", "FFAI", "FFBC", "FFC", "FFIN", "FFIV", "FG", "FGBI", "FGBIP", "FGI", "FGII", "FGL", "FGNX",
  "FGNXP", "FHB", "FHI", "FHN", "FHN-P-E", "FHN-P-F", "FHN-P-H", "FHTX", "FIBK", "FICO", "FIEE", "FIG", "FIGR", "FIGS", "FIGX", "FINS", "FINV", "FINW", "FIP", "FIRY",
  "FIS", "FISI", "FISK", "FISN", "FISV", "FITB", "FITB-P-A", "FITB-P-I", "FITB-P-K", "FITB-P-M", "FIVE", "FIVN", "FIX", "FIZZ", "FJET", "FKWL", "FLC", "FLD", "FLEX", "FLG",
  "FLG-P-A", "FLGT", "FLL", "FLNA", "FLNC", "FLNG", "FLNT", "FLO", "FLOC", "FLR", "FLS", "FLUT", "FLUX", "FLWS", "FLX", "FLXS", "FLY", "FLYE", "FLYW", "FLYX",
  "FLZH", "FMAC", "FMAO", "FMBH", "FMC", "FMFC", "FMN", "FMNB", "FMS", "FMST", "FMX", "FMY", "FN", "FNB", "FND", "FNF", "FNGR", "FNKO", "FNLC", "FNRN",
  "FNUC", "FNV", "FNWB", "FNWD", "FOA", "FOCL", "FOF", "FOFO", "FOR", "FORM", "FORR", "FORTY", "FOSL", "FOUR", "FOUR-P-A", "FOX", "FOXA", "FOXF", "FOXX", "FPF",
  "FPH", "FPI", "FPS", "FR", "FRA", "FRAF", "FRBA", "FRBT", "FRD", "FRGT", "FRHC", "FRME", "FRMEP", "FRMI", "FRMM", "FRNM", "FRO", "FROG", "FRPH", "FRPT",
  "FRSH", "FRST", "FRSX", "FRT", "FRT-P-C", "FRTT", "FRVO", "FSBC", "FSBW", "FSCO", "FSEA", "FSHP", "FSI", "FSK", "FSLR", "FSLY", "FSM", "FSP", "FSS", "FSSL",
  "FSTR", "FSUN", "FSV", "FT", "FTAI", "FTAIM", "FTCI", "FTDR", "FTEK", "FTF", "FTFT", "FTH", "FTHA", "FTHM", "FTHY", "FTI", "FTK", "FTLF", "FTNT", "FTRA",
  "FTRE", "FTRK", "FTS", "FTV", "FTW", "FUBO", "FUFU", "FUL", "FULC", "FULT", "FULTP", "FUN", "FUNC", "FUND", "FURY", "FUSB", "FUSE", "FUTU", "FVAV", "FVCB",
  "FVN", "FVR", "FVRR", "FWAC", "FWDI", "FWONA", "FWONK", "FWRD", "FWRG", "FXAC", "FXHO", "FXNC", "G", "GAB", "GAB-P-G", "GAB-P-H", "GAB-P-K", "GABC", "GAIA", "GAIN",
  "GALT", "GAM", "GAM-P-B", "GAME", "GANX", "GAP", "GASS", "GATX", "GAU", "GAUZ", "GBAB", "GBCI", "GBDC", "GBFH", "GBLI", "GBR", "GBTG", "GBX", "GCBC", "GCDT",
  "GCGR", "GCL", "GCMG", "GCO", "GCT", "GCTK", "GCTS", "GCV", "GD", "GDC", "GDDY", "GDEV", "GDHG", "GDL", "GDO", "GDOT", "GDRX", "GDS", "GDTC", "GDV",
  "GDV-P-H", "GDV-P-K", "GDYN", "GE", "GECC", "GEF", "GEF-B", "GEG", "GEHC", "GEL", "GELS", "GEMI", "GEN", "GENB", "GENC", "GENI", "GENK", "GEO", "GEOS", "GERN",
  "GETY", "GEV", "GEVO", "GF", "GFAI", "GFF", "GFI", "GFL", "GFR", "GFS", "GFUZ", "GGAL", "GGB", "GGG", "GGN", "GGN-P-B", "GGR", "GGRP", "GGT", "GGT-P-E",
  "GGT-P-G", "GGZ", "GH", "GHC", "GHG", "GHI", "GHM", "GHRS", "GHY", "GIB", "GIBO", "GIC", "GIFT", "GIGM", "GIII", "GIL", "GILD", "GILT", "GIPR", "GIS",
  "GITS", "GIW", "GIX", "GJH", "GJO", "GJP", "GJR", "GJS", "GJT", "GKOS", "GL", "GLAD", "GLAS", "GLBE", "GLBS", "GLDG", "GLE", "GLED", "GLIBA", "GLIBK",
  "GLMD", "GLND", "GLNG", "GLO", "GLOB", "GLOO", "GLOP-P-A", "GLOP-P-B", "GLOP-P-C", "GLP", "GLPI", "GLQ", "GLRE", "GLSI", "GLU", "GLU-P-A", "GLU-P-B", "GLUE", "GLV", "GLW",
  "GLXG", "GLXY", "GM", "GMAB", "GME", "GMED", "GMEX", "GMHS", "GMM", "GMRS", "GMTL", "GNE", "GNK", "GNL", "GNL-P-A", "GNL-P-B", "GNL-P-D", "GNL-P-E", "GNLN", "GNLX",
  "GNPX", "GNRC", "GNS", "GNSS", "GNT", "GNT-P-A", "GNTA", "GNTX", "GNW", "GO", "GOAI", "GOF", "GOGO", "GOLD", "GOLF", "GOOD", "GOODN", "GOODO", "GOOG", "GOOGL",
  "GOOGM", "GOOGN", "GOOS", "GORO", "GOSS", "GOTU", "GOVX", "GP", "GPAC", "GPAT", "GPC", "GPCR", "GPGI", "GPI", "GPK", "GPMT", "GPMT-P-A", "GPN", "GPOR", "GPRE",
  "GPRK", "GPRO", "GPUS", "GPUS-P-D", "GRAB", "GRAL", "GRAN", "GRBK", "GRBK-P-A", "GRC", "GRCE", "GRDN", "GRDX", "GRF", "GRFS", "GRI", "GRML", "GRMN", "GRND", "GRNQ",
  "GRNT", "GRO", "GROV", "GROW", "GROY", "GRPN", "GRRR", "GRSD", "GRVY", "GRWG", "GRX", "GS", "GS-P-A", "GS-P-C", "GS-P-D", "GSAT", "GSBC", "GSBD", "GSHD", "GSHR",
  "GSIT", "GSIW", "GSK", "GSL", "GSL-P-B", "GSM", "GSRF", "GSRV", "GSUN", "GT", "GTBP", "GTE", "GTEC", "GTEN", "GTERA", "GTES", "GTIM", "GTLB", "GTM", "GTN",
  "GTN-A", "GTX", "GTY", "GUAC", "GUG", "GURE", "GUT", "GUT-P-C", "GUTS", "GVA", "GVH", "GWAV", "GWH", "GWRE", "GWRS", "GWW", "GXAI", "GXO", "GYGY", "GYRE",
  "GYRO", "H", "HACQ", "HAE", "HAFC", "HAFN", "HAIN", "HAL", "HALO", "HAO", "HAPN", "HAS", "HASI", "HAVA", "HAWK", "HAYW", "HBAN", "HBANL", "HBANM", "HBANP",
  "HBANZ", "HBB", "HBCP", "HBIO", "HBM", "HBNB", "HBNC", "HBT", "HCA", "HCAC", "HCAI", "HCAT", "HCC", "HCHL", "HCI", "HCIC", "HCKT", "HCM", "HCMA", "HCSG",
  "HCTI", "HCWB", "HCWC", "HD", "HDB", "HDL", "HDRN", "HDSN", "HE", "HEI", "HEI-A", "HELE", "HELP", "HEPS", "HEQ", "HERE", "HERZ", "HESM", "HFBL", "HFFG",
  "HFRO", "HFRO-P-A", "HFRO-P-B", "HFWA", "HG", "HGBL", "HGLB", "HGTY", "HGV", "HHH", "HHS", "HIFS", "HIG", "HIG-P-G", "HIHO", "HII", "HIMS", "HIMX", "HIND", "HIO",
  "HIPO", "HIT", "HITI", "HIVE", "HIW", "HIX", "HKD", "HKIT", "HKPD", "HL", "HL-P-B", "HLF", "HLI", "HLIO", "HLIT", "HLLY", "HLMN", "HLN", "HLNE", "HLP",
  "HLT", "HLX", "HLXC", "HMC", "HMH", "HMN", "HMR", "HMY", "HNGE", "HNI", "HNNA", "HNRG", "HNST", "HNVR", "HODO", "HOFT", "HOG", "HOLO", "HOMB", "HON",
  "HONA", "HOOD", "HOPE", "HOUR", "HOV", "HOVNP", "HOVR", "HOWL", "HP", "HPAI", "HPE", "HPE-P-C", "HPF", "HPI", "HPK", "HPP", "HPP-P-C", "HPQ", "HPS", "HQ",
  "HQH", "HQI", "HQL", "HQY", "HR", "HRB", "HRI", "HRL", "HRMY", "HROW", "HRTG", "HRTX", "HRZN", "HSAI", "HSBC", "HSCS", "HSDT", "HSHP", "HSIC", "HSLV",
  "HST", "HSTM", "HSY", "HTB", "HTCO", "HTCR", "HTD", "HTFL", "HTGC", "HTH", "HTHT", "HTLD", "HTLM", "HTO", "HTOO", "HTT", "HTZ", "HUBB", "HUBC", "HUBG",
  "HUBS", "HUDI", "HUHU", "HUIZ", "HUM", "HUMA", "HUN", "HURA", "HURC", "HURN", "HUT", "HUYA", "HVII", "HVMC", "HVT", "HVT-A", "HWBK", "HWC", "HWH", "HWKN",
  "HWM", "HXHX", "HXL", "HY", "HYFM", "HYFT", "HYI", "HYLN", "HYMC", "HYNE", "HYPD", "HYPR", "HYT", "HZO", "IACO", "IACQ", "IAE", "IAF", "IAG", "IART",
  "IAUX", "IBAC", "IBCP", "IBEX", "IBG", "IBIO", "IBKR", "IBM", "IBN", "IBO", "IBOC", "IBP", "IBRX", "IBTA", "ICCC", "ICCM", "ICE", "ICFI", "ICG", "ICHR",
  "ICL", "ICLR", "ICMB", "ICON", "ICR-P-A", "ICU", "ICUI", "IDA", "IDAC", "IDAI", "IDCC", "IDE", "IDN", "IDR", "IDT", "IDXX", "IDYA", "IE", "IEAG", "IEP",
  "IESC", "IEX", "IFBD", "IFF", "IFN", "IFRX", "IFS", "IGA", "IGAC", "IGC", "IGD", "IGI", "IGIC", "IGR", "IH", "IHD", "IHG", "IHRT", "IHS", "IHT",
  "IIF", "III", "IIIN", "IIIV", "IIM", "IIPR", "IIPR-P-A", "IKT", "ILAG", "ILLR", "ILLU", "ILMN", "ILPT", "IMA", "IMAX", "IMC", "IMCC", "IMCR", "IMDX", "IMKTA",
  "IMMP", "IMMR", "IMMX", "IMNM", "IMNN", "IMO", "IMOS", "IMPP", "IMPPP", "IMRN", "IMRX", "IMSR", "IMTE", "IMTX", "IMUX", "IMVT", "IMXI", "INAB", "INAC", "INBK",
  "INBS", "INBX", "INCR", "INCY", "INDB", "INDI", "INDO", "INDP", "INDV", "INEO", "INFQ", "INFU", "INFY", "ING", "INGM", "INGN", "INGR", "INHD", "INIO", "INKT",
  "INLF", "INLX", "INM", "INMB", "INMD", "INN", "INN-P-E", "INN-P-F", "INNV", "INO", "INOD", "INR", "INSE", "INSG", "INSM", "INSP", "INSW", "INTA", "INTC", "INTG",
  "INTJ", "INTR", "INTS", "INTT", "INTU", "INTZ", "INUV", "INV", "INVA", "INVE", "INVH", "INVX", "INVZ", "IOND", "IONQ", "IONR", "IONS", "IOR", "IOSP", "IOT",
  "IOTR", "IOVA", "IP", "IPAR", "IPCX", "IPDN", "IPEX", "IPFX", "IPGP", "IPHA", "IPI", "IPM", "IPSC", "IPST", "IPVV", "IPW", "IPWR", "IPX", "IQ", "IQI",
  "IQMX", "IQST", "IQV", "IR", "IRAB", "IRD", "IRDM", "IREN", "IRHO", "IRIX", "IRM", "IRMD", "IRON", "IRS", "IRT", "IRTC", "IRWD", "ISBA", "ISD", "ISNR",
  "ISOU", "ISPC", "ISPR", "ISRG", "ISSC", "ISTR", "IT", "ITG", "ITGR", "ITHA", "ITIC", "ITOC", "ITP", "ITRG", "ITRI", "ITRN", "ITT", "ITUB", "ITW", "IVA",
  "IVDA", "IVF", "IVR", "IVR-P-C", "IVT", "IVVD", "IVZ", "IX", "IXHL", "IZEA", "IZM", "J", "JAB", "JACK", "JACS", "JAGU", "JAGX", "JAKK", "JAN", "JANX",
  "JATT", "JAZZ", "JBDI", "JBGS", "JBHT", "JBI", "JBIO", "JBK", "JBL", "JBLU", "JBS", "JBSS", "JBTM", "JCAP", "JCE", "JCI", "JCSE", "JCTC", "JD", "JDZG",
  "JEF", "JELD", "JEM", "JENA", "JF", "JFB", "JFIN", "JFR", "JFU", "JG", "JGH", "JHI", "JHS", "JHX", "JILL", "JJSF", "JKHY", "JKS", "JL", "JLHL",
  "JLL", "JLS", "JMIA", "JMKE", "JMM", "JMSB", "JNJ", "JOB", "JOBY", "JOE", "JOF", "JOUT", "JOYY", "JPC", "JPM", "JPM-P-C", "JPM-P-D", "JPM-P-J", "JPM-P-K", "JPM-P-L",
  "JPM-P-M", "JQC", "JRI", "JRS", "JRSH", "JRVR", "JSPR", "JTAI", "JUNS", "JVA", "JWEL", "JXG", "JXN", "JXN-P-A", "JYD", "JYNT", "JZ", "JZXN", "KAI", "KALA",
  "KALU", "KAPA", "KARD", "KARO", "KAZR", "KB", "KBDC", "KBH", "KBON", "KBR", "KBSX", "KC", "KCHV", "KD", "KDK", "KDP", "KE", "KEEL", "KELYA", "KELYB",
  "KEN", "KEP", "KEQU", "KEX", "KEY", "KEY-P-I", "KEY-P-J", "KEY-P-K", "KEY-P-L", "KEYS", "KEYY", "KF", "KFFB", "KFII", "KFRC", "KFY", "KG", "KGC", "KGEI", "KGS",
  "KHC", "KIDS", "KIDZ", "KIM", "KIM-P-L", "KIM-P-M", "KIM-P-N", "KINS", "KIO", "KITT", "KKR", "KKR-P-D", "KLAC", "KLAR", "KLC", "KLIC", "KLRA", "KLRS", "KLTR", "KLXE",
  "KMB", "KMDA", "KMI", "KMPR", "KMRK", "KMT", "KMTS", "KMX", "KN", "KNDI", "KNF", "KNOP", "KNRX", "KNSA", "KNSL", "KNTK", "KNX", "KO", "KOD", "KODK",
  "KOF", "KOP", "KOPN", "KOS", "KOSS", "KOYN", "KPET", "KPLT", "KPRX", "KPTI", "KR", "KRAQ", "KRC", "KREF", "KREF-P-A", "KRG", "KRKR", "KRMD", "KRMN", "KRNT",
  "KRNY", "KRO", "KROS", "KRP", "KRRO", "KRSP", "KRT", "KRUS", "KRYS", "KSCP", "KSPI", "KSS", "KT", "KTB", "KTCC", "KTF", "KTH", "KTN", "KTOS", "KTTA",
  "KTWO", "KULR", "KURA", "KUST", "KVHI", "KVUE", "KVYO", "KWM", "KWR", "KWY", "KXIN", "KYIV", "KYMR", "KYN", "KYNB", "KYTX", "KZIA", "L", "LAB", "LABT",
  "LAC", "LAD", "LADR", "LAES", "LAFA", "LAKE", "LAMR", "LAND", "LANDO", "LANDP", "LANV", "LAR", "LARK", "LASE", "LASR", "LATA", "LAUR", "LAW", "LAWR", "LAZ",
  "LB", "LBGJ", "LBRDA", "LBRDK", "LBRDP", "LBRT", "LBRX", "LBTYA", "LBTYB", "LBTYK", "LCCC", "LCFY", "LCID", "LCII", "LCLN", "LCNB", "LCTX", "LCUT", "LDI", "LDOS",
  "LDP", "LE", "LEA", "LECO", "LEDS", "LEE", "LEG", "LEGH", "LEGN", "LEGO", "LEN", "LEN-B", "LENZ", "LEO", "LESL", "LEU", "LEVI", "LEXX", "LFAC", "LFCR",
  "LFMD", "LFMDP", "LFS", "LFST", "LFT", "LFT-P-A", "LFTO", "LFUS", "LFVN", "LFWD", "LGCL", "LGCY", "LGHL", "LGI", "LGIH", "LGL", "LGN", "LGND", "LGO", "LGPS",
  "LGVN", "LH", "LHAI", "LHSW", "LHX", "LI", "LICN", "LIDR", "LIEN", "LIF", "LIFE", "LII", "LILA", "LILAK", "LILAP", "LIME", "LIMN", "LIN", "LINC", "LIND",
  "LINE", "LINK", "LION", "LIQT", "LITB", "LITE", "LITS", "LIVE", "LIVN", "LKFN", "LKFT", "LKQ", "LKSP", "LLY", "LLYVA", "LLYVK", "LMAT", "LMB", "LMND", "LMNR",
  "LMRI", "LMT", "LNAI", "LNC", "LNC-P-D", "LND", "LNG", "LNKS", "LNN", "LNSR", "LNT", "LNTH", "LNZA", "LOAN", "LOAR", "LOB", "LOB-P-A", "LOBO", "LOCL", "LOCO",
  "LODE", "LOGI", "LOMA", "LONA", "LOOP", "LOPE", "LOT", "LOVE", "LOW", "LPA", "LPAA", "LPBB", "LPCN", "LPCV", "LPG", "LPL", "LPLA", "LPSN", "LPTH", "LPX",
  "LQDA", "LQDT", "LRCX", "LRE", "LRHC", "LRMR", "LRN", "LSAK", "LSBK", "LSCC", "LSE", "LSF", "LSPD", "LSTA", "LSTR", "LTBR", "LTC", "LTGO", "LTGR", "LTH",
  "LTM", "LTRN", "LTRX", "LU", "LUCD", "LUCK", "LUCY", "LUD", "LULU", "LUMN", "LUNG", "LUNR", "LUV", "LUXE", "LVLU", "LVO", "LVS", "LVWR", "LW", "LWAC",
  "LWAY", "LWLG", "LX", "LXEH", "LXEO", "LXFR", "LXP", "LXP-P-C", "LXRX", "LXU", "LYB", "LYEL", "LYFT", "LYG", "LYTS", "LYV", "LZ", "LZB", "LZM", "LZMH",
  "M", "MA", "MAA", "MAA-P-I", "MAAS", "MAC", "MACI", "MAGH", "MAGN", "MAIA", "MAIN", "MAIR", "MAKO", "MAMA", "MAMK", "MAMO", "MAN", "MANE", "MANH", "MANU",
  "MAR", "MARA", "MAS", "MASK", "MASS", "MAT", "MATH", "MATV", "MATW", "MATX", "MAX", "MAYS", "MAZE", "MB", "MBAI", "MBBC", "MBC", "MBGL", "MBI", "MBIN",
  "MBINL", "MBINM", "MBINN", "MBIO", "MBLY", "MBNKO", "MBOT", "MBRX", "MBUU", "MBVI", "MBWM", "MBX", "MC", "MCAH", "MCB", "MCBS", "MCD", "MCFT", "MCGA", "MCHB",
  "MCHP", "MCHPP", "MCHX", "MCI", "MCK", "MCN", "MCO", "MCRB", "MCRI", "MCRP", "MCS", "MCTA", "MCY", "MD", "MDA", "MDAI", "MDB", "MDBH", "MDCX", "MDGL",
  "MDIA", "MDLN", "MDLZ", "MDRR", "MDT", "MDU", "MDV", "MDV-P-A", "MDWD", "MDXG", "MDXH", "MEC", "MED", "MEDP", "MEDS", "MEGI", "MEGL", "MEI", "MELI", "MENS",
  "MEOH", "MERC", "MESH", "MESO", "MET", "MET-P-A", "MET-P-E", "MET-P-F", "META", "METC", "METCB", "MEVO", "MF", "MFA", "MFA-P-B", "MFA-P-C", "MFC", "MFG", "MFI", "MFIC",
  "MFIN", "MFM", "MFP", "MG", "MGA", "MGEE", "MGF", "MGIH", "MGLD", "MGM", "MGN", "MGNI", "MGNX", "MGPI", "MGRC", "MGRT", "MGRX", "MGTX", "MGX", "MGY",
  "MGYR", "MH", "MHD", "MHF", "MHH", "MHK", "MHO", "MI", "MIAX", "MICC", "MIDD", "MIMI", "MIN", "MIND", "MINE", "MIR", "MIRA", "MIRM", "MIST", "MITK",
  "MITQ", "MITT", "MITT-P-A", "MITT-P-B", "MITT-P-C", "MIY", "MKC", "MKC-V", "MKDW", "MKL", "MKLY", "MKSI", "MKTW", "MKTX", "MKZR", "MLAA", "MLAB", "MLCI", "MLCO", "MLEC",
  "MLGO", "MLI", "MLKN", "MLM", "MLP", "MLR", "MLSS", "MLTX", "MLYS", "MMA", "MMD", "MMED", "MMI", "MMLP", "MMM", "MMS", "MMSI", "MMT", "MMTX", "MMU",
  "MMYT", "MNDO", "MNDR", "MNDY", "MNKD", "MNOV", "MNPR", "MNR", "MNRO", "MNSB", "MNSBP", "MNSO", "MNST", "MNTK", "MNTN", "MNTS", "MNY", "MO", "MOB", "MOBI",
  "MOBX", "MOD", "MODD", "MOG-A", "MOG-B", "MOGU", "MOH", "MOLN", "MOMO", "MORN", "MOS", "MOV", "MOVE", "MP", "MPA", "MPAA", "MPB", "MPC", "MPLT", "MPLX",
  "MPT", "MPTI", "MPU", "MPV", "MPWR", "MQ", "MQY", "MRAM", "MRBK", "MRCY", "MRDN", "MREO", "MRK", "MRKR", "MRLN", "MRM", "MRNA", "MRNO", "MRP", "MRSH",
  "MRT", "MRTN", "MRVI", "MRVL", "MRX", "MS", "MS-P-A", "MS-P-E", "MS-P-F", "MS-P-I", "MS-P-K", "MS-P-L", "MS-P-O", "MS-P-P", "MS-P-Q", "MSA", "MSAI", "MSB", "MSBI", "MSBIP",
  "MSC", "MSCI", "MSD", "MSDL", "MSEX", "MSFT", "MSGE", "MSGM", "MSGS", "MSGY", "MSI", "MSIF", "MSLE", "MSM", "MSN", "MSS", "MSTR", "MT", "MTA", "MTAL",
  "MTB", "MTB-P-H", "MTB-P-J", "MTB-P-K", "MTB-P-L", "MTC", "MTCH", "MTD", "MTDR", "MTEK", "MTEN", "MTEX", "MTG", "MTH", "MTLS", "MTN", "MTNB", "MTNE", "MTR", "MTRN",
  "MTRX", "MTSI", "MTUS", "MTVA", "MTW", "MTX", "MTZ", "MU", "MUA", "MUC", "MUFG", "MUJ", "MUR", "MUSA", "MUX", "MUZE", "MVBF", "MVIS", "MVST", "MWA",
  "MWC", "MWG", "MWH", "MWYN", "MX", "MXC", "MXCT", "MXE", "MXF", "MXL", "MYE", "MYFW", "MYGN", "MYI", "MYN", "MYND", "MYO", "MYPS", "MYRG", "MYSE",
  "MYSZ", "MYX", "MZTI", "MZYX", "NA", "NAAS", "NABL", "NAC", "NAD", "NAGE", "NAII", "NAK", "NAKA", "NAMI", "NAMM", "NAMS", "NAN", "NAT", "NATH", "NATL",
  "NATR", "NAUT", "NAVI", "NAVN", "NAZ", "NB", "NBB", "NBBK", "NBH", "NBHC", "NBIS", "NBIX", "NBN", "NBP", "NBR", "NBRG", "NBTB", "NBTX", "NBXG", "NC",
  "NCA", "NCDL", "NCEL", "NCEW", "NCI", "NCL", "NCLH", "NCMI", "NCNA", "NCNO", "NCO", "NCPL", "NCRA", "NCSM", "NCT", "NCTY", "NCV", "NCV-P-A", "NCZ", "NCZ-P-A",
  "NDAQ", "NDLS", "NDMO", "NDRA", "NDSN", "NE", "NEA", "NECB", "NEE", "NEGG", "NEM", "NEN", "NEO", "NEOG", "NEON", "NEOV", "NEPH", "NERV", "NESR", "NET",
  "NEU", "NEUP", "NEWP", "NEWT", "NEWTP", "NEXA", "NEXM", "NEXN", "NEXR", "NEXT", "NFE", "NFG", "NFGC", "NFJ", "NFLX", "NG", "NGEN", "NGG", "NGL", "NGNE",
  "NGS", "NGVC", "NGVT", "NHC", "NHI", "NHIC", "NHIV", "NHP", "NHPAP", "NHPBP", "NHS", "NHTC", "NI", "NIC", "NICE", "NICM", "NIE", "NIKI", "NIM", "NINE",
  "NIO", "NIPG", "NIQ", "NIU", "NIVF", "NIXX", "NJR", "NKE", "NKLR", "NKSH", "NKTR", "NKTX", "NKX", "NL", "NLOP", "NLY", "NLY-P-F", "NLY-P-G", "NLY-P-I", "NLY-P-J",
  "NMAD", "NMAI", "NMAX", "NMCO", "NMFC", "NMG", "NMI", "NMIH", "NML", "NMM", "NMP", "NMR", "NMRA", "NMRK", "NMS", "NMT", "NMTC", "NMZ", "NN", "NNBR",
  "NNDM", "NNE", "NNI", "NNN", "NNNN", "NNOX", "NNVC", "NNY", "NOA", "NOAH", "NOC", "NODK", "NOEM", "NOG", "NOK", "NOMA", "NOMD", "NOV", "NOVT", "NOW",
  "NP", "NPAC", "NPB", "NPCE", "NPCT", "NPFD", "NPK", "NPKI", "NPO", "NPT", "NPV", "NPWR", "NRC", "NRDS", "NRDY", "NREF", "NREF-P-A", "NRG", "NRGV", "NRIM",
  "NRIX", "NRK", "NRO", "NRP", "NRSN", "NRT", "NRXP", "NRXS", "NSC", "NSIT", "NSLR", "NSP", "NSPR", "NSRX", "NSSC", "NSTS", "NSYS", "NTAP", "NTB", "NTCL",
  "NTCT", "NTES", "NTGR", "NTHI", "NTIC", "NTIP", "NTLA", "NTNX", "NTR", "NTRA", "NTRB", "NTRP", "NTRS", "NTRSO", "NTSK", "NTST", "NTWK", "NTWO", "NTZ", "NU",
  "NUAI", "NUCL", "NUE", "NUS", "NUTR", "NUTX", "NUV", "NUVB", "NUW", "NUWE", "NVA", "NVAX", "NVCR", "NVCT", "NVDA", "NVEC", "NVG", "NVGS", "NVMI", "NVNI",
  "NVNO", "NVO", "NVR", "NVRI", "NVS", "NVST", "NVT", "NVTS", "NVX", "NWAX", "NWBI", "NWE", "NWFL", "NWG", "NWGL", "NWL", "NWN", "NWPX", "NWS", "NWSA",
  "NWTG", "NX", "NXB", "NXDR", "NXDT", "NXDT-P-A", "NXE", "NXG", "NXGL", "NXL", "NXP", "NXPI", "NXPL", "NXRT", "NXST", "NXT", "NXTC", "NXTS", "NXTT", "NXXT",
  "NYAX", "NYC", "NYT", "NYXH", "NZF", "O", "OABI", "OACC", "OBA", "OBAI", "OBDC", "OBE", "OBIO", "OBK", "OBT", "OBX", "OC", "OCAC", "OCC", "OCCI",
  "OCCIM", "OCCIN", "OCFC", "OCG", "OCGN", "OCS", "OCSL", "OCTV", "OCUL", "ODC", "ODD", "ODFL", "ODTX", "ODYS", "OEC", "OESX", "OFAL", "OFG", "OFIX", "OFLX",
  "OFRM", "OFS", "OGC", "OGCP", "OGE", "OGEN", "OGG", "OGI", "OGN", "OGS", "OHAC", "OHI", "OI", "OIA", "OII", "OIM", "OIO", "OIS", "OKE", "OKLO",
  "OKTA", "OKUR", "OKYO", "OLB", "OLED", "OLLI", "OLMA", "OLN", "OLOX", "OLP", "OM", "OMAB", "OMC", "OMCL", "OMDA", "OMER", "OMEX", "OMF", "OMH", "OMSE",
  "ON", "ONB", "ONBPO", "ONBPP", "ONC", "ONCH", "ONCO", "ONCY", "ONDS", "ONEG", "ONEW", "ONFO", "ONIT", "ONL", "ONMD", "ONON", "ONT", "ONTO", "OOMA", "OPAD",
  "OPAL", "OPBK", "OPCH", "OPEN", "OPFI", "OPHC", "OPI", "OPK", "OPLN", "OPP", "OPP-P-A", "OPP-P-B", "OPP-P-C", "OPRA", "OPRT", "OPRX", "OPTH", "OPTT", "OPTU", "OPTX",
  "OPXS", "OPY", "OR", "ORA", "ORBS", "ORC", "ORCL", "ORCL-P-D", "ORGO", "ORI", "ORIC", "ORIO", "ORIQ", "ORKA", "ORKT", "ORLY", "ORMP", "ORN", "ORRF", "OSBC",
  "OSCR", "OSG", "OSIS", "OSK", "OSPN", "OSRH", "OSS", "OST", "OSTX", "OSUR", "OSW", "OTAI", "OTEX", "OTF", "OTGA", "OTIS", "OTLK", "OTLY", "OTTR", "OUST",
  "OUT", "OVBC", "OVID", "OVLY", "OVV", "OWL", "OWLS", "OWLT", "OXBR", "OXLC", "OXLCM", "OXLCN", "OXLCO", "OXM", "OXSQ", "OXY", "OYSE", "OZK", "OZKAP", "P",
  "PAA", "PAAC", "PAAS", "PAC", "PACB", "PACH", "PACK", "PACS", "PAG", "PAGP", "PAGS", "PAHC", "PAI", "PAII", "PAL", "PALI", "PALO", "PAM", "PAMT", "PANL",
  "PANW", "PAPL", "PAR", "PARA", "PARK", "PARR", "PASG", "PASW", "PATH", "PATK", "PAVM", "PAVS", "PAX", "PAXS", "PAY", "PAYC", "PAYO", "PAYP", "PAYS", "PAYX",
  "PB", "PBA", "PBAM", "PBF", "PBFS", "PBH", "PBHC", "PBI", "PBK", "PBLS", "PBM", "PBR", "PBR-A", "PBT", "PBYI", "PC", "PCAP", "PCAR", "PCB", "PCF",
  "PCG", "PCG-P-A", "PCG-P-B", "PCG-P-C", "PCG-P-D", "PCG-P-E", "PCG-P-G", "PCG-P-H", "PCG-P-I", "PCG-P-X", "PCLA", "PCM", "PCN", "PCOR", "PCQ", "PCRX", "PCSA", "PCT", "PCTY", "PCVX",
  "PCYO", "PD", "PDC", "PDCC", "PDD", "PDEX", "PDFS", "PDI", "PDLB", "PDM", "PDO", "PDPA", "PDS", "PDSB", "PDT", "PDX", "PDYN", "PEB", "PEB-P-E", "PEB-P-F",
  "PEB-P-G", "PEB-P-H", "PEBK", "PEBO", "PECE", "PECO", "PED", "PEG", "PEGA", "PEN", "PENG", "PENN", "PEO", "PEP", "PEPG", "PERF", "PERI", "PESI", "PETS", "PETZ",
  "PEW", "PFAI", "PFBC", "PFD", "PFE", "PFG", "PFGC", "PFIS", "PFL", "PFLT", "PFN", "PFO", "PFS", "PFSA", "PFSI", "PFX", "PG", "PGAC", "PGC", "PGEN",
  "PGNY", "PGP", "PGR", "PGY", "PGZ", "PH", "PHAR", "PHAT", "PHG", "PHGE", "PHI", "PHIN", "PHIO", "PHK", "PHM", "PHOE", "PHR", "PHUN", "PHVS", "PHXE-P",
  "PI", "PICS", "PII", "PIII", "PIM", "PINE", "PINE-P-A", "PINS", "PIPR", "PJT", "PK", "PKBK", "PKE", "PKG", "PKOH", "PKX", "PL", "PLAB", "PLAG", "PLAY",
  "PLBC", "PLBL", "PLBY", "PLCE", "PLD", "PLG", "PLGO", "PLMK", "PLMR", "PLNT", "PLOW", "PLPC", "PLRX", "PLRZ", "PLSE", "PLSM", "PLTK", "PLTR", "PLTS", "PLUG",
  "PLUN", "PLUR", "PLUS", "PLUT", "PLX", "PLXS", "PLYX", "PM", "PMA", "PMAX", "PMCB", "PMEC", "PMI", "PML", "PMM", "PMN", "PMO", "PMT", "PMT-P-A", "PMT-P-B",
  "PMT-P-C", "PMTR", "PMTS", "PMVP", "PN", "PNBK", "PNC", "PNFP", "PNFP-P-A", "PNFP-P-B", "PNFP-P-C", "PNI", "PNNT", "PNR", "PNRG", "PNTG", "PNW", "POAS", "POCI", "PODC",
  "PODD", "POET", "POLA", "POLE", "POM", "PONO", "PONY", "POOL", "POR", "POST", "POWI", "POWL", "POWW", "POWWP", "PPBT", "PPC", "PPCB", "PPG", "PPHC", "PPIH",
  "PPL", "PPLI", "PPSI", "PPT", "PPTA", "PR", "PRAA", "PRAX", "PRCH", "PRCT", "PRDO", "PRE", "PRFX", "PRG", "PRGO", "PRGS", "PRHI", "PRI", "PRIF-P-D", "PRIF-P-K",
  "PRIF-P-L", "PRIM", "PRK", "PRKS", "PRLB", "PRLD", "PRM", "PRMB", "PRME", "PROF", "PROK", "PROP", "PROV", "PRPL", "PRPO", "PRQR", "PRSO", "PRSU", "PRT", "PRTA",
  "PRTH", "PRTS", "PRU", "PRVA", "PRZO", "PS", "PSA", "PSA-P-F", "PSA-P-G", "PSA-P-H", "PSA-P-I", "PSA-P-J", "PSA-P-K", "PSA-P-L", "PSA-P-M", "PSA-P-N", "PSA-P-O", "PSA-P-P", "PSA-P-Q", "PSA-P-R",
  "PSA-P-S", "PSA-P-T", "PSA-P-U", "PSBD", "PSEC", "PSEC-P-A", "PSF", "PSFE", "PSHG", "PSIG", "PSIX", "PSKY", "PSMT", "PSN", "PSNL", "PSNY", "PSNYW", "PSO", "PSQH", "PSTL",
  "PSUS", "PSX", "PTA", "PTAC", "PTC", "PTCT", "PTEN", "PTGX", "PTHS", "PTLE", "PTLO", "PTN", "PTON", "PTOR", "PTRN", "PTY", "PUBM", "PUK", "PULM", "PUMP",
  "PURR", "PUSA", "PVH", "PVL", "PVLA", "PW", "PW-P-A", "PWCM", "PWP", "PWR", "PWRL", "PXED", "PXLW", "PXS", "PYPD", "PYPL", "PYT", "PYXS", "PZG", "PZZA",
  "Q", "QADR", "QBTS", "QCLS", "QCOM", "QCRH", "QDEL", "QETA", "QFIN", "QGEN", "QH", "QLEP", "QLYS", "QMCO", "QMLS", "QMMM", "QNC", "QNCX", "QNME", "QNRX",
  "QNST", "QNT", "QNTM", "QQQX", "QRED", "QRHC", "QRVO", "QS", "QSEA", "QSI", "QSR", "QTEX", "QTI", "QTRX", "QTTB", "QTWO", "QUAD", "QUBT", "QUCY", "QUIK",
  "QUMS", "QURE", "QVC", "QXL", "QXO", "QXO-P-B", "R", "RA", "RAC", "RACC", "RACD", "RACE", "RADX", "RAIL", "RAIN", "RAL", "RAMP", "RAND", "RANG", "RANI",
  "RAPP", "RARE", "RAVE", "RAY", "RAYA", "RBA", "RBB", "RBBN", "RBC", "RBCAA", "RBKB", "RBLX", "RBNE", "RBRK", "RC", "RC-P-C", "RC-P-E", "RCAT", "RCBC", "RCEL",
  "RCG", "RCI", "RCKT", "RCKY", "RCL", "RCMT", "RCON", "RCS", "RCT", "RCUS", "RDAC", "RDAG", "RDCM", "RDDT", "RDGT", "RDHL", "RDI", "RDIB", "RDN", "RDNT",
  "RDNW", "RDVT", "RDW", "RDWR", "RDY", "RDZN", "REA", "REAL", "REAX", "REBN", "RECT", "REED", "REF", "REFI", "REFR", "REG", "REGCO", "REGCP", "REGN", "REI",
  "REKR", "RELL", "RELX", "RELY", "RENT", "RENX", "REPL", "REPX", "RERE", "RES", "RETO", "REVB", "REX", "REXR", "REXR-P-B", "REXR-P-C", "REYN", "REZI", "RF", "RF-P-C",
  "RF-P-E", "RF-P-F", "RFAI", "RFAM", "RFI", "RFIL", "RFL", "RFM", "RFMZ", "RGA", "RGC", "RGCO", "RGEN", "RGLD", "RGNT", "RGNX", "RGP", "RGR", "RGS", "RGT",
  "RGTI", "RH", "RHI", "RHLD", "RHP", "RIBB", "RICK", "RIG", "RIGL", "RILY", "RILYL", "RILYP", "RIME", "RIO", "RIOT", "RITM", "RITM-P-A", "RITM-P-B", "RITM-P-C", "RITM-P-D",
  "RITM-P-E", "RITM-P-F", "RITR", "RIV", "RIV-P-A", "RIVN", "RJET", "RJF", "RKDA", "RKLB", "RKT", "RKTO", "RL", "RLAY", "RLGT", "RLI", "RLJ", "RLJ-P-A", "RLMD", "RLTY",
  "RLX", "RLYB", "RM", "RMAX", "RMBI", "RMBS", "RMCF", "RMCO", "RMD", "RMI", "RMIX", "RMM", "RMMZ", "RMNI", "RMR", "RMSG", "RMT", "RMTI", "RNA", "RNAC",
  "RNAZ", "RNG", "RNGR", "RNGT", "RNP", "RNR", "RNR-P-F", "RNR-P-G", "RNST", "RNTX", "RNW", "RNXT", "ROAD", "ROC", "ROCK", "ROG", "ROIV", "ROK", "ROKU", "ROL",
  "ROLR", "ROMA", "ROOT", "ROP", "ROST", "RPAY", "RPC", "RPD", "RPGL", "RPID", "RPM", "RPRX", "RPT", "RPT-P-C", "RQI", "RR", "RRBI", "RRC", "RREV", "RRGB",
  "RRR", "RRX", "RS", "RSF", "RSG", "RSI", "RSKD", "RSSS", "RSVR", "RTAC", "RTB", "RTO", "RTX", "RUBI", "RUM", "RUN", "RUSHA", "RUSHB", "RVI", "RVLV",
  "RVMD", "RVP", "RVSB", "RVSN", "RVT", "RVTY", "RWAY", "RWT", "RWT-P-A", "RXO", "RXRX", "RXST", "RXT", "RY", "RYAAY", "RYAM", "RYAN", "RYDE", "RYET", "RYM",
  "RYN", "RYOJ", "RYTM", "RYZ", "RZLT", "RZLV", "S", "SA", "SAAQ", "SABA", "SABR", "SABS", "SAC", "SACH", "SACH-P-A", "SAFE", "SAFT", "SAFX", "SAGT", "SAGU",
  "SAH", "SAIA", "SAIC", "SAIH", "SAIL", "SAM", "SAMG", "SAN", "SANA", "SANG", "SANM", "SAP", "SAR", "SARO", "SATA", "SATL", "SB", "SB-P-C", "SB-P-D", "SBAC",
  "SBC", "SBCF", "SBET", "SBEV", "SBFG", "SBFM", "SBGI", "SBH", "SBI", "SBLK", "SBMT", "SBR", "SBRA", "SBS", "SBSI", "SBSW", "SBUX", "SBXD", "SBXE", "SCAG",
  "SCCO", "SCD", "SCE-P-G", "SCE-P-L", "SCE-P-M", "SCE-P-N", "SCHL", "SCHW", "SCHW-P-D", "SCHW-P-J", "SCI", "SCII", "SCKT", "SCL", "SCLX", "SCM", "SCNI", "SCNX", "SCOR", "SCPQ",
  "SCSC", "SCTX", "SCWO", "SCYX", "SCZM", "SD", "SDA", "SDEV", "SDGR", "SDHC", "SDHI", "SDHY", "SDOT", "SDRL", "SDST", "SE", "SEAT", "SEB", "SECZ", "SEDG",
  "SEED", "SEER", "SEG", "SEGG", "SEI", "SEIC", "SELF", "SENEA", "SENEB", "SENS", "SEPN", "SER", "SERA", "SERV", "SES", "SEV", "SEVN", "SEZL", "SF", "SF-P-B",
  "SF-P-C", "SF-P-D", "SFBC", "SFBS", "SFD", "SFHG", "SFIX", "SFL", "SFM", "SFNC", "SFST", "SFWL", "SG", "SGA", "SGC", "SGHC", "SGHT", "SGI", "SGLY", "SGML",
  "SGMT", "SGP", "SGRY", "SGU", "SHAK", "SHAZ", "SHBI", "SHC", "SHEL", "SHEN", "SHFS", "SHG", "SHIM", "SHIP", "SHLS", "SHMD", "SHO", "SHO-P-H", "SHO-P-I", "SHOE",
  "SHOO", "SHOP", "SHOT", "SHPH", "SHW", "SI", "SIBN", "SID", "SIDU", "SIEB", "SIF", "SIFY", "SIG", "SIGA", "SIGI", "SIGIP", "SII", "SILC", "SILO", "SIM",
  "SIMA", "SIMO", "SIND", "SINT", "SION", "SIRI", "SITC", "SITE", "SITM", "SJ", "SJM", "SJT", "SKE", "SKHY", "SKIL", "SKIN", "SKK", "SKM", "SKT", "SKWD",
  "SKY", "SKYA", "SKYE", "SKYH", "SKYQ", "SKYW", "SKYX", "SLAB", "SLB", "SLBT", "SLDB", "SLDE", "SLDP", "SLE", "SLF", "SLG", "SLG-P-I", "SLGB", "SLGL", "SLGN",
  "SLI", "SLM", "SLMBP", "SLMT", "SLN", "SLND", "SLNG", "SLNH", "SLNHP", "SLP", "SLQT", "SLRC", "SLS", "SLSN", "SLSR", "SLVM", "SLXN", "SM", "SMA", "SMBC",
  "SMBK", "SMC", "SMCI", "SMCIP", "SMFG", "SMG", "SMHI", "SMID", "SMJF", "SMMT", "SMP", "SMPL", "SMR", "SMRT", "SMSI", "SMTC", "SMTI", "SMTK", "SMWB", "SMX",
  "SMXT", "SN", "SNA", "SNAL", "SNAP", "SND", "SNDA", "SNDK", "SNDL", "SNDR", "SNDX", "SNES", "SNEX", "SNFCA", "SNGX", "SNN", "SNOA", "SNOW", "SNPS", "SNT",
  "SNTG", "SNTI", "SNWV", "SNX", "SNY", "SNYR", "SO", "SOAR", "SOBO", "SOBR", "SOC", "SOCA", "SOFI", "SOGP", "SOHU", "SOLS", "SOLV", "SON", "SONM", "SONO",
  "SONY", "SOPH", "SOR", "SORA", "SORN", "SOS", "SOTK", "SOUL", "SOUN", "SOWG", "SPAI", "SPB", "SPCB", "SPCE", "SPCX", "SPE", "SPE-P-C", "SPEG", "SPFI", "SPG",
  "SPG-P-J", "SPGI", "SPH", "SPHL", "SPHR", "SPIR", "SPKL", "SPMA", "SPMC", "SPME", "SPNT", "SPOK", "SPOT", "SPPL", "SPRB", "SPRC", "SPRO", "SPRU", "SPRY", "SPSC",
  "SPT", "SPTX", "SPWH", "SPWR", "SPXC", "SPXX", "SQFT", "SQFTP", "SQM", "SQNS", "SR", "SRAD", "SRBK", "SRCE", "SRE", "SRFM", "SRG", "SRG-P-A", "SRI", "SRL",
  "SRPT", "SRRK", "SRTA", "SRTS", "SRV", "SRXH", "SRZN", "SSAC", "SSB", "SSBI", "SSD", "SSEA", "SSII", "SSL", "SSM", "SSMR", "SSNC", "SSP", "SSRM", "SST",
  "SSTI", "SSTK", "SSYS", "ST", "STAA", "STAG", "STAK", "STBA", "STC", "STDN", "STE", "STEM", "STEP", "STEW", "STEX", "STFS", "STG", "STGW", "STHO", "STI",
  "STIM", "STK", "STKE", "STKH", "STKS", "STLA", "STLD", "STLN", "STM", "STN", "STNE", "STNG", "STOK", "STRA", "STRC", "STRD", "STRF", "STRK", "STRL", "STRO",
  "STRR", "STRRP", "STRS", "STRT", "STRW", "STRZ", "STT", "STT-P-G", "STTK", "STUB", "STVN", "STWD", "STX", "STXS", "STZ", "SU", "SUGP", "SUI", "SUIG", "SUJA",
  "SUMA", "SUN", "SUNB", "SUNC", "SUNE", "SUNS", "SUPN", "SUPV", "SUPX", "SURG", "SUZ", "SVA", "SVAQ", "SVC", "SVCC", "SVCO", "SVIV", "SVM", "SVRA", "SVRE",
  "SVRN", "SVV", "SW", "SWAG", "SWBI", "SWIM", "SWK", "SWKS", "SWMR", "SWVL", "SWX", "SWZ", "SXC", "SXI", "SXT", "SXTC", "SXTP", "SY", "SYBT", "SYF",
  "SYF-P-A", "SYF-P-B", "SYK", "SYM", "SYNA", "SYNX", "SYPR", "SYRE", "SYY", "SZZL", "T", "T-P-A", "T-P-C", "TAC", "TACH", "TACO", "TACT", "TAK", "TAL", "TALK",
  "TALO", "TANH", "TAOP", "TAOX", "TAP", "TAP-A", "TARA", "TARS", "TASK", "TATT", "TAVI", "TAYD", "TBBB", "TBBK", "TBCH", "TBI", "TBLA", "TBLD", "TBN", "TBPH",
  "TC", "TCBI", "TCBIO", "TCBK", "TCBS", "TCBX", "TCGX", "TCI", "TCMD", "TCOM", "TCPC", "TCRT", "TCRX", "TCX", "TD", "TDAC", "TDAY", "TDC", "TDF", "TDG",
  "TDIC", "TDOC", "TDS", "TDS-P-U", "TDS-P-V", "TDTH", "TDUP", "TDW", "TDWD", "TDY", "TE", "TEAD", "TEAM", "TECH", "TECK", "TECX", "TEI", "TEL", "TELA", "TELO",
  "TEM", "TEN", "TEN-P-E", "TEN-P-F", "TENB", "TENX", "TEO", "TER", "TEVA", "TEX", "TFC", "TFC-P-I", "TFC-P-O", "TFC-P-R", "TFII", "TFIN", "TFIN-P", "TFPM", "TFSL", "TFX",
  "TG", "TGB", "TGE", "TGEN", "TGHL", "TGL", "TGLS", "TGS", "TGT", "TGTX", "TH", "THC", "THCH", "THFF", "THG", "THH", "THM", "THO", "THQ", "THRM",
  "THRY", "THW", "TIC", "TIGO", "TIGR", "TII", "TIL", "TILE", "TIMB", "TIPT", "TISI", "TITN", "TJGC", "TJX", "TK", "TKC", "TKLF", "TKNO", "TKO", "TKR",
  "TLF", "TLIH", "TLK", "TLN", "TLNC", "TLPH", "TLRY", "TLS", "TLSA", "TLSI", "TLX", "TLYS", "TM", "TMC", "TMCI", "TMCR", "TMDE", "TMDX", "TME", "TMO",
  "TMP", "TMQ", "TMS", "TMTS", "TMUS", "TNC", "TNDM", "TNET", "TNGX", "TNK", "TNL", "TNMG", "TNON", "TNXP", "TNYA", "TOL", "TOMZ", "TONT", "TONX", "TOON",
  "TOP", "TOPP", "TOPS", "TORO", "TOST", "TOUR", "TOVX", "TOWN", "TOYO", "TP", "TPB", "TPC", "TPCS", "TPET", "TPG", "TPL", "TPR", "TPST", "TPVG", "TR",
  "TRAD", "TRAK", "TRAW", "TRAX", "TRC", "TRDA", "TREE", "TREX", "TRGP", "TRGS", "TRI", "TRIB", "TRIN", "TRIP", "TRLV", "TRMB", "TRMD", "TRMK", "TRN", "TRNO",
  "TRNR", "TRNS", "TRON", "TROO", "TROW", "TROX", "TRP", "TRS", "TRSG", "TRST", "TRT", "TRTN-P-A", "TRTN-P-B", "TRTN-P-C", "TRTN-P-D", "TRTN-P-E", "TRTN-P-F", "TRTN-P-G", "TRTX", "TRTX-P-C",
  "TRU", "TRUG", "TRUP", "TRV", "TRVG", "TRVI", "TRX", "TS", "TSAT", "TSBK", "TSCO", "TSEM", "TSHA", "TSI", "TSLA", "TSLX", "TSM", "TSN", "TSQ", "TSSI",
  "TT", "TTAM", "TTAN", "TTC", "TTD", "TTE", "TTEC", "TTEK", "TTGT", "TTI", "TTMI", "TTRX", "TTWO", "TU", "TULP", "TURB", "TUSK", "TUYA", "TV", "TVA",
  "TVAI", "TVC", "TVE", "TVGN", "TVIV", "TVRD", "TVTX", "TW", "TWAV", "TWFG", "TWG", "TWI", "TWIN", "TWLO", "TWLV", "TWN", "TWO", "TWO-P-A", "TWO-P-B", "TWO-P-C",
  "TWST", "TX", "TXG", "TXMD", "TXN", "TXNM", "TXO", "TXRH", "TXT", "TY", "TY-P", "TYG", "TYGO", "TYL", "TYRA", "TZOO", "U", "UA", "UAA", "UAC",
  "UAL", "UAMY", "UAN", "UAVS", "UBCP", "UBER", "UBS", "UBSI", "UCAR", "UCB", "UCFI", "UCL", "UCTT", "UDR", "UE", "UEC", "UEIC", "UFCS", "UFG", "UFI",
  "UFPI", "UFPT", "UG", "UGI", "UGP", "UHAL", "UHAL-B", "UHS", "UHT", "UI", "UIS", "UK", "UL", "ULBI", "ULCC", "ULH", "ULS", "ULTA", "UMAC", "UMBF",
  "UMBFO", "UMC", "UMH", "UMH-P-D", "UNB", "UNCY", "UNF", "UNFI", "UNH", "UNIT", "UNM", "UNP", "UNTY", "UONE", "UONEK", "UP", "UPB", "UPBD", "UPC", "UPLD",
  "UPS", "UPST", "UPWK", "UPXI", "URBN", "URG", "URGN", "URI", "UROY", "USA", "USAC", "USAR", "USAS", "USAU", "USB", "USB-P-A", "USB-P-H", "USB-P-P", "USB-P-Q", "USB-P-R",
  "USB-P-S", "USBC", "USCB", "USDE", "USEA", "USFD", "USGO", "USIO", "USLM", "USNA", "USPH", "UTF", "UTG", "UTHR", "UTI", "UTL", "UTMD", "UTSI", "UTZ", "UUU",
  "UUUU", "UVE", "UVSP", "UVV", "UWMC", "UXIN", "UYSC", "UZX", "V", "VABK", "VAC", "VACI", "VAL", "VALE", "VALN", "VALU", "VANI", "VATE", "VBF", "VBIO",
  "VBNK", "VC", "VCEL", "VCIG", "VCRE", "VCTR", "VCV", "VCX", "VCYT", "VECA", "VECO", "VEEA", "VEEE", "VEEV", "VEL", "VELO", "VENU", "VEON", "VERA", "VERI",
  "VERU", "VERX", "VET", "VFC", "VFF", "VFS", "VG", "VGAS", "VGI", "VGM", "VGNT", "VGZ", "VHC", "VHCP", "VHI", "VHUB", "VIA", "VIAV", "VICI", "VICR",
  "VIDA", "VII", "VIK", "VINP", "VIOT", "VIP", "VIPS", "VIR", "VIRC", "VIRT", "VISN", "VIST", "VITL", "VIV", "VIVK", "VIVO", "VIVS", "VKI", "VKQ", "VKTX",
  "VLGEA", "VLN", "VLO", "VLOS", "VLRS", "VLT", "VLTO", "VLY", "VLYPN", "VLYPO", "VLYPP", "VMAR", "VMC", "VMD", "VMET", "VMI", "VMO", "VNCE", "VNDA", "VNET",
  "VNME", "VNO", "VNO-P-L", "VNO-P-M", "VNO-P-N", "VNO-P-O", "VNOM", "VNRX", "VNT", "VNTG", "VOC", "VOD", "VOR", "VOXR", "VOYA", "VOYA-P-B", "VOYG", "VPG", "VPV", "VRA",
  "VRAX", "VRCA", "VRDN", "VREX", "VRM", "VRME", "VRNS", "VRRM", "VRSK", "VRSN", "VRT", "VRTS", "VRTX", "VRXA", "VS", "VSA", "VSAT", "VSEC", "VSH", "VSME",
  "VSNT", "VST", "VSTM", "VSTS", "VSXY", "VTAK", "VTEX", "VTGN", "VTIX", "VTMX", "VTN", "VTOL", "VTR", "VTRS", "VTS", "VTSI", "VTVT", "VUZI", "VVOS", "VVR",
  "VVV", "VVX", "VWAV", "VYGR", "VYX", "VZ", "VZLA", "W", "WAB", "WABC", "WAFD", "WAFDP", "WAFU", "WAL", "WAL-P-A", "WALD", "WASH", "WAT", "WATT", "WAVE",
  "WAY", "WB", "WBD", "WBI", "WBS", "WBS-P-F", "WBS-P-G", "WBTN", "WBUY", "WBX", "WCC", "WCN", "WCT", "WD", "WDAY", "WDC", "WDFC", "WDH", "WDI", "WDS",
  "WEA", "WEAV", "WEC", "WELL", "WEN", "WENC", "WENN", "WERN", "WES", "WEST", "WETH", "WETO", "WEX", "WEYS", "WF", "WFC", "WFC-P-A", "WFC-P-C", "WFC-P-D", "WFC-P-L",
  "WFC-P-Y", "WFC-P-Z", "WFCF", "WFF", "WFG", "WFRD", "WGO", "WGS", "WH", "WHD", "WHF", "WHG", "WHK", "WHLR", "WHLRD", "WHLRP", "WHR", "WHR-P-A", "WHWK", "WIA",
  "WILC", "WIMI", "WINA", "WING", "WIT", "WIW", "WIX", "WK", "WKC", "WKEY", "WKHS", "WKSP", "WLDN", "WLDS", "WLFC", "WLII", "WLK", "WLKP", "WLTH", "WLY",
  "WLYB", "WM", "WMB", "WMG", "WMK", "WMS", "WMT", "WNC", "WNEB", "WNW", "WOK", "WOLF", "WOOF", "WOR", "WPAC", "WPC", "WPM", "WPP", "WPRT", "WRAP",
  "WRB", "WRBY", "WRD", "WRLD", "WRN", "WS", "WSBC", "WSBCO", "WSBF", "WSBK", "WSC", "WSE", "WSFS", "WSHP", "WSM", "WSO", "WSO-B", "WST", "WSTN", "WT",
  "WTBA", "WTF", "WTFC", "WTFCN", "WTG", "WTI", "WTM", "WTRG", "WTS", "WTTR", "WTW", "WU", "WULF", "WVE", "WVVI", "WVVIP", "WW", "WWD", "WWR", "WWW",
  "WXM", "WY", "WYFI", "WYHG", "WYNN", "WYY", "XAIR", "XBIO", "XBIT", "XBP", "XCBE", "XCH", "XCUR", "XE", "XEL", "XELB", "XENE", "XERS", "XFLH", "XFLT",
  "XFOR", "XGN", "XHG", "XHLD", "XHR", "XIFR", "XLO", "XMAX", "XMTR", "XNCR", "XNDU", "XNET", "XOM", "XOS", "XP", "XPEL", "XPER", "XPEV", "XPL", "XPO",
  "XPOF", "XPON", "XPRO", "XRAY", "XRN", "XRN-P-A", "XRN-P-B", "XRPN", "XRTX", "XRX", "XSLL", "XTIA", "XTLB", "XTNT", "XWEL", "XXI", "XXII", "XYF", "XYL", "XYZ",
  "XZO", "YAAS", "YALA", "YARW", "YB", "YCBD", "YCY", "YDDL", "YDES", "YDKG", "YELP", "YETI", "YEXT", "YHC", "YHGJ", "YHNA", "YI", "YIBO", "YICC", "YJ",
  "YMAT", "YMM", "YMT", "YORW", "YOU", "YOUL", "YPF", "YQ", "YRD", "YSG", "YSS", "YSWY", "YSXT", "YTRA", "YUM", "YUMC", "YXT", "YYAI", "YYGH", "Z",
  "ZBAO", "ZBH", "ZBIO", "ZBRA", "ZCMD", "ZD", "ZDAI", "ZDGE", "ZENA", "ZEO", "ZEPP", "ZETA", "ZG", "ZGN", "ZH", "ZIM", "ZION", "ZIONP", "ZIP", "ZJK",
  "ZJYL", "ZKH", "ZKIN", "ZKP", "ZLAB", "ZM", "ZNB", "ZNTL", "ZONE", "ZOOZ", "ZS", "ZSQR", "ZSTK", "ZTEK", "ZTG", "ZTO", "ZTR", "ZTS", "ZUMZ", "ZURA",
  "ZVIA", "ZVRA", "ZWS", "ZYBT", "ZYME",
]);

export const US_KO_TO_TICKER: Record<string, string> = {
  "1-800플라워스닷컴": "FLWS",
  "10X제노믹스": "TXG",
  "111ADR": "YI",
  "17에듀케이션앤테크놀로지ADR": "YQ",
  "1RT애퀴지션": "ONCH",
  "20/20바이오랩스": "AIDX",
  "22세기그룹": "XXII",
  "36KR홀딩스ADR": "KRKR",
  "374워터": "SCWO",
  "3E네트워크테크놀로지그룹": "MASK",
  "4D몰레큘러테라퓨틱스": "FDMT",
  "51토크온라인에듀케이션그룹ADR": "COE",
  "5E어드밴스드머터리얼즈": "FEAM",
  "60디그리스파마슈티컬스": "SXTP",
  "707케이맨홀딩스": "JEM",
  "8i애퀴지션2": "EUDA",
  "8x8": "EGHT",
  "908디바이시스": "MASS",
  "9FADR": "JFU",
  "A10네트웍스": "ATEN",
  "A2Z커스투메이트솔루션스": "AZ",
  "AA미션애퀴지션II": "YCY",
  "ABM인더스트리즈": "ABM",
  "ABVC바이오파마": "ABVC",
  "ACI월드와이드": "ACIW",
  "ACM리서치": "ACMR",
  "ACP홀딩스애퀴지션": "ACGC",
  "ACV옥션스": "ACVA",
  "AC이뮨": "ACIU",
  "ADC테라퓨틱스": "ADCT",
  "ADI글로벌디스트리뷰션": "ADIG",
  "ADMA바이오로직스": "ADMA",
  "AEA-브릿지스임팩트": "LVWR",
  "AGI": "AGI",
  "AGM그룹홀딩스": "AGMH",
  "AGNC인베스트먼트": "AGNC",
  "AGNC인베스트먼트우선주SeriesH8.75%": "AGNCZ",
  "AGNC인베스트먼트우선주시리즈C": "AGNCN",
  "AGNC인베스트먼트우선주시리즈D": "AGNCM",
  "AGNC인베스트먼트우선주시리즈E": "AGNCO",
  "AGNC인베스트먼트우선주시리즈F": "AGNCP",
  "AGNC인베스트먼트우선주시리즈G": "AGNCL",
  "AH리얼티트러스트": "AHRT",
  "AIAI홀딩스": "AIAI",
  "AIB데이터센터스": "AIB",
  "AIM이뮤노테크": "AIM",
  "AIOS테크": "AIOS",
  "AIRO그룹홀딩스": "AIRO",
  "AIx크립토홀딩스": "AIXC",
  "AI인프라스트럭처애퀴지션": "AIIA",
  "AI파이낸셜": "AIFC",
  "AKA브랜즈홀딩": "AKA",
  "ALX온콜로지홀딩스": "ALXO",
  "AMC글로벌미디어": "AMCX",
  "AMC로보틱스": "AMCI",
  "AMC엔터테인먼트홀딩스": "AMC",
  "AMD(어드밴스드마이크로디바이시스)": "AMD",
  "AMN헬스케어서비스": "AMN",
  "AMTD디지털": "HKD",
  "AMTD아이디어그룹ADR": "AMTD",
  "AN2테라퓨틱스": "ANTX",
  "ANI파마슈티컬스": "ANIP",
  "AO스미스": "AOS",
  "APEX테크애퀴지션": "TRAD",
  "APi그룹": "APG",
  "ARBIOT그룹": "ARBB",
  "ARC그룹애퀴지션I": "ARCL",
  "ARS파마슈티컬스": "SPRY",
  "ARXIS": "ARXS",
  "ASE테크놀로지홀딩ADR": "ASX",
  "ASML홀딩ADR": "ASML",
  "ASP아이소토프": "ASPI",
  "AST스페이스모바일": "ASTS",
  "ATA크리에이티비티글로벌ADR": "AACG",
  "ATIF홀딩스": "AUC",
  "ATN인터내셔널": "ATNI",
  "AT리뉴ADR": "RERE",
  "AVAX원테크놀로지": "AVX",
  "Aar": "AIR",
  "AberdeenGovernmentMarkets": "MGF",
  "AberdeenIndiaFund": "IFN",
  "AberdeenIntermediate": "MIN",
  "AberdeenMulti-Market": "MMT",
  "AberdeenMunicipal": "MFM",
  "Acnb": "ACNB",
  "AdamsDiversifiedEquityFund，Inc.": "ADX",
  "AdamsNaturalResourcesFund，Inc.": "PEO",
  "Adt": "ADT",
  "AdventConvertibleandIncomeFund": "AVK",
  "Aes": "AES",
  "Aevex": "AVEX",
  "Agi": "AGBK",
  "Agnt": "AGNT",
  "AiRWA": "YYAI",
  "Aifu": "AIFU",
  "AllianceBernsteinHolding,L.P.": "AB",
  "AllianceNationalMunicipal": "AFB",
  "AllianceResourcePartnersUnits": "ARLP",
  "AlliancebersteinGlobalHigh": "AWF",
  "Allspring": "EAD",
  "AllspringGlobalDividendOpportunityFund": "EOD",
  "AllspringMulti-SectorIncomeFund": "ERC",
  "AllspringUtilitiesAndHighIncomeMutualFund": "ERH",
  "AngelOakFinancialStrategiesIncomeTermTrust": "FINS",
  "AnglogoldAshantiPLC": "ANG-P-D",
  "Apa": "APA",
  "ApnimedInc": "APMD",
  "AresDynamicCreditAllocationFundInc": "ARDC",
  "AsaGoldAndPreciousMetals": "ASA",
  "AscendisPharmaA/SOrdinaryShare": "ASND",
  "At&T": "T",
  "AtheneHoldingDSRepresenting11000PrefShsSeriesA": "ATH-P-A",
  "Ati": "ATI",
  "Ats": "ATS",
  "Axt": "AXTI",
  "Azz": "AZZ",
  "A패러다이스애퀴지션": "ENHA",
  "B.O.S.베터온라인솔루션스": "BOSC",
  "B2골드": "BTG",
  "BBB푸드": "TBBB",
  "BCB뱅코프": "BCBP",
  "BCP인베스트먼트": "BCIC",
  "BERKSHIREHATHAWAYClassB": "BRK-B",
  "BFC캐피탈트러스트II우선주7.2%": "BANFP",
  "BGM그룹": "BGM",
  "BHP그룹ADR": "BHP",
  "BJ's홀세일클럽홀딩스": "BJ",
  "BK테크놀로지스": "BKTI",
  "BNYMellonHighYieldStrategiesFund": "DHF",
  "BNYMellonMunicipalBondInfrastructureFundIn": "DMB",
  "BNYMellonStrategicMunicipalBondFundInc": "DSM",
  "BNYMellonStrategicMunicipalsInc": "LEO",
  "BOK파이낸셜": "BOKF",
  "BPp.l.c.": "BP",
  "BRBIBR파트너스ADR": "BRBI",
  "BRC": "BRC",
  "BRC그룹홀딩스": "RILY",
  "BRC그룹홀딩스우선주시리즈A6.875%": "RILYP",
  "BRC그룹홀딩스우선주시리즈B7.375%": "RILYL",
  "BRT아파트먼트": "BRT",
  "BTC디벨롭먼트": "BDCI",
  "BTC디지털": "BTCT",
  "BTQ테크놀로지스": "BTQ",
  "BT브랜즈": "BTBD",
  "BUUU그룹": "BUUU",
  "BWX테크놀로지스": "BWXT",
  "BancoBradescoADSRepresenting1OrdShs": "BBDO",
  "BancroftClosedFund": "BCV",
  "BankOZKSeriesAPreferredStock": "OZKAP",
  "BanzaiInternational": "PARA",
  "BaringsCorporateInvestors": "MCI",
  "BaringsGlobalShortDurationHighYieldFund": "BGH",
  "BaringsParticipationInvestors": "MPV",
  "Bce": "BCE",
  "BerkshireHathawayInc.": "BRK-A",
  "Bgc그룹": "BGC",
  "Bgsf": "BGSF",
  "BiglariHoldingsInc.ClassACommonStock": "BH-A",
  "Bio-RadLaboratories,Inc.ClassB": "BIO-B",
  "BioStemTechnologiesInc.": "BSEM",
  "BitVenturesLtd": "BVC",
  "Bkv": "BKV",
  "BlackRock2037MunicipalTargetTermTrust": "BMN",
  "BlackRockCapitalAllocationTermClosedEndFund": "BCAT",
  "BlackRockCreditAllocationIncomeTrust": "BTZ",
  "BlackRockESGCapitalAllocationTermClosedEndFund": "ECAT",
  "BlackRockEnhancedEquityDividendTrust": "BDJ",
  "BlackRockEnhancedGlobalDividendClosedEndFund": "BOE",
  "BlackRockEnhancedInternationalDividendClosedEndFund": "BGY",
  "BlackRockEnhancedLargeCapCoreFund": "CII",
  "BlackRockFloatingRateIncomeClosedFund": "BGT",
  "BlackRockHealthSciencesTermClosedEndFund": "BMEZ",
  "BlackRockIncomeTrust，Inc.": "BKT",
  "BlackRockMunicipal2030TargetTermTrust": "BTT",
  "BlackRockScienceandTechnologyTermClosedEndFund": "BSTZ",
  "BlackRockScienceandTechnologyTrust": "BST",
  "BlackRockTaxableMunicipalBondTrust": "BBN",
  "BlackRockTechnologyandPrivateEquityTermTrust": "BTX",
  "BlackRockUtilitiesInfrastructure&PowerOppty": "BUI",
  "BlackRockVirginiaMuniBondTrust": "BHV",
  "BlackStoneMinerals,L.P.": "BSM",
  "Blackrock": "BLW",
  "BlackrockCoreBdTr": "BHK",
  "BlackrockDebtStrategiesFund": "DSU",
  "BlackrockEnergyandResourcesTrust": "BGR",
  "BlackrockFloatingRate": "FRA",
  "BlackrockHealthSciencesTrust": "BME",
  "BlackrockMulti-Sector": "BIT",
  "BlackrockMuniAssetsFund": "MUA",
  "BlackrockMuniYieldQualityFund": "MQY",
  "BlackrockMuniholdingsCaliforniaQualityFund": "MUC",
  "BlackrockMuniholdingsFund": "MHD",
  "BlackrockMuniholdingsNewJerseyQualityFund": "MUJ",
  "BlackrockMuniyieldMichiganQualityFund": "MIY",
  "BlackrockMuniyieldNewYorkQualityFund": "MYN",
  "BlackrockMuniyieldPennsylvaniaQualityFund": "MPA",
  "BlackrockMuniyieldQualityFundIii": "MYI",
  "BlackrockResourcescommoditiesStrategyTrust": "BCX",
  "BlackstoneLong-ShortCredit": "BGX",
  "BlackstoneSeniorFloatingRate2027TermFund": "BSL",
  "BlackstoneStrategicCredit2027TermFund": "BGB",
  "BlossomHillTherapeuticsInc": "BLSM",
  "BluerockPrivateRealEstateFund": "BPRE",
  "BoqiiHoldingLtd": "BQ",
  "BrandywineGLOBALGlobal": "BWG",
  "Brc": "BRCC",
  "BrookfieldInfrastructurePartnersL.P.": "BIP",
  "BrookfieldInfrastructurePartnersL.P.5.000%ClassAPreferred": "BIP-P-B",
  "BrookfieldInfrastructurePartnersL.P.5.125%ClassAPreferred": "BIP-P-A",
  "BrookfieldRealAssetsIncomeClosedFund": "RA",
  "BrookfieldRenewablePartnersL.P.": "BEP",
  "BrookfieldRenewablePartnersL.P.5.25%ClassAPreferred": "BEP-P-A",
  "Brown-FormanCorporationClassA": "BF-A",
  "Brown-FormanCorporationClassB": "BF-B",
  "Brp": "DOO",
  "Btcs": "BTCS",
  "Bv파이낸셜": "BVFL",
  "BwLpg": "BWLP",
  "Bxp": "BXP",
  "C&F파이낸셜": "CFFI",
  "C1펀드": "CFND",
  "C3AI": "AI",
  "C3is": "CISS",
  "C4테라퓨틱스": "CCCC",
  "CACI인터내셔널": "CACI",
  "CAE": "CAE",
  "CBAK에너지테크놀러지": "CBAT",
  "CBIZ": "CBZ",
  "CBL&어소시에이츠프로퍼티스": "CBL",
  "CBL인터내셔널": "BANL",
  "CBREGlobalRealEstateIncomeFund": "IGR",
  "CBRE그룹": "CBRE",
  "CB파이낸셜서비스": "CBFV",
  "CCC인텔리전트": "CCC",
  "CCH홀딩스": "CCHH",
  "CCSC테크놀로지인터내셔널홀딩스": "CCTG",
  "CDT에퀴티": "CDT",
  "CDT인바이어런먼털테크놀로지인베스트먼트홀딩스": "CDTG",
  "CEA인더스트리스": "BNC",
  "CECO인바이런먼털": "CECO",
  "CF뱅크셰어스": "CFBK",
  "CF인더스트리스홀딩스": "CF",
  "CG온콜로지": "CGON",
  "CH4내추럴솔루션스": "MTNE",
  "CHS우선주8%": "CHSCP",
  "CHS우선주클래스B7.875%": "CHSCO",
  "CHS클래스B우선주시리즈2": "CHSCN",
  "CHS클래스B우선주시리즈3": "CHSCM",
  "CHS클래스B우선주시리즈47.5%": "CHSCL",
  "CH로빈슨월드와이드": "CHRW",
  "CID홀드": "DAIC",
  "CIONInvestment": "CION",
  "CKX랜드": "CKX",
  "CL워크샵그룹ADR": "NWGL",
  "CMB.테크": "CMBT",
  "CME그룹": "CME",
  "CMS에너지": "CMS",
  "CNA파이낸셜": "CNA",
  "CNB파이낸셜": "CCNE",
  "CNB파이낸셜우선주시리즈A7.125%": "CCNEP",
  "CNH인더스트리얼": "CNH",
  "CNO파이낸셜그룹": "CNO",
  "CNS파마슈티컬스": "CNSP",
  "CNX리소스": "CNX",
  "CN에너지그룹": "CNEY",
  "CN파이낸스홀딩스ADR": "CNF",
  "CN헬시푸드테크그룹": "UCFI",
  "CO2에너지트랜지션": "NOEM",
  "COPT디펜스프로퍼티스": "CDP",
  "CPI에어로스트럭처스": "CVU",
  "CPI카드그룹": "PMTS",
  "CPS테크놀러지": "CPSH",
  "CRA인터내셔널": "CRAI",
  "CRHPublic": "CRH",
  "CSLM디지털애셋애퀴지션III": "KOYN",
  "CSW인더스트리얼즈": "CSW",
  "CS디스코": "LAW",
  "CTO리얼티그로스": "CTO",
  "CTWClassA": "CTW",
  "CVB파이낸셜": "CVBF",
  "CVD이큅먼트": "CVV",
  "CVRPartners,LP": "UAN",
  "CVR에너지": "CVI",
  "CVR엑스": "CVRX",
  "CVS헬스": "CVS",
  "CX앱": "CXAI",
  "CalamosConvertibleOpportunitiesandIncomeClosedFund": "CHI",
  "CalamosConvertibleandHighIncomeClosedFund": "CHY",
  "CalamosDynamicConvertible": "CCD",
  "CalamosGlobalDynamicIncomeClosedFund": "CHW",
  "CalamosGlobalTotalReturnClosedFund": "CGO",
  "CalamosLongShortEquityDynamicIncomeTrustClosedFund": "CPZ",
  "CalamosStrategicTotalReturnClosedFund": "CSQ",
  "CallanJMB": "CJMB",
  "Calumet": "CLMT",
  "CarlyleCreditIncomeFund": "CCIF",
  "Cboe글로벌마켓": "CBOE",
  "Cdw": "CDW",
  "CellectisS.A.": "CLLS",
  "CentralSecuritiesClosedFund": "CET",
  "CentralandEasternEuropeFundInc": "CEE",
  "Cgi": "GIB",
  "ChathamLodgingTrustSeriesAPreferred": "CLDT-P-A",
  "CheniereEnergyPartners,LP": "CQP",
  "Ci&T": "CINT",
  "Ciena": "CIEN",
  "CipherDigital": "CIFR",
  "Circle8Group": "CIRC",
  "ClearBridgeEnergyMidstreamOpportunityClosedEndFund": "EMO",
  "CloughGlobalDividendandIncomeFund": "GLV",
  "CloughGlobalEquityClosedFund": "GLQ",
  "CloughGlobalOpportunitiesClosedFund": "GLO",
  "Clps": "CLPS",
  "Cohen&SteersRealEstateOppsandIncomeFund": "RLTY",
  "CohenSteersClosedEndOpportunityFund": "FOF",
  "CohenSteersInfrastructureFund": "UTF",
  "CohenSteersREITandPreferredand": "RNP",
  "CohenSteersTax-AdvantagedPreferredSecuritiesand": "PTA",
  "CohenandSteersTotalReturnRealtyFund": "RFI",
  "Cohensteers": "LDP",
  "CohensteersQuality": "RQI",
  "CohensteersSelectPreferredAnd": "PSF",
  "CollplantBiotechnologiesLtd": "CLGN",
  "ColumbiaSeligmanPremiumTechnologyGrowthFund": "STK",
  "ColumbusCircleCapitalCorpIII": "CCCT",
  "CompXInternational": "CIX",
  "CompanhiaEnergeticaDeMinasGerais-CEMIG": "CIG",
  "CompanhiaParanaensedeEnergia-COPEL": "ELPC",
  "ConnectBiopharmaHoldingsLtd": "CNTB",
  "CornerstoneStrategicInvestmentFund": "CLM",
  "CornerstoneTotalReturnClosedFund": "CRF",
  "Corvex": "MOVE",
  "CrawfordCompanyClassA": "CRD-A",
  "CrawfordCompanyClassB": "CRD-B",
  "Cre8엔터프라이즈": "CRE",
  "CreditSuisseAssetManagementIncomeClosedFund": "CIK",
  "CreditSuisseHighYieldCreditFund": "DHY",
  "CrossAmericaPartnersLPCommonunitsrepresenting": "CAPL",
  "CrossTimbersRoyaltyUnits": "CRT",
  "Csp": "CSPI",
  "Csx": "CSX",
  "Cts": "CTS",
  "D.R.호턴": "DHI",
  "DBV테크놀로지스ADR": "DBVT",
  "DDC엔터프라이즈": "DDC",
  "DEFSEC테크놀로지스": "DFSC",
  "DHI그룹": "DHX",
  "DHT홀딩스": "DHT",
  "DLH홀딩스": "DLHC",
  "DMC글로벌": "BOOM",
  "DNPSelectIncomeFundInc": "DNP",
  "DPC홀딩스": "DPC",
  "DPC홀딩스ADR": "DSC",
  "DRD골드ADR": "DRD",
  "DTE에너지": "DTE",
  "DTFTax-FreeIncome2028TermFundInc.": "DTF",
  "DT미드스트림": "DTM",
  "DT클라우드스타애퀴지션": "DTSQ",
  "DWSMunicipalIncomeTrust": "KTF",
  "DXC테크놀러지컴퍼니": "DXC",
  "DXP엔터프라이지스": "DXPE",
  "DelekLogisticsPartners,Lp": "DKL",
  "DestinyTech100ClosedEndFund": "DXYZ",
  "DestraMulti-AlternativeFund": "DMA",
  "DnaX": "SONM",
  "DorchesterMineralsUnits": "DMLP",
  "DoubleLineYieldOpportunitiesFund": "DLY",
  "Doubleline": "DSL",
  "DoublelineOpportunisticCreditFund": "DBL",
  "Dss": "DSS",
  "Duff&PhelpsUtilityandInfrastructureFundInc": "DPG",
  "DynagasLngParnersLp": "DLNG",
  "D보랄애퀴지션I": "DBCA",
  "E-파워": "EPOW",
  "E-홈하우스홀드서비스홀딩스": "EJH",
  "ECB뱅코프": "ECBK",
  "EGH애퀴지션": "EGHA",
  "EOG리소시스": "EOG",
  "EON리소시스": "EONR",
  "EPR프로퍼티스": "EPR",
  "EQV벤처스애퀴지션II": "EVAC",
  "ESS테크": "GWH",
  "ETSY": "ETSY",
  "EVI인더스트리": "EVI",
  "EV고": "EVGO",
  "EW스크립스": "SSP",
  "EagleCapitalGrowthFund": "GRF",
  "EaglePointCreditCompanyInc": "ECC",
  "EaglePointCreditCompanySeriesDPreferred": "ECC-P-D",
  "EaglePointIncomeCompanyClosedEndFund": "EIC",
  "EatonVanceCaliforniaMunicipalIncomeClosedFund": "CEV",
  "EatonVanceEnhanceEquity": "EOS",
  "EatonVanceEnhancedEquityIncomeClosedFund": "EOI",
  "EatonVanceFloatingRateIncomeClosedFund": "EFT",
  "EatonVanceLimitedDurationIncomeClosedFund": "EVV",
  "EatonVanceMunicipalBondClosedFund": "EIM",
  "EatonVanceMunicipalIncome2028TermTrust": "ETX",
  "EatonVanceMunicipalIncomeTrust": "EVN",
  "EatonVanceNationalMunicipalOpportunitiesClosedFund": "EOT",
  "EatonVanceRisk-ManagedDiversifiedEquity": "ETJ",
  "EatonVanceSeniorFloating-RateFund": "EFR",
  "EatonVanceSeniorIncomeClosedFund": "EVF",
  "EatonVanceShortDurationDiversifiedIncomeClosedFund": "EVG",
  "EatonVanceTax-AdvantagedGlobalDivOppor.Fund": "ETO",
  "EatonVanceTax-ManagedGlobalDiversifiedEquityIncomeClosedFund": "EXG",
  "EatonVanceTaxAdvantagedDividendIncomeClosedFund": "EVT",
  "EatonVanceTaxAdvantagedGlobalDividendIncomeClosedFund": "ETG",
  "EatonVanceTaxManagedBuyWriteIncomeClosedFund": "ETB",
  "EatonVanceTaxManagedBuyWriteOpportunitiesClosedFund": "ETV",
  "EatonVanceTaxManagedDiversifiedEquityIncomeClosedFund": "ETY",
  "EatonVanceTaxManagedGlobalBuyWriteOpportunitiesClosedFund": "ETW",
  "Eidp": "CTA-P-A",
  "ElevraLithium": "ELVR",
  "EllingtonCreditCompany": "EARN",
  "EllsworthGrowthandIncomeFundLtd.": "ECF",
  "EmbotelladoraAndinaS.A.SeriesA": "AKO-A",
  "EmbotelladoraAndinaS.A.SeriesB": "AKO-B",
  "EmpireStateRealtyOP,L.P.Series250": "FISK",
  "EmpireStateRealtyOP,L.P.Series60": "OGCP",
  "EmpireStateRealtyOp,L.P.SeriesEs": "ESBA",
  "EnergyTransferLPCommonUnitsrepresenting": "ET",
  "EnterpriseProductsPartnersL.P.": "EPD",
  "Eqt": "EQT",
  "Esab": "ESAB",
  "F&G어뉴어티앤라이프": "FG",
  "F5": "FFIV",
  "FBS글로벌": "FBGL",
  "FB뱅코프": "FBLA",
  "FB파이낸셜그룹": "FBK",
  "FGI인더스트리스": "FGI",
  "FG머저II": "BXBL",
  "FG임페리얼애퀴지션": "FGII",
  "FIGX캐피털애퀴지션": "FIGX",
  "FNB": "FNB",
  "FRP홀딩스": "FRPH",
  "FSCreditOpportunitiesCorp.": "FSCO",
  "FSKKR캐피털": "FSK",
  "FSSpecialtyLendingFund": "FSSL",
  "FS뱅코프": "FSBW",
  "FTAI애비에이션": "FTAI",
  "FTAI애비에이션우선주SeriesD": "FTAIM",
  "FTAI인프라스트럭처": "FIP",
  "FTC솔라": "FTCI",
  "FTI컨설팅": "FCN",
  "FVC뱅크코프": "FVCB",
  "FangddNetworkGroupLtd": "DUO",
  "FederalAgriculturalMortgageCorporationClassAVoting": "AGM-A",
  "FederatedHermesPremierMunicipalIncomeClosedEndFund": "FMN",
  "Fg넥서스": "FGNX",
  "Fg넥서스우선주8.00%": "FGNXP",
  "FiEE": "FIEE",
  "FirstTrustEnhancedEquityIncomeClosedFund": "FFA",
  "FirstTrustHighYieldOpportunities2027TermClosedEndFd": "FTHY",
  "FirstTrustIntermediateDurationPreferred&Inc": "FPF",
  "FirstTrustMortgageIncomeFund": "FMY",
  "FirstTrustSeniorFloatingRateIncomeFundII": "FCT",
  "FlahertyCrumrinePreferredand": "FFC",
  "FlahertyCrumrineTotalReturnMutualFundIncorporated": "FLC",
  "FlahertycrumrineDynamicPreferredAnd": "DFP",
  "Fmc": "FMC",
  "FranklinLimitedDurationIncomeTrust": "FTF",
  "FranklinManagedMunicipal": "PMM",
  "FranklinMasterIntermediate": "PIM",
  "FranklinMunicipalOpportunitiesTrust": "PMO",
  "FranklinPremier": "PPT",
  "FranklinUniversalClosedFund": "FT",
  "Fst": "KBSX",
  "FundriseInnovationFundLLC": "VCX",
  "FuturewaveAcquisitionCorp": "FWAC",
  "G-III어패럴그룹": "GIII",
  "GAMCOGlobalGoldNaturalResourcesandIncomeClosedFund": "GGN",
  "GAMCONaturalResources,Gold": "GNT-P-A",
  "GAMCONaturalResourcesGold&IncomeTrust": "GNT",
  "GCL글로벌홀딩스": "GCL",
  "GCM그로스브너": "GCMG",
  "GCT세미컨덕터홀딩": "GCTS",
  "GDLFund": "GDL",
  "GDS홀딩스ADR": "GDS",
  "GD컬처그룹": "GDC",
  "GEE그룹": "JOB",
  "GEN레스토랑그룹": "GENK",
  "GE버노바": "GEV",
  "GE에어로스페이스": "GE",
  "GE헬스케어": "GEHC",
  "GFL인바이런먼털": "GFL",
  "GH리서치": "GHRS",
  "GMEX로보틱스": "GMEX",
  "GMR솔루션스": "GMRS",
  "GP-ActIII애퀴지션": "GPAT",
  "GRI바이오": "GRI",
  "GSI테크놀러지": "GSIT",
  "GSRIV애퀴지션": "GSRF",
  "GSRV애퀴지션": "GSRV",
  "GT바이오파마": "GTBP",
  "GXO로지스틱스": "GXO",
  "GabelliConvertibleandIncomeSecuritiesMutualFund": "GCV",
  "GabelliDividend&IncomeTrust": "GDV",
  "GabelliEquityTrustInc": "GAB",
  "GabelliGlobalSmallandMidCapValueClosedFund": "GGZ",
  "GabelliGlobalUtilityandIncomeClosedFund": "GLU-P-A",
  "GabelliHealthcare&WellnessRxTrust": "GRX",
  "GabelliMultimediaTrustInc": "GGT",
  "GabelliUtilityTrust": "GUT",
  "GabelliUtilityTrustSeriesCPreferred": "GUT-P-C",
  "Gatx": "GATX",
  "Gdev": "GDEV",
  "GeneralAmericanInvestorsClosedFund": "GAM",
  "GeneralAmericanInvestorsCompany": "GAM-P-B",
  "GenesisEnergy,L.P.": "GEL",
  "Global-EOnline": "GLBE",
  "GlobalPartnersUnits": "GLP",
  "Gpgi": "GPGI",
  "GrayMedia": "GTN-A",
  "Greif,Inc.ClassB": "GEF-B",
  "GreystoneHousingImpactInvestorsLPBeneficialUnitCertificatesrepresentingassignmentsof": "GHI",
  "GrupoAeroportuariodelPacifico,S.A.B.deC.V.": "PAC",
  "GrupoCibestS.A.AmericanPreferred": "CIB",
  "Gsk": "GSK",
  "GuggenheimActiveAllocationCEF": "GUG",
  "GuggenheimStrategicOpportunitiesMutualFund": "GOF",
  "GuggenheimTaxableMuniBd&InvGradeDbtTrust": "GBAB",
  "G뱅크파이낸셜홀딩스": "GBFH",
  "G윌리푸드인터내셔널": "WILC",
  "H&R블록": "HRB",
  "H2O아메리카": "HTO",
  "HA서스테이너블인프라캐피털": "HASI",
  "HBT파이낸셜": "HBT",
  "HCA헬스케어": "HCA",
  "HCI그룹": "HCI",
  "HCMIII애퀴지션": "HCMA",
  "HCMIV애퀴지션": "HACQ",
  "HCW바이오로직스": "HCWB",
  "HDFC뱅크ADR": "HDB",
  "HEICOCORPCLA": "HEI-A",
  "HF싱클레어": "DINO",
  "HF푸즈그룹": "HFFG",
  "HMH홀딩": "HMH",
  "HP": "HP",
  "HSBC홀딩스ADR": "HSBC",
  "HWH인터내셔널": "HWH",
  "HavertyFurnitureCompanies": "HVT-A",
  "HerzfeldCreditIncomeFund，Inc.": "HERZ",
  "HighIncomeSecuritiesFund": "PCF",
  "HighlandGlobalAllocationFund": "HGLB",
  "HighlandOpportunitiesand": "HFRO",
  "HighlandOpportunitiesandIncomeFund": "HFRO-P-A",
  "Hni": "HNI",
  "Hp": "HPQ",
  "I-80골드": "IAUX",
  "I3버티칼스": "IIIV",
  "IBM(인터내셔널비지니스머신)": "IBM",
  "IB애퀴지션": "IBAC",
  "ICF인터내셔널": "ICFI",
  "ICICI뱅크ADR": "IBN",
  "ICU메디컬": "ICUI",
  "ICZOOMGroup": "IZM",
  "IES홀딩스": "IESC",
  "IHS홀딩": "IHS",
  "IMC레어어스": "IMC",
  "IM카나비스": "IMCC",
  "ING그룹ADR": "ING",
  "INNEOVA홀딩스": "INEO",
  "INVO퍼틸리티": "IVF",
  "IPG포토닉스": "IPGP",
  "IP스트래티지홀딩스": "IPST",
  "IQM퀀텀컴퓨터스ADR": "IQMX",
  "IRSA인베르시오네스ADR": "IRS",
  "ITHAX애퀴지션III": "ITHA",
  "IT테크패키징": "ITP",
  "IcahnEnterprisesL.P": "IEP",
  "Idt": "IDT",
  "InvescoAdvantageMunicipalIncTrII": "VKI",
  "InvescoBondFund": "VBF",
  "InvescoCaliforniaValueMuni": "VCV",
  "InvescoHigh": "VLT",
  "InvescoMuniIncomeOpportunitiesTrust": "OIA",
  "InvescoMunicipalOpportunityTrust": "VMO",
  "InvescoMunicipalTrust": "VKQ",
  "InvescoPennsylvaniaValueMunicipal": "VPV",
  "InvescoQualityMunicipalSecurities": "IQI",
  "InvescoSenior": "VVR",
  "InvescoTrustInvestmentGradeMunicipals": "VGM",
  "InvescoTrustforInvestmentGradeNewYorkMunicipals": "VTN",
  "InvescoValueMunicipalIncomeClosedFund": "IIM",
  "Iqstel": "IQST",
  "Itg": "ITG",
  "Itt": "ITT",
  "J&J스낵푸즈": "JJSF",
  "J-롱그룹": "JL",
  "J.M.스머커": "SJM",
  "JAB애퀴지션I": "JAB",
  "JBDI홀딩스": "JBDI",
  "JBGSMITHPropertiesCommon": "JBGS",
  "JBHuntTransportServices": "JBHT",
  "JBT마렐": "JBTM",
  "JE클린테크홀딩스": "JCSE",
  "JFBConstructionHoldingsClassA": "JFB",
  "JW메이스": "MAYS",
  "JX룩스벤처그룹": "JXG",
  "JackintheBox": "JACK",
  "JacksonAcquisitionCompanyII": "JACS",
  "JadeBiosciences": "JBIO",
  "JamesHardieIndustriesPLC": "JHX",
  "JandFriendsHoldings": "JF",
  "JanusLiving": "JAN",
  "JapanSmallerCapitalizationClosedFund": "JOF",
  "JbsN.V.": "JBS",
  "JetBlueAirways": "JBLU",
  "JohnB.SanfilippoSON": "JBSS",
  "JohnHancockDiversified": "HEQ",
  "JohnHancockFinancialOpportunitiesFund": "BTO",
  "JohnHancockIncomeSecuritiesClosedFund": "JHS",
  "JohnHancockInvestorsTrustCapitalStock": "JHI",
  "JohnHancockPreferredIncomeClosedFund": "HPI",
  "JohnHancockPreferredIncomeIIClosedFund": "HPF",
  "JohnHancockPreferredIncomeIIIClosedFund": "HPS",
  "JohnHancockPremiumDividendFund": "PDT",
  "JohnHancockTaxAdvantagedDividendIncomeClosedFund": "HTD",
  "J스타홀딩": "YMAT",
  "K&F그로스애퀴지션II": "KFII",
  "K2캐피탈애퀴지션": "KTWO",
  "KB금융지주ADR": "KB",
  "KB홈": "KBH",
  "KE홀딩스ADR": "BEKE",
  "KKR리얼에스테이트파이낸스트러스트": "KREF",
  "KLX에너지서비시스홀딩스": "KLXE",
  "KRAK애퀴지션": "KRAQ",
  "KULR테크놀로지그룹": "KULR",
  "KVH인더스트리": "KVHI",
  "KayneAndersonEnergyInfrastructureFundInc": "KYN",
  "Kbr": "KBR",
  "KidzAi": "KIDZ",
  "KimbellRoyaltyPartners,LPCommonUnitsrepresenting": "KRP",
  "Kkr": "KIO",
  "Kla": "KLAC",
  "KnotOffshorePartnersLp": "KNOP",
  "KoreaFund": "KF",
  "Kt": "KT",
  "K웨이브미디어": "KWM",
  "K테크솔루션스": "KMRK",
  "K포스": "KFRC",
  "L3해리스테크놀러지스": "LHX",
  "LB파마슈티컬스": "LBRX",
  "LB포스터": "FSTR",
  "LCI인더스트리스": "LCII",
  "LGI홈스": "LGIH",
  "LGL그룹": "LGL",
  "LMPCapitaland": "SCD",
  "LPL파이낸셜홀딩스": "LPLA",
  "LQR하우스": "YHC",
  "LSB인더스트리": "LXU",
  "LSI인더스트리": "LYTS",
  "LTC프로퍼티즈": "LTC",
  "LXP인더스트리얼트러스트": "LXP",
  "LZ테크놀로지홀딩스": "LZMH",
  "LatigoBiotherapeuticsInc": "LTGO",
  "LazardGlobalTotalReturn": "LGI",
  "Lcnb": "LCNB",
  "LennarCorporationClassB": "LEN-B",
  "LibertyAll-StarGrowthFd": "ASG",
  "LibertyAllStarEquityClosedFund": "USA",
  "LibertyCapital": "GLIBA",
  "Lkq": "LKQ",
  "M&T뱅크": "MTB",
  "M-트론인더스트리스": "MPTI",
  "M/A-컴테크놀로지솔루션스홀딩스": "MTSI",
  "M/I홈스": "MHO",
  "M3-브리게이드애퀴지션VI": "MBVI",
  "MBX바이오사이언시스": "MBX",
  "MDA스페이스": "MDA",
  "MDB캐피털홀딩스": "MDBH",
  "MDU리소시스그룹": "MDU",
  "MDxHealthSA": "MDXH",
  "MFA파이낸셜": "MFA",
  "MGE에너지": "MGEE",
  "MGIC인베스트먼트": "MTG",
  "MGM리조트인터내셔널": "MGM",
  "MGP인그리디언츠": "MGPI",
  "MKD웰테크": "MKDW",
  "MMTec": "MTC",
  "MOOGINCCLB": "MOG-B",
  "MORGANSTANLEYSeriesIPreferredStock": "MS-P-I",
  "MSC인더스트리얼다이렉트": "MSM",
  "MVB파이낸셜": "MVBF",
  "MYR그룹": "MYRG",
  "MachNaturalResourcesLPCommonUnitsrepresenting": "MNR",
  "Marcusmillichap": "MMI",
  "Marsh": "MRSH",
  "MartiTechnologies": "MRT",
  "MartinMidstreamPartnersUnits": "MMLP",
  "McCormickCompany": "MKC-V",
  "MereoBioPharmaGroup": "MREO",
  "MeridianHoldings": "MRDN",
  "Merlin": "MRLN",
  "MexicoFund": "MXF",
  "MiddlesexWater": "MSEX",
  "MindCTI": "MNDO",
  "MineSafety": "MSA",
  "MixedMartialArtsGroup": "MMA",
  "Mks": "MKSI",
  "Mntn": "MNTN",
  "Mobile-healthNetworkSolutionsClassA": "MNDR",
  "MobilicomLtd": "MOB",
  "ModineManufacturing": "MOD",
  "Mogu": "MOGU",
  "MonolithicPowerSystems": "MPWR",
  "MoogInc.": "MOG-A",
  "MoonLakeImmunotherapeuticsClassA": "MLTX",
  "MorganStanleyChinaAShareClosedFund": "CAF",
  "MorganStanleyDep": "MS-P-E",
  "MorganStanleyEmergingMarketsDebtClosedFund": "MSD",
  "MorganStanleyEmergingMrktDomesticDebtFdInc": "EDD",
  "MorganStanleyFloatingRatenon-cumulativePreferredSeriesA": "MS-P-A",
  "MorganStanleyIndiaInvestmentClosedFund": "IIF",
  "MorganStanleySeriesF": "MS-P-F",
  "MorganStanleySeriesKPreferredStock": "MS-P-K",
  "MorganStanleySeriesLPreferredStock": "MS-P-L",
  "MorganStanleySeriesOPreferredStock": "MS-P-O",
  "MorganStanleySeriesPPreferredStock": "MS-P-P",
  "MorganStanleySeriesQPreferredStock": "MS-P-Q",
  "MplxLp": "MPLX",
  "Msc": "MSIF",
  "Msci": "MSCI",
  "M에보글로벌애퀴지션II": "MEVO",
  "NBT뱅코프": "NBTB",
  "NB뱅코프": "NBBK",
  "NCR보익스": "VYX",
  "NCR아틀레오스": "NATL",
  "NCS멀티스테이지홀딩스": "NCSM",
  "NIP그룹ADR": "NIPG",
  "NIQ글로벌인텔리전스": "NIQ",
  "NIU테크놀러지ADR": "NIU",
  "NI홀딩스": "NODK",
  "NLI홀딩스": "NL",
  "NMI홀딩스": "NMIH",
  "NMP애퀴지션": "NMP",
  "NN": "NN",
  "NPK인터내셔널": "NPKI",
  "NRC헬스": "NRC",
  "NRG에너지": "NRG",
  "NRX파마슈티컬스": "NRXP",
  "NSTS뱅코프": "NSTS",
  "NWPX인프라스트럭처": "NWPX",
  "NXGCushingMidstreamEnergyClosedEndFund": "SRV",
  "NXGNextGenInfrastructureIncomeFund": "NXG",
  "NXP세미콘덕터": "NXPI",
  "NYLICBREGlobalInfrastructureMegatrendsTermFund": "MEGI",
  "NYLIMacKayDefinedTermMuniOpportunitiesFund": "MMD",
  "NaturalResourcePartnersL.P.": "NRP",
  "NaviosMaritimePartnersUnits": "NMM",
  "NeubergerEnergyInfrastructureand": "NML",
  "NeubergerHighYieldStrategiesFund": "NHS",
  "NeubergerMunicipalFund": "NBH",
  "NeubergerNextGenerationConnectivityFund": "NBXG",
  "NeubergerRealEstateSecurities": "NRO",
  "NewGermanyFund": "GF",
  "Nft": "MI",
  "NglEnergyPartnersLp": "NGL",
  "Nn": "NNBR",
  "NorthEuropeanOilRoyaltyUnits": "NRT",
  "NovaMineralsCorp": "NVA",
  "NuveenAMT-FreeMunicipalCreditIncomeFund": "NVG",
  "NuveenAMT-FreeMunicipalValueFund": "NUW",
  "NuveenAMT-FreeQualityMunicipalIncomeFund": "NEA",
  "NuveenArizonaQualityMunicipalIncomeFund": "NAZ",
  "NuveenCaliforniaAMT-FreeQualityMunicipalInFd": "NKX",
  "NuveenCaliforniaMunicipalValueFund": "NCA",
  "NuveenCaliforniaQualityMunicipalIncomeFund": "NAC",
  "NuveenCoreEquityAlphaClosedFund": "JCE",
  "NuveenCorePlusImpactFund": "NPCT",
  "NuveenCreditStrategiesIncomeClosedFund": "JQC",
  "NuveenDynamicMunicipalOpportunitiesFund": "NDMO",
  "NuveenFloatingRateIncomeClosedFund": "JFR",
  "NuveenGlobalHighIncomeFund": "JGH",
  "NuveenMassachusettsQualityMunicipalIncomeFund": "NMT",
  "NuveenMinnesotaQualityMunicipalIncomeFund": "NMS",
  "NuveenMortgageandIncomeFund": "JLS",
  "NuveenMulti-AssetIncomeFund": "NMAI",
  "NuveenMulti-MarketIncomeFund": "JMM",
  "NuveenMunicipalCreditIncomeFund": "NZF",
  "NuveenMunicipalCreditOpportunitiesFund": "NMCO",
  "NuveenMunicipalHighIncomeOpportunityClosedFund": "NMZ",
  "NuveenMunicipalIncomeFundInc": "NMI",
  "NuveenMunicipalValueFundInc": "NUV",
  "NuveenNASDAQ100DynamicOverwriteFund-": "QQQX",
  "NuveenNewYorkAMT-FreeQualityMunicipalIncFd": "NRK",
  "NuveenNewYorkMunicipalValueFund": "NNY",
  "NuveenNewYorkQualityMunicipalIncomeFund": "NAN",
  "NuveenPreferred&IncomeOpportunitiesFund": "JPC",
  "NuveenQualityMunicipalIncomeFund": "NAD",
  "NuveenRealAssetIncomeandGrowthFund": "JRI",
  "NuveenRealEstateIncomeClosedFund": "JRS",
  "NuveenS&P500DynamicOverwriteClosedEndFund": "SPXX",
  "NuveenSelectMaturitiesMunicipalFund": "NIM",
  "NuveenSelectTax-FreeIncomePortfolio": "NXP",
  "NuveenTaxableMunicipalIncomeFund": "NBB",
  "NuveenVariableRatePreferredIncomeClosedEndFund": "NPFD",
  "NuveenVirginiaQualityMunicipalIncomeFund": "NPV",
  "Nve": "NVEC",
  "Nvr": "NVR",
  "O-i글래스": "OI",
  "OFA그룹": "OFAL",
  "OFG뱅코프": "OFG",
  "OFS캐피털": "OFS",
  "OFS크레디트우선주SeriesE5.25%": "OCCIN",
  "OFS크레디트우선주SeriesF7.875%": "OCCIM",
  "OFS크레디트컴퍼니": "OCCI",
  "OGE에너지": "OGE",
  "OIO그룹": "OIO",
  "OKYOPharmaLtd": "OKYO",
  "OMS에너지테크놀로지스": "OMSE",
  "OP뱅코프": "OPBK",
  "OR로열티스": "OR",
  "OSI시스템즈": "OSIS",
  "OSR헬스": "OSRH",
  "OSS(원스탑시스템)": "OSS",
  "OS테라퓨틱스": "OSTX",
  "OTG애퀴지션I": "OTGA",
  "P&G(프록터&갬블)": "PG",
  "P3헬스파트너스": "PIII",
  "PARTechnology": "PAR",
  "PCBBancorp": "PCB",
  "PCMFundInc": "PCM",
  "PC커넥션": "CNXN",
  "PDF솔루션스": "PDFS",
  "PDS바이오테크놀러지": "PDSB",
  "PGIMGlobalHighYieldFund，Inc": "GHY",
  "PGIMHighYieldBondFund，Inc": "ISD",
  "PGIMShortDurationHighYieldOpportunitiesFund": "SDHY",
  "PIMCOAccessIncomeFund": "PAXS",
  "PIMCODynamic": "PDX",
  "PIMCODynamicIncomeFund": "PDI",
  "PIMCODynamicIncomeOpportunitiesFund": "PDO",
  "PIMCOGlobalStockPLUS": "PGP",
  "PIMCOHighIncomeFund": "PHK",
  "PJT파트너스": "PJT",
  "PMGC홀딩스": "ELAB",
  "PMV파마슈티컬스": "PMVP",
  "PNC파이낸셜서비스": "PNC",
  "PN스마트에너지": "PN",
  "PPG인더스트리스": "PPG",
  "PRA그룹": "PRAA",
  "PRF테크놀로지스": "PRFX",
  "PROG홀딩스": "PRG",
  "PSQ홀딩스": "PSQH",
  "PS인터내셔널그룹": "PSIG",
  "PTC테라퓨틱스": "PTCT",
  "PagerDuty": "PD",
  "PampaEnergiaS.A.": "PAM",
  "Pamt": "PAMT",
  "Paysign": "PAYS",
  "PbfEnergy": "PBF",
  "PebblebrookHotelTrustSeriesEPreferred": "PEB-P-E",
  "PebblebrookHotelTrustSeriesFPreferred": "PEB-P-F",
  "PebblebrookHotelTrustSeriesGPreferred": "PEB-P-G",
  "PebblebrookHotelTrustSeriesHPreferred": "PEB-P-H",
  "Pedevco": "PED",
  "PeoplesBancorpofNorthCarol": "PEBK",
  "PermRockRoyaltyTrustTrustUnit": "PRT",
  "PermianBasinRoyaltyUnits": "PBT",
  "PermianvilleRoyaltyUnit": "PVL",
  "Perpetuals.com": "PDC",
  "PetMedExpress": "PETS",
  "PetroleoBrasileiroS.A.-Petrobras": "PBR-A",
  "PetroleoBrasileiroS.A.-PetrobrasAds(Rep1CommonShare)": "PBR",
  "Pg&E": "PCG",
  "PiedmontRealtyTrust": "PDM",
  "Pimco": "PCN",
  "PimcoCaliforniaMunicipal": "PCQ",
  "PimcoMunicipal": "PML",
  "PimcoNewYorkMunicipal": "PNI",
  "PimcoStrategic": "RCS",
  "PlainsAllAmericanPipeline,L.P.CommonUnitsrepresenting": "PAA",
  "PlainsGPHoldings,L.P.ClassAUnitsrepresenting": "PAGP",
  "Pldt": "PHI",
  "Ppl": "PPL",
  "PrincipalRealEstateIncomeFund": "PGZ",
  "ProCapAcquisition": "PCAP",
  "Ptc": "PTC",
  "Ptl": "PTLE",
  "Q/C테크놀로지스": "QCLS",
  "Q2홀딩스": "QTWO",
  "Q32바이오": "QTTB",
  "QCR홀딩스": "QCRH",
  "QDRO애퀴지션": "QADR",
  "QMMM홀딩스": "QMMM",
  "QT이미징홀딩스": "QTI",
  "QVC그룹": "QVC",
  "QuanomeTechnologies": "QNME",
  "Qxo": "QXO",
  "RBB뱅코프": "RBB",
  "RCB": "RCBC",
  "RCI호스피탤리티홀딩스": "RICK",
  "RCM테크놀로지스": "RCMT",
  "RENNFund": "RCG",
  "RE앨로이스": "ALOY",
  "RF애퀴지션II": "RFAI",
  "RF애퀴지션III": "RFAM",
  "RF인더스트리스": "RFIL",
  "RGC리소스": "RGCO",
  "RLJ로징트러스트": "RLJ",
  "RLX테크놀로지ADR": "RLX",
  "RMGMLSportsHoldingsClassA": "SHOT",
  "RMR그룹": "RMR",
  "RPM인터내셔널": "RPM",
  "RRE벤처스애퀴지션": "RREV",
  "RTB디지털": "RTB",
  "ReavesUtilityIncomeClosedFund": "UTG",
  "Rh": "RH",
  "RidgepostCapital": "RPC",
  "RiverNorth/DoubleLineStrategicOpportunityFund": "OPP",
  "RiverNorthCapitalandIncomeIntervalFund": "RSF",
  "RiverNorthFlexibleMunicipalIncomeFundIIInc.": "RFMZ",
  "RiverNorthFlexibleMunicipalIncomeFundInc.": "RFM",
  "RiverNorthManagedDurationMuniIncomeFdIIInc.": "RMMZ",
  "RiverNorthManagedDurationMuniIncomeFdInc": "RMM",
  "RiverNorthOpportunisticMunicipalIncomeFundInc": "RMI",
  "RiverNorthOpportunitiesFundInc": "RIV",
  "RobinhoodVenturesFundI": "RVI",
  "RoyceGlobalTrustInc": "RGT",
  "RoyceMicroCapClosedFund": "RMT",
  "RoyceSmall-CapTrustInc": "RVT",
  "Rpc": "RES",
  "Rtx": "RTX",
  "Rxo": "RXO",
  "Rx사이트": "RXST",
  "S&P글로벌": "SPGI",
  "S&T뱅코프": "STBA",
  "SAB바이오테라퓨틱스": "SABS",
  "SBA커뮤니케이션스": "SBAC",
  "SBC메디컬그룹홀딩스": "SBC",
  "SB파이낸셜그룹": "SBFG",
  "SCE트러스트VII우선주": "SCE-P-G",
  "SCII애퀴지션": "SCII",
  "SEI인베스트먼트": "SEIC",
  "SFL코퍼레이션": "SFL",
  "SGHC": "SGHC",
  "SHF홀딩스": "SHFS",
  "SIFCO인더스트리": "SIF",
  "SIM애퀴지션I": "SIMA",
  "SINTX테크놀로지스": "SINT",
  "SKK홀딩스": "SKK",
  "SKYAI": "SKYA",
  "SK텔레콤ADR": "SKM",
  "SK하이닉스ADR": "SKHY",
  "SLM우선주시리즈B": "SLMBP",
  "SLR인베스트먼트": "SLRC",
  "SL그린리얼티": "SLG",
  "SMJ인터내셔널홀딩스": "SMJF",
  "SMX(시큐리티매터스)": "SMX",
  "SM에너지": "SM",
  "SPS커머스": "SPSC",
  "SPX테크놀로지스": "SPXC",
  "SRHTotalReturnFund，Inc": "STEW",
  "SRx글로벌": "SRXH",
  "SR뱅코프": "SRBK",
  "SS&C테크놀로지스홀딩스": "SSNC",
  "SSR마이닝": "SSRM",
  "SS이노베이션스인터내셔널": "SSII",
  "ST마이크로일렉트로닉스ADR": "STM",
  "SUI그룹홀딩스": "SUIG",
  "SUMA애퀴지션": "SUMA",
  "SU그룹홀딩스": "SUGP",
  "SabaCapitalIncome&OpportunitiesFund": "BRW",
  "SabaCapitalIncome&OpportunitiesFundII": "SABA",
  "SabineRoyaltyUnits": "SBR",
  "SanJuanBasinRoyaltyTrustUBI": "SJT",
  "SapSe": "SAP",
  "SesAi": "SES",
  "Si타임": "SITM",
  "Slb": "SLB",
  "Slm": "SLM",
  "Sl사이언스홀딩": "SLBT",
  "SolsticeAdvancedMaterials": "SOLS",
  "SourceCapitalBeneficialInterest": "SOR",
  "SouthernCrossAcquisitionICorp": "NCO",
  "SpecialOpportunitiesFund，Inc.": "SPE",
  "SprottFocusTrust": "FUND",
  "StarGroup,L.P.CommonUnitsRepresenting": "SGU",
  "SuburbanPropanePartnersLP": "SPH",
  "SummitTherapeuticsInc": "SMMT",
  "SundialGrowers": "SNDL",
  "SunocoCorp": "SUNC",
  "SunocoL.P.": "SUN",
  "SyntheticFixed": "GJP",
  "SyntheticFixed-IncomeSecSTRATS2004-06,6.375%USCellular": "GJH",
  "SyntheticFixed-IncomeSecurities": "GJO",
  "SyntheticFixed-IncomeSecuritiesSTRATS2006-2GoldmanSachsGroup": "GJS",
  "SyntheticFixed-IncomeSecuritiesSTRATS2006-3AllState": "GJT",
  "T-모바일US": "TMUS",
  "T1에너지": "TE",
  "T3디펜스": "DFNS",
  "TAL에듀케이션그룹ADR": "TAL",
  "TAO시너지스": "TAOX",
  "TAT테크놀러지": "TATT",
  "TCGX애퀴지션": "TCGX",
  "TCWStrategicIncomeClosedFund": "TSI",
  "TC에너지": "TRP",
  "TDH홀딩스": "PETZ",
  "TD시넥스": "SNX",
  "TEN홀딩스": "XHLD",
  "TE커넥티비티": "TEL",
  "TFI인터내셔널": "TFII",
  "TFS파이낸셜": "TFSL",
  "TGE밸류크리에이티브솔루션즈": "BEBE",
  "TG테라퓨틱스": "TGTX",
  "TH인터내셔널": "THCH",
  "TIC솔루션스": "TIC",
  "TJGC그룹": "TJGC",
  "TJX컴퍼니스": "TJX",
  "TKO그룹홀딩스": "TKO",
  "TMC더메탈스컴퍼니": "TMC",
  "TMD에너지": "TMDE",
  "TNL미디어진": "TNMG",
  "TPG리파이낸스트러스트": "TRTX",
  "TPG모기지인베스트먼트": "MITT",
  "TPG스페셜티렌딩": "TSLX",
  "TRG라틴아메리카애퀴지션스": "TRGS",
  "TRI-Continental": "TY",
  "TSMC(타이완반도체제조)ADR": "TSM",
  "TTEC홀딩스": "TTEC",
  "TTM테크놀로지스": "TTMI",
  "TXNM에너지": "TXNM",
  "TXOPartners,L.P.": "TXO",
  "TaiwanFund": "TWN",
  "TempletonDragonClosedFund": "TDF",
  "TempletonEmergingMarketsClosedFund": "EMF",
  "TempletonEmergingMarketsIncomeClosedFund": "TEI",
  "TheCignaGroup": "CI",
  "TheEuropeanEquityFundInc": "EEA",
  "TheGabelliDividend": "GDV-P-H",
  "TheGabelliEquityTrust": "GAB-P-G",
  "TheGabelliMultimediaTrust": "GGT-P-E",
  "TheGabelliUtility": "GLU",
  "TheMexicoEquityand": "MXE",
  "TheMosaicCompany": "MOS",
  "ThornburgIncomeBuilderOpportunitiesTrust": "TBLD",
  "TicketplusLtd": "TP",
  "TizianaLifeSciencesLtd": "TLSA",
  "TortoiseEnergyInfrastructureClosedFund": "TYG",
  "TotalReturnSecuritiesFund": "SWZ",
  "Tpg": "TPG",
  "TransportadoradeGasdelSurS.A.ADS": "TGS",
  "TriContinentalClosedFund": "TY-P",
  "Tron": "TRON",
  "Tss": "TSSI",
  "Twfg": "TWFG",
  "T스캔테라퓨틱스": "TCRX",
  "UBS그룹AG": "UBS",
  "UFP인더스트리": "UFPI",
  "UFP테크놀로지스": "UFPT",
  "UL솔루션스": "ULS",
  "UMB파이낸셜": "UMBF",
  "UMB파이낸셜우선주SeriesB7.750%": "UMBFO",
  "UMH프로퍼티": "UMH",
  "UPS(유나이티드파셀서비스)": "UPS",
  "USA레어어스": "USAR",
  "USA투데이": "TDAY",
  "US골드": "USAU",
  "US골드마이닝": "USGO",
  "US글로벌인베스터스": "GROW",
  "US뱅코프": "USB",
  "US센츄리뱅크": "USCB",
  "US푸즈홀딩": "USFD",
  "US피지컬테라피": "USPH",
  "UTZ브랜즈": "UTZ",
  "UT스타컴홀딩스": "UTSI",
  "UWM홀딩스": "UWMC",
  "UY스쿠티애퀴지션": "UYSC",
  "Udr": "UDR",
  "Ugi": "UGI",
  "UsaCompressionPartnersLp": "USAC",
  "Usbc": "USBC",
  "V.F.": "VFC",
  "VCI글로벌": "VCIG",
  "VS미디어홀딩스": "VSME",
  "VirtusArtificialIntelligenceandTechnologyOpportunitiesFund": "AIO",
  "VirtusConvertibleAndIncomeFund": "NCV",
  "VirtusConvertibleandIncomeFundII": "NCZ",
  "VirtusDiversifiedIncomeAndConvertibleFund": "ACV",
  "VirtusDividendInterest&PremStrFd": "NFJ",
  "VirtusEquityAndConvertibleIncomeFund": "NIE",
  "VirtusGlobalMulti-SectorIncomeFund": "VGI",
  "VirtusStoneHarborEmergingMarketsIncomeFund": "EDF",
  "VirtusTotalReturnFund": "ZTR",
  "VocEnergyTrust": "VOC",
  "VoyaAsiaPacificHighDividendEquityIncomeFund": "IAE",
  "VoyaEmergingMarketsHigh": "IHD",
  "VoyaGlobalAdvantageAndPremiumOpportunityFund": "IGA",
  "VoyaGlobalEquityDividendAndPremiumOpportunityFund": "IGD",
  "VoyaInfrastructure,IndustrialsAndMaterialsFund": "IDE",
  "Vse": "VSEC",
  "Vtex": "VTEX",
  "W&T오프쇼어": "WTI",
  "W.R.버클리": "WRB",
  "W.p.케어리": "WPC",
  "WEC에너지그룹": "WEC",
  "WF인터내셔널": "WXM",
  "WF홀딩": "WFF",
  "WSFS파이낸셜": "WSFS",
  "WW그레인저": "GWW",
  "WW인터내셔널": "WW",
  "WaFd": "WAFD",
  "WaFd우선주SeriesA": "WAFDP",
  "Watsco,Inc.ClassB": "WSO-B",
  "Wd-40": "WDFC",
  "WesternAssetDiversifiedIncomeFund": "WDI",
  "WesternAssetEmergingMarketsDebtFund": "EMD",
  "WesternAssetGlobalCorporateOpportunityFdInc.": "GDO",
  "WesternAssetGlobalHighIncomeFund": "EHI",
  "WesternAssetHighIncomeFundIIInc": "HIX",
  "WesternAssetHighIncomeOpportunityClosedFund": "HIO",
  "WesternAssetHighYieldOpportunityFund": "HYI",
  "WesternAssetInflationLinkedIncomeClosedEndFund": "WIA",
  "WesternAssetInflationLinkedOpportunitiesIncomeClosedEndFund": "WIW",
  "WesternAssetIntermediateMuniFund": "SBI",
  "WesternAssetInvestmentGradeIncomeClosedEndFundInc": "PAI",
  "WesternAssetInvestmentGradeOppsTrustInc.": "IGI",
  "WesternAssetManagedMunicipalsFund": "MMU",
  "WesternAssetMortgageOpportunityFund": "DMO",
  "WesternAssetMunicipalHighIncomeFund": "MHF",
  "WesternAssetPremierBondClosedFund": "WEA",
  "WesternMidstreamPartners,LP": "WES",
  "WestlakeChemicalPartnersLp": "WLKP",
  "Wpp": "WPP",
  "X-에너지": "XE",
  "X3애퀴지션": "XCBE",
  "X4파마슈티컬": "XFOR",
  "XAIFloatingRateAlternative": "XFLT",
  "XAIMadisonEquityPremium": "MCN",
  "XBP글로벌홀딩스": "XBP",
  "XCF글로벌": "SAFX",
  "XFLH캐피탈": "XFLH",
  "XPLR인프라스트럭처": "XIFR",
  "XTI에어로스페이스": "XTIA",
  "XTL바이오파마슈티컬ADR": "XTLB",
  "Xchg": "XCH",
  "Xmax": "XMAX",
  "X웰": "XWEL",
  "X체인지TEC.INCADR": "XHG",
  "YD바이오": "YDES",
  "YHN애퀴지션I": "YHNA",
  "YPFSociedadAnonima": "YPF",
  "YSX테크": "YSXT",
  "YXT.컴그룹홀딩ADR": "YXT",
  "YY그룹홀딩": "YYGH",
  "ZIM인티그레이티드시핑서비시스": "ZIM",
  "ZJK인터스트리얼": "ZJK",
  "ZKH그룹ADR": "ZKH",
  "ZK인터내셔널": "ZKIN",
  "ZTO익스프레스(케이먼)ADR": "ZTO",
  "ZW데이터액션테크놀로지스": "CNET",
  "Z스퀘어드": "ZSQR",
  "abrdn": "ACP",
  "abrdnAsia-Pacific": "FAX",
  "abrdnAustraliaEquityFund": "IAF",
  "abrdnEmergingMarketsex-ChinaFund": "AEF",
  "abrdnGlobalDynamicDividendFund": "AGD",
  "abrdnGlobalInfrastructureIncomeFund": "ASGI",
  "abrdnGlobalPremierPropertiesMutualFund": "AWP",
  "abrdnHealthcareInvestors": "HQH",
  "abrdnHealthcareOpportunitiesFund": "THQ",
  "abrdnIncomeCreditStrategiesMutualFund": "ACP-P-A",
  "abrdnLifeSciencesInvestors": "HQL",
  "abrdnTotalDynamicDividendFund": "AOD",
  "abrdnWorldHealthcareFund": "THW",
  "monday.com": "MNDY",
  "rYojbaba": "RYOJ",
  "vTv테라퓨틱스": "VTVT",
  "가단트헬쓰": "GH",
  "가드포스AI": "GFAI",
  "가든스테이지": "GSIW",
  "가디언메탈리소시스ADR": "GMTL",
  "가디언파마시서비시스": "GRDN",
  "가렛모션": "GTX",
  "가민": "GRMN",
  "가소스.AI": "GXAI",
  "가스로그파트너스우선주시리즈A": "GLOP-P-A",
  "가이드와이어소프트웨어": "GWRE",
  "가이아": "GAIA",
  "가트너": "IT",
  "갈라타애퀴지션II": "LATA",
  "갈레라테라퓨틱스": "OBX",
  "갈렉틴테라퓨틱스": "GALT",
  "갈리아노골드": "GAU",
  "갈메드파머슈티컬스": "GLMD",
  "갤럭시디지털홀딩스": "GLXY",
  "갤럭시엣지애퀴지션": "GLED",
  "갤럭시페이롤그룹": "GLXG",
  "갭": "GAP",
  "걸프리소시즈": "GURE",
  "걸프포트에너지": "GPOR",
  "게셔애퀴지션II": "GSHR",
  "게이밍&레저프로퍼티스": "GLPI",
  "게이츠인더스트리얼": "GTES",
  "게인테라퓨틱스": "GANX",
  "게임스탑": "GME",
  "게임유어게임": "GYGY",
  "게임하우스홀딩스": "GMHS",
  "게티리얼티": "GTY",
  "게티이미지스홀딩스": "GETY",
  "고고": "GOGO",
  "고고로": "GGR",
  "고대디": "GDDY",
  "고릴라테크놀로지그룹": "GRRR",
  "고먼-러프": "GRC",
  "고사머바이오": "GOSS",
  "고어스홀딩스X": "GTEN",
  "고지": "GAUZ",
  "고프로": "GPRO",
  "골드그룹마이닝": "GORO",
  "골드닷컴": "GOLD",
  "골드로열티": "GROY",
  "골드마이닝": "GLDG",
  "골드만삭스": "GS",
  "골드만삭스BDC": "GSBD",
  "골드만삭스캐피탈I시큐리티-백드우선주시리즈2004-6": "JBK",
  "골드필즈ADR": "GFI",
  "골든선테크놀로지그룹": "GSUN",
  "골든헤븐그룹홀딩스": "GDHG",
  "골라LNG": "GLNG",
  "골럽캐피탈BDC": "GBDC",
  "구스헤드인슈어런스": "GSHD",
  "굿알엑스홀딩스": "GDRX",
  "굿이어타이어&러버": "GT",
  "굿타임스레스토란츠": "GTIM",
  "그라비티ADR": "GRVY",
  "그라인더": "GRND",
  "그라코": "GGG",
  "그라프글로벌": "TONT",
  "그란데그룹": "GRAN",
  "그래나이트릿지리소시스": "GRNT",
  "그래니트모인트모기지트러스트": "GPMT",
  "그래니트컨스트럭션": "GVA",
  "그래프테크인터내셔널": "EAF",
  "그래픽패키징홀딩": "GPK",
  "그랜드스탠드": "GRSD",
  "그랜드캐년에듀케이션": "LOPE",
  "그랜티에라에너지": "GTE",
  "그랩어건디지털홀딩스": "PEW",
  "그랩홀딩스": "GRAB",
  "그레이미디어": "GTN",
  "그레이스테라퓨틱스": "GRCE",
  "그레이엄": "GHM",
  "그레이엄홀딩스": "GHC",
  "그레이트서던뱅코프": "GSBC",
  "그레이트엘름그룹": "GEG",
  "그레이트엘름캐피털": "GECC",
  "그레일": "GRAL",
  "그로브콜라보레이티브홀딩스": "GROV",
  "그로서리아울렛홀딩스": "GO",
  "그로우제너레이션": "GRWG",
  "그로우허브": "TGHL",
  "그루포수페르비엘ADR": "SUPV",
  "그루포시멕ADR": "SIM",
  "그루포아발악시오네스이발로ADR": "AVAL",
  "그루포에어로멕시코ADR": "AERO",
  "그루포에어로포르투아리오센트로노테ADR": "OMAB",
  "그루포에어로포르투아리오수레스테ADR": "ASR",
  "그루포텔레비사ADR": "TV",
  "그루포피난시에로갈리시아ADR": "GGAL",
  "그루폰": "GRPN",
  "그룹원오토모티브": "GPI",
  "그리니치라이프사이언스": "GLSI",
  "그리드다이나믹홀딩스": "GDYN",
  "그리폰": "GFF",
  "그리폴스ADR": "GRFS",
  "그리프ClassA": "GEF",
  "그린닷": "GDOT",
  "그린라이트캐피털리": "GLRE",
  "그린란드에너지": "GLND",
  "그린랜드마인스": "GRML",
  "그린랜드테크놀로지홀딩": "GTEC",
  "그린레인홀딩스": "GNLN",
  "그린브라이어": "GBX",
  "그린브릭파트너스": "GRBK",
  "그린서클탈탄소테크": "GCDT",
  "그린웨이브테크놀로지솔루션스": "GWAV",
  "그린카운티뱅코프": "GCBC",
  "그린트리호스피탈리티그룹ADR": "GHG",
  "그린파워모터컴퍼니": "GP",
  "그린파이어리소시스": "GFR",
  "그린프로캐피털": "GRNQ",
  "그린플레인스": "GPRE",
  "글라우코스": "GKOS",
  "글래드스톤랜드": "LAND",
  "글래드스톤랜드우선주SeriesC6.00%": "LANDP",
  "글래드스톤랜드우선주시리즈B6.00%": "LANDO",
  "글래드스톤인베스트먼트": "GAIN",
  "글래드스톤캐피털": "GLAD",
  "글래드스톤커머셜": "GOOD",
  "글래드스톤커머셜우선주시리즈E6.625%": "GOODN",
  "글래드스톤커머셜우선주시리즈G6.00%": "GOODO",
  "글래스하우스브랜즈": "GLAS",
  "글레이셔뱅코프": "GBCI",
  "글로바벤드홀딩스": "GVH",
  "글로바테라애퀴지션": "GTERA",
  "글로버스마리타임": "GLBS",
  "글로번트": "GLOB",
  "글로벌네트리스": "GNL",
  "글로벌모피AI": "GMM",
  "글로벌비지니스트래블그룹": "GBTG",
  "글로벌셀프스토리지": "SELF",
  "글로벌스타": "GSAT",
  "글로벌십리스": "GSL",
  "글로벌엔진그룹홀딩": "GLE",
  "글로벌워터리소스": "GWRS",
  "글로벌인더스트리얼": "GIC",
  "글로벌인뎀니티그룹": "GBLI",
  "글로벌인터랙티브테크놀로지스": "GITS",
  "글로벌파운드리": "GFS",
  "글로벌페이먼츠": "GPN",
  "글로부스메디컬": "GMED",
  "글로브라이프": "GL",
  "글루코트랙": "GCTK",
  "글루홀딩스": "GLOO",
  "글림스그룹": "GGRP",
  "기가미디어": "GIGM",
  "기가클라우드테크놀로지": "GCT",
  "기그캐피탈9": "GIX",
  "기프티파이": "GIFT",
  "긱캐피탈8": "GIW",
  "길라트새털라이트네트웍스": "GILT",
  "길리어드사이언시스": "GILD",
  "깃랩": "GTLB",
  "깅코바이오웍스홀딩스": "DNA",
  "나노-엑스이미징": "NNOX",
  "나노뉴클리어에너지": "NNE",
  "나노디멘션ADR": "NNDM",
  "나노랩스": "NA",
  "나노바이리사이드스": "NNVC",
  "나노바이오틱스ADR": "NBTX",
  "나뚜찌SpAADR": "NTZ",
  "나밉미네랄스": "NAMM",
  "나반": "NAVN",
  "나비엔트": "NAVI",
  "나비타스세미컨덕터": "NVTS",
  "나서스파마": "NSRX",
  "나스닥": "NDAQ",
  "나스테크놀로지ADR": "NAAS",
  "나약스": "NYAX",
  "나이소스": "NI",
  "나이스ADR": "NICE",
  "나이아젠바이오사이언스": "NAGE",
  "나이키": "NKE",
  "나이트-스위프트트랜스포테이션": "KNX",
  "나이트스코프": "KSCP",
  "나이프리버": "KNF",
  "나인에너지서비스": "NINE",
  "나카모토": "NAKA",
  "나코인더스트리스": "NC",
  "나테라": "NTRA",
  "내비게이터홀딩스": "NVGS",
  "내셔널그리드ADR": "NGG",
  "내셔널리테일프로퍼티즈": "NNN",
  "내셔널뱅크셰어즈": "NKSH",
  "내셔널뱅크홀딩스": "NBHC",
  "내셔널베버리지": "FIZZ",
  "내셔널비전홀딩스": "EYE",
  "내셔널시네미디어": "NCMI",
  "내셔널에너지서비스리유나이티드": "NESR",
  "내셔널퓨얼가스": "NFG",
  "내셔널프레스토인더스트리스": "NPK",
  "내셔널헬스인베스터스": "NHI",
  "내셔널헬스케어": "NHC",
  "내셔널헬스케어우선주SeriesA7.375%": "NHPAP",
  "내셔널헬스케어우선주SeriesB7.125%": "NHPBP",
  "내셔널헬스케어프로퍼티스": "NHP",
  "내추럴가스서비스그룹": "NGS",
  "내추럴그로서즈바이바이타민코티지": "NGVC",
  "내추럴얼터너티브인터내셔널": "NAII",
  "내추럴헬스트렌즈": "NHTC",
  "내트웨스트그룹ADR": "NWG",
  "냅코시큐리티테크놀로지스": "NSSC",
  "너드월렛": "NRDS",
  "너디": "NRDY",
  "너브젠파마": "NGEN",
  "네비우스그룹": "NBIS",
  "네오-콘셉트인터내셔널그룹홀딩스": "NCI",
  "네오노드": "NEON",
  "네오볼타": "NEOV",
  "네오스텔라캐피털": "NSLR",
  "네오지노믹스": "NEO",
  "네이보스인더스트리스": "NBR",
  "네이선스페이머스": "NATH",
  "네이처스선샤인프로덕츠": "NATR",
  "네트스카우트시스템즈": "NTCT",
  "네트워크-1테크놀로지스": "NTIP",
  "네프로스": "NEPH",
  "넥사리소스": "NEXA",
  "넥살린테크놀로지": "NXL",
  "넥세라테크놀로지스": "NEXR",
  "넥센티스테크놀로지스": "NXTS",
  "넥스메탈스마이닝": "NEXM",
  "넥스젠에너지": "NXE",
  "넥스젤": "NXGL",
  "넥스큐어": "NXTC",
  "넥스타미디어그룹": "NXST",
  "넥스트NRG": "NXXT",
  "넥스트데케이드": "NEXT",
  "넥스트도어홀딩스": "NXDR",
  "넥스트보트": "NXB",
  "넥스트에라에너지": "NEE",
  "넥스트테크놀로지홀딩": "NXTT",
  "넥스트트립": "NTRP",
  "넥스트파워": "NXT",
  "넥스트플랫": "NXPL",
  "넥스포인트다이버시파이드리얼에스테이트트러스트": "NXDT",
  "넥스포인트레지덴셜트러스트": "NXRT",
  "넥스포인트리얼에스테이트파이낸스": "NREF",
  "넥슨인터내셔널": "NEXN",
  "넥타테라퓨틱스": "NKTR",
  "넬넷": "NNI",
  "넵튠인슈어런스홀딩스": "NP",
  "넷기어": "NTGR",
  "넷리즈오피스프로퍼티스": "NLOP",
  "넷솔테크놀로지스": "NTWK",
  "넷스코프": "NTSK",
  "넷앱": "NTAP",
  "넷에스티리츠": "NTST",
  "넷이즈ADR": "NTES",
  "넷캐피탈": "NCPL",
  "넷클래스테크놀로지": "NTCL",
  "넷파워": "NPWR",
  "넷플릭스": "NFLX",
  "노던": "NCL",
  "노던다이너스티미네랄스": "NAK",
  "노던오일&가스": "NOG",
  "노던테크놀로지스인터내셔널": "NTIC",
  "노던트러스트": "NTRS",
  "노던트러스트우선주시리즈E4.7%": "NTRSO",
  "노드슨": "NDSN",
  "노르딕아메리칸탱커": "NAT",
  "노르웨이지안크루즈라인홀딩스": "NCLH",
  "노마다르": "NOMA",
  "노마드파워솔루션스": "NMAD",
  "노마드푸드": "NOMD",
  "노무라홀딩스ADR": "NMR",
  "노바골드리소시스": "NG",
  "노바메저링인스트루먼츠": "NVMI",
  "노바백스": "NVAX",
  "노바브리지바이오사이언스": "NBP",
  "노바티스ADR": "NVS",
  "노밴타": "NOVT",
  "노보노디스크ADR": "NVO",
  "노보닉스ADR": "NVX",
  "노보큐어": "NVCR",
  "노브": "NOV",
  "노블": "NE",
  "노세라": "NCRA",
  "노스롭그루만": "NOC",
  "노스림뱅코프": "NRIM",
  "노스아메리칸컨스트럭션그룹": "NOA",
  "노스웨스턴에너지그룹": "NWE",
  "노스웨스트내추럴홀딩": "NWN",
  "노스웨스트뱅크셰어스": "NWBI",
  "노스이스트뱅크": "NBN",
  "노스이스트커뮤니티뱅코프": "NECB",
  "노스포인트뱅크셰어스": "NPB",
  "노아홀딩스ADR": "NOAH",
  "노우드파이낸셜": "NWFL",
  "노키아ADR": "NOK",
  "노테크시스템즈": "NSYS",
  "노티커스로보틱스": "KITT",
  "노틸러스바이오테크놀러지": "NAUT",
  "노퍽서던": "NSC",
  "놀스": "KN",
  "누들스": "NDLS",
  "누릭스테라퓨틱스": "NRIX",
  "누베이션바이오": "NUVB",
  "누벡티스파마": "NVCT",
  "누보몽드그래파이트": "NMG",
  "누빈처칠다이렉트렌딩": "NCDL",
  "누사트립": "NUTR",
  "누카나ADR": "NCNA",
  "누홀딩스": "NU",
  "뉴락시스": "NRXS",
  "뉴로네틱스": "STIM",
  "뉴로센스테라퓨틱스": "NRSN",
  "뉴로원메디컬테크놀로지스": "NMTC",
  "뉴로진": "NGNE",
  "뉴로크린바이오사이언시스": "NBIX",
  "뉴로페이스": "NPCE",
  "뉴마운틴파이낸스": "NMFC",
  "뉴마켓": "NEU",
  "뉴마크그룹": "NMRK",
  "뉴모라테라퓨틱스": "NMRA",
  "뉴몬트": "NEM",
  "뉴버리스트리트II애퀴지션": "NTWO",
  "뉴브리지애퀴지션": "NBRG",
  "뉴센추리로지스틱스": "NCEW",
  "뉴셀X": "NCEL",
  "뉴스맥스": "NMAX",
  "뉴스케일파워": "SMR",
  "뉴스코퍼레이션ClassA": "NWSA",
  "뉴스코퍼레이션ClassB": "NWS",
  "뉴스킨엔터프라이즈": "NUS",
  "뉴아메리카애퀴지션": "NWAX",
  "뉴암스테르담파마컴퍼니": "NAMS",
  "뉴에그커머스": "NEGG",
  "뉴에라에너지&디지털": "NUAI",
  "뉴오리엔탈에듀케이션&테크놀로지ADR": "EDU",
  "뉴욕멜론은행": "BNY",
  "뉴욕시티리츠": "NYC",
  "뉴욕타임스": "NYT",
  "뉴웰리스": "NUWE",
  "뉴웰브랜즈": "NWL",
  "뉴잉글랜드리얼티어소시에이트DRC": "NEN",
  "뉴저지리소시스": "NJR",
  "뉴젠Ivf그룹": "NIVF",
  "뉴컨셉에너지": "GBR",
  "뉴코": "NUE",
  "뉴타닉스": "NTNX",
  "뉴턴골프": "NWTG",
  "뉴테크원우선주SeriesB": "NEWTP",
  "뉴텍비즈니스서비스": "NEWT",
  "뉴텍스헬스": "NUTX",
  "뉴트론홀딩스": "LIME",
  "뉴트리밴드": "NTRB",
  "뉴트리엔": "NTR",
  "뉴파운드골드": "NFGC",
  "뉴퍼시픽메탈스": "NEWP",
  "뉴포리아테라퓨틱스": "NEUP",
  "뉴포트리스에너지": "NFE",
  "뉴프로비던스애퀴지션III": "NPAC",
  "뉴호라이즌에어크래프트": "HOVR",
  "뉴홀드인베스트먼트III": "NHIC",
  "뉴홀드인베스트먼트IV": "NHIV",
  "니오ADR": "NIO",
  "니오젠": "NEOG",
  "니오코프디벨롭먼츠": "NB",
  "니온테크놀로지스홀딩스": "NTHI",
  "니콜라마이닝ADR": "NICM",
  "니콜렛뱅크셰어스": "NIC",
  "닉소아": "NYXH",
  "닉시": "NIXX",
  "다나": "DAN",
  "다나오스": "DAC",
  "다나허": "DHR",
  "다든레스토랑": "DRI",
  "다리오헬스": "DRIO",
  "다모라테라퓨틱스": "DMRA",
  "다비타": "DVA",
  "다우": "DOW",
  "다우치": "DCH",
  "다이나믹스": "DYNC",
  "다이나믹스III": "DNMX",
  "다이나트레이스": "DT",
  "다이넥스캐피털": "DX",
  "다이달로스스페셜애퀴지션": "DSAC",
  "다이렉트디지털홀딩스": "DRCT",
  "다이렉트부킹테크놀로지": "ZDAI",
  "다이버시파이드에너지": "DEC",
  "다이버시파이드헬스케어": "DHC",
  "다이볼드닉스도르프": "DBD",
  "다이아딕인터내셔널": "DYAI",
  "다이아메디카테라퓨틱스": "DMAC",
  "다이아몬드락하스피탈리티": "DRH",
  "다이아몬드백에너지": "FANG",
  "다이안서스테라퓨틱스": "DNTH",
  "다이애나쉬핑": "DSX",
  "다이오즈": "DIOD",
  "다이콤인더스트리스": "DY",
  "다인브랜드글로벌": "DIN",
  "다인테라퓨틱스": "DYN",
  "다임커머셜뱅크셰어스": "DCOM",
  "다초뉴에너지ADR": "DQ",
  "다케다파마슈티컬ADR": "TAK",
  "다코타골드": "DC",
  "다크아이리스": "DKI",
  "닥소": "DXR",
  "닥터레디스래보라토리스ADR": "RDY",
  "닥트로닉스": "DAKT",
  "달러제너럴": "DG",
  "달러트리": "DLTR",
  "달링인그리디언츠": "DAR",
  "더글라스다이내믹스": "PLOW",
  "더글라스엘리먼": "DOUG",
  "더글러스에밋": "DEI",
  "더나인ADR": "NCTY",
  "더마타테라퓨틱스": "DRMA",
  "더블다운인터랙티브ADR": "DDI",
  "더블베리파이홀딩스": "DV",
  "더심플리굿푸드": "SMPL",
  "더치브로스": "BROS",
  "덜루스홀딩스": "DLTH",
  "데니슨마인스": "DNN",
  "데번에너지": "DVN",
  "데스웰인더스트리": "DSWL",
  "데스티네이션XL그룹": "DXLG",
  "데어바이오사이언스": "DARE",
  "데이브": "DAVE",
  "데이브&버스터스엔터테인먼트": "PLAY",
  "데이타센트렉스": "DTCX",
  "데이터I/O": "DAIO",
  "데이터도그": "DDOG",
  "데이터메즈AI": "MEDS",
  "데이터볼트AI": "DVLT",
  "데이터스토리지": "DTST",
  "데이터씨인텔리전트테크": "DTSS",
  "데일리저널": "DJCO",
  "데카르트시스템즈그룹": "DSGX",
  "데피니움테라퓨틱스": "DFTX",
  "데피니티브헬스케어": "DH",
  "덱스컴": "DXCM",
  "덱커아웃도어": "DECK",
  "덴츠플라이시로나": "XRAY",
  "델렉유에스홀딩스": "DK",
  "델릭시홀딩스": "DLXY",
  "델몬트": "DMC",
  "델캐스시스템즈": "DCTH",
  "델타에어라인스": "DAL",
  "델테크놀로지": "DELL",
  "도그니스인터네셔널": "DOGZ",
  "도그우드테라퓨틱스": "DWTX",
  "도널드슨": "DCI",
  "도넬리파이낸셜솔루션스": "DFIN",
  "도니골그룹ClassA": "DGICA",
  "도니골그룹ClassB": "DGICB",
  "도리안LPG": "LPG",
  "도먼프로덕츠": "DORM",
  "도모": "DOMO",
  "도미나리홀딩스": "DOMH",
  "도미노피자": "DPZ",
  "도미니언에너지": "D",
  "도버": "DOV",
  "도세보": "DCBO",
  "도슨지오피지컬": "DWSN",
  "도어대시": "DASH",
  "도유인터내셔널홀딩스ADR": "DOYU",
  "도이치은행": "DB",
  "도쿄라이프스타일ADR": "TKLF",
  "도큐사인": "DOCU",
  "독고": "DCGO",
  "독시미티": "DOCS",
  "돌": "DOLE",
  "돌비래보라토리스": "DLB",
  "돌핀엔터테인먼트": "DLPN",
  "듀오링고": "DUOL",
  "듀오스테크놀로지그룹": "DUOT",
  "듀코먼": "DCO",
  "듀크로보틱스": "DUKR",
  "듀크에너지": "DUK",
  "듀폰": "DD",
  "드라간플라이": "DPRO",
  "드랍박스": "DBX",
  "드래곤플라이에너지홀딩스": "DFLI",
  "드래프트킹즈홀딩스": "DKNG",
  "드러그스메이드인아메리카애퀴지션": "DMAA",
  "드러그스메이드인아메리카애퀴지션II": "DMII",
  "드리븐브랜즈홀딩스": "DRVN",
  "드릴링툴스인터내셔널": "DTI",
  "드림랜드": "TDIC",
  "드림파인더스홈즈": "DFH",
  "디나우": "DNOW",
  "디날리테라퓨틱스": "DNLI",
  "디로컬": "DLO",
  "디마켓일렉트로시티ADR": "HEPS",
  "디보럴ARC애퀴지션I": "BCAR",
  "디서플린드그로스애퀴지션": "DGAC",
  "디센트홀딩": "DXST",
  "디스크메디슨": "IRON",
  "디스트리뷰션솔루션스그룹": "DSGR",
  "디아지오ADR": "DEO",
  "디어": "DE",
  "디웨이브퀀텀": "QBTS",
  "디자이너브랜즈": "DBI",
  "디자인테라퓨틱스": "DSGN",
  "디지넥스": "DGNX",
  "디지마크": "DMRC",
  "디지인터내셔널": "DGII",
  "디지털리얼티트러스트": "DLR",
  "디지털브랜즈그룹": "DBGI",
  "디지털브리지그룹": "DBRG",
  "디지털애셋애퀴지션": "DAAQ",
  "디지털오션홀딩스": "DOCN",
  "디지털커런시X테크놀로지": "DCX",
  "디지털터빈": "APPS",
  "디지파워X": "DGXX",
  "디파이디벨롭먼트": "DFDV",
  "디파이테크놀로지스": "DEFT",
  "딕스스포팅굿즈": "DKS",
  "딜라드캐피탈트러스트I": "DDT",
  "딜라즈": "DDS",
  "딜럭스": "DLX",
  "딥피션": "FISN",
  "딩동(케이먼)ADR": "DDL",
  "라니테라퓨틱스홀딩스": "RANI",
  "라드웨어": "RDWR",
  "라디안그룹": "RDN",
  "라디오팜테라노스틱스ADR": "RADX",
  "라로사홀딩스": "LRHC",
  "라르고": "LGO",
  "라리마테라퓨틱스": "LRMR",
  "라마애드버타이징": "LAMR",
  "라마코리소시스ClassA": "METC",
  "라마코리소시스ClassB": "METCB",
  "라스베이거스샌즈": "LVS",
  "라이더시스템": "R",
  "라이드그룹": "RYDE",
  "라이드나우그룹": "RDNW",
  "라이먼호스피탤리티프로퍼티스": "RHP",
  "라이브네이션엔터테인먼트": "LYV",
  "라이브램프홀딩스": "RAMP",
  "라이브벤처스": "LIVE",
  "라이브오크뱅크셰어스": "LOB",
  "라이브원": "LVO",
  "라이브퍼슨": "LPSN",
  "라이스애퀴지션3": "KRSP",
  "라이어슨홀딩": "RYZ",
  "라이언스페셜티홀딩스": "RYAN",
  "라이언에어홀딩스ADR": "RYAAY",
  "라이엇플랫폼즈": "RIOT",
  "라이엘이뮤노파마": "LYEL",
  "라이온그룹홀딩스ADR": "LGHL",
  "라이온델바젤인더스트리스": "LYB",
  "라이온스게이트스튜디오스": "LION",
  "라이온하트홀딩스": "CUB",
  "라이징드래곤애퀴지션": "RDAC",
  "라이터로그텍홀딩스": "RITR",
  "라이트브리지": "LTBR",
  "라이트스트래티지": "LITS",
  "라이트스피드커머스": "LSPD",
  "라이트웨이브로직": "LWLG",
  "라이트웨이브애퀴지션": "LWAC",
  "라이트인더박스홀딩ADR": "LITB",
  "라이트패스테크놀로지스": "LPTH",
  "라이프360": "LIF",
  "라이프라스ADR": "LFS",
  "라이프밴티지": "LFVN",
  "라이프스탠스헬스그룹": "LFST",
  "라이프엠디": "LFMD",
  "라이프엠디우선주시리즈A8.875%": "LFMDP",
  "라이프워드": "LFWD",
  "라이프웨이푸드": "LWAY",
  "라이프존메탈스": "LZM",
  "라이프코어바이오메디컬": "LFCR",
  "라이프타임그룹홀딩스": "LTH",
  "라이프타임브랜즈": "LCUT",
  "라인벡뱅코프": "RBKB",
  "라일리익스플로레이션퍼미안": "REPX",
  "라자드": "LAZ",
  "라탐그룹": "SWIM",
  "라탐에어라인스그룹ADR": "LTM",
  "라파엘홀딩스": "RFL",
  "라파예트디지털애퀴지션I": "ZKP",
  "라파예트애퀴지션": "LAFA",
  "라포르테라퓨틱스": "RAPP",
  "란자테크글로벌": "LNZA",
  "란팍홀딩스": "PACK",
  "랄프로렌": "RL",
  "랑방그룹홀딩스": "LANV",
  "래더캐피털": "LADR",
  "래드넷": "RDNT",
  "래드콤": "RDCM",
  "래티스세미컨덕터": "LSCC",
  "래피드7": "RPD",
  "래피드마이크로바이오시스템스": "RPID",
  "랙스페이스테크놀로지": "RXT",
  "랜드마크뱅코프": "LARK",
  "랜드브리지": "LB",
  "랜드스타시스템": "LSTR",
  "랜드캐피탈": "RAND",
  "랜즈엔드": "LE",
  "랜턴파마": "LTRN",
  "랜티우스홀딩스": "LNTH",
  "랠리바이오": "RLYB",
  "랠리언트": "RAL",
  "램리서치": "LRCX",
  "램버스": "RMBS",
  "램웨스턴홀딩스": "LW",
  "랩코프홀딩스": "LH",
  "랩테크놀로지스": "WRAP",
  "랭크원컴퓨팅": "ROC",
  "러브색": "LOVE",
  "러시스트리트인터랙티브": "RSI",
  "러시엔터프라이즈ClassA": "RUSHA",
  "러시엔터프라이즈ClassB": "RUSHB",
  "럭스익스피리언스ADR": "LUXE",
  "럭스퍼홀딩스": "LXFR",
  "럭키스트라이크엔터테인먼트": "LUCK",
  "런웨이그로스파이낸스": "RWAY",
  "런치원애퀴지션": "LPAA",
  "런치투애퀴지션": "LPBB",
  "런치패드카덴자애퀴지션I": "LPCV",
  "럼그룹": "RUM",
  "레가시에듀케이션": "LGCY",
  "레가시하우징": "LEGH",
  "레가토머저IV": "LEGO",
  "레겟&플랫": "LEG",
  "레나ClassA": "LEN",
  "레나투스택티컬애퀴지션I": "RTAC",
  "레노보Rx": "RNXT",
  "레녹스인터내셔널": "LII",
  "레드락리조트": "RRR",
  "레드로빈고메버거스": "RRGB",
  "레드리버뱅크셰어스": "RRBI",
  "레드바이올렛": "RDVT",
  "레드와이어": "RDW",
  "레드우드트러스트": "RWT",
  "레드캣홀딩스": "RCAT",
  "레드클라우드홀딩스": "RCT",
  "레드힐바이오파마ADR": "RDHL",
  "레디캐피털": "RC",
  "레딧": "RDDT",
  "레모네이드": "LMND",
  "레벨레이션바이오사이언시스": "REVB",
  "레볼루션메디신": "RVMD",
  "레비티": "RVTY",
  "레사카테크놀로지스": "LSAK",
  "레스메드": "RMD",
  "레스토랑브랜즈인터내셔널": "QSR",
  "레슬리즈": "LESL",
  "레신핀테크홀딩스ADR": "LX",
  "레어드슈퍼푸드": "LSF",
  "레어어스아메리카스": "REA",
  "레오나르도DRS": "DRS",
  "레오나바이오": "LONA",
  "레이놀드컨슈머프라덕츠": "REYN",
  "레이도스홀딩스": "LDOS",
  "레이디언트로지스틱스": "RLGT",
  "레이먼드제임스파이낸셜": "RJF",
  "레이브레스토랑그룹": "RAVE",
  "레이센에너지홀딩": "LSE",
  "레이어니어": "RYN",
  "레이오니어어드밴스드머티리얼": "RYAM",
  "레이저포토닉스": "LASE",
  "레이지보이": "LZB",
  "레이크랜드인더스트리스": "LAKE",
  "레이크랜드파이낸셜": "LKFN",
  "레이크쇼어뱅코프": "LSBK",
  "레이크쇼어애퀴지션III": "LCCC",
  "레이크슈페리얼애퀴지션": "LKSP",
  "레이크우드아메덱스바이오": "LABT",
  "레이크프론트바이오테라퓨틱스": "LKFT",
  "레이텍홀딩": "RAY",
  "레인인한스먼트테크놀로지스": "RAIN",
  "레인져에너지서비스": "RNGR",
  "레인지리소시스": "RRC",
  "레인지캐피탈애퀴지션": "RANG",
  "레인지캐피털애퀴지션II": "RNGT",
  "레인테라퓨틱스": "RNTX",
  "레일비전": "RVSN",
  "레저보아르미디어": "RSVR",
  "레전드바이오테크ADR": "LEGN",
  "레전스": "LGN",
  "레졸루트": "RZLT",
  "레졸루트홀딩스매니지먼트": "RHLD",
  "레지디오테크놀러지": "REZI",
  "레지스": "RGS",
  "레코시스템": "REKR",
  "레콘테크놀러지": "RCON",
  "레포지트랙": "TRAK",
  "레플리뮨그룹": "REPL",
  "레플리젠": "RGEN",
  "렉사리아바이오사이언스": "LEXX",
  "렉스아메리칸리소시즈": "REX",
  "렉스포드인더스트리얼리얼티": "REXR",
  "렉시오테라퓨틱스": "LXEO",
  "렉시콘파마슈티컬스": "LXRX",
  "렉티튜드홀딩스": "RECT",
  "렌딩트리": "TREE",
  "렌엑스엔터프라이즈": "RENX",
  "렌자": "LNSR",
  "렌즈테라퓨틱스": "LENZ",
  "렌토킬이니셜ADR": "RTO",
  "렌트더런웨이": "RENT",
  "렌트로닉": "LTRX",
  "렐러티비티애퀴지션": "BIOT",
  "렐마다테라퓨틱스": "RLMD",
  "렐엑스ADR": "RELX",
  "로그프로스타일": "LGPS",
  "로드젠": "RDZN",
  "로리어트에듀케이션": "LAUR",
  "로마그린파이낸스": "ROMA",
  "로마네그라콤파니아인더스트리얼ADR": "LOMA",
  "로만DBDR애퀴지션II": "DRDB",
  "로버트하프인터내셔널": "RHI",
  "로보.ai": "AIIO",
  "로보스트래티지": "BOT",
  "로보테크놀로지스": "LOBO",
  "로봇컨설팅ADR": "LAWR",
  "로블록스": "RBLX",
  "로빈에너지": "RBNE",
  "로빈후드": "HOOD",
  "로스스토어스": "ROST",
  "로얄골드": "RGLD",
  "로얄캐리비안크루즈": "RCL",
  "로어홀딩스": "LOAR",
  "로열뱅크오브캐나다": "RY",
  "로열티매니지먼트홀딩": "RMCO",
  "로열티파마": "RPRX",
  "로우스": "L",
  "로우스컴퍼니": "LOW",
  "로이반트사이언시스": "ROIV",
  "로이즈뱅킹그룹ADR": "LYG",
  "로저스": "ROG",
  "로저스커뮤니케이션스": "RCI",
  "로지스틱프로퍼티스오브디아메리카스": "LPA",
  "로지텍인터내셔널": "LOGI",
  "로커파이": "LCFY",
  "로컬바운티": "LOCL",
  "로켓랩": "RKLB",
  "로켓원": "RKTO",
  "로켓컴퍼니스": "RKT",
  "로켓파머슈티컬스": "RCKT",
  "로쿠": "ROKU",
  "로크웰오토메이션": "ROK",
  "로키마운틴초콜릿팩토리": "RMCF",
  "로키브랜즈": "RCKY",
  "로터스테크놀로지ADR": "LOT",
  "로퍼테크놀로지스": "ROP",
  "록웰메디컬": "RMTI",
  "록히드마틴": "LMT",
  "론디포": "LDI",
  "롤린스": "ROL",
  "롱에버론": "LGVN",
  "롱테이블그로스": "LTGR",
  "루나이바이오웍스": "LNAI",
  "루다테크놀로지그룹": "LUD",
  "루루스패션라운지홀딩스": "LVLU",
  "루먼트파이낸스트러스트": "LFT",
  "루멕사이미징홀딩스": "LMRI",
  "루멘텀홀딩스": "LITE",
  "루멘테크놀로지스": "LUMN",
  "루브릭": "RBRK",
  "루비코": "RUBI",
  "루시드그룹": "LCID",
  "루시드다이어그노스틱스": "LUCD",
  "루안윈에다이테크놀로지": "RYET",
  "루이지애나-퍼시픽": "LPX",
  "루카스GC": "LGCL",
  "루트": "ROOT",
  "루팍스홀딩ADR": "LU",
  "룰루레몬애슬레티카": "LULU",
  "룹인더스트리": "LOOP",
  "르네산트": "RNST",
  "르네상스리홀딩스": "RNR",
  "르메이트르배스큘러": "LMAT",
  "리/맥스홀딩스": "RMAX",
  "리간드파마슈티컬스": "LGND",
  "리갈벨로이트": "RBC",
  "리갈줌닷컴": "LZ",
  "리걸렉스노드": "RRX",
  "리게티컴퓨팅": "RGTI",
  "리겔파마슈티컬스": "RIGL",
  "리뉴에너지글로벌": "RNW",
  "리니지": "LINE",
  "리니지셀테라퓨틱스": "LCTX",
  "리드리얼에스테이트ADR": "LRE",
  "리듬": "RYM",
  "리듬애퀴지션": "RAC",
  "리듬캐피탈": "RITM",
  "리듬파머수티컬스": "RYTM",
  "리듬프로퍼티트러스트": "RPT",
  "리딩인터내셔널ClassA": "RDI",
  "리딩인터내셔널ClassB": "RDIB",
  "리모네이라": "LMNR",
  "리미나투스파마": "LIMN",
  "리미니스트리트": "RMNI",
  "리미틀리글로벌": "RELY",
  "리바노바": "LIVN",
  "리바이스트라우스": "LEVI",
  "리뱅인터내셔널": "LBGJ",
  "리버뷰뱅코프": "RVSB",
  "리버티글로벌ClassA": "LBTYA",
  "리버티글로벌ClassB": "LBTYB",
  "리버티글로벌ClassC": "LBTYK",
  "리버티디펜스홀딩스": "DETX",
  "리버티라이브SeriesC": "LLYVK",
  "리버티라이브홀딩스SeriesA": "LLYVA",
  "리버티라틴아메리카ClassA": "LILA",
  "리버티라틴아메리카ClassC": "LILAK",
  "리버티라틴아메리카우선주SeriesA9.0%": "LILAP",
  "리버티브로드밴드시리즈A": "LBRDA",
  "리버티브로드밴드시리즈C": "LBRDK",
  "리버티브로드밴드우선주시리즈A7.000%": "LBRDP",
  "리버티에너지": "LBRT",
  "리본애퀴지션": "RIBB",
  "리본커뮤니케이션": "RBBN",
  "리본커피": "REBN",
  "리볼브그룹": "RVLV",
  "리비안": "RIVN",
  "리사타테라퓨틱스": "LSTA",
  "리샹에듀케이션홀딩ADR": "LXEH",
  "리서치솔루션스": "RSSS",
  "리서치얼라이언스III": "RACC",
  "리서치얼라이언스IV": "RACD",
  "리서치프런티어스": "REFR",
  "리소스커넥션": "RGP",
  "리스키파이드": "RSKD",
  "리시아모터스": "LAD",
  "리안허소웰인터내셔널그룹": "LHSW",
  "리알파테크": "AIRE",
  "리어": "LEA",
  "리얼리얼": "REAL",
  "리얼메신저": "RMSG",
  "리얼브로커리지": "REAX",
  "리얼티인컴": "O",
  "리엔터프라이즈": "LEE",
  "리오토ADR": "LI",
  "리오틴토ADR": "RIO",
  "리인슈어런스그룹오브아메리카": "RGA",
  "리저널매니지먼트": "RM",
  "리전스파이낸셜": "RF",
  "리제네론파마슈티컬스": "REGN",
  "리젠셀바이오사이언스홀딩스": "RGC",
  "리젠시센터스": "REG",
  "리젠시센터스우선주SeriesA6.25%": "REGCP",
  "리젠시센터스우선주SeriesB5.875%": "REGCO",
  "리젠엑스바이오": "RGNX",
  "리젠티스바이오머티리얼즈": "RGNT",
  "리졸브AI": "RZLV",
  "리즈": "REED",
  "리지테크": "RDGT",
  "리처드슨일렉트로닉스": "RELL",
  "리첸인터내셔널": "LICN",
  "리치몬드뮤추얼뱅코포레이션": "RMBI",
  "리치브로스옥셔니어스": "RBA",
  "리치스파클홀딩스": "ANPA",
  "리치테크로보틱스": "RR",
  "리커젼파마슈티컬스": "RXRX",
  "리퀴디아": "LQDA",
  "리퀴디티서비스": "LQDT",
  "리크테크인터내셔널": "LIQT",
  "리토에코-솔루션": "RETO",
  "리튬아르헨티나": "LAR",
  "리튬아메리카스": "LAC",
  "리트랙터블테크놀로지스": "RVP",
  "리틀휴즈": "LFUS",
  "리퍼블릭디지털애퀴지션": "RDAG",
  "리퍼블릭뱅코프": "RBCAA",
  "리퍼블릭서비스": "RSG",
  "리퍼블릭파워그룹": "RPGL",
  "리페이홀딩스": "RPAY",
  "리포메이션": "REF",
  "리포신": "LPCN",
  "리프트": "LYFT",
  "리프트오프모바일": "LFTO",
  "린드": "LIN",
  "린드블라드익스퍼디션스홀딩스": "LIND",
  "린지": "LNN",
  "릴라이언스": "RS",
  "릴라이언스글로벌그룹": "EZRA",
  "릴레이테라퓨틱스": "RLAY",
  "림바흐홀딩스": "LMB",
  "립프라그애퀴지션": "LFAC",
  "링센트럴": "RNG",
  "링에너지": "REI",
  "링커스인더스트리스": "LNKS",
  "링컨내셔널": "LNC",
  "링컨에듀케이셔널서비스": "LINC",
  "링컨인터내셔널": "LCLN",
  "링컨일렉트릭홀딩스": "LECO",
  "링크홈홀딩스": "LHAI",
  "링키지글로벌": "UZX",
  "마그나인터내셔널": "MGA",
  "마그네라": "MAGN",
  "마라바이라이프사이언시스홀딩스": "MRVI",
  "마라톤뱅코프": "MBBC",
  "마라홀딩스": "MARA",
  "마렉스UK홀딩스": "MRX",
  "마르제티": "MZTI",
  "마리스테크": "MTEK",
  "마린맥스": "HZO",
  "마마스크리에이션스": "MAMA",
  "마벨테크놀로지그룹": "MRVL",
  "마스": "MAAS",
  "마스터브랜드": "MBC",
  "마스터비프그룹": "MB",
  "마스터카드": "MA",
  "마스터크래프트보트홀딩스": "MCFT",
  "마스텍": "MTZ",
  "마시모그룹": "MAMO",
  "마우이랜드&파인애플": "MLP",
  "마운트로건캐피털": "MLCI",
  "마운틴레이크애퀴지션II": "MLAA",
  "마운틴크레스트애퀴지션6": "MCAH",
  "마이모": "MYO",
  "마이사이즈": "MYSZ",
  "마이아바이오테크놀로지": "MAIA",
  "마이애미인터내셔널홀딩스": "MIAX",
  "마이어스인더스트리스": "MYE",
  "마이지엄AI": "MYSE",
  "마이크로배스트홀딩스": "MVST",
  "마이크로봇메디컬": "MBOT",
  "마이크로비전": "MVIS",
  "마이크로소프트": "MSFT",
  "마이크로알고": "MLGO",
  "마이크로칩테크놀러지": "MCHP",
  "마이크로칩테크놀로지우선주SeriesA7.50%": "MCHPP",
  "마이크로클라우드홀로그램": "HOLO",
  "마이크로폴리스홀딩": "MCRP",
  "마이크론테크놀로지": "MU",
  "마이크웨어ADR": "MWC",
  "마이텍시스템즈": "MITK",
  "마인드.aiADR": "MYND",
  "마인드워크홀딩스": "HYFT",
  "마인드테크놀로지": "MIND",
  "마인드포지": "MF",
  "마일스톤사이언티픽": "MLSS",
  "마일스톤파머수티컬스": "MIST",
  "마자르뱅코프": "MGYR",
  "마첵스": "MCHX",
  "마커스": "MCS",
  "마커테라퓨틱스": "MRKR",
  "마케타": "MQ",
  "마켈": "MKL",
  "마켓액세스홀딩스": "MKTX",
  "마켓와이즈": "MKTW",
  "마코마이닝": "MAKO",
  "마타도리소시스": "MTDR",
  "마테리언": "MTRN",
  "마텐트랜스포트": "MRTN",
  "마텔": "MAT",
  "마티나스바이오팜홀딩스": "MTNB",
  "마티브홀딩스": "MATV",
  "마틴마리에타머터리얼스": "MLM",
  "막시무스": "MMS",
  "말리부보츠": "MBUU",
  "말윈홀딩스": "MWYN",
  "망고슈티컬스": "MGRX",
  "매그나이트": "MGNI",
  "매그나칩세미컨덕터": "MX",
  "매그넘아이스크림컴퍼니": "MICC",
  "매그놀리아오일&가스": "MGY",
  "매그니튜드인터내셔널": "MAGH",
  "매나테크": "MTEX",
  "매뉴라이프파이낸셜": "MFC",
  "매니토웍컴퍼니": "MTW",
  "매드리갈파마슈티컬스": "MDGL",
  "매디슨스퀘어가든스포츠": "MSGS",
  "매디슨스퀘어가든엔터테인먼트": "MSGE",
  "매디슨에어솔루션스": "MAIR",
  "매러선페트롤리엄": "MPC",
  "매머드에너지서비스": "TUSK",
  "매스코": "MAS",
  "매직엠파이어글로벌": "MEGL",
  "매치그룹": "MTCH",
  "매케슨": "MCK",
  "매크로제닉스": "MGNX",
  "매튜스인터내셔널": "MATW",
  "매트릭스서비스": "MTRX",
  "매트슨": "MATX",
  "맥그래스렌트코프": "MGRC",
  "맥그로힐": "MH",
  "맥도날드": "MCD",
  "맥스리니어": "MXL",
  "맥스메이킹": "MAMK",
  "맥스사이트": "MXCT",
  "맥이웬": "MUX",
  "맥켄지리얼티캐피털": "MKZR",
  "맥코믹앤컴퍼니무의결권주": "MKC",
  "맥킨리애퀴지션": "MKLY",
  "맨체스터유나이티드": "MANU",
  "맨카인드": "MNKD",
  "맨파워그룹": "MAN",
  "맨해튼브리지캐피털": "LOAN",
  "맨해튼어소시에이츠": "MANH",
  "맵라이트테라퓨틱스": "MPLT",
  "머니히로": "MNY",
  "머서인터내셔널": "MERC",
  "머스탱바이오": "MBIO",
  "머천트뱅코프": "MBIN",
  "머천트뱅코프우선주8.25%": "MBINM",
  "머천트뱅코프우선주SeriesE7.25%": "MBINL",
  "머천트뱅코프우선주시리즈C6%": "MBINN",
  "머컨틸은행": "MBWM",
  "머큐리시스템즈": "MRCY",
  "머큐리제너럴": "MCY",
  "머크앤코": "MRK",
  "머티리얼라이즈ADR": "MTLS",
  "머피USA": "MUSA",
  "머피오일": "MUR",
  "먼로": "MNRO",
  "멀티센서AI홀딩스": "MSAI",
  "멀티웨이스홀딩스": "MWG",
  "메가매트릭스": "MPU",
  "메가포춘": "MGRT",
  "메간홀딩스": "MGN",
  "메달리스트다이버시파이드": "MDRR",
  "메달리언뱅크우선주SeriesG": "MBNKO",
  "메달리언파이낸셜": "MFIN",
  "메드라인": "MDLN",
  "메드테크애퀴지션": "TLSI",
  "메드트로닉": "MDT",
  "메드페이스홀딩스": "MEDP",
  "메디롬헬스케어테크놀로지스ADR": "MRM",
  "메디운드": "MDWD",
  "메디치노바": "MNOV",
  "메디컬프로퍼티즈트러스트": "MPT",
  "메디쿠스파마": "MDCX",
  "메디패스트": "MED",
  "메르카도리브레": "MELI",
  "메리골드컴퍼니스": "MGLD",
  "메리디안": "MRBK",
  "메리어트버케이션월드와이드": "VAC",
  "메리어트인터내셔널": "MAR",
  "메리트메디컬시스템즈": "MMSI",
  "메리티지홈즈": "MTH",
  "메사래보라토리스": "MLAB",
  "메사로열티트러스트": "MTR",
  "메사비트러스트": "MSB",
  "메소드일렉트로닉스": "MEI",
  "메쉬플로우애퀴지션": "MESH",
  "메스테크홀딩스": "MHH",
  "메이라지티엑스홀딩스": "MGTX",
  "메이빌엔지니어링": "MEC",
  "메이서리치": "MAC",
  "메이슨글로리": "MSGY",
  "메이시스": "M",
  "메이우드애퀴지션2": "MYX",
  "메이우테크놀로지": "WNW",
  "메이즈테라퓨틱스": "MAZE",
  "메이크마이트립": "MMYT",
  "메이페어골드": "MINE",
  "메이플베어": "CART",
  "메인스트리트뱅크셰어스": "MNSB",
  "메인스트리트뱅크셰어스우선주시리즈A7.50%": "MNSBP",
  "메인스트리트캐피털": "MAIN",
  "메조블라스트ADR": "MESO",
  "메종솔루션스": "MSS",
  "메카닉스뱅코프": "MCHB",
  "메타": "META",
  "메타넥스": "MEOH",
  "메타비아": "MTVA",
  "메타알파테크놀로지홀딩": "MATH",
  "메타지노미테라퓨틱스": "MGX",
  "메탈라로열티&스트리밍": "MTA",
  "메탈루스": "MTUS",
  "메탈스로열티컴퍼니": "TMCR",
  "메탈스애퀴지션II": "MTAL",
  "메트라이프": "MET",
  "메트로시티뱅크셰어즈": "MCBS",
  "메트로폴리탄뱅크홀딩스": "MCB",
  "메틀러톨레도인터내셔널": "MTD",
  "멕스코에너지": "MXC",
  "멜라르애퀴지션I": "MACI",
  "멜코리조트&엔터테인먼트ADR": "MLCO",
  "명등인터내셔널": "MTEN",
  "모간스탠리": "MS",
  "모간스탠리다이렉트렌딩펀드": "MSDL",
  "모나크카지노&리조트": "MCRI",
  "모노파테라퓨틱스": "MNPR",
  "모닝스타": "MORN",
  "모더나": "MRNA",
  "모듈러메디컬": "MODD",
  "모디브인더스트리얼": "MDV",
  "모멘터스": "MNTS",
  "모바도그룹": "MOV",
  "모바일인프라스트럭처": "BEEP",
  "모비아메디컬": "MOBI",
  "모빅스랩스": "MOBX",
  "모빌리티글로벌": "MBGL",
  "모빌아이글로벌": "MBLY",
  "모엘리스": "MC",
  "모자익스애퀴지션": "MZYX",
  "모터스포츠게임즈": "MSGM",
  "모터카파츠오브아메리카": "MPAA",
  "모토로라솔루션스": "MSI",
  "모호크인더스트리스": "MHK",
  "몬덜리즈인터내셔널": "MDLZ",
  "몬스터베버리지": "MNST",
  "몬탁리뉴어블스": "MNTK",
  "몬테로사테라퓨틱스": "GLUE",
  "몰레큘러파트너스ADR": "MOLN",
  "몰리나헬스케어": "MOH",
  "몰슨쿠어스베버리지ClassA": "TAP-A",
  "몰슨쿠어스베버리지ClassB": "TAP",
  "몰컬린바이오테크": "MBRX",
  "몽고DB": "MDB",
  "무디스": "MCO",
  "무라노글로벌인베스트먼츠": "MRNO",
  "무빙이미지테크놀로지스": "MITQ",
  "물렉사이언스": "MLEC",
  "뮤제로애퀴지션": "MUZE",
  "뮬러워터프로덕츠": "MWA",
  "뮬러인더스트리스": "MLI",
  "미나스부에나벤투라ADR": "BVN",
  "미네랄리스테라퓨틱스": "MLYS",
  "미네랄스테크놀로지스": "MTX",
  "미네르바뉴로사이언시스": "NERV",
  "미니메드그룹": "MMED",
  "미니소그룹홀딩ADR": "MNSO",
  "미데라푸드프로세싱": "MFP",
  "미드랜드스테이츠뱅코프": "MSBI",
  "미드랜드스테이츠뱅코프우선주시리즈A": "MSBIP",
  "미드아메리카아파트커뮤니티": "MAA",
  "미드캡파이낸셜인베스트먼트": "MFIC",
  "미드펜뱅코프": "MPB",
  "미들비": "MIDD",
  "미디아코홀딩": "MDIA",
  "미디어알파": "MAX",
  "미라파마슈티컬스": "MIRA",
  "미럼파마슈티컬스": "MIRM",
  "미리아드제네틱스": "MYGN",
  "미리온테크놀로지스": "MIR",
  "미메드엑스그룹": "MDXG",
  "미션프로듀스": "AVO",
  "미스트라스그룹": "MG",
  "미쓰비시UFJ파이낸셜그룹ADR": "MUFG",
  "미즈호파이낸셜그룹ADR": "MFG",
  "민트": "MIMI",
  "밀러놀": "MLKN",
  "밀러인더스트리스": "MLR",
  "밀레니엄그룹인터내셔널홀딩스": "MGIH",
  "밀로즈프로퍼티스": "MRP",
  "밀루나애퀴지션": "MMTX",
  "밀리콤인터내셔널셀룰러": "TIGO",
  "밍싱그룹홀딩스": "PMA",
  "밍크테라퓨틱스": "INKT",
  "바렉스이미징": "VREX",
  "바렛비지니스서비스": "BBSI",
  "바로니스시스템즈": "VRNS",
  "바릭마이닝": "B",
  "바린투스바이오테라퓨틱스ADR": "BRNS",
  "바브애퀴지션": "BHAV",
  "바셋퍼니처인더스트리스": "BSET",
  "바슈롬": "BLCO",
  "바슈헬스컴퍼니스": "BHC",
  "바오셩미디어그룹홀딩스": "BAOS",
  "바오준ADR": "BZUN",
  "바운드리스바이오": "BOLD",
  "바이두ADR": "BIDU",
  "바이라인뱅코프": "BY",
  "바이랙스바이오랩스그룹": "VRAX",
  "바이시클테라퓨틱스ADR": "BCYC",
  "바이안트테크놀로지": "DSP",
  "바이야인터내셔널그룹": "BIYA",
  "바이오-테크네": "TECH",
  "바이오MX": "PHGE",
  "바이오X셀테라퓨틱스": "BTAI",
  "바이오그린메드솔루션": "BGMS",
  "바이오나노지노믹스": "BNGO",
  "바이오넥서스진랩": "BGLC",
  "바이오데식스": "BDSX",
  "바이오덱사파마슈티컬스ADR": "BDRX",
  "바이오라이프솔루션스": "BLFS",
  "바이오라인RXADR": "BLRX",
  "바이오래드래보라토리스ClassA": "BIO",
  "바이오리스토러티브테라피스": "BRTX",
  "바이오마린파마슈티컬": "BMRN",
  "바이오메리카": "BMRA",
  "바이오미아퓨전": "BMEA",
  "바이오벤투스": "BVS",
  "바이오비": "BIVI",
  "바이오아틀라": "BCAB",
  "바이오어피니티테크놀로지스": "BIAF",
  "바이오에이지랩스": "BIOA",
  "바이오엔테크ADR": "BNTX",
  "바이오젠": "BIIB",
  "바이오카디아": "BCDA",
  "바이오케레스크랍솔루션즈": "BIOX",
  "바이오크리스트파마슈티컬스": "BCRX",
  "바이오키인터내셔널": "BKYI",
  "바이오티": "BTMD",
  "바이오프론테라": "BFRI",
  "바이오하베스트사이언스": "BHST",
  "바이오헤이븐": "BHVN",
  "바이옴홀딩스": "HIND",
  "바이카라테라퓨틱스": "BCAX",
  "바이코어파마홀딩ADR": "VCRE",
  "바이킹애퀴지션I": "VACI",
  "바이킹애퀴지션II": "VII",
  "바이킹테라퓨틱스": "VKTX",
  "바이킹홀딩스": "VIK",
  "바이탈팜스": "VITL",
  "바이퍼에너지": "VNOM",
  "바인힐캐피탈인베스트먼트II": "VHCP",
  "바젤메디컬그룹": "BMGL",
  "바크": "BARK",
  "바클레이즈ADR": "BCS",
  "바탈리온오일": "BATL",
  "바프레시푸드그룹": "BRFH",
  "바하버뱅크셰어스": "BHB",
  "박스": "BOX",
  "박스라잇": "BOXL",
  "박스터인터내셔널": "BAX",
  "반다파마슈티컬스": "VNDA",
  "반스앤노블에듀케이션": "BNED",
  "반웰인더스트리스": "BRN",
  "발네바ADR": "VALN",
  "발라드파워시스템즈": "BLDP",
  "발레ADR": "VALE",
  "발레로에너지": "VLO",
  "발렌스세미컨덕터": "VLN",
  "발리스": "BALY",
  "발켐": "BCPC",
  "발코에너지": "EGY",
  "밥스디스카운트퍼니처": "BOBS",
  "밥콕앤윌콕스엔터프라이스": "BW",
  "방코데칠레ADR": "BCH",
  "방코마크로ADR": "BMA",
  "방코빌바오비스카야아르헨타리아ADR": "BBVA",
  "방코산탄데르ADR": "SAN",
  "방코산탄데르칠레ADR": "BSAC",
  "방쿠브라데스쿠우선주ADR": "BBD",
  "방쿠산탄데르브라질ADR": "BSBR",
  "배너": "BANR",
  "배스앤바디웍스": "BBWI",
  "배이텍스에너지": "BTE",
  "배인캐피털스페셜티파이낸스": "BCSF",
  "배저미터": "BMI",
  "백블레이즈": "BLZE",
  "백사이트": "PCVX",
  "백트": "BKKT",
  "밴드위스": "BAND",
  "밴티지": "VNTG",
  "밸라리스": "VAL",
  "밸류라인": "VALU",
  "밸리내셔널뱅코프": "VLY",
  "밸리내셔널뱅코프우선주SeriesC8.250%": "VLYPN",
  "밸리내셔널뱅코프우선주시리즈A": "VLYPP",
  "밸리내셔널뱅코프우선주시리즈B": "VLYPO",
  "밸몬트인더스트리스": "VMI",
  "밸보라인": "VVV",
  "밸히": "VHI",
  "뱅코BBVA아르헨티나ADR": "BBAR",
  "뱅코프": "TBBK",
  "뱅크7": "BSVN",
  "뱅크오브NT버터필드&선": "NTB",
  "뱅크오브노바스코샤": "BNS",
  "뱅크오브더제임스파이낸셜": "BOTJ",
  "뱅크오브마린뱅코프": "BMRC",
  "뱅크오브몬트리올": "BMO",
  "뱅크오브아메리카": "BAC",
  "뱅크오브아메리카우선주시리즈5": "BML-P-G",
  "뱅크오브프린스턴": "BPRN",
  "뱅크오브하와이": "BOH",
  "뱅크오즈크": "OZK",
  "뱅크웰파이낸셜그룹": "BWFG",
  "뱅크유나이티드": "BKU",
  "뱅크퍼스트": "BANF",
  "버나테크놀로지스": "BYRN",
  "버널캐피탈애퀴지션": "VECA",
  "버넷X홀딩": "VHC",
  "버닝락바이오테크ADR": "BNR",
  "버라이존": "VZ",
  "버밀리온에너지": "VET",
  "버바이오테크놀로지": "VIR",
  "버사멧로열티스": "VMET",
  "버사뱅크": "VBNK",
  "버산트미디어그룹": "VSNT",
  "버서스시스템즈": "VS",
  "버시전트": "VGNT",
  "버즈피드": "BZFD",
  "버지니아내셔널뱅크셰어": "VABK",
  "버진갤럭틱홀딩스": "SPCE",
  "버치테크": "BCHT",
  "버컨스톡홀딩": "BIRK",
  "버코매뉴팩처링": "VIRC",
  "버크&허버트파이낸셜서비스": "BHRB",
  "버크스그룹": "BGI",
  "버클": "BKE",
  "버터플라이네트워크": "BFLY",
  "버테크애퀴지션II": "BRKH",
  "버텍스": "VERX",
  "버텍스파마슈티컬": "VRTX",
  "버툭스홀딩스": "VTIX",
  "버튜파이낸셜": "VIRT",
  "버트라": "VTSI",
  "버티브홀딩스": "VRT",
  "버티컬에어로스페이스": "EVTL",
  "버포트캐피털": "BUR",
  "번지글로벌": "BG",
  "벌링턴스토어스": "BURL",
  "벌칸머티리얼스": "VMC",
  "벌칸인프라스트럭처앤파워": "VIP",
  "범블": "BMBL",
  "베네피션트": "BENF",
  "베누홀딩": "VENU",
  "베니텍바이오파마": "BNTC",
  "베드배스앤드비욘드": "BBBY",
  "베라더믹스": "MANE",
  "베라모빌리티": "VRRM",
  "베라브래들리": "VRA",
  "베라사이트": "VCYT",
  "베라스템": "VSTM",
  "베라테라퓨틱스": "VERA",
  "베락사바이오테크": "VRXA",
  "베랄토": "VLTO",
  "베루": "VERU",
  "베르데클린퓨얼스": "VGAS",
  "베르토애퀴지션": "TACO",
  "베르토애퀴지션II": "GUAC",
  "베리사인": "VRSN",
  "베리셀": "VCEL",
  "베리스크애널리틱스": "VRSK",
  "베리카파마슈티컬": "VRCA",
  "베리톤": "VERI",
  "베리파이미": "VRME",
  "베스타리얼에스테이트ADR": "VTMX",
  "베스트바이": "BBY",
  "베스트스팩I애퀴지션": "BSAA",
  "베스티스": "VSTS",
  "베어드메디컬인베스트먼트홀딩스": "BDMD",
  "베어링스BDC": "BBDC",
  "베온ADR": "VEON",
  "베이커휴즈": "BKR",
  "베이컴": "BCML",
  "베이퍼스트파이낸셜": "BAFN",
  "베인캐피털GSS인베스트먼트": "BCSS",
  "베일리조트": "MTN",
  "베타바이오닉스": "BBNX",
  "베타테크놀로지스": "BETA",
  "베터웨어데멕시코": "BWMX",
  "베터홈&파이낸스홀딩스": "BETR",
  "벡톤디킨슨앤코": "BDX",
  "벤돔애퀴지션I": "VNME",
  "벤딩스푼스": "BSP",
  "벤처글로벌": "VG",
  "벤치마크일렉트로닉스": "BHE",
  "벤타스": "VTR",
  "벤틀리시스템즈": "BSY",
  "벤허브글로벌": "VHUB",
  "벨던": "BDC",
  "벨로3D": "VELO",
  "벨로스애퀴지션I": "VLOS",
  "벨로시티파이낸셜": "VEL",
  "벨링브랜드": "BRBR",
  "벨퓨즈ClassA": "BELFA",
  "벨퓨즈ClassB": "BELFB",
  "보고타파이낸셜": "BSBK",
  "보그워너": "BWA",
  "보나도리얼티트러스트": "VNO",
  "보다폰그룹ADR": "VOD",
  "보레알리스푸드": "BRLS",
  "보르드릴링": "BORR",
  "보스턴비어": "SAM",
  "보스턴사이언티픽": "BSX",
  "보스톤오마하": "BOC",
  "보야파이낸셜": "VOYA",
  "보어바이오파마": "VOR",
  "보우만컨설팅그룹": "BWMN",
  "보우헤드스페셜티홀딩스": "BOW",
  "보이드게이밍": "BYD",
  "보이드그룹서비스": "BGSI",
  "보이시캐스케이드": "BCC",
  "보이저테라퓨틱스": "VYGR",
  "보이저테크놀로지스": "VOYG",
  "보잉": "BA",
  "복스로열티": "VOXR",
  "본내추럴라이프": "BON",
  "본바이올로직스": "BBLG",
  "본티어": "VNT",
  "볼": "BALL",
  "볼드윈인슈어런스그룹": "BWIN",
  "볼드이글애퀴지션": "BEAG",
  "볼라토그룹": "SOAR",
  "볼리션RX": "VNRX",
  "볼트바이오테라퓨틱스": "BOLT",
  "봉크": "BNKK",
  "부다주스": "BUDA",
  "부스트런": "BRUN",
  "부즈앨런해밀턴홀딩": "BAH",
  "부킹홀딩스": "BKNG",
  "부트반홀딩스": "BOOT",
  "불리쉬": "BLSH",
  "불프로그AI홀딩스": "BFRG",
  "뷰직스": "VUZI",
  "브라스켐ADR": "BAK",
  "브라운&브라운": "BRO",
  "브라이트마인즈바이오사이언시스": "DRUG",
  "브라이트뷰홀딩스": "BV",
  "브라이트스타로터리": "BRSL",
  "브라이트스파이어캐피탈": "BRSP",
  "브라이트스프링헬스서비스": "BTSG",
  "브라이트하우스파이낸셜": "BHF",
  "브라이트하우스파이낸셜우선주시리즈A6.6%": "BHFAP",
  "브라이트하우스파이낸셜우선주시리즈B6.75%": "BHFAO",
  "브라이트하우스파이낸셜우선주시리즈C5.375%": "BHFAN",
  "브라이트하우스파이낸셜우선주시리즈D4.625%": "BHFAM",
  "브라이트호라이즌패밀리솔루션": "BFAM",
  "브라질아그로ADR": "LND",
  "브라질포태시": "GRO",
  "브래그게이밍그룹": "BRAG",
  "브랜드인게이지먼트네트워크": "BNAI",
  "브랜디와인리얼티트러스트": "BDN",
  "브랜치아웃푸드": "BOF",
  "브런스윅": "BC",
  "브레드파이낸셜홀딩스": "BFH",
  "브레라홀딩스": "SLMT",
  "브레이마호텔&리조트": "BHR",
  "브레이브하트바이오": "BRVE",
  "브레이즈": "BRZE",
  "브레인": "BRAI",
  "브레인스웨이ADR": "BWAY",
  "브렌밀러에너지": "BNRG",
  "브로드리지파이낸셜솔루션스": "BR",
  "브로드스톤넷리스": "BNL",
  "브로드웨이파이낸셜": "BYFC",
  "브로드윈드에너지": "BWEN",
  "브로드컴": "AVGO",
  "브루커": "BRKR",
  "브루커우선주SeriesA6.375%": "BRKRP",
  "브룩데일시니어리빙": "BKD",
  "브룩필드": "BN",
  "브룩필드리뉴어블리뉴어블": "BEPC",
  "브룩필드비즈니스홀딩스": "BBUC",
  "브룩필드애셋매니지먼트": "BAM",
  "브룩필드웰스솔루션스": "BNT",
  "브룩필드인프라스트럭처": "BIPC",
  "브룸": "VRM",
  "브리스토우그룹": "VTOL",
  "브리스톨-마이어스스큅": "BMY",
  "브리아셀테라퓨틱스": "BCTX",
  "브리저에어로스페이스그룹홀딩스": "BAER",
  "브리즈애퀴지션II": "BREZ",
  "브리지포드푸즈": "BRID",
  "브리티쉬아메리칸토바코ADR": "BTI",
  "브릭스모어프로퍼티그룹": "BRX",
  "브릴리아": "BRIA",
  "브릴리언트어스그룹": "BRLT",
  "브릿지라인디지털": "BLIN",
  "브릿지바이오온콜로지테라퓨틱스": "BBOT",
  "브릿지바이오파머": "BBIO",
  "브릿지워터뱅크셰어스": "BWB",
  "브릿지워터뱅크셰어스우선주SeriesA5.875%": "BWBBP",
  "브링커인터내셔널": "EAT",
  "브링크스": "BCO",
  "브이넷그룹ADR": "VNET",
  "브이아이피숍홀딩스ADR": "VIPS",
  "브이투엑스(V2X)": "VVX",
  "블라덱스": "BLX",
  "블라이크로더애퀴지션II": "BBCQ",
  "블라이크뢰더애퀴지션III": "BCCQ",
  "블랙다이아몬드테라퓨틱스": "BDTX",
  "블랙라인": "BL",
  "블랙락커피바": "BRCB",
  "블랙록": "BLK",
  "블랙록TCP캐피털": "TCPC",
  "블랙베리": "BB",
  "블랙보드": "BLKB",
  "블랙스카이테크놀로지": "BKSY",
  "블랙스톤": "BX",
  "블랙스톤디지털인프라트러스트": "BXDC",
  "블랙스톤모기지트러스트": "BXMT",
  "블랙스톤시큐어드렌딩펀드": "BXSL",
  "블랙스페이드애퀴지션III": "BIII",
  "블랙타이탄": "BTTC",
  "블랙호크애퀴지션": "BKHA",
  "블랙힐스": "BKH",
  "블레이즈홀딩스": "BZAI",
  "블렌드랩스": "BLND",
  "블록": "XYZ",
  "블루골드": "BGL",
  "블루락홈즈트러스트": "BHM",
  "블루록애퀴지션": "BLRK",
  "블루리지뱅크셰어스": "BRBS",
  "블루링스홀딩스": "BXC",
  "블루마운트홀딩스": "BMHL",
  "블루문메탈스": "BMM",
  "블루미아홀딩스": "TULP",
  "블루민브랜즈": "BLMN",
  "블루버드": "BLBD",
  "블루아울캐피털": "OBDC",
  "블루아울테크놀로지파이낸스": "OTF",
  "블루애퀴지션": "BACC",
  "블루워터애퀴지션III": "BLUW",
  "블루워터애퀴지션IV": "BWIV",
  "블루제이다이어그노스틱스": "BJDX",
  "블루포트애퀴지션": "BPAC",
  "블룸에너지": "BE",
  "블링크차징": "BLNK",
  "비글라리홀딩스ClassB": "BH",
  "비긴블록체인": "BGIN",
  "비나캐피털그룹": "BCG",
  "비다글로벌": "VIDA",
  "비라이브홀딩스": "BLIV",
  "비라이트바이오ADR": "BLTE",
  "비라인홀딩스": "BLNE",
  "비르투스인베스트먼트파트너스": "VRTS",
  "비리디안테라퓨틱스": "VRDN",
  "비머이미징": "BMR",
  "비머젠에너지": "BESS",
  "비메드헬스케어": "VMD",
  "비바니메디컬": "VANI",
  "비바시스템즈": "VEEV",
  "비바코어": "VIVK",
  "비보스테라퓨틱스": "VVOS",
  "비보심랩스": "VIVS",
  "비보파워": "VIVO",
  "비비드싯츠": "SEAT",
  "비샤이인터테크놀로지": "VSH",
  "비샤이프리시전그룹": "VPG",
  "비스타골드": "VGZ",
  "비스타에너지": "VIST",
  "비스타젠테라퓨틱스": "VTGN",
  "비스탄스네트웍스": "VISN",
  "비스트라에너지": "VST",
  "비스티온": "VC",
  "비슬리브로드캐스트그룹": "BBGI",
  "비아": "VEEA",
  "비아비솔루션스": "VIAV",
  "비아샛": "VSAT",
  "비아트랜스포테이션": "VIA",
  "비아트리스": "VTRS",
  "비앤지푸즈": "BGS",
  "비오미테크놀러지ADR": "VIOT",
  "비욘드미트": "BYND",
  "비욘드스프링": "BYSI",
  "비욘드에어": "XAIR",
  "비원메디슨스ADR": "ONC",
  "비자": "V",
  "비저홈스USA": "BZH",
  "비전마린테크놀로지스": "VMAR",
  "비전시스AIADR": "VSA",
  "비전웨이브홀딩스": "VWAV",
  "비제이스레스토랑": "BJRI",
  "비즈니스퍼스트뱅크셰어스": "BFST",
  "비즐라실버": "VZLA",
  "비치바디컴퍼니": "BODI",
  "비치프로퍼티스": "VICI",
  "비코": "VICR",
  "비코인스트루먼츠": "VECO",
  "비콘파이낸셜": "BBT",
  "비타코코컴퍼니": "COCO",
  "비테스에너지": "VTS",
  "비트고홀딩스": "BTGO",
  "비트디지털": "BTBT",
  "비트마인이머전테크놀로지스": "BMNR",
  "비트마인이머전테크놀로지스우선주SeriesA9.5%": "BMNP",
  "비트오리진": "BTOG",
  "비트제로홀딩스": "AIBZ",
  "비트코인인프라스트럭처애퀴지션": "BIXI",
  "빅디지털에너지": "BGDE",
  "빅베어AI홀딩스": "BBAI",
  "빅스카이인더스트리얼": "BSIN",
  "빅토리아시크릿": "VSXY",
  "빅토리캐피털홀딩스": "VCTR",
  "빅트리클라우드홀딩스": "DSY",
  "빈스홀딩": "VNCE",
  "빈치컴퍼스인베스트먼츠": "VINP",
  "빈패스트오토": "VFS",
  "빌닷컴홀딩스": "BILL",
  "빌더스퍼스트소스": "BLDR",
  "빌드어베어워크숍": "BBW",
  "빌리빌리ADR": "BILI",
  "빌리언투원": "BLLN",
  "빌리지슈퍼마켓": "VLGEA",
  "빌리지팜스인터내셔널": "VFF",
  "빔글로벌": "BEEM",
  "빔테라퓨틱스": "BEAM",
  "빗디어테크놀로지스": "BTDR",
  "빗푸푸": "FUFU",
  "빙엑스ADR": "FLX",
  "사가커뮤니케이션스": "SGA",
  "사나라메드테크": "SMTI",
  "사나바이오테크놀로지": "SANA",
  "사노피ADR": "SNY",
  "사돗그룹": "SDOT",
  "사라토가인베스트먼트": "SAR",
  "사렙타테라퓨틱스": "SRPT",
  "사바라": "SVRA",
  "사브라헬스케어리츠": "SBRA",
  "사솔ADR": "SSL",
  "사우스랜드홀딩스": "SLND",
  "사우스보우": "SOBO",
  "사우스사이드뱅크셰어스": "SBSI",
  "사우스스테이트뱅크": "SSB",
  "사우스웨스트가스홀딩스": "SWX",
  "사우스웨스트에어라인스": "LUV",
  "사우스플레인파이낸셜": "SPFI",
  "사운드그룹ADR": "SOGP",
  "사운드파이낸셜뱅코프": "SFBC",
  "사운드포인트머리디어캐피털우선주SeiresA8%": "SPMA",
  "사운드포인트머리디언캐피털": "SPMC",
  "사운드포인트메리디언캐피털우선주SeriesB7.875%": "SPME",
  "사운드하운드AI": "SOUN",
  "사이넥시스": "SCYX",
  "사이먼프로퍼티그룹": "SPG",
  "사이브라": "CYAB",
  "사이빈": "HELP",
  "사이스파크": "SPRC",
  "사이아": "SAIA",
  "사이언스바이오메디컬": "PBM",
  "사이언스어플리케이션스인터내셔널": "SAIC",
  "사이언조이홀딩": "SJ",
  "사이언처홀딩스": "SCNX",
  "사이텍바이오사이언시스": "CTKB",
  "사이토소벤츠": "CTSO",
  "사이토키네틱스": "CYTK",
  "사이톰엑스테라퓨틱스": "CTMX",
  "사이트사이언시스": "SGHT",
  "사이트센터스": "SITC",
  "사이트원랜드스케이프서플라이": "SITE",
  "사이퍼펑크테크놀로지스": "CYPH",
  "사이프리스솔루션스": "SYPR",
  "사이피테크놀러지ADR": "SIFY",
  "사이히트": "SAIH",
  "사일런스테라퓨틱스ADR": "SLN",
  "사일렉스홀딩": "SCLX",
  "사일로파마": "SILO",
  "사텔로스바이오사이언스": "MSLE",
  "산미나": "SANM",
  "산타크루즈실버마이닝": "SCZM",
  "삼사라": "IOT",
  "새그텍글로벌": "SAGT",
  "새기멧바이오사이언시스": "SGMT",
  "새켐캐피털": "SACH",
  "샌고마테크놀로지스": "SANG",
  "샌드리지에너지": "SD",
  "샌디스크": "SNDK",
  "샌유웨이브헬스": "SNWV",
  "샐리뷰티홀딩스": "SBH",
  "샘파인크리에이션홀딩스그룹": "SFHG",
  "생풍디벨롭먼트": "SFWL",
  "샤론AI홀딩스": "SHAZ",
  "샤오-아이ADR": "AIXI",
  "샤오펑ADR": "XPEV",
  "샤크닌자": "SN",
  "샤프링크": "SBET",
  "샷스포터": "SSTI",
  "샹송인터내셔널홀딩": "CHSN",
  "섀턱랩": "STTK",
  "서던": "SO",
  "서던미주리뱅코프": "SMBC",
  "서던코퍼": "SCCO",
  "서던퍼스트뱅크셰어스": "SFST",
  "서로젠": "SRZN",
  "서밋미드스트림": "SMC",
  "서밋스테이트뱅크": "SSBI",
  "서밋호텔프로퍼티스": "INN",
  "서브로보틱스": "SERV",
  "서비스나우": "NOW",
  "서비스코퍼레이션인터내셔널": "SCI",
  "서비스타이탄": "TTAN",
  "서비스퍼스트뱅크셰어스": "SFBS",
  "서비스프로퍼티스트러스트": "SVC",
  "서저리파트너스": "SGRY",
  "서지페이즈": "SURG",
  "서타라": "CERT",
  "서프에어모빌리티": "SRFM",
  "선내션에너지": "SUNE",
  "선라이즈리얼티트러스트": "SUNS",
  "선라이프파이낸셜": "SLF",
  "선랜드테크놀러지그룹ADR": "STG",
  "선런": "RUN",
  "선벨트렌탈스홀딩스": "SUNB",
  "선샤인바이오파마": "SBFM",
  "선샤인실버마이닝앤리파이닝": "SSMR",
  "선스톤호텔인베스터스": "SHO",
  "선카테크놀로지그룹": "SDA",
  "선커뮤니티즈": "SUI",
  "선코어에너지": "SU",
  "선코크에너지": "SXC",
  "선크리트": "RMIX",
  "선파워": "SPWR",
  "세네카푸즈ClassA": "SENEA",
  "세네카푸즈ClassB": "SENEB",
  "세노버스에너지": "CVE",
  "세라콘네트웍스": "CRNT",
  "세라프로그노스틱스": "SERA",
  "세러스": "CERS",
  "세레브라스시스템스": "CBRS",
  "세레스테라퓨틱스": "MCRB",
  "세렌스": "CRNC",
  "세르베러스사이버센티넬": "CISO",
  "세르베세리아스우니다스ADR": "CCU",
  "세르보메드": "CRVO",
  "세리나테라퓨틱스": "SER",
  "세리벨": "CBLL",
  "세리티지그로스프로퍼티스": "SRG",
  "세멘토스파카스마요ADR": "CPAC",
  "세미LEDS": "LEDS",
  "세바": "CEVA",
  "세븐힐즈리얼티트러스트": "SEVN",
  "세이버": "SABR",
  "세이버스밸류빌리지": "SVV",
  "세이버원2014ADR": "SVRE",
  "세이블오프쇼어": "SOC",
  "세이어벤처스애퀴지션II": "TVAI",
  "세이프가드애퀴지션": "SAC",
  "세이프벌커스": "SB",
  "세이프티인슈어런스그룹": "SAFT",
  "세이프프로그룹": "SPAI",
  "세이프홀드": "SAFE",
  "세인트조": "JOE",
  "세일즈포스": "CRM",
  "세일포인트": "SAIL",
  "세즐": "SEZL",
  "센미아오테크놀러지": "AIHS",
  "센사타테크놀로지스홀딩": "ST",
  "센서닉스홀딩스": "SENS",
  "센서스헬스케어": "SRTS",
  "센스타테크놀로지스": "SNT",
  "센시언트테크놀로지스": "SXT",
  "센추리알루미늄": "CENX",
  "센추리온애퀴지션": "ALF",
  "센추리카지노스": "CNTY",
  "센추리테라퓨틱스": "IPSC",
  "센추리홀딩스": "CTRI",
  "센츄리커뮤니티스": "CCS",
  "센코라": "COR",
  "센터스페이스": "CSR",
  "센터포인트에너지": "CNP",
  "센테라골드": "CGAU",
  "센트러스에너지": "LEU",
  "센트럴가든앤드펫": "CENT",
  "센트럴가든앤드펫ClassA": "CENTA",
  "센트럴밴컴퍼니": "CBC",
  "센트럴퍼시픽파이낸셜": "CPF",
  "센트럴푸에르토ADR": "CEPU",
  "센트럴플레인스뱅크셰어스": "CPBI",
  "센트로": "CENN",
  "센티넬원": "S",
  "센티바이오사이언시스": "SNTI",
  "센티지홀딩스": "SNTG",
  "센틴": "CNC",
  "셀덱스테라퓨틱스": "CLDX",
  "셀라니즈코퍼레이션": "CE",
  "셀라스라이프사이언스그룹": "SLS",
  "셀러리어스파머슈티컬스": "DCOY",
  "셀레브라이트": "CLBT",
  "셀레스티카": "CLS",
  "셀렉타바이오사이언시스": "CLRB",
  "셀렉트에너지서비스": "WTTR",
  "셀렉트코트": "SLQT",
  "셀렉티브인슈어런스그룹": "SIGI",
  "셀렉티브인슈어런스그룹우선주시리즈B4.6%": "SIGIP",
  "셀룰레리티": "CELU",
  "셀리안바이오테크": "HKPD",
  "셀사이": "CVM",
  "셀시어스홀딩스": "CELH",
  "셀큐이티": "CELC",
  "셈텍": "SMTC",
  "셈트렉스": "CETX",
  "셈프라에너지": "SRE",
  "셉테르나": "SEPN",
  "셔멍파이낸셜": "CHMG",
  "셔윈-윌리엄즈": "SHW",
  "셔터스톡": "SSTK",
  "셔틀파마슈티컬스": "SHPH",
  "셰넌도어텔레커뮤니케이션스": "SHEN",
  "셰니어에너지": "LNG",
  "셰브론": "CVX",
  "셰프스웨어하우스": "CHEF",
  "소노-테크": "SOTK",
  "소노그룹": "SSM",
  "소노마파머수티컬스": "SNOA",
  "소노스": "SONO",
  "소노코프로덕트": "SON",
  "소니그룹ADR": "SONY",
  "소니다시니어리빙": "SNDA",
  "소닉오토모티브": "SAH",
  "소렌애퀴지션": "SORN",
  "소버세이프": "SOBR",
  "소셜커머스파트너스": "SCPQ",
  "소시에다드퀴미카BADR": "SQM",
  "소어인더스트리스": "THO",
  "소영인터내셔널ADR": "SY",
  "소우굿": "SOWG",
  "소울파워애퀴지션": "SOUL",
  "소켓모바일": "SCKT",
  "소테라헬스": "SHC",
  "소파이테크놀로지스": "SOFI",
  "소피아제네틱스": "SOPH",
  "소후닷컴ADR": "SOHU",
  "솔라나": "HSDT",
  "솔라리스리소시스": "SLSR",
  "솔라리스에너지인프라스트럭처": "SEI",
  "솔라리우스캐피털애퀴지션": "SOCA",
  "솔라맥스테크놀로지": "SMXT",
  "솔라에지테크놀로지스": "SEDG",
  "솔레센스": "SLSN",
  "솔로윈홀딩스": "AXG",
  "솔루나홀딩스": "SLNH",
  "솔루나홀딩스우선주시리즈A9%": "SLNHP",
  "솔리드바이오사이언스": "SLDB",
  "솔리드파워": "SLDP",
  "솔리디온테크놀로지": "STI",
  "솔리제닉스": "SNGX",
  "솔리타리오리소시스": "XPL",
  "솔벤텀": "SOLV",
  "솔브에너지": "MWH",
  "솔센터스": "BFS",
  "솔스트래티지스": "STKE",
  "솔젤테크놀러지": "SLGL",
  "솜니그룹인터내셔널": "SGI",
  "쇼어뱅크셰어스": "SHBI",
  "쇼피파이": "SHOP",
  "숄더이노베이션스": "SI",
  "숄즈테크놀로지스그룹": "SHLS",
  "수자노ADR": "SUZ",
  "수자라이프": "SUJA",
  "수트로바이오파머": "STRO",
  "쉐이크쉑": "SHAK",
  "쉘ADR": "SHEL",
  "쉬프트4페이먼트": "FOUR",
  "쉰레이ADR": "XNET",
  "슈나이더내셔널": "SNDR",
  "슈레아애퀴지션그룹": "SAGU",
  "슈뢰딩거": "SDGR",
  "슈미드그룹": "SHMD",
  "슈스테이션그룹": "SHOE",
  "슈퍼XAI테크놀로지": "SUPX",
  "슈퍼누스파마슈티컬스": "SUPN",
  "슈퍼리그엔터프라이즈": "SLE",
  "슈퍼마이크로컴퓨터": "SMCI",
  "슈퍼마이크로컴퓨터우선주SeriesA": "SMCIP",
  "슈퍼컴": "SPCB",
  "슈퍼하이인터내셔널홀딩ADR": "HDL",
  "슈페리어유니폼그룹": "SGC",
  "스냅": "SNAP",
  "스냅-온": "SNA",
  "스네일": "SNAL",
  "스노우로스차일드애퀴지션": "ISNR",
  "스노우플레이크": "SNOW",
  "스레드업": "TDUP",
  "스마트렌트": "SMRT",
  "스마트로지스틱스글로벌": "SLGB",
  "스마트버드": "BIRD",
  "스마트샌드": "SND",
  "스마트스톱셀프스토리지REIT": "SMA",
  "스마트켐": "SMTK",
  "스마트파이낸셜": "SMBK",
  "스머핏웨스트락": "SW",
  "스미스&네퓨ADR": "SNN",
  "스미스&웨슨브랜드": "SWBI",
  "스미스-미드랜드": "SMID",
  "스미스더글러스홈스": "SDHC",
  "스미스마이크로소프트웨어": "SMSI",
  "스미스필드푸드": "SFD",
  "스미토모미쓰이파이낸셜그룹ADR": "SMFG",
  "스워머": "SWMR",
  "스워블홀딩스": "SWVL",
  "스윗그린": "SG",
  "스카이라인빌더스그룹홀딩": "KAZR",
  "스카이바이오사이언스": "SKYE",
  "스카이엑스플랫폼스": "SKYX",
  "스카이워드스페셜티인슈어런스그룹": "SKWD",
  "스카이웍스솔루션스": "SWKS",
  "스카이웨스트": "SKYW",
  "스카이쿼리": "SKYQ",
  "스카이하버그룹": "SKYH",
  "스칼러락홀딩": "SRRK",
  "스캔소스": "SCSC",
  "스컬리로열티": "SRL",
  "스케이지퓨처ADR": "SCAG",
  "스코츠미러클그로": "SMG",
  "스콜라스틱": "SCHL",
  "스콜피오탱커스": "STNG",
  "스크라이브테라퓨틱스": "SCTX",
  "스키나리소시스": "SKE",
  "스킨헬스시스템즈": "SKIN",
  "스킬소프트": "SKIL",
  "스킬풀크래프트맨에듀케이션테크놀로지": "EDTK",
  "스타더스트파워": "SDST",
  "스타링온콜로지": "STLN",
  "스타링크AI애퀴지션": "OTAI",
  "스타벅스": "SBUX",
  "스타벌크캐리어스": "SBLK",
  "스타서지컬": "STAA",
  "스타에퀴티홀딩스": "STRR",
  "스타에퀴티홀딩스우선주SeriesA10%": "STRRP",
  "스타우드프로퍼티트러스트": "STWD",
  "스타즈엔터테인먼트": "STRZ",
  "스타파이터스스페이스": "FJET",
  "스타패션컬처홀딩스": "STFS",
  "스타홀딩스": "STHO",
  "스탁": "STAK",
  "스탁야즈뱅코프": "SYBT",
  "스태그웰": "STGW",
  "스태그인더스트리얼": "STAG",
  "스태리씨애퀴지션": "SSEA",
  "스태빌리스솔루션스": "SLNG",
  "스탠다드뉴클리어": "STDN",
  "스탠다드리튬": "SLI",
  "스탠다드모터프로덕츠": "SMP",
  "스탠다드바이오툴즈": "LAB",
  "스탠다드에어로": "SARO",
  "스탠덱스인터내셔널": "SXI",
  "스탠리블랙&데커": "SWK",
  "스탠텍": "STN",
  "스털링인프라스트럭처": "STRL",
  "스텀루거앤컴퍼니": "RGR",
  "스텁허브홀딩스": "STUB",
  "스테레오택시스": "STXS",
  "스테리스": "STE",
  "스테바나토그룹": "STVN",
  "스테이블코인디벨롭먼트": "SDEV",
  "스테이블코인엑스": "USDE",
  "스테이크홀더푸즈ADR": "STKH",
  "스테이트스트리트": "STT",
  "스테판": "SCL",
  "스텔라V캐피탈": "SVCC",
  "스텔란티스": "STLA",
  "스텔러스캐피털인베스트먼트": "SCM",
  "스텔로직": "SATL",
  "스텔스가스": "GASS",
  "스템": "STEM",
  "스텝스톤그룹": "STEP",
  "스토넥스그룹": "SNEX",
  "스토케테라퓨틱스": "STOK",
  "스톤리지": "SRI",
  "스톤브릿지애퀴지션II": "APAC",
  "스톤코": "STNE",
  "스튜디오시티인터내셔널홀딩스ADR": "MSC",
  "스튜어트인포메이션서비스": "STC",
  "스트라이드": "LRN",
  "스트라이브": "ASST",
  "스트라이브우선주SeriesA": "SATA",
  "스트라이커": "SYK",
  "스트라타시스": "SSYS",
  "스트라타크리티컬메디컬": "SRTA",
  "스트라텍시큐리티": "STRT",
  "스트라투스프로퍼티스": "STRS",
  "스트란앤컴퍼니": "SWAG",
  "스트래티지": "MSTR",
  "스트래티지우선주SeriesA": "STRC",
  "스트래티지우선주SeriesA10.00%": "STRD",
  "스트래티지우선주SeriesA8.00%": "STRK",
  "스트래티직에듀케이션": "STRA",
  "스트럭처테라퓨틱스ADR": "GPCR",
  "스트럭처프로덕츠CortsTR페코에너지우선주8%": "KTH",
  "스트로베리필즈리츠": "STRW",
  "스트리멕스": "STEX",
  "스티븐매든": "SHOO",
  "스티치픽스": "SFIX",
  "스티펄파이낸셜": "SF",
  "스틸다이내믹스": "STLD",
  "스파르타쿠스애퀴지션II": "TMTS",
  "스파이글래스파마": "SGP",
  "스파이어": "SR",
  "스파이어글로벌": "SPIR",
  "스파이어테라퓨틱스": "SYRE",
  "스파크I애퀴지션": "SPKL",
  "스팩스피어애퀴지션": "SSAC",
  "스페로테라퓨틱스": "SPRO",
  "스페이스X": "SPCX",
  "스페이스애셋애퀴지션": "SAAQ",
  "스펙트럴AI": "MDAI",
  "스펙트럼브랜즈홀딩스": "SPB",
  "스포엔터": "SEGG",
  "스포츠레이더그룹": "SRAD",
  "스포츠맨스웨어하우스홀딩스": "SPWH",
  "스포티파이테크놀러지": "SPOT",
  "스폭홀딩스": "SPOK",
  "스프라우츠파머스마켓": "SFM",
  "스프라웃소셜": "SPT",
  "스프러스파워홀딩": "SPRU",
  "스프롯": "SII",
  "스프루스바이오사이언시스": "SPRB",
  "스프링밸리애퀴지션IV": "SVIV",
  "스프링뷰홀딩스": "SPHL",
  "스프링클러": "CXM",
  "스플래시베버리지그룹": "SBEV",
  "스피어3D": "ANY",
  "스피어엔터테인먼트": "SPHR",
  "슬라이드인슈어런스홀딩스": "SLDE",
  "시-본": "SIBN",
  "시가테크놀로지스": "SIGA",
  "시그넷주얼러스": "SIG",
  "시그마리튬": "SGML",
  "시나이이뮤노테라퓨틱스ADR": "SCNI",
  "시냅틱스": "SYNA",
  "시너지CHC": "SNYR",
  "시너지마리타임홀딩스": "SHIP",
  "시네마크홀딩스": "CNK",
  "시네버스": "CNVS",
  "시네스텍": "SNES",
  "시노백바이오테크": "SVA",
  "시놉시스": "SNPS",
  "시드릴": "SDRL",
  "시디애퀴지션": "SDHI",
  "시러스로직": "CRUS",
  "시리우스XM홀딩스": "SIRI",
  "시리우스포인트": "SPNT",
  "시멕스ADR": "CX",
  "시몬스퍼스트내셔널": "SFNC",
  "시뮬레이션스플러스": "SLP",
  "시밀러웹": "SMWB",
  "시바니스틸워터ADR": "SBSW",
  "시버트파이낸셜코퍼레이션": "SIEB",
  "시브리지골드": "SA",
  "시비스타뱅크셰어스": "CIVB",
  "시비오": "CVEO",
  "시스코": "SYY",
  "시스코시스템즈": "CSCO",
  "시스템원": "SST",
  "시어": "SEER",
  "시에라뱅코프": "BSRR",
  "시오나테라퓨틱스": "SION",
  "시저스엔터테인먼트": "CZR",
  "시저스톤": "CSTE",
  "시즐애퀴지션II": "SZZL",
  "시카고리벳&머신": "CVR",
  "시카고애틀란틱BDC": "LIEN",
  "시카고애틀랜틱리얼에스테이트파이낸스": "REFI",
  "시코마린홀딩스": "SMHI",
  "시코스트뱅킹코퍼레이션오브플로리다": "SBCF",
  "시퀀스커뮤니케이션즈ADR": "SQNS",
  "시큐리티내셔널파이낸셜": "SNFCA",
  "시트로테크": "CITR",
  "시티우스온콜로지": "CTOR",
  "시티우스파마슈티컬스": "CTXR",
  "시티즌스": "CIA",
  "시티즌스&노던": "CZNC",
  "시티즌스커뮤니티뱅코프": "CZWI",
  "시티즌스파이낸셜그룹": "CFG",
  "시티즌스파이낸셜서비시스": "CZFS",
  "시티트렌즈": "CTRN",
  "시티홀딩": "CHCO",
  "시포트테라퓨틱스": "SPTX",
  "식스플래그스엔터테인먼트": "FUN",
  "신다": "SIND",
  "신닥스파마슈티컬스": "SNDX",
  "신시내티파이낸셜": "CINF",
  "신젠": "CYN",
  "신타스": "CTAS",
  "신텍옵틱스홀딩스": "OPTX",
  "신한금융지주ADR": "SHG",
  "실간홀딩스": "SLGN",
  "실렉시온테라퓨틱스": "SLXN",
  "실리콘래보라토리스": "SLAB",
  "실리콘모션테크놀로지ADR": "SIMO",
  "실리콘밸리애퀴지션": "SVAQ",
  "실리콤": "SILC",
  "실링크스": "SYNX",
  "실바모": "SLVM",
  "실바코그룹": "SVCO",
  "실버박스IV": "SBXD",
  "실버박스V": "SBXE",
  "실버보우마이닝": "SBMT",
  "실버코프메탈스": "SVM",
  "실버크레스트애셋매니지먼트그룹": "SAMG",
  "실버페가수스애퀴지션": "SPEG",
  "실스크": "LAES",
  "심믹": "SHIM",
  "심보틱": "SYM",
  "심슨매뉴팩처링": "SSD",
  "심프레스": "CMPR",
  "심플": "SPPL",
  "싱귤러리티퓨처테크놀로지": "SGLY",
  "싱귤레이트": "CING",
  "싱크로니파이낸셜": "SYF",
  "싱클레어브로드캐스트그룹": "SBGI",
  "싸이더스스페이스": "SIDU",
  "싸이큐리온": "CYCU",
  "싸이클러리온테라퓨틱스": "CYCN",
  "싸이토메드테라퓨틱스": "GDTC",
  "써드코스트뱅크셰어스": "TCBX",
  "써모피셔사이언티픽": "TMO",
  "써클인터넷그룹": "CRCL",
  "쓰리디시스템즈": "DDD",
  "쓰리브홀딩스": "THRY",
  "쓰리엠(3M)": "MMM",
  "씨ADR": "SE",
  "씨게이트": "STX",
  "씨버스": "CBUS",
  "씨보드": "SEB",
  "씨비디엠디": "YCBD",
  "씨스퀘어": "CSQR",
  "씨스타메디컬홀딩": "ICU",
  "씨티그룹": "C",
  "씨포트엔터테인먼트그룹": "SEG",
  "아가페ATP": "ATPC",
  "아간": "AGX",
  "아겐스ADR": "ARGX",
  "아고라ADR": "API",
  "아고맙테라퓨틱스ADR": "AGMB",
  "아그로즈": "AGRZ",
  "아넥슨": "ANNX",
  "아니카테라퓨틱스": "ANIK",
  "아다마스트러스트": "ADAM",
  "아다마스트러스트우선주SeriesD8.00%": "ADAMN",
  "아다마스트러스트우선주SeriesE7.875%": "ADAMM",
  "아다마스트러스트우선주SeriesF6.875%": "ADAML",
  "아다마스트러스트우선주SeriesG7.000%": "ADAMZ",
  "아다지오메디컬홀딩스": "ADGM",
  "아다진ADR": "ADAG",
  "아던트헬스": "ARDT",
  "아데이아": "ADEA",
  "아데코아그로": "AGRO",
  "아델릭스": "ARDX",
  "아듀로클린테크놀로지스": "ADUR",
  "아듀스홈케어": "ADUS",
  "아드모어쉬핑": "ASC",
  "아들라이노르티에ADR": "ANL",
  "아라마크": "ARMK",
  "아레나그룹홀딩스": "AREN",
  "아레스매니지먼트": "ARES",
  "아레스캐피탈": "ARCC",
  "아레스커머셜리얼에스테이트": "ACRE",
  "아르고블록체인ADR": "ARBK",
  "아르다메탈패키징": "AMBP",
  "아르드바크테라퓨틱스": "AARD",
  "아르비나스": "ARVN",
  "아르셀로미탈ADR": "MT",
  "아르코": "ARKO",
  "아르코스도라도스홀딩스": "ARCO",
  "아르코페트롤리엄": "APC",
  "아르키메데스테크SPACIII": "ARCI",
  "아르키메데스테크SPAC파트너스II": "ATII",
  "아르킷퀀텀": "ARQQ",
  "아르테시안리소시스": "ARTNA",
  "아르텔로바이오사이언스": "ARTL",
  "아르하우스": "ARHS",
  "아를로테크놀러지": "ARLO",
  "아리스마이닝": "ARIS",
  "아리스타네트웍스": "ANET",
  "아마나트애퀴지션": "AMAN",
  "아마다애퀴지션2": "XRPN",
  "아마다애퀴지션III": "AACI",
  "아마린ADR": "AMRN",
  "아마존닷컴": "AMZN",
  "아마타파마슈티컬스": "ARMP",
  "아말가메이티드파이낸셜": "AMAL",
  "아머란트뱅코프": "AMTB",
  "아머레지던셜리츠": "ARR",
  "아머스포츠": "AS",
  "아메리서브파이낸셜": "ASRV",
  "아메리세이프": "AMSF",
  "아메리스뱅코프": "ABCB",
  "아메리스코": "AMRC",
  "아메리카모빌ADR시리즈L": "AMX",
  "아메리카스카-마트": "CRMT",
  "아메리칸골드앤실버": "USAS",
  "아메리칸드라이브애퀴지션": "ADAC",
  "아메리칸리소스": "AREC",
  "아메리칸리얼티인베스터스": "ARL",
  "아메리칸배터리테크놀로지": "ABAT",
  "아메리칸뱅가드": "AVD",
  "아메리칸비트코인": "ABTC",
  "아메리칸셰어드호스피털서비스": "AMS",
  "아메리칸수퍼컨덕터": "AMSC",
  "아메리칸스테이츠워터": "AWR",
  "아메리칸아웃도어브랜드": "AOUT",
  "아메리칸애셋츠트러스트": "AAT",
  "아메리칸에어라인스그룹": "AAL",
  "아메리칸워터웍스": "AWK",
  "아메리칸웰": "AMWL",
  "아메리칸이글아웃피터스": "AEO",
  "아메리칸익셉셔널리즘애퀴지션A": "AEXA",
  "아메리칸익스프레스": "AXP",
  "아메리칸인터내셔널그룹": "AIG",
  "아메리칸인테그리티인슈어런스그룹": "AII",
  "아메리칸일렉트릭파워컴퍼니": "AEP",
  "아메리칸코스탈인슈어런스": "ACIC",
  "아메리칸타워": "AMT",
  "아메리칸파이낸셜그룹": "AFG",
  "아메리칸퍼블릭에듀케이션": "APEI",
  "아메리칸헬스케어REIT": "AHR",
  "아메리칸홈스포렌트": "AMH",
  "아메리콜드리얼티트러스트": "COLD",
  "아메리프라이즈파이낸셜": "AMP",
  "아메텍": "AME",
  "아멘텀홀딩스": "AMTM",
  "아밀릭스파마슈티컬스": "AMLX",
  "아발로테라퓨틱스": "AVTX",
  "아발론베이커뮤니티": "AVB",
  "아발론홀딩스": "AWX",
  "아발린파마": "AVLN",
  "아버리얼티트러스트": "ABR",
  "아버터스바이오파마": "ABUS",
  "아베오나테라퓨틱스": "ABEO",
  "아브로보틱스": "ARBE",
  "아비노실버&골드마인스": "ASM",
  "아비백스ADR": "ABVX",
  "아비스타": "AVA",
  "아비아트네트웍스": "AVNW",
  "아비타메디컬": "RCEL",
  "아사나": "ASAN",
  "아서J갤러거앤코": "AJG",
  "아센드라헬스": "ACH",
  "아스테라랩스": "ALAB",
  "아스텍인더스트리스": "ASTE",
  "아스트라나헬스": "ASTH",
  "아스트라제네카": "AZN",
  "아스트로노바": "ALOT",
  "아스트로닉스": "ATRO",
  "아스펜에어로젤": "ASPN",
  "아스펜인슈어런스홀딩스우선주": "AHL-P-D",
  "아시아스트래티지": "SORA",
  "아시아퍼시픽와이어&케이블": "APWC",
  "아야골드앤실버": "AYA",
  "아에곤ADR": "AEG",
  "아에리스테크놀로지": "AERT",
  "아에바테크놀로지스": "AEVA",
  "아우나": "AUNA",
  "아우디아": "AUUD",
  "아우라미네랄스": "AUGO",
  "아우레우스그린웨이홀딩스": "PUSA",
  "아우렐리온": "AURE",
  "아우스터": "OUST",
  "아우어본드": "OBAI",
  "아웃도어홀딩": "POWW",
  "아웃도어홀딩우선주시리즈A8.75%": "POWWP",
  "아웃룩테라퓨틱스": "OTLK",
  "아웃셋메디컬": "OM",
  "아웃프론트미디어": "OUT",
  "아워루프": "HOUR",
  "아이다코프": "IDA",
  "아이다호스트래터직리소시스": "IDR",
  "아이다호코퍼": "COPR",
  "아이덱스": "IEX",
  "아이덱스래보라토리스": "IDXX",
  "아이덴티브": "INVE",
  "아이디야바이오사이언스": "IDYA",
  "아이디어애퀴지션": "IACO",
  "아이디얼파워": "IPWR",
  "아이라디메드": "IRMD",
  "아이레닉애퀴지션": "IACQ",
  "아이렌": "IREN",
  "아이리듬홀딩스": "IRTC",
  "아이리스애퀴지션II": "IRAB",
  "아이맥스": "IMAX",
  "아이바이오": "IBIO",
  "아이반호일렉트릭": "IE",
  "아이베다솔루션스": "IVDA",
  "아이벡스": "IBEX",
  "아이보타": "IBTA",
  "아이소에너지": "ISOU",
  "아이스큐어메디컬": "ICCM",
  "아이스페시멘": "ISPC",
  "아이언돔애퀴지션I": "IDAC",
  "아이언마운틴": "IRM",
  "아이언우드파마슈티컬스": "IRWD",
  "아이언호스애퀴지션스II": "IRHO",
  "아이엠골드": "IAG",
  "아이오니스파마슈티컬스": "IONS",
  "아이오니어ADR": "IONR",
  "아이오닉디지털": "IOND",
  "아이오쓰리": "IOTR",
  "아이온큐": "IONQ",
  "아이지아월드와이드": "IZEA",
  "아이치이ADR": "IQ",
  "아이코아홀딩스": "ICHR",
  "아이콘": "ICLR",
  "아이콘에너지": "ICON",
  "아이콘테라퓨틱스": "EIKN",
  "아이큐비아홀딩스": "IQV",
  "아이토닉홀딩스": "ITOC",
  "아이투바이오파마": "AYTU",
  "아이트론": "ITRI",
  "아이파워": "IPW",
  "아이포인트": "EYPT",
  "아이하트미디어": "IHRT",
  "아이휴먼ADR": "IH",
  "아인라이드ADR": "ENRD",
  "아제너스": "AGEN",
  "아젠타": "AZTA",
  "아줄ADR": "AZUL",
  "아지오AI홀딩스": "AZIO",
  "아지트라": "AZTR",
  "아처대니얼스미들랜드": "ADM",
  "아처에비에이션": "ACHR",
  "아츠웨이매뉴팩처링": "ARTW",
  "아치캐피탈그룹우선주시리즈G4.55%": "ACGLN",
  "아치캐피털그룹": "ACGL",
  "아치캐피털그룹우선주시리즈F5.45%": "ACGLO",
  "아카데미스포츠앤아웃도어스": "ASO",
  "아카디아리얼티트러스트": "AKR",
  "아카디아바이오사이언스": "RKDA",
  "아카디아파마슈티컬스": "ACAD",
  "아카디아헬스케어": "ACHC",
  "아카리테라퓨틱스ADR": "AKTX",
  "아카마이테크놀로지": "AKAM",
  "아카시아리서치": "ACTG",
  "아칸다": "AKAN",
  "아캐디언애셋매니지먼트": "AAMI",
  "아커티스바이오테라퓨틱스": "ARQT",
  "아케비아테라퓨틱스": "AKBA",
  "아코사": "ACA",
  "아쿠쉬네트홀딩스": "GOLF",
  "아쿠스바이오사이언스": "RCUS",
  "아쿠아메탈스": "AQMS",
  "아쿠아바운티테크놀로지스": "AQB",
  "아크": "ARQ",
  "아크레스토란츠": "ARKR",
  "아크록": "AROC",
  "아크베스트": "ARCB",
  "아크투루스테라퓨틱스홀딩스": "ARCT",
  "아타라바이오테라퓨틱스": "ATRA",
  "아타이버클리": "ATAI",
  "아테리스": "AIP",
  "아테리안": "ATER",
  "아테아파마슈티컬스": "AVIR",
  "아토메라": "ATOM",
  "아토비아테라퓨틱스": "ATTO",
  "아토사테라퓨틱스": "ATOS",
  "아트리움테라퓨틱스": "RNA",
  "아트리큐어": "ATRC",
  "아트무스필트레이션테크놀로지스": "ATMU",
  "아트테크놀로지애퀴지션": "ARTC",
  "아틀라스리튬": "ATLX",
  "아틀라스에너지솔루션스": "AESI",
  "아틀라스크리티컬미네랄스": "ATCX",
  "아틀라스클리어홀딩스": "ATCH",
  "아틀라시안": "TEAM",
  "아틀란타브레이브스홀딩스SeriesA": "BATRA",
  "아틀란타브레이브스홀딩스SeriesC": "BATRK",
  "아틀란티쿠스홀딩스": "ATLC",
  "아틀란티쿠스홀딩스우선주시리즈B7.625%": "ATLCP",
  "아틀란틱아메리칸": "AAME",
  "아틀란틱유니온뱅크셰어스": "AUB",
  "아티바바이오테라퓨틱스": "ARTV",
  "아티비온": "AORT",
  "아티어스II애퀴지션": "AACB",
  "아티잔파트너스애셋매니지먼트": "APAM",
  "아파트먼트인베스트먼트&매니지먼트": "AIV",
  "아포지엔터프라이스": "APOG",
  "아포지테라퓨틱스": "APGE",
  "아폴로글로벌매니지먼트": "APO",
  "아폴로믹스": "APLM",
  "아폴로커머셜리얼에스테이트파이낸스": "ARI",
  "아프레아테라퓨틱스": "APRE",
  "아프타그룹": "ATR",
  "아피메즈파마슈티컬스US": "APUS",
  "아피야": "AFYA",
  "악셀엔터테인먼트": "ACEL",
  "악소헬스그룹ADR": "AHG",
  "악실브랜즈": "AXIL",
  "악티늄파마슈티컬스": "ATNM",
  "안데르센그룹": "ANDG",
  "안드레티애퀴지션II": "POLE",
  "안비오바이오테크놀로지": "NNNN",
  "안탈파플랫폼홀딩": "ANTA",
  "안테리스테크놀로지스글로벌": "AVR",
  "안테릭스": "ATEX",
  "안텔로페엔터프라이즈홀딩스": "AEHL",
  "안호이저부시인베브ADR": "BUD",
  "알고리듬홀딩스": "RIME",
  "알고마스틸그룹": "ASTL",
  "알곤퀸파워&유틸리티": "AQN",
  "알다브라4리퀴디티오퍼튜니티": "ALOV",
  "알데이라테라퓨틱스": "ALDX",
  "알델파이낸셜II": "ALDF",
  "알라럼테크놀로지스ADR": "ALAR",
  "알라마바이오사이언스": "ALMR",
  "알라모그룹": "ALG",
  "알라우노스테라퓨틱스": "TCRT",
  "알람닷컴홀딩스": "ALRM",
  "알래스카에어그룹": "ALK",
  "알레그로마이크로시스템즈": "ALGM",
  "알렉산더스": "ALX",
  "알렉산드리아리얼에스테이트이쿼티": "ARE",
  "알렉터": "ALEC",
  "알로진테라퓨틱스": "ALLO",
  "알루미스": "ALMS",
  "알루사에너지애퀴지션II": "ALUB",
  "알리": "RLI",
  "알리바바그룹홀딩스ADR": "BABA",
  "알리안나": "ANNA",
  "알리코": "ALCO",
  "알몬티인더스트리스": "ALM",
  "알보테크": "ALVO",
  "알셋": "AEI",
  "알자멘드뉴로": "ALZN",
  "알카미테크놀로지": "ALKT",
  "알코아": "AA",
  "알콘": "ALC",
  "알타이큅먼트그룹": "ALTG",
  "알테리티테라퓨틱스ADR": "ATHE",
  "알토뉴로사이언스": "ANRO",
  "알토인그리디언츠": "ALTO",
  "알트리아그룹": "MO",
  "알티글로벌": "ALTI",
  "알티뮨": "ALT",
  "알티소스포트폴리오솔루션스": "ASPS",
  "알파메탈러지컬리소시스": "AMR",
  "알파모더스홀딩스": "AMOD",
  "알파벳ClassA": "GOOGL",
  "알파벳ClassC": "GOOG",
  "알파벳우선주6.25%SeriesA": "GOOGM",
  "알파벳우선주6.25%SeriesB": "GOOGN",
  "알파앤오메가세미콘덕터": "AOSL",
  "알파인인컴프로퍼티트러스트": "PINE",
  "알파컴퓨트": "ALP",
  "알파코그니토": "ACOG",
  "알파타우메디컬": "DRTS",
  "알파테크노바": "TKNO",
  "알파테크놀로지그룹": "ATGL",
  "알파텍홀딩스": "ATEC",
  "알파프로테크": "APT",
  "알펙스애퀴지션": "ALPX",
  "알프스그룹": "ALPS",
  "암독스": "DOX",
  "암라이즈": "AMRZ",
  "암로지홀딩": "BTOC",
  "암바렐라": "AMBA",
  "암베브ADR": "ABEV",
  "암스트롱월드인더스트리스": "AWI",
  "암젠": "AMGN",
  "암콘디스트리뷰팅": "DIT",
  "암테크시스템즈": "ASYS",
  "암퍼캡애퀴지션": "APMC",
  "암페놀": "APH",
  "암홀딩스ADR": "ARM",
  "압테라모터스": "SEV",
  "압티보테라퓨틱스": "APVO",
  "앙가미": "ANGH",
  "앙코어캐피털그룹": "ECPG",
  "애그니코이글마인스": "AEM",
  "애그리컬처&내추럴솔루션애퀴지션": "ANSC",
  "애그코": "AGCO",
  "애너벡스라이프사이언시스": "AVXL",
  "애널로그디바이시스": "ADI",
  "애널리캐피털매니지먼트": "NLY",
  "애노비스바이오": "ANVS",
  "애닉사바이오사이언시스": "ANIX",
  "애더홀딩스": "ATHR",
  "애드트랜홀딩스": "ADTN",
  "애든택스그룹": "ATXG",
  "애디언트": "ADNT",
  "애디얼파머수티컬": "ADIL",
  "애딕스테라퓨틱스ADR": "ADXN",
  "애로우마크파이낸셜": "BANX",
  "애로우일렉트로닉스": "ARW",
  "애로우파이낸셜": "AROW",
  "애로우헤드파마슈티컬스": "ARWR",
  "애머런": "AEE",
  "애버린캐피탈애퀴지션": "ACAA",
  "애버커스글로벌": "ABX",
  "애버크롬비&피치": "ANF",
  "애벌랜치트레저리": "AVAT",
  "애보니애퀴지션I": "AACO",
  "애보트래보라토리": "ABT",
  "애브비": "ABBV",
  "애브포인트": "AVPT",
  "애비드뱅크홀딩스": "AVBH",
  "애비디아뱅코프": "AVBC",
  "애비애나헬스케어홀딩스": "AVAH",
  "애비엔트": "AVNT",
  "애쉬랜드": "ASH",
  "애스트로테크": "ASTC",
  "애스파이어바이오파마": "ASBP",
  "애슬론메디컬": "AEMD",
  "애시포드호스피탤리티트러스트": "AHT",
  "애이콤": "ACM",
  "애즈-테크에너지": "ADSE",
  "애즈버리오토모티브그룹": "ABG",
  "애지오스파마슈티컬스": "AGIO",
  "애질런트테크놀로지스": "A",
  "애질론헬스": "AGL",
  "애코그룹홀딩스": "ACCL",
  "애코브랜즈": "ACCO",
  "애퀴티뱅크셰어스": "EQBK",
  "애큐레이": "ARAY",
  "애큐먼파마슈티컬스": "ABOS",
  "애크리본테라퓨틱스": "ACRV",
  "애크미유나이티드": "ACU",
  "애클라리온": "ACON",
  "애클래리스테라퓨틱스": "ACRS",
  "애트모스에너지": "ATO",
  "애퍼지애퀴지션": "AACP",
  "애퍼처": "APUR",
  "애플": "AAPL",
  "애플랙": "AFL",
  "애플호스피탤리티리츠": "APLE",
  "애피안": "APPN",
  "액섬테라퓨틱스": "AXSM",
  "액세스뉴스와이어": "ACCS",
  "액센추어": "ACN",
  "액셀리스테크놀로지스": "ACLS",
  "액소스파이낸셜": "AX",
  "액손엔터프라이스": "AXON",
  "액스컴퓨트": "AGPU",
  "액시스캐피털홀딩스": "AXS",
  "액시엄인텔리전스애퀴지션1": "AXIN",
  "액추에이트테라퓨틱스": "ACTU",
  "액티베이트에너지애퀴지션": "AEAQ",
  "액티스온콜로지": "AKTS",
  "앤더슨스": "ANDE",
  "앤지": "ANGI",
  "앤지오다이내믹스": "ANGO",
  "앤테로리소스": "AR",
  "앤테로미드스트림": "AM",
  "앤필드에너지": "AEC",
  "앨나일램파마슈티컬스": "ALNY",
  "앨라이드골드": "AAUC",
  "앨라이파이낸셜": "ALLY",
  "앨러루스파이낸셜": "ALRS",
  "앨럿": "ALLT",
  "앨루마": "ALMU",
  "앨리고스테라퓨틱스": "ALGS",
  "앨리슨트랜스미션홀딩스": "ALSN",
  "앨버니인터내셔널": "AIN",
  "앨버말": "ALB",
  "앨버트슨컴퍼니": "ACI",
  "앨커미스": "ALKS",
  "앰렙": "AXR",
  "앰버인터내셔널홀딩ADR": "AMBR",
  "앰보우에듀케이션홀딩스ADR": "AMBO",
  "앰비션스엔터프라이즈매니지먼트": "AHMA",
  "앰비크마이크로": "AMBQ",
  "앰코": "AMCR",
  "앰코테크놀로지": "AMKR",
  "앰퍼스타파마슈티컬스": "AMPH",
  "앰프리어스테크놀로지스": "AMPX",
  "앰프코피츠버그": "AP",
  "앰플리테크그룹": "AMPG",
  "앰플리튜드": "AMPL",
  "앰플리파이에너지": "AMPY",
  "앱러빈": "APP",
  "앱사이": "ABSI",
  "앱셀레라바이오로직스": "ABCL",
  "앱토럼그룹": "NIKI",
  "앱티브": "APTV",
  "앱폴리오": "APPF",
  "앳코어": "ATKR",
  "앵글로골드아샨티": "AU",
  "야누스인터내셔널그룹": "JBI",
  "야로우바이오사이언스": "YARW",
  "야트라온라인": "YTRA",
  "얄라그룹ADR": "YALA",
  "얏센홀딩ADR": "YSG",
  "어그리리얼티": "ADC",
  "어냅티스바이오": "ANAB",
  "어넥사테라퓨틱스": "ERNA",
  "어니스트컴퍼니": "HNST",
  "어댑트헬스": "AHCO",
  "어댑티브바이오테크놀러지": "ADPT",
  "어도비": "ADBE",
  "어드반스드플라워캐피털": "AFCG",
  "어드밴스드바이오메드": "ADVB",
  "어드밴스드에너지인더스트리스": "AEIS",
  "어드밴스오토파츠": "AAP",
  "어드밴스트드레이니지시스템즈": "WMS",
  "어드밴식스": "ASIX",
  "어드밴티지솔루션스": "ADV",
  "어라이번트바이오파마": "AVBP",
  "어라이브AI": "ARAI",
  "어레이디지털인프라스트럭처": "AD",
  "어레이테크놀로지스": "ARRY",
  "어매스브랜즈": "AMSS",
  "어메이즈홀딩스": "AMZE",
  "어반아웃피터스": "URBN",
  "어반에지프로퍼티스": "UE",
  "어반원ClassA": "UONE",
  "어반원ClassD": "UONEK",
  "어밴터": "AVTR",
  "어번내셔널뱅코프": "AUBN",
  "어번디아글로벌임팩트그룹": "AGIG",
  "어센트솔라테크놀로지스": "ASTI",
  "어센트인더스트리즈": "ACNT",
  "어센티지파마그룹인터내셔널ADR": "AAPG",
  "어셈블리바이오사이언시스": "ASMB",
  "어소시에이티드뱅크코프": "ASB",
  "어슈런트": "AIZ",
  "어슈어드개런티": "AGO",
  "어슈어소프트웨어": "ASUR",
  "어웨어": "AWRE",
  "어질리시스": "AGYS",
  "어치브라이프사이언스": "ACHV",
  "어퀴스티브테라퓨틱스": "AQST",
  "어큐어엑스파마슈티컬스": "ACXP",
  "어큐이티": "AYI",
  "어투어라이프스타일홀딩스ADR": "ATAT",
  "어펌홀딩스": "AFRM",
  "어플라이드디지털": "APLD",
  "어플라이드머티어리얼즈": "AMAT",
  "어플라이드에어로스페이스앤디펜스": "AADX",
  "어플라이드옵토일렉트로닉스": "AAOI",
  "어플라이드인더스트리얼테크놀로지": "AIT",
  "어필리에이티드매니저스그룹": "AMG",
  "언더아머ClassA": "UAA",
  "언더아머ClassC": "UA",
  "언유주얼머신스": "UMAC",
  "얼라러티테라퓨틱스": "ALLR",
  "얼라이언스런드리홀딩스": "ALH",
  "얼라이언스엔터테인먼트홀딩": "AENT",
  "얼라이언트": "ALNT",
  "얼라이언트에너지": "LNT",
  "얼라이트": "ALIT",
  "얼라인먼트헬스케어": "ALHC",
  "얼라인테크놀로지": "ALGN",
  "얼리전트트래블": "ALGT",
  "얼리지언": "ALLE",
  "업랜드소프트웨어": "UPLD",
  "업바운드그룹": "UPBD",
  "업스타트홀딩스": "UPST",
  "업스트림바이오": "UPB",
  "업워크": "UPWK",
  "업핀테크홀딩스ADR": "TIGR",
  "에난타파마슈티컬스": "ENTA",
  "에너거스": "WATT",
  "에너시스": "ENS",
  "에너자이저홀딩스": "ENR",
  "에너지리커버리": "ERII",
  "에너지볼트홀딩스": "NRGV",
  "에너지서비시스오브아메리카": "ESOA",
  "에너지스그룹": "ENGS",
  "에너지트랜지션스페셜오퍼튜니티스": "ETSS",
  "에너지포커스": "EFOI",
  "에너지퓨얼스": "UUUU",
  "에너팩툴그룹": "EPAC",
  "에너플렉스": "EFXT",
  "에넬칠레ADR": "ENIC",
  "에니ADR": "E",
  "에니그매티그": "EGG",
  "에니스": "EBF",
  "에더블가든": "EDBL",
  "에데사바이오테크": "EDSA",
  "에듀케이셔널디벨롭먼트": "EDUC",
  "에드워즈라이프사이언시스": "EW",
  "에디슨인터내셔널": "EIX",
  "에디타스메디신": "EDIT",
  "에라약파워솔루션그룹": "RAYA",
  "에로코퍼": "ERO",
  "에르메네질도제냐": "ZGN",
  "에머슨라디오": "MSN",
  "에머슨일렉트릭": "EMR",
  "에메라": "EMA",
  "에메티스": "AMTX",
  "에미스애퀴지션": "EMIS",
  "에바라이브": "GOAI",
  "에바종ADR": "EVAX",
  "에버브라이트디지털홀딩": "EDHL",
  "에버소스에너지": "ES",
  "에버스핀테크놀러지": "MRAM",
  "에버지": "EVRG",
  "에버커머스": "EVCM",
  "에버코어": "EVR",
  "에버쿼트": "EVER",
  "에버테크": "EVTC",
  "에버포스": "EFOR",
  "에버퓨어": "P",
  "에베레스트그룹": "EG",
  "에베루스컨스트럭션그룹": "ECG",
  "에보뮨": "EVMN",
  "에보젠": "EVGN",
  "에보텍ADR": "EVO",
  "에볼러스": "EOLS",
  "에볼런트헬스": "EVH",
  "에볼루션글로벌애퀴지션": "EVOX",
  "에볼루션메탈스&테크놀로지스": "EMAT",
  "에볼루션페트롤리엄": "EPM",
  "에비슈미트홀딩": "AEBI",
  "에섹스프로퍼티트러스트": "ESS",
  "에센셜유틸리티스": "WTRG",
  "에센셜프로퍼티리얼티": "EPRT",
  "에스오에스": "SOS",
  "에스칼라드": "ESCA",
  "에스코테크놀로지스": "ESE",
  "에스콰이어파이낸셜홀딩스": "ESQ",
  "에스타블리쉬먼트랩스홀딩스": "ESTA",
  "에스트렐라이뮤노파르마": "ESLA",
  "에스티로더": "EL",
  "에스페이MFG&일렉트로닉스": "ESP",
  "에어T": "AIRT",
  "에어T우선주8%": "AIRTP",
  "에어게인": "AIRG",
  "에어글로벌": "AIIR",
  "에어로바이런먼트": "AVAV",
  "에어비앤비": "ABNB",
  "에어세일": "ASLE",
  "에어스컬프테크놀로지스": "AIRS",
  "에어십AI홀딩스": "AISP",
  "에어인더스트리스그룹": "AIRI",
  "에어줄테크놀로지스": "AIRJ",
  "에어캡홀딩스": "AER",
  "에어프로덕츠앤케미컬스": "APD",
  "에이노스": "AIMD",
  "에이디셋바이오": "ACET",
  "에이메이헬스테크놀로지": "AFJK",
  "에이버리데니슨": "AVY",
  "에이브이넷": "AVT",
  "에이블뷰글로벌": "ABLV",
  "에이비스버짓그룹": "CAR",
  "에이비츠그룹": "ABTS",
  "에이스펙III애퀴지션": "ASPC",
  "에이아이": "LIDR",
  "에이에이온": "AAON",
  "에이온": "AON",
  "에이지이글에어리얼시스템": "UAVS",
  "에이커스커머셜리얼티": "ACR",
  "에이콘에너지": "ACFN",
  "에이타이르파르마": "ATYR",
  "에이토홀딩스": "ORBS",
  "에이티그리티스페셜티인슈어런스홀딩스": "ASIC",
  "에이펙스트레저리": "APXT",
  "에이픽스메디컬": "APYX",
  "에임스내셔널": "ATLO",
  "에임자이트": "AMST",
  "에젠시아커머셜스피리츠": "AGCC",
  "에지웰퍼스널케어": "EPC",
  "에코비스트": "ECVT",
  "에코스타": "ECHO",
  "에코웨이브파워글로벌AB(publ)ADR": "WAVE",
  "에코페트롤ADR": "EC",
  "에쿠스토탈리턴": "EQS",
  "에퀴노르ADR": "EQNR",
  "에퀴터블홀딩스": "EQH",
  "에퀴티라이프스타일프로퍼티스": "ELS",
  "에퀴티레지덴셜": "EQR",
  "에퀴팩스": "EFX",
  "에토스테크놀로지스": "LIFE",
  "에투알캐피털그룹": "EFTY",
  "에픽퀘스트에듀케이션그룹인터내셔널": "EEIQ",
  "에흐르테스트시스템즈": "AEHR",
  "엑사젠": "XGN",
  "엑셀러런트홀딩스": "ARX",
  "엑셀러레이트에너지": "EE",
  "엑셀론": "EXC",
  "엑셀리시스": "EXEL",
  "엑셀브랜즈": "XELB",
  "엑셀에너지": "XEL",
  "엑소더스무브먼트": "EXOD",
  "엑소스": "XOS",
  "엑소자임스": "EXOZ",
  "엑솔라스팩1": "XSLL",
  "엑솔타코팅시스템즈": "AXTA",
  "엑스바이오텍": "XBIT",
  "엑스턴트메디컬홀딩스": "XTNT",
  "엑스트라스페이스스토리지": "EXR",
  "엑스파이낸셜ADR": "XYF",
  "엑스페리": "XPER",
  "엑스펠": "XPEL",
  "엑스포": "XPO",
  "엑스포넌트": "EXPO",
  "엑스포넨셜피트니스": "XPOF",
  "엑스프로": "XPRO",
  "엑스피": "XP",
  "엑스피언360": "XPON",
  "엑슨모빌홀딩스": "XOM",
  "엑슬서비스홀딩스": "EXLS",
  "엑시큐어": "XCUR",
  "엑신테크놀로지스": "EXYN",
  "엑제오그룹": "XZO",
  "엔-에이블": "NABL",
  "엔다바ADR": "DAVA",
  "엔데버실버": "EXK",
  "엔드라라이프사이언스": "NDRA",
  "엔라이벡스": "ENLV",
  "엔라이트": "LASR",
  "엔라이트리뉴어블에너지": "ENLT",
  "엔버릭바이오사이언시스": "ENVB",
  "엔베노메디컬": "NVNO",
  "엔벤트일렉트릭": "NVT",
  "엔벨라": "ELA",
  "엔보이메디컬": "COCH",
  "엔뷰메디컬": "FEED",
  "엔브리지": "ENB",
  "엔비니그룹": "NVNI",
  "엔비디아": "NVDA",
  "엔비리": "NVRI",
  "엔비스타홀딩스": "NVST",
  "엔사인그룹": "ENSG",
  "엔시스바이오사이언시스": "ENSC",
  "엔씨노": "NCNO",
  "엔젤스튜디오스": "ANGX",
  "엔젤오크모기지": "AOMR",
  "엔진게이밍앤미디어": "GAME",
  "엔진테라퓨틱스": "ENGN",
  "엔카르타": "NKTX",
  "엔코어에너지": "EU",
  "엔터지": "ETR",
  "엔터지뉴올리언스선순위담보채권5.000%만기2052년": "ENJ",
  "엔터지뉴올리언스선순위담보채권5.500%만기2066년": "ENO",
  "엔터지루이지애나선순위담보채권4.875%만기2066년": "ELC",
  "엔터지미시시피선순위담보채권4.900%만기2066년": "EMP",
  "엔터지아칸소선순위담보채권4.875%만기2066년9월": "EAI",
  "엔터지텍사스우선주시리즈A5.375%": "ETI-P",
  "엔터프라이즈파이낸셜서비스": "EFSC",
  "엔터프라이즈파이낸셜서비시스우선주시리즈A5%": "EFSCP",
  "엔테라바이오": "ENTX",
  "엔테로테라퓨틱스": "GRDX",
  "엔트라다테라퓨틱스": "TRDA",
  "엔트라비전커뮤니케이션즈": "EVC",
  "엔프로": "NPO",
  "엘도라도골드": "EGO",
  "엘라스틱": "ESTC",
  "엘란코애니멀헬스": "ELAN",
  "엘러윗커넥션": "ELWT",
  "엘레돈파마슈티컬스": "ELDN",
  "엘레반스헬스": "ELV",
  "엘로메이캐피털": "ELLO",
  "엘록스파마슈티컬스": "ELOX",
  "엘루시아": "ELUT",
  "엘름커뮤니티스": "ELME",
  "엘리먼트솔루션즈": "ESI",
  "엘리멘탈로열티코퍼레이션": "ELE",
  "엘리시오테라퓨틱스": "ELTX",
  "엘리트익스프레스홀딩": "ETS",
  "엘링턴파이낸셜": "EFC",
  "엘멧그룹": "ELMT",
  "엘빗시스템즈": "ESLT",
  "엘지디스플레이ADR": "LPL",
  "엘텍": "ELTK",
  "엘폴로로코홀딩스": "LOCO",
  "엘프뷰티": "ELF",
  "엠닐파마슈티컬": "AMRX",
  "엠백타": "EMBC",
  "엠비아": "MBI",
  "엠에프인터내셔널": "MFI",
  "엠코그룹": "EME",
  "엠파이어스테이트리얼티트러스트": "ESRT",
  "엠파이어페트롤리움": "EP",
  "엠페리디지털": "EMPD",
  "엠프레사디스트리부이도라ADR": "EDN",
  "엠피머터리얼즈": "MP",
  "엡시움엔터프라이즈": "EPSM",
  "엡실론에너지": "EPSN",
  "엣지와이즈테라퓨틱스": "EWTX",
  "염브랜즈": "YUM",
  "염차이나홀딩스": "YUMC",
  "예스웨이": "YSWY",
  "예티홀딩스": "YETI",
  "옐프": "YELP",
  "오가노제네시스홀딩스": "ORGO",
  "오가논&코": "OGN",
  "오가니그램글로벌": "OGI",
  "오니티그룹": "ONIT",
  "오디사이트.AI": "ODYS",
  "오디세이마린익스플로레이션": "OMEX",
  "오디세이테라퓨틱스": "ODTX",
  "오디오아이": "AEYE",
  "오디오코드": "AUDC",
  "오디티테크": "ODD",
  "오라메드파마슈티컬스": "ORMP",
  "오라바이오사이언시스": "AURA",
  "오라슈어테크놀로지스": "OSUR",
  "오라이언그룹홀딩스": "ORN",
  "오라제닉스": "OGEN",
  "오라클": "ORCL",
  "오레녹스인더스트리스": "OLOX",
  "오레일리오토모티브": "ORLY",
  "오렌지카운티뱅코프": "OBT",
  "오렌지클라우드테크놀로지": "ORKT",
  "오로라모바일ADR": "JG",
  "오로라이노베이션": "AUR",
  "오로라카나비스": "ACB",
  "오루카테라퓨틱스": "ORKA",
  "오리니아파마슈티컬스": "AUPH",
  "오리엔탈컬처홀딩": "OCG",
  "오리온": "OEC",
  "오리온디지털": "ORIO",
  "오리온에너지시스템즈": "OESX",
  "오리온프로퍼티스": "ONL",
  "오리진뱅코프": "OBK",
  "오리진애그리테크": "SEED",
  "오리진인베스트먼트I": "ORIQ",
  "오릭스ADR": "IX",
  "오릭파마슈티컬스": "ORIC",
  "오마다헬스": "OMDA",
  "오마이홈": "OMH",
  "오마트테크놀로지스": "ORA",
  "오메가플렉스": "OFLX",
  "오메가헬스케어인베스터스": "OHI",
  "오메로스": "OMER",
  "오북홀딩스": "OWLS",
  "오비드테라퓨틱스": "OVID",
  "오빈티브": "OVV",
  "오셔나골드": "OGC",
  "오셔니어링인터내셔널": "OII",
  "오션캐피탈애퀴지션": "OCAC",
  "오션파워테크놀로지스": "OPTT",
  "오션팰": "SVRN",
  "오션퍼스트파이낸셜": "OCFC",
  "오션호크애퀴지션": "OHAC",
  "오소픽스메디컬": "OFIX",
  "오스아이디": "AUID",
  "오스카헬스": "OSCR",
  "오스타운파이낸셜서비스": "ORRF",
  "오스트레일리안오일시드홀딩스": "COOT",
  "오스틴골드": "AUST",
  "오스틴테크놀로지그룹": "OST",
  "오시스코골드그룹": "OGG",
  "오시코시": "OSK",
  "오쏘피디아트릭스": "KIDS",
  "오엘비그룹": "OLB",
  "오울렛": "OWLT",
  "오웬스코닝": "OC",
  "오이스터엔터프라이시스II애퀴지션": "OYSE",
  "오일-드리코퍼레이션오브아메리카": "ODC",
  "오일스테이츠인터내셔널": "OIS",
  "오케스트라바이오메드홀딩스": "OBIO",
  "오케아니스에코탱커스": "ECO",
  "오쿨리스홀딩": "OCS",
  "오큐젠": "OCGN",
  "오큘라테라퓨틱스": "OCUL",
  "오크밸리뱅코프": "OVLY",
  "오크트리스페셜티렌딩": "OCSL",
  "오크트리애퀴지션III라이프사이언스": "OACC",
  "오클로": "OKLO",
  "오키드아일랜드캐피털": "ORC",
  "오터테일": "OTTR",
  "오토네이션": "AN",
  "오토노믹스메디컬": "AMIX",
  "오토데스크": "ADSK",
  "오토러스테라퓨틱스ADR": "AUTL",
  "오토리브": "ALV",
  "오토매틱데이터프로세싱": "ADP",
  "오토존": "AZO",
  "오토지인터넷테크놀로지(글로벌)": "AZI",
  "오토홈ADR": "ATHM",
  "오틀리그룹ABADR": "OTLY",
  "오티스월드와이드": "OTIS",
  "오팔퓨얼": "OPAL",
  "오퍼패드솔루션스": "OPAD",
  "오페라ADR": "OPRA",
  "오펜하이머홀딩스": "OPY",
  "오포툰파이낸셜": "OPRT",
  "오푸스제네틱스": "IRD",
  "오픈도어테크놀로지스": "OPEN",
  "오픈레인": "OPLN",
  "오픈텍스트": "OTEX",
  "오피스프로퍼티스인컴트러스트": "OPI",
  "오하이오밸리뱅크": "OVBC",
  "옥소젠": "AXGN",
  "옥스브리지리홀딩스": "OXBR",
  "옥스퍼드레인우선주8.25%": "OXLCM",
  "옥스포드레인캐피털": "OXLC",
  "옥스포드레인캐피털우선주7.50%": "OXLCO",
  "옥스포드스퀘어캐피털": "OXSQ",
  "옥스포드인더스트리스": "OXM",
  "옥스포트레인캐피털우선주7.125%": "OXLCN",
  "옥슬리브릿지애퀴지션": "OBA",
  "옥시덴털페트롤리움": "OXY",
  "옥타": "OKTA",
  "옥타브스페셜티그룹": "OSG",
  "옥타브인텔리전스": "OCTV",
  "온다스": "ONDS",
  "온세미콘덕터": "ON",
  "온코네틱스": "ONCO",
  "온콜리틱스바이오텍": "ONCY",
  "온큐어테라퓨틱스": "OKUR",
  "온테리스": "ONT",
  "온투이노베이션": "ONTO",
  "온폴리오홀딩스": "ONFO",
  "온홀딩": "ONON",
  "올드내셔널뱅코프": "ONB",
  "올드내셔널뱅코프40우선주시리즈A": "ONBPP",
  "올드내셔널뱅코프40우선주시리즈C": "ONBPO",
  "올드도미니언프라이트라인": "ODFL",
  "올드리퍼블릭인터내셔널": "ORI",
  "올드세컨드뱅코프": "OSBC",
  "올레마파마슈티컬": "OLMA",
  "올리스바겐아웃렛홀딩스": "OLLI",
  "올린": "OLN",
  "올스테이트": "ALL",
  "올인퓨처테크얼라이언스": "AIFA",
  "옴니AB": "OABI",
  "옴니셀": "OMCL",
  "옴니콤그룹": "OMC",
  "옵션케어헬스": "OPCH",
  "옵시디안에너지": "OBE",
  "옵코헬스": "OPK",
  "옵텍스시스템스홀딩스": "OPXS",
  "옵티마이즈알엑스": "OPRX",
  "옵티멈뱅크홀딩스": "OPHC",
  "옵티멈커뮤니케이션스": "OPTU",
  "옵티미헬스": "OPTH",
  "옵티컬케이블": "OCC",
  "옵파이": "OPFI",
  "와바시내셔널": "WNC",
  "와비파커": "WRBY",
  "와이드포인트": "WYY",
  "와이마이홀로그램클라우드": "WIMI",
  "와이어하우저": "WY",
  "와이즈그룹": "WSE",
  "와이즈키인터내셔널홀딩AGADR": "WKEY",
  "와츠워터테크놀로지스": "WTS",
  "와츠코": "WSO",
  "와튼파이낸셜": "WTF",
  "와푸에듀케이션": "WAFU",
  "요신테크놀로지": "YAAS",
  "요크빌애퀴지션": "MCGA",
  "요크빌인터내셔널캐피털": "YICC",
  "요크스페이스시스템즈": "YSS",
  "요크워터": "YORW",
  "우드사이드에너지그룹ADR": "WDS",
  "우드워드": "WWD",
  "우라늄로열티": "UROY",
  "우라늄에너지": "UEC",
  "우로젠파마": "URGN",
  "우리금융지주ADR": "WF",
  "우마": "OOMA",
  "우버": "UBER",
  "우신ADR": "UXIN",
  "울버린월드와이드": "WWW",
  "울타뷰티": "ULTA",
  "울트라라이프": "ULBI",
  "울트라제닉스파마슈티컬": "RARE",
  "울트라클린홀딩스": "UCTT",
  "울트라파르팔티시파코에스ADR": "UGP",
  "울프스피드": "WOLF",
  "워너뮤직그룹": "WMG",
  "워너브로스디스커버리": "WBD",
  "워딩턴스틸": "WS",
  "워딩턴엔터프라이즈": "WOR",
  "워리어멧콜": "HCC",
  "워싱턴트러스트뱅코프": "WASH",
  "워커&던롭": "WD",
  "워크데이": "WDAY",
  "워크메디컬테크놀로지그룹": "WOK",
  "워크스포트": "WKSP",
  "워크호스그룹": "WKHS",
  "워키바": "WK",
  "워터드랍ADR": "WDH",
  "워터브리지인프라스트럭처": "WBI",
  "워터스": "WAT",
  "워터스톤파이낸셜": "WSBF",
  "원IM애퀴지션": "OIM",
  "원가스": "OGS",
  "원그룹호스피탤리티": "STKS",
  "원리버티프로퍼티즈": "OLP",
  "원메드넷": "ONMD",
  "원메인홀딩스": "OMF",
  "원스어폰어팜": "OFRM",
  "원스파월드홀딩스": "OSW",
  "원스팬": "OSPN",
  "원앤원그린테크놀로지스": "YDDL",
  "원오케이": "OKE",
  "원워터마린": "ONEW",
  "원컨스트럭션그룹": "ONEG",
  "월드억셉턴스": "WRLD",
  "월드키넥트": "WKC",
  "월든캐스트": "WALD",
  "월마트": "WMT",
  "월박스": "WBX",
  "월트디즈니": "DIS",
  "월풀": "WHR",
  "웨너엔터프라이즈": "WERN",
  "웨더포드인터네셔널": "WFRD",
  "웨스뱅코": "WSBC",
  "웨스뱅코우선주SeriesB7.375%": "WSBCO",
  "웨스코인터내셔널": "WCC",
  "웨스턴뉴잉글랜드뱅코프": "WNEB",
  "웨스턴디지털": "WDC",
  "웨스턴얼라이언스뱅코프": "WAL",
  "웨스턴유니온": "WU",
  "웨스턴코퍼&골드": "WRN",
  "웨스트락커피": "WEST",
  "웨스트레이크": "WLK",
  "웨스트뱅코프": "WTBA",
  "웨스트아메리카뱅코프": "WABC",
  "웨스트엔클레이브머저": "WENC",
  "웨스트우드홀딩스그룹": "WHG",
  "웨스트워터리소시스": "WWR",
  "웨스트파마슈티컬서비시즈": "WST",
  "웨스트포트퓨얼시스템즈": "WPRT",
  "웨스트프레이저팀버": "WFG",
  "웨스틴애퀴지션": "WSTN",
  "웨스팅하우스에어브레이크테크놀로지": "WAB",
  "웨어러블디바이시스": "WLDS",
  "웨어울프테라퓨틱스": "HOWL",
  "웨어푸드컴스프롬": "WFCF",
  "웨이보ADR": "WB",
  "웨이브라이프사이언스": "WVE",
  "웨이스마켓": "WMK",
  "웨이스타홀딩": "WAY",
  "웨이스트매니지먼트": "WM",
  "웨이스트커넥션스": "WCN",
  "웨이코그룹": "WEYS",
  "웨이페어": "W",
  "웩스": "WEX",
  "웬디스": "WEN",
  "웬애퀴지션": "WENN",
  "웰스파고": "WFC",
  "웰스프론트": "WLTH",
  "웰체인지홀딩스": "WCT",
  "웰타워": "WELL",
  "웹스터파이낸셜": "WBS",
  "웹툰엔터테인먼트": "WBTN",
  "위니바고인더스트리": "WGO",
  "위라이드ADR": "WRD",
  "위바이글로벌": "WBUY",
  "위불": "BULL",
  "위브커뮤니케이션스": "WEAV",
  "위샵홀딩스": "WSHP",
  "위안바오ADR": "YB",
  "위에다디지털홀딩": "YDKG",
  "위즈덤트리": "WT",
  "위터치테크놀로지": "WETH",
  "위투어로보틱스": "WETO",
  "위프로ADR": "WIT",
  "윅스닷컴": "WIX",
  "윈덤호텔&리조트": "WH",
  "윈리조트": "WYNN",
  "윈마크": "WINA",
  "윈체스터뱅코프": "WSBK",
  "윈터그린애퀴지션": "WTG",
  "윈트러스트파이낸셜": "WTFC",
  "윈트러스트파이낸셜우선주7.875%": "WTFCN",
  "윌댄그룹": "WLDN",
  "윌라멧밸리빈야즈": "WVVI",
  "윌래메트밸리바인야드우선주시리즈A": "WVVIP",
  "윌로우레인애퀴지션II": "WLII",
  "윌리스리스파이낸스": "WLFC",
  "윌리스타워스왓슨": "WTW",
  "윌리엄소노마": "WSM",
  "윌리엄스컴퍼니즈": "WMB",
  "윌스콧홀딩스": "WSC",
  "윙스톱": "WING",
  "윙입푸드홀딩스그룹ADR": "WYHG",
  "유나이티드-가디언": "UG",
  "유나이티드내추럴푸드": "UNFI",
  "유나이티드렌탈스": "URI",
  "유나이티드마리타임": "USEA",
  "유나이티드마이크로일렉트로닉ADR": "UMC",
  "유나이티드뱅코프": "UBCP",
  "유나이티드뱅크셰어스(NasdaqGS)": "UBSI",
  "유나이티드스테이츠라임&미네랄": "USLM",
  "유나이티드스테이츠앤티모니": "UAMY",
  "유나이티드애퀴지션I": "UAC",
  "유나이티드에어라인스홀딩스": "UAL",
  "유나이티드커뮤니티뱅크스": "UCB",
  "유나이티드테라퓨틱스": "UTHR",
  "유나이티드파이어그룹": "UFCS",
  "유나이티드파크&리조트": "PRKS",
  "유나이티드헬스그룹": "UNH",
  "유넘그룹": "UNM",
  "유니-퓨얼홀딩스": "UFG",
  "유니레버ADR": "UL",
  "유니버설": "UVV",
  "유니버설디스플레이": "OLED",
  "유니버설인슈어런스홀딩스": "UVE",
  "유니버설일렉트로닉스": "UEIC",
  "유니버설테크니컬인스티튜트": "UTI",
  "유니버설헬스리얼티인컴트러스트": "UHT",
  "유니버셜로지스틱스홀딩스": "ULH",
  "유니버셜세이프티프로덕츠": "UUU",
  "유니버셜헬스서비스": "UHS",
  "유니버스파마슈티컬스": "UPC",
  "유니베스트파이낸셜": "UVSP",
  "유니사이시브테라퓨틱스": "UNCY",
  "유니시스": "UIS",
  "유니언뱅크셰어스": "UNB",
  "유니온퍼시픽": "UNP",
  "유니큐어": "QURE",
  "유니티그룹(델라웨어)": "UNIT",
  "유니티뱅코프": "UNTY",
  "유니티소프트웨어": "U",
  "유니틸": "UTL",
  "유니퍼스트": "UNF",
  "유니피": "UFI",
  "유다오ADR": "DAO",
  "유라이프그룹ADR": "YOUL",
  "유레카애퀴지션": "EURK",
  "유로넷월드와이드": "EEFT",
  "유로드라이": "EDRY",
  "유로시스": "ESEA",
  "유로테크홀딩스컴퍼니": "CLWT",
  "유로홀딩스": "EHLD",
  "유비퀴티": "UI",
  "유사나헬스사이언스": "USNA",
  "유시오": "USIO",
  "유아이패스": "PATH",
  "유어-에너지": "URG",
  "유커뮨인터내셔널": "UK",
  "유클라우드링크그룹ADR": "UCL",
  "유타메디컬프로덕츠": "UTMD",
  "유타임": "FXHO",
  "유파워": "UCAR",
  "유펙시": "UPXI",
  "유프락시아파마슈티컬스": "EPRX",
  "유홀홀딩": "UHAL",
  "유홀홀딩시리즈N": "UHAL-B",
  "윤지ADR": "YJ",
  "윤홍그린CTI": "YHGJ",
  "이게인": "EGAN",
  "이글뉴클리어에너지": "NUCL",
  "이글락랜드": "EROK",
  "이글머티리얼스": "EXP",
  "이글뱅코프": "EGBN",
  "이글뱅코프몬태나": "EBMT",
  "이글파이낸셜서비스": "EFSI",
  "이글포인트인스티튜셔널인컴펀드우선주SeriesA8.125%": "EIIA",
  "이글포인트인컴우선주SeriesA5%": "EICA",
  "이글포인트크레디트우선주SeriesC6.5%만기2031년": "ECCC",
  "이네이트파르마ADR": "IPHA",
  "이노데이터": "INOD",
  "이노바인터내셔널": "ENVA",
  "이노베이션베버리지그룹": "IBG",
  "이노베이지홀딩": "INNV",
  "이노베이트": "VATE",
  "이노베이티브솔루션스&서포트": "ISSC",
  "이노베이티브아이웨어": "LUCY",
  "이노베이티브인더스트리얼프로퍼티": "IIPR",
  "이노벡스인터내셔널": "INVX",
  "이노비바": "INVA",
  "이노비스": "ENOV",
  "이노비오파마슈티컬스": "INO",
  "이노비즈테크놀로지스": "INVZ",
  "이노빅스": "ENVX",
  "이노스펙": "IOSP",
  "이노젠": "INGN",
  "이누보": "INUV",
  "이니오": "INIO",
  "이댑TMSADR": "FOCL",
  "이래스카": "ERAS",
  "이렌디지털ADR": "YRD",
  "이록": "EROC",
  "이롱파워홀딩": "ELPW",
  "이리덱스": "IRIX",
  "이리디움커뮤니케이션스": "IRDM",
  "이리인뎀니티": "ERIE",
  "이매진바이오": "IMA",
  "이매틱스": "IMTX",
  "이머션": "IMMR",
  "이머전트바이오솔루션스": "EBS",
  "이무톈ADR": "YMT",
  "이뮤노반트": "IMVT",
  "이뮤노코어홀딩스ADR": "IMCR",
  "이뮤놈": "IMNM",
  "이뮤니어링": "IMRX",
  "이뮤니티바이오": "IBRX",
  "이뮤닉": "IMUX",
  "이뮤론ADR": "IMRN",
  "이뮤셀": "ICCC",
  "이뮤텝ADR": "IMMP",
  "이뮨온": "IMNN",
  "이믹스바이오파마": "IMMX",
  "이방인터내셔널홀딩스": "EBON",
  "이베이": "EBAY",
  "이볼브테크놀로지스홀딩스": "EVLV",
  "이브홀딩": "EVEX",
  "이센트그룹": "ESNT",
  "이쉘고": "EHGO",
  "이스라엘케미컬스": "ICL",
  "이스턴": "EML",
  "이스턴뱅크셰어스": "EBC",
  "이스턴인터내셔널": "ELOG",
  "이스털리거번먼트프로퍼티스": "DEA",
  "이스트그룹프로퍼티스": "EGP",
  "이스트만케미컬": "EMN",
  "이스트먼코닥": "KODK",
  "이스트웨스트뱅코프": "EWBC",
  "이스파이어테크놀로지": "ISPR",
  "이슨테크놀로지ADR": "DXF",
  "이엑스트": "YEXT",
  "이오밴스바이오테라퓨틱스": "IOVA",
  "이오스에너지엔터프라이시스": "EOSE",
  "이온바이오파마": "AEON",
  "이온애퀴지션I": "AESP",
  "이자벨라뱅크": "ISBA",
  "이즈코프": "EZPW",
  "이지고테크놀로지스": "EZGO",
  "이카엑스홀딩스": "ECX",
  "이콜랩": "ECL",
  "이퀴녹스골드": "EQX",
  "이퀴닉스": "EQIX",
  "이퀼리움": "EQ",
  "이큅먼트쉐어닷컴": "EQPT",
  "이타우우니방쿠홀딩ADR": "ITUB",
  "이토로그룹": "ETOR",
  "이투란로케이션앤콘트롤": "ITRN",
  "이튼": "ETN",
  "이튼알렌인테리어스": "ETD",
  "이튼파마슈티컬즈": "ETON",
  "이팸시스템즈": "EPAM",
  "이페리온엑스ADR": "IPX",
  "이플러스": "PLUS",
  "이항홀딩스ADR": "EH",
  "이헬스": "EHTH",
  "익스트림네트웍스": "EXTR",
  "익스팬드에너지": "EXE",
  "익스페디터스인터내셔널오브워싱턴": "EXPD",
  "익스펜시파이": "EXFY",
  "익스피디아그룹": "EXPE",
  "인8바이오": "INAB",
  "인그램마이크로홀딩": "INGM",
  "인그리디언": "INGR",
  "인노홀딩스": "INHD",
  "인댑터스테라퓨틱스": "INDP",
  "인더스트리얼로지스틱스프로퍼티": "ILPT",
  "인도네시아에너지코퍼레이션": "INDO",
  "인디고애퀴지션": "INAC",
  "인디비어파마슈티컬스": "INDV",
  "인디세미컨덕터": "INDI",
  "인디아글로벌리제이션캐피털": "IGC",
  "인디펜던스리얼티트러스트": "IRT",
  "인디펜던트뱅크": "IBCP",
  "인디펜던트뱅크(매사추세츠)": "INDB",
  "인라이븐테라퓨틱스": "ELVN",
  "인리프": "INLF",
  "인메드파마슈티컬스": "INM",
  "인모드": "INMD",
  "인뮨바이오": "INMB",
  "인베스코": "IVZ",
  "인베스코모기지캐피털": "IVR",
  "인베스타홀딩": "ISTR",
  "인베스터스타이틀": "ITIC",
  "인베스트그린애퀴지션": "IGAC",
  "인베스트코프크레디트매니지먼트": "ICMB",
  "인벤처": "INV",
  "인벤트러스트프로퍼티스": "IVT",
  "인벤티바ADR": "IVA",
  "인비비드": "IVVD",
  "인비테이션홈스": "INVH",
  "인사이트": "INCY",
  "인사이트디지털파트너스II": "DYOR",
  "인사이트몰레큘러다이어그노스틱스": "IMDX",
  "인사이트엔터프라이지즈": "NSIT",
  "인슐릿": "PODD",
  "인스메드": "INSM",
  "인스위츠호스피털리티트러스트": "IHT",
  "인스톨드빌딩프로덕츠": "IBP",
  "인스틸바이오": "TIL",
  "인스틸인더스트리": "IIIN",
  "인스파이어MD": "NSPR",
  "인스파이어드엔터테인먼트": "INSE",
  "인스파이어메디컬시스템": "INSP",
  "인스페리티": "NSP",
  "인시고": "INSG",
  "인액트홀딩스": "ACT",
  "인제비티": "NGVT",
  "인카넥스헬스케어": "IXHL",
  "인컴오퍼튜니티리얼티인베스터스": "IOR",
  "인컴퍼스헬스": "EHC",
  "인탭": "INTA",
  "인터그룹": "INTG",
  "인터내셔널머니익스프레스": "IMXI",
  "인터내셔널뱅크셰어즈": "IBOC",
  "인터내셔널제네럴인슈런스홀딩스": "IGIC",
  "인터내셔널타워힐마인스": "THM",
  "인터내셔널페이퍼": "IP",
  "인터내셔널플레이버스&프레그런스": "IFF",
  "인터네셔널시웨이스": "INSW",
  "인터디지털": "IDCC",
  "인터랙티브브로커스그룹": "IBKR",
  "인터랙티브스트랭스": "TRNR",
  "인터링크일렉트로닉스": "LINK",
  "인터앤코": "INTR",
  "인터컨티넨탈호텔그룹ADR": "IHG",
  "인터컨티넨털익스체인지": "ICE",
  "인터코프파이낸셜서비스": "IFS",
  "인터콘트": "NCT",
  "인터큐어": "INCR",
  "인터퍼퓸": "IPAR",
  "인터페이스": "TILE",
  "인터프라이빗인베스트파트너스V": "IPVV",
  "인테그라라이프사이언시스홀딩스": "IART",
  "인테그라리소시즈": "ITRG",
  "인테그리스": "ENTG",
  "인테스트": "INTT",
  "인텐시티테라퓨틱스": "INTS",
  "인텔": "INTC",
  "인텔리네틱스": "INLX",
  "인텔리아테라퓨틱스": "NTLA",
  "인텔리전트그룹": "INTJ",
  "인텔리전트리빙어플리케이션그룹": "ILAG",
  "인텔리전트바이오솔루션스": "INBS",
  "인텔리전트프로텍션매니지먼트": "IPM",
  "인텔리체크": "IDN",
  "인튜이트": "INTU",
  "인튜이티브머신스": "LUNR",
  "인튜이티브서지컬": "ISRG",
  "인트레피드포타시": "IPI",
  "인트루젼": "INTZ",
  "인트체인스그룹ADR": "ICG",
  "인티거홀딩스": "ITGR",
  "인티그레이티드미디어테크놀로지": "IMTE",
  "인페이즈에너지": "ENPH",
  "인포메이션서비스그룹": "III",
  "인포버드": "IFBD",
  "인포시스ADR": "INFY",
  "인포인트커머셜리얼에스테이트인컴우선주시리즈A6.75%": "ICR-P-A",
  "인퓨시스템즈홀딩스": "INFU",
  "인플락스": "IFRX",
  "인플렉션": "INFQ",
  "인플렉션포인트애퀴지션III": "IPCX",
  "인플렉션포인트애퀴지션V": "IPEX",
  "인플렉션포인트애퀴지션VI": "IPFX",
  "인피니트이글애퀴지션": "IEAG",
  "인피니티내추럴리소시스": "INR",
  "인히브릭스바이오사이언시스": "INBX",
  "인히비케이즈테라퓨틱스": "IKT",
  "일라이릴리": "LLY",
  "일렉트라배터리머티리얼스": "ELBM",
  "일렉트로메드": "ELMD",
  "일렉트로바야": "ELVA",
  "일렉트로코어": "ECOR",
  "일루미나": "ILMN",
  "일루미네이션애퀴지션I": "ILLU",
  "일리노이툴웍스": "ITW",
  "임브라에르ADR": "EMBJ",
  "임팩트바이오메디컬": "IBO",
  "임페리얼오일": "IMO",
  "임페리얼페트롤리엄": "IMPP",
  "임페리얼페트롤리엄우선주시리즈A8.75%": "IMPPP",
  "임플로이어스홀딩스": "EIG",
  "임핀지": "PI",
  "잉가솔랜드": "IR",
  "잉글스마케츠": "IMKTA",
  "자나두퀀텀테크놀로지스": "XNDU",
  "자빌": "JBL",
  "자이랩ADR": "ZLAB",
  "자이로다인": "GYRO",
  "자이어테라퓨틱스": "GYRE",
  "자이언스뱅코프": "ZION",
  "자이언스뱅코프우선주시리즈A": "ZIONP",
  "자일럼": "XYL",
  "자일리오테라퓨틱스": "XLO",
  "자임웍스": "ZYME",
  "재규어우라늄": "JAGU",
  "재규어헬스": "JAGX",
  "재넉스테라퓨틱스": "JANX",
  "재스퍼테라퓨틱스": "JSPR",
  "재즈파마슈티컬스": "JAZZ",
  "재트II애퀴지션": "JATT",
  "잭스퍼시픽": "JAKK",
  "잭슨파이낸셜": "JXN",
  "잭헨리&어소시에이츠": "JKHY",
  "쟈인그룹ADR": "JFIN",
  "저니메디컬": "DERM",
  "저라쉬홀딩스": "JRSH",
  "저먼아메리칸뱅코프": "GABC",
  "저지마이크스서브스": "JMKE",
  "전엘케이워터솔루션스": "ZWS",
  "전지교육기술그룹ADR": "JZ",
  "정업바이오테크놀로지홀딩": "ZYBT",
  "제나스바이오파마": "ZBIO",
  "제나시스": "GNSS",
  "제나애퀴지션II": "JENA",
  "제나테크": "ZENA",
  "제너럴다이내믹스": "GD",
  "제너럴모터스": "GM",
  "제너럴밀즈": "GIS",
  "제너럴캐탈리스트글로벌": "GCGR",
  "제너럴퍼포스애퀴지션": "GPAC",
  "제너럴퓨전그룹": "GFUZ",
  "제너레이션에센셜스그룹": "TGE",
  "제너레이트바이오메디슨스": "GENB",
  "제네락홀딩스": "GNRC",
  "제네레이션인컴프로퍼티스": "GIPR",
  "제네룩스": "GNLX",
  "제네스코": "GCO",
  "제네틱바이오사이언스": "XBIO",
  "제넨타사이언스ADR": "GNTA",
  "제논파마슈티컬": "XENE",
  "제뉴인파츠": "GPC",
  "제니아호텔&리조트": "XHR",
  "제로스택": "ZSTK",
  "제록스홀딩스": "XRX",
  "제론": "GERN",
  "제르다우ADR": "GGB",
  "제리스바이오파마홀딩스": "XERS",
  "제미나이스페이스스테이션": "GEMI",
  "제보": "GEVO",
  "제브러테라퓨틱스": "ZVRA",
  "제비아": "ZVIA",
  "제오에너지": "ZEO",
  "제이디닷컴ADR": "JD",
  "제이유드글로벌로지스틱스": "JYD",
  "제이질": "JILL",
  "제이콥스솔루션스": "J",
  "제이프로그": "FROG",
  "제이피모간체이스": "JPM",
  "제임스리버그룹홀딩스": "JRVR",
  "제타글로벌홀딩스": "ZETA",
  "제타네트워크그룹": "ZNB",
  "제퍼슨캐피털": "JCAP",
  "제프리스파이낸셜그룹": "JEF",
  "젠디지털": "GEN",
  "젠맵ADR": "GMAB",
  "젠섬": "THRM",
  "젠워스파이낸셜": "GNW",
  "젠코": "XNCR",
  "젠코시핑&트레이딩": "GNK",
  "젠코인더스트리스": "GENC",
  "젠타그룹": "ZTG",
  "젠테일스파마슈티컬": "ZNTL",
  "젠텍": "ZTEK",
  "젠텍스": "GNTX",
  "젠팩트": "G",
  "젠프렉스": "GNPX",
  "젤드-웬홀딩": "JELD",
  "젤텍": "GELS",
  "젭헬스ADR": "ZEPP",
  "젯.AI": "JTAI",
  "젯지": "ZDGE",
  "조메트리": "XMTR",
  "조비에비에이션": "JOBY",
  "조에티스": "ZTS",
  "조웰글로벌": "JWEL",
  "조이ADR": "JOYY",
  "조인트": "JYNT",
  "존마샬뱅코프": "JMSB",
  "존스랭라살": "JLL",
  "존슨아웃도어스": "JOUT",
  "존슨앤드존슨": "JNJ",
  "존슨컨트롤스인터내셔널": "JCI",
  "존윌리앤손ClassA": "WLY",
  "존윌리앤손ClassB": "WLYB",
  "졸트테라퓨틱스": "XRTX",
  "주라바이오": "ZURA",
  "주롱홀딩": "JLHL",
  "주미아테크놀로지AGADR": "JMIA",
  "주미에즈": "ZUMZ",
  "주잇-캐머런트레이딩": "JCTC",
  "주즈스트래티지": "ZOOZ",
  "주피터뉴로사이언시스": "JUNS",
  "줌인포테크놀로지스": "GTM",
  "줌커뮤니케이션스": "ZM",
  "중국오토모티브시스템": "CAAS",
  "중차오": "ZCMD",
  "중화텔레콤ADR": "CHT",
  "즈바오테크놀로지": "ZBAO",
  "즈후ADR": "ZH",
  "지니어스그룹": "GNS",
  "지니어스스포츠": "GENI",
  "지니에너지": "GNE",
  "지보홀딩스": "GIBO",
  "지브라테크놀로지스": "ZBRA",
  "지브롤터인더스트리스": "ROCK",
  "지스케일러": "ZS",
  "지아드": "JDZG",
  "지오그룹": "GEO",
  "지오박스랩스": "GOVX",
  "지오스페이스테크놀로지스": "GEOS",
  "지오파크": "GPRK",
  "지용바이오테크": "MENS",
  "지우지홀딩스": "JZXN",
  "지프데이비스": "ZD",
  "진디엑스홀딩스": "WGS",
  "진메디컬인터내셔널": "ZJYL",
  "진신테크놀로지홀딩ADR": "NAMI",
  "질단액티브웨어": "GIL",
  "질로우그룹ClassA": "ZG",
  "질로우그룹ClassC": "Z",
  "짐머바이오멧홀딩스": "ZBH",
  "집리크루터": "ZIP",
  "징코솔라홀딩스ADR": "JKS",
  "차밍메디컬": "MCTA",
  "차우차우클라우드인터내셔널홀딩스": "CHOW",
  "차이나SXT파마슈티컬스": "SXTC",
  "차이나내츄럴리소스": "CHNR",
  "차이나유차이인터내셔널": "CYD",
  "차이나파마홀딩스": "CPHI",
  "차임파이낸셜": "CHYM",
  "차지포인트홀딩스": "CHPT",
  "차지홀딩스ADR": "CHA",
  "차코스에너지내비게이션": "TEN",
  "차터커뮤니케이션": "CHTR",
  "찰스리버래보라토리스인터내셔널": "CRL",
  "찰스슈왑": "SCHW",
  "찰톤아리아애퀴지션": "CHAR",
  "채텀로징트러스트": "CLDT",
  "챔피언스게이트애퀴지션": "CHPG",
  "챔피언스온콜로지": "CSBR",
  "챔피언홈스": "SKY",
  "처브": "CB",
  "처치&드와이트": "CHD",
  "처칠다운스": "CHDN",
  "처칠캐피탈XII": "CXII",
  "처칠캐피털XI": "CCXI",
  "청허애퀴지션III": "CHEC",
  "체그": "CHGG",
  "체리힐모기지인베스트먼트": "CHMI",
  "체사피크유틸리티스": "CPK",
  "체인브리지뱅코프": "CBNA",
  "체인스디지털홀딩스": "CD",
  "체인지에이전츠": "CHGA",
  "체체그룹": "CCG",
  "체크캡": "MBAI",
  "체크포인트소프트웨어테크놀로지": "CHKP",
  "초이스원파이낸셜서비스": "COFS",
  "초이스호텔스인터내셔널": "CHH",
  "취훠": "QH",
  "츄이": "CHWY",
  "치어홀딩": "CHR",
  "치즈케익팩토리": "CAKE",
  "치타넷서플라이체인서비스": "CTNT",
  "치타모바일ADR": "CMCM",
  "치폴레멕시칸그릴": "CMG",
  "칠드런스플레이스": "PLCE",
  "칩모스테크놀로지스ADR": "IMOS",
  "카구루스": "CARG",
  "카난ADR": "CAN",
  "카니발": "CCL",
  "카단트": "KAI",
  "카델러A/SADR": "CDLR",
  "카들리틱스": "CDLX",
  "카디건": "KARD",
  "카디널인프라스트럭처그룹": "CDNL",
  "카디널헬스": "CAH",
  "카디오다이어그노스틱스": "CDIO",
  "카디올테라퓨틱스": "CRDL",
  "카디즈": "CDZI",
  "카디즈우선주8.875%": "CDZIP",
  "카디프온콜로지": "CRDF",
  "카랫패키징": "KRT",
  "카료팜테라퓨틱스": "KPTI",
  "카루": "KARO",
  "카르만홀딩스": "KRMN",
  "카르테시안테라퓨틱스": "RNAC",
  "카리부바이오사이언시스": "CRBU",
  "카리스라이프사이언시스": "CAI",
  "카마다": "KMDA",
  "카맥스": "KMX",
  "카메코": "CCJ",
  "카바그룹": "CAVA",
  "카바나": "CVNA",
  "카발레타바이오": "CABA",
  "카본캐피털파트너스": "KBON",
  "카브코인더스트리스": "CVCO",
  "카셀라웨이스트시스템즈": "CWST",
  "카스닷컴": "CARS",
  "카스텔럼": "CTM",
  "카스피.kz우선주": "KSPI",
  "카오투테크에듀ADR": "GOTU",
  "카이로스파르마": "KAPA",
  "카이론리얼에스테이트": "XRN",
  "카이버나테라퓨틱스": "KYTX",
  "카이신홀딩스": "KXIN",
  "카이저알루미늄": "KALU",
  "카이트리얼티그룹트러스트": "KRG",
  "카인드케어러닝": "KLC",
  "카일레라테라퓨틱스": "KLRA",
  "카지아테라퓨틱스ADR": "KZIA",
  "카탈리스트뱅코프": "CLST",
  "카터뱅크셰어스": "CARE",
  "카터스": "CRI",
  "카테터프레시젼": "VTAK",
  "카툰스튜디오스": "TOON",
  "카파츠닷컴": "PRTS",
  "카펜터테크놀로지": "CRS",
  "카프리홀딩스": "CPRI",
  "칸네홀딩스": "CNNE",
  "칸디테크놀로지스그룹": "KNDI",
  "칸준ADR": "BZ",
  "칸토르에퀴티파트너스V": "CEPV",
  "칸토에퀴티파트너스I": "CEPO",
  "칸톤스트래티직홀딩스": "CNTN",
  "칼라리스테라퓨틱스": "KLRS",
  "칼라바이오": "KALA",
  "칼라일": "CSL",
  "칼라일그룹": "CG",
  "칼라일시큐어드렌딩": "CGBD",
  "칼라일크레딧인컴우선주SeriesD7.375%": "CCID",
  "칼레도니아마이닝": "CMCL",
  "칼레드우드애퀴지션": "CRAQ",
  "칼리디바이오테라퓨틱스": "CLDI",
  "칼리사애퀴지션": "ALIS",
  "칼메인푸즈": "CALM",
  "칼스메드": "CARL",
  "칼투라": "KLTR",
  "캄스톡리소시즈": "CRK",
  "캉고": "CANG",
  "캐나다구스홀딩스": "GOOS",
  "캐나다내추럴리소시스": "CNQ",
  "캐나디안솔라": "CSIQ",
  "캐나디안퍼시픽캔자스시티": "CP",
  "캐내디언임페리얼뱅크오브커머스": "CM",
  "캐노피그로스": "CGC",
  "캐드리홀딩스": "CDR-P-B",
  "캐리어글로벌": "CARR",
  "캐리지서비스": "CSV",
  "캐보트": "CBT",
  "캐세이제너럴뱅코프": "CATY",
  "캐스인포메이션시스템즈": "CASS",
  "캐스터마리타임": "CTRM",
  "캐슬바이오사이언스": "CSTL",
  "캐터펄트홀딩스": "KPLT",
  "캐터필러": "CAT",
  "캐프리코테라퓨틱스": "CAPR",
  "캐피탈사우스웨스트": "CSWC",
  "캐피털뱅코프": "CBNK",
  "캐피털시티뱅크그룹": "CCBG",
  "캐피털원파이낸셜": "COF",
  "캐피털클린에너지캐리어스": "CCEC",
  "캐피톨페더럴파이낸셜": "CFFN",
  "캑터스": "WHD",
  "캔달M벤처": "FMFC",
  "캔델테라퓨틱스": "CADL",
  "캔터베리파크홀딩": "CPHC",
  "캔터에쿼티파트너스IV": "CEPF",
  "캔터에퀴티파트너스II": "SECZ",
  "캔터에퀴티파트너스VII": "CAES",
  "캔터에퀴티파트너스Vi": "CEPS",
  "캔터우선주SeriesA9.50%": "CFTR-P-A",
  "캔터키퍼스트페더럴뱅코프": "KFFB",
  "캔파이트바이오파바ADR": "CANF",
  "캘러웨이골프": "CALY",
  "캘리버코스": "CWD",
  "캘리포니아리소시스": "CRC",
  "캘리포니아뱅코프": "BCAL",
  "캘리포니아워터서비스그룹": "CWT",
  "캘리포니아은행": "BANC",
  "캘릭스": "CALX",
  "캘시메디카": "CALC",
  "캘프라이빗뱅크": "PBAM",
  "캠던내셔널": "CAC",
  "캠든프로퍼티트러스트": "CPT",
  "캠벨스": "CPB",
  "캠브리지애퀴지션": "CAQ",
  "캠텍": "CAMT",
  "캠프4테라퓨틱스": "CAMP",
  "캠핑월드홀딩스": "CWH",
  "캡소비전": "CV",
  "캡스톤에너지+": "CEPL",
  "캡스톤홀딩": "CAPS",
  "커네디언내셔널레일웨이": "CNI",
  "커넥트원뱅코프": "CNOB",
  "커넥트원뱅코프우선주시리즈A5.25%": "CNOBP",
  "커니파이낸셜": "KRNY",
  "커드리널테라퓨틱스": "CVKD",
  "커렌크그룹": "CURR",
  "커머셜메탈스": "CMC",
  "커머셜뱅크그룹": "CBK",
  "커머셜비히클그룹": "CVGI",
  "커머스닷컴Series1": "CMRC",
  "커머스뱅크셰어스": "CBSH",
  "커뮤니티뱅코프": "CMTV",
  "커뮤니티웨스트뱅크셰어스": "CWBC",
  "커뮤니티트러스트뱅코프": "CTBI",
  "커뮤니티파이낸셜시스템": "CBU",
  "커뮤니티헬스시스템즈": "CYH",
  "커뮤니티헬스케어트러스트": "CHCT",
  "커민스": "CMI",
  "커브라인프로퍼티스": "CURB",
  "커비": "KEX",
  "커세어게이밍": "CRSR",
  "커스터머스뱅코프": "CUBI",
  "커스텀엔터테인먼트": "KUST",
  "커스텀트럭원소스": "CTOS",
  "커즌스프로퍼티스": "CUZ",
  "커티스라이트": "CW",
  "커프리나홀딩스(Cayman)": "CUPR",
  "커피홀딩": "JVA",
  "컨듀언트": "CNDT",
  "컨슈머포트폴리오서비스": "CPSS",
  "컨스텔레이션브랜즈": "STZ",
  "컨스트럭션파트너스": "ROAD",
  "컬런/프로스트뱅커스": "CFR",
  "컬럼버스매키넌": "CMCO",
  "컬럼비아뱅킹시스템": "COLB",
  "컬럼비아스포츠웨어": "COLM",
  "컬레러스": "CAL",
  "컬리넌테라퓨틱스": "CGEM",
  "컬프": "CULP",
  "컴벌랜드파마슈티컬스": "CPIX",
  "컴볼트시스템즈": "CVLT",
  "컴스코어": "SCOR",
  "컴스톡홀딩": "CHCI",
  "컴캐스트": "CMCSA",
  "컴캐스트홀딩스후순위채권2%만기2029년10월": "CCZ",
  "컴테크텔레커뮤니케이션스": "CMTL",
  "컴퍼스": "COMP",
  "컴퍼스다이버시파이드홀딩스": "CODI",
  "컴퍼스미네랄스인터내셔널": "CMP",
  "컴퍼스테라퓨틱스": "CMPX",
  "컴퍼스패스웨이스ADR": "CMPS",
  "컴포트시스템즈USA": "FIX",
  "컴퓨젠": "CGEN",
  "케논홀딩스": "KEN",
  "케로스테라퓨틱스": "KROS",
  "케무어스": "CC",
  "케미드": "CHE",
  "케스트라메디컬테크놀로지스": "KMTS",
  "케스트렐그룹": "KG",
  "케어Dx": "CDNA",
  "케어링브랜즈": "CABR",
  "케어클라우드": "CCLD",
  "케어트러스트리츠(REIT)": "CTRE",
  "케이던스디자인시스템즈": "CDNS",
  "케이블원": "CABO",
  "케이슨애퀴지션": "CAPN",
  "케이시스제너럴스토어스": "CASY",
  "케이토": "CATO",
  "케이펫울트라페이스라인": "KPET",
  "케인앤더슨": "KBDC",
  "켄나메탈": "KMT",
  "켄뷰": "KVUE",
  "켈리서비스ClassA": "KELYA",
  "켈리서비스ClassB": "KELYB",
  "켐퍼": "KMPR",
  "코그나이트소프트웨어": "CGNT",
  "코그넥스": "CGNX",
  "코그니션테라퓨틱스": "CGTX",
  "코그니전트테크놀로지솔루션": "CTSH",
  "코넥스유사이언시스": "CNXU",
  "코노코필립스": "COP",
  "코닛디지털": "KRNT",
  "코닝": "GLW",
  "코닝클레이커필립스ADR": "PHG",
  "코다옥토퍼스그룹": "CODA",
  "코다이어그노틱스": "CODX",
  "코더온라인룩셈부르크": "CDRO",
  "코덱시스": "CDXS",
  "코드에너지": "CHRD",
  "코디악AI": "KDK",
  "코디악가스서비시스": "KGS",
  "코디악사이언스": "KOD",
  "코로바이오": "KRRO",
  "코루메디컬시스템스": "KRMD",
  "코르테바": "CTVA",
  "코메딕스": "CRMD",
  "코버넌트로지스틱스그룹": "CVLG",
  "코버스파마슈티컬스": "CRVS",
  "코버스파마슈티컬스홀딩스": "CRBP",
  "코벨": "CRVL",
  "코보": "QRVO",
  "코비스타": "CVSA",
  "코샌ADR": "CSAN",
  "코세라": "COUR",
  "코셉트테라퓨틱스": "CORT",
  "코스": "KOSS",
  "코스모스에너지": "KOS",
  "코스모스헬스": "COSM",
  "코스타그룹": "CSGP",
  "코스타마레": "CMRE",
  "코스타마레벌커스홀딩스": "CMDB",
  "코스탈사우스뱅크셰어스": "COSO",
  "코스탈파이낸셜": "CCB",
  "코스트코홀세일": "COST",
  "코야테라퓨틱스": "COYA",
  "코어&메인": "CNM",
  "코어AI홀딩스": "CHAI",
  "코어내추럴리소시스": "CNR",
  "코어래보라토리스": "CLB",
  "코어몰딩테크놀로지스": "CMT",
  "코어브릿지파이낸셜": "CRBG",
  "코어사이언티픽": "CORZ",
  "코어시빅": "CXW",
  "코어위브": "CRWV",
  "코인베이스글로벌": "COIN",
  "코인셰어스": "CSHR",
  "코인체크그룹": "CNCK",
  "코인파마슈티컬스ADR": "QNRX",
  "코젠트바이오사이언시스": "COGT",
  "코젠트커뮤니케이션스홀딩스": "CCOI",
  "코채브디펜스애퀴지션": "KCHV",
  "코카-콜라유로퍼시픽파트너스": "CCEP",
  "코카콜라": "KO",
  "코카콜라콘솔리데이티드": "COKE",
  "코카콜라펨사ADR": "KOF",
  "코크리스털파마": "COCP",
  "코티": "COTY",
  "코파트": "CPRT",
  "코파홀딩스": "CPA",
  "코퍼래시온어메리카에어포츠": "CAAP",
  "코퍼스홀딩스": "KOP",
  "코플리애퀴지션": "COPL",
  "코핀": "KOPN",
  "코헨&스티어스": "CNS",
  "코헨서클애퀴지션II": "CCII",
  "코헨앤컴퍼니": "COHN",
  "코후": "COHU",
  "코히러스온콜로지": "CHRS",
  "코히런트": "COHR",
  "콘메드": "CNMD",
  "콘센서스클라우드솔루션스": "CCSI",
  "콘센트라그룹홀딩스": "CON",
  "콘센트릭스": "CNXC",
  "콘솔리데이티드에디슨": "ED",
  "콘솔리데이티드워터": "CWCO",
  "콘스텔레이션에너지": "CEG",
  "콘스텔리움": "CSTM",
  "콘아그라브랜즈": "CAG",
  "콘크리트펌핑홀딩스": "BBCP",
  "콘탱고실버앤골드": "CTGO",
  "콘텍스트테라퓨틱스": "CNTX",
  "콘투어브랜즈": "KTB",
  "콘트롤라도라부엘라콤파니아아비아시온ADR": "VLRS",
  "콘티네움테라퓨틱스": "CTNM",
  "콘페리": "KFY",
  "콜게이트-팜올리브": "CL",
  "콜럼버스서클캐피털II": "CMII",
  "콜레지움파마슈티컬": "COLL",
  "콜렉티브마이닝": "CNL",
  "콜렉티브애퀴지션": "CCAQ",
  "콜렉티브애퀴지션II": "CAII",
  "콜로니뱅코프": "CBAN",
  "콜롬버스애퀴지션": "COLA",
  "콜롬비아파이낸셜": "CLBK",
  "콜롬비어애퀴지션III": "CLBR",
  "콜리브리글로벌에너지": "KGEI",
  "콜리어스인터내셔널그룹": "CIGI",
  "콜스": "KSS",
  "콜페이": "CPAY",
  "콤스톡": "LODE",
  "콤파니아데사네아멘투바지쿠상파울루-SABESP": "SBS",
  "콤파니아시데루르지카나시오나우ADR": "SID",
  "콩코드메디컬서비스홀딩스ADR": "CCM",
  "콩코드인터내셔널그룹": "CIGL",
  "콰넥스빌딩프로덕츠": "NX",
  "콴타서비스": "PWR",
  "쾨르마이닝": "CDE",
  "쿠라스시USA": "KRUS",
  "쿠라온콜로지": "KURA",
  "쿠쉬맨앤웨이크필드": "CWK",
  "쿠팡": "CPNG",
  "쿠퍼-스탠더드홀딩스": "CPS",
  "쿠퍼컴퍼니스": "COO",
  "쿨리크&소파인더스트리스": "KLIC",
  "쿼드/그래픽스": "QUAD",
  "쿼츠씨애퀴지션": "QSEA",
  "퀀텀": "QMCO",
  "퀀텀-Si": "QSI",
  "퀀텀X랩스": "QXL",
  "퀀텀리프애퀴지션": "QLEP",
  "퀀텀바이오파마": "QNTM",
  "퀀텀사이버": "QUCY",
  "퀀텀스케이프": "QS",
  "퀀텀스피어애퀴지션": "QUMS",
  "퀀텀이모션": "QNC",
  "퀀텀컴퓨팅": "QUBT",
  "퀀테릭스": "QTRX",
  "퀀티넘": "QNT",
  "퀄리스": "QLYS",
  "퀄컴": "QCOM",
  "퀘사에지애퀴지션": "QRED",
  "퀘스트다이아그노스틱스": "DGX",
  "퀘스트리소스홀딩": "QRHC",
  "퀘이커케미컬": "KWR",
  "퀘타애퀴지션": "QETA",
  "퀴델오쏘": "QDEL",
  "퀴아젠": "QGEN",
  "퀵로직": "QUIK",
  "퀸스테라퓨틱스": "QNCX",
  "퀸스트리트": "QNST",
  "큐니티일렉트로닉스": "Q",
  "큐라넥스파마슈티컬스": "CURX",
  "큐리그닥터페퍼": "KDP",
  "큐리스": "CRIS",
  "큐리어시티스트림": "CURI",
  "큐뮬러스AI": "QMLS",
  "큐바이오파마": "CUE",
  "큐브스마트": "CUBE",
  "큐트렉스퀀텀": "QTEX",
  "큐핀홀딩스ADR": "QFIN",
  "크노렉스": "KNRX",
  "크라우드스트라이크홀딩스": "CRWD",
  "크라운리저브애퀴지션I": "CRAC",
  "크라운캐슬": "CCI",
  "크라운크래프츠": "CRWS",
  "크라운홀딩스": "CCK",
  "크라이오-셀인터내셔널": "CCEL",
  "크라이오포트": "CYRX",
  "크라토스디펜스&시큐리티솔": "KTOS",
  "크래커배럴올드컨트리스토어": "CBRL",
  "크래프트하인즈": "KHC",
  "크레도테크놀로지그룹홀딩": "CRDO",
  "크레디코프": "BAP",
  "크레디트억셉턴스": "CACC",
  "크레딧인핸스드코츠트러스트우선주8.2050%": "KTN",
  "크레센트바이오파마": "CBIO",
  "크레센트에너지": "CRGY",
  "크레센트캐피탈BDC": "CCAP",
  "크레수드ADR": "CRESY",
  "크레인NXT": "CXT",
  "크레인하버애퀴지션II": "CRAN",
  "크레인홀딩스": "CR",
  "크렉센도": "CXDO",
  "크로거": "KR",
  "크로노스그룹": "CRON",
  "크로노스월드와이드": "KRO",
  "크로노스케일": "CHRN",
  "크로락스": "CLX",
  "크록스": "CROX",
  "크리네틱스파머슈티컬스": "CRNX",
  "크리스탈바이오텍": "KRYS",
  "크리스퍼테라퓨틱스": "CRSP",
  "크리스피크림": "DNUT",
  "크리에이티브글로벌테크놀로지홀딩스": "CGTL",
  "크리에이티브리얼리티스": "CREX",
  "크리에이티브메디컬테크놀로지홀딩스": "CELZ",
  "크리에이티브미디어&커뮤니티트러스트": "CMCT",
  "크리컷": "CRCT",
  "크리테오": "CRTO",
  "크리티컬메탈스": "CRML",
  "클라나그룹": "KLAR",
  "클라로스모기지트러스트": "CMTG",
  "클라루스": "CLAR",
  "클라리텝": "CTEV",
  "클라비요": "KVYO",
  "클라우다스트럭쳐": "CSAI",
  "클라우드플레어": "NET",
  "클라임글로벌솔루션스": "CLMB",
  "클라임바이오": "CLYM",
  "클래리베이트": "CLVT",
  "클렌": "CLNN",
  "클로버헬스인베스트먼츠": "CLOV",
  "클리누벨파마슈티컬스ADR": "CUVL",
  "클리블랜드-클리프스": "CLF",
  "클리어마인드메디슨": "CMND",
  "클리어사인테크놀로지스": "CLIR",
  "클리어시큐어": "YOU",
  "클리어씽크1애퀴지션": "CTAA",
  "클리어원": "CLRO",
  "클리어웨이에너지ClassC": "CWEN",
  "클리어채널아웃도어홀딩스": "CCO",
  "클리어포인트뉴로": "CLPT",
  "클리어필드": "CLFD",
  "클리퍼리얼티": "CLPR",
  "클릭홀딩스": "CLIK",
  "클린스파크": "CLSK",
  "클린에너지테크놀로지스": "CETY",
  "클린에너지퓨얼스": "CLNE",
  "클린워터페이퍼": "CLW",
  "클린코어솔루션스": "ZONE",
  "클린하버스": "CLH",
  "키네틱홀딩스": "KNTK",
  "키닉사파마슈티컬스인터내셔널": "KNSA",
  "키메라인베스트먼트": "CIM",
  "키메라테라퓨틱스": "KYMR",
  "키모맵테라퓨틱스ADR": "CMMB",
  "키사이트테크놀로지스": "KEYS",
  "키스톤애퀴지션": "KEYY",
  "키오라파마슈티컬스": "KPRX",
  "키와우니사이언티픽": "KEQU",
  "키이우스타그룹": "KYIV",
  "키코프": "KEY",
  "키트로닉": "KTCC",
  "킨더모건": "KMI",
  "킨드릴홀딩스": "KD",
  "킨로스골드": "KGC",
  "킨세일캐피털그룹": "KNSL",
  "킨트라바이오": "KYNB",
  "킬로이리얼티": "KRC",
  "킬인프라스트럭처": "KEEL",
  "킴벌리클라크": "KMB",
  "킴볼일렉트로닉스": "KE",
  "킴코리얼티": "KIM",
  "킹소프트클라우드홀딩스ADR": "KC",
  "킹스웨이": "KWY",
  "킹스톤컴퍼니": "KINS",
  "타겟": "TGT",
  "타겟호스피탈리티": "TH",
  "타르가리소스": "TRGP",
  "타불라": "TBLA",
  "타비아애퀴지션": "TAVI",
  "타서스파마슈티컬스": "TARS",
  "타오위브": "TWAV",
  "타오핑": "TAOP",
  "타운뱅크": "TOWN",
  "타운스퀘어미디어": "TSQ",
  "타워세미컨덕터": "TSEM",
  "타이드워터": "TDW",
  "타이라바이오사이언시스": "TYRA",
  "타이샤젠테라피": "TSHA",
  "타이슨푸드": "TSN",
  "타이탄마이닝": "TII",
  "타이탄머시너리": "TITN",
  "타이탄아메리카": "TTAM",
  "타이탄애퀴지션": "TACH",
  "타이탄인터내셔널": "TWI",
  "타일러테크놀로지스": "TYL",
  "탄자니아골드": "TRX",
  "탄테크홀딩스": "TANH",
  "탈렌에너지": "TLN",
  "탈로스에너지": "TALO",
  "탈론캐피털": "TLNC",
  "탈페라": "TLPH",
  "탑십스": "TOPS",
  "탑웰스그룹홀딩": "TWG",
  "탑킹윈": "DPU",
  "탑파이낸셜그룹": "TOP",
  "탑포인트홀딩스": "TOPP",
  "태스크어스": "TASK",
  "태피스트리": "TPR",
  "택타일시스템테크놀로지": "TCMD",
  "탠덤다이어비츠케어": "TNDM",
  "탠디레더팩토리": "TLF",
  "탬보란리소시스": "TBN",
  "탱고테라퓨틱스": "TNGX",
  "터닝포인트브랜드": "TPB",
  "터보에너지ADR": "TURB",
  "터틀비치": "TBCH",
  "턴그레이테크놀로지스": "TRSG",
  "턴테라퓨틱스": "TTRX",
  "테나리스ADR": "TS",
  "테나야테라퓨틱스": "TNYA",
  "테낙스테라퓨틱스": "TENX",
  "테너블홀딩스": "TENB",
  "테넌트": "TNC",
  "테네시밸리오쏘리티선순위채권시리즈A만기2029년": "TVE",
  "테네시밸리오쏘리티선순위채권시리즈D만기2028년": "TVC",
  "테넷헬스케어": "THC",
  "테논메디컬": "TNON",
  "테라다인": "TER",
  "테라데이타": "TDC",
  "테라반스바이오파마": "TBPH",
  "테라울프": "WULF",
  "테라이노바툼글로벌": "NKLR",
  "테라퓨틱스MD": "TXMD",
  "테레노리얼티": "TRNO",
  "테레스트리얼에너지": "IMSR",
  "테렉스": "TEX",
  "테르니움ADR": "TX",
  "테리바바이오로직스": "TOVX",
  "테바파마슈티컬인더스트리ADR": "TEVA",
  "테슬라": "TSLA",
  "테이크-투인터랙티브소프트웨어": "TTWO",
  "테일러디바이시스": "TAYD",
  "테일윈드2.0애퀴지션": "TDWD",
  "테코젠": "TGEN",
  "테크노글래스홀딩스": "TGLS",
  "테크닙FMC": "FTI",
  "테크타겟": "TTGT",
  "테크프레시젼": "TPCS",
  "테트라테크": "TTEK",
  "테트라테크놀로지스": "TTI",
  "테혼랜치": "TRC",
  "텍리소스": "TECK",
  "텍사스로드하우스": "TXRH",
  "텍사스벤처스애퀴지션III": "TVA",
  "텍사스벤처스애퀴지션IV": "TVIV",
  "텍사스인스트루먼트": "TXN",
  "텍사스캐피털뱅크셰어스": "TCBI",
  "텍사스캐피털뱅크셰어스우선주SeriesB5.75%": "TCBIO",
  "텍사스커뮤니티뱅크셰어": "TCBS",
  "텍사스퍼시픽랜드": "TPL",
  "텍손홀딩": "NPT",
  "텍스트론": "TXT",
  "텍토닉테라퓨틱": "TECX",
  "텐리그인터내셔널홀딩스": "TLIH",
  "텐센트뮤직엔터테인먼트그룹ADR": "TME",
  "텐저": "SKT",
  "텔라닥헬스": "TDOC",
  "텔라바이오": "TELA",
  "텔러스": "TU",
  "텔레다인테크놀로지스": "TDY",
  "텔레샛": "TSAT",
  "텔레콤아르헨티나ADR": "TEO",
  "텔레포니카브라질ADR": "VIV",
  "텔레폰악티에볼라예트에릭슨ADR": "ERIC",
  "텔레폰앤데이터시스템즈": "TDS",
  "텔레플렉스": "TFX",
  "텔로미르파마슈티컬스": "TELO",
  "텔로스": "TLS",
  "텔릭스파마슈티컬스ADR": "TLX",
  "텔콤인도네시아ADR": "TLK",
  "템퍼스AI": "TEM",
  "템피스트테라퓨틱스": "TPST",
  "토닉스파마슈티컬스홀딩": "TNXP",
  "토로": "TORO",
  "토론토도미니언은행": "TD",
  "토리드홀딩스": "CURV",
  "토미인바이런먼털솔루션스": "TOMZ",
  "토스트": "TOST",
  "토요": "TOYO",
  "토요타자동차ADR": "TM",
  "토크스페이스": "TALK",
  "토큰캣ADR": "TC",
  "토탈에너지스": "TTE",
  "톤스트래티지": "TONX",
  "톨브라더스": "TOL",
  "톰": "TRMD",
  "톰슨로이터": "TRI",
  "톰킨스파이낸셜": "TMP",
  "투뉴ADR": "TOUR",
  "투르크젤을레티심히즈메틀레리ADR": "TKC",
  "투시롤인더스트리스": "TR",
  "투야ADR": "TUYA",
  "투카우스": "TCX",
  "투하버스인베스트먼트": "TWO",
  "투후라바이오사이언스": "HURA",
  "튜터페리니": "TPC",
  "트라이넷그룹": "TNET",
  "트라이던트디지털테크홀딩스": "TDTH",
  "트라이베카스트래티직애퀴지션": "BID",
  "트라이엄프파이낸셜": "TFIN",
  "트라이코뱅크셰어스": "TCBK",
  "트라이턴인터내셔널우선주시리즈C7.375%": "TRTN-P-A",
  "트라이하드홀딩스": "THH",
  "트래버테라퓨틱스": "TVTX",
  "트래블러스컴퍼니스": "TRV",
  "트래블앤레저": "TNL",
  "트래블주": "TZOO",
  "트래저": "COOK",
  "트랙터서플라이": "TSCO",
  "트랜스다임그룹": "TDG",
  "트랜스레이셔널디벨롭먼트애퀴지션": "TDAC",
  "트랜스메딕스그룹": "TMDX",
  "트랜스알타": "TAC",
  "트랜스액트테크놀로지스": "TACT",
  "트랜스오션": "RIG",
  "트랜스유니온": "TRU",
  "트랜스캣": "TRNS",
  "트랜스컨티넨탈리얼티인베스터": "TCI",
  "트랜스코드테라퓨틱스": "RNAZ",
  "트러스트마크": "TRMK",
  "트러스트코은행NY": "TRST",
  "트럼프미디어&테크놀로지그룹": "DJT",
  "트레데가": "TG",
  "트레비테라퓨틱스": "TRVI",
  "트레이드데스크": "TTD",
  "트레이드웹마켓": "TW",
  "트레인테크놀로지": "TT",
  "트레일블래이저애퀴지션": "BLZR",
  "트레저글로벌": "TGL",
  "트레코메탈스": "TGB",
  "트렉스": "TREX",
  "트로녹스홀딩스": "TROX",
  "트로스파르마": "TRAW",
  "트루골프홀딩스": "TRUG",
  "트루블루": "TBI",
  "트루이스트파이낸셜": "TFC",
  "트루패니언": "TRUP",
  "트룰리브캐나비스": "TRLV",
  "트룹스": "TROO",
  "트리니티바이오테크ADR": "TRIB",
  "트리니티인더스트리스": "TRN",
  "트리니티캐피탈": "TRIN",
  "트리마스": "TRS",
  "트리바고ADR": "TRVG",
  "트리스메디컬컨셉트": "TMCI",
  "트리오테크인터내셔널": "TRT",
  "트리오퍼트롤리엄": "TPET",
  "트리플포인트벤처그로스BDC": "TPVG",
  "트리플플래그프레셔스메탈스": "TFPM",
  "트릴러그룹": "ILLR",
  "트릴로지메탈": "TMQ",
  "트림블": "TRMB",
  "트립닷컴그룹ADR": "TCOM",
  "트립어드바이저": "TRIP",
  "트웬티원캐피털": "XXI",
  "트웰브시즈인베스트먼트컴퍼니III": "TWLV",
  "트위스트바이오사이언스": "TWST",
  "트윈디스크": "TWIN",
  "트윈비파워캣츠": "VEEE",
  "트윌리오": "TWLO",
  "티고에너지": "TYGO",
  "티로웨프라이스그룹": "TROW",
  "티발디테라퓨틱스": "TVRD",
  "티보젠": "TVGN",
  "티빅헬스시스템스": "VBIO",
  "티스탬프": "IDAI",
  "티안시인터내셔널": "CIIT",
  "티즈홀딩": "TEAD",
  "티케이": "TK",
  "티케이탱커스": "TNK",
  "틸레이브랜즈": "TLRY",
  "틸리스": "TLYS",
  "팀": "TISI",
  "팀ADR": "TIMB",
  "팀버랜드뱅코프": "TSBK",
  "팀셰어스": "TMS",
  "팀켄": "TKR",
  "팁트리": "TIPT",
  "파가야테크놀로지스": "PGY",
  "파그세구로디지털": "PAGS",
  "파라노부스엔터테인먼트테크놀로지": "PAVS",
  "파라마운트골드네바다": "PZG",
  "파라마운트스카이댄스": "PSKY",
  "파라빌리스메디슨스": "PBLS",
  "파라제로테크놀로지스": "PRZO",
  "파렐라와인버그파트너스": "PWP",
  "파르미": "FAMI",
  "파마사이트바이오테크": "PMCB",
  "파머스&머천츠뱅코프": "FMAO",
  "파머스내셔널은행": "FMNB",
  "파머스퀘어캐피털BDC": "PSBD",
  "파밍그룹ADR": "PHAR",
  "파바비스NV": "PHVS",
  "파브메드": "PAVM",
  "파슨스": "PSN",
  "파슬그룹": "FOSL",
  "파시라바이오사이언스": "PCRX",
  "파시테아테라퓨틱스": "KTTA",
  "파에스테라퓨틱스": "FTH",
  "파오스테크놀로지홀딩스": "POAS",
  "파운더그룹": "FGL",
  "파워로10": "PWRL",
  "파워리츠": "PW",
  "파워뱅크": "PBK",
  "파워솔루션스인터내셔널": "PSIX",
  "파워인티그레이션": "POWI",
  "파워컴퓨트": "PWCM",
  "파워플리트": "AIOT",
  "파월인더스트리스": "POWL",
  "파웰맥스": "PMAX",
  "파이낸셜인스티튜션스": "FISI",
  "파이낸스오브아메리카컴퍼니스": "FOA",
  "파이더스인베스트먼트": "FDUS",
  "파이로파이트애퀴지션II": "PAII",
  "파이버인터내셔널": "FVRR",
  "파이브나인": "FIVN",
  "파이브로바이올로직스": "FBLG",
  "파이브빌로우": "FIVE",
  "파이브스타뱅코프": "FSBC",
  "파이브포인트홀딩스": "FPH",
  "파이서브": "FISV",
  "파이어니어애퀴지션I": "PACH",
  "파이어니어파워솔루션스": "PPSI",
  "파이어리": "FIRY",
  "파이어플라이뉴로사이언스": "AIFF",
  "파이어플라이에어로스페이스": "FLY",
  "파이오니아뱅코프": "PBFS",
  "파이퍼샌들러컴퍼니스": "PIPR",
  "파인애플파이낸셜": "PAPL",
  "파카": "PCAR",
  "파커-하니핀": "PH",
  "파크-오하이오홀딩스": "PKOH",
  "파크내셔널": "PRK",
  "파크덴탈파트너스": "PARK",
  "파크뱅코프": "PKBK",
  "파크에어로스페이스": "PKE",
  "파크하바이오테크": "BYAH",
  "파크호텔&리조트": "PK",
  "파트리아인베스트먼트": "PAX",
  "파파존스인터내셔널": "PZZA",
  "파퍼시픽홀딩스": "PARR",
  "파퓰러": "BPOP",
  "파퓰러캐피탈트러스트II우선주6.125%": "BPOPM",
  "팔라다인AI": "PDYN",
  "팔라틴테크놀로지스": "PTN",
  "팔란티어테크놀로지스": "PLTR",
  "팔로마애퀴지션I": "PALO",
  "팔로마홀딩스": "PLMR",
  "팔로알토네트웍스": "PANW",
  "팔리사드바이오": "PALI",
  "팔벨라테라퓨틱스": "PVLA",
  "팔콘스비욘드글로벌": "FBYD",
  "팔콘스비욘드우선주SeriesB": "FBYDP",
  "팜랜드파트너스": "FPI",
  "팝컬처그룹": "CPOP",
  "팡게아로지스틱스솔루션스": "PANL",
  "패러데이퓨처인텔리전트일렉트릭": "FFAI",
  "패브리넷": "FN",
  "패브릭AI": "FABC",
  "패섬홀딩스": "FTHM",
  "패스널": "FAST",
  "패스워드파이낸셜": "CASH",
  "패스트트랙엔터테인먼트": "FTRK",
  "패스틀리": "FSLY",
  "패시지바이오": "PASG",
  "패썸파마슈티컬스": "PHAT",
  "패키징코퍼레이션오브아메리카": "PKG",
  "패터슨-UTI에너지": "PTEN",
  "패턴그룹": "PTRN",
  "패트리엇내셔널뱅코프": "PNBK",
  "패트리엇애퀴지션": "PTAC",
  "패트릭인더스트리스": "PATK",
  "패트파인더뱅코프": "PBHC",
  "팩스그룹": "PACS",
  "팩토리얼에너지": "FAC",
  "팩트II애퀴지션": "FACT",
  "팩트셋리서치시스템즈": "FDS",
  "팬아메리카실버": "PAAS",
  "팬티지스캐피털애퀴지션": "PGAC",
  "팻파이프": "FATN",
  "퍼거슨엔터프라이즈": "FERG",
  "퍼도세오에듀케이션": "PRDO",
  "퍼마-파이프인터내셔널홀딩스": "PPIH",
  "퍼마-픽스인바이런먼털서비스": "PESI",
  "퍼보에너지": "FRVO",
  "퍼브매틱": "PUBM",
  "퍼블릭서비스엔터프라이즈": "PEG",
  "퍼블릭스토리지": "PSA",
  "퍼블릭폴리시홀딩컴퍼니": "PPHC",
  "퍼셉티브캐피털솔루션스": "FRNM",
  "퍼슈트어트랙션스앤호스피탈리티": "PRSU",
  "퍼스날리스": "PSNL",
  "퍼스트US뱅크셰어스": "FUSB",
  "퍼스트개런티뱅그셰어스우선주시리즈A6.75%": "FGBIP",
  "퍼스트개런티뱅크셰어스": "FGBI",
  "퍼스트내셔널": "FXNC",
  "퍼스트노던커뮤니티뱅코프": "FNRN",
  "퍼스트노스웨스트뱅코프": "FNWB",
  "퍼스트딥스닷컴": "DIBS",
  "퍼스트머제스틱실버": "AG",
  "퍼스트머천츠": "FRME",
  "퍼스트머천트": "FRMEP",
  "퍼스트미드뱅크셰어스": "FMBH",
  "퍼스트뱅코프": "FNLC",
  "퍼스트뱅코프(노스캐롤라이나)": "FBNC",
  "퍼스트뱅코프푸에르토리코": "FBP",
  "퍼스트뱅크": "FRBA",
  "퍼스트뷰지": "BUSE",
  "퍼스트뷰지우선주SeriesB8.25%": "BUSEP",
  "퍼스트비즈니스파이낸셜서비스": "FBIZ",
  "퍼스트서비스": "FSV",
  "퍼스트선캐피털뱅코프": "FSUN",
  "퍼스트소스": "SRCE",
  "퍼스트솔라": "FSLR",
  "퍼스트시코스트뱅코프": "FSEA",
  "퍼스트시티즌스뱅크셰어스": "FCNCA",
  "퍼스트시티즌스뱅크셰어스우선주시리즈A5.375%": "FCNCP",
  "퍼스트시티즌스뱅크셰어스우선주시리즈C5.625%": "FCNCO",
  "퍼스트시티즌스우선주SeriesE": "FCNCN",
  "퍼스트아메리칸파이낸셜": "FAF",
  "퍼스트어드밴티지": "FA",
  "퍼스트에너지": "FE",
  "퍼스트와치레스토랑그룹": "FWRG",
  "퍼스트웨스턴파이낸셜": "MYFW",
  "퍼스트유나이티드": "FUNC",
  "퍼스트인더스트리얼리얼티트러스트": "FR",
  "퍼스트인터넷뱅코프": "INBK",
  "퍼스트인터스테이트뱅크시스템": "FIBK",
  "퍼스트캐롤리나파이낸셜서비스": "FCBM",
  "퍼스트캐쉬홀딩스": "FCFS",
  "퍼스트캐피탈": "FCAP",
  "퍼스트커먼웰스파이낸셜": "FCF",
  "퍼스트커뮤니티": "FCCO",
  "퍼스트커뮤니티뱅크셰어스": "FCBC",
  "퍼스트트랙스바이오테라퓨틱": "TRAX",
  "퍼스트파이낸셜": "THFF",
  "퍼스트파이낸셜뱅코프": "FFBC",
  "퍼스트파이낸셜뱅크셰어스": "FFIN",
  "퍼스트하와이안": "FHB",
  "퍼스트호라이즌": "FHN",
  "퍼스펙티브테라퓨틱스": "CATX",
  "퍼시픽가스&일렉트릭": "PCG-P-A",
  "퍼시픽바이오사이언시스오브캘리포니아": "PACB",
  "퍼싱스퀘어": "PS",
  "퍼싱스퀘어USA": "PSUS",
  "퍼페투아리소시스": "PPTA",
  "퍼펙트": "PERF",
  "퍼포먼스쉬핑": "PSHG",
  "퍼포먼스푸드그룹": "PFGC",
  "퍼플바이오테크ADR": "PPBT",
  "퍼플이노베이션": "PRPL",
  "펀웨어": "PHUN",
  "펀코": "FNKO",
  "펄다이버크레디트": "PDCC",
  "펄다이버크레딧우선주SeriesA8.00%": "PDPA",
  "펄센모어": "PLSM",
  "펄스바이오사이언스": "PLSE",
  "펄젠트제네틱스": "FLGT",
  "페가시스템즈": "PEGA",
  "페넌트그룹": "PNTG",
  "페넌트파크인베트스트먼트": "PNNT",
  "페넌트파크플로팅레이트캐피탈": "PFLT",
  "페넘브라": "PEN",
  "페넥파머수티컬스": "FENC",
  "페니맥모기지인베스트먼트": "PMT",
  "페니맥파이낸셜서비스": "PFSI",
  "페더럴리얼티인베스트먼트트러스트": "FRT",
  "페더럴시그널": "FSS",
  "페더럴애그리컬처럴모기지ClassC": "AGM",
  "페더레이티드헤르메스": "FHI",
  "페덱스": "FDX",
  "페덱스프레이트홀딩컴퍼니": "FDXF",
  "페디아트릭스메디컬그룹": "MD",
  "페라리": "RACE",
  "페라소": "PRSO",
  "페로글로브": "GSM",
  "페로비알": "FER",
  "페르미": "FRMI",
  "페르미안리소시스": "PR",
  "페리고": "PRGO",
  "페리미터솔루션스": "PRM",
  "페리미터애퀴지션I": "PMTR",
  "페리언네트워크": "PERI",
  "페블브룩호텔트러스트": "PEB",
  "페어아이작": "FICO",
  "페이먼트어스홀딩스": "PAY",
  "페이세이프": "PSFE",
  "페이오니아글로벌": "PAYO",
  "페이첵스": "PAYX",
  "페이콤소프트웨어": "PAYC",
  "페이트테라퓨틱스": "FATE",
  "페이팔홀딩스": "PYPL",
  "페이페이ADR": "PAYP",
  "페일로시티홀딩": "PCTY",
  "펜보홀딩스": "FEBO",
  "펜스케오토모티브그룹": "PAG",
  "펜엔터테인먼트": "PENN",
  "펜테어": "PNR",
  "펠라고스인슈어런스캐피탈": "PLGO",
  "펠로튼인터랙티브": "PTON",
  "펠소스테라퓨틱스": "PTHS",
  "펨비나파이프라인": "PBA",
  "펩시코": "PEP",
  "펩젠": "PEPG",
  "펫코헬스앤웰니스컴퍼니": "WOOF",
  "펭귄솔루션스": "PENG",
  "포그혼테라퓨틱스": "FHTX",
  "포노캐피탈포": "PONO",
  "포니AIADR": "PONY",
  "포드모터": "F",
  "포드캐스톤": "PODC",
  "포라프릭글로벌": "AFRI",
  "포럼마켓츠": "FRMM",
  "포럼에너지테크놀로지스": "FET",
  "포레스타그룹": "FOR",
  "포레스터리서치": "FORR",
  "포르테바이오사이언스": "FBRX",
  "포르투나마이닝": "FSM",
  "포르티스": "FTS",
  "포멘토에코노미코멕시카노ADR": "FMX",
  "포모스트클린에너지": "FMST",
  "포뮬러시스템즈1985ADR": "FORTY",
  "포뮬러원그룹SeriesA": "FWONA",
  "포뮬러원그룹SeriesC": "FWONK",
  "포브라이트": "FRBT",
  "포스코홀딩스ADR": "PKX",
  "포스털리얼티트러스트": "PSTL",
  "포스트홀딩스": "POST",
  "포시즌스에듀케이션케이먼ADR": "FEDU",
  "포어사이트오토노모스홀딩스ADR": "FRSX",
  "포어프런트테크홀딩스애퀴지션": "FTHA",
  "포엣테크놀로지": "POET",
  "포워드에어(델라웨어)": "FWRD",
  "포워드인더스트리스": "FWDI",
  "포전트파워솔루션스": "FPS",
  "포츈브랜즈홈앤시큐리티": "FBIN",
  "포치그룹": "PRCH",
  "포커스유니버설": "FCUV",
  "포코너스프로퍼티트러스트": "FCPT",
  "포튜넥스애퀴지션": "FXAC",
  "포트레아홀딩스": "FTRE",
  "포트로닉스": "PLAB",
  "포트리스바이오텍": "FBIO",
  "포트리스바이오텍우선주시리즈A9.375%": "FBIOP",
  "포트리스밸류애퀴지션V": "FVAV",
  "포트테크놀로지": "FRTT",
  "포틀랜드제너럴일렉트릭": "POR",
  "포티넷": "FTNT",
  "포티브": "FTV",
  "포틸로스": "PTLO",
  "폭스ClassA": "FOXA",
  "폭스ClassB": "FOX",
  "폭스디벨롭먼트홀딩스": "FOXX",
  "폭스팩토리홀딩": "FOXF",
  "폰스파이낸셜그룹": "PDLB",
  "폴드홀딩스": "FLD",
  "폴라리스": "PII",
  "폴라릭스테라퓨틱스": "PLYX",
  "폴라파워": "POLA",
  "폴리벨리그룹": "PLBL",
  "폴리존": "PLRZ",
  "폴리피드": "PYPD",
  "폴스타오토모티브홀딩UKADR": "PSNY",
  "폼닥터ADR": "POM",
  "폼팩터": "FORM",
  "푸르덴셜ADR": "PUK",
  "푸르덴셜파이낸셜": "PRU",
  "푸보티비": "FUBO",
  "푸투홀딩스ADR": "FUTU",
  "풀": "POOL",
  "풀러HB": "FUL",
  "풀매트릭스": "PULM",
  "풀몬스": "LUNG",
  "풀크럼테라퓨틱스": "FULC",
  "풀턴파이낸셜": "FULT",
  "풀턴파이낸셜우선주시리즈A5.125%": "FULTP",
  "풀트럭얼라이언스ADR": "YMM",
  "풀티그룹": "PHM",
  "풀하우스리조트": "FLL",
  "퓨리골드마인스": "FURY",
  "퓨마바이오테크놀러지": "PBYI",
  "퓨어사이클": "PCYO",
  "퓨어사이클테크놀러지": "PCT",
  "퓨얼셀에너지": "FCEL",
  "퓨얼테크": "FTEK",
  "퓨전퓨얼그린": "HTOO",
  "퓨즈머신스": "FUSE",
  "퓨처머니애퀴지션": "FMAC",
  "퓨처비전II애퀴지션": "FVN",
  "퓨처코프스페이스애퀴지션1": "FTRA",
  "퓨처크레스트애퀴지션": "FCRS",
  "퓨처퓨얼": "FF",
  "퓨처핀테크그룹": "FTFT",
  "프라이메리카": "PRI",
  "프라이메크홀딩스": "PMEC",
  "프라이스스마트": "PSMT",
  "프라이어리티인컴펀드우선주시리즈J6%": "PRIF-P-D",
  "프라이오리티테크놀러지홀딩스": "PRTH",
  "프라이트테크놀로지스": "FRGT",
  "프라임메디슨": "PRME",
  "프라임에너지리소스": "PNRG",
  "프락시스프리시젼메디신": "PRAX",
  "프랑코-네바다": "FNV",
  "프랙틸헬스": "GUTS",
  "프랭클린BSP리얼티트러스트": "FBRT",
  "프랭클린리소시스": "BEN",
  "프랭클린스트리트프로퍼티스": "FSP",
  "프랭클린와이어리스": "FKWL",
  "프랭클린일렉트릭": "FELE",
  "프랭클린커비": "FC",
  "프랭클린파이낸셜서비스": "FRAF",
  "프레네틱스글로벌": "PRE",
  "프레리오퍼레이팅": "PROP",
  "프레스티지컨슈머헬스케어": "PBH",
  "프레시디오프로덕션": "FTW",
  "프레시디오프로퍼티트러스트": "SQFT",
  "프레시웍스": "FRSH",
  "프레시전드릴링": "PDS",
  "프레시젠": "PGEN",
  "프레시펫": "FRPT",
  "프레이토스": "CRGO",
  "프레이트카아메리카": "RAIL",
  "프레제니우스메디칼케어ADR": "FMS",
  "프레지디오프로퍼티트러스트우선주시리즈D9.375%": "SQFTP",
  "프레토리안애퀴지션": "PTOR",
  "프렐류드테라퓨틱스": "PRLD",
  "프로-덱스": "PDEX",
  "프로그레스소프트웨어": "PRGS",
  "프로그레시브": "PGR",
  "프로로지스": "PLD",
  "프로미스뉴로사이언시스": "PMN",
  "프로비던트파이낸셜서비스": "PFS",
  "프로비던트파이낸셜홀딩스": "PROV",
  "프로세사파마슈티컬스": "PCSA",
  "프로셉트바이오로보틱스": "PRCT",
  "프로스페리티뱅크셰어스": "PB",
  "프로스펙트캐피털": "PSEC",
  "프로엠애퀴지션I": "PAAC",
  "프로지니": "PGNY",
  "프로캡파이낸셜": "BRR",
  "프로코어테크놀러지스": "PCOR",
  "프로큐알테라퓨틱스": "PRQR",
  "프로키드니": "PROK",
  "프로타고니스트테라퓨틱스": "PTGX",
  "프로타라테라퓨틱스": "TARA",
  "프로탈릭스바이오테라퓨틱스": "PLX",
  "프로테나": "PRTA",
  "프로토랩스": "PRLB",
  "프로파운드메디컬": "PROF",
  "프로팽바이오파마": "PPCB",
  "프로페셔널다이버시티네트워크": "IPDN",
  "프로페트로홀딩": "PUMP",
  "프로퓨사": "PFSA",
  "프로프랙홀딩": "ACDC",
  "프로피시언트오토로지스틱스": "PAL",
  "프론트도어": "FTDR",
  "프론트라인": "FRO",
  "프론트뷰REIT": "FVR",
  "프론티어그룹홀딩스": "ULCC",
  "프론티어뉴클리어앤미네랄스": "FNUC",
  "프리덤메탈스애퀴지션": "FDMM",
  "프리덤홀딩": "FRHC",
  "프리드먼인더스트리스": "FRD",
  "프리모리스서비시스": "PRIM",
  "프리모브랜드": "PRMB",
  "프리미스파이낸셜": "FRST",
  "프리미엄케이터링홀딩스": "PC",
  "프리비아헬스그룹": "PRVA",
  "프리사이젼바이오사이언스": "DTIL",
  "프리슈어런스홀딩스": "PRHI",
  "프리시아": "PHR",
  "프리시전옵틱스": "POCI",
  "프리시피오": "PRPO",
  "프리캐스트": "CAST",
  "프리컨시일렉트로닉스": "FEIM",
  "프리퍼드은행": "PFBC",
  "프리퍼드플러스우선주시리즈GSC-2": "PYT",
  "프리포트맥모란": "FCX",
  "프리폼드라인프로덕츠": "PLPC",
  "프린시펄파이낸셜그룹": "PFG",
  "플라워스푸드": "FLO",
  "플라이-이그룹": "FLYE",
  "플라이와이어": "FLYW",
  "플라익스클루시브": "FLYX",
  "플래그스타파이낸셜": "FLG",
  "플래그십애퀴지션": "FSHP",
  "플래니건스엔터프라이시스": "BDL",
  "플래닛그린홀딩스": "PLAG",
  "플래닛랩스PBC": "PL",
  "플래닛이미지인터내셔널": "YIBO",
  "플래닛피트니스": "PLNT",
  "플래시스포츠앤미디어": "FLZH",
  "플래티넘그룹메탈스": "PLG",
  "플래티넘애널리틱스케이맨": "PLTS",
  "플러그파워": "PLUG",
  "플러스테라퓨틱스": "CNSY",
  "플러터엔터테인먼트": "FLUT",
  "플럭스파워홀딩스": "FLUX",
  "플럼애퀴지션IV": "PLMK",
  "플레이보이": "PLBY",
  "플레이스튜디오스": "MYPS",
  "플레이티카홀딩": "PLTK",
  "플렉서블솔루션스인터내셔널": "FSI",
  "플렉서스": "PLXS",
  "플렉스": "FLEX",
  "플렉스LNG": "FLNG",
  "플렉스스틸인더스트리스": "FLXS",
  "플로어&데코홀딩스": "FND",
  "플로우서브": "FLS",
  "플로우코홀딩스": "FLOC",
  "플로텍인더스트리스": "FTK",
  "플루리": "PLUR",
  "플루마스뱅코프": "PLBC",
  "플루언스에너지": "FLNC",
  "플루언트": "FLNT",
  "플루오르": "FLR",
  "플루토니안애퀴지션II": "PLUN",
  "플루투스파이낸션그룹": "PLUT",
  "플리언트테라퓨틱스": "PLRX",
  "피규어테크놀로지솔루션스": "FIGR",
  "피그마": "FIG",
  "피그스": "FIGS",
  "피너클웨스트캐피털": "PNW",
  "피너클파이낸셜파트너스": "PNFP",
  "피너클푸드그룹": "PFAI",
  "피니아": "PHIN",
  "피닉스뉴미디어ADR": "FENG",
  "피닉스아시아홀딩스": "PHOE",
  "피닉스에너지원우선주SeriesA10%": "PHXE-P",
  "피닉스에듀케이션파트너스": "PXED",
  "피닉스핀": "PFX",
  "피델리티D&D뱅코프": "FDBC",
  "피델리티내셔널인포메이션서비스": "FIS",
  "피델리티내셔널파이낸셜": "FNF",
  "피메이시스": "FEMY",
  "피바디에너지": "BTU",
  "피버블릭에어웨이스홀딩스": "RJET",
  "피브로애니멀헬스": "PAHC",
  "피스애퀴지션": "PECE",
  "피어슨ADR": "PSO",
  "피오파마슈티컬스": "PHIO",
  "피카드메디컬": "PMI",
  "피코셀라ADR": "PCLA",
  "피트니보우스": "PBI",
  "피트니스챔스홀딩스": "FCHL",
  "피팩글래드스턴파이낸셜": "PGC",
  "피프스디스트릭트뱅코프": "FDSB",
  "피프스서드뱅코프": "FITB",
  "피프스에라애퀴지션I": "FERA",
  "피플스뱅코프": "PEBO",
  "피플스파이낸셜서비스": "PFIS",
  "피플인코포레이티드": "PPLI",
  "픽셀웍스": "PXLW",
  "픽스": "PICS",
  "픽시스온콜로지": "PYXS",
  "픽시스탱커스": "PXS",
  "핀둬둬ADR": "PDD",
  "핀볼루션그룹ADR": "FINV",
  "핀와이즈뱅코프": "FINW",
  "핀워드뱅코프": "FNWD",
  "핀터레스트": "PINS",
  "필그림즈프라이드": "PPC",
  "필라나테라퓨틱스": "FLNA",
  "필립모리스인터내셔널": "PM",
  "필립스66": "PSX",
  "필립스반휴센": "PVH",
  "필립스에디슨&코": "PECO",
  "핏라이프브랜즈": "FTLF",
  "핑거모션": "FNGR",
  "핑안바이오메디컬": "PASW",
  "하노버뱅코프": "HNVR",
  "하노버인슈어런스그룹": "THG",
  "하드론에너지": "HDRN",
  "하모니골드마이닝ADR": "HMY",
  "하모니바이오사이언시스홀딩스": "HRMY",
  "하모닉": "HLIT",
  "하버드바이오사이언스": "HBIO",
  "하버드에비뉴애퀴지션": "HAVA",
  "하버티퍼니처": "HVT",
  "하얏트호텔": "H",
  "하오시헬스테크놀로지": "HAO",
  "하오신홀딩스": "HXHX",
  "하와이안일렉트릭인더스트리스": "HE",
  "하우멧에어로스페이스": "HWM",
  "하우스오브도지": "HODO",
  "하워드휴스홀딩스": "HHH",
  "하이-트렌드인터내셔널그룹": "HTCO",
  "하이드로팜홀딩스": "HYFM",
  "하이드말매리타임홀딩스": "HMR",
  "하이랜더실버": "HSLV",
  "하이롤러테크놀러지스": "ROLR",
  "하이맥스테크놀로지스ADR": "HIMX",
  "하이뷰머저": "HVMC",
  "하이브디지털테크놀로지스": "HIVE",
  "하이스터-예일": "HY",
  "하이어퀘스트": "HQI",
  "하이우즈프로퍼티스": "HIW",
  "하이웨이홀딩스": "HIHO",
  "하이크로프트마이닝홀딩": "HYMC",
  "하이타이드": "HITI",
  "하이텍글로벌": "HKIT",
  "하이템플러테크": "HTT",
  "하이퍼리퀴드스트래티지스": "PURR",
  "하이퍼스케일데이터": "GPUS",
  "하이퍼파인": "HYPR",
  "하이페리온디파이": "HYPD",
  "하이피크에너지": "HPK",
  "하인셀레셜그룹": "HAIN",
  "하일리온홀딩스": "HYLN",
  "하트랜드익스프레스": "HTLD",
  "하트빔": "BEAT",
  "하트사이언스": "HSCS",
  "하트코어엔터프라이시스": "HTCR",
  "하트포드인슈어런스그룹": "HIG",
  "하트플로우": "HTFL",
  "하트행크스": "HHS",
  "하프니아": "HAFN",
  "한국전력ADR": "KEP",
  "한미파이낸셜": "HAFC",
  "할로자임테라퓨틱스": "HALO",
  "할리-데이비슨": "HOG",
  "할리버튼": "HAL",
  "항펑테크놀로지이노베이션": "FOFO",
  "해거티": "HGTY",
  "해로우": "HROW",
  "해밀턴레인": "HLNE",
  "해밀턴비치브랜드홀딩": "HBB",
  "해밀턴인슈어런스그룹": "HG",
  "해이워드홀딩스": "HAYW",
  "해즈브로": "HAS",
  "해켓그룹": "HCKT",
  "해픈": "HAPN",
  "해피시티홀딩스": "HCHL",
  "핸콕휘트니": "HWC",
  "핼러도에너지": "HNRG",
  "허니웰에어로스페이스": "HONA",
  "허니웰인터내셔널": "HON",
  "허드베이미네랄": "HBM",
  "허드슨테크놀로지스": "HDSN",
  "허드슨퍼시픽프로퍼티즈": "HPP",
  "허벌라이프": "HLF",
  "허벨": "HUBB",
  "허브그룹": "HUBG",
  "허브사이버시큐리티": "HUBC",
  "허브스팟": "HUBS",
  "허쉬": "HSY",
  "허츠글로벌홀딩스": "HTZ",
  "허치메드(차이나)ADR": "HCM",
  "허코컴퍼니스": "HURC",
  "허큘리스캐피털": "HTGC",
  "허크홀딩스": "HRI",
  "헌츠맨": "HUN",
  "헌팅턴뱅그셰어스우선주SeriesJ": "HBANL",
  "헌팅턴뱅크셰어스": "HBAN",
  "헌팅턴뱅크셰어스우선주시리즈H4.5%": "HBANP",
  "헌팅턴뱅크셰어스우선주시리즈I5.7%": "HBANM",
  "헌팅턴뱅크우선주SeriesL5.50%": "HBANZ",
  "헌팅턴잉걸스인더스트리즈": "HII",
  "헛8": "HUT",
  "헤네스캐피탈인베스트먼트VII": "HVII",
  "헤네시어드바이저스": "HNNA",
  "헤네시캐피털인베스트먼트VIII": "HCIC",
  "헤런테라퓨틱스": "HRTX",
  "헤리티지글로벌": "HGBL",
  "헤리티지인슈어런스홀딩스": "HRTG",
  "헤리티지파이낸셜": "HFWA",
  "헤맙테라퓨틱스홀딩스": "COAG",
  "헤모네틱스": "HAE",
  "헤사이그룹ADR": "HSAI",
  "헤스미드스트림": "HESM",
  "헤이코": "HEI",
  "헤일리온ADR": "HLN",
  "헤클라마이닝": "HL",
  "헥셀": "HXL",
  "헨리셰인": "HSIC",
  "헬렌오브트로이": "HELE",
  "헬로그룹ADR": "MOMO",
  "헬리오스테크놀로지스": "HLIO",
  "헬릭스애퀴지션III": "HLXC",
  "헬릭스에너지솔루션스그룹": "HLX",
  "헬스스트림": "HSTM",
  "헬스에퀴티": "HQY",
  "헬스인테크": "HIT",
  "헬스카탈리스트": "HCAT",
  "헬스케어리얼티트러스트": "HR",
  "헬스케어서비스그룹": "HCSG",
  "헬스케어트라이앵글": "HCTI",
  "헬스피크프로퍼티스": "DOC",
  "헬시초이스웰니스": "HCWC",
  "헬포트AI": "HPAI",
  "호라이즌뱅코프": "HBNC",
  "호라이즌퀀텀홀딩스": "HQ",
  "호라이즌테크놀로지파이낸스": "HRZN",
  "호레이스맨에듀케이터스": "HMN",
  "호멜푸즈": "HRL",
  "호브내니언엔터프라이스": "HOV",
  "호브내니언엔터프라이스우선주시리즈A7.625%": "HOVNP",
  "호손뱅크셰어스": "HWBK",
  "호스트호텔스&리조트": "HST",
  "호인뱅코프": "HYNE",
  "호크아이360": "HAWK",
  "호킨스": "HWKN",
  "호텔101글로벌홀딩스": "HBNB",
  "호프뱅코프": "HOPE",
  "혼다자동차ADR": "HMC",
  "홀리": "HLLY",
  "홀채드윅애퀴지션": "HCAC",
  "홈디포": "HD",
  "홈뱅코프": "HBCP",
  "홈뱅크셰어스": "HOMB",
  "홈스투라이프": "HTLM",
  "홈트러스트뱅크셰어스": "HTB",
  "홈페더럴뱅코프오브루이지아나": "HFBL",
  "홍리그룹": "HLP",
  "화디인터내셔널그룹": "HUDI",
  "화이자": "PFE",
  "화이트마운틴스인슈어런스그룹": "WTM",
  "화이트파이버": "WYFI",
  "화이트펄애퀴지션": "WPAC",
  "화이트호스파이낸스": "WHF",
  "화이트호크미네랄스": "WHK",
  "화이트호크테라퓨틱스": "WHWK",
  "화주그룹": "HTHT",
  "화천AI파킹매니지먼트테크놀로지": "HCAI",
  "후야ADR": "HUYA",
  "후이쩌홀딩ADR": "HUIZ",
  "후커퍼니싱스": "HOFT",
  "후후테크인터내셔널그룹": "HUHU",
  "훌리한로키": "HLI",
  "휘턴프레셔스메탈스": "WPM",
  "휠러리얼에스테이트인베스트": "WHLR",
  "휠러리얼에스테이트인베스트우선주시리즈B9.000%": "WHLRP",
  "휠러리얼에스테이트인베스트우선주시리즈D8.75%": "WHLRD",
  "휠즈업익스피리언스": "UP",
  "휴런컨설팅그룹": "HURN",
  "휴렛패커드엔터프라이즈": "HPE",
  "휴마나": "HUM",
  "휴마사이트": "HUMA",
  "히말라야쉬핑": "HSHP",
  "히어그룹ADR": "HERE",
  "히포홀딩스": "HIPO",
  "힌지헬스": "HNGE",
  "힐먼솔루션스": "HLMN",
  "힐탑홀딩스": "HTH",
  "힐튼그랜드베케이션스": "HGV",
  "힐튼월드와이드홀딩스": "HLT",
  "힘스&허즈": "HIMS",
  "힝엄인스티튜션포세이빙스": "HIFS",
};

export const US_KO_ORIG_TO_TICKER: Record<string, string> = {
  "1-800 플라워스닷컴": "FLWS",
  "10X 제노믹스": "TXG",
  "111 ADR": "YI",
  "17 에듀케이션 앤 테크놀로지 ADR": "YQ",
  "1RT 애퀴지션": "ONCH",
  "20/20 바이오랩스": "AIDX",
  "22세기 그룹": "XXII",
  "3 E 네트워크 테크놀로지 그룹": "MASK",
  "36KR 홀딩스 ADR": "KRKR",
  "374워터": "SCWO",
  "4D 몰레큘러 테라퓨틱스": "FDMT",
  "51토크 온라인 에듀케이션 그룹 ADR": "COE",
  "5E 어드밴스드 머터리얼즈": "FEAM",
  "60 디그리스 파마슈티컬스": "SXTP",
  "707 케이맨 홀딩스": "JEM",
  "8i 애퀴지션 2": "EUDA",
  "8x8": "EGHT",
  "908 디바이시스": "MASS",
  "9F ADR": "JFU",
  "A O 스미스": "AOS",
  "A 패러다이스 애퀴지션": "ENHA",
  "A10 네트웍스": "ATEN",
  "A2Z 커스투메이트 솔루션스": "AZ",
  "AA 미션 애퀴지션 II": "YCY",
  "ABM 인더스트리즈": "ABM",
  "ABVC 바이오파마": "ABVC",
  "AC 이뮨": "ACIU",
  "ACI 월드와이드": "ACIW",
  "ACM 리서치": "ACMR",
  "ACP 홀딩스 애퀴지션": "ACGC",
  "ACV 옥션스": "ACVA",
  "ADC 테라퓨틱스": "ADCT",
  "ADI 글로벌 디스트리뷰션": "ADIG",
  "ADMA 바이오로직스": "ADMA",
  "AEA-브릿지스 임팩트": "LVWR",
  "AGI": "AGI",
  "AGM 그룹 홀딩스": "AGMH",
  "AGNC 인베스트먼트": "AGNC",
  "AGNC 인베스트먼트 우선주 Series H 8.75%": "AGNCZ",
  "AGNC 인베스트먼트 우선주 시리즈 C": "AGNCN",
  "AGNC 인베스트먼트 우선주 시리즈 D": "AGNCM",
  "AGNC 인베스트먼트 우선주 시리즈 E": "AGNCO",
  "AGNC 인베스트먼트 우선주 시리즈 F": "AGNCP",
  "AGNC 인베스트먼트 우선주 시리즈 G": "AGNCL",
  "AH 리얼티 트러스트": "AHRT",
  "AI 인프라스트럭처 애퀴지션": "AIIA",
  "AI 파이낸셜": "AIFC",
  "AIAI 홀딩스": "AIAI",
  "AIB 데이터 센터스": "AIB",
  "AIM 이뮤노테크": "AIM",
  "AIOS 테크": "AIOS",
  "AIRO 그룹 홀딩스": "AIRO",
  "AIx크립토 홀딩스": "AIXC",
  "AKA 브랜즈 홀딩": "AKA",
  "ALX 온콜로지 홀딩스": "ALXO",
  "AMC 글로벌 미디어": "AMCX",
  "AMC 로보틱스": "AMCI",
  "AMC 엔터테인먼트 홀딩스": "AMC",
  "AMD(어드밴스드 마이크로 디바이시스)": "AMD",
  "AMN 헬스케어 서비스": "AMN",
  "AMTD 디지털": "HKD",
  "AMTD 아이디어 그룹 ADR": "AMTD",
  "AN2 테라퓨틱스": "ANTX",
  "ANI 파마슈티컬스": "ANIP",
  "APEX 테크 애퀴지션": "TRAD",
  "APi 그룹": "APG",
  "ARB IOT 그룹": "ARBB",
  "ARC 그룹 애퀴지션 I": "ARCL",
  "ARS 파마슈티컬스": "SPRY",
  "ARXIS": "ARXS",
  "ASE 테크놀로지 홀딩 ADR": "ASX",
  "ASML 홀딩 ADR": "ASML",
  "ASP 아이소토프": "ASPI",
  "AST 스페이스모바일": "ASTS",
  "ATA 크리에이티비티 글로벌 ADR": "AACG",
  "ATIF 홀딩스": "AUC",
  "ATN 인터내셔널": "ATNI",
  "AT리뉴 ADR": "RERE",
  "AVAX 원 테크놀로지": "AVX",
  "Aar": "AIR",
  "Aberdeen Government Markets": "MGF",
  "Aberdeen India Fund": "IFN",
  "Aberdeen Intermediate": "MIN",
  "Aberdeen Multi-Market": "MMT",
  "Aberdeen Municipal": "MFM",
  "Acnb": "ACNB",
  "Adams Diversified Equity Fund，Inc.": "ADX",
  "Adams Natural Resources Fund，Inc.": "PEO",
  "Adt": "ADT",
  "Advent Convertible and Income Fund": "AVK",
  "Aes": "AES",
  "Aevex": "AVEX",
  "Agi": "AGBK",
  "Agnt": "AGNT",
  "AiRWA": "YYAI",
  "Aifu": "AIFU",
  "Alliance National Municipal": "AFB",
  "Alliance Resource Partners Units": "ARLP",
  "AllianceBernstein Holding, L.P.": "AB",
  "Allianceberstein Global High": "AWF",
  "Allspring": "EAD",
  "Allspring Global Dividend Opportunity Fund": "EOD",
  "Allspring Multi-Sector Income Fund": "ERC",
  "Allspring Utilities And High Income Mutual Fund": "ERH",
  "Angel Oak Financial Strategies Income Term Trust": "FINS",
  "Anglogold Ashanti PLC": "ANG-P-D",
  "Apa": "APA",
  "Apnimed Inc": "APMD",
  "Ares Dynamic Credit Allocation Fund Inc": "ARDC",
  "Asa Gold And Precious Metals": "ASA",
  "Ascendis Pharma A/S Ordinary Share": "ASND",
  "At&T": "T",
  "Athene Holding DS Representing 1 1000 Pref Shs Series A": "ATH-P-A",
  "Ati": "ATI",
  "Ats": "ATS",
  "Axt": "AXTI",
  "Azz": "AZZ",
  "B.O.S. 베터 온라인 솔루션스": "BOSC",
  "B2골드": "BTG",
  "BBB 푸드": "TBBB",
  "BCB 뱅코프": "BCBP",
  "BCP 인베스트먼트": "BCIC",
  "BERKSHIRE HATHAWAY Class B": "BRK-B",
  "BFC 캐피탈 트러스트 II 우선주 7.2%": "BANFP",
  "BGM 그룹": "BGM",
  "BHP 그룹 ADR": "BHP",
  "BJ's 홀세일 클럽 홀딩스": "BJ",
  "BK 테크놀로지스": "BKTI",
  "BNY Mellon High Yield Strategies Fund": "DHF",
  "BNY Mellon Municipal Bond Infrastructure Fund In": "DMB",
  "BNY Mellon Strategic Municipal Bond Fund Inc": "DSM",
  "BNY Mellon Strategic Municipals Inc": "LEO",
  "BOK 파이낸셜": "BOKF",
  "BP p.l.c.": "BP",
  "BRBI BR 파트너스 ADR": "BRBI",
  "BRC": "BRC",
  "BRC 그룹 홀딩스": "RILY",
  "BRC 그룹 홀딩스 우선주 시리즈 A 6.875%": "RILYP",
  "BRC 그룹 홀딩스 우선주 시리즈 B 7.375%": "RILYL",
  "BRT 아파트먼트": "BRT",
  "BT 브랜즈": "BTBD",
  "BTC 디벨롭먼트": "BDCI",
  "BTC 디지털": "BTCT",
  "BTQ 테크놀로지스": "BTQ",
  "BUUU 그룹": "BUUU",
  "BWX 테크놀로지스": "BWXT",
  "Banco Bradesco ADS Representing 1 Ord Shs": "BBDO",
  "Bancroft Closed Fund": "BCV",
  "Bank OZK Series A Preferred Stock": "OZKAP",
  "Banzai International": "PARA",
  "Barings Corporate Investors": "MCI",
  "Barings Global Short Duration High Yield Fund": "BGH",
  "Barings Participation Investors": "MPV",
  "Bce": "BCE",
  "Berkshire Hathaway Inc.": "BRK-A",
  "Bgc 그룹": "BGC",
  "Bgsf": "BGSF",
  "Biglari Holdings Inc. Class A Common Stock": "BH-A",
  "Bio-Rad Laboratories, Inc. Class B": "BIO-B",
  "BioStem Technologies  Inc.": "BSEM",
  "BitVentures Ltd": "BVC",
  "Bkv": "BKV",
  "Black Stone Minerals, L.P.": "BSM",
  "BlackRock 2037 Municipal Target Term Trust": "BMN",
  "BlackRock Capital Allocation Term Closed End Fund": "BCAT",
  "BlackRock Credit Allocation Income Trust": "BTZ",
  "BlackRock ESG Capital Allocation Term Closed End Fund": "ECAT",
  "BlackRock Enhanced Equity Dividend Trust": "BDJ",
  "BlackRock Enhanced Global Dividend Closed End Fund": "BOE",
  "BlackRock Enhanced International Dividend Closed End Fund": "BGY",
  "BlackRock Enhanced Large Cap Core Fund": "CII",
  "BlackRock Floating Rate Income Closed Fund": "BGT",
  "BlackRock Health Sciences Term Closed End Fund": "BMEZ",
  "BlackRock Income Trust，Inc.": "BKT",
  "BlackRock Municipal 2030 Target Term Trust": "BTT",
  "BlackRock Science and Technology Term Closed End Fund": "BSTZ",
  "BlackRock Science and Technology Trust": "BST",
  "BlackRock Taxable Municipal Bond Trust": "BBN",
  "BlackRock Technology and Private Equity Term Trust": "BTX",
  "BlackRock Utilities Infrastructure & Power Oppty": "BUI",
  "BlackRock Virginia Muni Bond Trust": "BHV",
  "Blackrock": "BLW",
  "Blackrock Core Bd Tr": "BHK",
  "Blackrock Debt Strategies Fund": "DSU",
  "Blackrock Energy and Resources Trust": "BGR",
  "Blackrock Floating Rate": "FRA",
  "Blackrock Health Sciences Trust": "BME",
  "Blackrock Multi-Sector": "BIT",
  "Blackrock Muni Assets Fund": "MUA",
  "Blackrock Muni Yield Quality Fund": "MQY",
  "Blackrock Muniholdings California Quality Fund": "MUC",
  "Blackrock Muniholdings Fund": "MHD",
  "Blackrock Muniholdings New Jersey Quality Fund": "MUJ",
  "Blackrock Muniyield Michigan Quality Fund": "MIY",
  "Blackrock Muniyield New York Quality Fund": "MYN",
  "Blackrock Muniyield Pennsylvania Quality Fund": "MPA",
  "Blackrock Muniyield Quality Fund Iii": "MYI",
  "Blackrock Resourcescommodities Strategy Trust": "BCX",
  "Blackstone Long-Short Credit": "BGX",
  "Blackstone Senior Floating Rate 2027 Term Fund": "BSL",
  "Blackstone Strategic Credit 2027 Term Fund": "BGB",
  "BlossomHill Therapeutics Inc": "BLSM",
  "Bluerock Private Real Estate Fund": "BPRE",
  "Boqii Holding Ltd": "BQ",
  "BrandywineGLOBAL Global": "BWG",
  "Brc": "BRCC",
  "Brookfield Infrastructure Partners L.P.": "BIP",
  "Brookfield Infrastructure Partners L.P. 5.000% Class A Preferred": "BIP-P-B",
  "Brookfield Infrastructure Partners L.P. 5.125% Class A Preferred": "BIP-P-A",
  "Brookfield Real Assets Income Closed Fund": "RA",
  "Brookfield Renewable Partners L.P.": "BEP",
  "Brookfield Renewable Partners L.P. 5.25% Class A Preferred": "BEP-P-A",
  "Brown-Forman Corporation Class A": "BF-A",
  "Brown-Forman Corporation Class B": "BF-B",
  "Brp": "DOO",
  "Btcs": "BTCS",
  "Bv 파이낸셜": "BVFL",
  "Bw Lpg": "BWLP",
  "Bxp": "BXP",
  "C&F 파이낸셜": "CFFI",
  "C1 펀드": "CFND",
  "C3 AI": "AI",
  "C3is": "CISS",
  "C4 테라퓨틱스": "CCCC",
  "CACI 인터내셔널": "CACI",
  "CAE": "CAE",
  "CB 파이낸셜 서비스": "CBFV",
  "CBAK 에너지 테크놀러지": "CBAT",
  "CBIZ": "CBZ",
  "CBL & 어소시에이츠 프로퍼티스": "CBL",
  "CBL 인터내셔널": "BANL",
  "CBRE Global Real Estate Income Fund": "IGR",
  "CBRE 그룹": "CBRE",
  "CCC 인텔리전트": "CCC",
  "CCH 홀딩스": "CCHH",
  "CCSC 테크놀로지 인터내셔널 홀딩스": "CCTG",
  "CDT 에퀴티": "CDT",
  "CDT 인바이어런먼털 테크놀로지 인베스트먼트 홀딩스": "CDTG",
  "CEA 인더스트리스": "BNC",
  "CECO 인바이런먼털": "CECO",
  "CF 뱅크셰어스": "CFBK",
  "CF 인더스트리스 홀딩스": "CF",
  "CG 온콜로지": "CGON",
  "CH 로빈슨 월드와이드": "CHRW",
  "CH4 내추럴 솔루션스": "MTNE",
  "CHS 우선주 8%": "CHSCP",
  "CHS 우선주 클래스 B 7.875%": "CHSCO",
  "CHS 클래스 B 우선주 시리즈 2": "CHSCN",
  "CHS 클래스 B 우선주 시리즈 3": "CHSCM",
  "CHS 클래스 B 우선주 시리즈 4 7.5%": "CHSCL",
  "CID 홀드": "DAIC",
  "CION Investment": "CION",
  "CKX 랜드": "CKX",
  "CL 워크샵 그룹 ADR": "NWGL",
  "CMB.테크": "CMBT",
  "CME 그룹": "CME",
  "CMS 에너지": "CMS",
  "CN 에너지 그룹": "CNEY",
  "CN 헬시 푸드 테크 그룹": "UCFI",
  "CNA 파이낸셜": "CNA",
  "CNB 파이낸셜": "CCNE",
  "CNB 파이낸셜 우선주 시리즈 A 7.125%": "CCNEP",
  "CNH 인더스트리얼": "CNH",
  "CNO 파이낸셜 그룹": "CNO",
  "CNS 파마슈티컬스": "CNSP",
  "CNX 리소스": "CNX",
  "CN파이낸스 홀딩스 ADR": "CNF",
  "CO2 에너지 트랜지션": "NOEM",
  "COPT 디펜스 프로퍼티스": "CDP",
  "CPI 에어로스트럭처스": "CVU",
  "CPI 카드 그룹": "PMTS",
  "CPS 테크놀러지": "CPSH",
  "CRA 인터내셔널": "CRAI",
  "CRH Public": "CRH",
  "CS 디스코": "LAW",
  "CSLM 디지털 애셋 애퀴지션 III": "KOYN",
  "CSW 인더스트리얼즈": "CSW",
  "CTO 리얼티 그로스": "CTO",
  "CTW Class A": "CTW",
  "CVB 파이낸셜": "CVBF",
  "CVD 이큅먼트": "CVV",
  "CVR Partners, LP": "UAN",
  "CVR 에너지": "CVI",
  "CVR엑스": "CVRX",
  "CVS 헬스": "CVS",
  "CX앱": "CXAI",
  "Calamos Convertible Opportunities and Income Closed Fund": "CHI",
  "Calamos Convertible and High Income Closed Fund": "CHY",
  "Calamos Dynamic Convertible": "CCD",
  "Calamos Global Dynamic Income Closed Fund": "CHW",
  "Calamos Global Total Return Closed Fund": "CGO",
  "Calamos Long Short Equity Dynamic Income Trust Closed Fund": "CPZ",
  "Calamos Strategic Total Return Closed Fund": "CSQ",
  "Callan JMB": "CJMB",
  "Calumet": "CLMT",
  "Carlyle Credit Income Fund": "CCIF",
  "Cboe 글로벌 마켓": "CBOE",
  "Cdw": "CDW",
  "Cellectis S.A.": "CLLS",
  "Central Securities Closed Fund": "CET",
  "Central and Eastern Europe Fund Inc": "CEE",
  "Cgi": "GIB",
  "Chatham Lodging Trust Series A Preferred": "CLDT-P-A",
  "Cheniere Energy Partners, LP": "CQP",
  "Ci&T": "CINT",
  "Ciena": "CIEN",
  "Cipher Digital": "CIFR",
  "Circle8 Group": "CIRC",
  "ClearBridge Energy Midstream Opportunity Closed End Fund": "EMO",
  "Clough Global Dividend and Income Fund": "GLV",
  "Clough Global Equity Closed Fund": "GLQ",
  "Clough Global Opportunities Closed Fund": "GLO",
  "Clps": "CLPS",
  "Cohen & Steers Real Estate Opps and Income Fund": "RLTY",
  "Cohen and Steers Total Return Realty Fund": "RFI",
  "CohenSteers  Infrastructure Fund": "UTF",
  "CohenSteers Closed End Opportunity Fund": "FOF",
  "CohenSteers REIT and Preferred and": "RNP",
  "CohenSteers Tax-Advantaged Preferred Securities and": "PTA",
  "Cohensteers": "LDP",
  "Cohensteers Quality": "RQI",
  "Cohensteers Select Preferred And": "PSF",
  "Collplant Biotechnologies Ltd": "CLGN",
  "Columbia Seligman Premium Technology Growth Fund": "STK",
  "Columbus Circle Capital Corp III": "CCCT",
  "Comp X International": "CIX",
  "Companhia Energetica De Minas Gerais-CEMIG": "CIG",
  "Companhia Paranaense de Energia - COPEL": "ELPC",
  "Connect Biopharma Holdings Ltd": "CNTB",
  "Cornerstone Strategic Investment Fund": "CLM",
  "Cornerstone Total Return Closed Fund": "CRF",
  "Corvex": "MOVE",
  "CrawfordCompany Class A": "CRD-A",
  "CrawfordCompany Class B": "CRD-B",
  "Cre8 엔터프라이즈": "CRE",
  "Credit Suisse Asset Management Income Closed Fund": "CIK",
  "Credit Suisse High Yield Credit Fund": "DHY",
  "Cross Timbers Royalty Units": "CRT",
  "CrossAmerica Partners LP Common units representing": "CAPL",
  "Csp": "CSPI",
  "Csx": "CSX",
  "Cts": "CTS",
  "D 보랄 애퀴지션 I": "DBCA",
  "D.R. 호턴": "DHI",
  "DBV 테크놀로지스 ADR": "DBVT",
  "DDC 엔터프라이즈": "DDC",
  "DEFSEC 테크놀로지스": "DFSC",
  "DHI 그룹": "DHX",
  "DHT 홀딩스": "DHT",
  "DLH 홀딩스": "DLHC",
  "DMC 글로벌": "BOOM",
  "DNP Select Income Fund Inc": "DNP",
  "DPC 홀딩스": "DPC",
  "DPC 홀딩스 ADR": "DSC",
  "DRD골드 ADR": "DRD",
  "DT 미드스트림": "DTM",
  "DT 클라우드 스타 애퀴지션": "DTSQ",
  "DTE 에너지": "DTE",
  "DTF Tax-Free Income 2028 Term Fund Inc.": "DTF",
  "DWS Municipal Income Trust": "KTF",
  "DXC 테크놀러지 컴퍼니": "DXC",
  "DXP 엔터프라이지스": "DXPE",
  "Delek Logistics Partners, Lp": "DKL",
  "Destiny Tech100 Closed End Fund": "DXYZ",
  "Destra Multi-Alternative Fund": "DMA",
  "Dna X": "SONM",
  "Dorchester Minerals Units": "DMLP",
  "DoubleLine Yield Opportunities Fund": "DLY",
  "Doubleline": "DSL",
  "Doubleline Opportunistic Credit Fund": "DBL",
  "Dss": "DSS",
  "Duff & Phelps Utility and Infrastructure Fund Inc": "DPG",
  "Dynagas Lng Parners Lp": "DLNG",
  "E W 스크립스": "SSP",
  "E-파워": "EPOW",
  "E-홈 하우스홀드 서비스 홀딩스": "EJH",
  "ECB 뱅코프": "ECBK",
  "EGH 애퀴지션": "EGHA",
  "EOG 리소시스": "EOG",
  "EON 리소시스": "EONR",
  "EPR 프로퍼티스": "EPR",
  "EQV 벤처스 애퀴지션 II": "EVAC",
  "ESS 테크": "GWH",
  "ETSY": "ETSY",
  "EVI 인더스트리": "EVI",
  "EV고": "EVGO",
  "Eagle Capital Growth Fund": "GRF",
  "Eagle Point Credit Company Inc": "ECC",
  "Eagle Point Credit Company Series D Preferred": "ECC-P-D",
  "Eagle Point Income Company Closed End Fund": "EIC",
  "Eaton Vance California Municipal Income Closed Fund": "CEV",
  "Eaton Vance Enhance Equity": "EOS",
  "Eaton Vance Enhanced Equity Income Closed Fund": "EOI",
  "Eaton Vance Floating Rate Income Closed Fund": "EFT",
  "Eaton Vance Limited Duration Income Closed Fund": "EVV",
  "Eaton Vance Municipal Bond Closed Fund": "EIM",
  "Eaton Vance Municipal Income 2028 Term Trust": "ETX",
  "Eaton Vance Municipal Income Trust": "EVN",
  "Eaton Vance National Municipal Opportunities Closed Fund": "EOT",
  "Eaton Vance Risk - Managed Diversified Equity": "ETJ",
  "Eaton Vance Senior Floating-Rate Fund": "EFR",
  "Eaton Vance Senior Income Closed Fund": "EVF",
  "Eaton Vance Short Duration Diversified Income Closed Fund": "EVG",
  "Eaton Vance Tax Advantaged Dividend Income Closed Fund": "EVT",
  "Eaton Vance Tax Advantaged Global Dividend Income Closed Fund": "ETG",
  "Eaton Vance Tax Managed Buy Write Income Closed Fund": "ETB",
  "Eaton Vance Tax Managed Buy Write Opportunities Closed Fund": "ETV",
  "Eaton Vance Tax Managed Diversified Equity Income Closed Fund": "ETY",
  "Eaton Vance Tax Managed Global Buy Write Opportunities Closed Fund": "ETW",
  "Eaton Vance Tax-Advantaged Global Div Oppor. Fund": "ETO",
  "Eaton Vance Tax-Managed Global Diversified Equity Income Closed Fund": "EXG",
  "Eidp": "CTA-P-A",
  "Elevra Lithium": "ELVR",
  "Ellington Credit Company": "EARN",
  "Ellsworth Growth and Income Fund Ltd.": "ECF",
  "Embotelladora Andina S.A. Series A": "AKO-A",
  "Embotelladora Andina S.A. Series B": "AKO-B",
  "Empire State Realty OP, L.P. Series 250": "FISK",
  "Empire State Realty OP, L.P. Series 60": "OGCP",
  "Empire State Realty Op, L.P.  Series Es": "ESBA",
  "Energy Transfer LP Common Units representing": "ET",
  "Enterprise Products Partners L.P.": "EPD",
  "Eqt": "EQT",
  "Esab": "ESAB",
  "F&G 어뉴어티 앤 라이프": "FG",
  "F5": "FFIV",
  "FB 뱅코프": "FBLA",
  "FB 파이낸셜 그룹": "FBK",
  "FBS 글로벌": "FBGL",
  "FG 머저 II": "BXBL",
  "FG 임페리얼 애퀴지션": "FGII",
  "FGI 인더스트리스": "FGI",
  "FIGX 캐피털 애퀴지션": "FIGX",
  "FNB": "FNB",
  "FRP 홀딩스": "FRPH",
  "FS Credit Opportunities Corp.": "FSCO",
  "FS KKR 캐피털": "FSK",
  "FS Specialty Lending Fund": "FSSL",
  "FS 뱅코프": "FSBW",
  "FTAI 애비에이션": "FTAI",
  "FTAI 애비에이션 우선주 Series D": "FTAIM",
  "FTAI 인프라스트럭처": "FIP",
  "FTC 솔라": "FTCI",
  "FTI 컨설팅": "FCN",
  "FVC뱅크코프": "FVCB",
  "Fangdd Network Group Ltd": "DUO",
  "Federal Agricultural Mortgage Corporation Class A Voting": "AGM-A",
  "Federated Hermes Premier Municipal Income Closed End Fund": "FMN",
  "Fg 넥서스": "FGNX",
  "Fg 넥서스 우선주 8.00%": "FGNXP",
  "FiEE": "FIEE",
  "First Trust Enhanced Equity Income Closed Fund": "FFA",
  "First Trust High Yield Opportunities 2027 Term Closed End Fd": "FTHY",
  "First Trust Intermediate Duration Preferred & Inc": "FPF",
  "First Trust Mortgage Income Fund": "FMY",
  "First Trust Senior Floating Rate Income Fund II": "FCT",
  "Flaherty Crumrine Total Return Mutual Fund  Incorporated": "FLC",
  "FlahertyCrumrine Preferred and": "FFC",
  "Flahertycrumrine Dynamic Preferred And": "DFP",
  "Fmc": "FMC",
  "Franklin Limited Duration Income Trust": "FTF",
  "Franklin Managed Municipal": "PMM",
  "Franklin Master Intermediate": "PIM",
  "Franklin Municipal Opportunities Trust": "PMO",
  "Franklin Premier": "PPT",
  "Franklin Universal Closed Fund": "FT",
  "Fst": "KBSX",
  "Fundrise Innovation Fund  LLC": "VCX",
  "Futurewave Acquisition Corp": "FWAC",
  "G 윌리 푸드 인터내셔널": "WILC",
  "G-III 어패럴 그룹": "GIII",
  "GAMCO Global Gold Natural Resources and Income Closed Fund": "GGN",
  "GAMCO Natural Resources Gold & Income Trust": "GNT",
  "GAMCO Natural Resources, Gold": "GNT-P-A",
  "GCL 글로벌 홀딩스": "GCL",
  "GCM 그로스브너": "GCMG",
  "GCT 세미컨덕터 홀딩": "GCTS",
  "GD 컬처 그룹": "GDC",
  "GDL Fund": "GDL",
  "GDS 홀딩스 ADR": "GDS",
  "GE 버노바": "GEV",
  "GE 에어로스페이스": "GE",
  "GE 헬스케어": "GEHC",
  "GEE 그룹": "JOB",
  "GEN 레스토랑 그룹": "GENK",
  "GFL 인바이런먼털": "GFL",
  "GH 리서치": "GHRS",
  "GMEX 로보틱스": "GMEX",
  "GMR 솔루션스": "GMRS",
  "GP-Act III 애퀴지션": "GPAT",
  "GRI 바이오": "GRI",
  "GSI 테크놀러지": "GSIT",
  "GSR IV 애퀴지션": "GSRF",
  "GSR V 애퀴지션": "GSRV",
  "GT 바이오파마": "GTBP",
  "GXO 로지스틱스": "GXO",
  "Gabelli Convertible and Income Securities Mutual Fund": "GCV",
  "Gabelli Dividend & Income Trust": "GDV",
  "Gabelli Equity Trust Inc": "GAB",
  "Gabelli Global Small and Mid Cap Value Closed Fund": "GGZ",
  "Gabelli Global Utility and Income Closed Fund": "GLU-P-A",
  "Gabelli Healthcare & WellnessRx Trust": "GRX",
  "Gabelli Multimedia Trust Inc": "GGT",
  "Gabelli Utility Trust": "GUT",
  "Gabelli Utility Trust Series C Preferred": "GUT-P-C",
  "Gatx": "GATX",
  "Gdev": "GDEV",
  "General American Investors Closed Fund": "GAM",
  "General American Investors Company": "GAM-P-B",
  "Genesis Energy, L.P.": "GEL",
  "Global Partners Units": "GLP",
  "Global-E Online": "GLBE",
  "Gpgi": "GPGI",
  "Gray Media": "GTN-A",
  "Greif, Inc. Class B": "GEF-B",
  "Greystone Housing Impact Investors LP Beneficial Unit Certificates representing assignments of": "GHI",
  "Grupo Aeroportuario del Pacifico, S.A.B. de C.V.": "PAC",
  "Grupo Cibest S.A. American Preferred": "CIB",
  "Gsk": "GSK",
  "Guggenheim Active Allocation CEF": "GUG",
  "Guggenheim Strategic Opportunities Mutual Fund": "GOF",
  "Guggenheim Taxable Muni Bd & Inv Grade Dbt Trust": "GBAB",
  "G뱅크 파이낸셜 홀딩스": "GBFH",
  "H&R 블록": "HRB",
  "H2O 아메리카": "HTO",
  "HA 서스테이너블 인프라 캐피털": "HASI",
  "HBT 파이낸셜": "HBT",
  "HCA 헬스케어": "HCA",
  "HCI 그룹": "HCI",
  "HCM III 애퀴지션": "HCMA",
  "HCM IV 애퀴지션": "HACQ",
  "HCW 바이오로직스": "HCWB",
  "HDFC 뱅크 ADR": "HDB",
  "HEICO CORP CL A": "HEI-A",
  "HF 싱클레어": "DINO",
  "HF 푸즈그룹": "HFFG",
  "HMH 홀딩": "HMH",
  "HP": "HP",
  "HSBC 홀딩스 ADR": "HSBC",
  "HWH 인터내셔널": "HWH",
  "Haverty Furniture Companies": "HVT-A",
  "Herzfeld Credit Income Fund，Inc.": "HERZ",
  "High Income Securities Fund": "PCF",
  "Highland Global Allocation Fund": "HGLB",
  "Highland Opportunities and": "HFRO",
  "Highland Opportunities and Income Fund": "HFRO-P-A",
  "Hni": "HNI",
  "Hp": "HPQ",
  "I-80 골드": "IAUX",
  "I3 버티칼스": "IIIV",
  "IB 애퀴지션": "IBAC",
  "IBM(인터내셔널 비지니스 머신)": "IBM",
  "ICF 인터내셔널": "ICFI",
  "ICICI 뱅크 ADR": "IBN",
  "ICU 메디컬": "ICUI",
  "ICZOOM Group": "IZM",
  "IES 홀딩스": "IESC",
  "IHS 홀딩": "IHS",
  "IM 카나비스": "IMCC",
  "IMC 레어 어스": "IMC",
  "ING 그룹 ADR": "ING",
  "INNEOVA 홀딩스": "INEO",
  "INVO 퍼틸리티": "IVF",
  "IP 스트래티지 홀딩스": "IPST",
  "IPG 포토닉스": "IPGP",
  "IQM 퀀텀 컴퓨터스 ADR": "IQMX",
  "IRSA 인베르시오네스 ADR": "IRS",
  "IT 테크 패키징": "ITP",
  "ITHAX 애퀴지션 III": "ITHA",
  "Icahn Enterprises L.P": "IEP",
  "Idt": "IDT",
  "Invesco  Bond Fund": "VBF",
  "Invesco  California Value Muni": "VCV",
  "Invesco  High": "VLT",
  "Invesco  Pennsylvania Value Municipal": "VPV",
  "Invesco  Senior": "VVR",
  "Invesco  Trust Investment Grade Municipals": "VGM",
  "Invesco  Trust for Investment Grade New York Municipals": "VTN",
  "Invesco Advantage Municipal Inc Tr II": "VKI",
  "Invesco Muni Income Opportunities Trust": "OIA",
  "Invesco Municipal Opportunity Trust": "VMO",
  "Invesco Municipal Trust": "VKQ",
  "Invesco Quality Municipal Securities": "IQI",
  "Invesco Value Municipal Income Closed Fund": "IIM",
  "Iqstel": "IQST",
  "Itg": "ITG",
  "Itt": "ITT",
  "J and Friends Holdings": "JF",
  "J&J 스낵 푸즈": "JJSF",
  "J-롱 그룹": "JL",
  "J.M. 스머커": "SJM",
  "JAB 애퀴지션 I": "JAB",
  "JB Hunt Transport Services": "JBHT",
  "JBDI 홀딩스": "JBDI",
  "JBG SMITH Properties Common": "JBGS",
  "JBT 마렐": "JBTM",
  "JE 클린테크 홀딩스": "JCSE",
  "JFB Construction Holdings Class A": "JFB",
  "JW 메이스": "MAYS",
  "JX 룩스벤처 그룹": "JXG",
  "Jack in the Box": "JACK",
  "Jackson Acquisition Company II": "JACS",
  "Jade Biosciences": "JBIO",
  "James Hardie Industries PLC": "JHX",
  "Janus Living": "JAN",
  "Japan Smaller Capitalization Closed Fund": "JOF",
  "Jbs N.V.": "JBS",
  "JetBlue Airways": "JBLU",
  "John B. SanfilippoSON": "JBSS",
  "John Hancock Diversified": "HEQ",
  "John Hancock Financial Opportunities Fund": "BTO",
  "John Hancock Income Securities Closed Fund": "JHS",
  "John Hancock Investors Trust Capital Stock": "JHI",
  "John Hancock Preferred Income Closed Fund": "HPI",
  "John Hancock Preferred Income II Closed Fund": "HPF",
  "John Hancock Preferred Income III Closed Fund": "HPS",
  "John Hancock Premium Dividend Fund": "PDT",
  "John Hancock Tax Advantaged Dividend Income Closed Fund": "HTD",
  "J스타 홀딩": "YMAT",
  "K 웨이브 미디어": "KWM",
  "K&F 그로스 애퀴지션 II": "KFII",
  "K2 캐피탈 애퀴지션": "KTWO",
  "KB 홈": "KBH",
  "KB금융지주 ADR": "KB",
  "KE 홀딩스 ADR": "BEKE",
  "KKR 리얼에스테이트 파이낸스 트러스트": "KREF",
  "KLX 에너지 서비시스 홀딩스": "KLXE",
  "KRAK애퀴지션": "KRAQ",
  "KULR 테크놀로지 그룹": "KULR",
  "KVH 인더스트리": "KVHI",
  "Kayne Anderson Energy Infrastructure Fund Inc": "KYN",
  "Kbr": "KBR",
  "Kidz Ai": "KIDZ",
  "Kimbell Royalty Partners, LP Common Units representing": "KRP",
  "Kkr": "KIO",
  "Kla": "KLAC",
  "Knot Offshore Partners Lp": "KNOP",
  "Korea Fund": "KF",
  "Kt": "KT",
  "K테크 솔루션스": "KMRK",
  "K포스": "KFRC",
  "L B 포스터": "FSTR",
  "L3 해리스 테크놀러지스": "LHX",
  "LB 파마슈티컬스": "LBRX",
  "LCI 인더스트리스": "LCII",
  "LGI 홈스": "LGIH",
  "LGL 그룹": "LGL",
  "LMP Capital and": "SCD",
  "LPL 파이낸셜 홀딩스": "LPLA",
  "LQR 하우스": "YHC",
  "LSB 인더스트리": "LXU",
  "LSI 인더스트리": "LYTS",
  "LTC 프로퍼티즈": "LTC",
  "LXP 인더스트리얼 트러스트": "LXP",
  "LZ 테크놀로지 홀딩스": "LZMH",
  "Latigo Biotherapeutics Inc": "LTGO",
  "Lazard Global Total Return": "LGI",
  "Lcnb": "LCNB",
  "Lennar Corporation Class B": "LEN-B",
  "Liberty All Star Equity Closed Fund": "USA",
  "Liberty All-Star Growth Fd": "ASG",
  "Liberty Capital": "GLIBA",
  "Lkq": "LKQ",
  "M 에보 글로벌 애퀴지션 II": "MEVO",
  "M&T 뱅크": "MTB",
  "M-트론 인더스트리스": "MPTI",
  "M/A-컴 테크놀로지 솔루션스 홀딩스": "MTSI",
  "M/I 홈스": "MHO",
  "M3-브리게이드 애퀴지션 VI": "MBVI",
  "MBX 바이오사이언시스": "MBX",
  "MDA 스페이스": "MDA",
  "MDB 캐피털 홀딩스": "MDBH",
  "MDU 리소시스 그룹": "MDU",
  "MDxHealth SA": "MDXH",
  "MFA 파이낸셜": "MFA",
  "MGE 에너지": "MGEE",
  "MGIC 인베스트먼트": "MTG",
  "MGM 리조트 인터내셔널": "MGM",
  "MGP 인그리디언츠": "MGPI",
  "MKD웰 테크": "MKDW",
  "MMTec": "MTC",
  "MOOG INC CL B": "MOG-B",
  "MORGAN STANLEY Series I Preferred Stock": "MS-P-I",
  "MSC 인더스트리얼 다이렉트": "MSM",
  "MVB 파이낸셜": "MVBF",
  "MYR 그룹": "MYRG",
  "Mach Natural Resources LP Common Units representing": "MNR",
  "Marcusmillichap": "MMI",
  "Marsh": "MRSH",
  "Marti Technologies": "MRT",
  "Martin Midstream Partners Units": "MMLP",
  "McCormickCompany": "MKC-V",
  "Mereo BioPharma Group": "MREO",
  "Meridian Holdings": "MRDN",
  "Merlin": "MRLN",
  "Mexico Fund": "MXF",
  "Middlesex Water": "MSEX",
  "Mind CTI": "MNDO",
  "Mine Safety": "MSA",
  "Mixed Martial Arts Group": "MMA",
  "Mks": "MKSI",
  "Mntn": "MNTN",
  "Mobile-health Network Solutions Class A": "MNDR",
  "Mobilicom Ltd": "MOB",
  "Modine Manufacturing": "MOD",
  "Mogu": "MOGU",
  "Monolithic Power Systems": "MPWR",
  "Moog Inc.": "MOG-A",
  "MoonLake Immunotherapeutics Class A": "MLTX",
  "Morgan Stanley China A Share Closed Fund": "CAF",
  "Morgan Stanley Dep": "MS-P-E",
  "Morgan Stanley Emerging Markets Debt Closed Fund": "MSD",
  "Morgan Stanley Emerging Mrkt Domestic Debt Fd Inc": "EDD",
  "Morgan Stanley Floating Rate non-cumulative Preferred Series A": "MS-P-A",
  "Morgan Stanley India Investment Closed Fund": "IIF",
  "Morgan Stanley Series F": "MS-P-F",
  "Morgan Stanley Series K Preferred Stock": "MS-P-K",
  "Morgan Stanley Series L Preferred Stock": "MS-P-L",
  "Morgan Stanley Series O Preferred Stock": "MS-P-O",
  "Morgan Stanley Series P Preferred Stock": "MS-P-P",
  "Morgan Stanley Series Q Preferred Stock": "MS-P-Q",
  "Mplx Lp": "MPLX",
  "Msc": "MSIF",
  "Msci": "MSCI",
  "NB 뱅코프": "NBBK",
  "NBT 뱅코프": "NBTB",
  "NCR 보익스": "VYX",
  "NCR 아틀레오스": "NATL",
  "NCS 멀티스테이지 홀딩스": "NCSM",
  "NI 홀딩스": "NODK",
  "NIP 그룹 ADR": "NIPG",
  "NIQ 글로벌 인텔리전스": "NIQ",
  "NIU 테크놀러지 ADR": "NIU",
  "NLI 홀딩스": "NL",
  "NMI 홀딩스": "NMIH",
  "NMP 애퀴지션": "NMP",
  "NN": "NN",
  "NPK 인터내셔널": "NPKI",
  "NRC 헬스": "NRC",
  "NRG 에너지": "NRG",
  "NRX 파마슈티컬스": "NRXP",
  "NSTS 뱅코프": "NSTS",
  "NWPX 인프라스트럭처": "NWPX",
  "NXG Cushing Midstream Energy Closed End Fund": "SRV",
  "NXG NextGen Infrastructure Income Fund": "NXG",
  "NXP 세미콘덕터": "NXPI",
  "NYLI CBRE Global Infrastructure Megatrends Term Fund": "MEGI",
  "NYLI MacKay DefinedTerm Muni Opportunities Fund": "MMD",
  "Natural Resource Partners L.P.": "NRP",
  "Navios Maritime Partners Units": "NMM",
  "Neuberger Energy Infrastructure and": "NML",
  "Neuberger High Yield Strategies Fund": "NHS",
  "Neuberger Municipal Fund": "NBH",
  "Neuberger Next Generation Connectivity Fund": "NBXG",
  "Neuberger Real Estate Securities": "NRO",
  "New Germany Fund": "GF",
  "Nft": "MI",
  "Ngl Energy Partners Lp": "NGL",
  "Nn": "NNBR",
  "North European Oil Royalty Units": "NRT",
  "Nova Minerals Corp": "NVA",
  "Nuveen AMT-Free Municipal Credit Income Fund": "NVG",
  "Nuveen AMT-Free Municipal Value Fund": "NUW",
  "Nuveen AMT-Free Quality Municipal Income Fund": "NEA",
  "Nuveen Arizona Quality Municipal Income Fund": "NAZ",
  "Nuveen California AMT-Free Quality Municipal In Fd": "NKX",
  "Nuveen California Municipal Value Fund": "NCA",
  "Nuveen California Quality Municipal Income Fund": "NAC",
  "Nuveen Core Equity Alpha Closed Fund": "JCE",
  "Nuveen Core Plus Impact Fund": "NPCT",
  "Nuveen Credit Strategies Income Closed Fund": "JQC",
  "Nuveen Dynamic Municipal Opportunities Fund": "NDMO",
  "Nuveen Floating Rate Income Closed Fund": "JFR",
  "Nuveen Global High Income Fund": "JGH",
  "Nuveen Massachusetts Quality Municipal Income Fund": "NMT",
  "Nuveen Minnesota Quality Municipal Income Fund": "NMS",
  "Nuveen Mortgage and Income Fund": "JLS",
  "Nuveen Multi-Asset Income Fund": "NMAI",
  "Nuveen Multi-Market Income Fund": "JMM",
  "Nuveen Municipal Credit Income Fund": "NZF",
  "Nuveen Municipal Credit Opportunities Fund": "NMCO",
  "Nuveen Municipal High Income Opportunity Closed Fund": "NMZ",
  "Nuveen Municipal Income Fund Inc": "NMI",
  "Nuveen Municipal Value Fund Inc": "NUV",
  "Nuveen NASDAQ 100 Dynamic Overwrite Fund -": "QQQX",
  "Nuveen New York AMT-Free Quality Municipal Inc Fd": "NRK",
  "Nuveen New York Municipal Value Fund": "NNY",
  "Nuveen New York Quality Municipal Income Fund": "NAN",
  "Nuveen Preferred & Income Opportunities Fund": "JPC",
  "Nuveen Quality Municipal Income Fund": "NAD",
  "Nuveen Real Asset Income and Growth Fund": "JRI",
  "Nuveen Real Estate Income Closed Fund": "JRS",
  "Nuveen S&P 500 Dynamic Overwrite Closed End Fund": "SPXX",
  "Nuveen Select Maturities Municipal Fund": "NIM",
  "Nuveen Select Tax-Free Income Portfolio": "NXP",
  "Nuveen Taxable Municipal Income Fund": "NBB",
  "Nuveen Variable Rate Preferred Income Closed End Fund": "NPFD",
  "Nuveen Virginia Quality Municipal Income Fund": "NPV",
  "Nve": "NVEC",
  "Nvr": "NVR",
  "O-i 글래스": "OI",
  "OFA 그룹": "OFAL",
  "OFG 뱅코프": "OFG",
  "OFS 캐피털": "OFS",
  "OFS 크레디트 우선주 Series E 5.25%": "OCCIN",
  "OFS 크레디트 우선주 Series F 7.875%": "OCCIM",
  "OFS 크레디트 컴퍼니": "OCCI",
  "OGE 에너지": "OGE",
  "OIO 그룹": "OIO",
  "OKYO Pharma Ltd": "OKYO",
  "OMS 에너지 테크놀로지스": "OMSE",
  "OP 뱅코프": "OPBK",
  "OR 로열티스": "OR",
  "OS 테라퓨틱스": "OSTX",
  "OSI 시스템즈": "OSIS",
  "OSR 헬스": "OSRH",
  "OSS(원 스탑 시스템)": "OSS",
  "OTG 애퀴지션 I": "OTGA",
  "P&G(프록터 & 갬블)": "PG",
  "P3 헬스 파트너스": "PIII",
  "PAR Technology": "PAR",
  "PC 커넥션": "CNXN",
  "PCB Bancorp": "PCB",
  "PCM Fund Inc": "PCM",
  "PDF 솔루션스": "PDFS",
  "PDS 바이오테크놀러지": "PDSB",
  "PGIM Global High Yield Fund，Inc": "GHY",
  "PGIM High Yield Bond Fund，Inc": "ISD",
  "PGIM Short Duration High Yield Opportunities Fund": "SDHY",
  "PIMCO Access Income Fund": "PAXS",
  "PIMCO Dynamic": "PDX",
  "PIMCO Dynamic Income Fund": "PDI",
  "PIMCO Dynamic Income Opportunities Fund": "PDO",
  "PIMCO Global StockPLUS": "PGP",
  "PIMCO High Income Fund": "PHK",
  "PJT 파트너스": "PJT",
  "PMGC 홀딩스": "ELAB",
  "PMV 파마슈티컬스": "PMVP",
  "PN 스마트 에너지": "PN",
  "PNC 파이낸셜 서비스": "PNC",
  "PPG 인더스트리스": "PPG",
  "PRA 그룹": "PRAA",
  "PRF 테크놀로지스": "PRFX",
  "PROG 홀딩스": "PRG",
  "PS 인터내셔널 그룹": "PSIG",
  "PSQ 홀딩스": "PSQH",
  "PTC 테라퓨틱스": "PTCT",
  "PagerDuty": "PD",
  "Pampa Energia S.A.": "PAM",
  "Pamt": "PAMT",
  "Paysign": "PAYS",
  "Pbf Energy": "PBF",
  "Pebblebrook Hotel Trust Series E Preferred": "PEB-P-E",
  "Pebblebrook Hotel Trust Series F Preferred": "PEB-P-F",
  "Pebblebrook Hotel Trust Series G Preferred": "PEB-P-G",
  "Pebblebrook Hotel Trust Series H Preferred": "PEB-P-H",
  "Pedevco": "PED",
  "Peoples Bancorp of North Carol": "PEBK",
  "PermRock Royalty Trust Trust Unit": "PRT",
  "Permian Basin Royalty Units": "PBT",
  "Permianville Royalty Unit": "PVL",
  "Perpetuals.com": "PDC",
  "PetMed Express": "PETS",
  "Petroleo Brasileiro S.A.-Petrobras": "PBR-A",
  "Petroleo Brasileiro S.A.-Petrobras Ads (Rep 1 Common Share)": "PBR",
  "Pg&E": "PCG",
  "Piedmont Realty Trust": "PDM",
  "Pimco": "PCN",
  "Pimco California Municipal": "PCQ",
  "Pimco Municipal": "PML",
  "Pimco New York Municipal": "PNI",
  "Pimco Strategic": "RCS",
  "Plains All American Pipeline, L.P. Common Units representing": "PAA",
  "Plains GP Holdings, L.P. Class A Units representing": "PAGP",
  "Pldt": "PHI",
  "Ppl": "PPL",
  "Principal Real Estate Income Fund": "PGZ",
  "ProCap Acquisition": "PCAP",
  "Ptc": "PTC",
  "Ptl": "PTLE",
  "Q/C 테크놀로지스": "QCLS",
  "Q2 홀딩스": "QTWO",
  "Q32 바이오": "QTTB",
  "QCR 홀딩스": "QCRH",
  "QDRO 애퀴지션": "QADR",
  "QMMM 홀딩스": "QMMM",
  "QT 이미징 홀딩스": "QTI",
  "QVC 그룹": "QVC",
  "Quanome Technologies": "QNME",
  "Qxo": "QXO",
  "RBB 뱅코프": "RBB",
  "RCB": "RCBC",
  "RCI 호스피탤리티 홀딩스": "RICK",
  "RCM 테크놀로지스": "RCMT",
  "RENN Fund": "RCG",
  "RE앨로이스": "ALOY",
  "RF 애퀴지션 II": "RFAI",
  "RF 애퀴지션 III": "RFAM",
  "RF 인더스트리스": "RFIL",
  "RGC 리소스": "RGCO",
  "RLJ 로징 트러스트": "RLJ",
  "RLX 테크놀로지 ADR": "RLX",
  "RMG ML Sports Holdings Class A": "SHOT",
  "RMR 그룹": "RMR",
  "RPM 인터내셔널": "RPM",
  "RRE 벤처스 애퀴지션": "RREV",
  "RTB 디지털": "RTB",
  "Reaves Utility Income Closed Fund": "UTG",
  "Rh": "RH",
  "Ridgepost Capital": "RPC",
  "RiverNorth Capital and Income Interval Fund": "RSF",
  "RiverNorth Flexible Municipal Income Fund II Inc.": "RFMZ",
  "RiverNorth Flexible Municipal Income Fund Inc.": "RFM",
  "RiverNorth Managed Duration Muni Income Fd II Inc.": "RMMZ",
  "RiverNorth Managed Duration Muni Income Fd Inc": "RMM",
  "RiverNorth Opportunistic Municipal Income Fund Inc": "RMI",
  "RiverNorth Opportunities Fund Inc": "RIV",
  "RiverNorth/DoubleLine Strategic Opportunity Fund": "OPP",
  "Robinhood Ventures Fund I": "RVI",
  "Royce Global Trust Inc": "RGT",
  "Royce Micro Cap Closed Fund": "RMT",
  "Royce Small-Cap Trust Inc": "RVT",
  "Rpc": "RES",
  "Rtx": "RTX",
  "Rxo": "RXO",
  "Rx사이트": "RXST",
  "S&P 글로벌": "SPGI",
  "S&T 뱅코프": "STBA",
  "SAB 바이오테라퓨틱스": "SABS",
  "SB 파이낸셜 그룹": "SBFG",
  "SBA 커뮤니케이션스": "SBAC",
  "SBC 메디컬 그룹 홀딩스": "SBC",
  "SC II 애퀴지션": "SCII",
  "SCE 트러스트 VII 우선주": "SCE-P-G",
  "SEI 인베스트먼트": "SEIC",
  "SFL 코퍼레이션": "SFL",
  "SGHC": "SGHC",
  "SHF 홀딩스": "SHFS",
  "SIFCO 인더스트리": "SIF",
  "SIM 애퀴지션 I": "SIMA",
  "SINTX 테크놀로지스": "SINT",
  "SKK 홀딩스": "SKK",
  "SKYAI": "SKYA",
  "SK텔레콤 ADR": "SKM",
  "SK하이닉스 ADR": "SKHY",
  "SL 그린 리얼티": "SLG",
  "SLM 우선주 시리즈 B": "SLMBP",
  "SLR 인베스트먼트": "SLRC",
  "SM 에너지": "SM",
  "SMJ 인터내셔널 홀딩스": "SMJF",
  "SMX (시큐리티 매터스)": "SMX",
  "SPS 커머스": "SPSC",
  "SPX 테크놀로지스": "SPXC",
  "SR 뱅코프": "SRBK",
  "SRH Total Return Fund，Inc": "STEW",
  "SRx 글로벌": "SRXH",
  "SS 이노베이션스 인터내셔널": "SSII",
  "SS&C 테크놀로지스 홀딩스": "SSNC",
  "SSR 마이닝": "SSRM",
  "ST 마이크로 일렉트로닉스 ADR": "STM",
  "SU 그룹 홀딩스": "SUGP",
  "SUI 그룹 홀딩스": "SUIG",
  "SUMA 애퀴지션": "SUMA",
  "Saba Capital Income & Opportunities Fund": "BRW",
  "Saba Capital Income & Opportunities Fund II": "SABA",
  "Sabine Royalty Units": "SBR",
  "San Juan Basin Royalty Trust UBI": "SJT",
  "Sap Se": "SAP",
  "Ses Ai": "SES",
  "Si타임": "SITM",
  "Sl 사이언스 홀딩": "SLBT",
  "Slb": "SLB",
  "Slm": "SLM",
  "Solstice Advanced Materials": "SOLS",
  "Source Capital Beneficial Interest": "SOR",
  "Southern Cross Acquisition I Corp": "NCO",
  "Special Opportunities Fund，Inc.": "SPE",
  "Sprott Focus Trust": "FUND",
  "Star Group, L.P. Common Units Representing": "SGU",
  "Suburban Propane Partners L P": "SPH",
  "Summit Therapeutics Inc": "SMMT",
  "Sundial Growers": "SNDL",
  "Sunoco L.P.": "SUN",
  "SunocoCorp": "SUNC",
  "Synthetic Fixed": "GJP",
  "Synthetic Fixed-Income Sec STRATS 2004-06, 6.375% US Cellular": "GJH",
  "Synthetic Fixed-Income Securities": "GJO",
  "Synthetic Fixed-Income Securities STRATS 2006-2 Goldman Sachs Group": "GJS",
  "Synthetic Fixed-Income Securities STRATS 2006-3 AllState": "GJT",
  "T-모바일 US": "TMUS",
  "T1 에너지": "TE",
  "T3 디펜스": "DFNS",
  "TAL 에듀케이션 그룹 ADR": "TAL",
  "TAO 시너지스": "TAOX",
  "TAT 테크놀러지": "TATT",
  "TC 에너지": "TRP",
  "TCGX 애퀴지션": "TCGX",
  "TCW Strategic Income Closed Fund": "TSI",
  "TD 시넥스": "SNX",
  "TDH 홀딩스": "PETZ",
  "TE 커넥티비티": "TEL",
  "TEN 홀딩스": "XHLD",
  "TFI 인터내셔널": "TFII",
  "TFS 파이낸셜": "TFSL",
  "TG 테라퓨틱스": "TGTX",
  "TGE 밸류 크리에이티브 솔루션즈": "BEBE",
  "TH 인터내셔널": "THCH",
  "TIC 솔루션스": "TIC",
  "TJGC 그룹": "TJGC",
  "TJX 컴퍼니스": "TJX",
  "TKO 그룹 홀딩스": "TKO",
  "TMC 더 메탈스 컴퍼니": "TMC",
  "TMD 에너지": "TMDE",
  "TNL 미디어진": "TNMG",
  "TPG 리 파이낸스 트러스트": "TRTX",
  "TPG 모기지 인베스트먼트": "MITT",
  "TPG 스페셜티 렌딩": "TSLX",
  "TRG 라틴 아메리카 애퀴지션스": "TRGS",
  "TRI-Continental": "TY",
  "TSMC(타이완반도체제조) ADR": "TSM",
  "TTEC 홀딩스": "TTEC",
  "TTM 테크놀로지스": "TTMI",
  "TXNM 에너지": "TXNM",
  "TXO Partners, L.P.": "TXO",
  "Taiwan Fund": "TWN",
  "Templeton Dragon Closed Fund": "TDF",
  "Templeton Emerging Markets Closed Fund": "EMF",
  "Templeton Emerging Markets Income Closed Fund": "TEI",
  "The Cigna Group": "CI",
  "The European Equity Fund Inc": "EEA",
  "The Gabelli Dividend": "GDV-P-H",
  "The Gabelli Equity Trust": "GAB-P-G",
  "The Gabelli Multimedia Trust": "GGT-P-E",
  "The Gabelli Utility": "GLU",
  "The Mexico Equity and": "MXE",
  "The Mosaic Company": "MOS",
  "Thornburg Income Builder Opportunities Trust": "TBLD",
  "Ticketplus Ltd": "TP",
  "Tiziana Life Sciences Ltd": "TLSA",
  "Tortoise Energy Infrastructure Closed Fund": "TYG",
  "Total Return Securities Fund": "SWZ",
  "Tpg": "TPG",
  "Transportadora de Gas del Sur S.A. ADS": "TGS",
  "Tri Continental Closed Fund": "TY-P",
  "Tron": "TRON",
  "Tss": "TSSI",
  "Twfg": "TWFG",
  "T스캔 테라퓨틱스": "TCRX",
  "UBS 그룹 AG": "UBS",
  "UFP 인더스트리": "UFPI",
  "UFP 테크놀로지스": "UFPT",
  "UL 솔루션스": "ULS",
  "UMB 파이낸셜": "UMBF",
  "UMB 파이낸셜 우선주 Series B 7.750%": "UMBFO",
  "UMH 프로퍼티": "UMH",
  "UPS(유나이티드 파셀 서비스)": "UPS",
  "US 골드": "USAU",
  "US 골드마이닝": "USGO",
  "US 글로벌 인베스터스": "GROW",
  "US 뱅코프": "USB",
  "US 센츄리 뱅크": "USCB",
  "US 푸즈 홀딩": "USFD",
  "US 피지컬 테라피": "USPH",
  "USA 레어 어스": "USAR",
  "USA 투데이": "TDAY",
  "UTZ 브랜즈": "UTZ",
  "UT스타컴 홀딩스": "UTSI",
  "UWM 홀딩스": "UWMC",
  "UY 스쿠티 애퀴지션": "UYSC",
  "Udr": "UDR",
  "Ugi": "UGI",
  "Usa Compression Partners Lp": "USAC",
  "Usbc": "USBC",
  "V.F.": "VFC",
  "VCI 글로벌": "VCIG",
  "VS 미디어 홀딩스": "VSME",
  "Virtus Artificial Intelligence and Technology Opportunities Fund": "AIO",
  "Virtus Convertible And Income Fund": "NCV",
  "Virtus Convertible and Income Fund II": "NCZ",
  "Virtus Diversified Income And Convertible Fund": "ACV",
  "Virtus Dividend  Interest & Prem Str Fd": "NFJ",
  "Virtus Equity And Convertible Income Fund": "NIE",
  "Virtus Global Multi-Sector Income Fund": "VGI",
  "Virtus Stone Harbor Emerging Markets Income Fund": "EDF",
  "Virtus Total Return Fund": "ZTR",
  "Voc Energy Trust": "VOC",
  "Voya Asia Pacific High Dividend Equity Income Fund": "IAE",
  "Voya Emerging Markets High": "IHD",
  "Voya Global Advantage And Premium Opportunity Fund": "IGA",
  "Voya Global Equity Dividend And Premium Opportunity Fund": "IGD",
  "Voya Infrastructure, Industrials And Materials Fund": "IDE",
  "Vse": "VSEC",
  "Vtex": "VTEX",
  "W W 그레인저": "GWW",
  "W&T 오프쇼어": "WTI",
  "W. R. 버클리": "WRB",
  "W.p. 케어리": "WPC",
  "WEC 에너지 그룹": "WEC",
  "WF 인터내셔널": "WXM",
  "WF 홀딩": "WFF",
  "WSFS 파이낸셜": "WSFS",
  "WW 인터내셔널": "WW",
  "WaFd": "WAFD",
  "WaFd 우선주 Series A": "WAFDP",
  "Watsco, Inc. Class B": "WSO-B",
  "Wd-40": "WDFC",
  "Western Asset Diversified Income Fund": "WDI",
  "Western Asset Emerging Markets Debt Fund": "EMD",
  "Western Asset Global Corporate Opportunity Fd Inc.": "GDO",
  "Western Asset Global High Income Fund": "EHI",
  "Western Asset High Income Fund II Inc": "HIX",
  "Western Asset High Income Opportunity Closed Fund": "HIO",
  "Western Asset High Yield Opportunity Fund": "HYI",
  "Western Asset Inflation Linked Income Closed End Fund": "WIA",
  "Western Asset Inflation Linked Opportunities Income Closed End Fund": "WIW",
  "Western Asset Intermediate Muni Fund": "SBI",
  "Western Asset Investment Grade Income Closed End Fund Inc": "PAI",
  "Western Asset Investment Grade Opps Trust Inc.": "IGI",
  "Western Asset Managed Municipals Fund": "MMU",
  "Western Asset Mortgage Opportunity Fund": "DMO",
  "Western Asset Municipal High Income Fund": "MHF",
  "Western Asset Premier Bond Closed Fund": "WEA",
  "Western Midstream Partners, LP": "WES",
  "Westlake Chemical Partners Lp": "WLKP",
  "Wpp": "WPP",
  "X T L 바이오파마슈티컬 ADR": "XTLB",
  "X-에너지": "XE",
  "X3 애퀴지션": "XCBE",
  "X4 파마슈티컬": "XFOR",
  "XAI Floating RateAlternative": "XFLT",
  "XAI Madison Equity Premium": "MCN",
  "XBP 글로벌 홀딩스": "XBP",
  "XCF 글로벌": "SAFX",
  "XFLH 캐피탈": "XFLH",
  "XPLR 인프라스트럭처": "XIFR",
  "XTI 에어로스페이스": "XTIA",
  "Xchg": "XCH",
  "Xmax": "XMAX",
  "X웰": "XWEL",
  "X체인지 TEC.INC ADR": "XHG",
  "YD 바이오": "YDES",
  "YHN 애퀴지션 I": "YHNA",
  "YPF Sociedad Anonima": "YPF",
  "YSX 테크": "YSXT",
  "YXT.컴 그룹 홀딩 ADR": "YXT",
  "YY 그룹 홀딩": "YYGH",
  "Z 스퀘어드": "ZSQR",
  "ZIM 인티그레이티드 시핑 서비시스": "ZIM",
  "ZJK 인터스트리얼": "ZJK",
  "ZK 인터내셔널": "ZKIN",
  "ZKH 그룹 ADR": "ZKH",
  "ZTO 익스프레스 (케이먼) ADR": "ZTO",
  "ZW 데이터 액션 테크놀로지스": "CNET",
  "abrdn": "ACP",
  "abrdn Asia-Pacific": "FAX",
  "abrdn Australia Equity Fund": "IAF",
  "abrdn Emerging Markets ex-China Fund": "AEF",
  "abrdn Global Dynamic Dividend Fund": "AGD",
  "abrdn Global Infrastructure Income Fund": "ASGI",
  "abrdn Global Premier Properties Mutual Fund": "AWP",
  "abrdn Healthcare Investors": "HQH",
  "abrdn Healthcare Opportunities Fund": "THQ",
  "abrdn Income Credit Strategies Mutual Fund": "ACP-P-A",
  "abrdn Life Sciences Investors": "HQL",
  "abrdn Total Dynamic Dividend Fund": "AOD",
  "abrdn World Healthcare Fund": "THW",
  "monday.com": "MNDY",
  "rYojbaba": "RYOJ",
  "vTv 테라퓨틱스": "VTVT",
  "가단트 헬쓰": "GH",
  "가드포스 AI": "GFAI",
  "가든 스테이지": "GSIW",
  "가디언 메탈 리소시스 ADR": "GMTL",
  "가디언 파마시 서비시스": "GRDN",
  "가렛 모션": "GTX",
  "가민": "GRMN",
  "가소스.AI": "GXAI",
  "가스로그 파트너스 우선주 시리즈 A": "GLOP-P-A",
  "가이드와이어 소프트웨어": "GWRE",
  "가이아": "GAIA",
  "가트너": "IT",
  "갈라타 애퀴지션 II": "LATA",
  "갈레라 테라퓨틱스": "OBX",
  "갈렉틴 테라퓨틱스": "GALT",
  "갈리아노 골드": "GAU",
  "갈메드 파머슈티컬스": "GLMD",
  "갤럭시 디지털 홀딩스": "GLXY",
  "갤럭시 페이롤 그룹": "GLXG",
  "갤럭시엣지 애퀴지션": "GLED",
  "갭": "GAP",
  "걸프 리소시즈": "GURE",
  "걸프포트 에너지": "GPOR",
  "게셔 애퀴지션 II": "GSHR",
  "게이밍 & 레저 프로퍼티스": "GLPI",
  "게이츠 인더스트리얼": "GTES",
  "게인 테라퓨틱스": "GANX",
  "게임 유어 게임": "GYGY",
  "게임스탑": "GME",
  "게임하우스 홀딩스": "GMHS",
  "게티 리얼티": "GTY",
  "게티 이미지스 홀딩스": "GETY",
  "고고": "GOGO",
  "고고로": "GGR",
  "고대디": "GDDY",
  "고릴라 테크놀로지 그룹": "GRRR",
  "고먼-러프": "GRC",
  "고사머 바이오": "GOSS",
  "고어스 홀딩스 X": "GTEN",
  "고지": "GAUZ",
  "고프로": "GPRO",
  "골드 로열티": "GROY",
  "골드 필즈 ADR": "GFI",
  "골드그룹 마이닝": "GORO",
  "골드닷컴": "GOLD",
  "골드마이닝": "GLDG",
  "골드만삭스": "GS",
  "골드만삭스 BDC": "GSBD",
  "골드만삭스 캐피탈 I 시큐리티-백드 우선주 시리즈 2004-6": "JBK",
  "골든 선 테크놀로지 그룹": "GSUN",
  "골든 헤븐 그룹 홀딩스": "GDHG",
  "골라 LNG": "GLNG",
  "골럽 캐피탈 BDC": "GBDC",
  "구스헤드 인슈어런스": "GSHD",
  "굿 타임스 레스토란츠": "GTIM",
  "굿알엑스 홀딩스": "GDRX",
  "굿이어 타이어 & 러버": "GT",
  "그라비티 ADR": "GRVY",
  "그라인더": "GRND",
  "그라코": "GGG",
  "그라프 글로벌": "TONT",
  "그란데 그룹": "GRAN",
  "그래나이트 릿지 리소시스": "GRNT",
  "그래니트 모인트 모기지 트러스트": "GPMT",
  "그래니트 컨스트럭션": "GVA",
  "그래프테크 인터내셔널": "EAF",
  "그래픽 패키징 홀딩": "GPK",
  "그랜 티에라 에너지": "GTE",
  "그랜드 캐년 에듀케이션": "LOPE",
  "그랜드스탠드": "GRSD",
  "그랩 홀딩스": "GRAB",
  "그랩어건 디지털 홀딩스": "PEW",
  "그레이 미디어": "GTN",
  "그레이스 테라퓨틱스": "GRCE",
  "그레이엄": "GHM",
  "그레이엄 홀딩스": "GHC",
  "그레이트 서던 뱅코프": "GSBC",
  "그레이트 엘름 그룹": "GEG",
  "그레이트 엘름 캐피털": "GECC",
  "그레일": "GRAL",
  "그로브 콜라보레이티브 홀딩스": "GROV",
  "그로서리 아울렛 홀딩스": "GO",
  "그로우제너레이션": "GRWG",
  "그로우허브": "TGHL",
  "그루포 수페르비엘 ADR": "SUPV",
  "그루포 시멕 ADR": "SIM",
  "그루포 아발 악시오네스 이 발로 ADR": "AVAL",
  "그루포 에어로멕시코 ADR": "AERO",
  "그루포 에어로포르투아리오 센트로노테 ADR": "OMAB",
  "그루포 에어로포르투아리오 수레스테 ADR": "ASR",
  "그루포 텔레비사 ADR": "TV",
  "그루포 피난시에로 갈리시아 ADR": "GGAL",
  "그루폰": "GRPN",
  "그룹 원 오토모티브": "GPI",
  "그리니치 라이프사이언스": "GLSI",
  "그리드 다이나믹 홀딩스": "GDYN",
  "그리폰": "GFF",
  "그리폴스 ADR": "GRFS",
  "그리프 Class A": "GEF",
  "그린 닷": "GDOT",
  "그린 브릭 파트너스": "GRBK",
  "그린 서클 탈탄소 테크": "GCDT",
  "그린 카운티 뱅코프": "GCBC",
  "그린 플레인스": "GPRE",
  "그린라이트 캐피털 리": "GLRE",
  "그린란드 에너지": "GLND",
  "그린랜드 마인스": "GRML",
  "그린랜드 테크놀로지 홀딩": "GTEC",
  "그린레인 홀딩스": "GNLN",
  "그린브라이어": "GBX",
  "그린웨이브 테크놀로지 솔루션스": "GWAV",
  "그린트리 호스피탈리티 그룹 ADR": "GHG",
  "그린파워 모터 컴퍼니": "GP",
  "그린파이어 리소시스": "GFR",
  "그린프로 캐피털": "GRNQ",
  "글라우코스": "GKOS",
  "글래드스톤 랜드": "LAND",
  "글래드스톤 랜드 우선주 Series C 6.00%": "LANDP",
  "글래드스톤 랜드 우선주 시리즈 B 6.00%": "LANDO",
  "글래드스톤 인베스트먼트": "GAIN",
  "글래드스톤 캐피털": "GLAD",
  "글래드스톤 커머셜": "GOOD",
  "글래드스톤 커머셜 우선주 시리즈 E 6.625%": "GOODN",
  "글래드스톤 커머셜 우선주 시리즈 G 6.00%": "GOODO",
  "글래스 하우스 브랜즈": "GLAS",
  "글레이셔 뱅코프": "GBCI",
  "글로바 테라 애퀴지션": "GTERA",
  "글로바벤드 홀딩스": "GVH",
  "글로버스 마리타임": "GLBS",
  "글로번트": "GLOB",
  "글로벌 네트 리스": "GNL",
  "글로벌 모피 AI": "GMM",
  "글로벌 비지니스 트래블 그룹": "GBTG",
  "글로벌 셀프 스토리지": "SELF",
  "글로벌 십 리스": "GSL",
  "글로벌 엔진 그룹 홀딩": "GLE",
  "글로벌 워터 리소스": "GWRS",
  "글로벌 인더스트리얼": "GIC",
  "글로벌 인뎀니티 그룹": "GBLI",
  "글로벌 인터랙티브 테크놀로지스": "GITS",
  "글로벌 페이먼츠": "GPN",
  "글로벌스타": "GSAT",
  "글로벌파운드리": "GFS",
  "글로부스 메디컬": "GMED",
  "글로브 라이프": "GL",
  "글루 홀딩스": "GLOO",
  "글루코 트랙": "GCTK",
  "글림스 그룹": "GGRP",
  "기가미디어": "GIGM",
  "기가클라우드 테크놀로지": "GCT",
  "기그캐피탈9": "GIX",
  "기프티파이": "GIFT",
  "긱캐피탈8": "GIW",
  "길라트 새털라이트 네트웍스": "GILT",
  "길리어드 사이언시스": "GILD",
  "깃랩": "GTLB",
  "깅코 바이오웍스 홀딩스": "DNA",
  "나노 뉴클리어 에너지": "NNE",
  "나노 디멘션 ADR": "NNDM",
  "나노 랩스": "NA",
  "나노-엑스이미징": "NNOX",
  "나노바이리사이드스": "NNVC",
  "나노바이오틱스 ADR": "NBTX",
  "나뚜찌 SpA ADR": "NTZ",
  "나밉 미네랄스": "NAMM",
  "나반": "NAVN",
  "나비엔트": "NAVI",
  "나비타스 세미컨덕터": "NVTS",
  "나서스 파마": "NSRX",
  "나스 테크놀로지 ADR": "NAAS",
  "나스닥": "NDAQ",
  "나약스": "NYAX",
  "나이소스": "NI",
  "나이스 ADR": "NICE",
  "나이아젠 바이오사이언스": "NAGE",
  "나이키": "NKE",
  "나이트-스위프트 트랜스포테이션": "KNX",
  "나이트스코프": "KSCP",
  "나이프 리버": "KNF",
  "나인 에너지 서비스": "NINE",
  "나카모토": "NAKA",
  "나코 인더스트리스": "NC",
  "나테라": "NTRA",
  "내비게이터 홀딩스": "NVGS",
  "내셔널 그리드 ADR": "NGG",
  "내셔널 리테일 프로퍼티즈": "NNN",
  "내셔널 뱅크 홀딩스": "NBHC",
  "내셔널 뱅크셰어즈": "NKSH",
  "내셔널 베버리지": "FIZZ",
  "내셔널 비전 홀딩스": "EYE",
  "내셔널 시네미디어": "NCMI",
  "내셔널 에너지 서비스 리유나이티드": "NESR",
  "내셔널 퓨얼 가스": "NFG",
  "내셔널 프레스토 인더스트리스": "NPK",
  "내셔널 헬스 인베스터스": "NHI",
  "내셔널 헬스케어": "NHC",
  "내셔널 헬스케어 우선주 Series A 7.375%": "NHPAP",
  "내셔널 헬스케어 우선주 Series B 7.125%": "NHPBP",
  "내셔널 헬스케어 프로퍼티스": "NHP",
  "내추럴 가스 서비스 그룹": "NGS",
  "내추럴 그로서즈 바이 바이타민 코티지": "NGVC",
  "내추럴 얼터너티브 인터내셔널": "NAII",
  "내추럴 헬스 트렌즈": "NHTC",
  "내트웨스트 그룹 ADR": "NWG",
  "냅코 시큐리티 테크놀로지스": "NSSC",
  "너드월렛": "NRDS",
  "너디": "NRDY",
  "너브젠 파마": "NGEN",
  "네비우스 그룹": "NBIS",
  "네오-콘셉트 인터내셔널 그룹 홀딩스": "NCI",
  "네오노드": "NEON",
  "네오볼타": "NEOV",
  "네오스텔라 캐피털": "NSLR",
  "네오지노믹스": "NEO",
  "네이보스 인더스트리스": "NBR",
  "네이선스 페이머스": "NATH",
  "네이처스 선샤인 프로덕츠": "NATR",
  "네트스카우트 시스템즈": "NTCT",
  "네트워크-1 테크놀로지스": "NTIP",
  "네프로스": "NEPH",
  "넥사 리소스": "NEXA",
  "넥살린 테크놀로지": "NXL",
  "넥세라 테크놀로지스": "NEXR",
  "넥센티스 테크놀로지스": "NXTS",
  "넥스메탈스 마이닝": "NEXM",
  "넥스젠 에너지": "NXE",
  "넥스젤": "NXGL",
  "넥스큐어": "NXTC",
  "넥스타 미디어 그룹": "NXST",
  "넥스트 테크놀로지 홀딩": "NXTT",
  "넥스트NRG": "NXXT",
  "넥스트데케이드": "NEXT",
  "넥스트도어 홀딩스": "NXDR",
  "넥스트보트": "NXB",
  "넥스트에라 에너지": "NEE",
  "넥스트트립": "NTRP",
  "넥스트파워": "NXT",
  "넥스트플랫": "NXPL",
  "넥스포인트 다이버시파이드 리얼 에스테이트 트러스트": "NXDT",
  "넥스포인트 레지덴셜 트러스트": "NXRT",
  "넥스포인트 리얼 에스테이트 파이낸스": "NREF",
  "넥슨 인터내셔널": "NEXN",
  "넥타 테라퓨틱스": "NKTR",
  "넬넷": "NNI",
  "넵튠 인슈어런스 홀딩스": "NP",
  "넷 리즈 오피스 프로퍼티스": "NLOP",
  "넷 파워": "NPWR",
  "넷기어": "NTGR",
  "넷솔 테크놀로지스": "NTWK",
  "넷스코프": "NTSK",
  "넷앱": "NTAP",
  "넷에스티리츠": "NTST",
  "넷이즈 ADR": "NTES",
  "넷캐피탈": "NCPL",
  "넷클래스 테크놀로지": "NTCL",
  "넷플릭스": "NFLX",
  "노던": "NCL",
  "노던 다이너스티 미네랄스": "NAK",
  "노던 오일 & 가스": "NOG",
  "노던 테크놀로지스 인터내셔널": "NTIC",
  "노던 트러스트": "NTRS",
  "노던 트러스트 우선주 시리즈 E 4.7%": "NTRSO",
  "노드슨": "NDSN",
  "노르딕 아메리칸 탱커": "NAT",
  "노르웨이지안 크루즈 라인 홀딩스": "NCLH",
  "노마다르": "NOMA",
  "노마드 파워 솔루션스": "NMAD",
  "노마드 푸드": "NOMD",
  "노무라 홀딩스 ADR": "NMR",
  "노바 메저링 인스트루먼츠": "NVMI",
  "노바골드 리소시스": "NG",
  "노바백스": "NVAX",
  "노바브리지 바이오사이언스": "NBP",
  "노바티스 ADR": "NVS",
  "노밴타": "NOVT",
  "노보 노디스크 ADR": "NVO",
  "노보닉스 ADR": "NVX",
  "노보큐어": "NVCR",
  "노브": "NOV",
  "노블": "NE",
  "노세라": "NCRA",
  "노스 아메리칸 컨스트럭션 그룹": "NOA",
  "노스롭 그루만": "NOC",
  "노스림 뱅코프": "NRIM",
  "노스웨스턴 에너지 그룹": "NWE",
  "노스웨스트 내추럴 홀딩": "NWN",
  "노스웨스트 뱅크셰어스": "NWBI",
  "노스이스트 뱅크": "NBN",
  "노스이스트 커뮤니티 뱅코프": "NECB",
  "노스포인트 뱅크셰어스": "NPB",
  "노아 홀딩스 ADR": "NOAH",
  "노우드 파이낸셜": "NWFL",
  "노키아 ADR": "NOK",
  "노테크 시스템즈": "NSYS",
  "노티커스 로보틱스": "KITT",
  "노틸러스 바이오테크놀러지": "NAUT",
  "노퍽서던": "NSC",
  "놀스": "KN",
  "누 홀딩스": "NU",
  "누들스": "NDLS",
  "누릭스 테라퓨틱스": "NRIX",
  "누베이션 바이오": "NUVB",
  "누벡티스 파마": "NVCT",
  "누보 몽드 그래파이트": "NMG",
  "누빈 처칠 다이렉트 렌딩": "NCDL",
  "누사트립": "NUTR",
  "누카나 ADR": "NCNA",
  "뉴 마운틴 파이낸스": "NMFC",
  "뉴 센추리 로지스틱스": "NCEW",
  "뉴 에라 에너지 & 디지털": "NUAI",
  "뉴 오리엔탈 에듀케이션 & 테크놀로지 ADR": "EDU",
  "뉴 잉글랜드 리얼티 어소시에이트 DRC": "NEN",
  "뉴 컨셉 에너지": "GBR",
  "뉴 파운드 골드": "NFGC",
  "뉴 퍼시픽 메탈스": "NEWP",
  "뉴 포트리스 에너지": "NFE",
  "뉴 프로비던스 애퀴지션 III": "NPAC",
  "뉴 호라이즌 에어크래프트": "HOVR",
  "뉴락시스": "NRXS",
  "뉴로네틱스": "STIM",
  "뉴로센스 테라퓨틱스": "NRSN",
  "뉴로원 메디컬 테크놀로지스": "NMTC",
  "뉴로진": "NGNE",
  "뉴로크린 바이오사이언시스": "NBIX",
  "뉴로페이스": "NPCE",
  "뉴마켓": "NEU",
  "뉴마크 그룹": "NMRK",
  "뉴모라 테라퓨틱스": "NMRA",
  "뉴몬트": "NEM",
  "뉴버리 스트리트 II 애퀴지션": "NTWO",
  "뉴브리지 애퀴지션": "NBRG",
  "뉴셀X": "NCEL",
  "뉴스 코퍼레이션 Class A": "NWSA",
  "뉴스 코퍼레이션 Class B": "NWS",
  "뉴스맥스": "NMAX",
  "뉴스케일 파워": "SMR",
  "뉴스킨 엔터프라이즈": "NUS",
  "뉴아메리카 애퀴지션": "NWAX",
  "뉴암스테르담 파마 컴퍼니": "NAMS",
  "뉴에그 커머스": "NEGG",
  "뉴욕 시티 리츠": "NYC",
  "뉴욕멜론은행": "BNY",
  "뉴욕타임스": "NYT",
  "뉴웰리스": "NUWE",
  "뉴웰브랜즈": "NWL",
  "뉴저지 리소시스": "NJR",
  "뉴젠Ivf 그룹": "NIVF",
  "뉴코": "NUE",
  "뉴타닉스": "NTNX",
  "뉴턴 골프": "NWTG",
  "뉴테크원 우선주 Series B": "NEWTP",
  "뉴텍 비즈니스 서비스": "NEWT",
  "뉴텍스 헬스": "NUTX",
  "뉴트론 홀딩스": "LIME",
  "뉴트리밴드": "NTRB",
  "뉴트리엔": "NTR",
  "뉴포리아 테라퓨틱스": "NEUP",
  "뉴홀드 인베스트먼트 III": "NHIC",
  "뉴홀드 인베스트먼트 IV": "NHIV",
  "니오 ADR": "NIO",
  "니오젠": "NEOG",
  "니오코프 디벨롭먼츠": "NB",
  "니온 테크놀로지스 홀딩스": "NTHI",
  "니콜라 마이닝 ADR": "NICM",
  "니콜렛 뱅크셰어스": "NIC",
  "닉소아": "NYXH",
  "닉시": "NIXX",
  "다나": "DAN",
  "다나오스": "DAC",
  "다나허": "DHR",
  "다든 레스토랑": "DRI",
  "다리오헬스": "DRIO",
  "다모라 테라퓨틱스": "DMRA",
  "다비타": "DVA",
  "다우": "DOW",
  "다우치": "DCH",
  "다이나믹스": "DYNC",
  "다이나믹스 III": "DNMX",
  "다이나트레이스": "DT",
  "다이넥스 캐피털": "DX",
  "다이달로스 스페셜 애퀴지션": "DSAC",
  "다이렉트 디지털 홀딩스": "DRCT",
  "다이렉트부킹 테크놀로지": "ZDAI",
  "다이버시파이드 에너지": "DEC",
  "다이버시파이드 헬스케어": "DHC",
  "다이볼드 닉스도르프": "DBD",
  "다이아딕 인터내셔널": "DYAI",
  "다이아메디카 테라퓨틱스": "DMAC",
  "다이아몬드락 하스피탈리티": "DRH",
  "다이아몬드백 에너지": "FANG",
  "다이안서스 테라퓨틱스": "DNTH",
  "다이애나 쉬핑": "DSX",
  "다이오즈": "DIOD",
  "다이콤 인더스트리스": "DY",
  "다인 테라퓨틱스": "DYN",
  "다인브랜드글로벌": "DIN",
  "다임 커머셜 뱅크셰어스": "DCOM",
  "다초 뉴 에너지 ADR": "DQ",
  "다케다 파마슈티컬 ADR": "TAK",
  "다코타 골드": "DC",
  "다크아이리스": "DKI",
  "닥소": "DXR",
  "닥터 레디스 래보라토리스 ADR": "RDY",
  "닥트로닉스": "DAKT",
  "달러 제너럴": "DG",
  "달러 트리": "DLTR",
  "달링 인그리디언츠": "DAR",
  "더 심플리 굿 푸드": "SMPL",
  "더글라스 다이내믹스": "PLOW",
  "더글라스 엘리먼": "DOUG",
  "더글러스 에밋": "DEI",
  "더나인 ADR": "NCTY",
  "더마타 테라퓨틱스": "DRMA",
  "더블다운 인터랙티브 ADR": "DDI",
  "더블베리파이 홀딩스": "DV",
  "더치 브로스": "BROS",
  "덜루스 홀딩스": "DLTH",
  "데니슨 마인스": "DNN",
  "데번 에너지": "DVN",
  "데스웰 인더스트리": "DSWL",
  "데스티네이션 XL 그룹": "DXLG",
  "데어 바이오사이언스": "DARE",
  "데이브": "DAVE",
  "데이브 & 버스터스 엔터테인먼트": "PLAY",
  "데이타센트렉스": "DTCX",
  "데이터 I/O": "DAIO",
  "데이터 스토리지": "DTST",
  "데이터도그": "DDOG",
  "데이터메즈 AI": "MEDS",
  "데이터볼트 AI": "DVLT",
  "데이터씨 인텔리전트 테크": "DTSS",
  "데일리 저널": "DJCO",
  "데카르트 시스템즈 그룹": "DSGX",
  "데피니움 테라퓨틱스": "DFTX",
  "데피니티브 헬스케어": "DH",
  "덱스컴": "DXCM",
  "덱커 아웃도어": "DECK",
  "덴츠플라이 시로나": "XRAY",
  "델렉 유에스 홀딩스": "DK",
  "델릭시 홀딩스": "DLXY",
  "델몬트": "DMC",
  "델캐스 시스템즈": "DCTH",
  "델타 에어라인스": "DAL",
  "델테크놀로지": "DELL",
  "도그니스 인터네셔널": "DOGZ",
  "도그우드 테라퓨틱스": "DWTX",
  "도널드슨": "DCI",
  "도넬리 파이낸셜 솔루션스": "DFIN",
  "도니골 그룹 Class A": "DGICA",
  "도니골 그룹 Class B": "DGICB",
  "도리안 LPG": "LPG",
  "도먼 프로덕츠": "DORM",
  "도모": "DOMO",
  "도미나리 홀딩스": "DOMH",
  "도미노피자": "DPZ",
  "도미니언 에너지": "D",
  "도버": "DOV",
  "도세보": "DCBO",
  "도슨 지오피지컬": "DWSN",
  "도어대시": "DASH",
  "도유 인터내셔널 홀딩스 ADR": "DOYU",
  "도이치은행": "DB",
  "도쿄 라이프스타일 ADR": "TKLF",
  "도큐사인": "DOCU",
  "독고": "DCGO",
  "독시미티": "DOCS",
  "돌": "DOLE",
  "돌비 래보라토리스": "DLB",
  "돌핀 엔터테인먼트": "DLPN",
  "듀오링고": "DUOL",
  "듀오스 테크놀로지 그룹": "DUOT",
  "듀코먼": "DCO",
  "듀크 로보틱스": "DUKR",
  "듀크 에너지": "DUK",
  "듀폰": "DD",
  "드라간플라이": "DPRO",
  "드랍박스": "DBX",
  "드래곤플라이 에너지 홀딩스": "DFLI",
  "드래프트킹즈 홀딩스": "DKNG",
  "드러그스 메이드 인 아메리카 애퀴지션": "DMAA",
  "드러그스 메이드 인 아메리카 애퀴지션 II": "DMII",
  "드리븐 브랜즈 홀딩스": "DRVN",
  "드릴링 툴스 인터내셔널": "DTI",
  "드림 파인더스 홈즈": "DFH",
  "드림랜드": "TDIC",
  "디 마켓 일렉트로시티 ADR": "HEPS",
  "디 보럴 ARC 애퀴지션 I": "BCAR",
  "디 웨이브 퀀텀": "QBTS",
  "디나우": "DNOW",
  "디날리 테라퓨틱스": "DNLI",
  "디로컬": "DLO",
  "디서플린드 그로스 애퀴지션": "DGAC",
  "디센트 홀딩": "DXST",
  "디스크 메디슨": "IRON",
  "디스트리뷰션 솔루션스 그룹": "DSGR",
  "디아지오 ADR": "DEO",
  "디어": "DE",
  "디자이너 브랜즈": "DBI",
  "디자인 테라퓨틱스": "DSGN",
  "디지 인터내셔널": "DGII",
  "디지 파워 X": "DGXX",
  "디지넥스": "DGNX",
  "디지마크": "DMRC",
  "디지털 리얼티 트러스트": "DLR",
  "디지털 브랜즈 그룹": "DBGI",
  "디지털 애셋 애퀴지션": "DAAQ",
  "디지털 커런시 X 테크놀로지": "DCX",
  "디지털 터빈": "APPS",
  "디지털브리지 그룹": "DBRG",
  "디지털오션 홀딩스": "DOCN",
  "디파이 디벨롭먼트": "DFDV",
  "디파이 테크놀로지스": "DEFT",
  "딕스 스포팅 굿즈": "DKS",
  "딜라드 캐피탈 트러스트 I": "DDT",
  "딜라즈": "DDS",
  "딜럭스": "DLX",
  "딥 피션": "FISN",
  "딩동 (케이먼) ADR": "DDL",
  "라 로사 홀딩스": "LRHC",
  "라니 테라퓨틱스 홀딩스": "RANI",
  "라드웨어": "RDWR",
  "라디안 그룹": "RDN",
  "라디오팜 테라노스틱스 ADR": "RADX",
  "라르고": "LGO",
  "라리마 테라퓨틱스": "LRMR",
  "라마 애드버타이징": "LAMR",
  "라마코 리소시스 Class A": "METC",
  "라마코 리소시스 Class B": "METCB",
  "라스베이거스 샌즈": "LVS",
  "라이더 시스템": "R",
  "라이드 그룹": "RYDE",
  "라이드나우 그룹": "RDNW",
  "라이먼 호스피탤리티 프로퍼티스": "RHP",
  "라이브 네이션 엔터테인먼트": "LYV",
  "라이브 벤처스": "LIVE",
  "라이브 오크 뱅크셰어스": "LOB",
  "라이브램프 홀딩스": "RAMP",
  "라이브원": "LVO",
  "라이브퍼슨": "LPSN",
  "라이스 애퀴지션 3": "KRSP",
  "라이어슨 홀딩": "RYZ",
  "라이언 스페셜티 홀딩스": "RYAN",
  "라이언에어 홀딩스 ADR": "RYAAY",
  "라이엇 플랫폼즈": "RIOT",
  "라이엘 이뮤노파마": "LYEL",
  "라이온 그룹 홀딩스 ADR": "LGHL",
  "라이온델바젤 인더스트리스": "LYB",
  "라이온스게이트 스튜디오스": "LION",
  "라이온하트 홀딩스": "CUB",
  "라이징 드래곤 애퀴지션": "RDAC",
  "라이터 로그텍 홀딩스": "RITR",
  "라이트 스트래티지": "LITS",
  "라이트브리지": "LTBR",
  "라이트스피드 커머스": "LSPD",
  "라이트웨이브 로직": "LWLG",
  "라이트웨이브 애퀴지션": "LWAC",
  "라이트인더박스 홀딩 ADR": "LITB",
  "라이트패스 테크놀로지스": "LPTH",
  "라이프 타임 그룹 홀딩스": "LTH",
  "라이프360": "LIF",
  "라이프라스 ADR": "LFS",
  "라이프밴티지": "LFVN",
  "라이프스탠스 헬스 그룹": "LFST",
  "라이프엠디": "LFMD",
  "라이프엠디 우선주 시리즈 A 8.875%": "LFMDP",
  "라이프워드": "LFWD",
  "라이프웨이 푸드": "LWAY",
  "라이프존 메탈스": "LZM",
  "라이프코어 바이오메디컬": "LFCR",
  "라이프타임 브랜즈": "LCUT",
  "라인벡 뱅코프": "RBKB",
  "라일리 익스플로레이션 퍼미안": "REPX",
  "라자드": "LAZ",
  "라탐 그룹": "SWIM",
  "라탐 에어라인스 그룹 ADR": "LTM",
  "라파엘 홀딩스": "RFL",
  "라파예트 디지털 애퀴지션 I": "ZKP",
  "라파예트 애퀴지션": "LAFA",
  "라포르 테라퓨틱스": "RAPP",
  "란자테크 글로벌": "LNZA",
  "란팍 홀딩스": "PACK",
  "랄프 로렌": "RL",
  "랑방 그룹 홀딩스": "LANV",
  "래더 캐피털": "LADR",
  "래드넷": "RDNT",
  "래드콤": "RDCM",
  "래티스 세미컨덕터": "LSCC",
  "래피드 마이크로 바이오시스템스": "RPID",
  "래피드7": "RPD",
  "랙스페이스 테크놀로지": "RXT",
  "랜드 캐피탈": "RAND",
  "랜드마크 뱅코프": "LARK",
  "랜드브리지": "LB",
  "랜드스타 시스템": "LSTR",
  "랜즈 엔드": "LE",
  "랜턴 파마": "LTRN",
  "랜티우스 홀딩스": "LNTH",
  "랠리바이오": "RLYB",
  "랠리언트": "RAL",
  "램 리서치": "LRCX",
  "램 웨스턴 홀딩스": "LW",
  "램버스": "RMBS",
  "랩 테크놀로지스": "WRAP",
  "랩코프 홀딩스": "LH",
  "랭크 원 컴퓨팅": "ROC",
  "러브색": "LOVE",
  "러시 스트리트 인터랙티브": "RSI",
  "러시 엔터프라이즈 Class A": "RUSHA",
  "러시 엔터프라이즈 Class B": "RUSHB",
  "럭스익스피리언스 ADR": "LUXE",
  "럭스퍼 홀딩스": "LXFR",
  "럭키 스트라이크 엔터테인먼트": "LUCK",
  "런웨이 그로스 파이낸스": "RWAY",
  "런치 원 애퀴지션": "LPAA",
  "런치 투 애퀴지션": "LPBB",
  "런치패드 카덴자 애퀴지션 I": "LPCV",
  "럼 그룹": "RUM",
  "레가시 에듀케이션": "LGCY",
  "레가시 하우징": "LEGH",
  "레가토 머저 IV": "LEGO",
  "레겟 & 플랫": "LEG",
  "레나 Class A": "LEN",
  "레나투스 택티컬 애퀴지션 I": "RTAC",
  "레노보Rx": "RNXT",
  "레녹스 인터내셔널": "LII",
  "레드 락 리조트": "RRR",
  "레드 로빈 고메 버거스": "RRGB",
  "레드 리버 뱅크셰어스": "RRBI",
  "레드 바이올렛": "RDVT",
  "레드 캣 홀딩스": "RCAT",
  "레드와이어": "RDW",
  "레드우드 트러스트": "RWT",
  "레드클라우드 홀딩스": "RCT",
  "레드힐 바이오파마 ADR": "RDHL",
  "레디 캐피털": "RC",
  "레딧": "RDDT",
  "레모네이드": "LMND",
  "레벨레이션 바이오사이언시스": "REVB",
  "레볼루션 메디신": "RVMD",
  "레비티": "RVTY",
  "레사카 테크놀로지스": "LSAK",
  "레스메드": "RMD",
  "레스토랑 브랜즈 인터내셔널": "QSR",
  "레슬리즈": "LESL",
  "레신핀테크 홀딩스 ADR": "LX",
  "레어 어스 아메리카스": "REA",
  "레어드 슈퍼푸드": "LSF",
  "레오나르도 DRS": "DRS",
  "레오나바이오": "LONA",
  "레이놀드 컨슈머 프라덕츠": "REYN",
  "레이도스 홀딩스": "LDOS",
  "레이디언트 로지스틱스": "RLGT",
  "레이먼드 제임스 파이낸셜": "RJF",
  "레이브 레스토랑 그룹": "RAVE",
  "레이센 에너지 홀딩": "LSE",
  "레이어니어": "RYN",
  "레이오니어 어드밴스드 머티리얼": "RYAM",
  "레이저 포토닉스": "LASE",
  "레이지보이": "LZB",
  "레이크 쇼어 뱅코프": "LSBK",
  "레이크 슈페리얼 애퀴지션": "LKSP",
  "레이크랜드 인더스트리스": "LAKE",
  "레이크랜드 파이낸셜": "LKFN",
  "레이크쇼어 애퀴지션 III": "LCCC",
  "레이크우드 아메덱스 바이오": "LABT",
  "레이크프론트 바이오테라퓨틱스": "LKFT",
  "레이텍 홀딩": "RAY",
  "레인 인한스먼트 테크놀로지스": "RAIN",
  "레인 테라퓨틱스": "RNTX",
  "레인져 에너지 서비스": "RNGR",
  "레인지 리소시스": "RRC",
  "레인지 캐피탈 애퀴지션": "RANG",
  "레인지 캐피털 애퀴지션 II": "RNGT",
  "레일 비전": "RVSN",
  "레저보아르 미디어": "RSVR",
  "레전드 바이오테크 ADR": "LEGN",
  "레전스": "LGN",
  "레졸루트": "RZLT",
  "레졸루트 홀딩스 매니지먼트": "RHLD",
  "레지디오 테크놀러지": "REZI",
  "레지스": "RGS",
  "레코 시스템": "REKR",
  "레콘 테크놀러지": "RCON",
  "레포지트랙": "TRAK",
  "레플리뮨 그룹": "REPL",
  "레플리젠": "RGEN",
  "렉사리아 바이오사이언스": "LEXX",
  "렉스 아메리칸 리소시즈": "REX",
  "렉스포드 인더스트리얼 리얼티": "REXR",
  "렉시오 테라퓨틱스": "LXEO",
  "렉시콘 파마슈티컬스": "LXRX",
  "렉티튜드 홀딩스": "RECT",
  "렌딩트리": "TREE",
  "렌엑스 엔터프라이즈": "RENX",
  "렌자": "LNSR",
  "렌즈 테라퓨틱스": "LENZ",
  "렌토킬 이니셜 ADR": "RTO",
  "렌트 더 런웨이": "RENT",
  "렌트로닉": "LTRX",
  "렐러티비티 애퀴지션": "BIOT",
  "렐마다 테라퓨틱스": "RLMD",
  "렐엑스 ADR": "RELX",
  "로그프로스타일": "LGPS",
  "로드젠": "RDZN",
  "로리어트 에듀케이션": "LAUR",
  "로마 그린 파이낸스": "ROMA",
  "로마 네그라 콤파니아 인더스트리얼 ADR": "LOMA",
  "로만 DBDR 애퀴지션 II": "DRDB",
  "로버트 하프 인터내셔널": "RHI",
  "로보 테크놀로지스": "LOBO",
  "로보.ai": "AIIO",
  "로보스트래티지": "BOT",
  "로봇 컨설팅 ADR": "LAWR",
  "로블록스": "RBLX",
  "로빈 에너지": "RBNE",
  "로빈후드": "HOOD",
  "로스 스토어스": "ROST",
  "로얄 골드": "RGLD",
  "로얄 캐리비안 크루즈": "RCL",
  "로어 홀딩스": "LOAR",
  "로열 뱅크 오브 캐나다": "RY",
  "로열티 매니지먼트 홀딩": "RMCO",
  "로열티 파마": "RPRX",
  "로우스": "L",
  "로우스 컴퍼니": "LOW",
  "로이반트 사이언시스": "ROIV",
  "로이즈 뱅킹 그룹 ADR": "LYG",
  "로저스": "ROG",
  "로저스 커뮤니케이션스": "RCI",
  "로지스틱 프로퍼티스 오브 디 아메리카스": "LPA",
  "로지텍 인터내셔널": "LOGI",
  "로커파이": "LCFY",
  "로컬 바운티": "LOCL",
  "로켓 랩": "RKLB",
  "로켓 원": "RKTO",
  "로켓 컴퍼니스": "RKT",
  "로켓 파머슈티컬스": "RCKT",
  "로쿠": "ROKU",
  "로크웰 오토메이션": "ROK",
  "로키 마운틴 초콜릿 팩토리": "RMCF",
  "로키 브랜즈": "RCKY",
  "로터스 테크놀로지 ADR": "LOT",
  "로퍼 테크놀로지스": "ROP",
  "록웰 메디컬": "RMTI",
  "록히드 마틴": "LMT",
  "론디포": "LDI",
  "롤린스": "ROL",
  "롱 테이블 그로스": "LTGR",
  "롱에버론": "LGVN",
  "루나이 바이오웍스": "LNAI",
  "루다 테크놀로지 그룹": "LUD",
  "루루스 패션 라운지 홀딩스": "LVLU",
  "루먼트 파이낸스 트러스트": "LFT",
  "루멕사 이미징 홀딩스": "LMRI",
  "루멘 테크놀로지스": "LUMN",
  "루멘텀 홀딩스": "LITE",
  "루브릭": "RBRK",
  "루비코": "RUBI",
  "루시드 그룹": "LCID",
  "루시드 다이어그노스틱스": "LUCD",
  "루안윈 에다이 테크놀로지": "RYET",
  "루이지애나-퍼시픽": "LPX",
  "루카스 GC": "LGCL",
  "루트": "ROOT",
  "루팍스 홀딩 ADR": "LU",
  "룰루레몬 애슬레티카": "LULU",
  "룹 인더스트리": "LOOP",
  "르네산트": "RNST",
  "르네상스리 홀딩스": "RNR",
  "르메이트르 배스큘러": "LMAT",
  "리 뱅 인터내셔널": "LBGJ",
  "리 엔터프라이즈": "LEE",
  "리 오토 ADR": "LI",
  "리/맥스 홀딩스": "RMAX",
  "리간드 파마슈티컬스": "LGND",
  "리갈 벨로이트": "RBC",
  "리갈줌닷컴": "LZ",
  "리걸 렉스노드": "RRX",
  "리게티 컴퓨팅": "RGTI",
  "리겔 파마슈티컬스": "RIGL",
  "리뉴 에너지 글로벌": "RNW",
  "리니지": "LINE",
  "리니지 셀 테라퓨틱스": "LCTX",
  "리드 리얼 에스테이트 ADR": "LRE",
  "리듬": "RYM",
  "리듬 애퀴지션": "RAC",
  "리듬 캐피탈": "RITM",
  "리듬 파머수티컬스": "RYTM",
  "리듬 프로퍼티 트러스트": "RPT",
  "리딩 인터내셔널 Class A": "RDI",
  "리딩 인터내셔널 Class B": "RDIB",
  "리모네이라": "LMNR",
  "리미나투스 파마": "LIMN",
  "리미니스트리트": "RMNI",
  "리미틀리 글로벌": "RELY",
  "리바노바": "LIVN",
  "리바이 스트라우스": "LEVI",
  "리버뷰 뱅코프": "RVSB",
  "리버티 글로벌 Class A": "LBTYA",
  "리버티 글로벌 Class B": "LBTYB",
  "리버티 글로벌 Class C": "LBTYK",
  "리버티 디펜스 홀딩스": "DETX",
  "리버티 라이브 Series C": "LLYVK",
  "리버티 라이브 홀딩스 Series A": "LLYVA",
  "리버티 라틴 아메리카 Class A": "LILA",
  "리버티 라틴 아메리카 Class C": "LILAK",
  "리버티 라틴 아메리카 우선주 Series A 9.0%": "LILAP",
  "리버티 브로드밴드 시리즈 A": "LBRDA",
  "리버티 브로드밴드 시리즈 C": "LBRDK",
  "리버티 브로드밴드 우선주 시리즈 A 7.000%": "LBRDP",
  "리버티 에너지": "LBRT",
  "리본 애퀴지션": "RIBB",
  "리본 커뮤니케이션": "RBBN",
  "리본 커피": "REBN",
  "리볼브 그룹": "RVLV",
  "리비안": "RIVN",
  "리사타 테라퓨틱스": "LSTA",
  "리샹 에듀케이션 홀딩 ADR": "LXEH",
  "리서치 솔루션스": "RSSS",
  "리서치 얼라이언스 III": "RACC",
  "리서치 얼라이언스 IV": "RACD",
  "리서치 프런티어스": "REFR",
  "리소스 커넥션": "RGP",
  "리스키파이드": "RSKD",
  "리시아 모터스": "LAD",
  "리안허 소웰 인터내셔널 그룹": "LHSW",
  "리알파 테크": "AIRE",
  "리어": "LEA",
  "리얼 메신저": "RMSG",
  "리얼 브로커리지": "REAX",
  "리얼리얼": "REAL",
  "리얼티 인컴": "O",
  "리오 틴토 ADR": "RIO",
  "리인슈어런스 그룹 오브 아메리카": "RGA",
  "리저널 매니지먼트": "RM",
  "리전스 파이낸셜": "RF",
  "리제네론 파마슈티컬스": "REGN",
  "리젠셀 바이오사이언스 홀딩스": "RGC",
  "리젠시 센터스": "REG",
  "리젠시 센터스 우선주 Series A 6.25%": "REGCP",
  "리젠시 센터스 우선주 Series B 5.875%": "REGCO",
  "리젠엑스바이오": "RGNX",
  "리젠티스 바이오머티리얼즈": "RGNT",
  "리졸브 AI": "RZLV",
  "리즈": "REED",
  "리지테크": "RDGT",
  "리처드슨 일렉트로닉스": "RELL",
  "리첸 인터내셔널": "LICN",
  "리치 브로스 옥셔니어스": "RBA",
  "리치 스파클 홀딩스": "ANPA",
  "리치몬드 뮤추얼 뱅코포레이션": "RMBI",
  "리치테크 로보틱스": "RR",
  "리커젼 파마슈티컬스": "RXRX",
  "리퀴디아": "LQDA",
  "리퀴디티 서비스": "LQDT",
  "리크테크 인터내셔널": "LIQT",
  "리토 에코-솔루션": "RETO",
  "리튬 아르헨티나": "LAR",
  "리튬 아메리카스": "LAC",
  "리트랙터블 테크놀로지스": "RVP",
  "리틀휴즈": "LFUS",
  "리퍼블릭 디지털 애퀴지션": "RDAG",
  "리퍼블릭 뱅코프": "RBCAA",
  "리퍼블릭 서비스": "RSG",
  "리퍼블릭 파워 그룹": "RPGL",
  "리페이 홀딩스": "RPAY",
  "리포메이션": "REF",
  "리포신": "LPCN",
  "리프트": "LYFT",
  "리프트오프 모바일": "LFTO",
  "린드": "LIN",
  "린드블라드 익스퍼디션스 홀딩스": "LIND",
  "린지": "LNN",
  "릴라이언스": "RS",
  "릴라이언스 글로벌 그룹": "EZRA",
  "릴레이 테라퓨틱스": "RLAY",
  "림바흐 홀딩스": "LMB",
  "립프라그 애퀴지션": "LFAC",
  "링 에너지": "REI",
  "링센트럴": "RNG",
  "링커스 인더스트리스": "LNKS",
  "링컨 내셔널": "LNC",
  "링컨 에듀케이셔널 서비스": "LINC",
  "링컨 인터내셔널": "LCLN",
  "링컨 일렉트릭 홀딩스": "LECO",
  "링크홈 홀딩스": "LHAI",
  "링키지 글로벌": "UZX",
  "마그나 인터내셔널": "MGA",
  "마그네라": "MAGN",
  "마라 홀딩스": "MARA",
  "마라바이 라이프사이언시스 홀딩스": "MRVI",
  "마라톤 뱅코프": "MBBC",
  "마렉스 UK 홀딩스": "MRX",
  "마르제티": "MZTI",
  "마리스 테크": "MTEK",
  "마린맥스": "HZO",
  "마마스 크리에이션스": "MAMA",
  "마벨 테크놀로지 그룹": "MRVL",
  "마스": "MAAS",
  "마스터브랜드": "MBC",
  "마스터비프 그룹": "MB",
  "마스터카드": "MA",
  "마스터크래프트 보트 홀딩스": "MCFT",
  "마스텍": "MTZ",
  "마시모 그룹": "MAMO",
  "마우이 랜드 & 파인애플": "MLP",
  "마운트 로건 캐피털": "MLCI",
  "마운틴 레이크 애퀴지션 II": "MLAA",
  "마운틴 크레스트 애퀴지션 6": "MCAH",
  "마이 사이즈": "MYSZ",
  "마이모": "MYO",
  "마이아 바이오테크놀로지": "MAIA",
  "마이애미 인터내셔널 홀딩스": "MIAX",
  "마이어스 인더스트리스": "MYE",
  "마이지엄 AI": "MYSE",
  "마이크로배스트 홀딩스": "MVST",
  "마이크로봇 메디컬": "MBOT",
  "마이크로비전": "MVIS",
  "마이크로소프트": "MSFT",
  "마이크로알고": "MLGO",
  "마이크로칩 테크놀러지": "MCHP",
  "마이크로칩 테크놀로지 우선주 Series A 7.50%": "MCHPP",
  "마이크로클라우드 홀로그램": "HOLO",
  "마이크로폴리스 홀딩": "MCRP",
  "마이크론 테크놀로지": "MU",
  "마이크웨어 ADR": "MWC",
  "마이텍 시스템즈": "MITK",
  "마인드 테크놀로지": "MIND",
  "마인드.ai ADR": "MYND",
  "마인드워크 홀딩스": "HYFT",
  "마인드포지": "MF",
  "마일스톤 사이언티픽": "MLSS",
  "마일스톤 파머수티컬스": "MIST",
  "마자르 뱅코프": "MGYR",
  "마첵스": "MCHX",
  "마커 테라퓨틱스": "MRKR",
  "마커스": "MCS",
  "마케타": "MQ",
  "마켈": "MKL",
  "마켓액세스 홀딩스": "MKTX",
  "마켓와이즈": "MKTW",
  "마코 마이닝": "MAKO",
  "마타도 리소시스": "MTDR",
  "마테리언": "MTRN",
  "마텐 트랜스포트": "MRTN",
  "마텔": "MAT",
  "마티나스 바이오팜 홀딩스": "MTNB",
  "마티브 홀딩스": "MATV",
  "마틴 마리에타 머터리얼스": "MLM",
  "막시무스": "MMS",
  "말리부 보츠": "MBUU",
  "말윈 홀딩스": "MWYN",
  "망고슈티컬스": "MGRX",
  "매그나이트": "MGNI",
  "매그나칩 세미컨덕터": "MX",
  "매그넘 아이스크림 컴퍼니": "MICC",
  "매그놀리아 오일 & 가스": "MGY",
  "매그니튜드 인터내셔널": "MAGH",
  "매나테크": "MTEX",
  "매뉴라이프 파이낸셜": "MFC",
  "매니토웍 컴퍼니": "MTW",
  "매드리갈 파마슈티컬스": "MDGL",
  "매디슨 스퀘어 가든 스포츠": "MSGS",
  "매디슨 스퀘어 가든 엔터테인먼트": "MSGE",
  "매디슨 에어 솔루션스": "MAIR",
  "매러선 페트롤리엄": "MPC",
  "매머드 에너지서비스": "TUSK",
  "매스코": "MAS",
  "매직 엠파이어 글로벌": "MEGL",
  "매치 그룹": "MTCH",
  "매케슨": "MCK",
  "매크로제닉스": "MGNX",
  "매튜스 인터내셔널": "MATW",
  "매트릭스 서비스": "MTRX",
  "매트슨": "MATX",
  "맥그래스 렌트코프": "MGRC",
  "맥그로 힐": "MH",
  "맥도날드": "MCD",
  "맥스리니어": "MXL",
  "맥스메이킹": "MAMK",
  "맥스사이트": "MXCT",
  "맥이웬": "MUX",
  "맥켄지 리얼티 캐피털": "MKZR",
  "맥코믹 앤 컴퍼니 무의결권주": "MKC",
  "맥킨리 애퀴지션": "MKLY",
  "맨체스터 유나이티드": "MANU",
  "맨카인드": "MNKD",
  "맨파워그룹": "MAN",
  "맨해튼 브리지 캐피털": "LOAN",
  "맨해튼 어소시에이츠": "MANH",
  "맵라이트 테라퓨틱스": "MPLT",
  "머니히로": "MNY",
  "머서 인터내셔널": "MERC",
  "머스탱 바이오": "MBIO",
  "머천트 뱅코프": "MBIN",
  "머천트 뱅코프 우선주 8.25%": "MBINM",
  "머천트 뱅코프 우선주 Series E 7.25%": "MBINL",
  "머천트 뱅코프 우선주 시리즈 C 6%": "MBINN",
  "머컨틸 은행": "MBWM",
  "머큐리 시스템즈": "MRCY",
  "머큐리 제너럴": "MCY",
  "머크 앤 코": "MRK",
  "머티리얼라이즈 ADR": "MTLS",
  "머피 USA": "MUSA",
  "머피 오일": "MUR",
  "먼로": "MNRO",
  "멀티 웨이스 홀딩스": "MWG",
  "멀티센서 AI 홀딩스": "MSAI",
  "메가 매트릭스": "MPU",
  "메가 포춘": "MGRT",
  "메간 홀딩스": "MGN",
  "메달리스트 다이버시파이드": "MDRR",
  "메달리언 뱅크 우선주 Series G": "MBNKO",
  "메달리언 파이낸셜": "MFIN",
  "메드라인": "MDLN",
  "메드테크 애퀴지션": "TLSI",
  "메드트로닉": "MDT",
  "메드페이스 홀딩스": "MEDP",
  "메디롬 헬스케어 테크놀로지스 ADR": "MRM",
  "메디운드": "MDWD",
  "메디치노바": "MNOV",
  "메디컬 프로퍼티즈 트러스트": "MPT",
  "메디쿠스 파마": "MDCX",
  "메디패스트": "MED",
  "메르카도리브레": "MELI",
  "메리골드 컴퍼니스": "MGLD",
  "메리디안": "MRBK",
  "메리어트 버케이션 월드와이드": "VAC",
  "메리어트 인터내셔널": "MAR",
  "메리트 메디컬 시스템즈": "MMSI",
  "메리티지 홈즈": "MTH",
  "메사 래보라토리스": "MLAB",
  "메사 로열티 트러스트": "MTR",
  "메사비 트러스트": "MSB",
  "메소드 일렉트로닉스": "MEI",
  "메쉬플로우 애퀴지션": "MESH",
  "메스테크 홀딩스": "MHH",
  "메이라 지티 엑스 홀딩스": "MGTX",
  "메이빌 엔지니어링": "MEC",
  "메이서리치": "MAC",
  "메이슨글로리": "MSGY",
  "메이시스": "M",
  "메이우 테크놀로지": "WNW",
  "메이우드 애퀴지션 2": "MYX",
  "메이즈 테라퓨틱스": "MAZE",
  "메이크마이트립": "MMYT",
  "메이페어 골드": "MINE",
  "메이플베어": "CART",
  "메인 스트리트 캐피털": "MAIN",
  "메인스트리트 뱅크셰어스": "MNSB",
  "메인스트리트 뱅크셰어스 우선주 시리즈 A 7.50%": "MNSBP",
  "메조블라스트 ADR": "MESO",
  "메종 솔루션스": "MSS",
  "메카닉스 뱅코프": "MCHB",
  "메타": "META",
  "메타넥스": "MEOH",
  "메타비아": "MTVA",
  "메타알파 테크놀로지 홀딩": "MATH",
  "메타지노미 테라퓨틱스": "MGX",
  "메탈라 로열티 & 스트리밍": "MTA",
  "메탈루스": "MTUS",
  "메탈스 로열티 컴퍼니": "TMCR",
  "메탈스 애퀴지션 II": "MTAL",
  "메트라이프": "MET",
  "메트로시티 뱅크셰어즈": "MCBS",
  "메트로폴리탄 뱅크 홀딩스": "MCB",
  "메틀러 톨레도 인터내셔널": "MTD",
  "멕스코 에너지": "MXC",
  "멜라르 애퀴지션 I": "MACI",
  "멜코 리조트 & 엔터테인먼트 ADR": "MLCO",
  "명등 인터내셔널": "MTEN",
  "모간스탠리": "MS",
  "모간스탠리 다이렉트 렌딩 펀드": "MSDL",
  "모나크 카지노 & 리조트": "MCRI",
  "모노파 테라퓨틱스": "MNPR",
  "모닝스타": "MORN",
  "모더나": "MRNA",
  "모듈러 메디컬": "MODD",
  "모디브 인더스트리얼": "MDV",
  "모멘터스": "MNTS",
  "모바도 그룹": "MOV",
  "모바일 인프라스트럭처": "BEEP",
  "모비아 메디컬": "MOBI",
  "모빅스 랩스": "MOBX",
  "모빌리티 글로벌": "MBGL",
  "모빌아이 글로벌": "MBLY",
  "모엘리스": "MC",
  "모자익스 애퀴지션": "MZYX",
  "모터스포츠 게임즈": "MSGM",
  "모터카 파츠 오브 아메리카": "MPAA",
  "모토로라 솔루션스": "MSI",
  "모호크 인더스트리스": "MHK",
  "몬덜리즈 인터내셔널": "MDLZ",
  "몬스터 베버리지": "MNST",
  "몬탁 리뉴어블스": "MNTK",
  "몬테 로사 테라퓨틱스": "GLUE",
  "몰레큘러 파트너스 ADR": "MOLN",
  "몰리나 헬스케어": "MOH",
  "몰슨 쿠어스 베버리지 Class A": "TAP-A",
  "몰슨 쿠어스 베버리지 Class B": "TAP",
  "몰컬린 바이오테크": "MBRX",
  "몽고DB": "MDB",
  "무디스": "MCO",
  "무라노 글로벌 인베스트먼츠": "MRNO",
  "무빙 이미지 테크놀로지스": "MITQ",
  "물렉 사이언스": "MLEC",
  "뮤제로 애퀴지션": "MUZE",
  "뮬러 워터 프로덕츠": "MWA",
  "뮬러 인더스트리스": "MLI",
  "미나스 부에나벤투라 ADR": "BVN",
  "미네랄리스 테라퓨틱스": "MLYS",
  "미네랄스 테크놀로지스": "MTX",
  "미네르바 뉴로사이언시스": "NERV",
  "미니메드 그룹": "MMED",
  "미니소 그룹 홀딩 ADR": "MNSO",
  "미데라 푸드 프로세싱": "MFP",
  "미드 펜 뱅코프": "MPB",
  "미드랜드 스테이츠 뱅코프": "MSBI",
  "미드랜드 스테이츠 뱅코프 우선주 시리즈 A": "MSBIP",
  "미드아메리카 아파트 커뮤니티": "MAA",
  "미드캡 파이낸셜 인베스트먼트": "MFIC",
  "미들비": "MIDD",
  "미디아코 홀딩": "MDIA",
  "미디어알파": "MAX",
  "미라 파마슈티컬스": "MIRA",
  "미럼 파마슈티컬스": "MIRM",
  "미리아드 제네틱스": "MYGN",
  "미리온 테크놀로지스": "MIR",
  "미메드엑스 그룹": "MDXG",
  "미션 프로듀스": "AVO",
  "미스트라스 그룹": "MG",
  "미쓰비시 UFJ 파이낸셜 그룹 ADR": "MUFG",
  "미즈호 파이낸셜그룹 ADR": "MFG",
  "민트": "MIMI",
  "밀러 인더스트리스": "MLR",
  "밀러놀": "MLKN",
  "밀레니엄 그룹 인터내셔널 홀딩스": "MGIH",
  "밀로즈 프로퍼티스": "MRP",
  "밀루나 애퀴지션": "MMTX",
  "밀리콤 인터내셔널 셀룰러": "TIGO",
  "밍싱 그룹 홀딩스": "PMA",
  "밍크 테라퓨틱스": "INKT",
  "바 하버 뱅크셰어스": "BHB",
  "바렉스 이미징": "VREX",
  "바렛 비지니스 서비스": "BBSI",
  "바로니스 시스템즈": "VRNS",
  "바릭 마이닝": "B",
  "바린투스 바이오테라퓨틱스 ADR": "BRNS",
  "바브 애퀴지션": "BHAV",
  "바셋 퍼니처 인더스트리스": "BSET",
  "바슈 헬스 컴퍼니스": "BHC",
  "바슈롬": "BLCO",
  "바오셩 미디어 그룹 홀딩스": "BAOS",
  "바오준 ADR": "BZUN",
  "바운드리스 바이오": "BOLD",
  "바이두 ADR": "BIDU",
  "바이라인 뱅코프": "BY",
  "바이랙스 바이오랩스 그룹": "VRAX",
  "바이시클 테라퓨틱스 ADR": "BCYC",
  "바이안트 테크놀로지": "DSP",
  "바이야 인터내셔널 그룹": "BIYA",
  "바이오 그린 메드 솔루션": "BGMS",
  "바이오-테크네": "TECH",
  "바이오MX": "PHGE",
  "바이오X셀 테라퓨틱스": "BTAI",
  "바이오나노 지노믹스": "BNGO",
  "바이오넥서스 진 랩": "BGLC",
  "바이오데식스": "BDSX",
  "바이오덱사 파마슈티컬스 ADR": "BDRX",
  "바이오라이프 솔루션스": "BLFS",
  "바이오라인 RX ADR": "BLRX",
  "바이오래드 래보라토리스 Class A": "BIO",
  "바이오리스토러티브 테라피스": "BRTX",
  "바이오마린 파마슈티컬": "BMRN",
  "바이오메리카": "BMRA",
  "바이오미아 퓨전": "BMEA",
  "바이오벤투스": "BVS",
  "바이오비": "BIVI",
  "바이오아틀라": "BCAB",
  "바이오어피니티 테크놀로지스": "BIAF",
  "바이오에이지 랩스": "BIOA",
  "바이오엔테크 ADR": "BNTX",
  "바이오젠": "BIIB",
  "바이오카디아": "BCDA",
  "바이오케레스 크랍 솔루션즈": "BIOX",
  "바이오크리스트 파마슈티컬스": "BCRX",
  "바이오키 인터내셔널": "BKYI",
  "바이오티": "BTMD",
  "바이오프론테라": "BFRI",
  "바이오하베스트 사이언스": "BHST",
  "바이오헤이븐": "BHVN",
  "바이옴 홀딩스": "HIND",
  "바이카라 테라퓨틱스": "BCAX",
  "바이코어 파마 홀딩 ADR": "VCRE",
  "바이킹 애퀴지션 I": "VACI",
  "바이킹 애퀴지션 II": "VII",
  "바이킹 테라퓨틱스": "VKTX",
  "바이킹 홀딩스": "VIK",
  "바이탈 팜스": "VITL",
  "바이퍼 에너지": "VNOM",
  "바인힐 캐피탈 인베스트먼트 II": "VHCP",
  "바젤 메디컬 그룹": "BMGL",
  "바크": "BARK",
  "바클레이즈 ADR": "BCS",
  "바탈리온 오일": "BATL",
  "바프레시 푸드 그룹": "BRFH",
  "박스": "BOX",
  "박스라잇": "BOXL",
  "박스터 인터내셔널": "BAX",
  "반다 파마슈티컬스": "VNDA",
  "반스 앤 노블 에듀케이션": "BNED",
  "반웰 인더스트리스": "BRN",
  "발네바 ADR": "VALN",
  "발라드 파워 시스템즈": "BLDP",
  "발레 ADR": "VALE",
  "발레로 에너지": "VLO",
  "발렌스 세미컨덕터": "VLN",
  "발리스": "BALY",
  "발켐": "BCPC",
  "발코 에너지": "EGY",
  "밥스 디스카운트 퍼니처": "BOBS",
  "밥콕 앤 윌콕스 엔터프라이스": "BW",
  "방코 데 칠레 ADR": "BCH",
  "방코 마크로 ADR": "BMA",
  "방코 빌바오 비스카야 아르헨타리아 ADR": "BBVA",
  "방코 산탄데르 ADR": "SAN",
  "방코 산탄데르 칠레 ADR": "BSAC",
  "방쿠 브라데스쿠 우선주 ADR": "BBD",
  "방쿠 산탄데르 브라질 ADR": "BSBR",
  "배너": "BANR",
  "배스 앤 바디 웍스": "BBWI",
  "배이텍스 에너지": "BTE",
  "배인 캐피털 스페셜티 파이낸스": "BCSF",
  "배저 미터": "BMI",
  "백블레이즈": "BLZE",
  "백사이트": "PCVX",
  "백트": "BKKT",
  "밴드위스": "BAND",
  "밴티지": "VNTG",
  "밸라리스": "VAL",
  "밸류 라인": "VALU",
  "밸리 내셔널 뱅코프": "VLY",
  "밸리 내셔널 뱅코프 우선주 Series C 8.250%": "VLYPN",
  "밸리 내셔널 뱅코프 우선주 시리즈 A": "VLYPP",
  "밸리 내셔널 뱅코프 우선주 시리즈 B": "VLYPO",
  "밸몬트 인더스트리스": "VMI",
  "밸보라인": "VVV",
  "밸히": "VHI",
  "뱅코 BBVA 아르헨티나 ADR": "BBAR",
  "뱅코프": "TBBK",
  "뱅크 오브 NT 버터필드 & 선": "NTB",
  "뱅크 오브 노바 스코샤": "BNS",
  "뱅크 오브 더 제임스 파이낸셜": "BOTJ",
  "뱅크 오브 마린 뱅코프": "BMRC",
  "뱅크 오브 몬트리올": "BMO",
  "뱅크 오브 프린스턴": "BPRN",
  "뱅크 오브 하와이": "BOH",
  "뱅크 오즈크": "OZK",
  "뱅크 퍼스트": "BFC",
  "뱅크7": "BSVN",
  "뱅크오브아메리카": "BAC",
  "뱅크오브아메리카 우선주 시리즈 5": "BML-P-G",
  "뱅크웰 파이낸셜 그룹": "BWFG",
  "뱅크유나이티드": "BKU",
  "뱅크퍼스트": "BANF",
  "버 바이오테크놀로지": "VIR",
  "버나 테크놀로지스": "BYRN",
  "버널 캐피탈 애퀴지션": "VECA",
  "버넷X 홀딩": "VHC",
  "버닝 락 바이오테크 ADR": "BNR",
  "버라이존": "VZ",
  "버밀리온 에너지": "VET",
  "버사멧 로열티스": "VMET",
  "버사뱅크": "VBNK",
  "버산트 미디어 그룹": "VSNT",
  "버서스 시스템즈": "VS",
  "버시전트": "VGNT",
  "버즈피드": "BZFD",
  "버지니아 내셔널 뱅크셰어": "VABK",
  "버진 갤럭틱 홀딩스": "SPCE",
  "버치테크": "BCHT",
  "버컨스톡 홀딩": "BIRK",
  "버코 매뉴팩처링": "VIRC",
  "버크 & 허버트 파이낸셜 서비스": "BHRB",
  "버크스 그룹": "BGI",
  "버클": "BKE",
  "버터플라이 네트워크": "BFLY",
  "버테크 애퀴지션 II": "BRKH",
  "버텍스": "VERX",
  "버텍스 파마슈티컬": "VRTX",
  "버툭스 홀딩스": "VTIX",
  "버튜 파이낸셜": "VIRT",
  "버트라": "VTSI",
  "버티브 홀딩스": "VRT",
  "버티컬 에어로스페이스": "EVTL",
  "버포트 캐피털": "BUR",
  "번지 글로벌": "BG",
  "벌링턴 스토어스": "BURL",
  "벌칸 머티리얼스": "VMC",
  "벌칸 인프라스트럭처 앤 파워": "VIP",
  "범블": "BMBL",
  "베네피션트": "BENF",
  "베누 홀딩": "VENU",
  "베니텍 바이오파마": "BNTC",
  "베드 배스 앤드 비욘드": "BBBY",
  "베라 모빌리티": "VRRM",
  "베라 브래들리": "VRA",
  "베라 테라퓨틱스": "VERA",
  "베라더믹스": "MANE",
  "베라사이트": "VCYT",
  "베라스템": "VSTM",
  "베락사 바이오테크": "VRXA",
  "베랄토": "VLTO",
  "베루": "VERU",
  "베르데 클린 퓨얼스": "VGAS",
  "베르토 애퀴지션": "TACO",
  "베르토 애퀴지션 II": "GUAC",
  "베리사인": "VRSN",
  "베리셀": "VCEL",
  "베리스크 애널리틱스": "VRSK",
  "베리카 파마슈티컬": "VRCA",
  "베리톤": "VERI",
  "베리파이미": "VRME",
  "베스타 리얼 에스테이트 ADR": "VTMX",
  "베스트 바이": "BBY",
  "베스트 스팩 I 애퀴지션": "BSAA",
  "베스티스": "VSTS",
  "베어드 메디컬 인베스트먼트 홀딩스": "BDMD",
  "베어링스 BDC": "BBDC",
  "베온 ADR": "VEON",
  "베이커 휴즈": "BKR",
  "베이컴": "BCML",
  "베이퍼스트 파이낸셜": "BAFN",
  "베인 캐피털 GSS 인베스트먼트": "BCSS",
  "베일 리조트": "MTN",
  "베타 바이오닉스": "BBNX",
  "베타 테크놀로지스": "BETA",
  "베터 홈 & 파이낸스 홀딩스": "BETR",
  "베터웨어 데 멕시코": "BWMX",
  "벡톤 디킨슨 앤 코": "BDX",
  "벤돔 애퀴지션 I": "VNME",
  "벤딩 스푼스": "BSP",
  "벤처 글로벌": "VG",
  "벤치마크 일렉트로닉스": "BHE",
  "벤타스": "VTR",
  "벤틀리 시스템즈": "BSY",
  "벤허브 글로벌": "VHUB",
  "벨 퓨즈 Class A": "BELFA",
  "벨 퓨즈 Class B": "BELFB",
  "벨던": "BDC",
  "벨로3D": "VELO",
  "벨로스 애퀴지션 I": "VLOS",
  "벨로시티 파이낸셜": "VEL",
  "벨링 브랜드": "BRBR",
  "보고타 파이낸셜": "BSBK",
  "보그워너": "BWA",
  "보나도 리얼티 트러스트": "VNO",
  "보다폰 그룹 ADR": "VOD",
  "보레알리스 푸드": "BRLS",
  "보르 드릴링": "BORR",
  "보스턴 비어": "SAM",
  "보스턴 사이언티픽": "BSX",
  "보스톤 오마하": "BOC",
  "보야 파이낸셜": "VOYA",
  "보어 바이오파마": "VOR",
  "보우만 컨설팅 그룹": "BWMN",
  "보우헤드 스페셜티 홀딩스": "BOW",
  "보이드 게이밍": "BYD",
  "보이드 그룹 서비스": "BGSI",
  "보이시 캐스케이드": "BCC",
  "보이저 테라퓨틱스": "VYGR",
  "보이저 테크놀로지스": "VOYG",
  "보잉": "BA",
  "복스 로열티": "VOXR",
  "본 내추럴 라이프": "BON",
  "본 바이올로직스": "BBLG",
  "본티어": "VNT",
  "볼": "BALL",
  "볼드 이글 애퀴지션": "BEAG",
  "볼드윈 인슈어런스 그룹": "BWIN",
  "볼라토 그룹": "SOAR",
  "볼리션RX": "VNRX",
  "볼트 바이오테라퓨틱스": "BOLT",
  "봉크": "BNKK",
  "부다 주스": "BUDA",
  "부스트 런": "BRUN",
  "부즈 앨런 해밀턴 홀딩": "BAH",
  "부킹 홀딩스": "BKNG",
  "부트 반 홀딩스": "BOOT",
  "불리쉬": "BLSH",
  "불프로그 AI 홀딩스": "BFRG",
  "뷰직스": "VUZI",
  "브라스켐 ADR": "BAK",
  "브라운 & 브라운": "BRO",
  "브라이트 마인즈 바이오사이언시스": "DRUG",
  "브라이트 호라이즌 패밀리 솔루션": "BFAM",
  "브라이트뷰 홀딩스": "BV",
  "브라이트스타 로터리": "BRSL",
  "브라이트스파이어 캐피탈": "BRSP",
  "브라이트스프링 헬스 서비스": "BTSG",
  "브라이트하우스 파이낸셜": "BHF",
  "브라이트하우스 파이낸셜 우선주 시리즈 A 6.6%": "BHFAP",
  "브라이트하우스 파이낸셜 우선주 시리즈 B 6.75%": "BHFAO",
  "브라이트하우스 파이낸셜 우선주 시리즈 C 5.375%": "BHFAN",
  "브라이트하우스 파이낸셜 우선주 시리즈 D 4.625%": "BHFAM",
  "브라질 포태시": "GRO",
  "브라질아그로 ADR": "LND",
  "브래그 게이밍 그룹": "BRAG",
  "브랜드 인게이지먼트 네트워크": "BNAI",
  "브랜디와인 리얼티 트러스트": "BDN",
  "브랜치아웃 푸드": "BOF",
  "브런스윅": "BC",
  "브레드 파이낸셜 홀딩스": "BFH",
  "브레라 홀딩스": "SLMT",
  "브레이마 호텔 & 리조트": "BHR",
  "브레이브하트 바이오": "BRVE",
  "브레이즈": "BRZE",
  "브레인": "BRAI",
  "브레인스웨이 ADR": "BWAY",
  "브렌밀러 에너지": "BNRG",
  "브로드리지 파이낸셜 솔루션스": "BR",
  "브로드스톤 넷 리스": "BNL",
  "브로드웨이 파이낸셜": "BYFC",
  "브로드윈드 에너지": "BWEN",
  "브로드컴": "AVGO",
  "브루커": "BRKR",
  "브루커 우선주 Series A 6.375%": "BRKRP",
  "브룩데일 시니어 리빙": "BKD",
  "브룩필드": "BN",
  "브룩필드 리뉴어블 리뉴어블": "BEPC",
  "브룩필드 비즈니스 홀딩스": "BBUC",
  "브룩필드 애셋 매니지먼트": "BAM",
  "브룩필드 웰스 솔루션스": "BNT",
  "브룩필드 인프라스트럭처": "BIPC",
  "브룸": "VRM",
  "브리스토우 그룹": "VTOL",
  "브리스톨-마이어스 스큅": "BMY",
  "브리아셀 테라퓨틱스": "BCTX",
  "브리저 에어로스페이스 그룹 홀딩스": "BAER",
  "브리즈 애퀴지션 II": "BREZ",
  "브리지포드 푸즈": "BRID",
  "브리티쉬 아메리칸 토바코 ADR": "BTI",
  "브릭스모어 프로퍼티 그룹": "BRX",
  "브릴리아": "BRIA",
  "브릴리언트 어스 그룹": "BRLT",
  "브릿지라인 디지털": "BLIN",
  "브릿지바이오 온콜로지 테라퓨틱스": "BBOT",
  "브릿지바이오 파머": "BBIO",
  "브릿지워터 뱅크셰어스": "BWB",
  "브릿지워터 뱅크셰어스 우선주 Series A 5.875%": "BWBBP",
  "브링커 인터내셔널": "EAT",
  "브링크스": "BCO",
  "브이넷 그룹 ADR": "VNET",
  "브이아이피숍 홀딩스 ADR": "VIPS",
  "브이투엑스(V2X)": "VVX",
  "블라덱스": "BLX",
  "블라이크로더 애퀴지션 II": "BBCQ",
  "블라이크뢰더 애퀴지션 III": "BCCQ",
  "블랙 다이아몬드 테라퓨틱스": "BDTX",
  "블랙 락 커피 바": "BRCB",
  "블랙 스페이드 애퀴지션 III": "BIII",
  "블랙 타이탄": "BTTC",
  "블랙 호크 애퀴지션": "BKHA",
  "블랙 힐스": "BKH",
  "블랙라인": "BL",
  "블랙록": "BLK",
  "블랙록 TCP 캐피털": "TCPC",
  "블랙베리": "BB",
  "블랙보드": "BLKB",
  "블랙스카이 테크놀로지": "BKSY",
  "블랙스톤": "BX",
  "블랙스톤 디지털 인프라 트러스트": "BXDC",
  "블랙스톤 모기지 트러스트": "BXMT",
  "블랙스톤 시큐어드 렌딩 펀드": "BXSL",
  "블레이즈 홀딩스": "BZAI",
  "블렌드 랩스": "BLND",
  "블록": "XYZ",
  "블루 골드": "BGL",
  "블루 리지 뱅크셰어스": "BRBS",
  "블루 버드": "BLBD",
  "블루 아울 캐피털": "OBDC",
  "블루 아울 테크놀로지 파이낸스": "OTF",
  "블루 애퀴지션": "BACC",
  "블루 워터 애퀴지션 III": "BLUW",
  "블루 워터 애퀴지션 IV": "BWIV",
  "블루락 홈즈 트러스트": "BHM",
  "블루록 애퀴지션": "BLRK",
  "블루링스 홀딩스": "BXC",
  "블루마운트 홀딩스": "BMHL",
  "블루문 메탈스": "BMM",
  "블루미아 홀딩스": "TULP",
  "블루민 브랜즈": "BLMN",
  "블루제이 다이어그노스틱스": "BJDX",
  "블루포트 애퀴지션": "BPAC",
  "블룸 에너지": "BE",
  "블링크 차징": "BLNK",
  "비글라리 홀딩스 Class B": "BH",
  "비긴 블록체인": "BGIN",
  "비나 캐피털 그룹": "BCG",
  "비다 글로벌": "VIDA",
  "비라이브 홀딩스": "BLIV",
  "비라이트 바이오 ADR": "BLTE",
  "비라인 홀딩스": "BLNE",
  "비르투스 인베스트먼트 파트너스": "VRTS",
  "비리디안 테라퓨틱스": "VRDN",
  "비머 이미징": "BMR",
  "비머젠 에너지": "BESS",
  "비메드 헬스케어": "VMD",
  "비바 시스템즈": "VEEV",
  "비바니 메디컬": "VANI",
  "비바코어": "VIVK",
  "비보스 테라퓨틱스": "VVOS",
  "비보심 랩스": "VIVS",
  "비보파워": "VIVO",
  "비비드 싯츠": "SEAT",
  "비샤이 인터테크놀로지": "VSH",
  "비샤이 프리시전 그룹": "VPG",
  "비스타 골드": "VGZ",
  "비스타 에너지": "VIST",
  "비스타젠 테라퓨틱스": "VTGN",
  "비스탄스 네트웍스": "VISN",
  "비스트라 에너지": "VST",
  "비스티온": "VC",
  "비슬리 브로드캐스트 그룹": "BBGI",
  "비아": "VEEA",
  "비아 트랜스포테이션": "VIA",
  "비아비 솔루션스": "VIAV",
  "비아샛": "VSAT",
  "비아트리스": "VTRS",
  "비앤지 푸즈": "BGS",
  "비오미 테크놀러지 ADR": "VIOT",
  "비욘드 미트": "BYND",
  "비욘드 에어": "XAIR",
  "비욘드스프링": "BYSI",
  "비원 메디슨스 ADR": "ONC",
  "비자": "V",
  "비저 홈스 USA": "BZH",
  "비전 마린 테크놀로지스": "VMAR",
  "비전시스 AI ADR": "VSA",
  "비전웨이브 홀딩스": "VWAV",
  "비제이스 레스토랑": "BJRI",
  "비즈니스 퍼스트 뱅크셰어스": "BFST",
  "비즐라 실버": "VZLA",
  "비치 프로퍼티스": "VICI",
  "비치바디 컴퍼니": "BODI",
  "비코": "VICR",
  "비코 인스트루먼츠": "VECO",
  "비콘 파이낸셜": "BBT",
  "비타 코코 컴퍼니": "COCO",
  "비테스 에너지": "VTS",
  "비트 디지털": "BTBT",
  "비트 오리진": "BTOG",
  "비트고 홀딩스": "BTGO",
  "비트마인 이머전 테크놀로지스": "BMNR",
  "비트마인 이머전 테크놀로지스 우선주 Series A 9.5%": "BMNP",
  "비트제로 홀딩스": "AIBZ",
  "비트코인 인프라스트럭처 애퀴지션": "BIXI",
  "빅 디지털 에너지": "BGDE",
  "빅 스카이 인더스트리얼": "BSIN",
  "빅 트리 클라우드 홀딩스": "DSY",
  "빅베어 AI 홀딩스": "BBAI",
  "빅토리 캐피털 홀딩스": "VCTR",
  "빅토리아 시크릿": "VSXY",
  "빈스 홀딩": "VNCE",
  "빈치 컴퍼스 인베스트먼츠": "VINP",
  "빈패스트 오토": "VFS",
  "빌닷컴 홀딩스": "BILL",
  "빌더스 퍼스트소스": "BLDR",
  "빌드어베어 워크숍": "BBW",
  "빌리빌리 ADR": "BILI",
  "빌리언투원": "BLLN",
  "빌리지 슈퍼 마켓": "VLGEA",
  "빌리지 팜스 인터내셔널": "VFF",
  "빔 글로벌": "BEEM",
  "빔 테라퓨틱스": "BEAM",
  "빗디어 테크놀로지스": "BTDR",
  "빗푸푸": "FUFU",
  "빙엑스 ADR": "FLX",
  "사가 커뮤니케이션스": "SGA",
  "사나 바이오테크놀로지": "SANA",
  "사나라 메드테크": "SMTI",
  "사노피 ADR": "SNY",
  "사돗 그룹": "SDOT",
  "사라토가 인베스트먼트": "SAR",
  "사렙타 테라퓨틱스": "SRPT",
  "사바라": "SVRA",
  "사브라 헬스케어 리츠": "SBRA",
  "사솔 ADR": "SSL",
  "사우스 보우": "SOBO",
  "사우스 플레인 파이낸셜": "SPFI",
  "사우스랜드 홀딩스": "SLND",
  "사우스사이드 뱅크셰어스": "SBSI",
  "사우스스테이트 뱅크": "SSB",
  "사우스웨스트 가스 홀딩스": "SWX",
  "사우스웨스트 에어라인스": "LUV",
  "사운드 그룹 ADR": "SOGP",
  "사운드 파이낸셜 뱅코프": "SFBC",
  "사운드 포인트 머리디어 캐피털 우선주 Seires A 8%": "SPMA",
  "사운드 포인트 머리디언 캐피털": "SPMC",
  "사운드 포인트 메리디언 캐피털 우선주 Series B 7.875%": "SPME",
  "사운드하운드 AI": "SOUN",
  "사이넥시스": "SCYX",
  "사이먼 프로퍼티 그룹": "SPG",
  "사이브라": "CYAB",
  "사이빈": "HELP",
  "사이스파크": "SPRC",
  "사이아": "SAIA",
  "사이언스 바이오메디컬": "PBM",
  "사이언스 어플리케이션스 인터내셔널": "SAIC",
  "사이언조이 홀딩": "SJ",
  "사이언처 홀딩스": "SCNX",
  "사이텍 바이오사이언시스": "CTKB",
  "사이토소벤츠": "CTSO",
  "사이토키네틱스": "CYTK",
  "사이톰엑스 테라퓨틱스": "CTMX",
  "사이트 사이언시스": "SGHT",
  "사이트 센터스": "SITC",
  "사이트원 랜드스케이프 서플라이": "SITE",
  "사이퍼펑크 테크놀로지스": "CYPH",
  "사이프리스 솔루션스": "SYPR",
  "사이피 테크놀러지 ADR": "SIFY",
  "사이히트": "SAIH",
  "사일런스 테라퓨틱스 ADR": "SLN",
  "사일렉스 홀딩": "SCLX",
  "사일로 파마": "SILO",
  "사텔로스 바이오사이언스": "MSLE",
  "산미나": "SANM",
  "산타크루즈 실버 마이닝": "SCZM",
  "삼사라": "IOT",
  "새그텍 글로벌": "SAGT",
  "새기멧 바이오사이언시스": "SGMT",
  "새켐 캐피털": "SACH",
  "샌고마 테크놀로지스": "SANG",
  "샌드리지 에너지": "SD",
  "샌디스크": "SNDK",
  "샌유웨이브 헬스": "SNWV",
  "샐리 뷰티 홀딩스": "SBH",
  "샘파인 크리에이션 홀딩스 그룹": "SFHG",
  "생풍 디벨롭먼트": "SFWL",
  "샤론AI 홀딩스": "SHAZ",
  "샤오-아이 ADR": "AIXI",
  "샤오펑 ADR": "XPEV",
  "샤크닌자": "SN",
  "샤프링크": "SBET",
  "샷스포터": "SSTI",
  "샹송 인터내셔널 홀딩": "CHSN",
  "섀턱 랩": "STTK",
  "서던": "SO",
  "서던 미주리 뱅코프": "SMBC",
  "서던 코퍼": "SCCO",
  "서던 퍼스트 뱅크셰어스": "SFST",
  "서로젠": "SRZN",
  "서밋 미드스트림": "SMC",
  "서밋 스테이트 뱅크": "SSBI",
  "서밋 호텔 프로퍼티스": "INN",
  "서브 로보틱스": "SERV",
  "서비스 코퍼레이션 인터내셔널": "SCI",
  "서비스 프로퍼티스 트러스트": "SVC",
  "서비스나우": "NOW",
  "서비스타이탄": "TTAN",
  "서비스퍼스트 뱅크셰어스": "SFBS",
  "서저리 파트너스": "SGRY",
  "서지페이즈": "SURG",
  "서타라": "CERT",
  "서프 에어 모빌리티": "SRFM",
  "선 라이프 파이낸셜": "SLF",
  "선 커뮤니티즈": "SUI",
  "선내션 에너지": "SUNE",
  "선라이즈 리얼티 트러스트": "SUNS",
  "선랜드 테크놀러지 그룹 ADR": "STG",
  "선런": "RUN",
  "선벨트 렌탈스 홀딩스": "SUNB",
  "선샤인 바이오파마": "SBFM",
  "선샤인 실버 마이닝 앤 리파이닝": "SSMR",
  "선스톤 호텔 인베스터스": "SHO",
  "선카 테크놀로지 그룹": "SDA",
  "선코어 에너지": "SU",
  "선코크 에너지": "SXC",
  "선크리트": "RMIX",
  "선파워": "SPWR",
  "세네카 푸즈 Class A": "SENEA",
  "세네카 푸즈 Class B": "SENEB",
  "세노버스 에너지": "CVE",
  "세라 프로그노스틱스": "SERA",
  "세라콘 네트웍스": "CRNT",
  "세러스": "CERS",
  "세레브라스 시스템스": "CBRS",
  "세레스 테라퓨틱스": "MCRB",
  "세렌스": "CRNC",
  "세르베러스 사이버 센티넬": "CISO",
  "세르베세리아스 우니다스 ADR": "CCU",
  "세르보메드": "CRVO",
  "세리나 테라퓨틱스": "SER",
  "세리벨": "CBLL",
  "세리티지 그로스 프로퍼티스": "SRG",
  "세멘토스 파카스마요 ADR": "CPAC",
  "세미LEDS": "LEDS",
  "세바": "CEVA",
  "세븐 힐즈 리얼티 트러스트": "SEVN",
  "세이버": "SABR",
  "세이버스 밸류 빌리지": "SVV",
  "세이버원 2014 ADR": "SVRE",
  "세이블 오프쇼어": "SOC",
  "세이어 벤처스 애퀴지션 II": "TVAI",
  "세이프 벌커스": "SB",
  "세이프 프로 그룹": "SPAI",
  "세이프가드 애퀴지션": "SAC",
  "세이프티 인슈어런스 그룹": "SAFT",
  "세이프홀드": "SAFE",
  "세인트 조": "JOE",
  "세일즈포스": "CRM",
  "세일포인트": "SAIL",
  "세즐": "SEZL",
  "센미아오 테크놀러지": "AIHS",
  "센사타 테크놀로지스 홀딩": "ST",
  "센서닉스 홀딩스": "SENS",
  "센서스 헬스케어": "SRTS",
  "센스타 테크놀로지스": "SNT",
  "센시언트 테크놀로지스": "SXT",
  "센추리 알루미늄": "CENX",
  "센추리 카지노스": "CNTY",
  "센추리 테라퓨틱스": "IPSC",
  "센추리 홀딩스": "CTRI",
  "센추리온 애퀴지션": "ALF",
  "센츄리 커뮤니티스": "CCS",
  "센코라": "COR",
  "센터스페이스": "CSR",
  "센터포인트 에너지": "CNP",
  "센테라 골드": "CGAU",
  "센트러스 에너지": "LEU",
  "센트럴 가든 앤드 펫": "CENT",
  "센트럴 가든 앤드 펫 Class A": "CENTA",
  "센트럴 밴컴퍼니": "CBC",
  "센트럴 퍼시픽 파이낸셜": "CPF",
  "센트럴 푸에르토 ADR": "CEPU",
  "센트럴 플레인스 뱅크셰어스": "CPBI",
  "센트로": "CENN",
  "센티 바이오사이언시스": "SNTI",
  "센티넬원": "S",
  "센티지 홀딩스": "SNTG",
  "센틴": "CNC",
  "셀 사이": "CVM",
  "셀덱스 테라퓨틱스": "CLDX",
  "셀라니즈 코퍼레이션": "CE",
  "셀라스 라이프 사이언스 그룹": "SLS",
  "셀러리어스 파머슈티컬스": "DCOY",
  "셀레브라이트": "CLBT",
  "셀레스티카": "CLS",
  "셀렉타 바이오사이언시스": "CLRB",
  "셀렉트 에너지 서비스": "WTTR",
  "셀렉트코트": "SLQT",
  "셀렉티브 인슈어런스 그룹": "SIGI",
  "셀렉티브 인슈어런스 그룹 우선주 시리즈 B 4.6%": "SIGIP",
  "셀룰레리티": "CELU",
  "셀리안 바이오테크": "HKPD",
  "셀시어스 홀딩스": "CELH",
  "셀큐이티": "CELC",
  "셈텍": "SMTC",
  "셈트렉스": "CETX",
  "셈프라 에너지": "SRE",
  "셉테르나": "SEPN",
  "셔멍 파이낸셜": "CHMG",
  "셔윈-윌리엄즈": "SHW",
  "셔터스톡": "SSTK",
  "셔틀 파마슈티컬스": "SHPH",
  "셰넌도어 텔레커뮤니케이션스": "SHEN",
  "셰니어 에너지": "LNG",
  "셰브론": "CVX",
  "셰프스 웨어하우스": "CHEF",
  "소노 그룹": "SSM",
  "소노-테크": "SOTK",
  "소노마 파머수티컬스": "SNOA",
  "소노스": "SONO",
  "소노코 프로덕트": "SON",
  "소니 그룹 ADR": "SONY",
  "소니다 시니어 리빙": "SNDA",
  "소닉 오토모티브": "SAH",
  "소렌 애퀴지션": "SORN",
  "소버세이프": "SOBR",
  "소셜 커머스 파트너스": "SCPQ",
  "소시에다드 퀴미카 B ADR": "SQM",
  "소어 인더스트리스": "THO",
  "소영 인터내셔널 ADR": "SY",
  "소우 굿": "SOWG",
  "소울파워 애퀴지션": "SOUL",
  "소켓 모바일": "SCKT",
  "소테라 헬스": "SHC",
  "소파이 테크놀로지스": "SOFI",
  "소피아 제네틱스": "SOPH",
  "소후 닷컴 ADR": "SOHU",
  "솔 센터스": "BFS",
  "솔 스트래티지스": "STKE",
  "솔라나": "HSDT",
  "솔라리스 리소시스": "SLSR",
  "솔라리스 에너지 인프라스트럭처": "SEI",
  "솔라리우스 캐피털 애퀴지션": "SOCA",
  "솔라맥스 테크놀로지": "SMXT",
  "솔라에지 테크놀로지스": "SEDG",
  "솔레센스": "SLSN",
  "솔로윈 홀딩스": "AXG",
  "솔루나 홀딩스": "SLNH",
  "솔루나 홀딩스 우선주 시리즈 A 9%": "SLNHP",
  "솔리드 바이오사이언스": "SLDB",
  "솔리드 파워": "SLDP",
  "솔리디온 테크놀로지": "STI",
  "솔리제닉스": "SNGX",
  "솔리타리오 리소시스": "XPL",
  "솔벤텀": "SOLV",
  "솔브 에너지": "MWH",
  "솔젤 테크놀러지": "SLGL",
  "솜니그룹 인터내셔널": "SGI",
  "쇼어 뱅크셰어스": "SHBI",
  "쇼피파이": "SHOP",
  "숄더 이노베이션스": "SI",
  "숄즈 테크놀로지스 그룹": "SHLS",
  "수자 라이프": "SUJA",
  "수자노 ADR": "SUZ",
  "수트로 바이오파머": "STRO",
  "쉐이크쉑": "SHAK",
  "쉘 ADR": "SHEL",
  "쉬프트4 페이먼트": "FOUR",
  "쉰레이 ADR": "XNET",
  "슈 스테이션 그룹": "SHOE",
  "슈나이더 내셔널": "SNDR",
  "슈레아 애퀴지션 그룹": "SAGU",
  "슈뢰딩거": "SDGR",
  "슈미드 그룹": "SHMD",
  "슈퍼 리그 엔터프라이즈": "SLE",
  "슈퍼 마이크로 컴퓨터": "SMCI",
  "슈퍼 마이크로 컴퓨터 우선주 Series A": "SMCIP",
  "슈퍼 하이 인터내셔널 홀딩 ADR": "HDL",
  "슈퍼X AI 테크놀로지": "SUPX",
  "슈퍼누스 파마슈티컬스": "SUPN",
  "슈퍼컴": "SPCB",
  "슈페리어 유니폼 그룹": "SGC",
  "스냅": "SNAP",
  "스냅-온": "SNA",
  "스네일": "SNAL",
  "스노우 로스차일드 애퀴지션": "ISNR",
  "스노우플레이크": "SNOW",
  "스레드업": "TDUP",
  "스마트 로지스틱스 글로벌": "SLGB",
  "스마트 샌드": "SND",
  "스마트렌트": "SMRT",
  "스마트버드": "BIRD",
  "스마트스톱 셀프 스토리지 REIT": "SMA",
  "스마트켐": "SMTK",
  "스마트파이낸셜": "SMBK",
  "스머핏 웨스트락": "SW",
  "스미스 & 네퓨 ADR": "SNN",
  "스미스 더글러스 홈스": "SDHC",
  "스미스 마이크로 소프트웨어": "SMSI",
  "스미스&웨슨 브랜드": "SWBI",
  "스미스-미드랜드": "SMID",
  "스미스필드 푸드": "SFD",
  "스미토모 미쓰이 파이낸셜그룹 ADR": "SMFG",
  "스워머": "SWMR",
  "스워블 홀딩스": "SWVL",
  "스윗그린": "SG",
  "스카이 바이오사이언스": "SKYE",
  "스카이 쿼리": "SKYQ",
  "스카이 하버 그룹": "SKYH",
  "스카이라인 빌더스 그룹 홀딩": "KAZR",
  "스카이엑스 플랫폼스": "SKYX",
  "스카이워드 스페셜티 인슈어런스 그룹": "SKWD",
  "스카이웍스 솔루션스": "SWKS",
  "스카이웨스트": "SKYW",
  "스칼러 락 홀딩": "SRRK",
  "스캔소스": "SCSC",
  "스컬리 로열티": "SRL",
  "스케이지 퓨처 ADR": "SCAG",
  "스코츠 미러클 그로": "SMG",
  "스콜라스틱": "SCHL",
  "스콜피오 탱커스": "STNG",
  "스크라이브 테라퓨틱스": "SCTX",
  "스키나 리소시스": "SKE",
  "스킨헬스 시스템즈": "SKIN",
  "스킬소프트": "SKIL",
  "스킬풀 크래프트맨 에듀케이션 테크놀로지": "EDTK",
  "스타 벌크 캐리어스": "SBLK",
  "스타 서지컬": "STAA",
  "스타 에퀴티 홀딩스": "STRR",
  "스타 에퀴티 홀딩스 우선주 Series A 10%": "STRRP",
  "스타 패션 컬처 홀딩스": "STFS",
  "스타 홀딩스": "STHO",
  "스타더스트 파워": "SDST",
  "스타링 온콜로지": "STLN",
  "스타링크 AI 애퀴지션": "OTAI",
  "스타벅스": "SBUX",
  "스타우드 프로퍼티 트러스트": "STWD",
  "스타즈 엔터테인먼트": "STRZ",
  "스타파이터스 스페이스": "FJET",
  "스탁": "STAK",
  "스탁 야즈 뱅코프": "SYBT",
  "스태그 인더스트리얼": "STAG",
  "스태그웰": "STGW",
  "스태리 씨 애퀴지션": "SSEA",
  "스태빌리스 솔루션스": "SLNG",
  "스탠다드 뉴클리어": "STDN",
  "스탠다드 리튬": "SLI",
  "스탠다드 모터 프로덕츠": "SMP",
  "스탠다드 바이오툴즈": "LAB",
  "스탠다드에어로": "SARO",
  "스탠덱스 인터내셔널": "SXI",
  "스탠리 블랙 & 데커": "SWK",
  "스탠텍": "STN",
  "스털링 인프라스트럭처": "STRL",
  "스텀 루거 앤 컴퍼니": "RGR",
  "스텁허브 홀딩스": "STUB",
  "스테레오택시스": "STXS",
  "스테리스": "STE",
  "스테바나토 그룹": "STVN",
  "스테이블코인 디벨롭먼트": "SDEV",
  "스테이블코인엑스": "USDE",
  "스테이크홀더 푸즈 ADR": "STKH",
  "스테이트 스트리트": "STT",
  "스테판": "SCL",
  "스텔라 V 캐피탈": "SVCC",
  "스텔란티스": "STLA",
  "스텔러스 캐피털 인베스트먼트": "SCM",
  "스텔로직": "SATL",
  "스텔스가스": "GASS",
  "스템": "STEM",
  "스텝스톤 그룹": "STEP",
  "스토넥스 그룹": "SNEX",
  "스토케 테라퓨틱스": "STOK",
  "스톤리지": "SRI",
  "스톤브릿지 애퀴지션 II": "APAC",
  "스톤코": "STNE",
  "스튜디오 시티 인터내셔널 홀딩스 ADR": "MSC",
  "스튜어트 인포메이션 서비스": "STC",
  "스트라이드": "LRN",
  "스트라이브": "ASST",
  "스트라이브 우선주 Series A": "SATA",
  "스트라이커": "SYK",
  "스트라타 크리티컬 메디컬": "SRTA",
  "스트라타시스": "SSYS",
  "스트라텍 시큐리티": "STRT",
  "스트라투스 프로퍼티스": "STRS",
  "스트란앤컴퍼니": "SWAG",
  "스트래티지": "MSTR",
  "스트래티지 우선주 Series A": "STRC",
  "스트래티지 우선주 Series A 10.00%": "STRD",
  "스트래티지 우선주 Series A 8.00%": "STRK",
  "스트래티직 에듀케이션": "STRA",
  "스트럭처 테라퓨틱스 ADR": "GPCR",
  "스트럭처 프로덕츠 Corts TR 페코 에너지 우선주 8%": "KTH",
  "스트로베리 필즈 리츠": "STRW",
  "스트리멕스": "STEX",
  "스티븐 매든": "SHOO",
  "스티치 픽스": "SFIX",
  "스티펄 파이낸셜": "SF",
  "스틸 다이내믹스": "STLD",
  "스파르타쿠스 애퀴지션 II": "TMTS",
  "스파이글래스 파마": "SGP",
  "스파이어": "SR",
  "스파이어 글로벌": "SPIR",
  "스파이어 테라퓨틱스": "SYRE",
  "스파크 I 애퀴지션": "SPKL",
  "스팩스피어 애퀴지션": "SSAC",
  "스페로 테라퓨틱스": "SPRO",
  "스페이스 애셋 애퀴지션": "SAAQ",
  "스페이스X": "SPCX",
  "스펙트럴 AI": "MDAI",
  "스펙트럼 브랜즈 홀딩스": "SPB",
  "스포 엔터": "SEGG",
  "스포츠레이더 그룹": "SRAD",
  "스포츠맨스 웨어하우스 홀딩스": "SPWH",
  "스포티파이 테크놀러지": "SPOT",
  "스폭 홀딩스": "SPOK",
  "스프라우츠 파머스 마켓": "SFM",
  "스프라웃 소셜": "SPT",
  "스프러스 파워 홀딩": "SPRU",
  "스프롯": "SII",
  "스프루스 바이오사이언시스": "SPRB",
  "스프링 밸리 애퀴지션 IV": "SVIV",
  "스프링뷰 홀딩스": "SPHL",
  "스프링클러": "CXM",
  "스플래시 베버리지 그룹": "SBEV",
  "스피어 3D": "ANY",
  "스피어 엔터테인먼트": "SPHR",
  "슬라이드 인슈어런스 홀딩스": "SLDE",
  "시-본": "SIBN",
  "시가 테크놀로지스": "SIGA",
  "시그넷 주얼러스": "SIG",
  "시그마 리튬": "SGML",
  "시나이 이뮤노테라퓨틱스 ADR": "SCNI",
  "시냅틱스": "SYNA",
  "시너지 CHC": "SNYR",
  "시너지 마리타임 홀딩스": "SHIP",
  "시네마크 홀딩스": "CNK",
  "시네버스": "CNVS",
  "시네스텍": "SNES",
  "시노백 바이오테크": "SVA",
  "시놉시스": "SNPS",
  "시드릴": "SDRL",
  "시디 애퀴지션": "SDHI",
  "시러스 로직": "CRUS",
  "시리우스 XM 홀딩스": "SIRI",
  "시리우스포인트": "SPNT",
  "시멕스 ADR": "CX",
  "시몬스 퍼스트 내셔널": "SFNC",
  "시뮬레이션스 플러스": "SLP",
  "시밀러웹": "SMWB",
  "시바니 스틸워터 ADR": "SBSW",
  "시버트 파이낸셜 코퍼레이션": "SIEB",
  "시브리지 골드": "SA",
  "시비스타 뱅크셰어스": "CIVB",
  "시비오": "CVEO",
  "시스코": "SYY",
  "시스코 시스템즈": "CSCO",
  "시스템원": "SST",
  "시어": "SEER",
  "시에라 뱅코프": "BSRR",
  "시오나 테라퓨틱스": "SION",
  "시저스 엔터테인먼트": "CZR",
  "시저스톤": "CSTE",
  "시즐 애퀴지션 II": "SZZL",
  "시카고 리벳 & 머신": "CVR",
  "시카고 애틀란틱 BDC": "LIEN",
  "시카고 애틀랜틱 리얼 에스테이트 파이낸스": "REFI",
  "시코 마린 홀딩스": "SMHI",
  "시코스트 뱅킹 코퍼레이션 오브 플로리다": "SBCF",
  "시퀀스 커뮤니케이션즈 ADR": "SQNS",
  "시큐리티 내셔널 파이낸셜": "SNFCA",
  "시트로테크": "CITR",
  "시티 트렌즈": "CTRN",
  "시티 홀딩": "CHCO",
  "시티우스 온콜로지": "CTOR",
  "시티우스 파마슈티컬스": "CTXR",
  "시티즌스": "CIA",
  "시티즌스 & 노던": "CZNC",
  "시티즌스 커뮤니티 뱅코프": "CZWI",
  "시티즌스 파이낸셜 그룹": "CFG",
  "시티즌스 파이낸셜 서비시스": "CZFS",
  "시포트 테라퓨틱스": "SPTX",
  "식스 플래그스 엔터테인먼트": "FUN",
  "신다": "SIND",
  "신닥스 파마슈티컬스": "SNDX",
  "신시내티 파이낸셜": "CINF",
  "신젠": "CYN",
  "신타스": "CTAS",
  "신텍 옵틱스 홀딩스": "OPTX",
  "신한금융지주 ADR": "SHG",
  "실간 홀딩스": "SLGN",
  "실렉시온 테라퓨틱스": "SLXN",
  "실리콘 래보라토리스": "SLAB",
  "실리콘 모션 테크놀로지 ADR": "SIMO",
  "실리콘밸리 애퀴지션": "SVAQ",
  "실리콤": "SILC",
  "실링크스": "SYNX",
  "실바모": "SLVM",
  "실바코 그룹": "SVCO",
  "실버 보우 마이닝": "SBMT",
  "실버 페가수스 애퀴지션": "SPEG",
  "실버박스 IV": "SBXD",
  "실버박스 V": "SBXE",
  "실버코프 메탈스": "SVM",
  "실버크레스트 애셋 매니지먼트 그룹": "SAMG",
  "실스크": "LAES",
  "심믹": "SHIM",
  "심보틱": "SYM",
  "심슨 매뉴팩처링": "SSD",
  "심프레스": "CMPR",
  "심플": "SPPL",
  "싱귤러리티 퓨처 테크놀로지": "SGLY",
  "싱귤레이트": "CING",
  "싱크로니 파이낸셜": "SYF",
  "싱클레어 브로드캐스트 그룹": "SBGI",
  "싸이더스 스페이스": "SIDU",
  "싸이큐리온": "CYCU",
  "싸이클러리온 테라퓨틱스": "CYCN",
  "싸이토메드 테라퓨틱스": "GDTC",
  "써드 코스트 뱅크셰어스": "TCBX",
  "써모 피셔 사이언티픽": "TMO",
  "써클 인터넷 그룹": "CRCL",
  "쓰리디 시스템즈": "DDD",
  "쓰리브 홀딩스": "THRY",
  "쓰리엠 (3M)": "MMM",
  "씨 ADR": "SE",
  "씨게이트": "STX",
  "씨버스": "CBUS",
  "씨보드": "SEB",
  "씨비디엠디": "YCBD",
  "씨스퀘어": "CSQR",
  "씨스타 메디컬 홀딩": "ICU",
  "씨티그룹": "C",
  "씨포트 엔터테인먼트 그룹": "SEG",
  "아가페 ATP": "ATPC",
  "아간": "AGX",
  "아겐스 ADR": "ARGX",
  "아고라 ADR": "API",
  "아고맙 테라퓨틱스 ADR": "AGMB",
  "아그로즈": "AGRZ",
  "아넥슨": "ANNX",
  "아니카 테라퓨틱스": "ANIK",
  "아다마스 트러스트": "ADAM",
  "아다마스 트러스트 우선주 Series D 8.00%": "ADAMN",
  "아다마스 트러스트 우선주 Series E 7.875%": "ADAMM",
  "아다마스 트러스트 우선주 Series F 6.875%": "ADAML",
  "아다마스 트러스트 우선주 Series G 7.000%": "ADAMZ",
  "아다지오 메디컬 홀딩스": "ADGM",
  "아다진 ADR": "ADAG",
  "아던트 헬스": "ARDT",
  "아데이아": "ADEA",
  "아데코아그로": "AGRO",
  "아델릭스": "ARDX",
  "아듀로 클린 테크놀로지스": "ADUR",
  "아듀스 홈케어": "ADUS",
  "아드모어 쉬핑": "ASC",
  "아들라이 노르티에 ADR": "ANL",
  "아라마크": "ARMK",
  "아레나 그룹 홀딩스": "AREN",
  "아레스 매니지먼트": "ARES",
  "아레스 캐피탈": "ARCC",
  "아레스 커머셜 리얼에스테이트": "ACRE",
  "아르고 블록체인 ADR": "ARBK",
  "아르다 메탈 패키징": "AMBP",
  "아르드바크 테라퓨틱스": "AARD",
  "아르비나스": "ARVN",
  "아르셀로미탈 ADR": "MT",
  "아르코": "ARKO",
  "아르코 페트롤리엄": "APC",
  "아르코스 도라도스 홀딩스": "ARCO",
  "아르키메데스 테크 SPAC III": "ARCI",
  "아르키메데스 테크 SPAC 파트너스 II": "ATII",
  "아르킷 퀀텀": "ARQQ",
  "아르테시안 리소시스": "ARTNA",
  "아르텔로 바이오사이언스": "ARTL",
  "아르하우스": "ARHS",
  "아를로 테크놀러지": "ARLO",
  "아리스 마이닝": "ARIS",
  "아리스타 네트웍스": "ANET",
  "아마나트 애퀴지션": "AMAN",
  "아마다 애퀴지션 2": "XRPN",
  "아마다 애퀴지션 III": "AACI",
  "아마린 ADR": "AMRN",
  "아마존닷컴": "AMZN",
  "아마타 파마슈티컬스": "ARMP",
  "아말가메이티드 파이낸셜": "AMAL",
  "아머 레지던셜 리츠": "ARR",
  "아머 스포츠": "AS",
  "아머란트 뱅코프": "AMTB",
  "아메리서브 파이낸셜": "ASRV",
  "아메리세이프": "AMSF",
  "아메리스 뱅코프": "ABCB",
  "아메리스코": "AMRC",
  "아메리카 모빌 ADR 시리즈 L": "AMX",
  "아메리카스 카-마트": "CRMT",
  "아메리칸 골드 앤 실버": "USAS",
  "아메리칸 드라이브 애퀴지션": "ADAC",
  "아메리칸 리소스": "AREC",
  "아메리칸 리얼티 인베스터스": "ARL",
  "아메리칸 배터리 테크놀로지": "ABAT",
  "아메리칸 뱅가드": "AVD",
  "아메리칸 비트코인": "ABTC",
  "아메리칸 셰어드 호스피털 서비스": "AMS",
  "아메리칸 수퍼컨덕터": "AMSC",
  "아메리칸 스테이츠 워터": "AWR",
  "아메리칸 아웃도어 브랜드": "AOUT",
  "아메리칸 애셋츠 트러스트": "AAT",
  "아메리칸 에어라인스 그룹": "AAL",
  "아메리칸 워터 웍스": "AWK",
  "아메리칸 이글 아웃피터스": "AEO",
  "아메리칸 익셉셔널리즘 애퀴지션 A": "AEXA",
  "아메리칸 익스프레스": "AXP",
  "아메리칸 인터내셔널 그룹": "AIG",
  "아메리칸 인테그리티 인슈어런스 그룹": "AII",
  "아메리칸 일렉트릭 파워 컴퍼니": "AEP",
  "아메리칸 코스탈 인슈어런스": "ACIC",
  "아메리칸 타워": "AMT",
  "아메리칸 파이낸셜 그룹": "AFG",
  "아메리칸 퍼블릭 에듀케이션": "APEI",
  "아메리칸 헬스케어 REIT": "AHR",
  "아메리칸 홈스 포 렌트": "AMH",
  "아메리칸웰": "AMWL",
  "아메리콜드 리얼티 트러스트": "COLD",
  "아메리프라이즈 파이낸셜": "AMP",
  "아메텍": "AME",
  "아멘텀 홀딩스": "AMTM",
  "아밀릭스 파마슈티컬스": "AMLX",
  "아발로 테라퓨틱스": "AVTX",
  "아발론 홀딩스": "AWX",
  "아발론베이 커뮤니티": "AVB",
  "아발린 파마": "AVLN",
  "아버 리얼티 트러스트": "ABR",
  "아버터스 바이오파마": "ABUS",
  "아베오나 테라퓨틱스": "ABEO",
  "아브 로보틱스": "ARBE",
  "아비노 실버 & 골드 마인스": "ASM",
  "아비백스 ADR": "ABVX",
  "아비스타": "AVA",
  "아비아트 네트웍스": "AVNW",
  "아비타 메디컬": "RCEL",
  "아사나": "ASAN",
  "아서 J 갤러거 앤 코": "AJG",
  "아센드라 헬스": "ACH",
  "아스테라 랩스": "ALAB",
  "아스텍 인더스트리스": "ASTE",
  "아스트라나 헬스": "ASTH",
  "아스트라제네카": "AZN",
  "아스트로노바": "ALOT",
  "아스트로닉스": "ATRO",
  "아스펜 에어로젤": "ASPN",
  "아스펜 인슈어런스 홀딩스 우선주": "AHL-P-D",
  "아시아 퍼시픽 와이어 & 케이블": "APWC",
  "아시아스트래티지": "SORA",
  "아야 골드 앤 실버": "AYA",
  "아에곤 ADR": "AEG",
  "아에리스 테크놀로지": "AERT",
  "아에바 테크놀로지스": "AEVA",
  "아우나": "AUNA",
  "아우디아": "AUUD",
  "아우라 미네랄스": "AUGO",
  "아우레우스 그린웨이 홀딩스": "PUSA",
  "아우렐리온": "AURE",
  "아우스터": "OUST",
  "아우어 본드": "OBAI",
  "아웃도어 홀딩": "POWW",
  "아웃도어 홀딩 우선주 시리즈 A 8.75%": "POWWP",
  "아웃룩 테라퓨틱스": "OTLK",
  "아웃셋 메디컬": "OM",
  "아웃프론트 미디어": "OUT",
  "아워 루프": "HOUR",
  "아이다코프": "IDA",
  "아이다호 스트래터직 리소시스": "IDR",
  "아이다호 코퍼": "COPR",
  "아이덱스": "IEX",
  "아이덱스 래보라토리스": "IDXX",
  "아이덴티브": "INVE",
  "아이디야 바이오사이언스": "IDYA",
  "아이디어 애퀴지션": "IACO",
  "아이디얼 파워": "IPWR",
  "아이라디메드": "IRMD",
  "아이레닉 애퀴지션": "IACQ",
  "아이렌": "IREN",
  "아이리듬 홀딩스": "IRTC",
  "아이리스 애퀴지션 II": "IRAB",
  "아이맥스": "IMAX",
  "아이바이오": "IBIO",
  "아이반호 일렉트릭": "IE",
  "아이베다 솔루션스": "IVDA",
  "아이벡스": "IBEX",
  "아이보타": "IBTA",
  "아이소에너지": "ISOU",
  "아이스큐어 메디컬": "ICCM",
  "아이스페시멘": "ISPC",
  "아이언 돔 애퀴지션 I": "IDAC",
  "아이언 마운틴": "IRM",
  "아이언 호스 애퀴지션스 II": "IRHO",
  "아이언우드 파마슈티컬스": "IRWD",
  "아이엠골드": "IAG",
  "아이오니스 파마슈티컬스": "IONS",
  "아이오니어 ADR": "IONR",
  "아이오닉 디지털": "IOND",
  "아이오쓰리": "IOTR",
  "아이온큐": "IONQ",
  "아이지아 월드와이드": "IZEA",
  "아이치이 ADR": "IQ",
  "아이코아 홀딩스": "ICHR",
  "아이콘": "ICLR",
  "아이콘 에너지": "ICON",
  "아이콘 테라퓨틱스": "EIKN",
  "아이큐비아 홀딩스": "IQV",
  "아이토닉 홀딩스": "ITOC",
  "아이투 바이오파마": "AYTU",
  "아이트론": "ITRI",
  "아이파워": "IPW",
  "아이포인트": "EYPT",
  "아이하트미디어": "IHRT",
  "아이휴먼 ADR": "IH",
  "아인라이드 ADR": "ENRD",
  "아제너스": "AGEN",
  "아젠타": "AZTA",
  "아줄 ADR": "AZUL",
  "아지오 AI 홀딩스": "AZIO",
  "아지트라": "AZTR",
  "아처 대니얼스 미들랜드": "ADM",
  "아처 에비에이션": "ACHR",
  "아츠 웨이 매뉴팩처링": "ARTW",
  "아치 캐피탈 그룹 우선주 시리즈 G 4.55%": "ACGLN",
  "아치 캐피털 그룹": "ACGL",
  "아치 캐피털 그룹 우선주 시리즈 F 5.45%": "ACGLO",
  "아카데미 스포츠 앤 아웃도어스": "ASO",
  "아카디아 리얼티 트러스트": "AKR",
  "아카디아 바이오사이언스": "RKDA",
  "아카디아 파마슈티컬스": "ACAD",
  "아카디아 헬스케어": "ACHC",
  "아카리 테라퓨틱스 ADR": "AKTX",
  "아카마이 테크놀로지": "AKAM",
  "아카시아 리서치": "ACTG",
  "아칸다": "AKAN",
  "아캐디언 애셋 매니지먼트": "AAMI",
  "아커티스 바이오테라퓨틱스": "ARQT",
  "아케비아 테라퓨틱스": "AKBA",
  "아코사": "ACA",
  "아쿠쉬네트 홀딩스": "GOLF",
  "아쿠스 바이오사이언스": "RCUS",
  "아쿠아 메탈스": "AQMS",
  "아쿠아바운티 테크놀로지스": "AQB",
  "아크": "ARQ",
  "아크 레스토란츠": "ARKR",
  "아크록": "AROC",
  "아크베스트": "ARCB",
  "아크투루스 테라퓨틱스 홀딩스": "ARCT",
  "아타라 바이오테라퓨틱스": "ATRA",
  "아타이버클리": "ATAI",
  "아테리스": "AIP",
  "아테리안": "ATER",
  "아테아 파마슈티컬스": "AVIR",
  "아토메라": "ATOM",
  "아토비아 테라퓨틱스": "ATTO",
  "아토사 테라퓨틱스": "ATOS",
  "아트 테크놀로지 애퀴지션": "ARTC",
  "아트리움 테라퓨틱스": "RNA",
  "아트리큐어": "ATRC",
  "아트무스 필트레이션 테크놀로지스": "ATMU",
  "아틀라스 리튬": "ATLX",
  "아틀라스 에너지 솔루션스": "AESI",
  "아틀라스 크리티컬 미네랄스": "ATCX",
  "아틀라스클리어 홀딩스": "ATCH",
  "아틀라시안": "TEAM",
  "아틀란타 브레이브스 홀딩스 Series A": "BATRA",
  "아틀란타 브레이브스 홀딩스 Series C": "BATRK",
  "아틀란티쿠스 홀딩스": "ATLC",
  "아틀란티쿠스 홀딩스 우선주 시리즈 B 7.625%": "ATLCP",
  "아틀란틱 아메리칸": "AAME",
  "아틀란틱 유니온 뱅크셰어스": "AUB",
  "아티바 바이오테라퓨틱스": "ARTV",
  "아티비온": "AORT",
  "아티어스 II 애퀴지션": "AACB",
  "아티잔 파트너스 애셋 매니지먼트": "APAM",
  "아파트먼트 인베스트먼트 & 매니지먼트": "AIV",
  "아포지 엔터프라이스": "APOG",
  "아포지 테라퓨틱스": "APGE",
  "아폴로 글로벌 매니지먼트": "APO",
  "아폴로 커머셜 리얼에스테이트 파이낸스": "ARI",
  "아폴로믹스": "APLM",
  "아프레아 테라퓨틱스": "APRE",
  "아프타그룹": "ATR",
  "아피메즈 파마슈티컬스 US": "APUS",
  "아피야": "AFYA",
  "악셀 엔터테인먼트": "ACEL",
  "악소 헬스 그룹 ADR": "AHG",
  "악실 브랜즈": "AXIL",
  "악티늄 파마슈티컬스": "ATNM",
  "안데르센 그룹": "ANDG",
  "안드레티 애퀴지션 II": "POLE",
  "안비오 바이오테크놀로지": "NNNN",
  "안탈파 플랫폼 홀딩": "ANTA",
  "안테리스 테크놀로지스 글로벌": "AVR",
  "안테릭스": "ATEX",
  "안텔로페 엔터프라이즈 홀딩스": "AEHL",
  "안호이저부시 인베브 ADR": "BUD",
  "알고리듬 홀딩스": "RIME",
  "알고마 스틸 그룹": "ASTL",
  "알곤퀸 파워 & 유틸리티": "AQN",
  "알다브라4 리퀴디티 오퍼튜니티": "ALOV",
  "알데이라 테라퓨틱스": "ALDX",
  "알델 파이낸셜 II": "ALDF",
  "알라럼 테크놀로지스 ADR": "ALAR",
  "알라마 바이오사이언스": "ALMR",
  "알라모 그룹": "ALG",
  "알라우노스 테라퓨틱스": "TCRT",
  "알람닷컴 홀딩스": "ALRM",
  "알래스카 에어 그룹": "ALK",
  "알레그로 마이크로시스템즈": "ALGM",
  "알렉산더스": "ALX",
  "알렉산드리아 리얼에스테이트 이쿼티": "ARE",
  "알렉터": "ALEC",
  "알로진 테라퓨틱스": "ALLO",
  "알루미스": "ALMS",
  "알루사 에너지 애퀴지션 II": "ALUB",
  "알리": "RLI",
  "알리바바 그룹 홀딩스 ADR": "BABA",
  "알리안나": "ANNA",
  "알리코": "ALCO",
  "알몬티 인더스트리스": "ALM",
  "알보테크": "ALVO",
  "알셋": "AEI",
  "알자멘드 뉴로": "ALZN",
  "알카미 테크놀로지": "ALKT",
  "알코아": "AA",
  "알콘": "ALC",
  "알타 이큅먼트 그룹": "ALTG",
  "알테리티 테라퓨틱스 ADR": "ATHE",
  "알토 뉴로사이언스": "ANRO",
  "알토 인그리디언츠": "ALTO",
  "알트리아그룹": "MO",
  "알티 글로벌": "ALTI",
  "알티뮨": "ALT",
  "알티소스 포트폴리오 솔루션스": "ASPS",
  "알파 메탈러지컬 리소시스": "AMR",
  "알파 모더스 홀딩스": "AMOD",
  "알파 앤 오메가 세미콘덕터": "AOSL",
  "알파 컴퓨트": "ALP",
  "알파 코그니토": "ACOG",
  "알파 타우 메디컬": "DRTS",
  "알파 테크노바": "TKNO",
  "알파 테크놀로지 그룹": "ATGL",
  "알파 프로 테크": "APT",
  "알파벳 Class A": "GOOGL",
  "알파벳 Class C": "GOOG",
  "알파벳 우선주 6.25% Series A": "GOOGM",
  "알파벳 우선주 6.25% Series B": "GOOGN",
  "알파인 인컴 프로퍼티 트러스트": "PINE",
  "알파텍 홀딩스": "ATEC",
  "알펙스 애퀴지션": "ALPX",
  "알프스 그룹": "ALPS",
  "암 홀딩스 ADR": "ARM",
  "암독스": "DOX",
  "암라이즈": "AMRZ",
  "암로지 홀딩": "BTOC",
  "암바렐라": "AMBA",
  "암베브 ADR": "ABEV",
  "암스트롱 월드 인더스트리스": "AWI",
  "암젠": "AMGN",
  "암콘 디스트리뷰팅": "DIT",
  "암테크 시스템즈": "ASYS",
  "암퍼캡 애퀴지션": "APMC",
  "암페놀": "APH",
  "압테라 모터스": "SEV",
  "압티보 테라퓨틱스": "APVO",
  "앙가미": "ANGH",
  "앙코어 캐피털 그룹": "ECPG",
  "애그니코 이글 마인스": "AEM",
  "애그리컬처 & 내추럴 솔루션 애퀴지션": "ANSC",
  "애그코": "AGCO",
  "애너벡스 라이프 사이언시스": "AVXL",
  "애널로그 디바이시스": "ADI",
  "애널리 캐피털 매니지먼트": "NLY",
  "애노비스 바이오": "ANVS",
  "애닉사 바이오사이언시스": "ANIX",
  "애더 홀딩스": "ATHR",
  "애드트랜 홀딩스": "ADTN",
  "애든택스 그룹": "ATXG",
  "애디언트": "ADNT",
  "애디얼 파머수티컬": "ADIL",
  "애딕스 테라퓨틱스 ADR": "ADXN",
  "애로우 일렉트로닉스": "ARW",
  "애로우 파이낸셜": "AROW",
  "애로우마크 파이낸셜": "BANX",
  "애로우헤드 파마슈티컬스": "ARWR",
  "애머런": "AEE",
  "애버린 캐피탈 애퀴지션": "ACAA",
  "애버커스 글로벌": "ABX",
  "애버크롬비 & 피치": "ANF",
  "애벌랜치 트레저리": "AVAT",
  "애보니 애퀴지션 I": "AACO",
  "애보트 래보라토리": "ABT",
  "애브비": "ABBV",
  "애브포인트": "AVPT",
  "애비드뱅크 홀딩스": "AVBH",
  "애비디아 뱅코프": "AVBC",
  "애비애나 헬스케어 홀딩스": "AVAH",
  "애비엔트": "AVNT",
  "애쉬랜드": "ASH",
  "애스트로테크": "ASTC",
  "애스파이어 바이오파마": "ASBP",
  "애슬론 메디컬": "AEMD",
  "애시포드 호스피탤리티 트러스트": "AHT",
  "애이콤": "ACM",
  "애즈-테크 에너지": "ADSE",
  "애즈버리 오토모티브 그룹": "ABG",
  "애지오스 파마슈티컬스": "AGIO",
  "애질런트 테크놀로지스": "A",
  "애질론 헬스": "AGL",
  "애코 그룹 홀딩스": "ACCL",
  "애코 브랜즈": "ACCO",
  "애퀴티 뱅크셰어스": "EQBK",
  "애큐레이": "ARAY",
  "애큐먼 파마슈티컬스": "ABOS",
  "애크리본 테라퓨틱스": "ACRV",
  "애크미 유나이티드": "ACU",
  "애클라리온": "ACON",
  "애클래리스 테라퓨틱스": "ACRS",
  "애트모스 에너지": "ATO",
  "애퍼지 애퀴지션": "AACP",
  "애퍼처": "APUR",
  "애플": "AAPL",
  "애플 호스피탤리티 리츠": "APLE",
  "애플랙": "AFL",
  "애피안": "APPN",
  "액섬 테라퓨틱스": "AXSM",
  "액세스 뉴스와이어": "ACCS",
  "액센추어": "ACN",
  "액셀리스 테크놀로지스": "ACLS",
  "액소스 파이낸셜": "AX",
  "액손 엔터프라이스": "AXON",
  "액스 컴퓨트": "AGPU",
  "액시스 캐피털 홀딩스": "AXS",
  "액시엄 인텔리전스 애퀴지션 1": "AXIN",
  "액추에이트 테라퓨틱스": "ACTU",
  "액티베이트 에너지 애퀴지션": "AEAQ",
  "액티스 온콜로지": "AKTS",
  "앤더슨스": "ANDE",
  "앤지": "ANGI",
  "앤지오다이내믹스": "ANGO",
  "앤테로 리소스": "AR",
  "앤테로 미드스트림": "AM",
  "앤필드 에너지": "AEC",
  "앨나일램 파마슈티컬스": "ALNY",
  "앨라이 파이낸셜": "ALLY",
  "앨라이드 골드": "AAUC",
  "앨러루스 파이낸셜": "ALRS",
  "앨럿": "ALLT",
  "앨루마": "ALMU",
  "앨리고스 테라퓨틱스": "ALGS",
  "앨리슨 트랜스미션 홀딩스": "ALSN",
  "앨버니 인터내셔널": "AIN",
  "앨버말": "ALB",
  "앨버트슨 컴퍼니": "ACI",
  "앨커미스": "ALKS",
  "앰렙": "AXR",
  "앰버 인터내셔널 홀딩 ADR": "AMBR",
  "앰보우 에듀케이션 홀딩스 ADR": "AMBO",
  "앰비션스 엔터프라이즈 매니지먼트": "AHMA",
  "앰비크 마이크로": "AMBQ",
  "앰코": "AMCR",
  "앰코 테크놀로지": "AMKR",
  "앰퍼스타 파마슈티컬스": "AMPH",
  "앰프리어스 테크놀로지스": "AMPX",
  "앰프코 피츠버그": "AP",
  "앰플리테크 그룹": "AMPG",
  "앰플리튜드": "AMPL",
  "앰플리파이 에너지": "AMPY",
  "앱러빈": "APP",
  "앱사이": "ABSI",
  "앱셀레라 바이오로직스": "ABCL",
  "앱토럼 그룹": "NIKI",
  "앱티브": "APTV",
  "앱폴리오": "APPF",
  "앳코어": "ATKR",
  "앵글로골드 아샨티": "AU",
  "야누스 인터내셔널 그룹": "JBI",
  "야로우 바이오사이언스": "YARW",
  "야트라 온라인": "YTRA",
  "얄라 그룹 ADR": "YALA",
  "얏센 홀딩 ADR": "YSG",
  "어그리 리얼티": "ADC",
  "어냅티스바이오": "ANAB",
  "어넥사 테라퓨틱스": "ERNA",
  "어니스트 컴퍼니": "HNST",
  "어댑트헬스": "AHCO",
  "어댑티브 바이오테크놀러지": "ADPT",
  "어도비": "ADBE",
  "어드반스드 플라워 캐피털": "AFCG",
  "어드밴스 오토 파츠": "AAP",
  "어드밴스드 바이오메드": "ADVB",
  "어드밴스드 에너지 인더스트리스": "AEIS",
  "어드밴스트 드레이니지 시스템즈": "WMS",
  "어드밴식스": "ASIX",
  "어드밴티지 솔루션스": "ADV",
  "어라이번트 바이오파마": "AVBP",
  "어라이브 AI": "ARAI",
  "어레이 디지털 인프라스트럭처": "AD",
  "어레이 테크놀로지스": "ARRY",
  "어매스 브랜즈": "AMSS",
  "어메이즈 홀딩스": "AMZE",
  "어반 아웃피터스": "URBN",
  "어반 에지 프로퍼티스": "UE",
  "어반 원 Class A": "UONE",
  "어반 원 Class D": "UONEK",
  "어밴터": "AVTR",
  "어번 내셔널 뱅코프": "AUBN",
  "어번디아 글로벌 임팩트 그룹": "AGIG",
  "어센트 솔라 테크놀로지스": "ASTI",
  "어센트 인더스트리즈": "ACNT",
  "어센티지 파마 그룹 인터내셔널 ADR": "AAPG",
  "어셈블리 바이오사이언시스": "ASMB",
  "어소시에이티드 뱅크코프": "ASB",
  "어슈런트": "AIZ",
  "어슈어 소프트웨어": "ASUR",
  "어슈어드 개런티": "AGO",
  "어웨어": "AWRE",
  "어질리시스": "AGYS",
  "어치브 라이프 사이언스": "ACHV",
  "어퀴스티브 테라퓨틱스": "AQST",
  "어큐어엑스 파마슈티컬스": "ACXP",
  "어큐이티": "AYI",
  "어투어 라이프 스타일 홀딩스 ADR": "ATAT",
  "어펌 홀딩스": "AFRM",
  "어플라이드 디지털": "APLD",
  "어플라이드 머티어리얼즈": "AMAT",
  "어플라이드 에어로스페이스 앤 디펜스": "AADX",
  "어플라이드 옵토일렉트로닉스": "AAOI",
  "어플라이드 인더스트리얼 테크놀로지": "AIT",
  "어필리에이티드 매니저스 그룹": "AMG",
  "언더 아머 Class A": "UAA",
  "언더 아머 Class C": "UA",
  "언유주얼 머신스": "UMAC",
  "얼라러티 테라퓨틱스": "ALLR",
  "얼라이언스 런드리 홀딩스": "ALH",
  "얼라이언스 엔터테인먼트 홀딩": "AENT",
  "얼라이언트": "ALNT",
  "얼라이언트 에너지": "LNT",
  "얼라이트": "ALIT",
  "얼라인 테크놀로지": "ALGN",
  "얼라인먼트 헬스케어": "ALHC",
  "얼리전트 트래블": "ALGT",
  "얼리지언": "ALLE",
  "업 핀테크 홀딩스 ADR": "TIGR",
  "업랜드 소프트웨어": "UPLD",
  "업바운드 그룹": "UPBD",
  "업스타트 홀딩스": "UPST",
  "업스트림 바이오": "UPB",
  "업워크": "UPWK",
  "에난타 파마슈티컬스": "ENTA",
  "에너거스": "WATT",
  "에너시스": "ENS",
  "에너자이저 홀딩스": "ENR",
  "에너지 리커버리": "ERII",
  "에너지 볼트 홀딩스": "NRGV",
  "에너지 서비시스 오브 아메리카": "ESOA",
  "에너지 트랜지션 스페셜 오퍼튜니티스": "ETSS",
  "에너지 포커스": "EFOI",
  "에너지 퓨얼스": "UUUU",
  "에너지스 그룹": "ENGS",
  "에너팩 툴 그룹": "EPAC",
  "에너플렉스": "EFXT",
  "에넬 칠레 ADR": "ENIC",
  "에니 ADR": "E",
  "에니그매티그": "EGG",
  "에니스": "EBF",
  "에더블 가든": "EDBL",
  "에데사 바이오테크": "EDSA",
  "에듀케이셔널 디벨롭먼트": "EDUC",
  "에드워즈 라이프사이언시스": "EW",
  "에디슨 인터내셔널": "EIX",
  "에디타스 메디신": "EDIT",
  "에라약 파워 솔루션 그룹": "RAYA",
  "에로 코퍼": "ERO",
  "에르메네질도 제냐": "ZGN",
  "에머슨 라디오": "MSN",
  "에머슨 일렉트릭": "EMR",
  "에메라": "EMA",
  "에메티스": "AMTX",
  "에미스 애퀴지션": "EMIS",
  "에바 라이브": "GOAI",
  "에바종 ADR": "EVAX",
  "에버브라이트 디지털 홀딩": "EDHL",
  "에버소스 에너지": "ES",
  "에버스핀 테크놀러지": "MRAM",
  "에버지": "EVRG",
  "에버커머스": "EVCM",
  "에버코어": "EVR",
  "에버쿼트": "EVER",
  "에버테크": "EVTC",
  "에버포스": "EFOR",
  "에버퓨어": "P",
  "에베레스트 그룹": "EG",
  "에베루스 컨스트럭션 그룹": "ECG",
  "에보뮨": "EVMN",
  "에보젠": "EVGN",
  "에보텍 ADR": "EVO",
  "에볼러스": "EOLS",
  "에볼런트 헬스": "EVH",
  "에볼루션 글로벌 애퀴지션": "EVOX",
  "에볼루션 메탈스 & 테크놀로지스": "EMAT",
  "에볼루션 페트롤리엄": "EPM",
  "에비 슈미트 홀딩": "AEBI",
  "에섹스 프로퍼티 트러스트": "ESS",
  "에센셜 유틸리티스": "WTRG",
  "에센셜 프로퍼티 리얼티": "EPRT",
  "에스오에스": "SOS",
  "에스칼라드": "ESCA",
  "에스코 테크놀로지스": "ESE",
  "에스콰이어 파이낸셜 홀딩스": "ESQ",
  "에스타블리쉬먼트 랩스 홀딩스": "ESTA",
  "에스트렐라 이뮤노파르마": "ESLA",
  "에스티 로더": "EL",
  "에스페이 MFG & 일렉트로닉스": "ESP",
  "에어 T": "AIRT",
  "에어 T 우선주 8%": "AIRTP",
  "에어 글로벌": "AIIR",
  "에어 인더스트리스 그룹": "AIRI",
  "에어 프로덕츠 앤 케미컬스": "APD",
  "에어게인": "AIRG",
  "에어로바이런먼트": "AVAV",
  "에어비앤비": "ABNB",
  "에어세일": "ASLE",
  "에어스컬프 테크놀로지스": "AIRS",
  "에어십 AI 홀딩스": "AISP",
  "에어줄 테크놀로지스": "AIRJ",
  "에어캡 홀딩스": "AER",
  "에이 스펙 III 애퀴지션": "ASPC",
  "에이노스": "AIMD",
  "에이디셋바이오": "ACET",
  "에이메이 헬스 테크놀로지": "AFJK",
  "에이버리 데니슨": "AVY",
  "에이브이넷": "AVT",
  "에이블 뷰 글로벌": "ABLV",
  "에이비스 버짓 그룹": "CAR",
  "에이비츠 그룹": "ABTS",
  "에이아이": "LIDR",
  "에이에이온": "AAON",
  "에이온": "AON",
  "에이지이글 에어리얼 시스템": "UAVS",
  "에이커스 커머셜 리얼티": "ACR",
  "에이콘 에너지": "ACFN",
  "에이타이르 파르마": "ATYR",
  "에이토 홀딩스": "ORBS",
  "에이티그리티 스페셜티 인슈어런스 홀딩스": "ASIC",
  "에이펙스 트레저리": "APXT",
  "에이픽스 메디컬": "APYX",
  "에임스 내셔널": "ATLO",
  "에임자이트": "AMST",
  "에젠시아 커머셜 스피리츠": "AGCC",
  "에지웰 퍼스널 케어": "EPC",
  "에코 웨이브 파워 글로벌 AB (publ) ADR": "WAVE",
  "에코비스트": "ECVT",
  "에코스타": "ECHO",
  "에코페트롤 ADR": "EC",
  "에쿠스 토탈 리턴": "EQS",
  "에퀴노르 ADR": "EQNR",
  "에퀴터블 홀딩스": "EQH",
  "에퀴티 라이프스타일 프로퍼티스": "ELS",
  "에퀴티 레지덴셜": "EQR",
  "에퀴팩스": "EFX",
  "에토스 테크놀로지스": "LIFE",
  "에투알 캐피털 그룹": "EFTY",
  "에픽퀘스트 에듀케이션 그룹 인터내셔널": "EEIQ",
  "에흐르 테스트 시스템즈": "AEHR",
  "엑사젠": "XGN",
  "엑셀 브랜즈": "XELB",
  "엑셀 에너지": "XEL",
  "엑셀러런트 홀딩스": "ARX",
  "엑셀러레이트 에너지": "EE",
  "엑셀론": "EXC",
  "엑셀리시스": "EXEL",
  "엑소더스 무브먼트": "EXOD",
  "엑소스": "XOS",
  "엑소자임스": "EXOZ",
  "엑솔라 스팩 1": "XSLL",
  "엑솔타 코팅 시스템즈": "AXTA",
  "엑스 파이낸셜 ADR": "XYF",
  "엑스바이오텍": "XBIT",
  "엑스턴트 메디컬 홀딩스": "XTNT",
  "엑스트라 스페이스 스토리지": "EXR",
  "엑스페리": "XPER",
  "엑스펠": "XPEL",
  "엑스포": "XPO",
  "엑스포넌트": "EXPO",
  "엑스포넨셜 피트니스": "XPOF",
  "엑스프로": "XPRO",
  "엑스피": "XP",
  "엑스피언360": "XPON",
  "엑슨모빌 홀딩스": "XOM",
  "엑슬서비스 홀딩스": "EXLS",
  "엑시큐어": "XCUR",
  "엑신 테크놀로지스": "EXYN",
  "엑제오 그룹": "XZO",
  "엔-에이블": "NABL",
  "엔다바 ADR": "DAVA",
  "엔데버 실버": "EXK",
  "엔드라 라이프 사이언스": "NDRA",
  "엔라이벡스": "ENLV",
  "엔라이트": "LASR",
  "엔라이트 리뉴어블 에너지": "ENLT",
  "엔버릭 바이오사이언시스": "ENVB",
  "엔베노 메디컬": "NVNO",
  "엔벤트 일렉트릭": "NVT",
  "엔벨라": "ELA",
  "엔보이 메디컬": "COCH",
  "엔뷰 메디컬": "FEED",
  "엔브리지": "ENB",
  "엔비니 그룹": "NVNI",
  "엔비디아": "NVDA",
  "엔비리": "NVRI",
  "엔비스타 홀딩스": "NVST",
  "엔사인 그룹": "ENSG",
  "엔시스 바이오사이언시스": "ENSC",
  "엔씨노": "NCNO",
  "엔젤 스튜디오스": "ANGX",
  "엔젤 오크 모기지": "AOMR",
  "엔진 게이밍 앤 미디어": "GAME",
  "엔진 테라퓨틱스": "ENGN",
  "엔카르타": "NKTX",
  "엔코어 에너지": "EU",
  "엔터지": "ETR",
  "엔터지 뉴올리언스 선순위 담보채권 5.000% 만기 2052년": "ENJ",
  "엔터지 뉴올리언스 선순위 담보채권 5.500% 만기 2066년": "ENO",
  "엔터지 루이지애나 선순위 담보채권 4.875% 만기 2066년": "ELC",
  "엔터지 미시시피 선순위 담보채권 4.900% 만기 2066년": "EMP",
  "엔터지 아칸소 선순위 담보채권 4.875% 만기 2066년 9월": "EAI",
  "엔터지 텍사스 우선주 시리즈 A 5.375%": "ETI-P",
  "엔터프라이즈 파이낸셜 서비스": "EFSC",
  "엔터프라이즈 파이낸셜 서비시스 우선주 시리즈 A 5%": "EFSCP",
  "엔테라 바이오": "ENTX",
  "엔테로 테라퓨틱스": "GRDX",
  "엔트라다 테라퓨틱스": "TRDA",
  "엔트라비전 커뮤니케이션즈": "EVC",
  "엔프로": "NPO",
  "엘 폴로 로코 홀딩스": "LOCO",
  "엘도라도 골드": "EGO",
  "엘라스틱": "ESTC",
  "엘란코 애니멀 헬스": "ELAN",
  "엘러윗 커넥션": "ELWT",
  "엘레돈 파마슈티컬스": "ELDN",
  "엘레반스 헬스": "ELV",
  "엘로메이 캐피털": "ELLO",
  "엘록스 파마슈티컬스": "ELOX",
  "엘루시아": "ELUT",
  "엘름 커뮤니티스": "ELME",
  "엘리먼트 솔루션즈": "ESI",
  "엘리멘탈 로열티 코퍼레이션": "ELE",
  "엘리시오 테라퓨틱스": "ELTX",
  "엘리트 익스프레스 홀딩": "ETS",
  "엘링턴 파이낸셜": "EFC",
  "엘멧 그룹": "ELMT",
  "엘빗 시스템즈": "ESLT",
  "엘지디스플레이 ADR": "LPL",
  "엘텍": "ELTK",
  "엘프 뷰티": "ELF",
  "엠닐 파마슈티컬": "AMRX",
  "엠백타": "EMBC",
  "엠비아": "MBI",
  "엠에프 인터내셔널": "MFI",
  "엠코 그룹": "EME",
  "엠파이어 스테이트 리얼티 트러스트": "ESRT",
  "엠파이어 페트롤리움": "EP",
  "엠페리 디지털": "EMPD",
  "엠프레사 디스트리부이도라 ADR": "EDN",
  "엠피 머터리얼즈": "MP",
  "엡시움 엔터프라이즈": "EPSM",
  "엡실론 에너지": "EPSN",
  "엣지와이즈 테라퓨틱스": "EWTX",
  "염 브랜즈": "YUM",
  "염 차이나 홀딩스": "YUMC",
  "예스웨이": "YSWY",
  "예티 홀딩스": "YETI",
  "옐프": "YELP",
  "오가노제네시스홀딩스": "ORGO",
  "오가논 & 코": "OGN",
  "오가니그램 글로벌": "OGI",
  "오니티 그룹": "ONIT",
  "오디사이트.AI": "ODYS",
  "오디세이 마린 익스플로레이션": "OMEX",
  "오디세이 테라퓨틱스": "ODTX",
  "오디오아이": "AEYE",
  "오디오코드": "AUDC",
  "오디티 테크": "ODD",
  "오라 바이오사이언시스": "AURA",
  "오라메드 파마슈티컬스": "ORMP",
  "오라슈어 테크놀로지스": "OSUR",
  "오라이언 그룹 홀딩스": "ORN",
  "오라제닉스": "OGEN",
  "오라클": "ORCL",
  "오레녹스 인더스트리스": "OLOX",
  "오레일리 오토모티브": "ORLY",
  "오렌지 카운티 뱅코프": "OBT",
  "오렌지클라우드 테크놀로지": "ORKT",
  "오로라 모바일 ADR": "JG",
  "오로라 이노베이션": "AUR",
  "오로라 카나비스": "ACB",
  "오루카 테라퓨틱스": "ORKA",
  "오리니아 파마슈티컬스": "AUPH",
  "오리엔탈 컬처 홀딩": "OCG",
  "오리온": "OEC",
  "오리온 디지털": "ORIO",
  "오리온 에너지 시스템즈": "OESX",
  "오리온 프로퍼티스": "ONL",
  "오리진 뱅코프": "OBK",
  "오리진 애그리테크": "SEED",
  "오리진 인베스트먼트 I": "ORIQ",
  "오릭 파마슈티컬스": "ORIC",
  "오릭스 ADR": "IX",
  "오마다 헬스": "OMDA",
  "오마이홈": "OMH",
  "오마트 테크놀로지스": "ORA",
  "오메가 플렉스": "OFLX",
  "오메가 헬스케어 인베스터스": "OHI",
  "오메로스": "OMER",
  "오북 홀딩스": "OWLS",
  "오비드 테라퓨틱스": "OVID",
  "오빈티브": "OVV",
  "오셔나골드": "OGC",
  "오셔니어링 인터내셔널": "OII",
  "오션 캐피탈 애퀴지션": "OCAC",
  "오션 파워 테크놀로지스": "OPTT",
  "오션팰": "SVRN",
  "오션퍼스트 파이낸셜": "OCFC",
  "오션호크 애퀴지션": "OHAC",
  "오소픽스 메디컬": "OFIX",
  "오스아이디": "AUID",
  "오스카 헬스": "OSCR",
  "오스타운 파이낸셜 서비스": "ORRF",
  "오스트레일리안 오일시드 홀딩스": "COOT",
  "오스틴 골드": "AUST",
  "오스틴 테크놀로지 그룹": "OST",
  "오시스코 골드 그룹": "OGG",
  "오시코시": "OSK",
  "오쏘피디아트릭스": "KIDS",
  "오엘비 그룹": "OLB",
  "오울렛": "OWLT",
  "오웬스 코닝": "OC",
  "오이스터 엔터프라이시스 II 애퀴지션": "OYSE",
  "오일 스테이츠 인터내셔널": "OIS",
  "오일-드리 코퍼레이션 오브 아메리카": "ODC",
  "오케스트라 바이오메드 홀딩스": "OBIO",
  "오케아니스 에코 탱커스": "ECO",
  "오쿨리스 홀딩": "OCS",
  "오큐젠": "OCGN",
  "오큘라 테라퓨틱스": "OCUL",
  "오크 밸리 뱅코프": "OVLY",
  "오크트리 스페셜티 렌딩": "OCSL",
  "오크트리 애퀴지션 III 라이프 사이언스": "OACC",
  "오클로": "OKLO",
  "오키드 아일랜드 캐피털": "ORC",
  "오터 테일": "OTTR",
  "오토네이션": "AN",
  "오토노믹스 메디컬": "AMIX",
  "오토데스크": "ADSK",
  "오토러스 테라퓨틱스 ADR": "AUTL",
  "오토리브": "ALV",
  "오토매틱 데이터 프로세싱": "ADP",
  "오토존": "AZO",
  "오토지 인터넷 테크놀로지 (글로벌)": "AZI",
  "오토홈 ADR": "ATHM",
  "오틀리 그룹 AB ADR": "OTLY",
  "오티스 월드와이드": "OTIS",
  "오팔 퓨얼": "OPAL",
  "오퍼패드 솔루션스": "OPAD",
  "오페라 ADR": "OPRA",
  "오펜하이머 홀딩스": "OPY",
  "오포툰 파이낸셜": "OPRT",
  "오푸스 제네틱스": "IRD",
  "오픈 텍스트": "OTEX",
  "오픈도어 테크놀로지스": "OPEN",
  "오픈레인": "OPLN",
  "오피스 프로퍼티스 인컴 트러스트": "OPI",
  "오하이오 밸리 뱅크": "OVBC",
  "옥소젠": "AXGN",
  "옥스브리지 리 홀딩스": "OXBR",
  "옥스퍼드 레인 우선주 8.25%": "OXLCM",
  "옥스포드 레인 캐피털": "OXLC",
  "옥스포드 레인 캐피털 우선주 7.50%": "OXLCO",
  "옥스포드 스퀘어 캐피털": "OXSQ",
  "옥스포드 인더스트리스": "OXM",
  "옥스포트 레인 캐피털 우선주 7.125%": "OXLCN",
  "옥슬리 브릿지 애퀴지션": "OBA",
  "옥시덴털 페트롤리움": "OXY",
  "옥타": "OKTA",
  "옥타브 스페셜티 그룹": "OSG",
  "옥타브 인텔리전스": "OCTV",
  "온 세미콘덕터": "ON",
  "온 홀딩": "ONON",
  "온다스": "ONDS",
  "온코네틱스": "ONCO",
  "온콜리틱스 바이오텍": "ONCY",
  "온큐어 테라퓨틱스": "OKUR",
  "온테리스": "ONT",
  "온투 이노베이션": "ONTO",
  "온폴리오 홀딩스": "ONFO",
  "올 인 퓨처테크 얼라이언스": "AIFA",
  "올드 내셔널 뱅코프": "ONB",
  "올드 내셔널 뱅코프 40 우선주 시리즈 A": "ONBPP",
  "올드 내셔널 뱅코프 40 우선주 시리즈 C": "ONBPO",
  "올드 도미니언 프라이트 라인": "ODFL",
  "올드 리퍼블릭 인터내셔널": "ORI",
  "올드 세컨드 뱅코프": "OSBC",
  "올레마 파마슈티컬": "OLMA",
  "올리스 바겐 아웃렛 홀딩스": "OLLI",
  "올린": "OLN",
  "올스테이트": "ALL",
  "옴니AB": "OABI",
  "옴니셀": "OMCL",
  "옴니콤 그룹": "OMC",
  "옵션 케어 헬스": "OPCH",
  "옵시디안 에너지": "OBE",
  "옵코 헬스": "OPK",
  "옵텍스 시스템스 홀딩스": "OPXS",
  "옵티마이즈알엑스": "OPRX",
  "옵티멈 커뮤니케이션스": "OPTU",
  "옵티멈뱅크 홀딩스": "OPHC",
  "옵티미 헬스": "OPTH",
  "옵티컬 케이블": "OCC",
  "옵파이": "OPFI",
  "와바시 내셔널": "WNC",
  "와비 파커": "WRBY",
  "와이드포인트": "WYY",
  "와이마이 홀로그램 클라우드": "WIMI",
  "와이어하우저": "WY",
  "와이즈 그룹": "WSE",
  "와이즈키 인터내셔널 홀딩 AG ADR": "WKEY",
  "와츠 워터 테크놀로지스": "WTS",
  "와츠코": "WSO",
  "와튼 파이낸셜": "WTF",
  "와푸 에듀케이션": "WAFU",
  "요신 테크놀로지": "YAAS",
  "요크 스페이스 시스템즈": "YSS",
  "요크 워터": "YORW",
  "요크빌 애퀴지션": "MCGA",
  "요크빌 인터내셔널 캐피털": "YICC",
  "우드사이드 에너지 그룹 ADR": "WDS",
  "우드워드": "WWD",
  "우라늄 로열티": "UROY",
  "우라늄 에너지": "UEC",
  "우로젠 파마": "URGN",
  "우리금융지주 ADR": "WF",
  "우마": "OOMA",
  "우버": "UBER",
  "우신 ADR": "UXIN",
  "울버린 월드 와이드": "WWW",
  "울타 뷰티": "ULTA",
  "울트라 클린 홀딩스": "UCTT",
  "울트라라이프": "ULBI",
  "울트라제닉스 파마슈티컬": "RARE",
  "울트라파르 팔티시파코에스 ADR": "UGP",
  "울프스피드": "WOLF",
  "워너 뮤직 그룹": "WMG",
  "워너 브로스 디스커버리": "WBD",
  "워딩턴 스틸": "WS",
  "워딩턴 엔터프라이즈": "WOR",
  "워리어 멧 콜": "HCC",
  "워싱턴 트러스트 뱅코프": "WASH",
  "워커 & 던롭": "WD",
  "워크 메디컬 테크놀로지 그룹": "WOK",
  "워크데이": "WDAY",
  "워크스포트": "WKSP",
  "워크호스 그룹": "WKHS",
  "워키바": "WK",
  "워터드랍 ADR": "WDH",
  "워터브리지 인프라스트럭처": "WBI",
  "워터스": "WAT",
  "워터스톤 파이낸셜": "WSBF",
  "원 가스": "OGS",
  "원 그룹 호스피탤리티": "STKS",
  "원 리버티 프로퍼티즈": "OLP",
  "원 앤 원 그린 테크놀로지스": "YDDL",
  "원IM 애퀴지션": "OIM",
  "원메드넷": "ONMD",
  "원메인 홀딩스": "OMF",
  "원스 어폰 어 팜": "OFRM",
  "원스파월드 홀딩스": "OSW",
  "원스팬": "OSPN",
  "원오케이": "OKE",
  "원워터 마린": "ONEW",
  "원컨스트럭션 그룹": "ONEG",
  "월드 억셉턴스": "WRLD",
  "월드 키넥트": "WKC",
  "월든캐스트": "WALD",
  "월마트": "WMT",
  "월박스": "WBX",
  "월트 디즈니": "DIS",
  "월풀": "WHR",
  "웨너 엔터프라이즈": "WERN",
  "웨더포드 인터네셔널": "WFRD",
  "웨스뱅코": "WSBC",
  "웨스뱅코 우선주 Series B 7.375%": "WSBCO",
  "웨스코 인터내셔널": "WCC",
  "웨스턴 뉴 잉글랜드 뱅코프": "WNEB",
  "웨스턴 디지털": "WDC",
  "웨스턴 얼라이언스 뱅코프": "WAL",
  "웨스턴 코퍼 & 골드": "WRN",
  "웨스턴유니온": "WU",
  "웨스트 뱅코프": "WTBA",
  "웨스트 엔클레이브 머저": "WENC",
  "웨스트 파마슈티컬 서비시즈": "WST",
  "웨스트 프레이저 팀버": "WFG",
  "웨스트락 커피": "WEST",
  "웨스트레이크": "WLK",
  "웨스트아메리카 뱅코프": "WABC",
  "웨스트우드 홀딩스 그룹": "WHG",
  "웨스트워터 리소시스": "WWR",
  "웨스트포트 퓨얼 시스템즈": "WPRT",
  "웨스틴 애퀴지션": "WSTN",
  "웨스팅하우스 에어 브레이크 테크놀로지": "WAB",
  "웨어 푸드 컴스 프롬": "WFCF",
  "웨어러블 디바이시스": "WLDS",
  "웨어울프 테라퓨틱스": "HOWL",
  "웨이보 ADR": "WB",
  "웨이브 라이프 사이언스": "WVE",
  "웨이스 마켓": "WMK",
  "웨이스타 홀딩": "WAY",
  "웨이스트 매니지먼트": "WM",
  "웨이스트 커넥션스": "WCN",
  "웨이코 그룹": "WEYS",
  "웨이페어": "W",
  "웩스": "WEX",
  "웬 애퀴지션": "WENN",
  "웬디스": "WEN",
  "웰스파고": "WFC",
  "웰스프론트": "WLTH",
  "웰체인지 홀딩스": "WCT",
  "웰타워": "WELL",
  "웹스터 파이낸셜": "WBS",
  "웹툰 엔터테인먼트": "WBTN",
  "위니바고 인더스트리": "WGO",
  "위라이드 ADR": "WRD",
  "위바이 글로벌": "WBUY",
  "위불": "BULL",
  "위브 커뮤니케이션스": "WEAV",
  "위샵 홀딩스": "WSHP",
  "위안바오 ADR": "YB",
  "위에다 디지털 홀딩": "YDKG",
  "위즈덤트리": "WT",
  "위터치 테크놀로지": "WETH",
  "위투어 로보틱스": "WETO",
  "위프로 ADR": "WIT",
  "윅스닷컴": "WIX",
  "윈 리조트": "WYNN",
  "윈덤 호텔 & 리조트": "WH",
  "윈마크": "WINA",
  "윈체스터 뱅코프": "WSBK",
  "윈터그린 애퀴지션": "WTG",
  "윈트러스트 파이낸셜": "WTFC",
  "윈트러스트 파이낸셜 우선주 7.875%": "WTFCN",
  "윌댄 그룹": "WLDN",
  "윌라멧 밸리 빈야즈": "WVVI",
  "윌래메트 밸리 바인야드 우선주 시리즈 A": "WVVIP",
  "윌로우 레인 애퀴지션 II": "WLII",
  "윌리스 리스 파이낸스": "WLFC",
  "윌리스 타워스 왓슨": "WTW",
  "윌리엄 소노마": "WSM",
  "윌리엄스 컴퍼니즈": "WMB",
  "윌스콧 홀딩스": "WSC",
  "윙스톱": "WING",
  "윙입푸드홀딩스그룹 ADR": "WYHG",
  "유 파워": "UCAR",
  "유나이티드 내추럴 푸드": "UNFI",
  "유나이티드 렌탈스": "URI",
  "유나이티드 마리타임": "USEA",
  "유나이티드 마이크로일렉트로닉 ADR": "UMC",
  "유나이티드 뱅코프": "UBCP",
  "유나이티드 뱅크셰어스(Nasdaq GS)": "UBSI",
  "유나이티드 스테이츠 라임 & 미네랄": "USLM",
  "유나이티드 스테이츠 앤티모니": "UAMY",
  "유나이티드 애퀴지션 I": "UAC",
  "유나이티드 에어라인스 홀딩스": "UAL",
  "유나이티드 커뮤니티 뱅크스": "UCB",
  "유나이티드 테라퓨틱스": "UTHR",
  "유나이티드 파이어 그룹": "UFCS",
  "유나이티드 파크 & 리조트": "PRKS",
  "유나이티드-가디언": "UG",
  "유나이티드헬스 그룹": "UNH",
  "유넘그룹": "UNM",
  "유니-퓨얼 홀딩스": "UFG",
  "유니레버 ADR": "UL",
  "유니버설": "UVV",
  "유니버설 디스플레이": "OLED",
  "유니버설 인슈어런스 홀딩스": "UVE",
  "유니버설 일렉트로닉스": "UEIC",
  "유니버설 테크니컬 인스티튜트": "UTI",
  "유니버설 헬스 리얼티 인컴 트러스트": "UHT",
  "유니버셜 로지스틱스 홀딩스": "ULH",
  "유니버셜 세이프티 프로덕츠": "UUU",
  "유니버셜 헬스 서비스": "UHS",
  "유니버스 파마슈티컬스": "UPC",
  "유니베스트 파이낸셜": "UVSP",
  "유니사이시브 테라퓨틱스": "UNCY",
  "유니시스": "UIS",
  "유니언 뱅크셰어스": "UNB",
  "유니온 퍼시픽": "UNP",
  "유니큐어": "QURE",
  "유니티 그룹 (델라웨어)": "UNIT",
  "유니티 뱅코프": "UNTY",
  "유니티소프트웨어": "U",
  "유니틸": "UTL",
  "유니퍼스트": "UNF",
  "유니피": "UFI",
  "유다오 ADR": "DAO",
  "유라이프 그룹 ADR": "YOUL",
  "유레카 애퀴지션": "EURK",
  "유로 테크 홀딩스 컴퍼니": "CLWT",
  "유로넷 월드와이드": "EEFT",
  "유로드라이": "EDRY",
  "유로시스": "ESEA",
  "유로홀딩스": "EHLD",
  "유비퀴티": "UI",
  "유사나 헬스 사이언스": "USNA",
  "유시오": "USIO",
  "유아이패스": "PATH",
  "유어-에너지": "URG",
  "유커뮨 인터내셔널": "UK",
  "유클라우드링크 그룹 ADR": "UCL",
  "유타 메디컬 프로덕츠": "UTMD",
  "유타임": "FXHO",
  "유펙시": "UPXI",
  "유프락시아 파마슈티컬스": "EPRX",
  "유홀 홀딩": "UHAL",
  "유홀 홀딩 시리즈 N": "UHAL-B",
  "윤지 ADR": "YJ",
  "윤홍 그린 CTI": "YHGJ",
  "이게인": "EGAN",
  "이글 뉴클리어 에너지": "NUCL",
  "이글 머티리얼스": "EXP",
  "이글 뱅코프": "EGBN",
  "이글 뱅코프 몬태나": "EBMT",
  "이글 파이낸셜 서비스": "EFSI",
  "이글 포인트 인스티튜셔널 인컴 펀드 우선주 Series A 8.125%": "EIIA",
  "이글 포인트 인컴 우선주 Series A 5%": "EICA",
  "이글 포인트 크레디트 우선주 Series C 6.5% 만기 2031년": "ECCC",
  "이글락 랜드": "EROK",
  "이네이트 파르마 ADR": "IPHA",
  "이노데이터": "INOD",
  "이노바 인터내셔널": "ENVA",
  "이노베이션 베버리지 그룹": "IBG",
  "이노베이지 홀딩": "INNV",
  "이노베이트": "VATE",
  "이노베이티브 솔루션스 & 서포트": "ISSC",
  "이노베이티브 아이웨어": "LUCY",
  "이노베이티브 인더스트리얼 프로퍼티": "IIPR",
  "이노벡스 인터내셔널": "INVX",
  "이노비바": "INVA",
  "이노비스": "ENOV",
  "이노비오 파마슈티컬스": "INO",
  "이노비즈 테크놀로지스": "INVZ",
  "이노빅스": "ENVX",
  "이노스펙": "IOSP",
  "이노젠": "INGN",
  "이누보": "INUV",
  "이니오": "INIO",
  "이댑 TMS ADR": "FOCL",
  "이래스카": "ERAS",
  "이렌 디지털 ADR": "YRD",
  "이록": "EROC",
  "이롱 파워 홀딩": "ELPW",
  "이리 인뎀니티": "ERIE",
  "이리덱스": "IRIX",
  "이리디움 커뮤니케이션스": "IRDM",
  "이매진바이오": "IMA",
  "이매틱스": "IMTX",
  "이머션": "IMMR",
  "이머전트 바이오솔루션스": "EBS",
  "이무톈 ADR": "YMT",
  "이뮤노반트": "IMVT",
  "이뮤노코어 홀딩스 ADR": "IMCR",
  "이뮤놈": "IMNM",
  "이뮤니어링": "IMRX",
  "이뮤니티바이오": "IBRX",
  "이뮤닉": "IMUX",
  "이뮤론 ADR": "IMRN",
  "이뮤셀": "ICCC",
  "이뮤텝 ADR": "IMMP",
  "이뮨온": "IMNN",
  "이믹스 바이오파마": "IMMX",
  "이방 인터내셔널 홀딩스": "EBON",
  "이베이": "EBAY",
  "이볼브 테크놀로지스 홀딩스": "EVLV",
  "이브 홀딩": "EVEX",
  "이센트 그룹": "ESNT",
  "이쉘고": "EHGO",
  "이스라엘 케미컬스": "ICL",
  "이스턴": "EML",
  "이스턴 뱅크셰어스": "EBC",
  "이스턴 인터내셔널": "ELOG",
  "이스털리 거번먼트 프로퍼티스": "DEA",
  "이스트 웨스트 뱅코프": "EWBC",
  "이스트그룹 프로퍼티스": "EGP",
  "이스트만 케미컬": "EMN",
  "이스트먼 코닥": "KODK",
  "이스파이어 테크놀로지": "ISPR",
  "이슨 테크놀로지 ADR": "DXF",
  "이엑스트": "YEXT",
  "이오밴스 바이오테라퓨틱스": "IOVA",
  "이오스 에너지 엔터프라이시스": "EOSE",
  "이온 바이오파마": "AEON",
  "이온 애퀴지션 I": "AESP",
  "이자벨라 뱅크": "ISBA",
  "이즈코프": "EZPW",
  "이지고 테크놀로지스": "EZGO",
  "이카엑스 홀딩스": "ECX",
  "이콜랩": "ECL",
  "이퀴녹스 골드": "EQX",
  "이퀴닉스": "EQIX",
  "이퀼리움": "EQ",
  "이큅먼트쉐어 닷컴": "EQPT",
  "이타우 우니방쿠 홀딩 ADR": "ITUB",
  "이토로 그룹": "ETOR",
  "이투란 로케이션 앤 콘트롤": "ITRN",
  "이튼": "ETN",
  "이튼 알렌 인테리어스": "ETD",
  "이튼 파마슈티컬즈": "ETON",
  "이팸 시스템즈": "EPAM",
  "이페리온엑스 ADR": "IPX",
  "이플러스": "PLUS",
  "이항 홀딩스 ADR": "EH",
  "이헬스": "EHTH",
  "익스트림 네트웍스": "EXTR",
  "익스팬드 에너지": "EXE",
  "익스페디터스 인터내셔널 오브 워싱턴": "EXPD",
  "익스펜시파이": "EXFY",
  "익스피디아그룹": "EXPE",
  "인8바이오": "INAB",
  "인그램 마이크로 홀딩": "INGM",
  "인그리디언": "INGR",
  "인노 홀딩스": "INHD",
  "인댑터스 테라퓨틱스": "INDP",
  "인더스트리얼 로지스틱스 프로퍼티": "ILPT",
  "인도네시아 에너지 코퍼레이션": "INDO",
  "인디 세미컨덕터": "INDI",
  "인디고 애퀴지션": "INAC",
  "인디비어 파마슈티컬스": "INDV",
  "인디아 글로벌리제이션 캐피털": "IGC",
  "인디펜던스 리얼티 트러스트": "IRT",
  "인디펜던트 뱅크": "IBCP",
  "인디펜던트 뱅크 (매사추세츠)": "INDB",
  "인라이븐 테라퓨틱스": "ELVN",
  "인리프": "INLF",
  "인메드 파마슈티컬스": "INM",
  "인모드": "INMD",
  "인뮨 바이오": "INMB",
  "인베스코": "IVZ",
  "인베스코 모기지 캐피털": "IVR",
  "인베스타 홀딩": "ISTR",
  "인베스터스 타이틀": "ITIC",
  "인베스트그린 애퀴지션": "IGAC",
  "인베스트코프 크레디트 매니지먼트": "ICMB",
  "인벤처": "INV",
  "인벤트러스트 프로퍼티스": "IVT",
  "인벤티바 ADR": "IVA",
  "인비비드": "IVVD",
  "인비테이션 홈스": "INVH",
  "인사이트": "INCY",
  "인사이트 디지털 파트너스 II": "DYOR",
  "인사이트 몰레큘러 다이어그노스틱스": "IMDX",
  "인사이트 엔터프라이지즈": "NSIT",
  "인슐릿": "PODD",
  "인스메드": "INSM",
  "인스위츠 호스피털리티 트러스트": "IHT",
  "인스톨드 빌딩 프로덕츠": "IBP",
  "인스틸 바이오": "TIL",
  "인스틸 인더스트리": "IIIN",
  "인스파이어 메디컬 시스템": "INSP",
  "인스파이어MD": "NSPR",
  "인스파이어드 엔터테인먼트": "INSE",
  "인스페리티": "NSP",
  "인시고": "INSG",
  "인액트 홀딩스": "ACT",
  "인제비티": "NGVT",
  "인카넥스 헬스케어": "IXHL",
  "인컴 오퍼튜니티 리얼티 인베스터스": "IOR",
  "인컴퍼스 헬스": "EHC",
  "인탭": "INTA",
  "인터 앤 코": "INTR",
  "인터그룹": "INTG",
  "인터내셔널 머니 익스프레스": "IMXI",
  "인터내셔널 뱅크셰어즈": "IBOC",
  "인터내셔널 제네럴 인슈런스 홀딩스": "IGIC",
  "인터내셔널 타워 힐 마인스": "THM",
  "인터내셔널 페이퍼": "IP",
  "인터내셔널 플레이버스 & 프레그런스": "IFF",
  "인터네셔널 시웨이스": "INSW",
  "인터디지털": "IDCC",
  "인터랙티브 브로커스 그룹": "IBKR",
  "인터랙티브 스트랭스": "TRNR",
  "인터링크 일렉트로닉스": "LINK",
  "인터컨티넨탈 호텔 그룹 ADR": "IHG",
  "인터컨티넨털 익스체인지": "ICE",
  "인터코프 파이낸셜 서비스": "IFS",
  "인터콘트": "NCT",
  "인터큐어": "INCR",
  "인터퍼퓸": "IPAR",
  "인터페이스": "TILE",
  "인터프라이빗 인베스트 파트너스V": "IPVV",
  "인테그라 라이프사이언시스 홀딩스": "IART",
  "인테그라 리소시즈": "ITRG",
  "인테그리스": "ENTG",
  "인테스트": "INTT",
  "인텐시티 테라퓨틱스": "INTS",
  "인텔": "INTC",
  "인텔리네틱스": "INLX",
  "인텔리아 테라퓨틱스": "NTLA",
  "인텔리전트 그룹": "INTJ",
  "인텔리전트 리빙 어플리케이션 그룹": "ILAG",
  "인텔리전트 바이오 솔루션스": "INBS",
  "인텔리전트 프로텍션 매니지먼트": "IPM",
  "인텔리체크": "IDN",
  "인튜이트": "INTU",
  "인튜이티브 머신스": "LUNR",
  "인튜이티브 서지컬": "ISRG",
  "인트레피드 포타시": "IPI",
  "인트루젼": "INTZ",
  "인트체인스 그룹 ADR": "ICG",
  "인티거 홀딩스": "ITGR",
  "인티그레이티드 미디어 테크놀로지": "IMTE",
  "인페이즈 에너지": "ENPH",
  "인포메이션 서비스 그룹": "III",
  "인포버드": "IFBD",
  "인포시스 ADR": "INFY",
  "인포인트 커머셜 리얼 에스테이트 인컴 우선주 시리즈 A 6.75%": "ICR-P-A",
  "인퓨시스템즈 홀딩스": "INFU",
  "인플락스": "IFRX",
  "인플렉션": "INFQ",
  "인플렉션 포인트 애퀴지션 III": "IPCX",
  "인플렉션 포인트 애퀴지션 V": "IPEX",
  "인플렉션 포인트 애퀴지션 VI": "IPFX",
  "인피니트 이글 애퀴지션": "IEAG",
  "인피니티 내추럴 리소시스": "INR",
  "인히브릭스 바이오사이언시스": "INBX",
  "인히비케이즈 테라퓨틱스": "IKT",
  "일라이 릴리": "LLY",
  "일렉트라 배터리 머티리얼스": "ELBM",
  "일렉트로메드": "ELMD",
  "일렉트로바야": "ELVA",
  "일렉트로코어": "ECOR",
  "일루미나": "ILMN",
  "일루미네이션 애퀴지션 I": "ILLU",
  "일리노이 툴 웍스": "ITW",
  "임브라에르 ADR": "EMBJ",
  "임팩트 바이오메디컬": "IBO",
  "임페리얼 오일": "IMO",
  "임페리얼 페트롤리엄": "IMPP",
  "임페리얼 페트롤리엄 우선주 시리즈 A 8.75%": "IMPPP",
  "임플로이어스 홀딩스": "EIG",
  "임핀지": "PI",
  "잉가솔랜드": "IR",
  "잉글스 마케츠": "IMKTA",
  "자나두 퀀텀 테크놀로지스": "XNDU",
  "자빌": "JBL",
  "자이 랩 ADR": "ZLAB",
  "자이로다인": "GYRO",
  "자이어 테라퓨틱스": "GYRE",
  "자이언스 뱅코프": "ZION",
  "자이언스 뱅코프 우선주 시리즈 A": "ZIONP",
  "자일럼": "XYL",
  "자일리오 테라퓨틱스": "XLO",
  "자임웍스": "ZYME",
  "재규어 우라늄": "JAGU",
  "재규어 헬스": "JAGX",
  "재넉스 테라퓨틱스": "JANX",
  "재스퍼 테라퓨틱스": "JSPR",
  "재즈 파마슈티컬스": "JAZZ",
  "재트 II 애퀴지션": "JATT",
  "잭 헨리 & 어소시에이츠": "JKHY",
  "잭스 퍼시픽": "JAKK",
  "잭슨 파이낸셜": "JXN",
  "쟈인 그룹 ADR": "JFIN",
  "저니 메디컬": "DERM",
  "저라쉬 홀딩스": "JRSH",
  "저먼 아메리칸 뱅코프": "GABC",
  "저지 마이크스 서브스": "JMKE",
  "전 엘케이 워터 솔루션스": "ZWS",
  "전지 교육 기술 그룹 ADR": "JZ",
  "정업 바이오테크놀로지 홀딩": "ZYBT",
  "제나 애퀴지션 II": "JENA",
  "제나스 바이오파마": "ZBIO",
  "제나시스": "GNSS",
  "제나테크": "ZENA",
  "제너럴 다이내믹스": "GD",
  "제너럴 모터스": "GM",
  "제너럴 밀즈": "GIS",
  "제너럴 캐탈리스트 글로벌": "GCGR",
  "제너럴 퍼포스 애퀴지션": "GPAC",
  "제너럴 퓨전 그룹": "GFUZ",
  "제너레이션 에센셜스 그룹": "TGE",
  "제너레이트 바이오메디슨스": "GENB",
  "제네락 홀딩스": "GNRC",
  "제네레이션 인컴 프로퍼티스": "GIPR",
  "제네룩스": "GNLX",
  "제네스코": "GCO",
  "제네틱 바이오사이언스": "XBIO",
  "제넨타 사이언스 ADR": "GNTA",
  "제논 파마슈티컬": "XENE",
  "제뉴인 파츠": "GPC",
  "제니아 호텔 & 리조트": "XHR",
  "제로스택": "ZSTK",
  "제록스 홀딩스": "XRX",
  "제론": "GERN",
  "제르다우 ADR": "GGB",
  "제리스 바이오파마 홀딩스": "XERS",
  "제미나이 스페이스 스테이션": "GEMI",
  "제보": "GEVO",
  "제브러 테라퓨틱스": "ZVRA",
  "제비아": "ZVIA",
  "제오 에너지": "ZEO",
  "제이디닷컴 ADR": "JD",
  "제이유드 글로벌 로지스틱스": "JYD",
  "제이질": "JILL",
  "제이콥스 솔루션스": "J",
  "제이프로그": "FROG",
  "제이피모간체이스": "JPM",
  "제임스 리버 그룹 홀딩스": "JRVR",
  "제타 글로벌 홀딩스": "ZETA",
  "제타 네트워크 그룹": "ZNB",
  "제퍼슨 캐피털": "JCAP",
  "제프리스 파이낸셜 그룹": "JEF",
  "젠 디지털": "GEN",
  "젠맵 ADR": "GMAB",
  "젠섬": "THRM",
  "젠워스 파이낸셜": "GNW",
  "젠코": "XNCR",
  "젠코 시핑 & 트레이딩": "GNK",
  "젠코 인더스트리스": "GENC",
  "젠타 그룹": "ZTG",
  "젠테일스 파마슈티컬": "ZNTL",
  "젠텍": "ZTEK",
  "젠텍스": "GNTX",
  "젠팩트": "G",
  "젠프렉스": "GNPX",
  "젤드-웬 홀딩": "JELD",
  "젤텍": "GELS",
  "젭 헬스 ADR": "ZEPP",
  "젯.AI": "JTAI",
  "젯지": "ZDGE",
  "조메트리": "XMTR",
  "조비 에비에이션": "JOBY",
  "조에티스": "ZTS",
  "조웰 글로벌": "JWEL",
  "조이 ADR": "JOYY",
  "조인트": "JYNT",
  "존 마샬 뱅코프": "JMSB",
  "존 윌리 앤 손 Class A": "WLY",
  "존 윌리 앤 손 Class B": "WLYB",
  "존스 랭 라살": "JLL",
  "존슨 아웃도어스": "JOUT",
  "존슨 컨트롤스 인터내셔널": "JCI",
  "존슨앤드존슨": "JNJ",
  "졸트 테라퓨틱스": "XRTX",
  "주라 바이오": "ZURA",
  "주롱 홀딩": "JLHL",
  "주미아 테크놀로지 AG ADR": "JMIA",
  "주미에즈": "ZUMZ",
  "주잇-캐머런 트레이딩": "JCTC",
  "주즈 스트래티지": "ZOOZ",
  "주피터 뉴로사이언시스": "JUNS",
  "줌 커뮤니케이션스": "ZM",
  "줌인포 테크놀로지스": "GTM",
  "중국 오토모티브 시스템": "CAAS",
  "중차오": "ZCMD",
  "중화 텔레콤 ADR": "CHT",
  "즈바오 테크놀로지": "ZBAO",
  "즈후 ADR": "ZH",
  "지니 에너지": "GNE",
  "지니어스 그룹": "GNS",
  "지니어스 스포츠": "GENI",
  "지보 홀딩스": "GIBO",
  "지브라 테크놀로지스": "ZBRA",
  "지브롤터 인더스트리스": "ROCK",
  "지스케일러": "ZS",
  "지아드": "JDZG",
  "지오 그룹": "GEO",
  "지오박스 랩스": "GOVX",
  "지오스페이스 테크놀로지스": "GEOS",
  "지오파크": "GPRK",
  "지용 바이오테크": "MENS",
  "지우지 홀딩스": "JZXN",
  "지프 데이비스": "ZD",
  "진 메디컬 인터내셔널": "ZJYL",
  "진디엑스 홀딩스": "WGS",
  "진신 테크놀로지 홀딩 ADR": "NAMI",
  "질단 액티브웨어": "GIL",
  "질로우 그룹 Class A": "ZG",
  "질로우 그룹 Class C": "Z",
  "짐머 바이오멧 홀딩스": "ZBH",
  "집리크루터": "ZIP",
  "징코솔라 홀딩스 ADR": "JKS",
  "차밍 메디컬": "MCTA",
  "차우차우 클라우드 인터내셔널 홀딩스": "CHOW",
  "차이나 SXT 파마슈티컬스": "SXTC",
  "차이나 내츄럴 리소스": "CHNR",
  "차이나 유차이 인터내셔널": "CYD",
  "차이나 파마 홀딩스": "CPHI",
  "차임 파이낸셜": "CHYM",
  "차지 홀딩스 ADR": "CHA",
  "차지포인트 홀딩스": "CHPT",
  "차코스 에너지 내비게이션": "TEN",
  "차터 커뮤니케이션": "CHTR",
  "찰스 리버 래보라토리스 인터내셔널": "CRL",
  "찰스 슈왑": "SCHW",
  "찰톤 아리아 애퀴지션": "CHAR",
  "채텀 로징 트러스트": "CLDT",
  "챔피언 홈스": "SKY",
  "챔피언스 온콜로지": "CSBR",
  "챔피언스게이트 애퀴지션": "CHPG",
  "처브": "CB",
  "처치 & 드와이트": "CHD",
  "처칠 다운스": "CHDN",
  "처칠 캐피탈 XII": "CXII",
  "처칠 캐피털 XI": "CCXI",
  "청허 애퀴지션 III": "CHEC",
  "체그": "CHGG",
  "체리힐 모기지 인베스트먼트": "CHMI",
  "체사피크 유틸리티스": "CPK",
  "체인 브리지 뱅코프": "CBNA",
  "체인스 디지털 홀딩스": "CD",
  "체인지 에이전츠": "CHGA",
  "체체 그룹": "CCG",
  "체크 포인트 소프트웨어 테크놀로지": "CHKP",
  "체크캡": "MBAI",
  "초이스 호텔스 인터내셔널": "CHH",
  "초이스원 파이낸셜 서비스": "COFS",
  "취훠": "QH",
  "츄이": "CHWY",
  "치어 홀딩": "CHR",
  "치즈케익 팩토리": "CAKE",
  "치타 넷 서플라이 체인 서비스": "CTNT",
  "치타 모바일 ADR": "CMCM",
  "치폴레 멕시칸 그릴": "CMG",
  "칠드런스 플레이스": "PLCE",
  "칩모스 테크놀로지스 ADR": "IMOS",
  "카구루스": "CARG",
  "카난 ADR": "CAN",
  "카니발": "CCL",
  "카단트": "KAI",
  "카델러 A/S ADR": "CDLR",
  "카들리틱스": "CDLX",
  "카디건": "KARD",
  "카디널 인프라스트럭처 그룹": "CDNL",
  "카디널 헬스": "CAH",
  "카디오 다이어그노스틱스": "CDIO",
  "카디올 테라퓨틱스": "CRDL",
  "카디즈": "CDZI",
  "카디즈 우선주 8.875%": "CDZIP",
  "카디프 온콜로지": "CRDF",
  "카랫 패키징": "KRT",
  "카료팜 테라퓨틱스": "KPTI",
  "카루": "KARO",
  "카르만 홀딩스": "KRMN",
  "카르테시안 테라퓨틱스": "RNAC",
  "카리부 바이오사이언시스": "CRBU",
  "카리스 라이프 사이언시스": "CAI",
  "카마다": "KMDA",
  "카맥스": "KMX",
  "카메코": "CCJ",
  "카바 그룹": "CAVA",
  "카바나": "CVNA",
  "카발레타 바이오": "CABA",
  "카본 캐피털 파트너스": "KBON",
  "카브코 인더스트리스": "CVCO",
  "카셀라 웨이스트 시스템즈": "CWST",
  "카스닷컴": "CARS",
  "카스텔럼": "CTM",
  "카스피.kz 우선주": "KSPI",
  "카오투 테크에듀 ADR": "GOTU",
  "카이로스 파르마": "KAPA",
  "카이론 리얼 에스테이트": "XRN",
  "카이버나 테라퓨틱스": "KYTX",
  "카이신 홀딩스": "KXIN",
  "카이저 알루미늄": "KALU",
  "카이트 리얼티 그룹 트러스트": "KRG",
  "카인드케어 러닝": "KLC",
  "카일레라 테라퓨틱스": "KLRA",
  "카지아 테라퓨틱스 ADR": "KZIA",
  "카탈리스트 뱅코프": "CLST",
  "카터 뱅크셰어스": "CARE",
  "카터스": "CRI",
  "카테터 프레시젼": "VTAK",
  "카툰 스튜디오스": "TOON",
  "카파츠닷컴": "PRTS",
  "카펜터 테크놀로지": "CRS",
  "카프리홀딩스": "CPRI",
  "칸네 홀딩스": "CNNE",
  "칸디 테크놀로지스 그룹": "KNDI",
  "칸준 ADR": "BZ",
  "칸토 에퀴티 파트너스 I": "CEPO",
  "칸토르 에퀴티 파트너스 V": "CEPV",
  "칸톤 스트래티직 홀딩스": "CNTN",
  "칼 레드우드 애퀴지션": "CRAQ",
  "칼 메인 푸즈": "CALM",
  "칼라 바이오": "KALA",
  "칼라리스 테라퓨틱스": "KLRS",
  "칼라일": "CSL",
  "칼라일 그룹": "CG",
  "칼라일 시큐어드 렌딩": "CGBD",
  "칼라일 크레딧 인컴 우선주 Series D 7.375%": "CCID",
  "칼레도니아 마이닝": "CMCL",
  "칼리디 바이오테라퓨틱스": "CLDI",
  "칼리사 애퀴지션": "ALIS",
  "칼스메드": "CARL",
  "칼투라": "KLTR",
  "캄스톡 리소시즈": "CRK",
  "캉고": "CANG",
  "캐나다 구스 홀딩스": "GOOS",
  "캐나다 내추럴 리소시스": "CNQ",
  "캐나디안 솔라": "CSIQ",
  "캐나디안 퍼시픽 캔자스 시티": "CP",
  "캐내디언 임페리얼 뱅크 오브 커머스": "CM",
  "캐노피 그로스": "CGC",
  "캐드리 홀딩스": "CDR-P-B",
  "캐리어 글로벌": "CARR",
  "캐리지 서비스": "CSV",
  "캐보트": "CBT",
  "캐세이 제너럴 뱅코프": "CATY",
  "캐스 인포메이션 시스템즈": "CASS",
  "캐스터 마리타임": "CTRM",
  "캐슬 바이오사이언스": "CSTL",
  "캐터펄트 홀딩스": "KPLT",
  "캐터필러": "CAT",
  "캐프리코 테라퓨틱스": "CAPR",
  "캐피탈 사우스웨스트": "CSWC",
  "캐피털 뱅코프": "CBNK",
  "캐피털 시티 뱅크 그룹": "CCBG",
  "캐피털 원 파이낸셜": "COF",
  "캐피털 클린 에너지 캐리어스": "CCEC",
  "캐피톨 페더럴 파이낸셜": "CFFN",
  "캑터스": "WHD",
  "캔 파이트 바이오파바 ADR": "CANF",
  "캔달 M 벤처": "FMFC",
  "캔델 테라퓨틱스": "CADL",
  "캔터 에쿼티 파트너스 IV": "CEPF",
  "캔터 에퀴티 파트너스 II": "SECZ",
  "캔터 에퀴티 파트너스 VII": "CAES",
  "캔터 에퀴티 파트너스 Vi": "CEPS",
  "캔터 우선주 Series A 9.50%": "CFTR-P-A",
  "캔터베리 파크 홀딩": "CPHC",
  "캔터키 퍼스트 페더럴 뱅코프": "KFFB",
  "캘러웨이 골프": "CALY",
  "캘리버코스": "CWD",
  "캘리포니아 리소시스": "CRC",
  "캘리포니아 뱅코프": "BCAL",
  "캘리포니아 워터 서비스 그룹": "CWT",
  "캘리포니아 은행": "BANC",
  "캘릭스": "CALX",
  "캘시메디카": "CALC",
  "캘프라이빗 뱅크": "PBAM",
  "캠던 내셔널": "CAC",
  "캠든 프로퍼티 트러스트": "CPT",
  "캠벨스": "CPB",
  "캠브리지 애퀴지션": "CAQ",
  "캠텍": "CAMT",
  "캠프4 테라퓨틱스": "CAMP",
  "캠핑 월드 홀딩스": "CWH",
  "캡소비전": "CV",
  "캡스톤 에너지+": "CEPL",
  "캡스톤 홀딩": "CAPS",
  "커네디언 내셔널 레일웨이": "CNI",
  "커넥트원 뱅코프": "CNOB",
  "커넥트원 뱅코프 우선주 시리즈 A 5.25%": "CNOBP",
  "커니 파이낸셜": "KRNY",
  "커드리널 테라퓨틱스": "CVKD",
  "커렌크 그룹": "CURR",
  "커머셜 메탈스": "CMC",
  "커머셜 뱅크그룹": "CBK",
  "커머셜 비히클 그룹": "CVGI",
  "커머스 뱅크셰어스": "CBSH",
  "커머스닷컴 Series 1": "CMRC",
  "커뮤니티 뱅코프": "CMTV",
  "커뮤니티 웨스트 뱅크셰어스": "CWBC",
  "커뮤니티 트러스트 뱅코프": "CTBI",
  "커뮤니티 파이낸셜 시스템": "CBU",
  "커뮤니티 헬스 시스템즈": "CYH",
  "커뮤니티 헬스케어 트러스트": "CHCT",
  "커민스": "CMI",
  "커브라인 프로퍼티스": "CURB",
  "커비": "KEX",
  "커세어 게이밍": "CRSR",
  "커스터머스 뱅코프": "CUBI",
  "커스텀 엔터테인먼트": "KUST",
  "커스텀 트럭 원 소스": "CTOS",
  "커즌스 프로퍼티스": "CUZ",
  "커티스 라이트": "CW",
  "커프리나 홀딩스 (Cayman)": "CUPR",
  "커피 홀딩": "JVA",
  "컨듀언트": "CNDT",
  "컨슈머 포트폴리오 서비스": "CPSS",
  "컨스텔레이션 브랜즈": "STZ",
  "컨스트럭션 파트너스": "ROAD",
  "컬런/프로스트 뱅커스": "CFR",
  "컬럼버스 매키넌": "CMCO",
  "컬럼비아 뱅킹 시스템": "COLB",
  "컬럼비아 스포츠웨어": "COLM",
  "컬레러스": "CAL",
  "컬리넌 테라퓨틱스": "CGEM",
  "컬프": "CULP",
  "컴벌랜드 파마슈티컬스": "CPIX",
  "컴볼트 시스템즈": "CVLT",
  "컴스코어": "SCOR",
  "컴스톡 홀딩": "CHCI",
  "컴캐스트": "CMCSA",
  "컴캐스트 홀딩스 후순위 채권 2% 만기 2029년 10월": "CCZ",
  "컴테크 텔레커뮤니케이션스": "CMTL",
  "컴퍼스": "COMP",
  "컴퍼스 다이버시파이드 홀딩스": "CODI",
  "컴퍼스 미네랄스 인터내셔널": "CMP",
  "컴퍼스 테라퓨틱스": "CMPX",
  "컴퍼스패스웨이스 ADR": "CMPS",
  "컴포트 시스템즈 USA": "FIX",
  "컴퓨젠": "CGEN",
  "케논 홀딩스": "KEN",
  "케로스 테라퓨틱스": "KROS",
  "케무어스": "CC",
  "케미드": "CHE",
  "케스트라 메디컬 테크놀로지스": "KMTS",
  "케스트렐 그룹": "KG",
  "케어 클라우드": "CCLD",
  "케어Dx": "CDNA",
  "케어링 브랜즈": "CABR",
  "케어트러스트 리츠 (REIT)": "CTRE",
  "케이던스 디자인 시스템즈": "CDNS",
  "케이블 원": "CABO",
  "케이슨 애퀴지션": "CAPN",
  "케이시스 제너럴 스토어스": "CASY",
  "케이토": "CATO",
  "케이펫 울트라 페이스라인": "KPET",
  "케인 앤더슨": "KBDC",
  "켄나메탈": "KMT",
  "켄뷰": "KVUE",
  "켈리 서비스 Class A": "KELYA",
  "켈리 서비스 Class B": "KELYB",
  "켐퍼": "KMPR",
  "코 다이어그노틱스": "CODX",
  "코그나이트 소프트웨어": "CGNT",
  "코그넥스": "CGNX",
  "코그니션 테라퓨틱스": "CGTX",
  "코그니전트 테크놀로지 솔루션": "CTSH",
  "코넥스유 사이언시스": "CNXU",
  "코노코필립스": "COP",
  "코닛 디지털": "KRNT",
  "코닝": "GLW",
  "코닝클레이커 필립스 ADR": "PHG",
  "코다 옥토퍼스 그룹": "CODA",
  "코더 온라인 룩셈부르크": "CDRO",
  "코덱시스": "CDXS",
  "코드 에너지": "CHRD",
  "코디악 AI": "KDK",
  "코디악 가스 서비시스": "KGS",
  "코디악 사이언스": "KOD",
  "코로 바이오": "KRRO",
  "코루 메디컬 시스템스": "KRMD",
  "코르테바": "CTVA",
  "코메딕스": "CRMD",
  "코버넌트 로지스틱스 그룹": "CVLG",
  "코버스 파마슈티컬스": "CRVS",
  "코버스 파마슈티컬스 홀딩스": "CRBP",
  "코벨": "CRVL",
  "코보": "QRVO",
  "코비스타": "CVSA",
  "코샌 ADR": "CSAN",
  "코세라": "COUR",
  "코셉트 테라퓨틱스": "CORT",
  "코스": "KOSS",
  "코스모스 에너지": "KOS",
  "코스모스 헬스": "COSM",
  "코스타 그룹": "CSGP",
  "코스타마레": "CMRE",
  "코스타마레 벌커스 홀딩스": "CMDB",
  "코스탈 파이낸셜": "CCB",
  "코스탈사우스 뱅크셰어스": "COSO",
  "코스트코 홀세일": "COST",
  "코야 테라퓨틱스": "COYA",
  "코어 & 메인": "CNM",
  "코어 AI 홀딩스": "CHAI",
  "코어 내추럴 리소시스": "CNR",
  "코어 래보라토리스": "CLB",
  "코어 몰딩 테크놀로지스": "CMT",
  "코어 사이언티픽": "CORZ",
  "코어브릿지 파이낸셜": "CRBG",
  "코어시빅": "CXW",
  "코어위브": "CRWV",
  "코인 파마슈티컬스 ADR": "QNRX",
  "코인베이스 글로벌": "COIN",
  "코인셰어스": "CSHR",
  "코인체크 그룹": "CNCK",
  "코젠트 바이오사이언시스": "COGT",
  "코젠트 커뮤니케이션스 홀딩스": "CCOI",
  "코채브 디펜스 애퀴지션": "KCHV",
  "코카-콜라 유로퍼시픽 파트너스": "CCEP",
  "코카콜라": "KO",
  "코카콜라 콘솔리데이티드": "COKE",
  "코카콜라 펨사 ADR": "KOF",
  "코크리스털 파마": "COCP",
  "코티": "COTY",
  "코파 홀딩스": "CPA",
  "코파트": "CPRT",
  "코퍼래시온 어메리카 에어포츠": "CAAP",
  "코퍼스 홀딩스": "KOP",
  "코플리 애퀴지션": "COPL",
  "코핀": "KOPN",
  "코헨 & 스티어스": "CNS",
  "코헨 서클 애퀴지션 II": "CCII",
  "코헨 앤 컴퍼니": "COHN",
  "코후": "COHU",
  "코히러스 온콜로지": "CHRS",
  "코히런트": "COHR",
  "콘 페리": "KFY",
  "콘메드": "CNMD",
  "콘센서스 클라우드 솔루션스": "CCSI",
  "콘센트라 그룹 홀딩스": "CON",
  "콘센트릭스": "CNXC",
  "콘솔리데이티드 에디슨": "ED",
  "콘솔리데이티드 워터": "CWCO",
  "콘스텔레이션 에너지": "CEG",
  "콘스텔리움": "CSTM",
  "콘아그라 브랜즈": "CAG",
  "콘크리트 펌핑 홀딩스": "BBCP",
  "콘탱고 실버 앤 골드": "CTGO",
  "콘텍스트 테라퓨틱스": "CNTX",
  "콘투어 브랜즈": "KTB",
  "콘트롤라도라 부엘라 콤파니아 아비아시온 ADR": "VLRS",
  "콘티네움 테라퓨틱스": "CTNM",
  "콜게이트-팜올리브": "CL",
  "콜럼버스 서클 캐피털 II": "CMII",
  "콜레지움 파마슈티컬": "COLL",
  "콜렉티브 마이닝": "CNL",
  "콜렉티브 애퀴지션": "CCAQ",
  "콜렉티브 애퀴지션 II": "CAII",
  "콜로니 뱅코프": "CBAN",
  "콜롬버스 애퀴지션": "COLA",
  "콜롬비아 파이낸셜": "CLBK",
  "콜롬비어 애퀴지션 III": "CLBR",
  "콜리브리 글로벌 에너지": "KGEI",
  "콜리어스 인터내셔널 그룹": "CIGI",
  "콜스": "KSS",
  "콜페이": "CPAY",
  "콤스톡": "LODE",
  "콤파니아 데 사네아멘투 바지쿠 상파울루 - SABESP": "SBS",
  "콤파니아 시데루르지카 나시오나우 ADR": "SID",
  "콩코드 메디컬 서비스 홀딩스 ADR": "CCM",
  "콩코드 인터내셔널 그룹": "CIGL",
  "콰넥스 빌딩 프로덕츠": "NX",
  "콴타 서비스": "PWR",
  "쾨르 마이닝": "CDE",
  "쿠라 스시 USA": "KRUS",
  "쿠라 온콜로지": "KURA",
  "쿠쉬맨 앤 웨이크필드": "CWK",
  "쿠팡": "CPNG",
  "쿠퍼 컴퍼니스": "COO",
  "쿠퍼-스탠더드 홀딩스": "CPS",
  "쿨리크 & 소파 인더스트리스": "KLIC",
  "쿼드/그래픽스": "QUAD",
  "쿼츠씨 애퀴지션": "QSEA",
  "퀀텀": "QMCO",
  "퀀텀 X 랩스": "QXL",
  "퀀텀 리프 애퀴지션": "QLEP",
  "퀀텀 바이오파마": "QNTM",
  "퀀텀 사이버": "QUCY",
  "퀀텀 이모션": "QNC",
  "퀀텀 컴퓨팅": "QUBT",
  "퀀텀-Si": "QSI",
  "퀀텀스케이프": "QS",
  "퀀텀스피어 애퀴지션": "QUMS",
  "퀀테릭스": "QTRX",
  "퀀티넘": "QNT",
  "퀄리스": "QLYS",
  "퀄컴": "QCOM",
  "퀘사에지 애퀴지션": "QRED",
  "퀘스트 다이아그노스틱스": "DGX",
  "퀘스트 리소스 홀딩": "QRHC",
  "퀘이커 케미컬": "KWR",
  "퀘타 애퀴지션": "QETA",
  "퀴델오쏘": "QDEL",
  "퀴아젠": "QGEN",
  "퀵로직": "QUIK",
  "퀸스 테라퓨틱스": "QNCX",
  "퀸스트리트": "QNST",
  "큐 바이오파마": "CUE",
  "큐니티 일렉트로닉스": "Q",
  "큐라넥스 파마슈티컬스": "CURX",
  "큐리그 닥터 페퍼": "KDP",
  "큐리스": "CRIS",
  "큐리어시티스트림": "CURI",
  "큐뮬러스AI": "QMLS",
  "큐브스마트": "CUBE",
  "큐트렉스 퀀텀": "QTEX",
  "큐핀 홀딩스 ADR": "QFIN",
  "크노렉스": "KNRX",
  "크라우드 스트라이크 홀딩스": "CRWD",
  "크라운 리저브 애퀴지션 I": "CRAC",
  "크라운 캐슬": "CCI",
  "크라운 크래프츠": "CRWS",
  "크라운 홀딩스": "CCK",
  "크라이오-셀 인터내셔널": "CCEL",
  "크라이오포트": "CYRX",
  "크라토스 디펜스 & 시큐리티 솔": "KTOS",
  "크래커 배럴 올드 컨트리 스토어": "CBRL",
  "크래프트 하인즈": "KHC",
  "크레도 테크놀로지 그룹 홀딩": "CRDO",
  "크레디코프": "BAP",
  "크레디트 억셉턴스": "CACC",
  "크레딧인핸스드 코츠 트러스트 우선주 8.2050%": "KTN",
  "크레센트 바이오파마": "CBIO",
  "크레센트 에너지": "CRGY",
  "크레센트 캐피탈 BDC": "CCAP",
  "크레수드 ADR": "CRESY",
  "크레인 NXT": "CXT",
  "크레인 하버 애퀴지션 II": "CRAN",
  "크레인 홀딩스": "CR",
  "크렉센도": "CXDO",
  "크로거": "KR",
  "크로노스 그룹": "CRON",
  "크로노스 월드와이드": "KRO",
  "크로노스케일": "CHRN",
  "크로락스": "CLX",
  "크록스": "CROX",
  "크리네틱스 파머슈티컬스": "CRNX",
  "크리스탈 바이오텍": "KRYS",
  "크리스퍼 테라퓨틱스": "CRSP",
  "크리스피 크림": "DNUT",
  "크리에이티브 글로벌 테크놀로지 홀딩스": "CGTL",
  "크리에이티브 리얼리티스": "CREX",
  "크리에이티브 메디컬 테크놀로지 홀딩스": "CELZ",
  "크리에이티브 미디어 & 커뮤니티 트러스트": "CMCT",
  "크리컷": "CRCT",
  "크리테오": "CRTO",
  "크리티컬 메탈스": "CRML",
  "클라나 그룹": "KLAR",
  "클라로스 모기지 트러스트": "CMTG",
  "클라루스": "CLAR",
  "클라리텝": "CTEV",
  "클라비요": "KVYO",
  "클라우다스트럭쳐": "CSAI",
  "클라우드플레어": "NET",
  "클라임 글로벌 솔루션스": "CLMB",
  "클라임 바이오": "CLYM",
  "클래리베이트": "CLVT",
  "클렌": "CLNN",
  "클로버 헬스 인베스트먼츠": "CLOV",
  "클리누벨 파마슈티컬스 ADR": "CUVL",
  "클리블랜드-클리프스": "CLF",
  "클리어 시큐어": "YOU",
  "클리어 채널 아웃도어 홀딩스": "CCO",
  "클리어마인드 메디슨": "CMND",
  "클리어사인 테크놀로지스": "CLIR",
  "클리어씽크 1 애퀴지션": "CTAA",
  "클리어원": "CLRO",
  "클리어웨이 에너지 Class C": "CWEN",
  "클리어포인트 뉴로": "CLPT",
  "클리어필드": "CLFD",
  "클리퍼 리얼티": "CLPR",
  "클릭 홀딩스": "CLIK",
  "클린 에너지 테크놀로지스": "CETY",
  "클린 에너지 퓨얼스": "CLNE",
  "클린 하버스": "CLH",
  "클린스파크": "CLSK",
  "클린워터 페이퍼": "CLW",
  "클린코어 솔루션스": "ZONE",
  "키 트로닉": "KTCC",
  "키네틱 홀딩스": "KNTK",
  "키닉사 파마슈티컬스 인터내셔널": "KNSA",
  "키메라 인베스트먼트": "CIM",
  "키메라 테라퓨틱스": "KYMR",
  "키모맵 테라퓨틱스 ADR": "CMMB",
  "키사이트 테크놀로지스": "KEYS",
  "키스톤 애퀴지션": "KEYY",
  "키오라 파마슈티컬스": "KPRX",
  "키와우니 사이언티픽": "KEQU",
  "키이우스타 그룹": "KYIV",
  "키코프": "KEY",
  "킨더 모건": "KMI",
  "킨드릴 홀딩스": "KD",
  "킨로스 골드": "KGC",
  "킨세일 캐피털 그룹": "KNSL",
  "킨트라 바이오": "KYNB",
  "킬 인프라스트럭처": "KEEL",
  "킬로이 리얼티": "KRC",
  "킴벌리클라크": "KMB",
  "킴볼 일렉트로닉스": "KE",
  "킴코 리얼티": "KIM",
  "킹소프트 클라우드 홀딩스 ADR": "KC",
  "킹스웨이": "KWY",
  "킹스톤 컴퍼니": "KINS",
  "타겟": "TGT",
  "타겟 호스피탈리티": "TH",
  "타르가 리소스": "TRGP",
  "타불라": "TBLA",
  "타비아 애퀴지션": "TAVI",
  "타서스 파마슈티컬스": "TARS",
  "타오위브": "TWAV",
  "타오핑": "TAOP",
  "타운뱅크": "TOWN",
  "타운스퀘어 미디어": "TSQ",
  "타워 세미컨덕터": "TSEM",
  "타이드워터": "TDW",
  "타이라 바이오사이언시스": "TYRA",
  "타이샤 젠 테라피": "TSHA",
  "타이슨 푸드": "TSN",
  "타이탄 마이닝": "TII",
  "타이탄 머시너리": "TITN",
  "타이탄 아메리카": "TTAM",
  "타이탄 애퀴지션": "TACH",
  "타이탄 인터내셔널": "TWI",
  "타일러 테크놀로지스": "TYL",
  "탄자니아 골드": "TRX",
  "탄테크 홀딩스": "TANH",
  "탈렌 에너지": "TLN",
  "탈로스 에너지": "TALO",
  "탈론 캐피털": "TLNC",
  "탈페라": "TLPH",
  "탑 십스": "TOPS",
  "탑 웰스 그룹 홀딩": "TWG",
  "탑 킹윈": "DPU",
  "탑 파이낸셜 그룹": "TOP",
  "탑포인트 홀딩스": "TOPP",
  "태스크어스": "TASK",
  "태피스트리": "TPR",
  "택타일 시스템 테크놀로지": "TCMD",
  "탠덤 다이어비츠 케어": "TNDM",
  "탠디 레더 팩토리": "TLF",
  "탬보란 리소시스": "TBN",
  "탱고 테라퓨틱스": "TNGX",
  "터닝 포인트 브랜드": "TPB",
  "터보 에너지 ADR": "TURB",
  "터틀 비치": "TBCH",
  "턴 테라퓨틱스": "TTRX",
  "턴그레이 테크놀로지스": "TRSG",
  "테나리스 ADR": "TS",
  "테나야 테라퓨틱스": "TNYA",
  "테낙스 테라퓨틱스": "TENX",
  "테너블 홀딩스": "TENB",
  "테넌트": "TNC",
  "테네시 밸리 오쏘리티 선순위 채권 시리즈 A 만기 2029년": "TVE",
  "테네시 밸리 오쏘리티 선순위 채권 시리즈 D 만기 2028년": "TVC",
  "테넷 헬스케어": "THC",
  "테논 메디컬": "TNON",
  "테라 이노바툼 글로벌": "NKLR",
  "테라다인": "TER",
  "테라데이타": "TDC",
  "테라반스 바이오파마": "TBPH",
  "테라울프": "WULF",
  "테라퓨틱스MD": "TXMD",
  "테레노 리얼티": "TRNO",
  "테레스트리얼 에너지": "IMSR",
  "테렉스": "TEX",
  "테르니움 ADR": "TX",
  "테리바 바이오로직스": "TOVX",
  "테바 파마슈티컬 인더스트리 ADR": "TEVA",
  "테슬라": "TSLA",
  "테이크-투 인터랙티브 소프트웨어": "TTWO",
  "테일러 디바이시스": "TAYD",
  "테일윈드 2.0 애퀴지션": "TDWD",
  "테코젠": "TGEN",
  "테크노글래스 홀딩스": "TGLS",
  "테크닙FMC": "FTI",
  "테크타겟": "TTGT",
  "테크프레시젼": "TPCS",
  "테트라 테크": "TTEK",
  "테트라 테크놀로지스": "TTI",
  "테혼 랜치": "TRC",
  "텍 리소스": "TECK",
  "텍사스 로드하우스": "TXRH",
  "텍사스 벤처스 애퀴지션 III": "TVA",
  "텍사스 벤처스 애퀴지션 IV": "TVIV",
  "텍사스 인스트루먼트": "TXN",
  "텍사스 캐피털 뱅크셰어스": "TCBI",
  "텍사스 캐피털 뱅크셰어스 우선주 Series B 5.75%": "TCBIO",
  "텍사스 커뮤니티 뱅크셰어": "TCBS",
  "텍사스 퍼시픽 랜드": "TPL",
  "텍손 홀딩": "NPT",
  "텍스트론": "TXT",
  "텍토닉 테라퓨틱": "TECX",
  "텐리그 인터내셔널 홀딩스": "TLIH",
  "텐센트뮤직엔터테인먼트그룹 ADR": "TME",
  "텐저": "SKT",
  "텔라 바이오": "TELA",
  "텔라닥 헬스": "TDOC",
  "텔러스": "TU",
  "텔레다인 테크놀로지스": "TDY",
  "텔레샛": "TSAT",
  "텔레콤 아르헨티나 ADR": "TEO",
  "텔레포니카 브라질 ADR": "VIV",
  "텔레폰 앤 데이터 시스템즈": "TDS",
  "텔레폰악티에볼라예트 에릭슨 ADR": "ERIC",
  "텔레플렉스": "TFX",
  "텔로미르 파마슈티컬스": "TELO",
  "텔로스": "TLS",
  "텔릭스 파마슈티컬스 ADR": "TLX",
  "텔콤 인도네시아 ADR": "TLK",
  "템퍼스 AI": "TEM",
  "템피스트 테라퓨틱스": "TPST",
  "토닉스 파마슈티컬스 홀딩": "TNXP",
  "토로": "TORO",
  "토론토 도미니언 은행": "TD",
  "토리드 홀딩스": "CURV",
  "토미 인바이런먼털 솔루션스": "TOMZ",
  "토스트": "TOST",
  "토요": "TOYO",
  "토요타자동차 ADR": "TM",
  "토크스페이스": "TALK",
  "토큰 캣 ADR": "TC",
  "토탈에너지스": "TTE",
  "톤 스트래티지": "TONX",
  "톨 브라더스": "TOL",
  "톰": "TRMD",
  "톰슨 로이터": "TRI",
  "톰킨스 파이낸셜": "TMP",
  "투 하버스 인베스트먼트": "TWO",
  "투뉴 ADR": "TOUR",
  "투르크젤 을레티심 히즈메틀레리 ADR": "TKC",
  "투시 롤 인더스트리스": "TR",
  "투야 ADR": "TUYA",
  "투카우스": "TCX",
  "투후라 바이오사이언스": "HURA",
  "튜터 페리니": "TPC",
  "트라이넷 그룹": "TNET",
  "트라이던트 디지털 테크 홀딩스": "TDTH",
  "트라이베카 스트래티직 애퀴지션": "BID",
  "트라이엄프 파이낸셜": "TFIN",
  "트라이코 뱅크셰어스": "TCBK",
  "트라이턴 인터내셔널 우선주 시리즈 C 7.375%": "TRTN-P-A",
  "트라이하드 홀딩스": "THH",
  "트래버 테라퓨틱스": "TVTX",
  "트래블 앤 레저": "TNL",
  "트래블러스 컴퍼니스": "TRV",
  "트래블주": "TZOO",
  "트래저": "COOK",
  "트랙터 서플라이": "TSCO",
  "트랜스다임 그룹": "TDG",
  "트랜스레이셔널 디벨롭먼트 애퀴지션": "TDAC",
  "트랜스메딕스 그룹": "TMDX",
  "트랜스알타": "TAC",
  "트랜스액트 테크놀로지스": "TACT",
  "트랜스오션": "RIG",
  "트랜스유니온": "TRU",
  "트랜스캣": "TRNS",
  "트랜스컨티넨탈 리얼티 인베스터": "TCI",
  "트랜스코드 테라퓨틱스": "RNAZ",
  "트러스트마크": "TRMK",
  "트러스트코 은행 N Y": "TRST",
  "트럼프 미디어 & 테크놀로지 그룹": "DJT",
  "트레데가": "TG",
  "트레비 테라퓨틱스": "TRVI",
  "트레이드 데스크": "TTD",
  "트레이드웹 마켓": "TW",
  "트레인 테크놀로지": "TT",
  "트레일블래이저 애퀴지션": "BLZR",
  "트레저 글로벌": "TGL",
  "트레코 메탈스": "TGB",
  "트렉스": "TREX",
  "트로녹스 홀딩스": "TROX",
  "트로스 파르마": "TRAW",
  "트루골프 홀딩스": "TRUG",
  "트루블루": "TBI",
  "트루이스트 파이낸셜": "TFC",
  "트루패니언": "TRUP",
  "트룰리브 캐나비스": "TRLV",
  "트룹스": "TROO",
  "트리니티 바이오테크 ADR": "TRIB",
  "트리니티 인더스트리스": "TRN",
  "트리니티 캐피탈": "TRIN",
  "트리마스": "TRS",
  "트리바고 ADR": "TRVG",
  "트리스 메디컬 컨셉트": "TMCI",
  "트리오 테크 인터내셔널": "TRT",
  "트리오 퍼트롤리엄": "TPET",
  "트리플 플래그 프레셔스 메탈스": "TFPM",
  "트리플포인트 벤처 그로스 BDC": "TPVG",
  "트릴러 그룹": "ILLR",
  "트릴로지 메탈": "TMQ",
  "트림블": "TRMB",
  "트립닷컴 그룹 ADR": "TCOM",
  "트립어드바이저": "TRIP",
  "트웬티 원 캐피털": "XXI",
  "트웰브 시즈 인베스트먼트 컴퍼니 III": "TWLV",
  "트위스트 바이오사이언스": "TWST",
  "트윈 디스크": "TWIN",
  "트윈 비 파워캣츠": "VEEE",
  "트윌리오": "TWLO",
  "티 로웨 프라이스 그룹": "TROW",
  "티 스탬프": "IDAI",
  "티고 에너지": "TYGO",
  "티발디 테라퓨틱스": "TVRD",
  "티보젠": "TVGN",
  "티빅 헬스 시스템스": "VBIO",
  "티안시 인터내셔널": "CIIT",
  "티즈 홀딩": "TEAD",
  "티케이": "TK",
  "티케이 탱커스": "TNK",
  "틸레이 브랜즈": "TLRY",
  "틸리스": "TLYS",
  "팀": "TISI",
  "팀 ADR": "TIMB",
  "팀버랜드 뱅코프": "TSBK",
  "팀셰어스": "TMS",
  "팀켄": "TKR",
  "팁트리": "TIPT",
  "파 퍼시픽 홀딩스": "PARR",
  "파가야 테크놀로지스": "PGY",
  "파그세구로 디지털": "PAGS",
  "파라노부스 엔터테인먼트 테크놀로지": "PAVS",
  "파라마운트 골드 네바다": "PZG",
  "파라마운트 스카이댄스": "PSKY",
  "파라빌리스 메디슨스": "PBLS",
  "파라제로 테크놀로지스": "PRZO",
  "파렐라 와인버그 파트너스": "PWP",
  "파르미": "FAMI",
  "파마사이트 바이오테크": "PMCB",
  "파머 스퀘어 캐피털 BDC": "PSBD",
  "파머스 & 머천츠 뱅코프": "FMAO",
  "파머스 내셔널 은행": "FMNB",
  "파밍 그룹 ADR": "PHAR",
  "파바비스 NV": "PHVS",
  "파브메드": "PAVM",
  "파슨스": "PSN",
  "파슬 그룹": "FOSL",
  "파시라 바이오사이언스": "PCRX",
  "파시테아 테라퓨틱스": "KTTA",
  "파에스 테라퓨틱스": "FTH",
  "파오스 테크놀로지 홀딩스": "POAS",
  "파운더 그룹": "FGL",
  "파워 리츠": "PW",
  "파워 솔루션스 인터내셔널": "PSIX",
  "파워 인티그레이션": "POWI",
  "파워로10": "PWRL",
  "파워뱅크": "PBK",
  "파워컴퓨트": "PWCM",
  "파워플리트": "AIOT",
  "파월 인더스트리스": "POWL",
  "파웰 맥스": "PMAX",
  "파이낸셜 인스티튜션스": "FISI",
  "파이낸스 오브 아메리카 컴퍼니스": "FOA",
  "파이더스 인베스트먼트": "FDUS",
  "파이로파이트 애퀴지션 II": "PAII",
  "파이버 인터내셔널": "FVRR",
  "파이브 빌로우": "FIVE",
  "파이브 스타 뱅코프": "FSBC",
  "파이브 포인트 홀딩스": "FPH",
  "파이브나인": "FIVN",
  "파이브로바이올로직스": "FBLG",
  "파이서브": "FISV",
  "파이어니어 애퀴지션 I": "PACH",
  "파이어니어 파워 솔루션스": "PPSI",
  "파이어리": "FIRY",
  "파이어플라이 뉴로사이언스": "AIFF",
  "파이어플라이 에어로스페이스": "FLY",
  "파이오니아 뱅코프": "PBFS",
  "파이퍼 샌들러 컴퍼니스": "PIPR",
  "파인애플 파이낸셜": "PAPL",
  "파카": "PCAR",
  "파커-하니핀": "PH",
  "파크 내셔널": "PRK",
  "파크 덴탈 파트너스": "PARK",
  "파크 뱅코프": "PKBK",
  "파크 에어로스페이스": "PKE",
  "파크 하 바이오테크": "BYAH",
  "파크 호텔 & 리조트": "PK",
  "파크-오하이오 홀딩스": "PKOH",
  "파트리아 인베스트먼트": "PAX",
  "파파 존스 인터내셔널": "PZZA",
  "파퓰러": "BPOP",
  "파퓰러 캐피탈 트러스트 II 우선주 6.125%": "BPOPM",
  "팔라다인 AI": "PDYN",
  "팔라틴 테크놀로지스": "PTN",
  "팔란티어 테크놀로지스": "PLTR",
  "팔로 알토 네트웍스": "PANW",
  "팔로마 애퀴지션 I": "PALO",
  "팔로마 홀딩스": "PLMR",
  "팔리사드 바이오": "PALI",
  "팔벨라 테라퓨틱스": "PVLA",
  "팔콘스 비욘드 글로벌": "FBYD",
  "팔콘스 비욘드 우선주 Series B": "FBYDP",
  "팜랜드 파트너스": "FPI",
  "팝 컬처 그룹": "CPOP",
  "팡게아 로지스틱스 솔루션스": "PANL",
  "패러데이 퓨처 인텔리전트 일렉트릭": "FFAI",
  "패브리넷": "FN",
  "패브릭 AI": "FABC",
  "패섬 홀딩스": "FTHM",
  "패스널": "FAST",
  "패스워드 파이낸셜": "CASH",
  "패스트 트랙 엔터테인먼트": "FTRK",
  "패스틀리": "FSLY",
  "패시지 바이오": "PASG",
  "패썸 파마슈티컬스": "PHAT",
  "패키징 코퍼레이션 오브 아메리카": "PKG",
  "패터슨-UTI 에너지": "PTEN",
  "패턴 그룹": "PTRN",
  "패트리엇 내셔널 뱅코프": "PNBK",
  "패트리엇 애퀴지션": "PTAC",
  "패트릭 인더스트리스": "PATK",
  "패트파인더 뱅코프": "PBHC",
  "팩스 그룹": "PACS",
  "팩토리얼 에너지": "FAC",
  "팩트 II 애퀴지션": "FACT",
  "팩트셋 리서치 시스템즈": "FDS",
  "팬 아메리카 실버": "PAAS",
  "팬티지스 캐피털 애퀴지션": "PGAC",
  "팻파이프": "FATN",
  "퍼거슨 엔터프라이즈": "FERG",
  "퍼도세오 에듀케이션": "PRDO",
  "퍼마-파이프 인터내셔널 홀딩스": "PPIH",
  "퍼마-픽스 인바이런먼털 서비스": "PESI",
  "퍼보 에너지": "FRVO",
  "퍼브매틱": "PUBM",
  "퍼블릭 서비스 엔터프라이즈": "PEG",
  "퍼블릭 스토리지": "PSA",
  "퍼블릭 폴리시 홀딩 컴퍼니": "PPHC",
  "퍼셉티브 캐피털 솔루션스": "FRNM",
  "퍼슈트 어트랙션스 앤 호스피탈리티": "PRSU",
  "퍼스날리스": "PSNL",
  "퍼스트 US 뱅크셰어스": "FUSB",
  "퍼스트 개런티 뱅그셰어스 우선주 시리즈 A 6.75%": "FGBIP",
  "퍼스트 개런티 뱅크셰어스": "FGBI",
  "퍼스트 내셔널": "FXNC",
  "퍼스트 노던 커뮤니티 뱅코프": "FNRN",
  "퍼스트 노스웨스트 뱅코프": "FNWB",
  "퍼스트 머제스틱 실버": "AG",
  "퍼스트 머천츠": "FRME",
  "퍼스트 머천트": "FRMEP",
  "퍼스트 뱅코프": "FNLC",
  "퍼스트 뱅코프 푸에르토 리코": "FBP",
  "퍼스트 뱅코프(노스 캐롤라이나)": "FBNC",
  "퍼스트 뱅크": "FRBA",
  "퍼스트 뷰지": "BUSE",
  "퍼스트 뷰지 우선주 Series B 8.25%": "BUSEP",
  "퍼스트 비즈니스 파이낸셜 서비스": "FBIZ",
  "퍼스트 소스": "SRCE",
  "퍼스트 솔라": "FSLR",
  "퍼스트 시코스트 뱅코프": "FSEA",
  "퍼스트 시티즌스 뱅크셰어스": "FCNCA",
  "퍼스트 시티즌스 뱅크셰어스 우선주 시리즈 A 5.375%": "FCNCP",
  "퍼스트 시티즌스 뱅크셰어스 우선주 시리즈 C 5.625%": "FCNCO",
  "퍼스트 시티즌스 우선주 Series E": "FCNCN",
  "퍼스트 아메리칸 파이낸셜": "FAF",
  "퍼스트 어드밴티지": "FA",
  "퍼스트 와치 레스토랑 그룹": "FWRG",
  "퍼스트 웨스턴 파이낸셜": "MYFW",
  "퍼스트 유나이티드": "FUNC",
  "퍼스트 인더스트리얼 리얼티 트러스트": "FR",
  "퍼스트 인터넷 뱅코프": "INBK",
  "퍼스트 인터스테이트 뱅크시스템": "FIBK",
  "퍼스트 캐롤리나 파이낸셜 서비스": "FCBM",
  "퍼스트 캐피탈": "FCAP",
  "퍼스트 커먼웰스 파이낸셜": "FCF",
  "퍼스트 커뮤니티": "FCCO",
  "퍼스트 커뮤니티 뱅크셰어스": "FCBC",
  "퍼스트 트랙스 바이오테라퓨틱": "TRAX",
  "퍼스트 파이낸셜": "THFF",
  "퍼스트 파이낸셜 뱅코프": "FFBC",
  "퍼스트 파이낸셜 뱅크셰어스": "FFIN",
  "퍼스트 하와이안": "FHB",
  "퍼스트 호라이즌": "FHN",
  "퍼스트딥스닷컴": "DIBS",
  "퍼스트미드 뱅크셰어스": "FMBH",
  "퍼스트서비스": "FSV",
  "퍼스트선 캐피털 뱅코프": "FSUN",
  "퍼스트에너지": "FE",
  "퍼스트캐쉬 홀딩스": "FCFS",
  "퍼스펙티브 테라퓨틱스": "CATX",
  "퍼시픽 가스 & 일렉트릭": "PCG-P-A",
  "퍼시픽 바이오사이언시스 오브 캘리포니아": "PACB",
  "퍼싱 스퀘어": "PS",
  "퍼싱 스퀘어 USA": "PSUS",
  "퍼페투아 리소시스": "PPTA",
  "퍼펙트": "PERF",
  "퍼포먼스 쉬핑": "PSHG",
  "퍼포먼스 푸드 그룹": "PFGC",
  "퍼플 바이오테크 ADR": "PPBT",
  "퍼플 이노베이션": "PRPL",
  "펀웨어": "PHUN",
  "펀코": "FNKO",
  "펄 다이버 크레디트": "PDCC",
  "펄 다이버 크레딧 우선주 Series A 8.00%": "PDPA",
  "펄센모어": "PLSM",
  "펄스 바이오사이언스": "PLSE",
  "펄젠트 제네틱스": "FLGT",
  "페가시스템즈": "PEGA",
  "페넌트 그룹": "PNTG",
  "페넌트파크 인베트스트먼트": "PNNT",
  "페넌트파크 플로팅 레이트 캐피탈": "PFLT",
  "페넘브라": "PEN",
  "페넥 파머수티컬스": "FENC",
  "페니맥 모기지 인베스트먼트": "PMT",
  "페니맥 파이낸셜 서비스": "PFSI",
  "페더럴 리얼티 인베스트먼트 트러스트": "FRT",
  "페더럴 시그널": "FSS",
  "페더럴 애그리컬처럴 모기지 Class C": "AGM",
  "페더레이티드 헤르메스": "FHI",
  "페덱스": "FDX",
  "페덱스 프레이트 홀딩 컴퍼니": "FDXF",
  "페디아트릭스 메디컬 그룹": "MD",
  "페라리": "RACE",
  "페라소": "PRSO",
  "페로글로브": "GSM",
  "페로비알": "FER",
  "페르미": "FRMI",
  "페르미안 리소시스": "PR",
  "페리고": "PRGO",
  "페리미터 솔루션스": "PRM",
  "페리미터 애퀴지션 I": "PMTR",
  "페리언 네트워크": "PERI",
  "페블브룩 호텔 트러스트": "PEB",
  "페어 아이작": "FICO",
  "페이 세이프": "PSFE",
  "페이먼트어스 홀딩스": "PAY",
  "페이오니아 글로벌": "PAYO",
  "페이첵스": "PAYX",
  "페이콤 소프트웨어": "PAYC",
  "페이트 테라퓨틱스": "FATE",
  "페이팔 홀딩스": "PYPL",
  "페이페이 ADR": "PAYP",
  "페일로시티 홀딩": "PCTY",
  "펜 엔터테인먼트": "PENN",
  "펜보 홀딩스": "FEBO",
  "펜스케 오토모티브 그룹": "PAG",
  "펜테어": "PNR",
  "펠라고스 인슈어런스 캐피탈": "PLGO",
  "펠로튼 인터랙티브": "PTON",
  "펠소스 테라퓨틱스": "PTHS",
  "펨비나 파이프라인": "PBA",
  "펩시코": "PEP",
  "펩젠": "PEPG",
  "펫코 헬스 앤 웰니스 컴퍼니": "WOOF",
  "펭귄 솔루션스": "PENG",
  "포 코너스 프로퍼티 트러스트": "FCPT",
  "포그혼 테라퓨틱스": "FHTX",
  "포노 캐피탈 포": "PONO",
  "포니 AI ADR": "PONY",
  "포드 모터": "F",
  "포드캐스톤": "PODC",
  "포라프릭 글로벌": "AFRI",
  "포럼 마켓츠": "FRMM",
  "포럼 에너지 테크놀로지스": "FET",
  "포레스타 그룹": "FOR",
  "포레스터 리서치": "FORR",
  "포르테 바이오사이언스": "FBRX",
  "포르투나 마이닝": "FSM",
  "포르티스": "FTS",
  "포멘토 에코노미코 멕시카노 ADR": "FMX",
  "포모스트 클린 에너지": "FMST",
  "포뮬러 시스템즈 1985 ADR": "FORTY",
  "포뮬러 원 그룹 Series A": "FWONA",
  "포뮬러 원 그룹 Series C": "FWONK",
  "포브라이트": "FRBT",
  "포스코 홀딩스 ADR": "PKX",
  "포스털 리얼티 트러스트": "PSTL",
  "포스트 홀딩스": "POST",
  "포시즌스 에듀케이션 케이먼 ADR": "FEDU",
  "포어사이트 오토노모스 홀딩스 ADR": "FRSX",
  "포어프런트 테크 홀딩스 애퀴지션": "FTHA",
  "포엣 테크놀로지": "POET",
  "포워드 에어 (델라웨어)": "FWRD",
  "포워드 인더스트리스": "FWDI",
  "포전트 파워 솔루션스": "FPS",
  "포츈 브랜즈 홈 앤 시큐리티": "FBIN",
  "포치 그룹": "PRCH",
  "포커스 유니버설": "FCUV",
  "포튜넥스 애퀴지션": "FXAC",
  "포트 테크놀로지": "FRTT",
  "포트레아 홀딩스": "FTRE",
  "포트로닉스": "PLAB",
  "포트리스 바이오텍": "FBIO",
  "포트리스 바이오텍 우선주 시리즈 A 9.375%": "FBIOP",
  "포트리스 밸류 애퀴지션 V": "FVAV",
  "포틀랜드 제너럴 일렉트릭": "POR",
  "포티넷": "FTNT",
  "포티브": "FTV",
  "포틸로스": "PTLO",
  "폭스 Class A": "FOXA",
  "폭스 Class B": "FOX",
  "폭스 디벨롭먼트 홀딩스": "FOXX",
  "폭스 팩토리 홀딩": "FOXF",
  "폰스 파이낸셜 그룹": "PDLB",
  "폴드 홀딩스": "FLD",
  "폴라 파워": "POLA",
  "폴라리스": "PII",
  "폴라릭스 테라퓨틱스": "PLYX",
  "폴리벨리 그룹": "PLBL",
  "폴리존": "PLRZ",
  "폴리피드": "PYPD",
  "폴스타 오토모티브 홀딩 UK ADR": "PSNY",
  "폼닥터 ADR": "POM",
  "폼팩터": "FORM",
  "푸르덴셜 ADR": "PUK",
  "푸르덴셜 파이낸셜": "PRU",
  "푸보티비": "FUBO",
  "푸투 홀딩스 ADR": "FUTU",
  "풀": "POOL",
  "풀 트럭 얼라이언스 ADR": "YMM",
  "풀 하우스 리조트": "FLL",
  "풀러 H B": "FUL",
  "풀매트릭스": "PULM",
  "풀몬스": "LUNG",
  "풀크럼 테라퓨틱스": "FULC",
  "풀턴 파이낸셜": "FULT",
  "풀턴 파이낸셜 우선주 시리즈 A 5.125%": "FULTP",
  "풀티 그룹": "PHM",
  "퓨리 골드 마인스": "FURY",
  "퓨마 바이오테크놀러지": "PBYI",
  "퓨어 사이클": "PCYO",
  "퓨어사이클 테크놀러지": "PCT",
  "퓨얼 테크": "FTEK",
  "퓨얼셀 에너지": "FCEL",
  "퓨전 퓨얼 그린": "HTOO",
  "퓨즈머신스": "FUSE",
  "퓨처 머니 애퀴지션": "FMAC",
  "퓨처 비전 II 애퀴지션": "FVN",
  "퓨처 핀테크 그룹": "FTFT",
  "퓨처코프 스페이스 애퀴지션 1": "FTRA",
  "퓨처크레스트 애퀴지션": "FCRS",
  "퓨처퓨얼": "FF",
  "프라이메리카": "PRI",
  "프라이메크 홀딩스": "PMEC",
  "프라이스스마트": "PSMT",
  "프라이어리티 인컴 펀드 우선주 시리즈 J 6%": "PRIF-P-D",
  "프라이오리티 테크놀러지 홀딩스": "PRTH",
  "프라이트 테크놀로지스": "FRGT",
  "프라임 메디슨": "PRME",
  "프라임에너지 리소스": "PNRG",
  "프락시스 프리시젼 메디신": "PRAX",
  "프랑코-네바다": "FNV",
  "프랙틸 헬스": "GUTS",
  "프랭클린 BSP 리얼티 트러스트": "FBRT",
  "프랭클린 리소시스": "BEN",
  "프랭클린 스트리트 프로퍼티스": "FSP",
  "프랭클린 와이어리스": "FKWL",
  "프랭클린 일렉트릭": "FELE",
  "프랭클린 커비": "FC",
  "프랭클린 파이낸셜 서비스": "FRAF",
  "프레네틱스 글로벌": "PRE",
  "프레리 오퍼레이팅": "PROP",
  "프레스티지 컨슈머 헬스케어": "PBH",
  "프레시디오 프로덕션": "FTW",
  "프레시디오 프로퍼티 트러스트": "SQFT",
  "프레시웍스": "FRSH",
  "프레시전 드릴링": "PDS",
  "프레시젠": "PGEN",
  "프레시펫": "FRPT",
  "프레이토스": "CRGO",
  "프레이트카 아메리카": "RAIL",
  "프레제니우스 메디칼 케어 ADR": "FMS",
  "프레지디오 프로퍼티 트러스트 우선주 시리즈 D 9.375%": "SQFTP",
  "프레토리안 애퀴지션": "PTOR",
  "프렐류드 테라퓨틱스": "PRLD",
  "프로-덱스": "PDEX",
  "프로그레스 소프트웨어": "PRGS",
  "프로그레시브": "PGR",
  "프로로지스": "PLD",
  "프로미스 뉴로사이언시스": "PMN",
  "프로비던트 파이낸셜 서비스": "PFS",
  "프로비던트 파이낸셜 홀딩스": "PROV",
  "프로세사 파마슈티컬스": "PCSA",
  "프로셉트 바이오로보틱스": "PRCT",
  "프로스페리티 뱅크셰어스": "PB",
  "프로스펙트 캐피털": "PSEC",
  "프로엠 애퀴지션 I": "PAAC",
  "프로지니": "PGNY",
  "프로캡 파이낸셜": "BRR",
  "프로코어테크놀러지스": "PCOR",
  "프로큐알테라퓨틱스": "PRQR",
  "프로키드니": "PROK",
  "프로타고니스트 테라퓨틱스": "PTGX",
  "프로타라 테라퓨틱스": "TARA",
  "프로탈릭스 바이오테라퓨틱스": "PLX",
  "프로테나": "PRTA",
  "프로토 랩스": "PRLB",
  "프로파운드 메디컬": "PROF",
  "프로팽 바이오파마": "PPCB",
  "프로페셔널 다이버시티 네트워크": "IPDN",
  "프로페트로 홀딩": "PUMP",
  "프로퓨사": "PFSA",
  "프로프랙 홀딩": "ACDC",
  "프로피시언트 오토 로지스틱스": "PAL",
  "프론트도어": "FTDR",
  "프론트라인": "FRO",
  "프론트뷰 REIT": "FVR",
  "프론티어 그룹 홀딩스": "ULCC",
  "프론티어 뉴클리어 앤 미네랄스": "FNUC",
  "프리덤 메탈스 애퀴지션": "FDMM",
  "프리덤 홀딩": "FRHC",
  "프리드먼 인더스트리스": "FRD",
  "프리모 브랜드": "PRMB",
  "프리모리스 서비시스": "PRIM",
  "프리미스 파이낸셜": "FRST",
  "프리미엄 케이터링 홀딩스": "PC",
  "프리비아 헬스 그룹": "PRVA",
  "프리사이젼 바이오사이언스": "DTIL",
  "프리슈어런스 홀딩스": "PRHI",
  "프리시아": "PHR",
  "프리시전 옵틱스": "POCI",
  "프리시피오": "PRPO",
  "프리캐스트": "CAST",
  "프리컨시 일렉트로닉스": "FEIM",
  "프리퍼드 은행": "PFBC",
  "프리퍼드플러스 우선주 시리즈 GSC-2": "PYT",
  "프리포트 맥모란": "FCX",
  "프리폼드 라인 프로덕츠": "PLPC",
  "프린시펄 파이낸셜 그룹": "PFG",
  "플라워스 푸드": "FLO",
  "플라이-이 그룹": "FLYE",
  "플라이와이어": "FLYW",
  "플라익스클루시브": "FLYX",
  "플래그 십 애퀴지션": "FSHP",
  "플래그스타 파이낸셜": "FLG",
  "플래니건스 엔터프라이시스": "BDL",
  "플래닛 그린 홀딩스": "PLAG",
  "플래닛 랩스 PBC": "PL",
  "플래닛 이미지 인터내셔널": "YIBO",
  "플래닛 피트니스": "PLNT",
  "플래시 스포츠 앤 미디어": "FLZH",
  "플래티넘 그룹 메탈스": "PLG",
  "플래티넘 애널리틱스 케이맨": "PLTS",
  "플러그 파워": "PLUG",
  "플러스 테라퓨틱스": "CNSY",
  "플러터 엔터테인먼트": "FLUT",
  "플럭스 파워 홀딩스": "FLUX",
  "플럼 애퀴지션 IV": "PLMK",
  "플레이보이": "PLBY",
  "플레이스튜디오스": "MYPS",
  "플레이티카 홀딩": "PLTK",
  "플렉서블 솔루션스 인터내셔널": "FSI",
  "플렉서스": "PLXS",
  "플렉스": "FLEX",
  "플렉스 LNG": "FLNG",
  "플렉스스틸 인더스트리스": "FLXS",
  "플로어 & 데코 홀딩스": "FND",
  "플로우서브": "FLS",
  "플로우코 홀딩스": "FLOC",
  "플로텍 인더스트리스": "FTK",
  "플루리": "PLUR",
  "플루마스 뱅코프": "PLBC",
  "플루언스 에너지": "FLNC",
  "플루언트": "FLNT",
  "플루오르": "FLR",
  "플루토니안 애퀴지션 II": "PLUN",
  "플루투스 파이낸션 그룹": "PLUT",
  "플리언트 테라퓨틱스": "PLRX",
  "피규어 테크놀로지 솔루션스": "FIGR",
  "피그마": "FIG",
  "피그스": "FIGS",
  "피너클 웨스트 캐피털": "PNW",
  "피너클 파이낸셜 파트너스": "PNFP",
  "피너클 푸드 그룹": "PFAI",
  "피니아": "PHIN",
  "피닉스 뉴 미디어 ADR": "FENG",
  "피닉스 아시아 홀딩스": "PHOE",
  "피닉스 에너지 원 우선주 Series A 10%": "PHXE-P",
  "피닉스 에듀케이션 파트너스": "PXED",
  "피닉스핀": "PFX",
  "피델리티 D&D 뱅코프": "FDBC",
  "피델리티 내셔널 인포메이션 서비스": "FIS",
  "피델리티 내셔널 파이낸셜": "FNF",
  "피메이시스": "FEMY",
  "피바디 에너지": "BTU",
  "피버블릭 에어웨이스 홀딩스": "RJET",
  "피브로 애니멀 헬스": "PAHC",
  "피스 애퀴지션": "PECE",
  "피어슨 ADR": "PSO",
  "피오 파마슈티컬스": "PHIO",
  "피카드 메디컬": "PMI",
  "피코셀라 ADR": "PCLA",
  "피트니보우스": "PBI",
  "피트니스 챔스 홀딩스": "FCHL",
  "피팩 글래드스턴 파이낸셜": "PGC",
  "피프스 디스트릭트 뱅코프": "FDSB",
  "피프스 서드 뱅코프": "FITB",
  "피프스 에라 애퀴지션 I": "FERA",
  "피플 인코포레이티드": "PPLI",
  "피플스 뱅코프": "PEBO",
  "피플스 파이낸셜 서비스": "PFIS",
  "픽셀웍스": "PXLW",
  "픽스": "PICS",
  "픽시스 온콜로지": "PYXS",
  "픽시스 탱커스": "PXS",
  "핀둬둬 ADR": "PDD",
  "핀볼루션 그룹 ADR": "FINV",
  "핀와이즈 뱅코프": "FINW",
  "핀워드 뱅코프": "FNWD",
  "핀터레스트": "PINS",
  "필그림즈 프라이드": "PPC",
  "필라나 테라퓨틱스": "FLNA",
  "필립 모리스 인터내셔널": "PM",
  "필립스 66": "PSX",
  "필립스 반 휴센": "PVH",
  "필립스 에디슨 & 코": "PECO",
  "핏라이프 브랜즈": "FTLF",
  "핑거모션": "FNGR",
  "핑안 바이오메디컬": "PASW",
  "하노버 뱅코프": "HNVR",
  "하노버 인슈어런스 그룹": "THG",
  "하드론 에너지": "HDRN",
  "하모니 골드 마이닝 ADR": "HMY",
  "하모니 바이오사이언시스 홀딩스": "HRMY",
  "하모닉": "HLIT",
  "하버드 바이오사이언스": "HBIO",
  "하버드 에비뉴 애퀴지션": "HAVA",
  "하버티 퍼니처": "HVT",
  "하얏트 호텔": "H",
  "하오시 헬스 테크놀로지": "HAO",
  "하오신 홀딩스": "HXHX",
  "하와이안 일렉트릭 인더스트리스": "HE",
  "하우멧 에어로스페이스": "HWM",
  "하우스 오브 도지": "HODO",
  "하워드 휴스 홀딩스": "HHH",
  "하이 롤러 테크놀러지스": "ROLR",
  "하이 타이드": "HITI",
  "하이-트렌드 인터내셔널 그룹": "HTCO",
  "하이드로팜 홀딩스": "HYFM",
  "하이드말 매리타임 홀딩스": "HMR",
  "하이랜더 실버": "HSLV",
  "하이맥스 테크놀로지스 ADR": "HIMX",
  "하이뷰 머저": "HVMC",
  "하이브 디지털 테크놀로지스": "HIVE",
  "하이스터-예일": "HY",
  "하이어퀘스트": "HQI",
  "하이우즈 프로퍼티스": "HIW",
  "하이웨이 홀딩스": "HIHO",
  "하이크로프트 마이닝 홀딩": "HYMC",
  "하이텍 글로벌": "HKIT",
  "하이템플러 테크": "HTT",
  "하이퍼리퀴드 스트래티지스": "PURR",
  "하이퍼스케일 데이터": "GPUS",
  "하이퍼파인": "HYPR",
  "하이페리온 디파이": "HYPD",
  "하이피크에너지": "HPK",
  "하인 셀레셜 그룹": "HAIN",
  "하일리온 홀딩스": "HYLN",
  "하트 행크스": "HHS",
  "하트랜드 익스프레스": "HTLD",
  "하트빔": "BEAT",
  "하트사이언스": "HSCS",
  "하트코어 엔터프라이시스": "HTCR",
  "하트포드 인슈어런스 그룹": "HIG",
  "하트플로우": "HTFL",
  "하프니아": "HAFN",
  "한국전력 ADR": "KEP",
  "한미 파이낸셜": "HAFC",
  "할로자임 테라퓨틱스": "HALO",
  "할리-데이비슨": "HOG",
  "할리버튼": "HAL",
  "항펑 테크놀로지 이노베이션": "FOFO",
  "해거티": "HGTY",
  "해로우": "HROW",
  "해밀턴 레인": "HLNE",
  "해밀턴 비치 브랜드 홀딩": "HBB",
  "해밀턴 인슈어런스 그룹": "HG",
  "해이워드 홀딩스": "HAYW",
  "해즈브로": "HAS",
  "해켓 그룹": "HCKT",
  "해픈": "HAPN",
  "해피 시티 홀딩스": "HCHL",
  "핸콕 휘트니": "HWC",
  "핼러도 에너지": "HNRG",
  "허니웰 에어로스페이스": "HONA",
  "허니웰 인터내셔널": "HON",
  "허드베이 미네랄": "HBM",
  "허드슨 테크놀로지스": "HDSN",
  "허드슨 퍼시픽 프로퍼티즈": "HPP",
  "허벌라이프": "HLF",
  "허벨": "HUBB",
  "허브 그룹": "HUBG",
  "허브 사이버 시큐리티": "HUBC",
  "허브스팟": "HUBS",
  "허쉬": "HSY",
  "허츠 글로벌 홀딩스": "HTZ",
  "허치메드 (차이나) ADR": "HCM",
  "허코 컴퍼니스": "HURC",
  "허큘리스 캐피털": "HTGC",
  "허크 홀딩스": "HRI",
  "헌츠맨": "HUN",
  "헌팅턴 뱅그셰어스 우선주 Series J": "HBANL",
  "헌팅턴 뱅크 우선주 Series L 5.50%": "HBANZ",
  "헌팅턴 뱅크셰어스": "HBAN",
  "헌팅턴 뱅크셰어스 우선주 시리즈 H 4.5%": "HBANP",
  "헌팅턴 뱅크셰어스 우선주 시리즈 I 5.7%": "HBANM",
  "헌팅턴 잉걸스 인더스트리즈": "HII",
  "헛 8": "HUT",
  "헤네스 캐피탈 인베스트먼트 VII": "HVII",
  "헤네시 어드바이저스": "HNNA",
  "헤네시 캐피털 인베스트먼트 VIII": "HCIC",
  "헤런 테라퓨틱스": "HRTX",
  "헤리티지 인슈어런스 홀딩스": "HRTG",
  "헤리티지 파이낸셜": "HFWA",
  "헤리티지글로벌": "HGBL",
  "헤맙 테라퓨틱스 홀딩스": "COAG",
  "헤모네틱스": "HAE",
  "헤사이 그룹 ADR": "HSAI",
  "헤스 미드스트림": "HESM",
  "헤이코": "HEI",
  "헤일리온 ADR": "HLN",
  "헤클라 마이닝": "HL",
  "헥셀": "HXL",
  "헨리 셰인": "HSIC",
  "헬렌 오브 트로이": "HELE",
  "헬로 그룹 ADR": "MOMO",
  "헬리오스 테크놀로지스": "HLIO",
  "헬릭스 애퀴지션 III": "HLXC",
  "헬릭스 에너지 솔루션스 그룹": "HLX",
  "헬스 인 테크": "HIT",
  "헬스 카탈리스트": "HCAT",
  "헬스스트림": "HSTM",
  "헬스에퀴티": "HQY",
  "헬스케어 리얼티 트러스트": "HR",
  "헬스케어 서비스 그룹": "HCSG",
  "헬스케어 트라이앵글": "HCTI",
  "헬스피크 프로퍼티스": "DOC",
  "헬시 초이스 웰니스": "HCWC",
  "헬포트 AI": "HPAI",
  "호라이즌 뱅코프": "HBNC",
  "호라이즌 퀀텀 홀딩스": "HQ",
  "호라이즌 테크놀로지 파이낸스": "HRZN",
  "호레이스 맨 에듀케이터스": "HMN",
  "호멜 푸즈": "HRL",
  "호브내니언 엔터프라이스": "HOV",
  "호브내니언 엔터프라이스 우선주 시리즈 A 7.625%": "HOVNP",
  "호손 뱅크셰어스": "HWBK",
  "호스트 호텔스 & 리조트": "HST",
  "호인 뱅코프": "HYNE",
  "호크아이 360": "HAWK",
  "호킨스": "HWKN",
  "호텔101 글로벌 홀딩스": "HBNB",
  "호프 뱅코프": "HOPE",
  "혼다자동차 ADR": "HMC",
  "홀 채드윅 애퀴지션": "HCAC",
  "홀리": "HLLY",
  "홈 뱅코프": "HBCP",
  "홈 뱅크셰어스": "HOMB",
  "홈 페더럴 뱅코프 오브 루이지아나": "HFBL",
  "홈디포": "HD",
  "홈스투라이프": "HTLM",
  "홈트러스트 뱅크셰어스": "HTB",
  "홍리 그룹": "HLP",
  "화디 인터내셔널 그룹": "HUDI",
  "화이자": "PFE",
  "화이트 마운틴스 인슈어런스 그룹": "WTM",
  "화이트 펄 애퀴지션": "WPAC",
  "화이트파이버": "WYFI",
  "화이트호스 파이낸스": "WHF",
  "화이트호크 미네랄스": "WHK",
  "화이트호크 테라퓨틱스": "WHWK",
  "화주 그룹": "HTHT",
  "화천 AI 파킹 매니지먼트 테크놀로지": "HCAI",
  "후야 ADR": "HUYA",
  "후이쩌 홀딩 ADR": "HUIZ",
  "후커 퍼니싱스": "HOFT",
  "후후테크 인터내셔널 그룹": "HUHU",
  "훌리한 로키": "HLI",
  "휘턴 프레셔스 메탈스": "WPM",
  "휠러 리얼 에스테이트 인베스트": "WHLR",
  "휠러 리얼 에스테이트 인베스트 우선주 시리즈 B 9.000%": "WHLRP",
  "휠러 리얼 에스테이트 인베스트 우선주 시리즈 D 8.75%": "WHLRD",
  "휠즈 업 익스피리언스": "UP",
  "휴런 컨설팅 그룹": "HURN",
  "휴렛패커드 엔터프라이즈": "HPE",
  "휴마나": "HUM",
  "휴마사이트": "HUMA",
  "히말라야 쉬핑": "HSHP",
  "히어 그룹 ADR": "HERE",
  "히포 홀딩스": "HIPO",
  "힌지 헬스": "HNGE",
  "힐먼 솔루션스": "HLMN",
  "힐탑 홀딩스": "HTH",
  "힐튼 그랜드 베케이션스": "HGV",
  "힐튼 월드와이드 홀딩스": "HLT",
  "힘스 & 허즈": "HIMS",
  "힝엄 인스티튜션 포 세이빙스": "HIFS",
};

export const US_TICKER_TO_KO: Record<string, string> = {
  "A": "애질런트 테크놀로지스",
  "AA": "알코아",
  "AACB": "아티어스 II 애퀴지션",
  "AACG": "ATA 크리에이티비티 글로벌 ADR",
  "AACI": "아마다 애퀴지션 III",
  "AACO": "애보니 애퀴지션 I",
  "AACP": "애퍼지 애퀴지션",
  "AADX": "어플라이드 에어로스페이스 앤 디펜스",
  "AAL": "아메리칸 에어라인스 그룹",
  "AAME": "아틀란틱 아메리칸",
  "AAMI": "아캐디언 애셋 매니지먼트",
  "AAOI": "어플라이드 옵토일렉트로닉스",
  "AAON": "에이에이온",
  "AAP": "어드밴스 오토 파츠",
  "AAPG": "어센티지 파마 그룹 인터내셔널 ADR",
  "AAPL": "애플",
  "AARD": "아르드바크 테라퓨틱스",
  "AAT": "아메리칸 애셋츠 트러스트",
  "AAUC": "앨라이드 골드",
  "AB": "AllianceBernstein Holding, L.P.",
  "ABAT": "아메리칸 배터리 테크놀로지",
  "ABBV": "애브비",
  "ABCB": "아메리스 뱅코프",
  "ABCL": "앱셀레라 바이오로직스",
  "ABEO": "아베오나 테라퓨틱스",
  "ABEV": "암베브 ADR",
  "ABG": "애즈버리 오토모티브 그룹",
  "ABLV": "에이블 뷰 글로벌",
  "ABM": "ABM 인더스트리즈",
  "ABNB": "에어비앤비",
  "ABOS": "애큐먼 파마슈티컬스",
  "ABR": "아버 리얼티 트러스트",
  "ABR-P-D": "아버 리얼티 트러스트",
  "ABR-P-E": "아버 리얼티 트러스트",
  "ABR-P-F": "아버 리얼티 트러스트",
  "ABSI": "앱사이",
  "ABT": "애보트 래보라토리",
  "ABTC": "아메리칸 비트코인",
  "ABTS": "에이비츠 그룹",
  "ABUS": "아버터스 바이오파마",
  "ABVC": "ABVC 바이오파마",
  "ABVX": "아비백스 ADR",
  "ABX": "애버커스 글로벌",
  "ACA": "아코사",
  "ACAA": "애버린 캐피탈 애퀴지션",
  "ACAD": "아카디아 파마슈티컬스",
  "ACB": "오로라 카나비스",
  "ACCL": "애코 그룹 홀딩스",
  "ACCO": "애코 브랜즈",
  "ACCS": "액세스 뉴스와이어",
  "ACDC": "프로프랙 홀딩",
  "ACEL": "악셀 엔터테인먼트",
  "ACET": "에이디셋바이오",
  "ACFN": "에이콘 에너지",
  "ACGC": "ACP 홀딩스 애퀴지션",
  "ACGL": "아치 캐피털 그룹",
  "ACGLN": "아치 캐피탈 그룹 우선주 시리즈 G 4.55%",
  "ACGLO": "아치 캐피털 그룹 우선주 시리즈 F 5.45%",
  "ACH": "아센드라 헬스",
  "ACHC": "아카디아 헬스케어",
  "ACHR": "아처 에비에이션",
  "ACHV": "어치브 라이프 사이언스",
  "ACI": "앨버트슨 컴퍼니",
  "ACIC": "아메리칸 코스탈 인슈어런스",
  "ACIU": "AC 이뮨",
  "ACIW": "ACI 월드와이드",
  "ACLS": "액셀리스 테크놀로지스",
  "ACM": "애이콤",
  "ACMR": "ACM 리서치",
  "ACN": "액센추어",
  "ACNB": "Acnb",
  "ACNT": "어센트 인더스트리즈",
  "ACOG": "알파 코그니토",
  "ACON": "애클라리온",
  "ACP": "abrdn",
  "ACP-P-A": "abrdn Income Credit Strategies Mutual Fund",
  "ACR": "에이커스 커머셜 리얼티",
  "ACR-P-C": "에이커스 커머셜 리얼티",
  "ACR-P-D": "에이커스 커머셜 리얼티",
  "ACRE": "아레스 커머셜 리얼에스테이트",
  "ACRS": "애클래리스 테라퓨틱스",
  "ACRV": "애크리본 테라퓨틱스",
  "ACT": "인액트 홀딩스",
  "ACTG": "아카시아 리서치",
  "ACTU": "액추에이트 테라퓨틱스",
  "ACU": "애크미 유나이티드",
  "ACV": "Virtus Diversified Income And Convertible Fund",
  "ACVA": "ACV 옥션스",
  "ACXP": "어큐어엑스 파마슈티컬스",
  "AD": "어레이 디지털 인프라스트럭처",
  "ADAC": "아메리칸 드라이브 애퀴지션",
  "ADAG": "아다진 ADR",
  "ADAM": "아다마스 트러스트",
  "ADAML": "아다마스 트러스트 우선주 Series F 6.875%",
  "ADAMM": "아다마스 트러스트 우선주 Series E 7.875%",
  "ADAMN": "아다마스 트러스트 우선주 Series D 8.00%",
  "ADAMZ": "아다마스 트러스트 우선주 Series G 7.000%",
  "ADBE": "어도비",
  "ADC": "어그리 리얼티",
  "ADC-P-A": "어그리 리얼티",
  "ADCT": "ADC 테라퓨틱스",
  "ADEA": "아데이아",
  "ADGM": "아다지오 메디컬 홀딩스",
  "ADI": "애널로그 디바이시스",
  "ADIG": "ADI 글로벌 디스트리뷰션",
  "ADIL": "애디얼 파머수티컬",
  "ADM": "아처 대니얼스 미들랜드",
  "ADMA": "ADMA 바이오로직스",
  "ADNT": "애디언트",
  "ADP": "오토매틱 데이터 프로세싱",
  "ADPT": "어댑티브 바이오테크놀러지",
  "ADSE": "애즈-테크 에너지",
  "ADSK": "오토데스크",
  "ADT": "Adt",
  "ADTN": "애드트랜 홀딩스",
  "ADUR": "아듀로 클린 테크놀로지스",
  "ADUS": "아듀스 홈케어",
  "ADV": "어드밴티지 솔루션스",
  "ADVB": "어드밴스드 바이오메드",
  "ADX": "Adams Diversified Equity Fund，Inc.",
  "ADXN": "애딕스 테라퓨틱스 ADR",
  "AEAQ": "액티베이트 에너지 애퀴지션",
  "AEBI": "에비 슈미트 홀딩",
  "AEC": "앤필드 에너지",
  "AEE": "애머런",
  "AEF": "abrdn Emerging Markets ex-China Fund",
  "AEG": "아에곤 ADR",
  "AEHL": "안텔로페 엔터프라이즈 홀딩스",
  "AEHR": "에흐르 테스트 시스템즈",
  "AEI": "알셋",
  "AEIS": "어드밴스드 에너지 인더스트리스",
  "AEM": "애그니코 이글 마인스",
  "AEMD": "애슬론 메디컬",
  "AENT": "얼라이언스 엔터테인먼트 홀딩",
  "AEO": "아메리칸 이글 아웃피터스",
  "AEON": "이온 바이오파마",
  "AEP": "아메리칸 일렉트릭 파워 컴퍼니",
  "AER": "에어캡 홀딩스",
  "AERO": "그루포 에어로멕시코 ADR",
  "AERT": "아에리스 테크놀로지",
  "AES": "Aes",
  "AESI": "아틀라스 에너지 솔루션스",
  "AESP": "이온 애퀴지션 I",
  "AEVA": "아에바 테크놀로지스",
  "AEXA": "아메리칸 익셉셔널리즘 애퀴지션 A",
  "AEYE": "오디오아이",
  "AFB": "Alliance National Municipal",
  "AFCG": "어드반스드 플라워 캐피털",
  "AFG": "아메리칸 파이낸셜 그룹",
  "AFJK": "에이메이 헬스 테크놀로지",
  "AFL": "애플랙",
  "AFRI": "포라프릭 글로벌",
  "AFRM": "어펌 홀딩스",
  "AFYA": "아피야",
  "AG": "퍼스트 머제스틱 실버",
  "AGBK": "Agi",
  "AGCC": "에젠시아 커머셜 스피리츠",
  "AGCO": "애그코",
  "AGD": "abrdn Global Dynamic Dividend Fund",
  "AGEN": "아제너스",
  "AGI": "AGI",
  "AGIG": "어번디아 글로벌 임팩트 그룹",
  "AGIO": "애지오스 파마슈티컬스",
  "AGL": "애질론 헬스",
  "AGM": "페더럴 애그리컬처럴 모기지 Class C",
  "AGM-A": "Federal Agricultural Mortgage Corporation Class A Voting",
  "AGM-P-D": "페더럴 애그리컬처럴 모기지 Class C",
  "AGM-P-E": "페더럴 애그리컬처럴 모기지 Class C",
  "AGM-P-F": "페더럴 애그리컬처럴 모기지 Class C",
  "AGM-P-G": "페더럴 애그리컬처럴 모기지 Class C",
  "AGM-P-H": "페더럴 애그리컬처럴 모기지 Class C",
  "AGM-P-I": "페더럴 애그리컬처럴 모기지 Class C",
  "AGMB": "아고맙 테라퓨틱스 ADR",
  "AGMH": "AGM 그룹 홀딩스",
  "AGNC": "AGNC 인베스트먼트",
  "AGNCL": "AGNC 인베스트먼트 우선주 시리즈 G",
  "AGNCM": "AGNC 인베스트먼트 우선주 시리즈 D",
  "AGNCN": "AGNC 인베스트먼트 우선주 시리즈 C",
  "AGNCO": "AGNC 인베스트먼트 우선주 시리즈 E",
  "AGNCP": "AGNC 인베스트먼트 우선주 시리즈 F",
  "AGNCZ": "AGNC 인베스트먼트 우선주 Series H 8.75%",
  "AGNT": "Agnt",
  "AGO": "어슈어드 개런티",
  "AGPU": "액스 컴퓨트",
  "AGRO": "아데코아그로",
  "AGRZ": "아그로즈",
  "AGX": "아간",
  "AGYS": "어질리시스",
  "AHCO": "어댑트헬스",
  "AHG": "악소 헬스 그룹 ADR",
  "AHL-P-D": "아스펜 인슈어런스 홀딩스 우선주",
  "AHL-P-E": "아스펜 인슈어런스 홀딩스 우선주",
  "AHL-P-F": "아스펜 인슈어런스 홀딩스 우선주",
  "AHMA": "앰비션스 엔터프라이즈 매니지먼트",
  "AHR": "아메리칸 헬스케어 REIT",
  "AHRT": "AH 리얼티 트러스트",
  "AHRT-P-A": "AH 리얼티 트러스트",
  "AHT": "애시포드 호스피탤리티 트러스트",
  "AHT-P-D": "애시포드 호스피탤리티 트러스트",
  "AHT-P-F": "애시포드 호스피탤리티 트러스트",
  "AHT-P-G": "애시포드 호스피탤리티 트러스트",
  "AHT-P-H": "애시포드 호스피탤리티 트러스트",
  "AHT-P-I": "애시포드 호스피탤리티 트러스트",
  "AI": "C3 AI",
  "AIAI": "AIAI 홀딩스",
  "AIB": "AIB 데이터 센터스",
  "AIBZ": "비트제로 홀딩스",
  "AIDX": "20/20 바이오랩스",
  "AIFA": "올 인 퓨처테크 얼라이언스",
  "AIFC": "AI 파이낸셜",
  "AIFF": "파이어플라이 뉴로사이언스",
  "AIFU": "Aifu",
  "AIG": "아메리칸 인터내셔널 그룹",
  "AIHS": "센미아오 테크놀러지",
  "AII": "아메리칸 인테그리티 인슈어런스 그룹",
  "AIIA": "AI 인프라스트럭처 애퀴지션",
  "AIIO": "로보.ai",
  "AIIR": "에어 글로벌",
  "AIM": "AIM 이뮤노테크",
  "AIMD": "에이노스",
  "AIN": "앨버니 인터내셔널",
  "AIO": "Virtus Artificial Intelligence and Technology Opportunities Fund",
  "AIOS": "AIOS 테크",
  "AIOT": "파워플리트",
  "AIP": "아테리스",
  "AIR": "Aar",
  "AIRE": "리알파 테크",
  "AIRG": "에어게인",
  "AIRI": "에어 인더스트리스 그룹",
  "AIRJ": "에어줄 테크놀로지스",
  "AIRO": "AIRO 그룹 홀딩스",
  "AIRS": "에어스컬프 테크놀로지스",
  "AIRT": "에어 T",
  "AIRTP": "에어 T 우선주 8%",
  "AISP": "에어십 AI 홀딩스",
  "AIT": "어플라이드 인더스트리얼 테크놀로지",
  "AIV": "아파트먼트 인베스트먼트 & 매니지먼트",
  "AIXC": "AIx크립토 홀딩스",
  "AIXI": "샤오-아이 ADR",
  "AIZ": "어슈런트",
  "AJG": "아서 J 갤러거 앤 코",
  "AKA": "AKA 브랜즈 홀딩",
  "AKAM": "아카마이 테크놀로지",
  "AKAN": "아칸다",
  "AKBA": "아케비아 테라퓨틱스",
  "AKO-A": "Embotelladora Andina S.A. Series A",
  "AKO-B": "Embotelladora Andina S.A. Series B",
  "AKR": "아카디아 리얼티 트러스트",
  "AKTS": "액티스 온콜로지",
  "AKTX": "아카리 테라퓨틱스 ADR",
  "ALAB": "아스테라 랩스",
  "ALAR": "알라럼 테크놀로지스 ADR",
  "ALB": "앨버말",
  "ALB-P-A": "앨버말",
  "ALC": "알콘",
  "ALCO": "알리코",
  "ALDF": "알델 파이낸셜 II",
  "ALDX": "알데이라 테라퓨틱스",
  "ALEC": "알렉터",
  "ALF": "센추리온 애퀴지션",
  "ALG": "알라모 그룹",
  "ALGM": "알레그로 마이크로시스템즈",
  "ALGN": "얼라인 테크놀로지",
  "ALGS": "앨리고스 테라퓨틱스",
  "ALGT": "얼리전트 트래블",
  "ALH": "얼라이언스 런드리 홀딩스",
  "ALHC": "얼라인먼트 헬스케어",
  "ALIS": "칼리사 애퀴지션",
  "ALIT": "얼라이트",
  "ALK": "알래스카 에어 그룹",
  "ALKS": "앨커미스",
  "ALKT": "알카미 테크놀로지",
  "ALL": "올스테이트",
  "ALL-P-H": "올스테이트",
  "ALL-P-I": "올스테이트",
  "ALL-P-J": "올스테이트",
  "ALLE": "얼리지언",
  "ALLO": "알로진 테라퓨틱스",
  "ALLR": "얼라러티 테라퓨틱스",
  "ALLT": "앨럿",
  "ALLY": "앨라이 파이낸셜",
  "ALM": "알몬티 인더스트리스",
  "ALMR": "알라마 바이오사이언스",
  "ALMS": "알루미스",
  "ALMU": "앨루마",
  "ALNT": "얼라이언트",
  "ALNY": "앨나일램 파마슈티컬스",
  "ALOT": "아스트로노바",
  "ALOV": "알다브라4 리퀴디티 오퍼튜니티",
  "ALOY": "RE앨로이스",
  "ALP": "알파 컴퓨트",
  "ALPS": "알프스 그룹",
  "ALPX": "알펙스 애퀴지션",
  "ALRM": "알람닷컴 홀딩스",
  "ALRS": "앨러루스 파이낸셜",
  "ALSN": "앨리슨 트랜스미션 홀딩스",
  "ALT": "알티뮨",
  "ALTG": "알타 이큅먼트 그룹",
  "ALTG-P-A": "알타 이큅먼트 그룹",
  "ALTI": "알티 글로벌",
  "ALTO": "알토 인그리디언츠",
  "ALUB": "알루사 에너지 애퀴지션 II",
  "ALV": "오토리브",
  "ALVO": "알보테크",
  "ALX": "알렉산더스",
  "ALXO": "ALX 온콜로지 홀딩스",
  "ALZN": "알자멘드 뉴로",
  "AM": "앤테로 미드스트림",
  "AMAL": "아말가메이티드 파이낸셜",
  "AMAN": "아마나트 애퀴지션",
  "AMAT": "어플라이드 머티어리얼즈",
  "AMBA": "암바렐라",
  "AMBO": "앰보우 에듀케이션 홀딩스 ADR",
  "AMBP": "아르다 메탈 패키징",
  "AMBQ": "앰비크 마이크로",
  "AMBR": "앰버 인터내셔널 홀딩 ADR",
  "AMC": "AMC 엔터테인먼트 홀딩스",
  "AMCI": "AMC 로보틱스",
  "AMCR": "앰코",
  "AMCX": "AMC 글로벌 미디어",
  "AMD": "AMD(어드밴스드 마이크로 디바이시스)",
  "AME": "아메텍",
  "AMG": "어필리에이티드 매니저스 그룹",
  "AMGN": "암젠",
  "AMH": "아메리칸 홈스 포 렌트",
  "AMH-P-G": "아메리칸 홈스 포 렌트",
  "AMH-P-H": "아메리칸 홈스 포 렌트",
  "AMIX": "오토노믹스 메디컬",
  "AMKR": "앰코 테크놀로지",
  "AMLX": "아밀릭스 파마슈티컬스",
  "AMN": "AMN 헬스케어 서비스",
  "AMOD": "알파 모더스 홀딩스",
  "AMP": "아메리프라이즈 파이낸셜",
  "AMPG": "앰플리테크 그룹",
  "AMPH": "앰퍼스타 파마슈티컬스",
  "AMPL": "앰플리튜드",
  "AMPX": "앰프리어스 테크놀로지스",
  "AMPY": "앰플리파이 에너지",
  "AMR": "알파 메탈러지컬 리소시스",
  "AMRC": "아메리스코",
  "AMRN": "아마린 ADR",
  "AMRX": "엠닐 파마슈티컬",
  "AMRZ": "암라이즈",
  "AMS": "아메리칸 셰어드 호스피털 서비스",
  "AMSC": "아메리칸 수퍼컨덕터",
  "AMSF": "아메리세이프",
  "AMSS": "어매스 브랜즈",
  "AMST": "에임자이트",
  "AMT": "아메리칸 타워",
  "AMTB": "아머란트 뱅코프",
  "AMTD": "AMTD 아이디어 그룹 ADR",
  "AMTM": "아멘텀 홀딩스",
  "AMTX": "에메티스",
  "AMWL": "아메리칸웰",
  "AMX": "아메리카 모빌 ADR 시리즈 L",
  "AMZE": "어메이즈 홀딩스",
  "AMZN": "아마존닷컴",
  "AN": "오토네이션",
  "ANAB": "어냅티스바이오",
  "ANDE": "앤더슨스",
  "ANDG": "안데르센 그룹",
  "ANET": "아리스타 네트웍스",
  "ANF": "애버크롬비 & 피치",
  "ANG-P-D": "Anglogold Ashanti PLC",
  "ANGH": "앙가미",
  "ANGI": "앤지",
  "ANGO": "앤지오다이내믹스",
  "ANGX": "엔젤 스튜디오스",
  "ANIK": "아니카 테라퓨틱스",
  "ANIP": "ANI 파마슈티컬스",
  "ANIX": "애닉사 바이오사이언시스",
  "ANL": "아들라이 노르티에 ADR",
  "ANNA": "알리안나",
  "ANNX": "아넥슨",
  "ANPA": "리치 스파클 홀딩스",
  "ANRO": "알토 뉴로사이언스",
  "ANSC": "애그리컬처 & 내추럴 솔루션 애퀴지션",
  "ANTA": "안탈파 플랫폼 홀딩",
  "ANTX": "AN2 테라퓨틱스",
  "ANVS": "애노비스 바이오",
  "ANY": "스피어 3D",
  "AOD": "abrdn Total Dynamic Dividend Fund",
  "AOMR": "엔젤 오크 모기지",
  "AON": "에이온",
  "AORT": "아티비온",
  "AOS": "A O 스미스",
  "AOSL": "알파 앤 오메가 세미콘덕터",
  "AOUT": "아메리칸 아웃도어 브랜드",
  "AP": "앰프코 피츠버그",
  "APA": "Apa",
  "APAC": "스톤브릿지 애퀴지션 II",
  "APAM": "아티잔 파트너스 애셋 매니지먼트",
  "APC": "아르코 페트롤리엄",
  "APD": "에어 프로덕츠 앤 케미컬스",
  "APEI": "아메리칸 퍼블릭 에듀케이션",
  "APG": "APi 그룹",
  "APGE": "아포지 테라퓨틱스",
  "APH": "암페놀",
  "API": "아고라 ADR",
  "APLD": "어플라이드 디지털",
  "APLE": "애플 호스피탤리티 리츠",
  "APLM": "아폴로믹스",
  "APMC": "암퍼캡 애퀴지션",
  "APMD": "Apnimed Inc",
  "APO": "아폴로 글로벌 매니지먼트",
  "APOG": "아포지 엔터프라이스",
  "APP": "앱러빈",
  "APPF": "앱폴리오",
  "APPN": "애피안",
  "APPS": "디지털 터빈",
  "APRE": "아프레아 테라퓨틱스",
  "APT": "알파 프로 테크",
  "APTV": "앱티브",
  "APUR": "애퍼처",
  "APUS": "아피메즈 파마슈티컬스 US",
  "APVO": "압티보 테라퓨틱스",
  "APWC": "아시아 퍼시픽 와이어 & 케이블",
  "APXT": "에이펙스 트레저리",
  "APYX": "에이픽스 메디컬",
  "AQB": "아쿠아바운티 테크놀로지스",
  "AQMS": "아쿠아 메탈스",
  "AQN": "알곤퀸 파워 & 유틸리티",
  "AQST": "어퀴스티브 테라퓨틱스",
  "AR": "앤테로 리소스",
  "ARAI": "어라이브 AI",
  "ARAY": "애큐레이",
  "ARBB": "ARB IOT 그룹",
  "ARBE": "아브 로보틱스",
  "ARBK": "아르고 블록체인 ADR",
  "ARCB": "아크베스트",
  "ARCC": "아레스 캐피탈",
  "ARCI": "아르키메데스 테크 SPAC III",
  "ARCL": "ARC 그룹 애퀴지션 I",
  "ARCO": "아르코스 도라도스 홀딩스",
  "ARCT": "아크투루스 테라퓨틱스 홀딩스",
  "ARDC": "Ares Dynamic Credit Allocation Fund Inc",
  "ARDT": "아던트 헬스",
  "ARDX": "아델릭스",
  "ARE": "알렉산드리아 리얼에스테이트 이쿼티",
  "AREC": "아메리칸 리소스",
  "AREN": "아레나 그룹 홀딩스",
  "ARES": "아레스 매니지먼트",
  "ARES-P-B": "아레스 매니지먼트",
  "ARGX": "아겐스 ADR",
  "ARHS": "아르하우스",
  "ARI": "아폴로 커머셜 리얼에스테이트 파이낸스",
  "ARIS": "아리스 마이닝",
  "ARKO": "아르코",
  "ARKR": "아크 레스토란츠",
  "ARL": "아메리칸 리얼티 인베스터스",
  "ARLO": "아를로 테크놀러지",
  "ARLP": "Alliance Resource Partners Units",
  "ARM": "암 홀딩스 ADR",
  "ARMK": "아라마크",
  "ARMP": "아마타 파마슈티컬스",
  "AROC": "아크록",
  "AROW": "애로우 파이낸셜",
  "ARQ": "아크",
  "ARQQ": "아르킷 퀀텀",
  "ARQT": "아커티스 바이오테라퓨틱스",
  "ARR": "아머 레지던셜 리츠",
  "ARR-P-C": "아머 레지던셜 리츠",
  "ARRY": "어레이 테크놀로지스",
  "ARTC": "아트 테크놀로지 애퀴지션",
  "ARTL": "아르텔로 바이오사이언스",
  "ARTNA": "아르테시안 리소시스",
  "ARTV": "아티바 바이오테라퓨틱스",
  "ARTW": "아츠 웨이 매뉴팩처링",
  "ARVN": "아르비나스",
  "ARW": "애로우 일렉트로닉스",
  "ARWR": "애로우헤드 파마슈티컬스",
  "ARX": "엑셀러런트 홀딩스",
  "ARXS": "ARXIS",
  "AS": "아머 스포츠",
  "ASA": "Asa Gold And Precious Metals",
  "ASAN": "아사나",
  "ASB": "어소시에이티드 뱅크코프",
  "ASB-P-E": "어소시에이티드 뱅크코프",
  "ASB-P-F": "어소시에이티드 뱅크코프",
  "ASBP": "애스파이어 바이오파마",
  "ASC": "아드모어 쉬핑",
  "ASG": "Liberty All-Star Growth Fd",
  "ASGI": "abrdn Global Infrastructure Income Fund",
  "ASH": "애쉬랜드",
  "ASIC": "에이티그리티 스페셜티 인슈어런스 홀딩스",
  "ASIX": "어드밴식스",
  "ASLE": "에어세일",
  "ASM": "아비노 실버 & 골드 마인스",
  "ASMB": "어셈블리 바이오사이언시스",
  "ASML": "ASML 홀딩 ADR",
  "ASND": "Ascendis Pharma A/S Ordinary Share",
  "ASO": "아카데미 스포츠 앤 아웃도어스",
  "ASPC": "에이 스펙 III 애퀴지션",
  "ASPI": "ASP 아이소토프",
  "ASPN": "아스펜 에어로젤",
  "ASPS": "알티소스 포트폴리오 솔루션스",
  "ASR": "그루포 에어로포르투아리오 수레스테 ADR",
  "ASRV": "아메리서브 파이낸셜",
  "ASST": "스트라이브",
  "ASTC": "애스트로테크",
  "ASTE": "아스텍 인더스트리스",
  "ASTH": "아스트라나 헬스",
  "ASTI": "어센트 솔라 테크놀로지스",
  "ASTL": "알고마 스틸 그룹",
  "ASTS": "AST 스페이스모바일",
  "ASUR": "어슈어 소프트웨어",
  "ASX": "ASE 테크놀로지 홀딩 ADR",
  "ASYS": "암테크 시스템즈",
  "ATAI": "아타이버클리",
  "ATAT": "어투어 라이프 스타일 홀딩스 ADR",
  "ATCH": "아틀라스클리어 홀딩스",
  "ATCX": "아틀라스 크리티컬 미네랄스",
  "ATEC": "알파텍 홀딩스",
  "ATEN": "A10 네트웍스",
  "ATER": "아테리안",
  "ATEX": "안테릭스",
  "ATGL": "알파 테크놀로지 그룹",
  "ATH-P-A": "Athene Holding DS Representing 1 1000 Pref Shs Series A",
  "ATH-P-B": "Athene Holding DS Representing 1 1000 Pref Shs Series A",
  "ATH-P-D": "Athene Holding DS Representing 1 1000 Pref Shs Series A",
  "ATH-P-E": "Athene Holding DS Representing 1 1000 Pref Shs Series A",
  "ATHE": "알테리티 테라퓨틱스 ADR",
  "ATHM": "오토홈 ADR",
  "ATHR": "애더 홀딩스",
  "ATI": "Ati",
  "ATII": "아르키메데스 테크 SPAC 파트너스 II",
  "ATKR": "앳코어",
  "ATLC": "아틀란티쿠스 홀딩스",
  "ATLCP": "아틀란티쿠스 홀딩스 우선주 시리즈 B 7.625%",
  "ATLO": "에임스 내셔널",
  "ATLX": "아틀라스 리튬",
  "ATMU": "아트무스 필트레이션 테크놀로지스",
  "ATNI": "ATN 인터내셔널",
  "ATNM": "악티늄 파마슈티컬스",
  "ATO": "애트모스 에너지",
  "ATOM": "아토메라",
  "ATOS": "아토사 테라퓨틱스",
  "ATPC": "아가페 ATP",
  "ATR": "아프타그룹",
  "ATRA": "아타라 바이오테라퓨틱스",
  "ATRC": "아트리큐어",
  "ATRO": "아스트로닉스",
  "ATS": "Ats",
  "ATTO": "아토비아 테라퓨틱스",
  "ATXG": "애든택스 그룹",
  "ATYR": "에이타이르 파르마",
  "AU": "앵글로골드 아샨티",
  "AUB": "아틀란틱 유니온 뱅크셰어스",
  "AUB-P-A": "아틀란틱 유니온 뱅크셰어스",
  "AUBN": "어번 내셔널 뱅코프",
  "AUC": "ATIF 홀딩스",
  "AUDC": "오디오코드",
  "AUGO": "아우라 미네랄스",
  "AUID": "오스아이디",
  "AUNA": "아우나",
  "AUPH": "오리니아 파마슈티컬스",
  "AUR": "오로라 이노베이션",
  "AURA": "오라 바이오사이언시스",
  "AURE": "아우렐리온",
  "AUST": "오스틴 골드",
  "AUTL": "오토러스 테라퓨틱스 ADR",
  "AUUD": "아우디아",
  "AVA": "아비스타",
  "AVAH": "애비애나 헬스케어 홀딩스",
  "AVAL": "그루포 아발 악시오네스 이 발로 ADR",
  "AVAT": "애벌랜치 트레저리",
  "AVAV": "에어로바이런먼트",
  "AVB": "아발론베이 커뮤니티",
  "AVBC": "애비디아 뱅코프",
  "AVBH": "애비드뱅크 홀딩스",
  "AVBP": "어라이번트 바이오파마",
  "AVD": "아메리칸 뱅가드",
  "AVEX": "Aevex",
  "AVGO": "브로드컴",
  "AVIR": "아테아 파마슈티컬스",
  "AVK": "Advent Convertible and Income Fund",
  "AVLN": "아발린 파마",
  "AVNT": "애비엔트",
  "AVNW": "아비아트 네트웍스",
  "AVO": "미션 프로듀스",
  "AVPT": "애브포인트",
  "AVR": "안테리스 테크놀로지스 글로벌",
  "AVT": "에이브이넷",
  "AVTR": "어밴터",
  "AVTX": "아발로 테라퓨틱스",
  "AVX": "AVAX 원 테크놀로지",
  "AVXL": "애너벡스 라이프 사이언시스",
  "AVY": "에이버리 데니슨",
  "AWF": "Allianceberstein Global High",
  "AWI": "암스트롱 월드 인더스트리스",
  "AWK": "아메리칸 워터 웍스",
  "AWP": "abrdn Global Premier Properties Mutual Fund",
  "AWR": "아메리칸 스테이츠 워터",
  "AWRE": "어웨어",
  "AWX": "아발론 홀딩스",
  "AX": "액소스 파이낸셜",
  "AXG": "솔로윈 홀딩스",
  "AXGN": "옥소젠",
  "AXIL": "악실 브랜즈",
  "AXIN": "액시엄 인텔리전스 애퀴지션 1",
  "AXON": "액손 엔터프라이스",
  "AXP": "아메리칸 익스프레스",
  "AXR": "앰렙",
  "AXS": "액시스 캐피털 홀딩스",
  "AXS-P-E": "액시스 캐피털 홀딩스",
  "AXSM": "액섬 테라퓨틱스",
  "AXTA": "엑솔타 코팅 시스템즈",
  "AXTI": "Axt",
  "AYA": "아야 골드 앤 실버",
  "AYI": "어큐이티",
  "AYTU": "아이투 바이오파마",
  "AZ": "A2Z 커스투메이트 솔루션스",
  "AZI": "오토지 인터넷 테크놀로지 (글로벌)",
  "AZIO": "아지오 AI 홀딩스",
  "AZN": "아스트라제네카",
  "AZO": "오토존",
  "AZTA": "아젠타",
  "AZTR": "아지트라",
  "AZUL": "아줄 ADR",
  "AZZ": "Azz",
  "B": "바릭 마이닝",
  "BA": "보잉",
  "BA-P-A": "보잉",
  "BABA": "알리바바 그룹 홀딩스 ADR",
  "BAC": "뱅크오브아메리카",
  "BAC-P-B": "뱅크오브아메리카",
  "BAC-P-E": "뱅크오브아메리카",
  "BAC-P-K": "뱅크오브아메리카",
  "BAC-P-L": "뱅크오브아메리카",
  "BAC-P-M": "뱅크오브아메리카",
  "BAC-P-N": "뱅크오브아메리카",
  "BAC-P-O": "뱅크오브아메리카",
  "BAC-P-P": "뱅크오브아메리카",
  "BAC-P-Q": "뱅크오브아메리카",
  "BAC-P-S": "뱅크오브아메리카",
  "BACC": "블루 애퀴지션",
  "BAER": "브리저 에어로스페이스 그룹 홀딩스",
  "BAFN": "베이퍼스트 파이낸셜",
  "BAH": "부즈 앨런 해밀턴 홀딩",
  "BAK": "브라스켐 ADR",
  "BALL": "볼",
  "BALY": "발리스",
  "BAM": "브룩필드 애셋 매니지먼트",
  "BANC": "캘리포니아 은행",
  "BANC-P-F": "캘리포니아 은행",
  "BAND": "밴드위스",
  "BANF": "뱅크퍼스트",
  "BANFP": "BFC 캐피탈 트러스트 II 우선주 7.2%",
  "BANL": "CBL 인터내셔널",
  "BANR": "배너",
  "BANX": "애로우마크 파이낸셜",
  "BAOS": "바오셩 미디어 그룹 홀딩스",
  "BAP": "크레디코프",
  "BARK": "바크",
  "BATL": "바탈리온 오일",
  "BATRA": "아틀란타 브레이브스 홀딩스 Series A",
  "BATRK": "아틀란타 브레이브스 홀딩스 Series C",
  "BAX": "박스터 인터내셔널",
  "BB": "블랙베리",
  "BBAI": "빅베어 AI 홀딩스",
  "BBAR": "뱅코 BBVA 아르헨티나 ADR",
  "BBBY": "베드 배스 앤드 비욘드",
  "BBCP": "콘크리트 펌핑 홀딩스",
  "BBCQ": "블라이크로더 애퀴지션 II",
  "BBD": "방쿠 브라데스쿠 우선주 ADR",
  "BBDC": "베어링스 BDC",
  "BBDO": "Banco Bradesco ADS Representing 1 Ord Shs",
  "BBGI": "비슬리 브로드캐스트 그룹",
  "BBIO": "브릿지바이오 파머",
  "BBLG": "본 바이올로직스",
  "BBN": "BlackRock Taxable Municipal Bond Trust",
  "BBNX": "베타 바이오닉스",
  "BBOT": "브릿지바이오 온콜로지 테라퓨틱스",
  "BBSI": "바렛 비지니스 서비스",
  "BBT": "비콘 파이낸셜",
  "BBUC": "브룩필드 비즈니스 홀딩스",
  "BBVA": "방코 빌바오 비스카야 아르헨타리아 ADR",
  "BBW": "빌드어베어 워크숍",
  "BBWI": "배스 앤 바디 웍스",
  "BBY": "베스트 바이",
  "BC": "브런스윅",
  "BCAB": "바이오아틀라",
  "BCAL": "캘리포니아 뱅코프",
  "BCAR": "디 보럴 ARC 애퀴지션 I",
  "BCAT": "BlackRock Capital Allocation Term Closed End Fund",
  "BCAX": "바이카라 테라퓨틱스",
  "BCBP": "BCB 뱅코프",
  "BCC": "보이시 캐스케이드",
  "BCCQ": "블라이크뢰더 애퀴지션 III",
  "BCDA": "바이오카디아",
  "BCE": "Bce",
  "BCG": "비나 캐피털 그룹",
  "BCH": "방코 데 칠레 ADR",
  "BCHT": "버치테크",
  "BCIC": "BCP 인베스트먼트",
  "BCML": "베이컴",
  "BCO": "브링크스",
  "BCPC": "발켐",
  "BCRX": "바이오크리스트 파마슈티컬스",
  "BCS": "바클레이즈 ADR",
  "BCSF": "배인 캐피털 스페셜티 파이낸스",
  "BCSS": "베인 캐피털 GSS 인베스트먼트",
  "BCTX": "브리아셀 테라퓨틱스",
  "BCV": "Bancroft Closed Fund",
  "BCV-P-A": "Bancroft Closed Fund",
  "BCX": "Blackrock Resourcescommodities Strategy Trust",
  "BCYC": "바이시클 테라퓨틱스 ADR",
  "BDC": "벨던",
  "BDCI": "BTC 디벨롭먼트",
  "BDJ": "BlackRock Enhanced Equity Dividend Trust",
  "BDL": "플래니건스 엔터프라이시스",
  "BDMD": "베어드 메디컬 인베스트먼트 홀딩스",
  "BDN": "브랜디와인 리얼티 트러스트",
  "BDRX": "바이오덱사 파마슈티컬스 ADR",
  "BDSX": "바이오데식스",
  "BDTX": "블랙 다이아몬드 테라퓨틱스",
  "BDX": "벡톤 디킨슨 앤 코",
  "BE": "블룸 에너지",
  "BEAG": "볼드 이글 애퀴지션",
  "BEAM": "빔 테라퓨틱스",
  "BEAT": "하트빔",
  "BEBE": "TGE 밸류 크리에이티브 솔루션즈",
  "BEEM": "빔 글로벌",
  "BEEP": "모바일 인프라스트럭처",
  "BEKE": "KE 홀딩스 ADR",
  "BELFA": "벨 퓨즈 Class A",
  "BELFB": "벨 퓨즈 Class B",
  "BEN": "프랭클린 리소시스",
  "BENF": "베네피션트",
  "BEP": "Brookfield Renewable Partners L.P.",
  "BEP-P-A": "Brookfield Renewable Partners L.P. 5.25% Class A Preferred",
  "BEPC": "브룩필드 리뉴어블 리뉴어블",
  "BESS": "비머젠 에너지",
  "BETA": "베타 테크놀로지스",
  "BETR": "베터 홈 & 파이낸스 홀딩스",
  "BF-A": "Brown-Forman Corporation Class A",
  "BF-B": "Brown-Forman Corporation Class B",
  "BFAM": "브라이트 호라이즌 패밀리 솔루션",
  "BFC": "뱅크 퍼스트",
  "BFH": "브레드 파이낸셜 홀딩스",
  "BFH-P-A": "브레드 파이낸셜 홀딩스",
  "BFH-P-B": "브레드 파이낸셜 홀딩스",
  "BFLY": "버터플라이 네트워크",
  "BFRG": "불프로그 AI 홀딩스",
  "BFRI": "바이오프론테라",
  "BFS": "솔 센터스",
  "BFS-P-D": "솔 센터스",
  "BFS-P-E": "솔 센터스",
  "BFST": "비즈니스 퍼스트 뱅크셰어스",
  "BG": "번지 글로벌",
  "BGB": "Blackstone Strategic Credit 2027 Term Fund",
  "BGC": "Bgc 그룹",
  "BGDE": "빅 디지털 에너지",
  "BGH": "Barings Global Short Duration High Yield Fund",
  "BGI": "버크스 그룹",
  "BGIN": "비긴 블록체인",
  "BGL": "블루 골드",
  "BGLC": "바이오넥서스 진 랩",
  "BGM": "BGM 그룹",
  "BGMS": "바이오 그린 메드 솔루션",
  "BGR": "Blackrock Energy and Resources Trust",
  "BGS": "비앤지 푸즈",
  "BGSF": "Bgsf",
  "BGSI": "보이드 그룹 서비스",
  "BGT": "BlackRock Floating Rate Income Closed Fund",
  "BGX": "Blackstone Long-Short Credit",
  "BGY": "BlackRock Enhanced International Dividend Closed End Fund",
  "BH": "비글라리 홀딩스 Class B",
  "BH-A": "Biglari Holdings Inc. Class A Common Stock",
  "BHAV": "바브 애퀴지션",
  "BHB": "바 하버 뱅크셰어스",
  "BHC": "바슈 헬스 컴퍼니스",
  "BHE": "벤치마크 일렉트로닉스",
  "BHF": "브라이트하우스 파이낸셜",
  "BHFAM": "브라이트하우스 파이낸셜 우선주 시리즈 D 4.625%",
  "BHFAN": "브라이트하우스 파이낸셜 우선주 시리즈 C 5.375%",
  "BHFAO": "브라이트하우스 파이낸셜 우선주 시리즈 B 6.75%",
  "BHFAP": "브라이트하우스 파이낸셜 우선주 시리즈 A 6.6%",
  "BHK": "Blackrock Core Bd Tr",
  "BHM": "블루락 홈즈 트러스트",
  "BHP": "BHP 그룹 ADR",
  "BHR": "브레이마 호텔 & 리조트",
  "BHR-P-B": "브레이마 호텔 & 리조트",
  "BHR-P-D": "브레이마 호텔 & 리조트",
  "BHRB": "버크 & 허버트 파이낸셜 서비스",
  "BHST": "바이오하베스트 사이언스",
  "BHV": "BlackRock Virginia Muni Bond Trust",
  "BHVN": "바이오헤이븐",
  "BIAF": "바이오어피니티 테크놀로지스",
  "BID": "트라이베카 스트래티직 애퀴지션",
  "BIDU": "바이두 ADR",
  "BIIB": "바이오젠",
  "BIII": "블랙 스페이드 애퀴지션 III",
  "BILI": "빌리빌리 ADR",
  "BILL": "빌닷컴 홀딩스",
  "BIO": "바이오래드 래보라토리스 Class A",
  "BIO-B": "Bio-Rad Laboratories, Inc. Class B",
  "BIOA": "바이오에이지 랩스",
  "BIOT": "렐러티비티 애퀴지션",
  "BIOX": "바이오케레스 크랍 솔루션즈",
  "BIP": "Brookfield Infrastructure Partners L.P.",
  "BIP-P-A": "Brookfield Infrastructure Partners L.P. 5.125% Class A Preferred",
  "BIP-P-B": "Brookfield Infrastructure Partners L.P. 5.000% Class A Preferred",
  "BIPC": "브룩필드 인프라스트럭처",
  "BIRD": "스마트버드",
  "BIRK": "버컨스톡 홀딩",
  "BIT": "Blackrock Multi-Sector",
  "BIVI": "바이오비",
  "BIXI": "비트코인 인프라스트럭처 애퀴지션",
  "BIYA": "바이야 인터내셔널 그룹",
  "BJ": "BJ's 홀세일 클럽 홀딩스",
  "BJDX": "블루제이 다이어그노스틱스",
  "BJRI": "비제이스 레스토랑",
  "BKD": "브룩데일 시니어 리빙",
  "BKE": "버클",
  "BKH": "블랙 힐스",
  "BKHA": "블랙 호크 애퀴지션",
  "BKKT": "백트",
  "BKNG": "부킹 홀딩스",
  "BKR": "베이커 휴즈",
  "BKSY": "블랙스카이 테크놀로지",
  "BKT": "BlackRock Income Trust，Inc.",
  "BKTI": "BK 테크놀로지스",
  "BKU": "뱅크유나이티드",
  "BKV": "Bkv",
  "BKYI": "바이오키 인터내셔널",
  "BL": "블랙라인",
  "BLBD": "블루 버드",
  "BLCO": "바슈롬",
  "BLDP": "발라드 파워 시스템즈",
  "BLDR": "빌더스 퍼스트소스",
  "BLFS": "바이오라이프 솔루션스",
  "BLIN": "브릿지라인 디지털",
  "BLIV": "비라이브 홀딩스",
  "BLK": "블랙록",
  "BLKB": "블랙보드",
  "BLLN": "빌리언투원",
  "BLMN": "블루민 브랜즈",
  "BLND": "블렌드 랩스",
  "BLNE": "비라인 홀딩스",
  "BLNK": "블링크 차징",
  "BLRK": "블루록 애퀴지션",
  "BLRX": "바이오라인 RX ADR",
  "BLSH": "불리쉬",
  "BLSM": "BlossomHill Therapeutics Inc",
  "BLTE": "비라이트 바이오 ADR",
  "BLUW": "블루 워터 애퀴지션 III",
  "BLW": "Blackrock",
  "BLX": "블라덱스",
  "BLZE": "백블레이즈",
  "BLZR": "트레일블래이저 애퀴지션",
  "BMA": "방코 마크로 ADR",
  "BMBL": "범블",
  "BME": "Blackrock Health Sciences Trust",
  "BMEA": "바이오미아 퓨전",
  "BMEZ": "BlackRock Health Sciences Term Closed End Fund",
  "BMGL": "바젤 메디컬 그룹",
  "BMHL": "블루마운트 홀딩스",
  "BMI": "배저 미터",
  "BML-P-G": "뱅크오브아메리카 우선주 시리즈 5",
  "BML-P-H": "뱅크오브아메리카 우선주 시리즈 5",
  "BML-P-J": "뱅크오브아메리카 우선주 시리즈 5",
  "BML-P-L": "뱅크오브아메리카 우선주 시리즈 5",
  "BMM": "블루문 메탈스",
  "BMN": "BlackRock 2037 Municipal Target Term Trust",
  "BMNP": "비트마인 이머전 테크놀로지스 우선주 Series A 9.5%",
  "BMNR": "비트마인 이머전 테크놀로지스",
  "BMO": "뱅크 오브 몬트리올",
  "BMR": "비머 이미징",
  "BMRA": "바이오메리카",
  "BMRC": "뱅크 오브 마린 뱅코프",
  "BMRN": "바이오마린 파마슈티컬",
  "BMY": "브리스톨-마이어스 스큅",
  "BN": "브룩필드",
  "BNAI": "브랜드 인게이지먼트 네트워크",
  "BNC": "CEA 인더스트리스",
  "BNED": "반스 앤 노블 에듀케이션",
  "BNGO": "바이오나노 지노믹스",
  "BNKK": "봉크",
  "BNL": "브로드스톤 넷 리스",
  "BNR": "버닝 락 바이오테크 ADR",
  "BNRG": "브렌밀러 에너지",
  "BNS": "뱅크 오브 노바 스코샤",
  "BNT": "브룩필드 웰스 솔루션스",
  "BNTC": "베니텍 바이오파마",
  "BNTX": "바이오엔테크 ADR",
  "BNY": "뉴욕멜론은행",
  "BNY-P-K": "뉴욕멜론은행",
  "BOBS": "밥스 디스카운트 퍼니처",
  "BOC": "보스톤 오마하",
  "BODI": "비치바디 컴퍼니",
  "BOE": "BlackRock Enhanced Global Dividend Closed End Fund",
  "BOF": "브랜치아웃 푸드",
  "BOH": "뱅크 오브 하와이",
  "BOH-P-A": "뱅크 오브 하와이",
  "BOH-P-B": "뱅크 오브 하와이",
  "BOKF": "BOK 파이낸셜",
  "BOLD": "바운드리스 바이오",
  "BOLT": "볼트 바이오테라퓨틱스",
  "BON": "본 내추럴 라이프",
  "BOOM": "DMC 글로벌",
  "BOOT": "부트 반 홀딩스",
  "BORR": "보르 드릴링",
  "BOSC": "B.O.S. 베터 온라인 솔루션스",
  "BOT": "로보스트래티지",
  "BOTJ": "뱅크 오브 더 제임스 파이낸셜",
  "BOW": "보우헤드 스페셜티 홀딩스",
  "BOX": "박스",
  "BOXL": "박스라잇",
  "BP": "BP p.l.c.",
  "BPAC": "블루포트 애퀴지션",
  "BPOP": "파퓰러",
  "BPOPM": "파퓰러 캐피탈 트러스트 II 우선주 6.125%",
  "BPRE": "Bluerock Private Real Estate Fund",
  "BPRN": "뱅크 오브 프린스턴",
  "BQ": "Boqii Holding Ltd",
  "BR": "브로드리지 파이낸셜 솔루션스",
  "BRAG": "브래그 게이밍 그룹",
  "BRAI": "브레인",
  "BRBI": "BRBI BR 파트너스 ADR",
  "BRBR": "벨링 브랜드",
  "BRBS": "블루 리지 뱅크셰어스",
  "BRC": "BRC",
  "BRCB": "블랙 락 커피 바",
  "BRCC": "Brc",
  "BREZ": "브리즈 애퀴지션 II",
  "BRFH": "바프레시 푸드 그룹",
  "BRIA": "브릴리아",
  "BRID": "브리지포드 푸즈",
  "BRK-A": "Berkshire Hathaway Inc.",
  "BRK-B": "BERKSHIRE HATHAWAY Class B",
  "BRKH": "버테크 애퀴지션 II",
  "BRKR": "브루커",
  "BRKRP": "브루커 우선주 Series A 6.375%",
  "BRLS": "보레알리스 푸드",
  "BRLT": "브릴리언트 어스 그룹",
  "BRN": "반웰 인더스트리스",
  "BRNS": "바린투스 바이오테라퓨틱스 ADR",
  "BRO": "브라운 & 브라운",
  "BROS": "더치 브로스",
  "BRR": "프로캡 파이낸셜",
  "BRSL": "브라이트스타 로터리",
  "BRSP": "브라이트스파이어 캐피탈",
  "BRT": "BRT 아파트먼트",
  "BRTX": "바이오리스토러티브 테라피스",
  "BRUN": "부스트 런",
  "BRVE": "브레이브하트 바이오",
  "BRW": "Saba Capital Income & Opportunities Fund",
  "BRX": "브릭스모어 프로퍼티 그룹",
  "BRZE": "브레이즈",
  "BSAA": "베스트 스팩 I 애퀴지션",
  "BSAC": "방코 산탄데르 칠레 ADR",
  "BSBK": "보고타 파이낸셜",
  "BSBR": "방쿠 산탄데르 브라질 ADR",
  "BSEM": "BioStem Technologies  Inc.",
  "BSET": "바셋 퍼니처 인더스트리스",
  "BSIN": "빅 스카이 인더스트리얼",
  "BSL": "Blackstone Senior Floating Rate 2027 Term Fund",
  "BSM": "Black Stone Minerals, L.P.",
  "BSP": "벤딩 스푼스",
  "BSRR": "시에라 뱅코프",
  "BST": "BlackRock Science and Technology Trust",
  "BSTZ": "BlackRock Science and Technology Term Closed End Fund",
  "BSVN": "뱅크7",
  "BSX": "보스턴 사이언티픽",
  "BSY": "벤틀리 시스템즈",
  "BTAI": "바이오X셀 테라퓨틱스",
  "BTBD": "BT 브랜즈",
  "BTBT": "비트 디지털",
  "BTCS": "Btcs",
  "BTCT": "BTC 디지털",
  "BTDR": "빗디어 테크놀로지스",
  "BTE": "배이텍스 에너지",
  "BTG": "B2골드",
  "BTGO": "비트고 홀딩스",
  "BTI": "브리티쉬 아메리칸 토바코 ADR",
  "BTMD": "바이오티",
  "BTO": "John Hancock Financial Opportunities Fund",
  "BTOC": "암로지 홀딩",
  "BTOG": "비트 오리진",
  "BTQ": "BTQ 테크놀로지스",
  "BTSG": "브라이트스프링 헬스 서비스",
  "BTT": "BlackRock Municipal 2030 Target Term Trust",
  "BTTC": "블랙 타이탄",
  "BTU": "피바디 에너지",
  "BTX": "BlackRock Technology and Private Equity Term Trust",
  "BTZ": "BlackRock Credit Allocation Income Trust",
  "BUD": "안호이저부시 인베브 ADR",
  "BUDA": "부다 주스",
  "BUI": "BlackRock Utilities Infrastructure & Power Oppty",
  "BULL": "위불",
  "BUR": "버포트 캐피털",
  "BURL": "벌링턴 스토어스",
  "BUSE": "퍼스트 뷰지",
  "BUSEP": "퍼스트 뷰지 우선주 Series B 8.25%",
  "BUUU": "BUUU 그룹",
  "BV": "브라이트뷰 홀딩스",
  "BVC": "BitVentures Ltd",
  "BVFL": "Bv 파이낸셜",
  "BVN": "미나스 부에나벤투라 ADR",
  "BVS": "바이오벤투스",
  "BW": "밥콕 앤 윌콕스 엔터프라이스",
  "BW-P-A": "밥콕 앤 윌콕스 엔터프라이스",
  "BWA": "보그워너",
  "BWAY": "브레인스웨이 ADR",
  "BWB": "브릿지워터 뱅크셰어스",
  "BWBBP": "브릿지워터 뱅크셰어스 우선주 Series A 5.875%",
  "BWEN": "브로드윈드 에너지",
  "BWFG": "뱅크웰 파이낸셜 그룹",
  "BWG": "BrandywineGLOBAL Global",
  "BWIN": "볼드윈 인슈어런스 그룹",
  "BWIV": "블루 워터 애퀴지션 IV",
  "BWLP": "Bw Lpg",
  "BWMN": "보우만 컨설팅 그룹",
  "BWMX": "베터웨어 데 멕시코",
  "BWXT": "BWX 테크놀로지스",
  "BX": "블랙스톤",
  "BXBL": "FG 머저 II",
  "BXC": "블루링스 홀딩스",
  "BXDC": "블랙스톤 디지털 인프라 트러스트",
  "BXMT": "블랙스톤 모기지 트러스트",
  "BXP": "Bxp",
  "BXSL": "블랙스톤 시큐어드 렌딩 펀드",
  "BY": "바이라인 뱅코프",
  "BYAH": "파크 하 바이오테크",
  "BYD": "보이드 게이밍",
  "BYFC": "브로드웨이 파이낸셜",
  "BYND": "비욘드 미트",
  "BYRN": "버나 테크놀로지스",
  "BYSI": "비욘드스프링",
  "BZ": "칸준 ADR",
  "BZAI": "블레이즈 홀딩스",
  "BZFD": "버즈피드",
  "BZH": "비저 홈스 USA",
  "BZUN": "바오준 ADR",
  "C": "씨티그룹",
  "C-P-N": "씨티그룹",
  "C-P-R": "씨티그룹",
  "CAAP": "코퍼래시온 어메리카 에어포츠",
  "CAAS": "중국 오토모티브 시스템",
  "CABA": "카발레타 바이오",
  "CABO": "케이블 원",
  "CABR": "케어링 브랜즈",
  "CAC": "캠던 내셔널",
  "CACC": "크레디트 억셉턴스",
  "CACI": "CACI 인터내셔널",
  "CADL": "캔델 테라퓨틱스",
  "CAE": "CAE",
  "CAES": "캔터 에퀴티 파트너스 VII",
  "CAF": "Morgan Stanley China A Share Closed Fund",
  "CAG": "콘아그라 브랜즈",
  "CAH": "카디널 헬스",
  "CAI": "카리스 라이프 사이언시스",
  "CAII": "콜렉티브 애퀴지션 II",
  "CAKE": "치즈케익 팩토리",
  "CAL": "컬레러스",
  "CALC": "캘시메디카",
  "CALM": "칼 메인 푸즈",
  "CALX": "캘릭스",
  "CALY": "캘러웨이 골프",
  "CAMP": "캠프4 테라퓨틱스",
  "CAMT": "캠텍",
  "CAN": "카난 ADR",
  "CANF": "캔 파이트 바이오파바 ADR",
  "CANG": "캉고",
  "CAPL": "CrossAmerica Partners LP Common units representing",
  "CAPN": "케이슨 애퀴지션",
  "CAPR": "캐프리코 테라퓨틱스",
  "CAPS": "캡스톤 홀딩",
  "CAQ": "캠브리지 애퀴지션",
  "CAR": "에이비스 버짓 그룹",
  "CARE": "카터 뱅크셰어스",
  "CARG": "카구루스",
  "CARL": "칼스메드",
  "CARR": "캐리어 글로벌",
  "CARS": "카스닷컴",
  "CART": "메이플베어",
  "CASH": "패스워드 파이낸셜",
  "CASS": "캐스 인포메이션 시스템즈",
  "CAST": "프리캐스트",
  "CASY": "케이시스 제너럴 스토어스",
  "CAT": "캐터필러",
  "CATO": "케이토",
  "CATX": "퍼스펙티브 테라퓨틱스",
  "CATY": "캐세이 제너럴 뱅코프",
  "CAVA": "카바 그룹",
  "CB": "처브",
  "CBAN": "콜로니 뱅코프",
  "CBAT": "CBAK 에너지 테크놀러지",
  "CBC": "센트럴 밴컴퍼니",
  "CBFV": "CB 파이낸셜 서비스",
  "CBIO": "크레센트 바이오파마",
  "CBK": "커머셜 뱅크그룹",
  "CBL": "CBL & 어소시에이츠 프로퍼티스",
  "CBLL": "세리벨",
  "CBNA": "체인 브리지 뱅코프",
  "CBNK": "캐피털 뱅코프",
  "CBOE": "Cboe 글로벌 마켓",
  "CBRE": "CBRE 그룹",
  "CBRL": "크래커 배럴 올드 컨트리 스토어",
  "CBRS": "세레브라스 시스템스",
  "CBSH": "커머스 뱅크셰어스",
  "CBT": "캐보트",
  "CBU": "커뮤니티 파이낸셜 시스템",
  "CBUS": "씨버스",
  "CBZ": "CBIZ",
  "CC": "케무어스",
  "CCAP": "크레센트 캐피탈 BDC",
  "CCAQ": "콜렉티브 애퀴지션",
  "CCB": "코스탈 파이낸셜",
  "CCBG": "캐피털 시티 뱅크 그룹",
  "CCC": "CCC 인텔리전트",
  "CCCC": "C4 테라퓨틱스",
  "CCCT": "Columbus Circle Capital Corp III",
  "CCD": "Calamos Dynamic Convertible",
  "CCEC": "캐피털 클린 에너지 캐리어스",
  "CCEL": "크라이오-셀 인터내셔널",
  "CCEP": "코카-콜라 유로퍼시픽 파트너스",
  "CCG": "체체 그룹",
  "CCHH": "CCH 홀딩스",
  "CCI": "크라운 캐슬",
  "CCID": "칼라일 크레딧 인컴 우선주 Series D 7.375%",
  "CCIF": "Carlyle Credit Income Fund",
  "CCII": "코헨 서클 애퀴지션 II",
  "CCJ": "카메코",
  "CCK": "크라운 홀딩스",
  "CCL": "카니발",
  "CCLD": "케어 클라우드",
  "CCM": "콩코드 메디컬 서비스 홀딩스 ADR",
  "CCNE": "CNB 파이낸셜",
  "CCNEP": "CNB 파이낸셜 우선주 시리즈 A 7.125%",
  "CCO": "클리어 채널 아웃도어 홀딩스",
  "CCOI": "코젠트 커뮤니케이션스 홀딩스",
  "CCS": "센츄리 커뮤니티스",
  "CCSI": "콘센서스 클라우드 솔루션스",
  "CCTG": "CCSC 테크놀로지 인터내셔널 홀딩스",
  "CCU": "세르베세리아스 우니다스 ADR",
  "CCXI": "처칠 캐피털 XI",
  "CCZ": "컴캐스트 홀딩스 후순위 채권 2% 만기 2029년 10월",
  "CD": "체인스 디지털 홀딩스",
  "CDE": "쾨르 마이닝",
  "CDIO": "카디오 다이어그노스틱스",
  "CDLR": "카델러 A/S ADR",
  "CDLX": "카들리틱스",
  "CDNA": "케어Dx",
  "CDNL": "카디널 인프라스트럭처 그룹",
  "CDNS": "케이던스 디자인 시스템즈",
  "CDP": "COPT 디펜스 프로퍼티스",
  "CDR-P-B": "캐드리 홀딩스",
  "CDR-P-C": "캐드리 홀딩스",
  "CDRE": "캐드리 홀딩스",
  "CDRO": "코더 온라인 룩셈부르크",
  "CDT": "CDT 에퀴티",
  "CDTG": "CDT 인바이어런먼털 테크놀로지 인베스트먼트 홀딩스",
  "CDW": "Cdw",
  "CDXS": "코덱시스",
  "CDZI": "카디즈",
  "CDZIP": "카디즈 우선주 8.875%",
  "CE": "셀라니즈 코퍼레이션",
  "CECO": "CECO 인바이런먼털",
  "CEE": "Central and Eastern Europe Fund Inc",
  "CEG": "콘스텔레이션 에너지",
  "CELC": "셀큐이티",
  "CELH": "셀시어스 홀딩스",
  "CELU": "셀룰레리티",
  "CELZ": "크리에이티브 메디컬 테크놀로지 홀딩스",
  "CENN": "센트로",
  "CENT": "센트럴 가든 앤드 펫",
  "CENTA": "센트럴 가든 앤드 펫 Class A",
  "CENX": "센추리 알루미늄",
  "CEPF": "캔터 에쿼티 파트너스 IV",
  "CEPL": "캡스톤 에너지+",
  "CEPO": "칸토 에퀴티 파트너스 I",
  "CEPS": "캔터 에퀴티 파트너스 Vi",
  "CEPU": "센트럴 푸에르토 ADR",
  "CEPV": "칸토르 에퀴티 파트너스 V",
  "CERS": "세러스",
  "CERT": "서타라",
  "CET": "Central Securities Closed Fund",
  "CETX": "셈트렉스",
  "CETY": "클린 에너지 테크놀로지스",
  "CEV": "Eaton Vance California Municipal Income Closed Fund",
  "CEVA": "세바",
  "CF": "CF 인더스트리스 홀딩스",
  "CFBK": "CF 뱅크셰어스",
  "CFFI": "C&F 파이낸셜",
  "CFFN": "캐피톨 페더럴 파이낸셜",
  "CFG": "시티즌스 파이낸셜 그룹",
  "CFG-P-E": "시티즌스 파이낸셜 그룹",
  "CFG-P-H": "시티즌스 파이낸셜 그룹",
  "CFG-P-I": "시티즌스 파이낸셜 그룹",
  "CFND": "C1 펀드",
  "CFR": "컬런/프로스트 뱅커스",
  "CFR-P-B": "컬런/프로스트 뱅커스",
  "CFTR-P-A": "캔터 우선주 Series A 9.50%",
  "CG": "칼라일 그룹",
  "CGAU": "센테라 골드",
  "CGBD": "칼라일 시큐어드 렌딩",
  "CGC": "캐노피 그로스",
  "CGEM": "컬리넌 테라퓨틱스",
  "CGEN": "컴퓨젠",
  "CGNT": "코그나이트 소프트웨어",
  "CGNX": "코그넥스",
  "CGO": "Calamos Global Total Return Closed Fund",
  "CGON": "CG 온콜로지",
  "CGTL": "크리에이티브 글로벌 테크놀로지 홀딩스",
  "CGTX": "코그니션 테라퓨틱스",
  "CHA": "차지 홀딩스 ADR",
  "CHAI": "코어 AI 홀딩스",
  "CHAR": "찰톤 아리아 애퀴지션",
  "CHCI": "컴스톡 홀딩",
  "CHCO": "시티 홀딩",
  "CHCT": "커뮤니티 헬스케어 트러스트",
  "CHD": "처치 & 드와이트",
  "CHDN": "처칠 다운스",
  "CHE": "케미드",
  "CHEC": "청허 애퀴지션 III",
  "CHEF": "셰프스 웨어하우스",
  "CHGA": "체인지 에이전츠",
  "CHGG": "체그",
  "CHH": "초이스 호텔스 인터내셔널",
  "CHI": "Calamos Convertible Opportunities and Income Closed Fund",
  "CHKP": "체크 포인트 소프트웨어 테크놀로지",
  "CHMG": "셔멍 파이낸셜",
  "CHMI": "체리힐 모기지 인베스트먼트",
  "CHMI-P-A": "체리힐 모기지 인베스트먼트",
  "CHMI-P-B": "체리힐 모기지 인베스트먼트",
  "CHNR": "차이나 내츄럴 리소스",
  "CHOW": "차우차우 클라우드 인터내셔널 홀딩스",
  "CHPG": "챔피언스게이트 애퀴지션",
  "CHPT": "차지포인트 홀딩스",
  "CHR": "치어 홀딩",
  "CHRD": "코드 에너지",
  "CHRN": "크로노스케일",
  "CHRS": "코히러스 온콜로지",
  "CHRW": "CH 로빈슨 월드와이드",
  "CHSCL": "CHS 클래스 B 우선주 시리즈 4 7.5%",
  "CHSCM": "CHS 클래스 B 우선주 시리즈 3",
  "CHSCN": "CHS 클래스 B 우선주 시리즈 2",
  "CHSCO": "CHS 우선주 클래스 B 7.875%",
  "CHSCP": "CHS 우선주 8%",
  "CHSN": "샹송 인터내셔널 홀딩",
  "CHT": "중화 텔레콤 ADR",
  "CHTR": "차터 커뮤니케이션",
  "CHW": "Calamos Global Dynamic Income Closed Fund",
  "CHWY": "츄이",
  "CHY": "Calamos Convertible and High Income Closed Fund",
  "CHYM": "차임 파이낸셜",
  "CI": "The Cigna Group",
  "CIA": "시티즌스",
  "CIB": "Grupo Cibest S.A. American Preferred",
  "CIEN": "Ciena",
  "CIFR": "Cipher Digital",
  "CIG": "Companhia Energetica De Minas Gerais-CEMIG",
  "CIG-C": "Companhia Energetica De Minas Gerais-CEMIG",
  "CIGI": "콜리어스 인터내셔널 그룹",
  "CIGL": "콩코드 인터내셔널 그룹",
  "CII": "BlackRock Enhanced Large Cap Core Fund",
  "CIIT": "티안시 인터내셔널",
  "CIK": "Credit Suisse Asset Management Income Closed Fund",
  "CIM": "키메라 인베스트먼트",
  "CIM-P-A": "키메라 인베스트먼트",
  "CIM-P-B": "키메라 인베스트먼트",
  "CIM-P-C": "키메라 인베스트먼트",
  "CIM-P-D": "키메라 인베스트먼트",
  "CINF": "신시내티 파이낸셜",
  "CING": "싱귤레이트",
  "CINT": "Ci&T",
  "CION": "CION Investment",
  "CIRC": "Circle8 Group",
  "CISO": "세르베러스 사이버 센티넬",
  "CISS": "C3is",
  "CITR": "시트로테크",
  "CIVB": "시비스타 뱅크셰어스",
  "CIX": "Comp X International",
  "CJMB": "Callan JMB",
  "CKX": "CKX 랜드",
  "CL": "콜게이트-팜올리브",
  "CLAR": "클라루스",
  "CLB": "코어 래보라토리스",
  "CLBK": "콜롬비아 파이낸셜",
  "CLBR": "콜롬비어 애퀴지션 III",
  "CLBT": "셀레브라이트",
  "CLDI": "칼리디 바이오테라퓨틱스",
  "CLDT": "채텀 로징 트러스트",
  "CLDT-P-A": "Chatham Lodging Trust Series A Preferred",
  "CLDX": "셀덱스 테라퓨틱스",
  "CLF": "클리블랜드-클리프스",
  "CLFD": "클리어필드",
  "CLGN": "Collplant Biotechnologies Ltd",
  "CLH": "클린 하버스",
  "CLIK": "클릭 홀딩스",
  "CLIR": "클리어사인 테크놀로지스",
  "CLLS": "Cellectis S.A.",
  "CLM": "Cornerstone Strategic Investment Fund",
  "CLMB": "클라임 글로벌 솔루션스",
  "CLMT": "Calumet",
  "CLNE": "클린 에너지 퓨얼스",
  "CLNN": "클렌",
  "CLOV": "클로버 헬스 인베스트먼츠",
  "CLPR": "클리퍼 리얼티",
  "CLPS": "Clps",
  "CLPT": "클리어포인트 뉴로",
  "CLRB": "셀렉타 바이오사이언시스",
  "CLRO": "클리어원",
  "CLS": "셀레스티카",
  "CLSK": "클린스파크",
  "CLST": "카탈리스트 뱅코프",
  "CLVT": "클래리베이트",
  "CLW": "클린워터 페이퍼",
  "CLWT": "유로 테크 홀딩스 컴퍼니",
  "CLX": "크로락스",
  "CLYM": "클라임 바이오",
  "CM": "캐내디언 임페리얼 뱅크 오브 커머스",
  "CMBT": "CMB.테크",
  "CMC": "커머셜 메탈스",
  "CMCL": "칼레도니아 마이닝",
  "CMCM": "치타 모바일 ADR",
  "CMCO": "컬럼버스 매키넌",
  "CMCSA": "컴캐스트",
  "CMCT": "크리에이티브 미디어 & 커뮤니티 트러스트",
  "CMDB": "코스타마레 벌커스 홀딩스",
  "CME": "CME 그룹",
  "CMG": "치폴레 멕시칸 그릴",
  "CMI": "커민스",
  "CMII": "콜럼버스 서클 캐피털 II",
  "CMMB": "키모맵 테라퓨틱스 ADR",
  "CMND": "클리어마인드 메디슨",
  "CMP": "컴퍼스 미네랄스 인터내셔널",
  "CMPR": "심프레스",
  "CMPS": "컴퍼스패스웨이스 ADR",
  "CMPX": "컴퍼스 테라퓨틱스",
  "CMRC": "커머스닷컴 Series 1",
  "CMRE": "코스타마레",
  "CMRE-P-B": "코스타마레",
  "CMRE-P-C": "코스타마레",
  "CMRE-P-D": "코스타마레",
  "CMS": "CMS 에너지",
  "CMS-P-B": "CMS 에너지",
  "CMS-P-C": "CMS 에너지",
  "CMT": "코어 몰딩 테크놀로지스",
  "CMTG": "클라로스 모기지 트러스트",
  "CMTL": "컴테크 텔레커뮤니케이션스",
  "CMTV": "커뮤니티 뱅코프",
  "CNA": "CNA 파이낸셜",
  "CNC": "센틴",
  "CNCK": "코인체크 그룹",
  "CNDT": "컨듀언트",
  "CNET": "ZW 데이터 액션 테크놀로지스",
  "CNEY": "CN 에너지 그룹",
  "CNF": "CN파이낸스 홀딩스 ADR",
  "CNH": "CNH 인더스트리얼",
  "CNI": "커네디언 내셔널 레일웨이",
  "CNK": "시네마크 홀딩스",
  "CNL": "콜렉티브 마이닝",
  "CNM": "코어 & 메인",
  "CNMD": "콘메드",
  "CNNE": "칸네 홀딩스",
  "CNO": "CNO 파이낸셜 그룹",
  "CNOB": "커넥트원 뱅코프",
  "CNOBP": "커넥트원 뱅코프 우선주 시리즈 A 5.25%",
  "CNP": "센터포인트 에너지",
  "CNQ": "캐나다 내추럴 리소시스",
  "CNR": "코어 내추럴 리소시스",
  "CNS": "코헨 & 스티어스",
  "CNSP": "CNS 파마슈티컬스",
  "CNSY": "플러스 테라퓨틱스",
  "CNTB": "Connect Biopharma Holdings Ltd",
  "CNTN": "칸톤 스트래티직 홀딩스",
  "CNTX": "콘텍스트 테라퓨틱스",
  "CNTY": "센추리 카지노스",
  "CNVS": "시네버스",
  "CNX": "CNX 리소스",
  "CNXC": "콘센트릭스",
  "CNXN": "PC 커넥션",
  "CNXU": "코넥스유 사이언시스",
  "COAG": "헤맙 테라퓨틱스 홀딩스",
  "COCH": "엔보이 메디컬",
  "COCO": "비타 코코 컴퍼니",
  "COCP": "코크리스털 파마",
  "CODA": "코다 옥토퍼스 그룹",
  "CODI": "컴퍼스 다이버시파이드 홀딩스",
  "CODI-P-A": "컴퍼스 다이버시파이드 홀딩스",
  "CODI-P-B": "컴퍼스 다이버시파이드 홀딩스",
  "CODI-P-C": "컴퍼스 다이버시파이드 홀딩스",
  "CODX": "코 다이어그노틱스",
  "COE": "51토크 온라인 에듀케이션 그룹 ADR",
  "COF": "캐피털 원 파이낸셜",
  "COF-P-I": "캐피털 원 파이낸셜",
  "COF-P-J": "캐피털 원 파이낸셜",
  "COF-P-K": "캐피털 원 파이낸셜",
  "COF-P-L": "캐피털 원 파이낸셜",
  "COF-P-N": "캐피털 원 파이낸셜",
  "COFS": "초이스원 파이낸셜 서비스",
  "COGT": "코젠트 바이오사이언시스",
  "COHN": "코헨 앤 컴퍼니",
  "COHR": "코히런트",
  "COHU": "코후",
  "COIN": "코인베이스 글로벌",
  "COKE": "코카콜라 콘솔리데이티드",
  "COLA": "콜롬버스 애퀴지션",
  "COLB": "컬럼비아 뱅킹 시스템",
  "COLD": "아메리콜드 리얼티 트러스트",
  "COLL": "콜레지움 파마슈티컬",
  "COLM": "컬럼비아 스포츠웨어",
  "COMP": "컴퍼스",
  "CON": "콘센트라 그룹 홀딩스",
  "COO": "쿠퍼 컴퍼니스",
  "COOK": "트래저",
  "COOT": "오스트레일리안 오일시드 홀딩스",
  "COP": "코노코필립스",
  "COPL": "코플리 애퀴지션",
  "COPR": "아이다호 코퍼",
  "COR": "센코라",
  "CORT": "코셉트 테라퓨틱스",
  "CORZ": "코어 사이언티픽",
  "COSM": "코스모스 헬스",
  "COSO": "코스탈사우스 뱅크셰어스",
  "COST": "코스트코 홀세일",
  "COTY": "코티",
  "COUR": "코세라",
  "COYA": "코야 테라퓨틱스",
  "CP": "캐나디안 퍼시픽 캔자스 시티",
  "CPA": "코파 홀딩스",
  "CPAC": "세멘토스 파카스마요 ADR",
  "CPAY": "콜페이",
  "CPB": "캠벨스",
  "CPBI": "센트럴 플레인스 뱅크셰어스",
  "CPF": "센트럴 퍼시픽 파이낸셜",
  "CPHC": "캔터베리 파크 홀딩",
  "CPHI": "차이나 파마 홀딩스",
  "CPIX": "컴벌랜드 파마슈티컬스",
  "CPK": "체사피크 유틸리티스",
  "CPNG": "쿠팡",
  "CPOP": "팝 컬처 그룹",
  "CPRI": "카프리홀딩스",
  "CPRT": "코파트",
  "CPS": "쿠퍼-스탠더드 홀딩스",
  "CPSH": "CPS 테크놀러지",
  "CPSS": "컨슈머 포트폴리오 서비스",
  "CPT": "캠든 프로퍼티 트러스트",
  "CPZ": "Calamos Long Short Equity Dynamic Income Trust Closed Fund",
  "CQP": "Cheniere Energy Partners, LP",
  "CR": "크레인 홀딩스",
  "CRAC": "크라운 리저브 애퀴지션 I",
  "CRAI": "CRA 인터내셔널",
  "CRAN": "크레인 하버 애퀴지션 II",
  "CRAQ": "칼 레드우드 애퀴지션",
  "CRBG": "코어브릿지 파이낸셜",
  "CRBP": "코버스 파마슈티컬스 홀딩스",
  "CRBU": "카리부 바이오사이언시스",
  "CRC": "캘리포니아 리소시스",
  "CRCL": "써클 인터넷 그룹",
  "CRCT": "크리컷",
  "CRD-A": "CrawfordCompany Class A",
  "CRD-B": "CrawfordCompany Class B",
  "CRDF": "카디프 온콜로지",
  "CRDL": "카디올 테라퓨틱스",
  "CRDO": "크레도 테크놀로지 그룹 홀딩",
  "CRE": "Cre8 엔터프라이즈",
  "CRESY": "크레수드 ADR",
  "CREX": "크리에이티브 리얼리티스",
  "CRF": "Cornerstone Total Return Closed Fund",
  "CRGO": "프레이토스",
  "CRGY": "크레센트 에너지",
  "CRH": "CRH Public",
  "CRI": "카터스",
  "CRIS": "큐리스",
  "CRK": "캄스톡 리소시즈",
  "CRL": "찰스 리버 래보라토리스 인터내셔널",
  "CRM": "세일즈포스",
  "CRMD": "코메딕스",
  "CRML": "크리티컬 메탈스",
  "CRMT": "아메리카스 카-마트",
  "CRNC": "세렌스",
  "CRNT": "세라콘 네트웍스",
  "CRNX": "크리네틱스 파머슈티컬스",
  "CRON": "크로노스 그룹",
  "CROX": "크록스",
  "CRS": "카펜터 테크놀로지",
  "CRSP": "크리스퍼 테라퓨틱스",
  "CRSR": "커세어 게이밍",
  "CRT": "Cross Timbers Royalty Units",
  "CRTO": "크리테오",
  "CRUS": "시러스 로직",
  "CRVL": "코벨",
  "CRVO": "세르보메드",
  "CRVS": "코버스 파마슈티컬스",
  "CRWD": "크라우드 스트라이크 홀딩스",
  "CRWS": "크라운 크래프츠",
  "CRWV": "코어위브",
  "CSAI": "클라우다스트럭쳐",
  "CSAN": "코샌 ADR",
  "CSBR": "챔피언스 온콜로지",
  "CSCO": "시스코 시스템즈",
  "CSGP": "코스타 그룹",
  "CSHR": "코인셰어스",
  "CSIQ": "캐나디안 솔라",
  "CSL": "칼라일",
  "CSPI": "Csp",
  "CSQ": "Calamos Strategic Total Return Closed Fund",
  "CSQR": "씨스퀘어",
  "CSR": "센터스페이스",
  "CSTE": "시저스톤",
  "CSTL": "캐슬 바이오사이언스",
  "CSTM": "콘스텔리움",
  "CSV": "캐리지 서비스",
  "CSW": "CSW 인더스트리얼즈",
  "CSWC": "캐피탈 사우스웨스트",
  "CSX": "Csx",
  "CTA-P-A": "Eidp",
  "CTA-P-B": "Eidp",
  "CTAA": "클리어씽크 1 애퀴지션",
  "CTAS": "신타스",
  "CTBI": "커뮤니티 트러스트 뱅코프",
  "CTEV": "클라리텝",
  "CTGO": "콘탱고 실버 앤 골드",
  "CTKB": "사이텍 바이오사이언시스",
  "CTM": "카스텔럼",
  "CTMX": "사이톰엑스 테라퓨틱스",
  "CTNM": "콘티네움 테라퓨틱스",
  "CTNT": "치타 넷 서플라이 체인 서비스",
  "CTO": "CTO 리얼티 그로스",
  "CTO-P-A": "CTO 리얼티 그로스",
  "CTOR": "시티우스 온콜로지",
  "CTOS": "커스텀 트럭 원 소스",
  "CTRE": "케어트러스트 리츠 (REIT)",
  "CTRI": "센추리 홀딩스",
  "CTRM": "캐스터 마리타임",
  "CTRN": "시티 트렌즈",
  "CTS": "Cts",
  "CTSH": "코그니전트 테크놀로지 솔루션",
  "CTSO": "사이토소벤츠",
  "CTVA": "코르테바",
  "CTW": "CTW Class A",
  "CTXR": "시티우스 파마슈티컬스",
  "CUB": "라이온하트 홀딩스",
  "CUBE": "큐브스마트",
  "CUBI": "커스터머스 뱅코프",
  "CUE": "큐 바이오파마",
  "CULP": "컬프",
  "CUPR": "커프리나 홀딩스 (Cayman)",
  "CURB": "커브라인 프로퍼티스",
  "CURI": "큐리어시티스트림",
  "CURR": "커렌크 그룹",
  "CURV": "토리드 홀딩스",
  "CURX": "큐라넥스 파마슈티컬스",
  "CUVL": "클리누벨 파마슈티컬스 ADR",
  "CUZ": "커즌스 프로퍼티스",
  "CV": "캡소비전",
  "CVBF": "CVB 파이낸셜",
  "CVCO": "카브코 인더스트리스",
  "CVE": "세노버스 에너지",
  "CVEO": "시비오",
  "CVGI": "커머셜 비히클 그룹",
  "CVI": "CVR 에너지",
  "CVKD": "커드리널 테라퓨틱스",
  "CVLG": "코버넌트 로지스틱스 그룹",
  "CVLT": "컴볼트 시스템즈",
  "CVM": "셀 사이",
  "CVNA": "카바나",
  "CVR": "시카고 리벳 & 머신",
  "CVRX": "CVR엑스",
  "CVS": "CVS 헬스",
  "CVSA": "코비스타",
  "CVU": "CPI 에어로스트럭처스",
  "CVV": "CVD 이큅먼트",
  "CVX": "셰브론",
  "CW": "커티스 라이트",
  "CWBC": "커뮤니티 웨스트 뱅크셰어스",
  "CWCO": "콘솔리데이티드 워터",
  "CWD": "캘리버코스",
  "CWEN": "클리어웨이 에너지 Class C",
  "CWH": "캠핑 월드 홀딩스",
  "CWK": "쿠쉬맨 앤 웨이크필드",
  "CWST": "카셀라 웨이스트 시스템즈",
  "CWT": "캘리포니아 워터 서비스 그룹",
  "CX": "시멕스 ADR",
  "CXAI": "CX앱",
  "CXDO": "크렉센도",
  "CXII": "처칠 캐피탈 XII",
  "CXM": "스프링클러",
  "CXT": "크레인 NXT",
  "CXW": "코어시빅",
  "CYAB": "사이브라",
  "CYCN": "싸이클러리온 테라퓨틱스",
  "CYCU": "싸이큐리온",
  "CYD": "차이나 유차이 인터내셔널",
  "CYH": "커뮤니티 헬스 시스템즈",
  "CYN": "신젠",
  "CYPH": "사이퍼펑크 테크놀로지스",
  "CYRX": "크라이오포트",
  "CYTK": "사이토키네틱스",
  "CZFS": "시티즌스 파이낸셜 서비시스",
  "CZNC": "시티즌스 & 노던",
  "CZR": "시저스 엔터테인먼트",
  "CZWI": "시티즌스 커뮤니티 뱅코프",
  "D": "도미니언 에너지",
  "DAAQ": "디지털 애셋 애퀴지션",
  "DAC": "다나오스",
  "DAIC": "CID 홀드",
  "DAIO": "데이터 I/O",
  "DAKT": "닥트로닉스",
  "DAL": "델타 에어라인스",
  "DAN": "다나",
  "DAO": "유다오 ADR",
  "DAR": "달링 인그리디언츠",
  "DARE": "데어 바이오사이언스",
  "DASH": "도어대시",
  "DAVA": "엔다바 ADR",
  "DAVE": "데이브",
  "DB": "도이치은행",
  "DBCA": "D 보랄 애퀴지션 I",
  "DBD": "다이볼드 닉스도르프",
  "DBGI": "디지털 브랜즈 그룹",
  "DBI": "디자이너 브랜즈",
  "DBL": "Doubleline Opportunistic Credit Fund",
  "DBRG": "디지털브리지 그룹",
  "DBRG-P-H": "디지털브리지 그룹",
  "DBRG-P-I": "디지털브리지 그룹",
  "DBRG-P-J": "디지털브리지 그룹",
  "DBVT": "DBV 테크놀로지스 ADR",
  "DBX": "드랍박스",
  "DC": "다코타 골드",
  "DCBO": "도세보",
  "DCGO": "독고",
  "DCH": "다우치",
  "DCI": "도널드슨",
  "DCO": "듀코먼",
  "DCOM": "다임 커머셜 뱅크셰어스",
  "DCOM-P": "다임 커머셜 뱅크셰어스",
  "DCOY": "셀러리어스 파머슈티컬스",
  "DCTH": "델캐스 시스템즈",
  "DCX": "디지털 커런시 X 테크놀로지",
  "DD": "듀폰",
  "DDC": "DDC 엔터프라이즈",
  "DDD": "쓰리디 시스템즈",
  "DDI": "더블다운 인터랙티브 ADR",
  "DDL": "딩동 (케이먼) ADR",
  "DDOG": "데이터도그",
  "DDS": "딜라즈",
  "DDT": "딜라드 캐피탈 트러스트 I",
  "DE": "디어",
  "DEA": "이스털리 거번먼트 프로퍼티스",
  "DEC": "다이버시파이드 에너지",
  "DECK": "덱커 아웃도어",
  "DEFT": "디파이 테크놀로지스",
  "DEI": "더글러스 에밋",
  "DELL": "델테크놀로지",
  "DEO": "디아지오 ADR",
  "DERM": "저니 메디컬",
  "DETX": "리버티 디펜스 홀딩스",
  "DFDV": "디파이 디벨롭먼트",
  "DFH": "드림 파인더스 홈즈",
  "DFIN": "도넬리 파이낸셜 솔루션스",
  "DFLI": "드래곤플라이 에너지 홀딩스",
  "DFNS": "T3 디펜스",
  "DFP": "Flahertycrumrine Dynamic Preferred And",
  "DFSC": "DEFSEC 테크놀로지스",
  "DFTX": "데피니움 테라퓨틱스",
  "DG": "달러 제너럴",
  "DGAC": "디서플린드 그로스 애퀴지션",
  "DGICA": "도니골 그룹 Class A",
  "DGICB": "도니골 그룹 Class B",
  "DGII": "디지 인터내셔널",
  "DGNX": "디지넥스",
  "DGX": "퀘스트 다이아그노스틱스",
  "DGXX": "디지 파워 X",
  "DH": "데피니티브 헬스케어",
  "DHC": "다이버시파이드 헬스케어",
  "DHF": "BNY Mellon High Yield Strategies Fund",
  "DHI": "D.R. 호턴",
  "DHR": "다나허",
  "DHT": "DHT 홀딩스",
  "DHX": "DHI 그룹",
  "DHY": "Credit Suisse High Yield Credit Fund",
  "DIBS": "퍼스트딥스닷컴",
  "DIN": "다인브랜드글로벌",
  "DINO": "HF 싱클레어",
  "DIOD": "다이오즈",
  "DIS": "월트 디즈니",
  "DIT": "암콘 디스트리뷰팅",
  "DJCO": "데일리 저널",
  "DJT": "트럼프 미디어 & 테크놀로지 그룹",
  "DK": "델렉 유에스 홀딩스",
  "DKI": "다크아이리스",
  "DKL": "Delek Logistics Partners, Lp",
  "DKNG": "드래프트킹즈 홀딩스",
  "DKS": "딕스 스포팅 굿즈",
  "DLB": "돌비 래보라토리스",
  "DLHC": "DLH 홀딩스",
  "DLNG": "Dynagas Lng Parners Lp",
  "DLO": "디로컬",
  "DLPN": "돌핀 엔터테인먼트",
  "DLR": "디지털 리얼티 트러스트",
  "DLR-P-J": "디지털 리얼티 트러스트",
  "DLR-P-K": "디지털 리얼티 트러스트",
  "DLR-P-L": "디지털 리얼티 트러스트",
  "DLTH": "덜루스 홀딩스",
  "DLTR": "달러 트리",
  "DLX": "딜럭스",
  "DLXY": "델릭시 홀딩스",
  "DLY": "DoubleLine Yield Opportunities Fund",
  "DMA": "Destra Multi-Alternative Fund",
  "DMAA": "드러그스 메이드 인 아메리카 애퀴지션",
  "DMAC": "다이아메디카 테라퓨틱스",
  "DMB": "BNY Mellon Municipal Bond Infrastructure Fund In",
  "DMC": "델몬트",
  "DMII": "드러그스 메이드 인 아메리카 애퀴지션 II",
  "DMLP": "Dorchester Minerals Units",
  "DMO": "Western Asset Mortgage Opportunity Fund",
  "DMRA": "다모라 테라퓨틱스",
  "DMRC": "디지마크",
  "DNA": "깅코 바이오웍스 홀딩스",
  "DNLI": "디날리 테라퓨틱스",
  "DNMX": "다이나믹스 III",
  "DNN": "데니슨 마인스",
  "DNOW": "디나우",
  "DNP": "DNP Select Income Fund Inc",
  "DNTH": "다이안서스 테라퓨틱스",
  "DNUT": "크리스피 크림",
  "DOC": "헬스피크 프로퍼티스",
  "DOCN": "디지털오션 홀딩스",
  "DOCS": "독시미티",
  "DOCU": "도큐사인",
  "DOGZ": "도그니스 인터네셔널",
  "DOLE": "돌",
  "DOMH": "도미나리 홀딩스",
  "DOMO": "도모",
  "DOO": "Brp",
  "DORM": "도먼 프로덕츠",
  "DOUG": "더글라스 엘리먼",
  "DOV": "도버",
  "DOW": "다우",
  "DOX": "암독스",
  "DOYU": "도유 인터내셔널 홀딩스 ADR",
  "DPC": "DPC 홀딩스",
  "DPG": "Duff & Phelps Utility and Infrastructure Fund Inc",
  "DPRO": "드라간플라이",
  "DPU": "탑 킹윈",
  "DPZ": "도미노피자",
  "DQ": "다초 뉴 에너지 ADR",
  "DRCT": "다이렉트 디지털 홀딩스",
  "DRD": "DRD골드 ADR",
  "DRDB": "로만 DBDR 애퀴지션 II",
  "DRH": "다이아몬드락 하스피탈리티",
  "DRI": "다든 레스토랑",
  "DRIO": "다리오헬스",
  "DRMA": "더마타 테라퓨틱스",
  "DRS": "레오나르도 DRS",
  "DRTS": "알파 타우 메디컬",
  "DRUG": "브라이트 마인즈 바이오사이언시스",
  "DRVN": "드리븐 브랜즈 홀딩스",
  "DSAC": "다이달로스 스페셜 애퀴지션",
  "DSC": "DPC 홀딩스 ADR",
  "DSGN": "디자인 테라퓨틱스",
  "DSGR": "디스트리뷰션 솔루션스 그룹",
  "DSGX": "데카르트 시스템즈 그룹",
  "DSL": "Doubleline",
  "DSM": "BNY Mellon Strategic Municipal Bond Fund Inc",
  "DSP": "바이안트 테크놀로지",
  "DSS": "Dss",
  "DSU": "Blackrock Debt Strategies Fund",
  "DSWL": "데스웰 인더스트리",
  "DSX": "다이애나 쉬핑",
  "DSX-P-B": "다이애나 쉬핑",
  "DSY": "빅 트리 클라우드 홀딩스",
  "DT": "다이나트레이스",
  "DTCX": "데이타센트렉스",
  "DTE": "DTE 에너지",
  "DTF": "DTF Tax-Free Income 2028 Term Fund Inc.",
  "DTI": "드릴링 툴스 인터내셔널",
  "DTIL": "프리사이젼 바이오사이언스",
  "DTM": "DT 미드스트림",
  "DTSQ": "DT 클라우드 스타 애퀴지션",
  "DTSS": "데이터씨 인텔리전트 테크",
  "DTST": "데이터 스토리지",
  "DUK": "듀크 에너지",
  "DUK-P-A": "듀크 에너지",
  "DUKR": "듀크 로보틱스",
  "DUO": "Fangdd Network Group Ltd",
  "DUOL": "듀오링고",
  "DUOT": "듀오스 테크놀로지 그룹",
  "DV": "더블베리파이 홀딩스",
  "DVA": "다비타",
  "DVLT": "데이터볼트 AI",
  "DVN": "데번 에너지",
  "DWSN": "도슨 지오피지컬",
  "DWTX": "도그우드 테라퓨틱스",
  "DX": "다이넥스 캐피털",
  "DX-P-C": "다이넥스 캐피털",
  "DXC": "DXC 테크놀러지 컴퍼니",
  "DXCM": "덱스컴",
  "DXF": "이슨 테크놀로지 ADR",
  "DXLG": "데스티네이션 XL 그룹",
  "DXPE": "DXP 엔터프라이지스",
  "DXR": "닥소",
  "DXST": "디센트 홀딩",
  "DXYZ": "Destiny Tech100 Closed End Fund",
  "DY": "다이콤 인더스트리스",
  "DYAI": "다이아딕 인터내셔널",
  "DYN": "다인 테라퓨틱스",
  "DYNC": "다이나믹스",
  "DYOR": "인사이트 디지털 파트너스 II",
  "E": "에니 ADR",
  "EAD": "Allspring",
  "EAF": "그래프테크 인터내셔널",
  "EAI": "엔터지 아칸소 선순위 담보채권 4.875% 만기 2066년 9월",
  "EARN": "Ellington Credit Company",
  "EAT": "브링커 인터내셔널",
  "EBAY": "이베이",
  "EBC": "이스턴 뱅크셰어스",
  "EBF": "에니스",
  "EBMT": "이글 뱅코프 몬태나",
  "EBON": "이방 인터내셔널 홀딩스",
  "EBS": "이머전트 바이오솔루션스",
  "EC": "에코페트롤 ADR",
  "ECAT": "BlackRock ESG Capital Allocation Term Closed End Fund",
  "ECBK": "ECB 뱅코프",
  "ECC": "Eagle Point Credit Company Inc",
  "ECC-P-D": "Eagle Point Credit Company Series D Preferred",
  "ECCC": "이글 포인트 크레디트 우선주 Series C 6.5% 만기 2031년",
  "ECF": "Ellsworth Growth and Income Fund Ltd.",
  "ECF-P-A": "Ellsworth Growth and Income Fund Ltd.",
  "ECG": "에베루스 컨스트럭션 그룹",
  "ECHO": "에코스타",
  "ECL": "이콜랩",
  "ECO": "오케아니스 에코 탱커스",
  "ECOR": "일렉트로코어",
  "ECPG": "앙코어 캐피털 그룹",
  "ECVT": "에코비스트",
  "ECX": "이카엑스 홀딩스",
  "ED": "콘솔리데이티드 에디슨",
  "EDBL": "에더블 가든",
  "EDD": "Morgan Stanley Emerging Mrkt Domestic Debt Fd Inc",
  "EDF": "Virtus Stone Harbor Emerging Markets Income Fund",
  "EDHL": "에버브라이트 디지털 홀딩",
  "EDIT": "에디타스 메디신",
  "EDN": "엠프레사 디스트리부이도라 ADR",
  "EDRY": "유로드라이",
  "EDSA": "에데사 바이오테크",
  "EDTK": "스킬풀 크래프트맨 에듀케이션 테크놀로지",
  "EDU": "뉴 오리엔탈 에듀케이션 & 테크놀로지 ADR",
  "EDUC": "에듀케이셔널 디벨롭먼트",
  "EE": "엑셀러레이트 에너지",
  "EEA": "The European Equity Fund Inc",
  "EEFT": "유로넷 월드와이드",
  "EEIQ": "에픽퀘스트 에듀케이션 그룹 인터내셔널",
  "EFC": "엘링턴 파이낸셜",
  "EFC-P-B": "엘링턴 파이낸셜",
  "EFC-P-C": "엘링턴 파이낸셜",
  "EFC-P-D": "엘링턴 파이낸셜",
  "EFOI": "에너지 포커스",
  "EFOR": "에버포스",
  "EFR": "Eaton Vance Senior Floating-Rate Fund",
  "EFSC": "엔터프라이즈 파이낸셜 서비스",
  "EFSCP": "엔터프라이즈 파이낸셜 서비시스 우선주 시리즈 A 5%",
  "EFSI": "이글 파이낸셜 서비스",
  "EFT": "Eaton Vance Floating Rate Income Closed Fund",
  "EFTY": "에투알 캐피털 그룹",
  "EFX": "에퀴팩스",
  "EFXT": "에너플렉스",
  "EG": "에베레스트 그룹",
  "EGAN": "이게인",
  "EGBN": "이글 뱅코프",
  "EGG": "에니그매티그",
  "EGHA": "EGH 애퀴지션",
  "EGHT": "8x8",
  "EGO": "엘도라도 골드",
  "EGP": "이스트그룹 프로퍼티스",
  "EGY": "발코 에너지",
  "EH": "이항 홀딩스 ADR",
  "EHC": "인컴퍼스 헬스",
  "EHGO": "이쉘고",
  "EHI": "Western Asset Global High Income Fund",
  "EHLD": "유로홀딩스",
  "EHTH": "이헬스",
  "EIC": "Eagle Point Income Company Closed End Fund",
  "EICA": "이글 포인트 인컴 우선주 Series A 5%",
  "EIG": "임플로이어스 홀딩스",
  "EIIA": "이글 포인트 인스티튜셔널 인컴 펀드 우선주 Series A 8.125%",
  "EIKN": "아이콘 테라퓨틱스",
  "EIM": "Eaton Vance Municipal Bond Closed Fund",
  "EIX": "에디슨 인터내셔널",
  "EJH": "E-홈 하우스홀드 서비스 홀딩스",
  "EL": "에스티 로더",
  "ELA": "엔벨라",
  "ELAB": "PMGC 홀딩스",
  "ELAN": "엘란코 애니멀 헬스",
  "ELBM": "일렉트라 배터리 머티리얼스",
  "ELC": "엔터지 루이지애나 선순위 담보채권 4.875% 만기 2066년",
  "ELDN": "엘레돈 파마슈티컬스",
  "ELE": "엘리멘탈 로열티 코퍼레이션",
  "ELF": "엘프 뷰티",
  "ELLO": "엘로메이 캐피털",
  "ELMD": "일렉트로메드",
  "ELME": "엘름 커뮤니티스",
  "ELMT": "엘멧 그룹",
  "ELOG": "이스턴 인터내셔널",
  "ELOX": "엘록스 파마슈티컬스",
  "ELPC": "Companhia Paranaense de Energia - COPEL",
  "ELPW": "이롱 파워 홀딩",
  "ELS": "에퀴티 라이프스타일 프로퍼티스",
  "ELTK": "엘텍",
  "ELTX": "엘리시오 테라퓨틱스",
  "ELUT": "엘루시아",
  "ELV": "엘레반스 헬스",
  "ELVA": "일렉트로바야",
  "ELVN": "인라이븐 테라퓨틱스",
  "ELVR": "Elevra Lithium",
  "ELWT": "엘러윗 커넥션",
  "EMA": "에메라",
  "EMAT": "에볼루션 메탈스 & 테크놀로지스",
  "EMBC": "엠백타",
  "EMBJ": "임브라에르 ADR",
  "EMD": "Western Asset Emerging Markets Debt Fund",
  "EME": "엠코 그룹",
  "EMF": "Templeton Emerging Markets Closed Fund",
  "EMIS": "에미스 애퀴지션",
  "EML": "이스턴",
  "EMN": "이스트만 케미컬",
  "EMO": "ClearBridge Energy Midstream Opportunity Closed End Fund",
  "EMP": "엔터지 미시시피 선순위 담보채권 4.900% 만기 2066년",
  "EMPD": "엠페리 디지털",
  "EMR": "에머슨 일렉트릭",
  "ENB": "엔브리지",
  "ENGN": "엔진 테라퓨틱스",
  "ENGS": "에너지스 그룹",
  "ENHA": "A 패러다이스 애퀴지션",
  "ENIC": "에넬 칠레 ADR",
  "ENJ": "엔터지 뉴올리언스 선순위 담보채권 5.000% 만기 2052년",
  "ENLT": "엔라이트 리뉴어블 에너지",
  "ENLV": "엔라이벡스",
  "ENO": "엔터지 뉴올리언스 선순위 담보채권 5.500% 만기 2066년",
  "ENOV": "이노비스",
  "ENPH": "인페이즈 에너지",
  "ENR": "에너자이저 홀딩스",
  "ENRD": "아인라이드 ADR",
  "ENS": "에너시스",
  "ENSC": "엔시스 바이오사이언시스",
  "ENSG": "엔사인 그룹",
  "ENTA": "에난타 파마슈티컬스",
  "ENTG": "인테그리스",
  "ENTX": "엔테라 바이오",
  "ENVA": "이노바 인터내셔널",
  "ENVB": "엔버릭 바이오사이언시스",
  "ENVX": "이노빅스",
  "EOD": "Allspring Global Dividend Opportunity Fund",
  "EOG": "EOG 리소시스",
  "EOI": "Eaton Vance Enhanced Equity Income Closed Fund",
  "EOLS": "에볼러스",
  "EONR": "EON 리소시스",
  "EOS": "Eaton Vance Enhance Equity",
  "EOSE": "이오스 에너지 엔터프라이시스",
  "EOT": "Eaton Vance National Municipal Opportunities Closed Fund",
  "EP": "엠파이어 페트롤리움",
  "EP-P-C": "엠파이어 페트롤리움",
  "EPAC": "에너팩 툴 그룹",
  "EPAM": "이팸 시스템즈",
  "EPC": "에지웰 퍼스널 케어",
  "EPD": "Enterprise Products Partners L.P.",
  "EPM": "에볼루션 페트롤리엄",
  "EPOW": "E-파워",
  "EPR": "EPR 프로퍼티스",
  "EPR-P-C": "EPR 프로퍼티스",
  "EPR-P-E": "EPR 프로퍼티스",
  "EPR-P-G": "EPR 프로퍼티스",
  "EPRT": "에센셜 프로퍼티 리얼티",
  "EPRX": "유프락시아 파마슈티컬스",
  "EPSM": "엡시움 엔터프라이즈",
  "EPSN": "엡실론 에너지",
  "EQ": "이퀼리움",
  "EQBK": "애퀴티 뱅크셰어스",
  "EQH": "에퀴터블 홀딩스",
  "EQH-P-A": "에퀴터블 홀딩스",
  "EQH-P-C": "에퀴터블 홀딩스",
  "EQIX": "이퀴닉스",
  "EQNR": "에퀴노르 ADR",
  "EQPT": "이큅먼트쉐어 닷컴",
  "EQR": "에퀴티 레지덴셜",
  "EQS": "에쿠스 토탈 리턴",
  "EQT": "Eqt",
  "EQX": "이퀴녹스 골드",
  "ERAS": "이래스카",
  "ERC": "Allspring Multi-Sector Income Fund",
  "ERH": "Allspring Utilities And High Income Mutual Fund",
  "ERIC": "텔레폰악티에볼라예트 에릭슨 ADR",
  "ERIE": "이리 인뎀니티",
  "ERII": "에너지 리커버리",
  "ERNA": "어넥사 테라퓨틱스",
  "ERO": "에로 코퍼",
  "EROC": "이록",
  "EROK": "이글락 랜드",
  "ES": "에버소스 에너지",
  "ESAB": "Esab",
  "ESBA": "Empire State Realty Op, L.P.  Series Es",
  "ESCA": "에스칼라드",
  "ESE": "에스코 테크놀로지스",
  "ESEA": "유로시스",
  "ESI": "엘리먼트 솔루션즈",
  "ESLA": "에스트렐라 이뮤노파르마",
  "ESLT": "엘빗 시스템즈",
  "ESNT": "이센트 그룹",
  "ESOA": "에너지 서비시스 오브 아메리카",
  "ESP": "에스페이 MFG & 일렉트로닉스",
  "ESQ": "에스콰이어 파이낸셜 홀딩스",
  "ESRT": "엠파이어 스테이트 리얼티 트러스트",
  "ESS": "에섹스 프로퍼티 트러스트",
  "ESTA": "에스타블리쉬먼트 랩스 홀딩스",
  "ESTC": "엘라스틱",
  "ET": "Energy Transfer LP Common Units representing",
  "ETB": "Eaton Vance Tax Managed Buy Write Income Closed Fund",
  "ETD": "이튼 알렌 인테리어스",
  "ETG": "Eaton Vance Tax Advantaged Global Dividend Income Closed Fund",
  "ETI-P": "엔터지 텍사스 우선주 시리즈 A 5.375%",
  "ETJ": "Eaton Vance Risk - Managed Diversified Equity",
  "ETN": "이튼",
  "ETO": "Eaton Vance Tax-Advantaged Global Div Oppor. Fund",
  "ETON": "이튼 파마슈티컬즈",
  "ETOR": "이토로 그룹",
  "ETR": "엔터지",
  "ETS": "엘리트 익스프레스 홀딩",
  "ETSS": "에너지 트랜지션 스페셜 오퍼튜니티스",
  "ETSY": "ETSY",
  "ETV": "Eaton Vance Tax Managed Buy Write Opportunities Closed Fund",
  "ETW": "Eaton Vance Tax Managed Global Buy Write Opportunities Closed Fund",
  "ETX": "Eaton Vance Municipal Income 2028 Term Trust",
  "ETY": "Eaton Vance Tax Managed Diversified Equity Income Closed Fund",
  "EU": "엔코어 에너지",
  "EUDA": "8i 애퀴지션 2",
  "EURK": "유레카 애퀴지션",
  "EVAC": "EQV 벤처스 애퀴지션 II",
  "EVAX": "에바종 ADR",
  "EVC": "엔트라비전 커뮤니케이션즈",
  "EVCM": "에버커머스",
  "EVER": "에버쿼트",
  "EVEX": "이브 홀딩",
  "EVF": "Eaton Vance Senior Income Closed Fund",
  "EVG": "Eaton Vance Short Duration Diversified Income Closed Fund",
  "EVGN": "에보젠",
  "EVGO": "EV고",
  "EVH": "에볼런트 헬스",
  "EVI": "EVI 인더스트리",
  "EVLV": "이볼브 테크놀로지스 홀딩스",
  "EVMN": "에보뮨",
  "EVN": "Eaton Vance Municipal Income Trust",
  "EVO": "에보텍 ADR",
  "EVOX": "에볼루션 글로벌 애퀴지션",
  "EVR": "에버코어",
  "EVRG": "에버지",
  "EVT": "Eaton Vance Tax Advantaged Dividend Income Closed Fund",
  "EVTC": "에버테크",
  "EVTL": "버티컬 에어로스페이스",
  "EVV": "Eaton Vance Limited Duration Income Closed Fund",
  "EW": "에드워즈 라이프사이언시스",
  "EWBC": "이스트 웨스트 뱅코프",
  "EWTX": "엣지와이즈 테라퓨틱스",
  "EXC": "엑셀론",
  "EXE": "익스팬드 에너지",
  "EXEL": "엑셀리시스",
  "EXFY": "익스펜시파이",
  "EXG": "Eaton Vance Tax-Managed Global Diversified Equity Income Closed Fund",
  "EXK": "엔데버 실버",
  "EXLS": "엑슬서비스 홀딩스",
  "EXOD": "엑소더스 무브먼트",
  "EXOZ": "엑소자임스",
  "EXP": "이글 머티리얼스",
  "EXPD": "익스페디터스 인터내셔널 오브 워싱턴",
  "EXPE": "익스피디아그룹",
  "EXPO": "엑스포넌트",
  "EXR": "엑스트라 스페이스 스토리지",
  "EXTR": "익스트림 네트웍스",
  "EXYN": "엑신 테크놀로지스",
  "EYE": "내셔널 비전 홀딩스",
  "EYPT": "아이포인트",
  "EZGO": "이지고 테크놀로지스",
  "EZPW": "이즈코프",
  "EZRA": "릴라이언스 글로벌 그룹",
  "F": "포드 모터",
  "FA": "퍼스트 어드밴티지",
  "FABC": "패브릭 AI",
  "FAC": "팩토리얼 에너지",
  "FACT": "팩트 II 애퀴지션",
  "FAF": "퍼스트 아메리칸 파이낸셜",
  "FAMI": "파르미",
  "FANG": "다이아몬드백 에너지",
  "FAST": "패스널",
  "FATE": "페이트 테라퓨틱스",
  "FATN": "팻파이프",
  "FAX": "abrdn Asia-Pacific",
  "FBGL": "FBS 글로벌",
  "FBIN": "포츈 브랜즈 홈 앤 시큐리티",
  "FBIO": "포트리스 바이오텍",
  "FBIOP": "포트리스 바이오텍 우선주 시리즈 A 9.375%",
  "FBIZ": "퍼스트 비즈니스 파이낸셜 서비스",
  "FBK": "FB 파이낸셜 그룹",
  "FBLA": "FB 뱅코프",
  "FBLG": "파이브로바이올로직스",
  "FBNC": "퍼스트 뱅코프(노스 캐롤라이나)",
  "FBP": "퍼스트 뱅코프 푸에르토 리코",
  "FBRT": "프랭클린 BSP 리얼티 트러스트",
  "FBRT-P-E": "프랭클린 BSP 리얼티 트러스트",
  "FBRX": "포르테 바이오사이언스",
  "FBYD": "팔콘스 비욘드 글로벌",
  "FBYDP": "팔콘스 비욘드 우선주 Series B",
  "FC": "프랭클린 커비",
  "FCAP": "퍼스트 캐피탈",
  "FCBC": "퍼스트 커뮤니티 뱅크셰어스",
  "FCBM": "퍼스트 캐롤리나 파이낸셜 서비스",
  "FCCO": "퍼스트 커뮤니티",
  "FCEL": "퓨얼셀 에너지",
  "FCF": "퍼스트 커먼웰스 파이낸셜",
  "FCFS": "퍼스트캐쉬 홀딩스",
  "FCHL": "피트니스 챔스 홀딩스",
  "FCN": "FTI 컨설팅",
  "FCNCA": "퍼스트 시티즌스 뱅크셰어스",
  "FCNCN": "퍼스트 시티즌스 우선주 Series E",
  "FCNCO": "퍼스트 시티즌스 뱅크셰어스 우선주 시리즈 C 5.625%",
  "FCNCP": "퍼스트 시티즌스 뱅크셰어스 우선주 시리즈 A 5.375%",
  "FCPT": "포 코너스 프로퍼티 트러스트",
  "FCRS": "퓨처크레스트 애퀴지션",
  "FCT": "First Trust Senior Floating Rate Income Fund II",
  "FCUV": "포커스 유니버설",
  "FCX": "프리포트 맥모란",
  "FDBC": "피델리티 D&D 뱅코프",
  "FDMM": "프리덤 메탈스 애퀴지션",
  "FDMT": "4D 몰레큘러 테라퓨틱스",
  "FDS": "팩트셋 리서치 시스템즈",
  "FDSB": "피프스 디스트릭트 뱅코프",
  "FDUS": "파이더스 인베스트먼트",
  "FDX": "페덱스",
  "FDXF": "페덱스 프레이트 홀딩 컴퍼니",
  "FE": "퍼스트에너지",
  "FEAM": "5E 어드밴스드 머터리얼즈",
  "FEBO": "펜보 홀딩스",
  "FEDU": "포시즌스 에듀케이션 케이먼 ADR",
  "FEED": "엔뷰 메디컬",
  "FEIM": "프리컨시 일렉트로닉스",
  "FELE": "프랭클린 일렉트릭",
  "FEMY": "피메이시스",
  "FENC": "페넥 파머수티컬스",
  "FENG": "피닉스 뉴 미디어 ADR",
  "FER": "페로비알",
  "FERA": "피프스 에라 애퀴지션 I",
  "FERG": "퍼거슨 엔터프라이즈",
  "FET": "포럼 에너지 테크놀로지스",
  "FF": "퓨처퓨얼",
  "FFA": "First Trust Enhanced Equity Income Closed Fund",
  "FFAI": "패러데이 퓨처 인텔리전트 일렉트릭",
  "FFBC": "퍼스트 파이낸셜 뱅코프",
  "FFC": "FlahertyCrumrine Preferred and",
  "FFIN": "퍼스트 파이낸셜 뱅크셰어스",
  "FFIV": "F5",
  "FG": "F&G 어뉴어티 앤 라이프",
  "FGBI": "퍼스트 개런티 뱅크셰어스",
  "FGBIP": "퍼스트 개런티 뱅그셰어스 우선주 시리즈 A 6.75%",
  "FGI": "FGI 인더스트리스",
  "FGII": "FG 임페리얼 애퀴지션",
  "FGL": "파운더 그룹",
  "FGNX": "Fg 넥서스",
  "FGNXP": "Fg 넥서스 우선주 8.00%",
  "FHB": "퍼스트 하와이안",
  "FHI": "페더레이티드 헤르메스",
  "FHN": "퍼스트 호라이즌",
  "FHN-P-E": "퍼스트 호라이즌",
  "FHN-P-F": "퍼스트 호라이즌",
  "FHN-P-H": "퍼스트 호라이즌",
  "FHTX": "포그혼 테라퓨틱스",
  "FIBK": "퍼스트 인터스테이트 뱅크시스템",
  "FICO": "페어 아이작",
  "FIEE": "FiEE",
  "FIG": "피그마",
  "FIGR": "피규어 테크놀로지 솔루션스",
  "FIGS": "피그스",
  "FIGX": "FIGX 캐피털 애퀴지션",
  "FINS": "Angel Oak Financial Strategies Income Term Trust",
  "FINV": "핀볼루션 그룹 ADR",
  "FINW": "핀와이즈 뱅코프",
  "FIP": "FTAI 인프라스트럭처",
  "FIRY": "파이어리",
  "FIS": "피델리티 내셔널 인포메이션 서비스",
  "FISI": "파이낸셜 인스티튜션스",
  "FISK": "Empire State Realty OP, L.P. Series 250",
  "FISN": "딥 피션",
  "FISV": "파이서브",
  "FITB": "피프스 서드 뱅코프",
  "FITB-P-A": "피프스 서드 뱅코프",
  "FITB-P-I": "피프스 서드 뱅코프",
  "FITB-P-K": "피프스 서드 뱅코프",
  "FITB-P-M": "피프스 서드 뱅코프",
  "FIVE": "파이브 빌로우",
  "FIVN": "파이브나인",
  "FIX": "컴포트 시스템즈 USA",
  "FIZZ": "내셔널 베버리지",
  "FJET": "스타파이터스 스페이스",
  "FKWL": "프랭클린 와이어리스",
  "FLC": "Flaherty Crumrine Total Return Mutual Fund  Incorporated",
  "FLD": "폴드 홀딩스",
  "FLEX": "플렉스",
  "FLG": "플래그스타 파이낸셜",
  "FLG-P-A": "플래그스타 파이낸셜",
  "FLGT": "펄젠트 제네틱스",
  "FLL": "풀 하우스 리조트",
  "FLNA": "필라나 테라퓨틱스",
  "FLNC": "플루언스 에너지",
  "FLNG": "플렉스 LNG",
  "FLNT": "플루언트",
  "FLO": "플라워스 푸드",
  "FLOC": "플로우코 홀딩스",
  "FLR": "플루오르",
  "FLS": "플로우서브",
  "FLUT": "플러터 엔터테인먼트",
  "FLUX": "플럭스 파워 홀딩스",
  "FLWS": "1-800 플라워스닷컴",
  "FLX": "빙엑스 ADR",
  "FLXS": "플렉스스틸 인더스트리스",
  "FLY": "파이어플라이 에어로스페이스",
  "FLYE": "플라이-이 그룹",
  "FLYW": "플라이와이어",
  "FLYX": "플라익스클루시브",
  "FLZH": "플래시 스포츠 앤 미디어",
  "FMAC": "퓨처 머니 애퀴지션",
  "FMAO": "파머스 & 머천츠 뱅코프",
  "FMBH": "퍼스트미드 뱅크셰어스",
  "FMC": "Fmc",
  "FMFC": "캔달 M 벤처",
  "FMN": "Federated Hermes Premier Municipal Income Closed End Fund",
  "FMNB": "파머스 내셔널 은행",
  "FMS": "프레제니우스 메디칼 케어 ADR",
  "FMST": "포모스트 클린 에너지",
  "FMX": "포멘토 에코노미코 멕시카노 ADR",
  "FMY": "First Trust Mortgage Income Fund",
  "FN": "패브리넷",
  "FNB": "FNB",
  "FND": "플로어 & 데코 홀딩스",
  "FNF": "피델리티 내셔널 파이낸셜",
  "FNGR": "핑거모션",
  "FNKO": "펀코",
  "FNLC": "퍼스트 뱅코프",
  "FNRN": "퍼스트 노던 커뮤니티 뱅코프",
  "FNUC": "프론티어 뉴클리어 앤 미네랄스",
  "FNV": "프랑코-네바다",
  "FNWB": "퍼스트 노스웨스트 뱅코프",
  "FNWD": "핀워드 뱅코프",
  "FOA": "파이낸스 오브 아메리카 컴퍼니스",
  "FOCL": "이댑 TMS ADR",
  "FOF": "CohenSteers Closed End Opportunity Fund",
  "FOFO": "항펑 테크놀로지 이노베이션",
  "FOR": "포레스타 그룹",
  "FORM": "폼팩터",
  "FORR": "포레스터 리서치",
  "FORTY": "포뮬러 시스템즈 1985 ADR",
  "FOSL": "파슬 그룹",
  "FOUR": "쉬프트4 페이먼트",
  "FOUR-P-A": "쉬프트4 페이먼트",
  "FOX": "폭스 Class B",
  "FOXA": "폭스 Class A",
  "FOXF": "폭스 팩토리 홀딩",
  "FOXX": "폭스 디벨롭먼트 홀딩스",
  "FPF": "First Trust Intermediate Duration Preferred & Inc",
  "FPH": "파이브 포인트 홀딩스",
  "FPI": "팜랜드 파트너스",
  "FPS": "포전트 파워 솔루션스",
  "FR": "퍼스트 인더스트리얼 리얼티 트러스트",
  "FRA": "Blackrock Floating Rate",
  "FRAF": "프랭클린 파이낸셜 서비스",
  "FRBA": "퍼스트 뱅크",
  "FRBT": "포브라이트",
  "FRD": "프리드먼 인더스트리스",
  "FRGT": "프라이트 테크놀로지스",
  "FRHC": "프리덤 홀딩",
  "FRME": "퍼스트 머천츠",
  "FRMEP": "퍼스트 머천트",
  "FRMI": "페르미",
  "FRMM": "포럼 마켓츠",
  "FRNM": "퍼셉티브 캐피털 솔루션스",
  "FRO": "프론트라인",
  "FROG": "제이프로그",
  "FRPH": "FRP 홀딩스",
  "FRPT": "프레시펫",
  "FRSH": "프레시웍스",
  "FRST": "프리미스 파이낸셜",
  "FRSX": "포어사이트 오토노모스 홀딩스 ADR",
  "FRT": "페더럴 리얼티 인베스트먼트 트러스트",
  "FRT-P-C": "페더럴 리얼티 인베스트먼트 트러스트",
  "FRTT": "포트 테크놀로지",
  "FRVO": "퍼보 에너지",
  "FSBC": "파이브 스타 뱅코프",
  "FSBW": "FS 뱅코프",
  "FSCO": "FS Credit Opportunities Corp.",
  "FSEA": "퍼스트 시코스트 뱅코프",
  "FSHP": "플래그 십 애퀴지션",
  "FSI": "플렉서블 솔루션스 인터내셔널",
  "FSK": "FS KKR 캐피털",
  "FSLR": "퍼스트 솔라",
  "FSLY": "패스틀리",
  "FSM": "포르투나 마이닝",
  "FSP": "프랭클린 스트리트 프로퍼티스",
  "FSS": "페더럴 시그널",
  "FSSL": "FS Specialty Lending Fund",
  "FSTR": "L B 포스터",
  "FSUN": "퍼스트선 캐피털 뱅코프",
  "FSV": "퍼스트서비스",
  "FT": "Franklin Universal Closed Fund",
  "FTAI": "FTAI 애비에이션",
  "FTAIM": "FTAI 애비에이션 우선주 Series D",
  "FTCI": "FTC 솔라",
  "FTDR": "프론트도어",
  "FTEK": "퓨얼 테크",
  "FTF": "Franklin Limited Duration Income Trust",
  "FTFT": "퓨처 핀테크 그룹",
  "FTH": "파에스 테라퓨틱스",
  "FTHA": "포어프런트 테크 홀딩스 애퀴지션",
  "FTHM": "패섬 홀딩스",
  "FTHY": "First Trust High Yield Opportunities 2027 Term Closed End Fd",
  "FTI": "테크닙FMC",
  "FTK": "플로텍 인더스트리스",
  "FTLF": "핏라이프 브랜즈",
  "FTNT": "포티넷",
  "FTRA": "퓨처코프 스페이스 애퀴지션 1",
  "FTRE": "포트레아 홀딩스",
  "FTRK": "패스트 트랙 엔터테인먼트",
  "FTS": "포르티스",
  "FTV": "포티브",
  "FTW": "프레시디오 프로덕션",
  "FUBO": "푸보티비",
  "FUFU": "빗푸푸",
  "FUL": "풀러 H B",
  "FULC": "풀크럼 테라퓨틱스",
  "FULT": "풀턴 파이낸셜",
  "FULTP": "풀턴 파이낸셜 우선주 시리즈 A 5.125%",
  "FUN": "식스 플래그스 엔터테인먼트",
  "FUNC": "퍼스트 유나이티드",
  "FUND": "Sprott Focus Trust",
  "FURY": "퓨리 골드 마인스",
  "FUSB": "퍼스트 US 뱅크셰어스",
  "FUSE": "퓨즈머신스",
  "FUTU": "푸투 홀딩스 ADR",
  "FVAV": "포트리스 밸류 애퀴지션 V",
  "FVCB": "FVC뱅크코프",
  "FVN": "퓨처 비전 II 애퀴지션",
  "FVR": "프론트뷰 REIT",
  "FVRR": "파이버 인터내셔널",
  "FWAC": "Futurewave Acquisition Corp",
  "FWDI": "포워드 인더스트리스",
  "FWONA": "포뮬러 원 그룹 Series A",
  "FWONK": "포뮬러 원 그룹 Series C",
  "FWRD": "포워드 에어 (델라웨어)",
  "FWRG": "퍼스트 와치 레스토랑 그룹",
  "FXAC": "포튜넥스 애퀴지션",
  "FXHO": "유타임",
  "FXNC": "퍼스트 내셔널",
  "G": "젠팩트",
  "GAB": "Gabelli Equity Trust Inc",
  "GAB-P-G": "The Gabelli Equity Trust",
  "GAB-P-H": "The Gabelli Equity Trust",
  "GAB-P-K": "The Gabelli Equity Trust",
  "GABC": "저먼 아메리칸 뱅코프",
  "GAIA": "가이아",
  "GAIN": "글래드스톤 인베스트먼트",
  "GALT": "갈렉틴 테라퓨틱스",
  "GAM": "General American Investors Closed Fund",
  "GAM-P-B": "General American Investors Company",
  "GAME": "엔진 게이밍 앤 미디어",
  "GANX": "게인 테라퓨틱스",
  "GAP": "갭",
  "GASS": "스텔스가스",
  "GATX": "Gatx",
  "GAU": "갈리아노 골드",
  "GAUZ": "고지",
  "GBAB": "Guggenheim Taxable Muni Bd & Inv Grade Dbt Trust",
  "GBCI": "글레이셔 뱅코프",
  "GBDC": "골럽 캐피탈 BDC",
  "GBFH": "G뱅크 파이낸셜 홀딩스",
  "GBLI": "글로벌 인뎀니티 그룹",
  "GBR": "뉴 컨셉 에너지",
  "GBTG": "글로벌 비지니스 트래블 그룹",
  "GBX": "그린브라이어",
  "GCBC": "그린 카운티 뱅코프",
  "GCDT": "그린 서클 탈탄소 테크",
  "GCGR": "제너럴 캐탈리스트 글로벌",
  "GCL": "GCL 글로벌 홀딩스",
  "GCMG": "GCM 그로스브너",
  "GCO": "제네스코",
  "GCT": "기가클라우드 테크놀로지",
  "GCTK": "글루코 트랙",
  "GCTS": "GCT 세미컨덕터 홀딩",
  "GCV": "Gabelli Convertible and Income Securities Mutual Fund",
  "GD": "제너럴 다이내믹스",
  "GDC": "GD 컬처 그룹",
  "GDDY": "고대디",
  "GDEV": "Gdev",
  "GDHG": "골든 헤븐 그룹 홀딩스",
  "GDL": "GDL Fund",
  "GDO": "Western Asset Global Corporate Opportunity Fd Inc.",
  "GDOT": "그린 닷",
  "GDRX": "굿알엑스 홀딩스",
  "GDS": "GDS 홀딩스 ADR",
  "GDTC": "싸이토메드 테라퓨틱스",
  "GDV": "Gabelli Dividend & Income Trust",
  "GDV-P-H": "The Gabelli Dividend",
  "GDV-P-K": "The Gabelli Dividend",
  "GDYN": "그리드 다이나믹 홀딩스",
  "GE": "GE 에어로스페이스",
  "GECC": "그레이트 엘름 캐피털",
  "GEF": "그리프 Class A",
  "GEF-B": "Greif, Inc. Class B",
  "GEG": "그레이트 엘름 그룹",
  "GEHC": "GE 헬스케어",
  "GEL": "Genesis Energy, L.P.",
  "GELS": "젤텍",
  "GEMI": "제미나이 스페이스 스테이션",
  "GEN": "젠 디지털",
  "GENB": "제너레이트 바이오메디슨스",
  "GENC": "젠코 인더스트리스",
  "GENI": "지니어스 스포츠",
  "GENK": "GEN 레스토랑 그룹",
  "GEO": "지오 그룹",
  "GEOS": "지오스페이스 테크놀로지스",
  "GERN": "제론",
  "GETY": "게티 이미지스 홀딩스",
  "GEV": "GE 버노바",
  "GEVO": "제보",
  "GF": "New Germany Fund",
  "GFAI": "가드포스 AI",
  "GFF": "그리폰",
  "GFI": "골드 필즈 ADR",
  "GFL": "GFL 인바이런먼털",
  "GFR": "그린파이어 리소시스",
  "GFS": "글로벌파운드리",
  "GFUZ": "제너럴 퓨전 그룹",
  "GGAL": "그루포 피난시에로 갈리시아 ADR",
  "GGB": "제르다우 ADR",
  "GGG": "그라코",
  "GGN": "GAMCO Global Gold Natural Resources and Income Closed Fund",
  "GGN-P-B": "GAMCO Global Gold Natural Resources and Income Closed Fund",
  "GGR": "고고로",
  "GGRP": "글림스 그룹",
  "GGT": "Gabelli Multimedia Trust Inc",
  "GGT-P-E": "The Gabelli Multimedia Trust",
  "GGT-P-G": "The Gabelli Multimedia Trust",
  "GGZ": "Gabelli Global Small and Mid Cap Value Closed Fund",
  "GH": "가단트 헬쓰",
  "GHC": "그레이엄 홀딩스",
  "GHG": "그린트리 호스피탈리티 그룹 ADR",
  "GHI": "Greystone Housing Impact Investors LP Beneficial Unit Certificates representing assignments of",
  "GHM": "그레이엄",
  "GHRS": "GH 리서치",
  "GHY": "PGIM Global High Yield Fund，Inc",
  "GIB": "Cgi",
  "GIBO": "지보 홀딩스",
  "GIC": "글로벌 인더스트리얼",
  "GIFT": "기프티파이",
  "GIGM": "기가미디어",
  "GIII": "G-III 어패럴 그룹",
  "GIL": "질단 액티브웨어",
  "GILD": "길리어드 사이언시스",
  "GILT": "길라트 새털라이트 네트웍스",
  "GIPR": "제네레이션 인컴 프로퍼티스",
  "GIS": "제너럴 밀즈",
  "GITS": "글로벌 인터랙티브 테크놀로지스",
  "GIW": "긱캐피탈8",
  "GIX": "기그캐피탈9",
  "GJH": "Synthetic Fixed-Income Sec STRATS 2004-06, 6.375% US Cellular",
  "GJO": "Synthetic Fixed-Income Securities",
  "GJP": "Synthetic Fixed",
  "GJR": "Synthetic Fixed",
  "GJS": "Synthetic Fixed-Income Securities STRATS 2006-2 Goldman Sachs Group",
  "GJT": "Synthetic Fixed-Income Securities STRATS 2006-3 AllState",
  "GKOS": "글라우코스",
  "GL": "글로브 라이프",
  "GLAD": "글래드스톤 캐피털",
  "GLAS": "글래스 하우스 브랜즈",
  "GLBE": "Global-E Online",
  "GLBS": "글로버스 마리타임",
  "GLDG": "골드마이닝",
  "GLE": "글로벌 엔진 그룹 홀딩",
  "GLED": "갤럭시엣지 애퀴지션",
  "GLIBA": "Liberty Capital",
  "GLIBK": "Liberty Capital",
  "GLMD": "갈메드 파머슈티컬스",
  "GLND": "그린란드 에너지",
  "GLNG": "골라 LNG",
  "GLO": "Clough Global Opportunities Closed Fund",
  "GLOB": "글로번트",
  "GLOO": "글루 홀딩스",
  "GLOP-P-A": "가스로그 파트너스 우선주 시리즈 A",
  "GLOP-P-B": "가스로그 파트너스 우선주 시리즈 A",
  "GLOP-P-C": "가스로그 파트너스 우선주 시리즈 A",
  "GLP": "Global Partners Units",
  "GLPI": "게이밍 & 레저 프로퍼티스",
  "GLQ": "Clough Global Equity Closed Fund",
  "GLRE": "그린라이트 캐피털 리",
  "GLSI": "그리니치 라이프사이언스",
  "GLU": "The Gabelli Utility",
  "GLU-P-A": "Gabelli Global Utility and Income Closed Fund",
  "GLU-P-B": "Gabelli Global Utility and Income Closed Fund",
  "GLUE": "몬테 로사 테라퓨틱스",
  "GLV": "Clough Global Dividend and Income Fund",
  "GLW": "코닝",
  "GLXG": "갤럭시 페이롤 그룹",
  "GLXY": "갤럭시 디지털 홀딩스",
  "GM": "제너럴 모터스",
  "GMAB": "젠맵 ADR",
  "GME": "게임스탑",
  "GMED": "글로부스 메디컬",
  "GMEX": "GMEX 로보틱스",
  "GMHS": "게임하우스 홀딩스",
  "GMM": "글로벌 모피 AI",
  "GMRS": "GMR 솔루션스",
  "GMTL": "가디언 메탈 리소시스 ADR",
  "GNE": "지니 에너지",
  "GNK": "젠코 시핑 & 트레이딩",
  "GNL": "글로벌 네트 리스",
  "GNL-P-A": "글로벌 네트 리스",
  "GNL-P-B": "글로벌 네트 리스",
  "GNL-P-D": "글로벌 네트 리스",
  "GNL-P-E": "글로벌 네트 리스",
  "GNLN": "그린레인 홀딩스",
  "GNLX": "제네룩스",
  "GNPX": "젠프렉스",
  "GNRC": "제네락 홀딩스",
  "GNS": "지니어스 그룹",
  "GNSS": "제나시스",
  "GNT": "GAMCO Natural Resources Gold & Income Trust",
  "GNT-P-A": "GAMCO Natural Resources, Gold",
  "GNTA": "제넨타 사이언스 ADR",
  "GNTX": "젠텍스",
  "GNW": "젠워스 파이낸셜",
  "GO": "그로서리 아울렛 홀딩스",
  "GOAI": "에바 라이브",
  "GOF": "Guggenheim Strategic Opportunities Mutual Fund",
  "GOGO": "고고",
  "GOLD": "골드닷컴",
  "GOLF": "아쿠쉬네트 홀딩스",
  "GOOD": "글래드스톤 커머셜",
  "GOODN": "글래드스톤 커머셜 우선주 시리즈 E 6.625%",
  "GOODO": "글래드스톤 커머셜 우선주 시리즈 G 6.00%",
  "GOOG": "알파벳 Class C",
  "GOOGL": "알파벳 Class A",
  "GOOGM": "알파벳 우선주 6.25% Series A",
  "GOOGN": "알파벳 우선주 6.25% Series B",
  "GOOS": "캐나다 구스 홀딩스",
  "GORO": "골드그룹 마이닝",
  "GOSS": "고사머 바이오",
  "GOTU": "카오투 테크에듀 ADR",
  "GOVX": "지오박스 랩스",
  "GP": "그린파워 모터 컴퍼니",
  "GPAC": "제너럴 퍼포스 애퀴지션",
  "GPAT": "GP-Act III 애퀴지션",
  "GPC": "제뉴인 파츠",
  "GPCR": "스트럭처 테라퓨틱스 ADR",
  "GPGI": "Gpgi",
  "GPI": "그룹 원 오토모티브",
  "GPK": "그래픽 패키징 홀딩",
  "GPMT": "그래니트 모인트 모기지 트러스트",
  "GPMT-P-A": "그래니트 모인트 모기지 트러스트",
  "GPN": "글로벌 페이먼츠",
  "GPOR": "걸프포트 에너지",
  "GPRE": "그린 플레인스",
  "GPRK": "지오파크",
  "GPRO": "고프로",
  "GPUS": "하이퍼스케일 데이터",
  "GPUS-P-D": "하이퍼스케일 데이터",
  "GRAB": "그랩 홀딩스",
  "GRAL": "그레일",
  "GRAN": "그란데 그룹",
  "GRBK": "그린 브릭 파트너스",
  "GRBK-P-A": "그린 브릭 파트너스",
  "GRC": "고먼-러프",
  "GRCE": "그레이스 테라퓨틱스",
  "GRDN": "가디언 파마시 서비시스",
  "GRDX": "엔테로 테라퓨틱스",
  "GRF": "Eagle Capital Growth Fund",
  "GRFS": "그리폴스 ADR",
  "GRI": "GRI 바이오",
  "GRML": "그린랜드 마인스",
  "GRMN": "가민",
  "GRND": "그라인더",
  "GRNQ": "그린프로 캐피털",
  "GRNT": "그래나이트 릿지 리소시스",
  "GRO": "브라질 포태시",
  "GROV": "그로브 콜라보레이티브 홀딩스",
  "GROW": "US 글로벌 인베스터스",
  "GROY": "골드 로열티",
  "GRPN": "그루폰",
  "GRRR": "고릴라 테크놀로지 그룹",
  "GRSD": "그랜드스탠드",
  "GRVY": "그라비티 ADR",
  "GRWG": "그로우제너레이션",
  "GRX": "Gabelli Healthcare & WellnessRx Trust",
  "GS": "골드만삭스",
  "GS-P-A": "골드만삭스",
  "GS-P-C": "골드만삭스",
  "GS-P-D": "골드만삭스",
  "GSAT": "글로벌스타",
  "GSBC": "그레이트 서던 뱅코프",
  "GSBD": "골드만삭스 BDC",
  "GSHD": "구스헤드 인슈어런스",
  "GSHR": "게셔 애퀴지션 II",
  "GSIT": "GSI 테크놀러지",
  "GSIW": "가든 스테이지",
  "GSK": "Gsk",
  "GSL": "글로벌 십 리스",
  "GSL-P-B": "글로벌 십 리스",
  "GSM": "페로글로브",
  "GSRF": "GSR IV 애퀴지션",
  "GSRV": "GSR V 애퀴지션",
  "GSUN": "골든 선 테크놀로지 그룹",
  "GT": "굿이어 타이어 & 러버",
  "GTBP": "GT 바이오파마",
  "GTE": "그랜 티에라 에너지",
  "GTEC": "그린랜드 테크놀로지 홀딩",
  "GTEN": "고어스 홀딩스 X",
  "GTERA": "글로바 테라 애퀴지션",
  "GTES": "게이츠 인더스트리얼",
  "GTIM": "굿 타임스 레스토란츠",
  "GTLB": "깃랩",
  "GTM": "줌인포 테크놀로지스",
  "GTN": "그레이 미디어",
  "GTN-A": "Gray Media",
  "GTX": "가렛 모션",
  "GTY": "게티 리얼티",
  "GUAC": "베르토 애퀴지션 II",
  "GUG": "Guggenheim Active Allocation CEF",
  "GURE": "걸프 리소시즈",
  "GUT": "Gabelli Utility Trust",
  "GUT-P-C": "Gabelli Utility Trust Series C Preferred",
  "GUTS": "프랙틸 헬스",
  "GVA": "그래니트 컨스트럭션",
  "GVH": "글로바벤드 홀딩스",
  "GWAV": "그린웨이브 테크놀로지 솔루션스",
  "GWH": "ESS 테크",
  "GWRE": "가이드와이어 소프트웨어",
  "GWRS": "글로벌 워터 리소스",
  "GWW": "W W 그레인저",
  "GXAI": "가소스.AI",
  "GXO": "GXO 로지스틱스",
  "GYGY": "게임 유어 게임",
  "GYRE": "자이어 테라퓨틱스",
  "GYRO": "자이로다인",
  "H": "하얏트 호텔",
  "HACQ": "HCM IV 애퀴지션",
  "HAE": "헤모네틱스",
  "HAFC": "한미 파이낸셜",
  "HAFN": "하프니아",
  "HAIN": "하인 셀레셜 그룹",
  "HAL": "할리버튼",
  "HALO": "할로자임 테라퓨틱스",
  "HAO": "하오시 헬스 테크놀로지",
  "HAPN": "해픈",
  "HAS": "해즈브로",
  "HASI": "HA 서스테이너블 인프라 캐피털",
  "HAVA": "하버드 에비뉴 애퀴지션",
  "HAWK": "호크아이 360",
  "HAYW": "해이워드 홀딩스",
  "HBAN": "헌팅턴 뱅크셰어스",
  "HBANL": "헌팅턴 뱅그셰어스 우선주 Series J",
  "HBANM": "헌팅턴 뱅크셰어스 우선주 시리즈 I 5.7%",
  "HBANP": "헌팅턴 뱅크셰어스 우선주 시리즈 H 4.5%",
  "HBANZ": "헌팅턴 뱅크 우선주 Series L 5.50%",
  "HBB": "해밀턴 비치 브랜드 홀딩",
  "HBCP": "홈 뱅코프",
  "HBIO": "하버드 바이오사이언스",
  "HBM": "허드베이 미네랄",
  "HBNB": "호텔101 글로벌 홀딩스",
  "HBNC": "호라이즌 뱅코프",
  "HBT": "HBT 파이낸셜",
  "HCA": "HCA 헬스케어",
  "HCAC": "홀 채드윅 애퀴지션",
  "HCAI": "화천 AI 파킹 매니지먼트 테크놀로지",
  "HCAT": "헬스 카탈리스트",
  "HCC": "워리어 멧 콜",
  "HCHL": "해피 시티 홀딩스",
  "HCI": "HCI 그룹",
  "HCIC": "헤네시 캐피털 인베스트먼트 VIII",
  "HCKT": "해켓 그룹",
  "HCM": "허치메드 (차이나) ADR",
  "HCMA": "HCM III 애퀴지션",
  "HCSG": "헬스케어 서비스 그룹",
  "HCTI": "헬스케어 트라이앵글",
  "HCWB": "HCW 바이오로직스",
  "HCWC": "헬시 초이스 웰니스",
  "HD": "홈디포",
  "HDB": "HDFC 뱅크 ADR",
  "HDL": "슈퍼 하이 인터내셔널 홀딩 ADR",
  "HDRN": "하드론 에너지",
  "HDSN": "허드슨 테크놀로지스",
  "HE": "하와이안 일렉트릭 인더스트리스",
  "HEI": "헤이코",
  "HEI-A": "HEICO CORP CL A",
  "HELE": "헬렌 오브 트로이",
  "HELP": "사이빈",
  "HEPS": "디 마켓 일렉트로시티 ADR",
  "HEQ": "John Hancock Diversified",
  "HERE": "히어 그룹 ADR",
  "HERZ": "Herzfeld Credit Income Fund，Inc.",
  "HESM": "헤스 미드스트림",
  "HFBL": "홈 페더럴 뱅코프 오브 루이지아나",
  "HFFG": "HF 푸즈그룹",
  "HFRO": "Highland Opportunities and",
  "HFRO-P-A": "Highland Opportunities and Income Fund",
  "HFRO-P-B": "Highland Opportunities and Income Fund",
  "HFWA": "헤리티지 파이낸셜",
  "HG": "해밀턴 인슈어런스 그룹",
  "HGBL": "헤리티지글로벌",
  "HGLB": "Highland Global Allocation Fund",
  "HGTY": "해거티",
  "HGV": "힐튼 그랜드 베케이션스",
  "HHH": "하워드 휴스 홀딩스",
  "HHS": "하트 행크스",
  "HIFS": "힝엄 인스티튜션 포 세이빙스",
  "HIG": "하트포드 인슈어런스 그룹",
  "HIG-P-G": "하트포드 인슈어런스 그룹",
  "HIHO": "하이웨이 홀딩스",
  "HII": "헌팅턴 잉걸스 인더스트리즈",
  "HIMS": "힘스 & 허즈",
  "HIMX": "하이맥스 테크놀로지스 ADR",
  "HIND": "바이옴 홀딩스",
  "HIO": "Western Asset High Income Opportunity Closed Fund",
  "HIPO": "히포 홀딩스",
  "HIT": "헬스 인 테크",
  "HITI": "하이 타이드",
  "HIVE": "하이브 디지털 테크놀로지스",
  "HIW": "하이우즈 프로퍼티스",
  "HIX": "Western Asset High Income Fund II Inc",
  "HKD": "AMTD 디지털",
  "HKIT": "하이텍 글로벌",
  "HKPD": "셀리안 바이오테크",
  "HL": "헤클라 마이닝",
  "HL-P-B": "헤클라 마이닝",
  "HLF": "허벌라이프",
  "HLI": "훌리한 로키",
  "HLIO": "헬리오스 테크놀로지스",
  "HLIT": "하모닉",
  "HLLY": "홀리",
  "HLMN": "힐먼 솔루션스",
  "HLN": "헤일리온 ADR",
  "HLNE": "해밀턴 레인",
  "HLP": "홍리 그룹",
  "HLT": "힐튼 월드와이드 홀딩스",
  "HLX": "헬릭스 에너지 솔루션스 그룹",
  "HLXC": "헬릭스 애퀴지션 III",
  "HMC": "혼다자동차 ADR",
  "HMH": "HMH 홀딩",
  "HMN": "호레이스 맨 에듀케이터스",
  "HMR": "하이드말 매리타임 홀딩스",
  "HMY": "하모니 골드 마이닝 ADR",
  "HNGE": "힌지 헬스",
  "HNI": "Hni",
  "HNNA": "헤네시 어드바이저스",
  "HNRG": "핼러도 에너지",
  "HNST": "어니스트 컴퍼니",
  "HNVR": "하노버 뱅코프",
  "HODO": "하우스 오브 도지",
  "HOFT": "후커 퍼니싱스",
  "HOG": "할리-데이비슨",
  "HOLO": "마이크로클라우드 홀로그램",
  "HOMB": "홈 뱅크셰어스",
  "HON": "허니웰 인터내셔널",
  "HONA": "허니웰 에어로스페이스",
  "HOOD": "로빈후드",
  "HOPE": "호프 뱅코프",
  "HOUR": "아워 루프",
  "HOV": "호브내니언 엔터프라이스",
  "HOVNP": "호브내니언 엔터프라이스 우선주 시리즈 A 7.625%",
  "HOVR": "뉴 호라이즌 에어크래프트",
  "HOWL": "웨어울프 테라퓨틱스",
  "HP": "HP",
  "HPAI": "헬포트 AI",
  "HPE": "휴렛패커드 엔터프라이즈",
  "HPE-P-C": "휴렛패커드 엔터프라이즈",
  "HPF": "John Hancock Preferred Income II Closed Fund",
  "HPI": "John Hancock Preferred Income Closed Fund",
  "HPK": "하이피크에너지",
  "HPP": "허드슨 퍼시픽 프로퍼티즈",
  "HPP-P-C": "허드슨 퍼시픽 프로퍼티즈",
  "HPQ": "Hp",
  "HPS": "John Hancock Preferred Income III Closed Fund",
  "HQ": "호라이즌 퀀텀 홀딩스",
  "HQH": "abrdn Healthcare Investors",
  "HQI": "하이어퀘스트",
  "HQL": "abrdn Life Sciences Investors",
  "HQY": "헬스에퀴티",
  "HR": "헬스케어 리얼티 트러스트",
  "HRB": "H&R 블록",
  "HRI": "허크 홀딩스",
  "HRL": "호멜 푸즈",
  "HRMY": "하모니 바이오사이언시스 홀딩스",
  "HROW": "해로우",
  "HRTG": "헤리티지 인슈어런스 홀딩스",
  "HRTX": "헤런 테라퓨틱스",
  "HRZN": "호라이즌 테크놀로지 파이낸스",
  "HSAI": "헤사이 그룹 ADR",
  "HSBC": "HSBC 홀딩스 ADR",
  "HSCS": "하트사이언스",
  "HSDT": "솔라나",
  "HSHP": "히말라야 쉬핑",
  "HSIC": "헨리 셰인",
  "HSLV": "하이랜더 실버",
  "HST": "호스트 호텔스 & 리조트",
  "HSTM": "헬스스트림",
  "HSY": "허쉬",
  "HTB": "홈트러스트 뱅크셰어스",
  "HTCO": "하이-트렌드 인터내셔널 그룹",
  "HTCR": "하트코어 엔터프라이시스",
  "HTD": "John Hancock Tax Advantaged Dividend Income Closed Fund",
  "HTFL": "하트플로우",
  "HTGC": "허큘리스 캐피털",
  "HTH": "힐탑 홀딩스",
  "HTHT": "화주 그룹",
  "HTLD": "하트랜드 익스프레스",
  "HTLM": "홈스투라이프",
  "HTO": "H2O 아메리카",
  "HTOO": "퓨전 퓨얼 그린",
  "HTT": "하이템플러 테크",
  "HTZ": "허츠 글로벌 홀딩스",
  "HUBB": "허벨",
  "HUBC": "허브 사이버 시큐리티",
  "HUBG": "허브 그룹",
  "HUBS": "허브스팟",
  "HUDI": "화디 인터내셔널 그룹",
  "HUHU": "후후테크 인터내셔널 그룹",
  "HUIZ": "후이쩌 홀딩 ADR",
  "HUM": "휴마나",
  "HUMA": "휴마사이트",
  "HUN": "헌츠맨",
  "HURA": "투후라 바이오사이언스",
  "HURC": "허코 컴퍼니스",
  "HURN": "휴런 컨설팅 그룹",
  "HUT": "헛 8",
  "HUYA": "후야 ADR",
  "HVII": "헤네스 캐피탈 인베스트먼트 VII",
  "HVMC": "하이뷰 머저",
  "HVT": "하버티 퍼니처",
  "HVT-A": "Haverty Furniture Companies",
  "HWBK": "호손 뱅크셰어스",
  "HWC": "핸콕 휘트니",
  "HWH": "HWH 인터내셔널",
  "HWKN": "호킨스",
  "HWM": "하우멧 에어로스페이스",
  "HXHX": "하오신 홀딩스",
  "HXL": "헥셀",
  "HY": "하이스터-예일",
  "HYFM": "하이드로팜 홀딩스",
  "HYFT": "마인드워크 홀딩스",
  "HYI": "Western Asset High Yield Opportunity Fund",
  "HYLN": "하일리온 홀딩스",
  "HYMC": "하이크로프트 마이닝 홀딩",
  "HYNE": "호인 뱅코프",
  "HYPD": "하이페리온 디파이",
  "HYPR": "하이퍼파인",
  "HYT": "Blackrock",
  "HZO": "마린맥스",
  "IACO": "아이디어 애퀴지션",
  "IACQ": "아이레닉 애퀴지션",
  "IAE": "Voya Asia Pacific High Dividend Equity Income Fund",
  "IAF": "abrdn Australia Equity Fund",
  "IAG": "아이엠골드",
  "IART": "인테그라 라이프사이언시스 홀딩스",
  "IAUX": "I-80 골드",
  "IBAC": "IB 애퀴지션",
  "IBCP": "인디펜던트 뱅크",
  "IBEX": "아이벡스",
  "IBG": "이노베이션 베버리지 그룹",
  "IBIO": "아이바이오",
  "IBKR": "인터랙티브 브로커스 그룹",
  "IBM": "IBM(인터내셔널 비지니스 머신)",
  "IBN": "ICICI 뱅크 ADR",
  "IBO": "임팩트 바이오메디컬",
  "IBOC": "인터내셔널 뱅크셰어즈",
  "IBP": "인스톨드 빌딩 프로덕츠",
  "IBRX": "이뮤니티바이오",
  "IBTA": "아이보타",
  "ICCC": "이뮤셀",
  "ICCM": "아이스큐어 메디컬",
  "ICE": "인터컨티넨털 익스체인지",
  "ICFI": "ICF 인터내셔널",
  "ICG": "인트체인스 그룹 ADR",
  "ICHR": "아이코아 홀딩스",
  "ICL": "이스라엘 케미컬스",
  "ICLR": "아이콘",
  "ICMB": "인베스트코프 크레디트 매니지먼트",
  "ICON": "아이콘 에너지",
  "ICR-P-A": "인포인트 커머셜 리얼 에스테이트 인컴 우선주 시리즈 A 6.75%",
  "ICU": "씨스타 메디컬 홀딩",
  "ICUI": "ICU 메디컬",
  "IDA": "아이다코프",
  "IDAC": "아이언 돔 애퀴지션 I",
  "IDAI": "티 스탬프",
  "IDCC": "인터디지털",
  "IDE": "Voya Infrastructure, Industrials And Materials Fund",
  "IDN": "인텔리체크",
  "IDR": "아이다호 스트래터직 리소시스",
  "IDT": "Idt",
  "IDXX": "아이덱스 래보라토리스",
  "IDYA": "아이디야 바이오사이언스",
  "IE": "아이반호 일렉트릭",
  "IEAG": "인피니트 이글 애퀴지션",
  "IEP": "Icahn Enterprises L.P",
  "IESC": "IES 홀딩스",
  "IEX": "아이덱스",
  "IFBD": "인포버드",
  "IFF": "인터내셔널 플레이버스 & 프레그런스",
  "IFN": "Aberdeen India Fund",
  "IFRX": "인플락스",
  "IFS": "인터코프 파이낸셜 서비스",
  "IGA": "Voya Global Advantage And Premium Opportunity Fund",
  "IGAC": "인베스트그린 애퀴지션",
  "IGC": "인디아 글로벌리제이션 캐피털",
  "IGD": "Voya Global Equity Dividend And Premium Opportunity Fund",
  "IGI": "Western Asset Investment Grade Opps Trust Inc.",
  "IGIC": "인터내셔널 제네럴 인슈런스 홀딩스",
  "IGR": "CBRE Global Real Estate Income Fund",
  "IH": "아이휴먼 ADR",
  "IHD": "Voya Emerging Markets High",
  "IHG": "인터컨티넨탈 호텔 그룹 ADR",
  "IHRT": "아이하트미디어",
  "IHS": "IHS 홀딩",
  "IHT": "인스위츠 호스피털리티 트러스트",
  "IIF": "Morgan Stanley India Investment Closed Fund",
  "III": "인포메이션 서비스 그룹",
  "IIIN": "인스틸 인더스트리",
  "IIIV": "I3 버티칼스",
  "IIM": "Invesco Value Municipal Income Closed Fund",
  "IIPR": "이노베이티브 인더스트리얼 프로퍼티",
  "IIPR-P-A": "이노베이티브 인더스트리얼 프로퍼티",
  "IKT": "인히비케이즈 테라퓨틱스",
  "ILAG": "인텔리전트 리빙 어플리케이션 그룹",
  "ILLR": "트릴러 그룹",
  "ILLU": "일루미네이션 애퀴지션 I",
  "ILMN": "일루미나",
  "ILPT": "인더스트리얼 로지스틱스 프로퍼티",
  "IMA": "이매진바이오",
  "IMAX": "아이맥스",
  "IMC": "IMC 레어 어스",
  "IMCC": "IM 카나비스",
  "IMCR": "이뮤노코어 홀딩스 ADR",
  "IMDX": "인사이트 몰레큘러 다이어그노스틱스",
  "IMKTA": "잉글스 마케츠",
  "IMMP": "이뮤텝 ADR",
  "IMMR": "이머션",
  "IMMX": "이믹스 바이오파마",
  "IMNM": "이뮤놈",
  "IMNN": "이뮨온",
  "IMO": "임페리얼 오일",
  "IMOS": "칩모스 테크놀로지스 ADR",
  "IMPP": "임페리얼 페트롤리엄",
  "IMPPP": "임페리얼 페트롤리엄 우선주 시리즈 A 8.75%",
  "IMRN": "이뮤론 ADR",
  "IMRX": "이뮤니어링",
  "IMSR": "테레스트리얼 에너지",
  "IMTE": "인티그레이티드 미디어 테크놀로지",
  "IMTX": "이매틱스",
  "IMUX": "이뮤닉",
  "IMVT": "이뮤노반트",
  "IMXI": "인터내셔널 머니 익스프레스",
  "INAB": "인8바이오",
  "INAC": "인디고 애퀴지션",
  "INBK": "퍼스트 인터넷 뱅코프",
  "INBS": "인텔리전트 바이오 솔루션스",
  "INBX": "인히브릭스 바이오사이언시스",
  "INCR": "인터큐어",
  "INCY": "인사이트",
  "INDB": "인디펜던트 뱅크 (매사추세츠)",
  "INDI": "인디 세미컨덕터",
  "INDO": "인도네시아 에너지 코퍼레이션",
  "INDP": "인댑터스 테라퓨틱스",
  "INDV": "인디비어 파마슈티컬스",
  "INEO": "INNEOVA 홀딩스",
  "INFQ": "인플렉션",
  "INFU": "인퓨시스템즈 홀딩스",
  "INFY": "인포시스 ADR",
  "ING": "ING 그룹 ADR",
  "INGM": "인그램 마이크로 홀딩",
  "INGN": "이노젠",
  "INGR": "인그리디언",
  "INHD": "인노 홀딩스",
  "INIO": "이니오",
  "INKT": "밍크 테라퓨틱스",
  "INLF": "인리프",
  "INLX": "인텔리네틱스",
  "INM": "인메드 파마슈티컬스",
  "INMB": "인뮨 바이오",
  "INMD": "인모드",
  "INN": "서밋 호텔 프로퍼티스",
  "INN-P-E": "서밋 호텔 프로퍼티스",
  "INN-P-F": "서밋 호텔 프로퍼티스",
  "INNV": "이노베이지 홀딩",
  "INO": "이노비오 파마슈티컬스",
  "INOD": "이노데이터",
  "INR": "인피니티 내추럴 리소시스",
  "INSE": "인스파이어드 엔터테인먼트",
  "INSG": "인시고",
  "INSM": "인스메드",
  "INSP": "인스파이어 메디컬 시스템",
  "INSW": "인터네셔널 시웨이스",
  "INTA": "인탭",
  "INTC": "인텔",
  "INTG": "인터그룹",
  "INTJ": "인텔리전트 그룹",
  "INTR": "인터 앤 코",
  "INTS": "인텐시티 테라퓨틱스",
  "INTT": "인테스트",
  "INTU": "인튜이트",
  "INTZ": "인트루젼",
  "INUV": "이누보",
  "INV": "인벤처",
  "INVA": "이노비바",
  "INVE": "아이덴티브",
  "INVH": "인비테이션 홈스",
  "INVX": "이노벡스 인터내셔널",
  "INVZ": "이노비즈 테크놀로지스",
  "IOND": "아이오닉 디지털",
  "IONQ": "아이온큐",
  "IONR": "아이오니어 ADR",
  "IONS": "아이오니스 파마슈티컬스",
  "IOR": "인컴 오퍼튜니티 리얼티 인베스터스",
  "IOSP": "이노스펙",
  "IOT": "삼사라",
  "IOTR": "아이오쓰리",
  "IOVA": "이오밴스 바이오테라퓨틱스",
  "IP": "인터내셔널 페이퍼",
  "IPAR": "인터퍼퓸",
  "IPCX": "인플렉션 포인트 애퀴지션 III",
  "IPDN": "프로페셔널 다이버시티 네트워크",
  "IPEX": "인플렉션 포인트 애퀴지션 V",
  "IPFX": "인플렉션 포인트 애퀴지션 VI",
  "IPGP": "IPG 포토닉스",
  "IPHA": "이네이트 파르마 ADR",
  "IPI": "인트레피드 포타시",
  "IPM": "인텔리전트 프로텍션 매니지먼트",
  "IPSC": "센추리 테라퓨틱스",
  "IPST": "IP 스트래티지 홀딩스",
  "IPVV": "인터프라이빗 인베스트 파트너스V",
  "IPW": "아이파워",
  "IPWR": "아이디얼 파워",
  "IPX": "이페리온엑스 ADR",
  "IQ": "아이치이 ADR",
  "IQI": "Invesco Quality Municipal Securities",
  "IQMX": "IQM 퀀텀 컴퓨터스 ADR",
  "IQST": "Iqstel",
  "IQV": "아이큐비아 홀딩스",
  "IR": "잉가솔랜드",
  "IRAB": "아이리스 애퀴지션 II",
  "IRD": "오푸스 제네틱스",
  "IRDM": "이리디움 커뮤니케이션스",
  "IREN": "아이렌",
  "IRHO": "아이언 호스 애퀴지션스 II",
  "IRIX": "이리덱스",
  "IRM": "아이언 마운틴",
  "IRMD": "아이라디메드",
  "IRON": "디스크 메디슨",
  "IRS": "IRSA 인베르시오네스 ADR",
  "IRT": "인디펜던스 리얼티 트러스트",
  "IRTC": "아이리듬 홀딩스",
  "IRWD": "아이언우드 파마슈티컬스",
  "ISBA": "이자벨라 뱅크",
  "ISD": "PGIM High Yield Bond Fund，Inc",
  "ISNR": "스노우 로스차일드 애퀴지션",
  "ISOU": "아이소에너지",
  "ISPC": "아이스페시멘",
  "ISPR": "이스파이어 테크놀로지",
  "ISRG": "인튜이티브 서지컬",
  "ISSC": "이노베이티브 솔루션스 & 서포트",
  "ISTR": "인베스타 홀딩",
  "IT": "가트너",
  "ITG": "Itg",
  "ITGR": "인티거 홀딩스",
  "ITHA": "ITHAX 애퀴지션 III",
  "ITIC": "인베스터스 타이틀",
  "ITOC": "아이토닉 홀딩스",
  "ITP": "IT 테크 패키징",
  "ITRG": "인테그라 리소시즈",
  "ITRI": "아이트론",
  "ITRN": "이투란 로케이션 앤 콘트롤",
  "ITT": "Itt",
  "ITUB": "이타우 우니방쿠 홀딩 ADR",
  "ITW": "일리노이 툴 웍스",
  "IVA": "인벤티바 ADR",
  "IVDA": "아이베다 솔루션스",
  "IVF": "INVO 퍼틸리티",
  "IVR": "인베스코 모기지 캐피털",
  "IVR-P-C": "인베스코 모기지 캐피털",
  "IVT": "인벤트러스트 프로퍼티스",
  "IVVD": "인비비드",
  "IVZ": "인베스코",
  "IX": "오릭스 ADR",
  "IXHL": "인카넥스 헬스케어",
  "IZEA": "아이지아 월드와이드",
  "IZM": "ICZOOM Group",
  "J": "제이콥스 솔루션스",
  "JAB": "JAB 애퀴지션 I",
  "JACK": "Jack in the Box",
  "JACS": "Jackson Acquisition Company II",
  "JAGU": "재규어 우라늄",
  "JAGX": "재규어 헬스",
  "JAKK": "잭스 퍼시픽",
  "JAN": "Janus Living",
  "JANX": "재넉스 테라퓨틱스",
  "JATT": "재트 II 애퀴지션",
  "JAZZ": "재즈 파마슈티컬스",
  "JBDI": "JBDI 홀딩스",
  "JBGS": "JBG SMITH Properties Common",
  "JBHT": "JB Hunt Transport Services",
  "JBI": "야누스 인터내셔널 그룹",
  "JBIO": "Jade Biosciences",
  "JBK": "골드만삭스 캐피탈 I 시큐리티-백드 우선주 시리즈 2004-6",
  "JBL": "자빌",
  "JBLU": "JetBlue Airways",
  "JBS": "Jbs N.V.",
  "JBSS": "John B. SanfilippoSON",
  "JBTM": "JBT 마렐",
  "JCAP": "제퍼슨 캐피털",
  "JCE": "Nuveen Core Equity Alpha Closed Fund",
  "JCI": "존슨 컨트롤스 인터내셔널",
  "JCSE": "JE 클린테크 홀딩스",
  "JCTC": "주잇-캐머런 트레이딩",
  "JD": "제이디닷컴 ADR",
  "JDZG": "지아드",
  "JEF": "제프리스 파이낸셜 그룹",
  "JELD": "젤드-웬 홀딩",
  "JEM": "707 케이맨 홀딩스",
  "JENA": "제나 애퀴지션 II",
  "JF": "J and Friends Holdings",
  "JFB": "JFB Construction Holdings Class A",
  "JFIN": "쟈인 그룹 ADR",
  "JFR": "Nuveen Floating Rate Income Closed Fund",
  "JFU": "9F ADR",
  "JG": "오로라 모바일 ADR",
  "JGH": "Nuveen Global High Income Fund",
  "JHI": "John Hancock Investors Trust Capital Stock",
  "JHS": "John Hancock Income Securities Closed Fund",
  "JHX": "James Hardie Industries PLC",
  "JILL": "제이질",
  "JJSF": "J&J 스낵 푸즈",
  "JKHY": "잭 헨리 & 어소시에이츠",
  "JKS": "징코솔라 홀딩스 ADR",
  "JL": "J-롱 그룹",
  "JLHL": "주롱 홀딩",
  "JLL": "존스 랭 라살",
  "JLS": "Nuveen Mortgage and Income Fund",
  "JMIA": "주미아 테크놀로지 AG ADR",
  "JMKE": "저지 마이크스 서브스",
  "JMM": "Nuveen Multi-Market Income Fund",
  "JMSB": "존 마샬 뱅코프",
  "JNJ": "존슨앤드존슨",
  "JOB": "GEE 그룹",
  "JOBY": "조비 에비에이션",
  "JOE": "세인트 조",
  "JOF": "Japan Smaller Capitalization Closed Fund",
  "JOUT": "존슨 아웃도어스",
  "JOYY": "조이 ADR",
  "JPC": "Nuveen Preferred & Income Opportunities Fund",
  "JPM": "제이피모간체이스",
  "JPM-P-C": "제이피모간체이스",
  "JPM-P-D": "제이피모간체이스",
  "JPM-P-J": "제이피모간체이스",
  "JPM-P-K": "제이피모간체이스",
  "JPM-P-L": "제이피모간체이스",
  "JPM-P-M": "제이피모간체이스",
  "JQC": "Nuveen Credit Strategies Income Closed Fund",
  "JRI": "Nuveen Real Asset Income and Growth Fund",
  "JRS": "Nuveen Real Estate Income Closed Fund",
  "JRSH": "저라쉬 홀딩스",
  "JRVR": "제임스 리버 그룹 홀딩스",
  "JSPR": "재스퍼 테라퓨틱스",
  "JTAI": "젯.AI",
  "JUNS": "주피터 뉴로사이언시스",
  "JVA": "커피 홀딩",
  "JWEL": "조웰 글로벌",
  "JXG": "JX 룩스벤처 그룹",
  "JXN": "잭슨 파이낸셜",
  "JXN-P-A": "잭슨 파이낸셜",
  "JYD": "제이유드 글로벌 로지스틱스",
  "JYNT": "조인트",
  "JZ": "전지 교육 기술 그룹 ADR",
  "JZXN": "지우지 홀딩스",
  "KAI": "카단트",
  "KALA": "칼라 바이오",
  "KALU": "카이저 알루미늄",
  "KAPA": "카이로스 파르마",
  "KARD": "카디건",
  "KARO": "카루",
  "KAZR": "스카이라인 빌더스 그룹 홀딩",
  "KB": "KB금융지주 ADR",
  "KBDC": "케인 앤더슨",
  "KBH": "KB 홈",
  "KBON": "카본 캐피털 파트너스",
  "KBR": "Kbr",
  "KBSX": "Fst",
  "KC": "킹소프트 클라우드 홀딩스 ADR",
  "KCHV": "코채브 디펜스 애퀴지션",
  "KD": "킨드릴 홀딩스",
  "KDK": "코디악 AI",
  "KDP": "큐리그 닥터 페퍼",
  "KE": "킴볼 일렉트로닉스",
  "KEEL": "킬 인프라스트럭처",
  "KELYA": "켈리 서비스 Class A",
  "KELYB": "켈리 서비스 Class B",
  "KEN": "케논 홀딩스",
  "KEP": "한국전력 ADR",
  "KEQU": "키와우니 사이언티픽",
  "KEX": "커비",
  "KEY": "키코프",
  "KEY-P-I": "키코프",
  "KEY-P-J": "키코프",
  "KEY-P-K": "키코프",
  "KEY-P-L": "키코프",
  "KEYS": "키사이트 테크놀로지스",
  "KEYY": "키스톤 애퀴지션",
  "KF": "Korea Fund",
  "KFFB": "캔터키 퍼스트 페더럴 뱅코프",
  "KFII": "K&F 그로스 애퀴지션 II",
  "KFRC": "K포스",
  "KFY": "콘 페리",
  "KG": "케스트렐 그룹",
  "KGC": "킨로스 골드",
  "KGEI": "콜리브리 글로벌 에너지",
  "KGS": "코디악 가스 서비시스",
  "KHC": "크래프트 하인즈",
  "KIDS": "오쏘피디아트릭스",
  "KIDZ": "Kidz Ai",
  "KIM": "킴코 리얼티",
  "KIM-P-L": "킴코 리얼티",
  "KIM-P-M": "킴코 리얼티",
  "KIM-P-N": "킴코 리얼티",
  "KINS": "킹스톤 컴퍼니",
  "KIO": "Kkr",
  "KITT": "노티커스 로보틱스",
  "KKR": "Kkr",
  "KKR-P-D": "Kkr",
  "KLAC": "Kla",
  "KLAR": "클라나 그룹",
  "KLC": "카인드케어 러닝",
  "KLIC": "쿨리크 & 소파 인더스트리스",
  "KLRA": "카일레라 테라퓨틱스",
  "KLRS": "칼라리스 테라퓨틱스",
  "KLTR": "칼투라",
  "KLXE": "KLX 에너지 서비시스 홀딩스",
  "KMB": "킴벌리클라크",
  "KMDA": "카마다",
  "KMI": "킨더 모건",
  "KMPR": "켐퍼",
  "KMRK": "K테크 솔루션스",
  "KMT": "켄나메탈",
  "KMTS": "케스트라 메디컬 테크놀로지스",
  "KMX": "카맥스",
  "KN": "놀스",
  "KNDI": "칸디 테크놀로지스 그룹",
  "KNF": "나이프 리버",
  "KNOP": "Knot Offshore Partners Lp",
  "KNRX": "크노렉스",
  "KNSA": "키닉사 파마슈티컬스 인터내셔널",
  "KNSL": "킨세일 캐피털 그룹",
  "KNTK": "키네틱 홀딩스",
  "KNX": "나이트-스위프트 트랜스포테이션",
  "KO": "코카콜라",
  "KOD": "코디악 사이언스",
  "KODK": "이스트먼 코닥",
  "KOF": "코카콜라 펨사 ADR",
  "KOP": "코퍼스 홀딩스",
  "KOPN": "코핀",
  "KOS": "코스모스 에너지",
  "KOSS": "코스",
  "KOYN": "CSLM 디지털 애셋 애퀴지션 III",
  "KPET": "케이펫 울트라 페이스라인",
  "KPLT": "캐터펄트 홀딩스",
  "KPRX": "키오라 파마슈티컬스",
  "KPTI": "카료팜 테라퓨틱스",
  "KR": "크로거",
  "KRAQ": "KRAK애퀴지션",
  "KRC": "킬로이 리얼티",
  "KREF": "KKR 리얼에스테이트 파이낸스 트러스트",
  "KREF-P-A": "KKR 리얼에스테이트 파이낸스 트러스트",
  "KRG": "카이트 리얼티 그룹 트러스트",
  "KRKR": "36KR 홀딩스 ADR",
  "KRMD": "코루 메디컬 시스템스",
  "KRMN": "카르만 홀딩스",
  "KRNT": "코닛 디지털",
  "KRNY": "커니 파이낸셜",
  "KRO": "크로노스 월드와이드",
  "KROS": "케로스 테라퓨틱스",
  "KRP": "Kimbell Royalty Partners, LP Common Units representing",
  "KRRO": "코로 바이오",
  "KRSP": "라이스 애퀴지션 3",
  "KRT": "카랫 패키징",
  "KRUS": "쿠라 스시 USA",
  "KRYS": "크리스탈 바이오텍",
  "KSCP": "나이트스코프",
  "KSPI": "카스피.kz 우선주",
  "KSS": "콜스",
  "KT": "Kt",
  "KTB": "콘투어 브랜즈",
  "KTCC": "키 트로닉",
  "KTF": "DWS Municipal Income Trust",
  "KTH": "스트럭처 프로덕츠 Corts TR 페코 에너지 우선주 8%",
  "KTN": "크레딧인핸스드 코츠 트러스트 우선주 8.2050%",
  "KTOS": "크라토스 디펜스 & 시큐리티 솔",
  "KTTA": "파시테아 테라퓨틱스",
  "KTWO": "K2 캐피탈 애퀴지션",
  "KULR": "KULR 테크놀로지 그룹",
  "KURA": "쿠라 온콜로지",
  "KUST": "커스텀 엔터테인먼트",
  "KVHI": "KVH 인더스트리",
  "KVUE": "켄뷰",
  "KVYO": "클라비요",
  "KWM": "K 웨이브 미디어",
  "KWR": "퀘이커 케미컬",
  "KWY": "킹스웨이",
  "KXIN": "카이신 홀딩스",
  "KYIV": "키이우스타 그룹",
  "KYMR": "키메라 테라퓨틱스",
  "KYN": "Kayne Anderson Energy Infrastructure Fund Inc",
  "KYNB": "킨트라 바이오",
  "KYTX": "카이버나 테라퓨틱스",
  "KZIA": "카지아 테라퓨틱스 ADR",
  "L": "로우스",
  "LAB": "스탠다드 바이오툴즈",
  "LABT": "레이크우드 아메덱스 바이오",
  "LAC": "리튬 아메리카스",
  "LAD": "리시아 모터스",
  "LADR": "래더 캐피털",
  "LAES": "실스크",
  "LAFA": "라파예트 애퀴지션",
  "LAKE": "레이크랜드 인더스트리스",
  "LAMR": "라마 애드버타이징",
  "LAND": "글래드스톤 랜드",
  "LANDO": "글래드스톤 랜드 우선주 시리즈 B 6.00%",
  "LANDP": "글래드스톤 랜드 우선주 Series C 6.00%",
  "LANV": "랑방 그룹 홀딩스",
  "LAR": "리튬 아르헨티나",
  "LARK": "랜드마크 뱅코프",
  "LASE": "레이저 포토닉스",
  "LASR": "엔라이트",
  "LATA": "갈라타 애퀴지션 II",
  "LAUR": "로리어트 에듀케이션",
  "LAW": "CS 디스코",
  "LAWR": "로봇 컨설팅 ADR",
  "LAZ": "라자드",
  "LB": "랜드브리지",
  "LBGJ": "리 뱅 인터내셔널",
  "LBRDA": "리버티 브로드밴드 시리즈 A",
  "LBRDK": "리버티 브로드밴드 시리즈 C",
  "LBRDP": "리버티 브로드밴드 우선주 시리즈 A 7.000%",
  "LBRT": "리버티 에너지",
  "LBRX": "LB 파마슈티컬스",
  "LBTYA": "리버티 글로벌 Class A",
  "LBTYB": "리버티 글로벌 Class B",
  "LBTYK": "리버티 글로벌 Class C",
  "LCCC": "레이크쇼어 애퀴지션 III",
  "LCFY": "로커파이",
  "LCID": "루시드 그룹",
  "LCII": "LCI 인더스트리스",
  "LCLN": "링컨 인터내셔널",
  "LCNB": "Lcnb",
  "LCTX": "리니지 셀 테라퓨틱스",
  "LCUT": "라이프타임 브랜즈",
  "LDI": "론디포",
  "LDOS": "레이도스 홀딩스",
  "LDP": "Cohensteers",
  "LE": "랜즈 엔드",
  "LEA": "리어",
  "LECO": "링컨 일렉트릭 홀딩스",
  "LEDS": "세미LEDS",
  "LEE": "리 엔터프라이즈",
  "LEG": "레겟 & 플랫",
  "LEGH": "레가시 하우징",
  "LEGN": "레전드 바이오테크 ADR",
  "LEGO": "레가토 머저 IV",
  "LEN": "레나 Class A",
  "LEN-B": "Lennar Corporation Class B",
  "LENZ": "렌즈 테라퓨틱스",
  "LEO": "BNY Mellon Strategic Municipals Inc",
  "LESL": "레슬리즈",
  "LEU": "센트러스 에너지",
  "LEVI": "리바이 스트라우스",
  "LEXX": "렉사리아 바이오사이언스",
  "LFAC": "립프라그 애퀴지션",
  "LFCR": "라이프코어 바이오메디컬",
  "LFMD": "라이프엠디",
  "LFMDP": "라이프엠디 우선주 시리즈 A 8.875%",
  "LFS": "라이프라스 ADR",
  "LFST": "라이프스탠스 헬스 그룹",
  "LFT": "루먼트 파이낸스 트러스트",
  "LFT-P-A": "루먼트 파이낸스 트러스트",
  "LFTO": "리프트오프 모바일",
  "LFUS": "리틀휴즈",
  "LFVN": "라이프밴티지",
  "LFWD": "라이프워드",
  "LGCL": "루카스 GC",
  "LGCY": "레가시 에듀케이션",
  "LGHL": "라이온 그룹 홀딩스 ADR",
  "LGI": "Lazard Global Total Return",
  "LGIH": "LGI 홈스",
  "LGL": "LGL 그룹",
  "LGN": "레전스",
  "LGND": "리간드 파마슈티컬스",
  "LGO": "라르고",
  "LGPS": "로그프로스타일",
  "LGVN": "롱에버론",
  "LH": "랩코프 홀딩스",
  "LHAI": "링크홈 홀딩스",
  "LHSW": "리안허 소웰 인터내셔널 그룹",
  "LHX": "L3 해리스 테크놀러지스",
  "LI": "리 오토 ADR",
  "LICN": "리첸 인터내셔널",
  "LIDR": "에이아이",
  "LIEN": "시카고 애틀란틱 BDC",
  "LIF": "라이프360",
  "LIFE": "에토스 테크놀로지스",
  "LII": "레녹스 인터내셔널",
  "LILA": "리버티 라틴 아메리카 Class A",
  "LILAK": "리버티 라틴 아메리카 Class C",
  "LILAP": "리버티 라틴 아메리카 우선주 Series A 9.0%",
  "LIME": "뉴트론 홀딩스",
  "LIMN": "리미나투스 파마",
  "LIN": "린드",
  "LINC": "링컨 에듀케이셔널 서비스",
  "LIND": "린드블라드 익스퍼디션스 홀딩스",
  "LINE": "리니지",
  "LINK": "인터링크 일렉트로닉스",
  "LION": "라이온스게이트 스튜디오스",
  "LIQT": "리크테크 인터내셔널",
  "LITB": "라이트인더박스 홀딩 ADR",
  "LITE": "루멘텀 홀딩스",
  "LITS": "라이트 스트래티지",
  "LIVE": "라이브 벤처스",
  "LIVN": "리바노바",
  "LKFN": "레이크랜드 파이낸셜",
  "LKFT": "레이크프론트 바이오테라퓨틱스",
  "LKQ": "Lkq",
  "LKSP": "레이크 슈페리얼 애퀴지션",
  "LLY": "일라이 릴리",
  "LLYVA": "리버티 라이브 홀딩스 Series A",
  "LLYVK": "리버티 라이브 Series C",
  "LMAT": "르메이트르 배스큘러",
  "LMB": "림바흐 홀딩스",
  "LMND": "레모네이드",
  "LMNR": "리모네이라",
  "LMRI": "루멕사 이미징 홀딩스",
  "LMT": "록히드 마틴",
  "LNAI": "루나이 바이오웍스",
  "LNC": "링컨 내셔널",
  "LNC-P-D": "링컨 내셔널",
  "LND": "브라질아그로 ADR",
  "LNG": "셰니어 에너지",
  "LNKS": "링커스 인더스트리스",
  "LNN": "린지",
  "LNSR": "렌자",
  "LNT": "얼라이언트 에너지",
  "LNTH": "랜티우스 홀딩스",
  "LNZA": "란자테크 글로벌",
  "LOAN": "맨해튼 브리지 캐피털",
  "LOAR": "로어 홀딩스",
  "LOB": "라이브 오크 뱅크셰어스",
  "LOB-P-A": "라이브 오크 뱅크셰어스",
  "LOBO": "로보 테크놀로지스",
  "LOCL": "로컬 바운티",
  "LOCO": "엘 폴로 로코 홀딩스",
  "LODE": "콤스톡",
  "LOGI": "로지텍 인터내셔널",
  "LOMA": "로마 네그라 콤파니아 인더스트리얼 ADR",
  "LONA": "레오나바이오",
  "LOOP": "룹 인더스트리",
  "LOPE": "그랜드 캐년 에듀케이션",
  "LOT": "로터스 테크놀로지 ADR",
  "LOVE": "러브색",
  "LOW": "로우스 컴퍼니",
  "LPA": "로지스틱 프로퍼티스 오브 디 아메리카스",
  "LPAA": "런치 원 애퀴지션",
  "LPBB": "런치 투 애퀴지션",
  "LPCN": "리포신",
  "LPCV": "런치패드 카덴자 애퀴지션 I",
  "LPG": "도리안 LPG",
  "LPL": "엘지디스플레이 ADR",
  "LPLA": "LPL 파이낸셜 홀딩스",
  "LPSN": "라이브퍼슨",
  "LPTH": "라이트패스 테크놀로지스",
  "LPX": "루이지애나-퍼시픽",
  "LQDA": "리퀴디아",
  "LQDT": "리퀴디티 서비스",
  "LRCX": "램 리서치",
  "LRE": "리드 리얼 에스테이트 ADR",
  "LRHC": "라 로사 홀딩스",
  "LRMR": "라리마 테라퓨틱스",
  "LRN": "스트라이드",
  "LSAK": "레사카 테크놀로지스",
  "LSBK": "레이크 쇼어 뱅코프",
  "LSCC": "래티스 세미컨덕터",
  "LSE": "레이센 에너지 홀딩",
  "LSF": "레어드 슈퍼푸드",
  "LSPD": "라이트스피드 커머스",
  "LSTA": "리사타 테라퓨틱스",
  "LSTR": "랜드스타 시스템",
  "LTBR": "라이트브리지",
  "LTC": "LTC 프로퍼티즈",
  "LTGO": "Latigo Biotherapeutics Inc",
  "LTGR": "롱 테이블 그로스",
  "LTH": "라이프 타임 그룹 홀딩스",
  "LTM": "라탐 에어라인스 그룹 ADR",
  "LTRN": "랜턴 파마",
  "LTRX": "렌트로닉",
  "LU": "루팍스 홀딩 ADR",
  "LUCD": "루시드 다이어그노스틱스",
  "LUCK": "럭키 스트라이크 엔터테인먼트",
  "LUCY": "이노베이티브 아이웨어",
  "LUD": "루다 테크놀로지 그룹",
  "LULU": "룰루레몬 애슬레티카",
  "LUMN": "루멘 테크놀로지스",
  "LUNG": "풀몬스",
  "LUNR": "인튜이티브 머신스",
  "LUV": "사우스웨스트 에어라인스",
  "LUXE": "럭스익스피리언스 ADR",
  "LVLU": "루루스 패션 라운지 홀딩스",
  "LVO": "라이브원",
  "LVS": "라스베이거스 샌즈",
  "LVWR": "AEA-브릿지스 임팩트",
  "LW": "램 웨스턴 홀딩스",
  "LWAC": "라이트웨이브 애퀴지션",
  "LWAY": "라이프웨이 푸드",
  "LWLG": "라이트웨이브 로직",
  "LX": "레신핀테크 홀딩스 ADR",
  "LXEH": "리샹 에듀케이션 홀딩 ADR",
  "LXEO": "렉시오 테라퓨틱스",
  "LXFR": "럭스퍼 홀딩스",
  "LXP": "LXP 인더스트리얼 트러스트",
  "LXP-P-C": "LXP 인더스트리얼 트러스트",
  "LXRX": "렉시콘 파마슈티컬스",
  "LXU": "LSB 인더스트리",
  "LYB": "라이온델바젤 인더스트리스",
  "LYEL": "라이엘 이뮤노파마",
  "LYFT": "리프트",
  "LYG": "로이즈 뱅킹 그룹 ADR",
  "LYTS": "LSI 인더스트리",
  "LYV": "라이브 네이션 엔터테인먼트",
  "LZ": "리갈줌닷컴",
  "LZB": "레이지보이",
  "LZM": "라이프존 메탈스",
  "LZMH": "LZ 테크놀로지 홀딩스",
  "M": "메이시스",
  "MA": "마스터카드",
  "MAA": "미드아메리카 아파트 커뮤니티",
  "MAA-P-I": "미드아메리카 아파트 커뮤니티",
  "MAAS": "마스",
  "MAC": "메이서리치",
  "MACI": "멜라르 애퀴지션 I",
  "MAGH": "매그니튜드 인터내셔널",
  "MAGN": "마그네라",
  "MAIA": "마이아 바이오테크놀로지",
  "MAIN": "메인 스트리트 캐피털",
  "MAIR": "매디슨 에어 솔루션스",
  "MAKO": "마코 마이닝",
  "MAMA": "마마스 크리에이션스",
  "MAMK": "맥스메이킹",
  "MAMO": "마시모 그룹",
  "MAN": "맨파워그룹",
  "MANE": "베라더믹스",
  "MANH": "맨해튼 어소시에이츠",
  "MANU": "맨체스터 유나이티드",
  "MAR": "메리어트 인터내셔널",
  "MARA": "마라 홀딩스",
  "MAS": "매스코",
  "MASK": "3 E 네트워크 테크놀로지 그룹",
  "MASS": "908 디바이시스",
  "MAT": "마텔",
  "MATH": "메타알파 테크놀로지 홀딩",
  "MATV": "마티브 홀딩스",
  "MATW": "매튜스 인터내셔널",
  "MATX": "매트슨",
  "MAX": "미디어알파",
  "MAYS": "JW 메이스",
  "MAZE": "메이즈 테라퓨틱스",
  "MB": "마스터비프 그룹",
  "MBAI": "체크캡",
  "MBBC": "마라톤 뱅코프",
  "MBC": "마스터브랜드",
  "MBGL": "모빌리티 글로벌",
  "MBI": "엠비아",
  "MBIN": "머천트 뱅코프",
  "MBINL": "머천트 뱅코프 우선주 Series E 7.25%",
  "MBINM": "머천트 뱅코프 우선주 8.25%",
  "MBINN": "머천트 뱅코프 우선주 시리즈 C 6%",
  "MBIO": "머스탱 바이오",
  "MBLY": "모빌아이 글로벌",
  "MBNKO": "메달리언 뱅크 우선주 Series G",
  "MBOT": "마이크로봇 메디컬",
  "MBRX": "몰컬린 바이오테크",
  "MBUU": "말리부 보츠",
  "MBVI": "M3-브리게이드 애퀴지션 VI",
  "MBWM": "머컨틸 은행",
  "MBX": "MBX 바이오사이언시스",
  "MC": "모엘리스",
  "MCAH": "마운틴 크레스트 애퀴지션 6",
  "MCB": "메트로폴리탄 뱅크 홀딩스",
  "MCBS": "메트로시티 뱅크셰어즈",
  "MCD": "맥도날드",
  "MCFT": "마스터크래프트 보트 홀딩스",
  "MCGA": "요크빌 애퀴지션",
  "MCHB": "메카닉스 뱅코프",
  "MCHP": "마이크로칩 테크놀러지",
  "MCHPP": "마이크로칩 테크놀로지 우선주 Series A 7.50%",
  "MCHX": "마첵스",
  "MCI": "Barings Corporate Investors",
  "MCK": "매케슨",
  "MCN": "XAI Madison Equity Premium",
  "MCO": "무디스",
  "MCRB": "세레스 테라퓨틱스",
  "MCRI": "모나크 카지노 & 리조트",
  "MCRP": "마이크로폴리스 홀딩",
  "MCS": "마커스",
  "MCTA": "차밍 메디컬",
  "MCY": "머큐리 제너럴",
  "MD": "페디아트릭스 메디컬 그룹",
  "MDA": "MDA 스페이스",
  "MDAI": "스펙트럴 AI",
  "MDB": "몽고DB",
  "MDBH": "MDB 캐피털 홀딩스",
  "MDCX": "메디쿠스 파마",
  "MDGL": "매드리갈 파마슈티컬스",
  "MDIA": "미디아코 홀딩",
  "MDLN": "메드라인",
  "MDLZ": "몬덜리즈 인터내셔널",
  "MDRR": "메달리스트 다이버시파이드",
  "MDT": "메드트로닉",
  "MDU": "MDU 리소시스 그룹",
  "MDV": "모디브 인더스트리얼",
  "MDV-P-A": "모디브 인더스트리얼",
  "MDWD": "메디운드",
  "MDXG": "미메드엑스 그룹",
  "MDXH": "MDxHealth SA",
  "MEC": "메이빌 엔지니어링",
  "MED": "메디패스트",
  "MEDP": "메드페이스 홀딩스",
  "MEDS": "데이터메즈 AI",
  "MEGI": "NYLI CBRE Global Infrastructure Megatrends Term Fund",
  "MEGL": "매직 엠파이어 글로벌",
  "MEI": "메소드 일렉트로닉스",
  "MELI": "메르카도리브레",
  "MENS": "지용 바이오테크",
  "MEOH": "메타넥스",
  "MERC": "머서 인터내셔널",
  "MESH": "메쉬플로우 애퀴지션",
  "MESO": "메조블라스트 ADR",
  "MET": "메트라이프",
  "MET-P-A": "메트라이프",
  "MET-P-E": "메트라이프",
  "MET-P-F": "메트라이프",
  "META": "메타",
  "METC": "라마코 리소시스 Class A",
  "METCB": "라마코 리소시스 Class B",
  "MEVO": "M 에보 글로벌 애퀴지션 II",
  "MF": "마인드포지",
  "MFA": "MFA 파이낸셜",
  "MFA-P-B": "MFA 파이낸셜",
  "MFA-P-C": "MFA 파이낸셜",
  "MFC": "매뉴라이프 파이낸셜",
  "MFG": "미즈호 파이낸셜그룹 ADR",
  "MFI": "엠에프 인터내셔널",
  "MFIC": "미드캡 파이낸셜 인베스트먼트",
  "MFIN": "메달리언 파이낸셜",
  "MFM": "Aberdeen Municipal",
  "MFP": "미데라 푸드 프로세싱",
  "MG": "미스트라스 그룹",
  "MGA": "마그나 인터내셔널",
  "MGEE": "MGE 에너지",
  "MGF": "Aberdeen Government Markets",
  "MGIH": "밀레니엄 그룹 인터내셔널 홀딩스",
  "MGLD": "메리골드 컴퍼니스",
  "MGM": "MGM 리조트 인터내셔널",
  "MGN": "메간 홀딩스",
  "MGNI": "매그나이트",
  "MGNX": "매크로제닉스",
  "MGPI": "MGP 인그리디언츠",
  "MGRC": "맥그래스 렌트코프",
  "MGRT": "메가 포춘",
  "MGRX": "망고슈티컬스",
  "MGTX": "메이라 지티 엑스 홀딩스",
  "MGX": "메타지노미 테라퓨틱스",
  "MGY": "매그놀리아 오일 & 가스",
  "MGYR": "마자르 뱅코프",
  "MH": "맥그로 힐",
  "MHD": "Blackrock Muniholdings Fund",
  "MHF": "Western Asset Municipal High Income Fund",
  "MHH": "메스테크 홀딩스",
  "MHK": "모호크 인더스트리스",
  "MHO": "M/I 홈스",
  "MI": "Nft",
  "MIAX": "마이애미 인터내셔널 홀딩스",
  "MICC": "매그넘 아이스크림 컴퍼니",
  "MIDD": "미들비",
  "MIMI": "민트",
  "MIN": "Aberdeen Intermediate",
  "MIND": "마인드 테크놀로지",
  "MINE": "메이페어 골드",
  "MIR": "미리온 테크놀로지스",
  "MIRA": "미라 파마슈티컬스",
  "MIRM": "미럼 파마슈티컬스",
  "MIST": "마일스톤 파머수티컬스",
  "MITK": "마이텍 시스템즈",
  "MITQ": "무빙 이미지 테크놀로지스",
  "MITT": "TPG 모기지 인베스트먼트",
  "MITT-P-A": "TPG 모기지 인베스트먼트",
  "MITT-P-B": "TPG 모기지 인베스트먼트",
  "MITT-P-C": "TPG 모기지 인베스트먼트",
  "MIY": "Blackrock Muniyield Michigan Quality Fund",
  "MKC": "맥코믹 앤 컴퍼니 무의결권주",
  "MKC-V": "McCormickCompany",
  "MKDW": "MKD웰 테크",
  "MKL": "마켈",
  "MKLY": "맥킨리 애퀴지션",
  "MKSI": "Mks",
  "MKTW": "마켓와이즈",
  "MKTX": "마켓액세스 홀딩스",
  "MKZR": "맥켄지 리얼티 캐피털",
  "MLAA": "마운틴 레이크 애퀴지션 II",
  "MLAB": "메사 래보라토리스",
  "MLCI": "마운트 로건 캐피털",
  "MLCO": "멜코 리조트 & 엔터테인먼트 ADR",
  "MLEC": "물렉 사이언스",
  "MLGO": "마이크로알고",
  "MLI": "뮬러 인더스트리스",
  "MLKN": "밀러놀",
  "MLM": "마틴 마리에타 머터리얼스",
  "MLP": "마우이 랜드 & 파인애플",
  "MLR": "밀러 인더스트리스",
  "MLSS": "마일스톤 사이언티픽",
  "MLTX": "MoonLake Immunotherapeutics Class A",
  "MLYS": "미네랄리스 테라퓨틱스",
  "MMA": "Mixed Martial Arts Group",
  "MMD": "NYLI MacKay DefinedTerm Muni Opportunities Fund",
  "MMED": "미니메드 그룹",
  "MMI": "Marcusmillichap",
  "MMLP": "Martin Midstream Partners Units",
  "MMM": "쓰리엠 (3M)",
  "MMS": "막시무스",
  "MMSI": "메리트 메디컬 시스템즈",
  "MMT": "Aberdeen Multi-Market",
  "MMTX": "밀루나 애퀴지션",
  "MMU": "Western Asset Managed Municipals Fund",
  "MMYT": "메이크마이트립",
  "MNDO": "Mind CTI",
  "MNDR": "Mobile-health Network Solutions Class A",
  "MNDY": "monday.com",
  "MNKD": "맨카인드",
  "MNOV": "메디치노바",
  "MNPR": "모노파 테라퓨틱스",
  "MNR": "Mach Natural Resources LP Common Units representing",
  "MNRO": "먼로",
  "MNSB": "메인스트리트 뱅크셰어스",
  "MNSBP": "메인스트리트 뱅크셰어스 우선주 시리즈 A 7.50%",
  "MNSO": "미니소 그룹 홀딩 ADR",
  "MNST": "몬스터 베버리지",
  "MNTK": "몬탁 리뉴어블스",
  "MNTN": "Mntn",
  "MNTS": "모멘터스",
  "MNY": "머니히로",
  "MO": "알트리아그룹",
  "MOB": "Mobilicom Ltd",
  "MOBI": "모비아 메디컬",
  "MOBX": "모빅스 랩스",
  "MOD": "Modine Manufacturing",
  "MODD": "모듈러 메디컬",
  "MOG-A": "Moog Inc.",
  "MOG-B": "MOOG INC CL B",
  "MOGU": "Mogu",
  "MOH": "몰리나 헬스케어",
  "MOLN": "몰레큘러 파트너스 ADR",
  "MOMO": "헬로 그룹 ADR",
  "MORN": "모닝스타",
  "MOS": "The Mosaic Company",
  "MOV": "모바도 그룹",
  "MOVE": "Corvex",
  "MP": "엠피 머터리얼즈",
  "MPA": "Blackrock Muniyield Pennsylvania Quality Fund",
  "MPAA": "모터카 파츠 오브 아메리카",
  "MPB": "미드 펜 뱅코프",
  "MPC": "매러선 페트롤리엄",
  "MPLT": "맵라이트 테라퓨틱스",
  "MPLX": "Mplx Lp",
  "MPT": "메디컬 프로퍼티즈 트러스트",
  "MPTI": "M-트론 인더스트리스",
  "MPU": "메가 매트릭스",
  "MPV": "Barings Participation Investors",
  "MPWR": "Monolithic Power Systems",
  "MQ": "마케타",
  "MQY": "Blackrock Muni Yield Quality Fund",
  "MRAM": "에버스핀 테크놀러지",
  "MRBK": "메리디안",
  "MRCY": "머큐리 시스템즈",
  "MRDN": "Meridian Holdings",
  "MREO": "Mereo BioPharma Group",
  "MRK": "머크 앤 코",
  "MRKR": "마커 테라퓨틱스",
  "MRLN": "Merlin",
  "MRM": "메디롬 헬스케어 테크놀로지스 ADR",
  "MRNA": "모더나",
  "MRNO": "무라노 글로벌 인베스트먼츠",
  "MRP": "밀로즈 프로퍼티스",
  "MRSH": "Marsh",
  "MRT": "Marti Technologies",
  "MRTN": "마텐 트랜스포트",
  "MRVI": "마라바이 라이프사이언시스 홀딩스",
  "MRVL": "마벨 테크놀로지 그룹",
  "MRX": "마렉스 UK 홀딩스",
  "MS": "모간스탠리",
  "MS-P-A": "Morgan Stanley Floating Rate non-cumulative Preferred Series A",
  "MS-P-E": "Morgan Stanley Dep",
  "MS-P-F": "Morgan Stanley Series F",
  "MS-P-I": "MORGAN STANLEY Series I Preferred Stock",
  "MS-P-K": "Morgan Stanley Series K Preferred Stock",
  "MS-P-L": "Morgan Stanley Series L Preferred Stock",
  "MS-P-O": "Morgan Stanley Series O Preferred Stock",
  "MS-P-P": "Morgan Stanley Series P Preferred Stock",
  "MS-P-Q": "Morgan Stanley Series Q Preferred Stock",
  "MSA": "Mine Safety",
  "MSAI": "멀티센서 AI 홀딩스",
  "MSB": "메사비 트러스트",
  "MSBI": "미드랜드 스테이츠 뱅코프",
  "MSBIP": "미드랜드 스테이츠 뱅코프 우선주 시리즈 A",
  "MSC": "스튜디오 시티 인터내셔널 홀딩스 ADR",
  "MSCI": "Msci",
  "MSD": "Morgan Stanley Emerging Markets Debt Closed Fund",
  "MSDL": "모간스탠리 다이렉트 렌딩 펀드",
  "MSEX": "Middlesex Water",
  "MSFT": "마이크로소프트",
  "MSGE": "매디슨 스퀘어 가든 엔터테인먼트",
  "MSGM": "모터스포츠 게임즈",
  "MSGS": "매디슨 스퀘어 가든 스포츠",
  "MSGY": "메이슨글로리",
  "MSI": "모토로라 솔루션스",
  "MSIF": "Msc",
  "MSLE": "사텔로스 바이오사이언스",
  "MSM": "MSC 인더스트리얼 다이렉트",
  "MSN": "에머슨 라디오",
  "MSS": "메종 솔루션스",
  "MSTR": "스트래티지",
  "MT": "아르셀로미탈 ADR",
  "MTA": "메탈라 로열티 & 스트리밍",
  "MTAL": "메탈스 애퀴지션 II",
  "MTB": "M&T 뱅크",
  "MTB-P-H": "M&T 뱅크",
  "MTB-P-J": "M&T 뱅크",
  "MTB-P-K": "M&T 뱅크",
  "MTB-P-L": "M&T 뱅크",
  "MTC": "MMTec",
  "MTCH": "매치 그룹",
  "MTD": "메틀러 톨레도 인터내셔널",
  "MTDR": "마타도 리소시스",
  "MTEK": "마리스 테크",
  "MTEN": "명등 인터내셔널",
  "MTEX": "매나테크",
  "MTG": "MGIC 인베스트먼트",
  "MTH": "메리티지 홈즈",
  "MTLS": "머티리얼라이즈 ADR",
  "MTN": "베일 리조트",
  "MTNB": "마티나스 바이오팜 홀딩스",
  "MTNE": "CH4 내추럴 솔루션스",
  "MTR": "메사 로열티 트러스트",
  "MTRN": "마테리언",
  "MTRX": "매트릭스 서비스",
  "MTSI": "M/A-컴 테크놀로지 솔루션스 홀딩스",
  "MTUS": "메탈루스",
  "MTVA": "메타비아",
  "MTW": "매니토웍 컴퍼니",
  "MTX": "미네랄스 테크놀로지스",
  "MTZ": "마스텍",
  "MU": "마이크론 테크놀로지",
  "MUA": "Blackrock Muni Assets Fund",
  "MUC": "Blackrock Muniholdings California Quality Fund",
  "MUFG": "미쓰비시 UFJ 파이낸셜 그룹 ADR",
  "MUJ": "Blackrock Muniholdings New Jersey Quality Fund",
  "MUR": "머피 오일",
  "MUSA": "머피 USA",
  "MUX": "맥이웬",
  "MUZE": "뮤제로 애퀴지션",
  "MVBF": "MVB 파이낸셜",
  "MVIS": "마이크로비전",
  "MVST": "마이크로배스트 홀딩스",
  "MWA": "뮬러 워터 프로덕츠",
  "MWC": "마이크웨어 ADR",
  "MWG": "멀티 웨이스 홀딩스",
  "MWH": "솔브 에너지",
  "MWYN": "말윈 홀딩스",
  "MX": "매그나칩 세미컨덕터",
  "MXC": "멕스코 에너지",
  "MXCT": "맥스사이트",
  "MXE": "The Mexico Equity and",
  "MXF": "Mexico Fund",
  "MXL": "맥스리니어",
  "MYE": "마이어스 인더스트리스",
  "MYFW": "퍼스트 웨스턴 파이낸셜",
  "MYGN": "미리아드 제네틱스",
  "MYI": "Blackrock Muniyield Quality Fund Iii",
  "MYN": "Blackrock Muniyield New York Quality Fund",
  "MYND": "마인드.ai ADR",
  "MYO": "마이모",
  "MYPS": "플레이스튜디오스",
  "MYRG": "MYR 그룹",
  "MYSE": "마이지엄 AI",
  "MYSZ": "마이 사이즈",
  "MYX": "메이우드 애퀴지션 2",
  "MZTI": "마르제티",
  "MZYX": "모자익스 애퀴지션",
  "NA": "나노 랩스",
  "NAAS": "나스 테크놀로지 ADR",
  "NABL": "엔-에이블",
  "NAC": "Nuveen California Quality Municipal Income Fund",
  "NAD": "Nuveen Quality Municipal Income Fund",
  "NAGE": "나이아젠 바이오사이언스",
  "NAII": "내추럴 얼터너티브 인터내셔널",
  "NAK": "노던 다이너스티 미네랄스",
  "NAKA": "나카모토",
  "NAMI": "진신 테크놀로지 홀딩 ADR",
  "NAMM": "나밉 미네랄스",
  "NAMS": "뉴암스테르담 파마 컴퍼니",
  "NAN": "Nuveen New York Quality Municipal Income Fund",
  "NAT": "노르딕 아메리칸 탱커",
  "NATH": "네이선스 페이머스",
  "NATL": "NCR 아틀레오스",
  "NATR": "네이처스 선샤인 프로덕츠",
  "NAUT": "노틸러스 바이오테크놀러지",
  "NAVI": "나비엔트",
  "NAVN": "나반",
  "NAZ": "Nuveen Arizona Quality Municipal Income Fund",
  "NB": "니오코프 디벨롭먼츠",
  "NBB": "Nuveen Taxable Municipal Income Fund",
  "NBBK": "NB 뱅코프",
  "NBH": "Neuberger Municipal Fund",
  "NBHC": "내셔널 뱅크 홀딩스",
  "NBIS": "네비우스 그룹",
  "NBIX": "뉴로크린 바이오사이언시스",
  "NBN": "노스이스트 뱅크",
  "NBP": "노바브리지 바이오사이언스",
  "NBR": "네이보스 인더스트리스",
  "NBRG": "뉴브리지 애퀴지션",
  "NBTB": "NBT 뱅코프",
  "NBTX": "나노바이오틱스 ADR",
  "NBXG": "Neuberger Next Generation Connectivity Fund",
  "NC": "나코 인더스트리스",
  "NCA": "Nuveen California Municipal Value Fund",
  "NCDL": "누빈 처칠 다이렉트 렌딩",
  "NCEL": "뉴셀X",
  "NCEW": "뉴 센추리 로지스틱스",
  "NCI": "네오-콘셉트 인터내셔널 그룹 홀딩스",
  "NCL": "노던",
  "NCLH": "노르웨이지안 크루즈 라인 홀딩스",
  "NCMI": "내셔널 시네미디어",
  "NCNA": "누카나 ADR",
  "NCNO": "엔씨노",
  "NCO": "Southern Cross Acquisition I Corp",
  "NCPL": "넷캐피탈",
  "NCRA": "노세라",
  "NCSM": "NCS 멀티스테이지 홀딩스",
  "NCT": "인터콘트",
  "NCTY": "더나인 ADR",
  "NCV": "Virtus Convertible And Income Fund",
  "NCV-P-A": "Virtus Convertible And Income Fund",
  "NCZ": "Virtus Convertible and Income Fund II",
  "NCZ-P-A": "Virtus Convertible and Income Fund II",
  "NDAQ": "나스닥",
  "NDLS": "누들스",
  "NDMO": "Nuveen Dynamic Municipal Opportunities Fund",
  "NDRA": "엔드라 라이프 사이언스",
  "NDSN": "노드슨",
  "NE": "노블",
  "NEA": "Nuveen AMT-Free Quality Municipal Income Fund",
  "NECB": "노스이스트 커뮤니티 뱅코프",
  "NEE": "넥스트에라 에너지",
  "NEGG": "뉴에그 커머스",
  "NEM": "뉴몬트",
  "NEN": "뉴 잉글랜드 리얼티 어소시에이트 DRC",
  "NEO": "네오지노믹스",
  "NEOG": "니오젠",
  "NEON": "네오노드",
  "NEOV": "네오볼타",
  "NEPH": "네프로스",
  "NERV": "미네르바 뉴로사이언시스",
  "NESR": "내셔널 에너지 서비스 리유나이티드",
  "NET": "클라우드플레어",
  "NEU": "뉴마켓",
  "NEUP": "뉴포리아 테라퓨틱스",
  "NEWP": "뉴 퍼시픽 메탈스",
  "NEWT": "뉴텍 비즈니스 서비스",
  "NEWTP": "뉴테크원 우선주 Series B",
  "NEXA": "넥사 리소스",
  "NEXM": "넥스메탈스 마이닝",
  "NEXN": "넥슨 인터내셔널",
  "NEXR": "넥세라 테크놀로지스",
  "NEXT": "넥스트데케이드",
  "NFE": "뉴 포트리스 에너지",
  "NFG": "내셔널 퓨얼 가스",
  "NFGC": "뉴 파운드 골드",
  "NFJ": "Virtus Dividend  Interest & Prem Str Fd",
  "NFLX": "넷플릭스",
  "NG": "노바골드 리소시스",
  "NGEN": "너브젠 파마",
  "NGG": "내셔널 그리드 ADR",
  "NGL": "Ngl Energy Partners Lp",
  "NGNE": "뉴로진",
  "NGS": "내추럴 가스 서비스 그룹",
  "NGVC": "내추럴 그로서즈 바이 바이타민 코티지",
  "NGVT": "인제비티",
  "NHC": "내셔널 헬스케어",
  "NHI": "내셔널 헬스 인베스터스",
  "NHIC": "뉴홀드 인베스트먼트 III",
  "NHIV": "뉴홀드 인베스트먼트 IV",
  "NHP": "내셔널 헬스케어 프로퍼티스",
  "NHPAP": "내셔널 헬스케어 우선주 Series A 7.375%",
  "NHPBP": "내셔널 헬스케어 우선주 Series B 7.125%",
  "NHS": "Neuberger High Yield Strategies Fund",
  "NHTC": "내추럴 헬스 트렌즈",
  "NI": "나이소스",
  "NIC": "니콜렛 뱅크셰어스",
  "NICE": "나이스 ADR",
  "NICM": "니콜라 마이닝 ADR",
  "NIE": "Virtus Equity And Convertible Income Fund",
  "NIKI": "앱토럼 그룹",
  "NIM": "Nuveen Select Maturities Municipal Fund",
  "NINE": "나인 에너지 서비스",
  "NIO": "니오 ADR",
  "NIPG": "NIP 그룹 ADR",
  "NIQ": "NIQ 글로벌 인텔리전스",
  "NIU": "NIU 테크놀러지 ADR",
  "NIVF": "뉴젠Ivf 그룹",
  "NIXX": "닉시",
  "NJR": "뉴저지 리소시스",
  "NKE": "나이키",
  "NKLR": "테라 이노바툼 글로벌",
  "NKSH": "내셔널 뱅크셰어즈",
  "NKTR": "넥타 테라퓨틱스",
  "NKTX": "엔카르타",
  "NKX": "Nuveen California AMT-Free Quality Municipal In Fd",
  "NL": "NLI 홀딩스",
  "NLOP": "넷 리즈 오피스 프로퍼티스",
  "NLY": "애널리 캐피털 매니지먼트",
  "NLY-P-F": "애널리 캐피털 매니지먼트",
  "NLY-P-G": "애널리 캐피털 매니지먼트",
  "NLY-P-I": "애널리 캐피털 매니지먼트",
  "NLY-P-J": "애널리 캐피털 매니지먼트",
  "NMAD": "노마드 파워 솔루션스",
  "NMAI": "Nuveen Multi-Asset Income Fund",
  "NMAX": "뉴스맥스",
  "NMCO": "Nuveen Municipal Credit Opportunities Fund",
  "NMFC": "뉴 마운틴 파이낸스",
  "NMG": "누보 몽드 그래파이트",
  "NMI": "Nuveen Municipal Income Fund Inc",
  "NMIH": "NMI 홀딩스",
  "NML": "Neuberger Energy Infrastructure and",
  "NMM": "Navios Maritime Partners Units",
  "NMP": "NMP 애퀴지션",
  "NMR": "노무라 홀딩스 ADR",
  "NMRA": "뉴모라 테라퓨틱스",
  "NMRK": "뉴마크 그룹",
  "NMS": "Nuveen Minnesota Quality Municipal Income Fund",
  "NMT": "Nuveen Massachusetts Quality Municipal Income Fund",
  "NMTC": "뉴로원 메디컬 테크놀로지스",
  "NMZ": "Nuveen Municipal High Income Opportunity Closed Fund",
  "NN": "NN",
  "NNBR": "Nn",
  "NNDM": "나노 디멘션 ADR",
  "NNE": "나노 뉴클리어 에너지",
  "NNI": "넬넷",
  "NNN": "내셔널 리테일 프로퍼티즈",
  "NNNN": "안비오 바이오테크놀로지",
  "NNOX": "나노-엑스이미징",
  "NNVC": "나노바이리사이드스",
  "NNY": "Nuveen New York Municipal Value Fund",
  "NOA": "노스 아메리칸 컨스트럭션 그룹",
  "NOAH": "노아 홀딩스 ADR",
  "NOC": "노스롭 그루만",
  "NODK": "NI 홀딩스",
  "NOEM": "CO2 에너지 트랜지션",
  "NOG": "노던 오일 & 가스",
  "NOK": "노키아 ADR",
  "NOMA": "노마다르",
  "NOMD": "노마드 푸드",
  "NOV": "노브",
  "NOVT": "노밴타",
  "NOW": "서비스나우",
  "NP": "넵튠 인슈어런스 홀딩스",
  "NPAC": "뉴 프로비던스 애퀴지션 III",
  "NPB": "노스포인트 뱅크셰어스",
  "NPCE": "뉴로페이스",
  "NPCT": "Nuveen Core Plus Impact Fund",
  "NPFD": "Nuveen Variable Rate Preferred Income Closed End Fund",
  "NPK": "내셔널 프레스토 인더스트리스",
  "NPKI": "NPK 인터내셔널",
  "NPO": "엔프로",
  "NPT": "텍손 홀딩",
  "NPV": "Nuveen Virginia Quality Municipal Income Fund",
  "NPWR": "넷 파워",
  "NRC": "NRC 헬스",
  "NRDS": "너드월렛",
  "NRDY": "너디",
  "NREF": "넥스포인트 리얼 에스테이트 파이낸스",
  "NREF-P-A": "넥스포인트 리얼 에스테이트 파이낸스",
  "NRG": "NRG 에너지",
  "NRGV": "에너지 볼트 홀딩스",
  "NRIM": "노스림 뱅코프",
  "NRIX": "누릭스 테라퓨틱스",
  "NRK": "Nuveen New York AMT-Free Quality Municipal Inc Fd",
  "NRO": "Neuberger Real Estate Securities",
  "NRP": "Natural Resource Partners L.P.",
  "NRSN": "뉴로센스 테라퓨틱스",
  "NRT": "North European Oil Royalty Units",
  "NRXP": "NRX 파마슈티컬스",
  "NRXS": "뉴락시스",
  "NSC": "노퍽서던",
  "NSIT": "인사이트 엔터프라이지즈",
  "NSLR": "네오스텔라 캐피털",
  "NSP": "인스페리티",
  "NSPR": "인스파이어MD",
  "NSRX": "나서스 파마",
  "NSSC": "냅코 시큐리티 테크놀로지스",
  "NSTS": "NSTS 뱅코프",
  "NSYS": "노테크 시스템즈",
  "NTAP": "넷앱",
  "NTB": "뱅크 오브 NT 버터필드 & 선",
  "NTCL": "넷클래스 테크놀로지",
  "NTCT": "네트스카우트 시스템즈",
  "NTES": "넷이즈 ADR",
  "NTGR": "넷기어",
  "NTHI": "니온 테크놀로지스 홀딩스",
  "NTIC": "노던 테크놀로지스 인터내셔널",
  "NTIP": "네트워크-1 테크놀로지스",
  "NTLA": "인텔리아 테라퓨틱스",
  "NTNX": "뉴타닉스",
  "NTR": "뉴트리엔",
  "NTRA": "나테라",
  "NTRB": "뉴트리밴드",
  "NTRP": "넥스트트립",
  "NTRS": "노던 트러스트",
  "NTRSO": "노던 트러스트 우선주 시리즈 E 4.7%",
  "NTSK": "넷스코프",
  "NTST": "넷에스티리츠",
  "NTWK": "넷솔 테크놀로지스",
  "NTWO": "뉴버리 스트리트 II 애퀴지션",
  "NTZ": "나뚜찌 SpA ADR",
  "NU": "누 홀딩스",
  "NUAI": "뉴 에라 에너지 & 디지털",
  "NUCL": "이글 뉴클리어 에너지",
  "NUE": "뉴코",
  "NUS": "뉴스킨 엔터프라이즈",
  "NUTR": "누사트립",
  "NUTX": "뉴텍스 헬스",
  "NUV": "Nuveen Municipal Value Fund Inc",
  "NUVB": "누베이션 바이오",
  "NUW": "Nuveen AMT-Free Municipal Value Fund",
  "NUWE": "뉴웰리스",
  "NVA": "Nova Minerals Corp",
  "NVAX": "노바백스",
  "NVCR": "노보큐어",
  "NVCT": "누벡티스 파마",
  "NVDA": "엔비디아",
  "NVEC": "Nve",
  "NVG": "Nuveen AMT-Free Municipal Credit Income Fund",
  "NVGS": "내비게이터 홀딩스",
  "NVMI": "노바 메저링 인스트루먼츠",
  "NVNI": "엔비니 그룹",
  "NVNO": "엔베노 메디컬",
  "NVO": "노보 노디스크 ADR",
  "NVR": "Nvr",
  "NVRI": "엔비리",
  "NVS": "노바티스 ADR",
  "NVST": "엔비스타 홀딩스",
  "NVT": "엔벤트 일렉트릭",
  "NVTS": "나비타스 세미컨덕터",
  "NVX": "노보닉스 ADR",
  "NWAX": "뉴아메리카 애퀴지션",
  "NWBI": "노스웨스트 뱅크셰어스",
  "NWE": "노스웨스턴 에너지 그룹",
  "NWFL": "노우드 파이낸셜",
  "NWG": "내트웨스트 그룹 ADR",
  "NWGL": "CL 워크샵 그룹 ADR",
  "NWL": "뉴웰브랜즈",
  "NWN": "노스웨스트 내추럴 홀딩",
  "NWPX": "NWPX 인프라스트럭처",
  "NWS": "뉴스 코퍼레이션 Class B",
  "NWSA": "뉴스 코퍼레이션 Class A",
  "NWTG": "뉴턴 골프",
  "NX": "콰넥스 빌딩 프로덕츠",
  "NXB": "넥스트보트",
  "NXDR": "넥스트도어 홀딩스",
  "NXDT": "넥스포인트 다이버시파이드 리얼 에스테이트 트러스트",
  "NXDT-P-A": "넥스포인트 다이버시파이드 리얼 에스테이트 트러스트",
  "NXE": "넥스젠 에너지",
  "NXG": "NXG NextGen Infrastructure Income Fund",
  "NXGL": "넥스젤",
  "NXL": "넥살린 테크놀로지",
  "NXP": "Nuveen Select Tax-Free Income Portfolio",
  "NXPI": "NXP 세미콘덕터",
  "NXPL": "넥스트플랫",
  "NXRT": "넥스포인트 레지덴셜 트러스트",
  "NXST": "넥스타 미디어 그룹",
  "NXT": "넥스트파워",
  "NXTC": "넥스큐어",
  "NXTS": "넥센티스 테크놀로지스",
  "NXTT": "넥스트 테크놀로지 홀딩",
  "NXXT": "넥스트NRG",
  "NYAX": "나약스",
  "NYC": "뉴욕 시티 리츠",
  "NYT": "뉴욕타임스",
  "NYXH": "닉소아",
  "NZF": "Nuveen Municipal Credit Income Fund",
  "O": "리얼티 인컴",
  "OABI": "옴니AB",
  "OACC": "오크트리 애퀴지션 III 라이프 사이언스",
  "OBA": "옥슬리 브릿지 애퀴지션",
  "OBAI": "아우어 본드",
  "OBDC": "블루 아울 캐피털",
  "OBE": "옵시디안 에너지",
  "OBIO": "오케스트라 바이오메드 홀딩스",
  "OBK": "오리진 뱅코프",
  "OBT": "오렌지 카운티 뱅코프",
  "OBX": "갈레라 테라퓨틱스",
  "OC": "오웬스 코닝",
  "OCAC": "오션 캐피탈 애퀴지션",
  "OCC": "옵티컬 케이블",
  "OCCI": "OFS 크레디트 컴퍼니",
  "OCCIM": "OFS 크레디트 우선주 Series F 7.875%",
  "OCCIN": "OFS 크레디트 우선주 Series E 5.25%",
  "OCFC": "오션퍼스트 파이낸셜",
  "OCG": "오리엔탈 컬처 홀딩",
  "OCGN": "오큐젠",
  "OCS": "오쿨리스 홀딩",
  "OCSL": "오크트리 스페셜티 렌딩",
  "OCTV": "옥타브 인텔리전스",
  "OCUL": "오큘라 테라퓨틱스",
  "ODC": "오일-드리 코퍼레이션 오브 아메리카",
  "ODD": "오디티 테크",
  "ODFL": "올드 도미니언 프라이트 라인",
  "ODTX": "오디세이 테라퓨틱스",
  "ODYS": "오디사이트.AI",
  "OEC": "오리온",
  "OESX": "오리온 에너지 시스템즈",
  "OFAL": "OFA 그룹",
  "OFG": "OFG 뱅코프",
  "OFIX": "오소픽스 메디컬",
  "OFLX": "오메가 플렉스",
  "OFRM": "원스 어폰 어 팜",
  "OFS": "OFS 캐피털",
  "OGC": "오셔나골드",
  "OGCP": "Empire State Realty OP, L.P. Series 60",
  "OGE": "OGE 에너지",
  "OGEN": "오라제닉스",
  "OGG": "오시스코 골드 그룹",
  "OGI": "오가니그램 글로벌",
  "OGN": "오가논 & 코",
  "OGS": "원 가스",
  "OHAC": "오션호크 애퀴지션",
  "OHI": "오메가 헬스케어 인베스터스",
  "OI": "O-i 글래스",
  "OIA": "Invesco Muni Income Opportunities Trust",
  "OII": "오셔니어링 인터내셔널",
  "OIM": "원IM 애퀴지션",
  "OIO": "OIO 그룹",
  "OIS": "오일 스테이츠 인터내셔널",
  "OKE": "원오케이",
  "OKLO": "오클로",
  "OKTA": "옥타",
  "OKUR": "온큐어 테라퓨틱스",
  "OKYO": "OKYO Pharma Ltd",
  "OLB": "오엘비 그룹",
  "OLED": "유니버설 디스플레이",
  "OLLI": "올리스 바겐 아웃렛 홀딩스",
  "OLMA": "올레마 파마슈티컬",
  "OLN": "올린",
  "OLOX": "오레녹스 인더스트리스",
  "OLP": "원 리버티 프로퍼티즈",
  "OM": "아웃셋 메디컬",
  "OMAB": "그루포 에어로포르투아리오 센트로노테 ADR",
  "OMC": "옴니콤 그룹",
  "OMCL": "옴니셀",
  "OMDA": "오마다 헬스",
  "OMER": "오메로스",
  "OMEX": "오디세이 마린 익스플로레이션",
  "OMF": "원메인 홀딩스",
  "OMH": "오마이홈",
  "OMSE": "OMS 에너지 테크놀로지스",
  "ON": "온 세미콘덕터",
  "ONB": "올드 내셔널 뱅코프",
  "ONBPO": "올드 내셔널 뱅코프 40 우선주 시리즈 C",
  "ONBPP": "올드 내셔널 뱅코프 40 우선주 시리즈 A",
  "ONC": "비원 메디슨스 ADR",
  "ONCH": "1RT 애퀴지션",
  "ONCO": "온코네틱스",
  "ONCY": "온콜리틱스 바이오텍",
  "ONDS": "온다스",
  "ONEG": "원컨스트럭션 그룹",
  "ONEW": "원워터 마린",
  "ONFO": "온폴리오 홀딩스",
  "ONIT": "오니티 그룹",
  "ONL": "오리온 프로퍼티스",
  "ONMD": "원메드넷",
  "ONON": "온 홀딩",
  "ONT": "온테리스",
  "ONTO": "온투 이노베이션",
  "OOMA": "우마",
  "OPAD": "오퍼패드 솔루션스",
  "OPAL": "오팔 퓨얼",
  "OPBK": "OP 뱅코프",
  "OPCH": "옵션 케어 헬스",
  "OPEN": "오픈도어 테크놀로지스",
  "OPFI": "옵파이",
  "OPHC": "옵티멈뱅크 홀딩스",
  "OPI": "오피스 프로퍼티스 인컴 트러스트",
  "OPK": "옵코 헬스",
  "OPLN": "오픈레인",
  "OPP": "RiverNorth/DoubleLine Strategic Opportunity Fund",
  "OPP-P-A": "RiverNorth/DoubleLine Strategic Opportunity Fund",
  "OPP-P-B": "RiverNorth/DoubleLine Strategic Opportunity Fund",
  "OPP-P-C": "RiverNorth/DoubleLine Strategic Opportunity Fund",
  "OPRA": "오페라 ADR",
  "OPRT": "오포툰 파이낸셜",
  "OPRX": "옵티마이즈알엑스",
  "OPTH": "옵티미 헬스",
  "OPTT": "오션 파워 테크놀로지스",
  "OPTU": "옵티멈 커뮤니케이션스",
  "OPTX": "신텍 옵틱스 홀딩스",
  "OPXS": "옵텍스 시스템스 홀딩스",
  "OPY": "오펜하이머 홀딩스",
  "OR": "OR 로열티스",
  "ORA": "오마트 테크놀로지스",
  "ORBS": "에이토 홀딩스",
  "ORC": "오키드 아일랜드 캐피털",
  "ORCL": "오라클",
  "ORCL-P-D": "오라클",
  "ORGO": "오가노제네시스홀딩스",
  "ORI": "올드 리퍼블릭 인터내셔널",
  "ORIC": "오릭 파마슈티컬스",
  "ORIO": "오리온 디지털",
  "ORIQ": "오리진 인베스트먼트 I",
  "ORKA": "오루카 테라퓨틱스",
  "ORKT": "오렌지클라우드 테크놀로지",
  "ORLY": "오레일리 오토모티브",
  "ORMP": "오라메드 파마슈티컬스",
  "ORN": "오라이언 그룹 홀딩스",
  "ORRF": "오스타운 파이낸셜 서비스",
  "OSBC": "올드 세컨드 뱅코프",
  "OSCR": "오스카 헬스",
  "OSG": "옥타브 스페셜티 그룹",
  "OSIS": "OSI 시스템즈",
  "OSK": "오시코시",
  "OSPN": "원스팬",
  "OSRH": "OSR 헬스",
  "OSS": "OSS(원 스탑 시스템)",
  "OST": "오스틴 테크놀로지 그룹",
  "OSTX": "OS 테라퓨틱스",
  "OSUR": "오라슈어 테크놀로지스",
  "OSW": "원스파월드 홀딩스",
  "OTAI": "스타링크 AI 애퀴지션",
  "OTEX": "오픈 텍스트",
  "OTF": "블루 아울 테크놀로지 파이낸스",
  "OTGA": "OTG 애퀴지션 I",
  "OTIS": "오티스 월드와이드",
  "OTLK": "아웃룩 테라퓨틱스",
  "OTLY": "오틀리 그룹 AB ADR",
  "OTTR": "오터 테일",
  "OUST": "아우스터",
  "OUT": "아웃프론트 미디어",
  "OVBC": "오하이오 밸리 뱅크",
  "OVID": "오비드 테라퓨틱스",
  "OVLY": "오크 밸리 뱅코프",
  "OVV": "오빈티브",
  "OWL": "블루 아울 캐피털",
  "OWLS": "오북 홀딩스",
  "OWLT": "오울렛",
  "OXBR": "옥스브리지 리 홀딩스",
  "OXLC": "옥스포드 레인 캐피털",
  "OXLCM": "옥스퍼드 레인 우선주 8.25%",
  "OXLCN": "옥스포트 레인 캐피털 우선주 7.125%",
  "OXLCO": "옥스포드 레인 캐피털 우선주 7.50%",
  "OXM": "옥스포드 인더스트리스",
  "OXSQ": "옥스포드 스퀘어 캐피털",
  "OXY": "옥시덴털 페트롤리움",
  "OYSE": "오이스터 엔터프라이시스 II 애퀴지션",
  "OZK": "뱅크 오즈크",
  "OZKAP": "Bank OZK Series A Preferred Stock",
  "P": "에버퓨어",
  "PAA": "Plains All American Pipeline, L.P. Common Units representing",
  "PAAC": "프로엠 애퀴지션 I",
  "PAAS": "팬 아메리카 실버",
  "PAC": "Grupo Aeroportuario del Pacifico, S.A.B. de C.V.",
  "PACB": "퍼시픽 바이오사이언시스 오브 캘리포니아",
  "PACH": "파이어니어 애퀴지션 I",
  "PACK": "란팍 홀딩스",
  "PACS": "팩스 그룹",
  "PAG": "펜스케 오토모티브 그룹",
  "PAGP": "Plains GP Holdings, L.P. Class A Units representing",
  "PAGS": "파그세구로 디지털",
  "PAHC": "피브로 애니멀 헬스",
  "PAI": "Western Asset Investment Grade Income Closed End Fund Inc",
  "PAII": "파이로파이트 애퀴지션 II",
  "PAL": "프로피시언트 오토 로지스틱스",
  "PALI": "팔리사드 바이오",
  "PALO": "팔로마 애퀴지션 I",
  "PAM": "Pampa Energia S.A.",
  "PAMT": "Pamt",
  "PANL": "팡게아 로지스틱스 솔루션스",
  "PANW": "팔로 알토 네트웍스",
  "PAPL": "파인애플 파이낸셜",
  "PAR": "PAR Technology",
  "PARA": "Banzai International",
  "PARK": "파크 덴탈 파트너스",
  "PARR": "파 퍼시픽 홀딩스",
  "PASG": "패시지 바이오",
  "PASW": "핑안 바이오메디컬",
  "PATH": "유아이패스",
  "PATK": "패트릭 인더스트리스",
  "PAVM": "파브메드",
  "PAVS": "파라노부스 엔터테인먼트 테크놀로지",
  "PAX": "파트리아 인베스트먼트",
  "PAXS": "PIMCO Access Income Fund",
  "PAY": "페이먼트어스 홀딩스",
  "PAYC": "페이콤 소프트웨어",
  "PAYO": "페이오니아 글로벌",
  "PAYP": "페이페이 ADR",
  "PAYS": "Paysign",
  "PAYX": "페이첵스",
  "PB": "프로스페리티 뱅크셰어스",
  "PBA": "펨비나 파이프라인",
  "PBAM": "캘프라이빗 뱅크",
  "PBF": "Pbf Energy",
  "PBFS": "파이오니아 뱅코프",
  "PBH": "프레스티지 컨슈머 헬스케어",
  "PBHC": "패트파인더 뱅코프",
  "PBI": "피트니보우스",
  "PBK": "파워뱅크",
  "PBLS": "파라빌리스 메디슨스",
  "PBM": "사이언스 바이오메디컬",
  "PBR": "Petroleo Brasileiro S.A.-Petrobras Ads (Rep 1 Common Share)",
  "PBR-A": "Petroleo Brasileiro S.A.-Petrobras",
  "PBT": "Permian Basin Royalty Units",
  "PBYI": "퓨마 바이오테크놀러지",
  "PC": "프리미엄 케이터링 홀딩스",
  "PCAP": "ProCap Acquisition",
  "PCAR": "파카",
  "PCB": "PCB Bancorp",
  "PCF": "High Income Securities Fund",
  "PCG": "Pg&E",
  "PCG-P-A": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-B": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-C": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-D": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-E": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-G": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-H": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-I": "퍼시픽 가스 & 일렉트릭",
  "PCG-P-X": "Pg&E",
  "PCLA": "피코셀라 ADR",
  "PCM": "PCM Fund Inc",
  "PCN": "Pimco",
  "PCOR": "프로코어테크놀러지스",
  "PCQ": "Pimco California Municipal",
  "PCRX": "파시라 바이오사이언스",
  "PCSA": "프로세사 파마슈티컬스",
  "PCT": "퓨어사이클 테크놀러지",
  "PCTY": "페일로시티 홀딩",
  "PCVX": "백사이트",
  "PCYO": "퓨어 사이클",
  "PD": "PagerDuty",
  "PDC": "Perpetuals.com",
  "PDCC": "펄 다이버 크레디트",
  "PDD": "핀둬둬 ADR",
  "PDEX": "프로-덱스",
  "PDFS": "PDF 솔루션스",
  "PDI": "PIMCO Dynamic Income Fund",
  "PDLB": "폰스 파이낸셜 그룹",
  "PDM": "Piedmont Realty Trust",
  "PDO": "PIMCO Dynamic Income Opportunities Fund",
  "PDPA": "펄 다이버 크레딧 우선주 Series A 8.00%",
  "PDS": "프레시전 드릴링",
  "PDSB": "PDS 바이오테크놀러지",
  "PDT": "John Hancock Premium Dividend Fund",
  "PDX": "PIMCO Dynamic",
  "PDYN": "팔라다인 AI",
  "PEB": "페블브룩 호텔 트러스트",
  "PEB-P-E": "Pebblebrook Hotel Trust Series E Preferred",
  "PEB-P-F": "Pebblebrook Hotel Trust Series F Preferred",
  "PEB-P-G": "Pebblebrook Hotel Trust Series G Preferred",
  "PEB-P-H": "Pebblebrook Hotel Trust Series H Preferred",
  "PEBK": "Peoples Bancorp of North Carol",
  "PEBO": "피플스 뱅코프",
  "PECE": "피스 애퀴지션",
  "PECO": "필립스 에디슨 & 코",
  "PED": "Pedevco",
  "PEG": "퍼블릭 서비스 엔터프라이즈",
  "PEGA": "페가시스템즈",
  "PEN": "페넘브라",
  "PENG": "펭귄 솔루션스",
  "PENN": "펜 엔터테인먼트",
  "PEO": "Adams Natural Resources Fund，Inc.",
  "PEP": "펩시코",
  "PEPG": "펩젠",
  "PERF": "퍼펙트",
  "PERI": "페리언 네트워크",
  "PESI": "퍼마-픽스 인바이런먼털 서비스",
  "PETS": "PetMed Express",
  "PETZ": "TDH 홀딩스",
  "PEW": "그랩어건 디지털 홀딩스",
  "PFAI": "피너클 푸드 그룹",
  "PFBC": "프리퍼드 은행",
  "PFD": "FlahertyCrumrine Preferred and",
  "PFE": "화이자",
  "PFG": "프린시펄 파이낸셜 그룹",
  "PFGC": "퍼포먼스 푸드 그룹",
  "PFIS": "피플스 파이낸셜 서비스",
  "PFL": "Pimco",
  "PFLT": "페넌트파크 플로팅 레이트 캐피탈",
  "PFN": "Pimco",
  "PFO": "FlahertyCrumrine Preferred and",
  "PFS": "프로비던트 파이낸셜 서비스",
  "PFSA": "프로퓨사",
  "PFSI": "페니맥 파이낸셜 서비스",
  "PFX": "피닉스핀",
  "PG": "P&G(프록터 & 갬블)",
  "PGAC": "팬티지스 캐피털 애퀴지션",
  "PGC": "피팩 글래드스턴 파이낸셜",
  "PGEN": "프레시젠",
  "PGNY": "프로지니",
  "PGP": "PIMCO Global StockPLUS",
  "PGR": "프로그레시브",
  "PGY": "파가야 테크놀로지스",
  "PGZ": "Principal Real Estate Income Fund",
  "PH": "파커-하니핀",
  "PHAR": "파밍 그룹 ADR",
  "PHAT": "패썸 파마슈티컬스",
  "PHG": "코닝클레이커 필립스 ADR",
  "PHGE": "바이오MX",
  "PHI": "Pldt",
  "PHIN": "피니아",
  "PHIO": "피오 파마슈티컬스",
  "PHK": "PIMCO High Income Fund",
  "PHM": "풀티 그룹",
  "PHOE": "피닉스 아시아 홀딩스",
  "PHR": "프리시아",
  "PHUN": "펀웨어",
  "PHVS": "파바비스 NV",
  "PHXE-P": "피닉스 에너지 원 우선주 Series A 10%",
  "PI": "임핀지",
  "PICS": "픽스",
  "PII": "폴라리스",
  "PIII": "P3 헬스 파트너스",
  "PIM": "Franklin Master Intermediate",
  "PINE": "알파인 인컴 프로퍼티 트러스트",
  "PINE-P-A": "알파인 인컴 프로퍼티 트러스트",
  "PINS": "핀터레스트",
  "PIPR": "파이퍼 샌들러 컴퍼니스",
  "PJT": "PJT 파트너스",
  "PK": "파크 호텔 & 리조트",
  "PKBK": "파크 뱅코프",
  "PKE": "파크 에어로스페이스",
  "PKG": "패키징 코퍼레이션 오브 아메리카",
  "PKOH": "파크-오하이오 홀딩스",
  "PKX": "포스코 홀딩스 ADR",
  "PL": "플래닛 랩스 PBC",
  "PLAB": "포트로닉스",
  "PLAG": "플래닛 그린 홀딩스",
  "PLAY": "데이브 & 버스터스 엔터테인먼트",
  "PLBC": "플루마스 뱅코프",
  "PLBL": "폴리벨리 그룹",
  "PLBY": "플레이보이",
  "PLCE": "칠드런스 플레이스",
  "PLD": "프로로지스",
  "PLG": "플래티넘 그룹 메탈스",
  "PLGO": "펠라고스 인슈어런스 캐피탈",
  "PLMK": "플럼 애퀴지션 IV",
  "PLMR": "팔로마 홀딩스",
  "PLNT": "플래닛 피트니스",
  "PLOW": "더글라스 다이내믹스",
  "PLPC": "프리폼드 라인 프로덕츠",
  "PLRX": "플리언트 테라퓨틱스",
  "PLRZ": "폴리존",
  "PLSE": "펄스 바이오사이언스",
  "PLSM": "펄센모어",
  "PLTK": "플레이티카 홀딩",
  "PLTR": "팔란티어 테크놀로지스",
  "PLTS": "플래티넘 애널리틱스 케이맨",
  "PLUG": "플러그 파워",
  "PLUN": "플루토니안 애퀴지션 II",
  "PLUR": "플루리",
  "PLUS": "이플러스",
  "PLUT": "플루투스 파이낸션 그룹",
  "PLX": "프로탈릭스 바이오테라퓨틱스",
  "PLXS": "플렉서스",
  "PLYX": "폴라릭스 테라퓨틱스",
  "PM": "필립 모리스 인터내셔널",
  "PMA": "밍싱 그룹 홀딩스",
  "PMAX": "파웰 맥스",
  "PMCB": "파마사이트 바이오테크",
  "PMEC": "프라이메크 홀딩스",
  "PMI": "피카드 메디컬",
  "PML": "Pimco Municipal",
  "PMM": "Franklin Managed Municipal",
  "PMN": "프로미스 뉴로사이언시스",
  "PMO": "Franklin Municipal Opportunities Trust",
  "PMT": "페니맥 모기지 인베스트먼트",
  "PMT-P-A": "페니맥 모기지 인베스트먼트",
  "PMT-P-B": "페니맥 모기지 인베스트먼트",
  "PMT-P-C": "페니맥 모기지 인베스트먼트",
  "PMTR": "페리미터 애퀴지션 I",
  "PMTS": "CPI 카드 그룹",
  "PMVP": "PMV 파마슈티컬스",
  "PN": "PN 스마트 에너지",
  "PNBK": "패트리엇 내셔널 뱅코프",
  "PNC": "PNC 파이낸셜 서비스",
  "PNFP": "피너클 파이낸셜 파트너스",
  "PNFP-P-A": "피너클 파이낸셜 파트너스",
  "PNFP-P-B": "피너클 파이낸셜 파트너스",
  "PNFP-P-C": "피너클 파이낸셜 파트너스",
  "PNI": "Pimco New York Municipal",
  "PNNT": "페넌트파크 인베트스트먼트",
  "PNR": "펜테어",
  "PNRG": "프라임에너지 리소스",
  "PNTG": "페넌트 그룹",
  "PNW": "피너클 웨스트 캐피털",
  "POAS": "파오스 테크놀로지 홀딩스",
  "POCI": "프리시전 옵틱스",
  "PODC": "포드캐스톤",
  "PODD": "인슐릿",
  "POET": "포엣 테크놀로지",
  "POLA": "폴라 파워",
  "POLE": "안드레티 애퀴지션 II",
  "POM": "폼닥터 ADR",
  "PONO": "포노 캐피탈 포",
  "PONY": "포니 AI ADR",
  "POOL": "풀",
  "POR": "포틀랜드 제너럴 일렉트릭",
  "POST": "포스트 홀딩스",
  "POWI": "파워 인티그레이션",
  "POWL": "파월 인더스트리스",
  "POWW": "아웃도어 홀딩",
  "POWWP": "아웃도어 홀딩 우선주 시리즈 A 8.75%",
  "PPBT": "퍼플 바이오테크 ADR",
  "PPC": "필그림즈 프라이드",
  "PPCB": "프로팽 바이오파마",
  "PPG": "PPG 인더스트리스",
  "PPHC": "퍼블릭 폴리시 홀딩 컴퍼니",
  "PPIH": "퍼마-파이프 인터내셔널 홀딩스",
  "PPL": "Ppl",
  "PPLI": "피플 인코포레이티드",
  "PPSI": "파이어니어 파워 솔루션스",
  "PPT": "Franklin Premier",
  "PPTA": "퍼페투아 리소시스",
  "PR": "페르미안 리소시스",
  "PRAA": "PRA 그룹",
  "PRAX": "프락시스 프리시젼 메디신",
  "PRCH": "포치 그룹",
  "PRCT": "프로셉트 바이오로보틱스",
  "PRDO": "퍼도세오 에듀케이션",
  "PRE": "프레네틱스 글로벌",
  "PRFX": "PRF 테크놀로지스",
  "PRG": "PROG 홀딩스",
  "PRGO": "페리고",
  "PRGS": "프로그레스 소프트웨어",
  "PRHI": "프리슈어런스 홀딩스",
  "PRI": "프라이메리카",
  "PRIF-P-D": "프라이어리티 인컴 펀드 우선주 시리즈 J 6%",
  "PRIF-P-K": "프라이어리티 인컴 펀드 우선주 시리즈 J 6%",
  "PRIF-P-L": "프라이어리티 인컴 펀드 우선주 시리즈 J 6%",
  "PRIM": "프리모리스 서비시스",
  "PRK": "파크 내셔널",
  "PRKS": "유나이티드 파크 & 리조트",
  "PRLB": "프로토 랩스",
  "PRLD": "프렐류드 테라퓨틱스",
  "PRM": "페리미터 솔루션스",
  "PRMB": "프리모 브랜드",
  "PRME": "프라임 메디슨",
  "PROF": "프로파운드 메디컬",
  "PROK": "프로키드니",
  "PROP": "프레리 오퍼레이팅",
  "PROV": "프로비던트 파이낸셜 홀딩스",
  "PRPL": "퍼플 이노베이션",
  "PRPO": "프리시피오",
  "PRQR": "프로큐알테라퓨틱스",
  "PRSO": "페라소",
  "PRSU": "퍼슈트 어트랙션스 앤 호스피탈리티",
  "PRT": "PermRock Royalty Trust Trust Unit",
  "PRTA": "프로테나",
  "PRTH": "프라이오리티 테크놀러지 홀딩스",
  "PRTS": "카파츠닷컴",
  "PRU": "푸르덴셜 파이낸셜",
  "PRVA": "프리비아 헬스 그룹",
  "PRZO": "파라제로 테크놀로지스",
  "PS": "퍼싱 스퀘어",
  "PSA": "퍼블릭 스토리지",
  "PSA-P-F": "퍼블릭 스토리지",
  "PSA-P-G": "퍼블릭 스토리지",
  "PSA-P-H": "퍼블릭 스토리지",
  "PSA-P-I": "퍼블릭 스토리지",
  "PSA-P-J": "퍼블릭 스토리지",
  "PSA-P-K": "퍼블릭 스토리지",
  "PSA-P-L": "퍼블릭 스토리지",
  "PSA-P-M": "퍼블릭 스토리지",
  "PSA-P-N": "퍼블릭 스토리지",
  "PSA-P-O": "퍼블릭 스토리지",
  "PSA-P-P": "퍼블릭 스토리지",
  "PSA-P-Q": "퍼블릭 스토리지",
  "PSA-P-R": "퍼블릭 스토리지",
  "PSA-P-S": "퍼블릭 스토리지",
  "PSA-P-T": "퍼블릭 스토리지",
  "PSA-P-U": "퍼블릭 스토리지",
  "PSBD": "파머 스퀘어 캐피털 BDC",
  "PSEC": "프로스펙트 캐피털",
  "PSEC-P-A": "프로스펙트 캐피털",
  "PSF": "Cohensteers Select Preferred And",
  "PSFE": "페이 세이프",
  "PSHG": "퍼포먼스 쉬핑",
  "PSIG": "PS 인터내셔널 그룹",
  "PSIX": "파워 솔루션스 인터내셔널",
  "PSKY": "파라마운트 스카이댄스",
  "PSMT": "프라이스스마트",
  "PSN": "파슨스",
  "PSNL": "퍼스날리스",
  "PSNY": "폴스타 오토모티브 홀딩 UK ADR",
  "PSNYW": "폴스타 오토모티브 홀딩 UK ADR",
  "PSO": "피어슨 ADR",
  "PSQH": "PSQ 홀딩스",
  "PSTL": "포스털 리얼티 트러스트",
  "PSUS": "퍼싱 스퀘어 USA",
  "PSX": "필립스 66",
  "PTA": "CohenSteers Tax-Advantaged Preferred Securities and",
  "PTAC": "패트리엇 애퀴지션",
  "PTC": "Ptc",
  "PTCT": "PTC 테라퓨틱스",
  "PTEN": "패터슨-UTI 에너지",
  "PTGX": "프로타고니스트 테라퓨틱스",
  "PTHS": "펠소스 테라퓨틱스",
  "PTLE": "Ptl",
  "PTLO": "포틸로스",
  "PTN": "팔라틴 테크놀로지스",
  "PTON": "펠로튼 인터랙티브",
  "PTOR": "프레토리안 애퀴지션",
  "PTRN": "패턴 그룹",
  "PTY": "Pimco",
  "PUBM": "퍼브매틱",
  "PUK": "푸르덴셜 ADR",
  "PULM": "풀매트릭스",
  "PUMP": "프로페트로 홀딩",
  "PURR": "하이퍼리퀴드 스트래티지스",
  "PUSA": "아우레우스 그린웨이 홀딩스",
  "PVH": "필립스 반 휴센",
  "PVL": "Permianville Royalty Unit",
  "PVLA": "팔벨라 테라퓨틱스",
  "PW": "파워 리츠",
  "PW-P-A": "파워 리츠",
  "PWCM": "파워컴퓨트",
  "PWP": "파렐라 와인버그 파트너스",
  "PWR": "콴타 서비스",
  "PWRL": "파워로10",
  "PXED": "피닉스 에듀케이션 파트너스",
  "PXLW": "픽셀웍스",
  "PXS": "픽시스 탱커스",
  "PYPD": "폴리피드",
  "PYPL": "페이팔 홀딩스",
  "PYT": "프리퍼드플러스 우선주 시리즈 GSC-2",
  "PYXS": "픽시스 온콜로지",
  "PZG": "파라마운트 골드 네바다",
  "PZZA": "파파 존스 인터내셔널",
  "Q": "큐니티 일렉트로닉스",
  "QADR": "QDRO 애퀴지션",
  "QBTS": "디 웨이브 퀀텀",
  "QCLS": "Q/C 테크놀로지스",
  "QCOM": "퀄컴",
  "QCRH": "QCR 홀딩스",
  "QDEL": "퀴델오쏘",
  "QETA": "퀘타 애퀴지션",
  "QFIN": "큐핀 홀딩스 ADR",
  "QGEN": "퀴아젠",
  "QH": "취훠",
  "QLEP": "퀀텀 리프 애퀴지션",
  "QLYS": "퀄리스",
  "QMCO": "퀀텀",
  "QMLS": "큐뮬러스AI",
  "QMMM": "QMMM 홀딩스",
  "QNC": "퀀텀 이모션",
  "QNCX": "퀸스 테라퓨틱스",
  "QNME": "Quanome Technologies",
  "QNRX": "코인 파마슈티컬스 ADR",
  "QNST": "퀸스트리트",
  "QNT": "퀀티넘",
  "QNTM": "퀀텀 바이오파마",
  "QQQX": "Nuveen NASDAQ 100 Dynamic Overwrite Fund -",
  "QRED": "퀘사에지 애퀴지션",
  "QRHC": "퀘스트 리소스 홀딩",
  "QRVO": "코보",
  "QS": "퀀텀스케이프",
  "QSEA": "쿼츠씨 애퀴지션",
  "QSI": "퀀텀-Si",
  "QSR": "레스토랑 브랜즈 인터내셔널",
  "QTEX": "큐트렉스 퀀텀",
  "QTI": "QT 이미징 홀딩스",
  "QTRX": "퀀테릭스",
  "QTTB": "Q32 바이오",
  "QTWO": "Q2 홀딩스",
  "QUAD": "쿼드/그래픽스",
  "QUBT": "퀀텀 컴퓨팅",
  "QUCY": "퀀텀 사이버",
  "QUIK": "퀵로직",
  "QUMS": "퀀텀스피어 애퀴지션",
  "QURE": "유니큐어",
  "QVC": "QVC 그룹",
  "QXL": "퀀텀 X 랩스",
  "QXO": "Qxo",
  "QXO-P-B": "Qxo",
  "R": "라이더 시스템",
  "RA": "Brookfield Real Assets Income Closed Fund",
  "RAC": "리듬 애퀴지션",
  "RACC": "리서치 얼라이언스 III",
  "RACD": "리서치 얼라이언스 IV",
  "RACE": "페라리",
  "RADX": "라디오팜 테라노스틱스 ADR",
  "RAIL": "프레이트카 아메리카",
  "RAIN": "레인 인한스먼트 테크놀로지스",
  "RAL": "랠리언트",
  "RAMP": "라이브램프 홀딩스",
  "RAND": "랜드 캐피탈",
  "RANG": "레인지 캐피탈 애퀴지션",
  "RANI": "라니 테라퓨틱스 홀딩스",
  "RAPP": "라포르 테라퓨틱스",
  "RARE": "울트라제닉스 파마슈티컬",
  "RAVE": "레이브 레스토랑 그룹",
  "RAY": "레이텍 홀딩",
  "RAYA": "에라약 파워 솔루션 그룹",
  "RBA": "리치 브로스 옥셔니어스",
  "RBB": "RBB 뱅코프",
  "RBBN": "리본 커뮤니케이션",
  "RBC": "리갈 벨로이트",
  "RBCAA": "리퍼블릭 뱅코프",
  "RBKB": "라인벡 뱅코프",
  "RBLX": "로블록스",
  "RBNE": "로빈 에너지",
  "RBRK": "루브릭",
  "RC": "레디 캐피털",
  "RC-P-C": "레디 캐피털",
  "RC-P-E": "레디 캐피털",
  "RCAT": "레드 캣 홀딩스",
  "RCBC": "RCB",
  "RCEL": "아비타 메디컬",
  "RCG": "RENN Fund",
  "RCI": "로저스 커뮤니케이션스",
  "RCKT": "로켓 파머슈티컬스",
  "RCKY": "로키 브랜즈",
  "RCL": "로얄 캐리비안 크루즈",
  "RCMT": "RCM 테크놀로지스",
  "RCON": "레콘 테크놀러지",
  "RCS": "Pimco Strategic",
  "RCT": "레드클라우드 홀딩스",
  "RCUS": "아쿠스 바이오사이언스",
  "RDAC": "라이징 드래곤 애퀴지션",
  "RDAG": "리퍼블릭 디지털 애퀴지션",
  "RDCM": "래드콤",
  "RDDT": "레딧",
  "RDGT": "리지테크",
  "RDHL": "레드힐 바이오파마 ADR",
  "RDI": "리딩 인터내셔널 Class A",
  "RDIB": "리딩 인터내셔널 Class B",
  "RDN": "라디안 그룹",
  "RDNT": "래드넷",
  "RDNW": "라이드나우 그룹",
  "RDVT": "레드 바이올렛",
  "RDW": "레드와이어",
  "RDWR": "라드웨어",
  "RDY": "닥터 레디스 래보라토리스 ADR",
  "RDZN": "로드젠",
  "REA": "레어 어스 아메리카스",
  "REAL": "리얼리얼",
  "REAX": "리얼 브로커리지",
  "REBN": "리본 커피",
  "RECT": "렉티튜드 홀딩스",
  "REED": "리즈",
  "REF": "리포메이션",
  "REFI": "시카고 애틀랜틱 리얼 에스테이트 파이낸스",
  "REFR": "리서치 프런티어스",
  "REG": "리젠시 센터스",
  "REGCO": "리젠시 센터스 우선주 Series B 5.875%",
  "REGCP": "리젠시 센터스 우선주 Series A 6.25%",
  "REGN": "리제네론 파마슈티컬스",
  "REI": "링 에너지",
  "REKR": "레코 시스템",
  "RELL": "리처드슨 일렉트로닉스",
  "RELX": "렐엑스 ADR",
  "RELY": "리미틀리 글로벌",
  "RENT": "렌트 더 런웨이",
  "RENX": "렌엑스 엔터프라이즈",
  "REPL": "레플리뮨 그룹",
  "REPX": "라일리 익스플로레이션 퍼미안",
  "RERE": "AT리뉴 ADR",
  "RES": "Rpc",
  "RETO": "리토 에코-솔루션",
  "REVB": "레벨레이션 바이오사이언시스",
  "REX": "렉스 아메리칸 리소시즈",
  "REXR": "렉스포드 인더스트리얼 리얼티",
  "REXR-P-B": "렉스포드 인더스트리얼 리얼티",
  "REXR-P-C": "렉스포드 인더스트리얼 리얼티",
  "REYN": "레이놀드 컨슈머 프라덕츠",
  "REZI": "레지디오 테크놀러지",
  "RF": "리전스 파이낸셜",
  "RF-P-C": "리전스 파이낸셜",
  "RF-P-E": "리전스 파이낸셜",
  "RF-P-F": "리전스 파이낸셜",
  "RFAI": "RF 애퀴지션 II",
  "RFAM": "RF 애퀴지션 III",
  "RFI": "Cohen and Steers Total Return Realty Fund",
  "RFIL": "RF 인더스트리스",
  "RFL": "라파엘 홀딩스",
  "RFM": "RiverNorth Flexible Municipal Income Fund Inc.",
  "RFMZ": "RiverNorth Flexible Municipal Income Fund II Inc.",
  "RGA": "리인슈어런스 그룹 오브 아메리카",
  "RGC": "리젠셀 바이오사이언스 홀딩스",
  "RGCO": "RGC 리소스",
  "RGEN": "레플리젠",
  "RGLD": "로얄 골드",
  "RGNT": "리젠티스 바이오머티리얼즈",
  "RGNX": "리젠엑스바이오",
  "RGP": "리소스 커넥션",
  "RGR": "스텀 루거 앤 컴퍼니",
  "RGS": "레지스",
  "RGT": "Royce Global Trust Inc",
  "RGTI": "리게티 컴퓨팅",
  "RH": "Rh",
  "RHI": "로버트 하프 인터내셔널",
  "RHLD": "레졸루트 홀딩스 매니지먼트",
  "RHP": "라이먼 호스피탤리티 프로퍼티스",
  "RIBB": "리본 애퀴지션",
  "RICK": "RCI 호스피탤리티 홀딩스",
  "RIG": "트랜스오션",
  "RIGL": "리겔 파마슈티컬스",
  "RILY": "BRC 그룹 홀딩스",
  "RILYL": "BRC 그룹 홀딩스 우선주 시리즈 B 7.375%",
  "RILYP": "BRC 그룹 홀딩스 우선주 시리즈 A 6.875%",
  "RIME": "알고리듬 홀딩스",
  "RIO": "리오 틴토 ADR",
  "RIOT": "라이엇 플랫폼즈",
  "RITM": "리듬 캐피탈",
  "RITM-P-A": "리듬 캐피탈",
  "RITM-P-B": "리듬 캐피탈",
  "RITM-P-C": "리듬 캐피탈",
  "RITM-P-D": "리듬 캐피탈",
  "RITM-P-E": "리듬 캐피탈",
  "RITM-P-F": "리듬 캐피탈",
  "RITR": "라이터 로그텍 홀딩스",
  "RIV": "RiverNorth Opportunities Fund Inc",
  "RIV-P-A": "RiverNorth Opportunities Fund Inc",
  "RIVN": "리비안",
  "RJET": "피버블릭 에어웨이스 홀딩스",
  "RJF": "레이먼드 제임스 파이낸셜",
  "RKDA": "아카디아 바이오사이언스",
  "RKLB": "로켓 랩",
  "RKT": "로켓 컴퍼니스",
  "RKTO": "로켓 원",
  "RL": "랄프 로렌",
  "RLAY": "릴레이 테라퓨틱스",
  "RLGT": "레이디언트 로지스틱스",
  "RLI": "알리",
  "RLJ": "RLJ 로징 트러스트",
  "RLJ-P-A": "RLJ 로징 트러스트",
  "RLMD": "렐마다 테라퓨틱스",
  "RLTY": "Cohen & Steers Real Estate Opps and Income Fund",
  "RLX": "RLX 테크놀로지 ADR",
  "RLYB": "랠리바이오",
  "RM": "리저널 매니지먼트",
  "RMAX": "리/맥스 홀딩스",
  "RMBI": "리치몬드 뮤추얼 뱅코포레이션",
  "RMBS": "램버스",
  "RMCF": "로키 마운틴 초콜릿 팩토리",
  "RMCO": "로열티 매니지먼트 홀딩",
  "RMD": "레스메드",
  "RMI": "RiverNorth Opportunistic Municipal Income Fund Inc",
  "RMIX": "선크리트",
  "RMM": "RiverNorth Managed Duration Muni Income Fd Inc",
  "RMMZ": "RiverNorth Managed Duration Muni Income Fd II Inc.",
  "RMNI": "리미니스트리트",
  "RMR": "RMR 그룹",
  "RMSG": "리얼 메신저",
  "RMT": "Royce Micro Cap Closed Fund",
  "RMTI": "록웰 메디컬",
  "RNA": "아트리움 테라퓨틱스",
  "RNAC": "카르테시안 테라퓨틱스",
  "RNAZ": "트랜스코드 테라퓨틱스",
  "RNG": "링센트럴",
  "RNGR": "레인져 에너지 서비스",
  "RNGT": "레인지 캐피털 애퀴지션 II",
  "RNP": "CohenSteers REIT and Preferred and",
  "RNR": "르네상스리 홀딩스",
  "RNR-P-F": "르네상스리 홀딩스",
  "RNR-P-G": "르네상스리 홀딩스",
  "RNST": "르네산트",
  "RNTX": "레인 테라퓨틱스",
  "RNW": "리뉴 에너지 글로벌",
  "RNXT": "레노보Rx",
  "ROAD": "컨스트럭션 파트너스",
  "ROC": "랭크 원 컴퓨팅",
  "ROCK": "지브롤터 인더스트리스",
  "ROG": "로저스",
  "ROIV": "로이반트 사이언시스",
  "ROK": "로크웰 오토메이션",
  "ROKU": "로쿠",
  "ROL": "롤린스",
  "ROLR": "하이 롤러 테크놀러지스",
  "ROMA": "로마 그린 파이낸스",
  "ROOT": "루트",
  "ROP": "로퍼 테크놀로지스",
  "ROST": "로스 스토어스",
  "RPAY": "리페이 홀딩스",
  "RPC": "Ridgepost Capital",
  "RPD": "래피드7",
  "RPGL": "리퍼블릭 파워 그룹",
  "RPID": "래피드 마이크로 바이오시스템스",
  "RPM": "RPM 인터내셔널",
  "RPRX": "로열티 파마",
  "RPT": "리듬 프로퍼티 트러스트",
  "RPT-P-C": "리듬 프로퍼티 트러스트",
  "RQI": "Cohensteers Quality",
  "RR": "리치테크 로보틱스",
  "RRBI": "레드 리버 뱅크셰어스",
  "RRC": "레인지 리소시스",
  "RREV": "RRE 벤처스 애퀴지션",
  "RRGB": "레드 로빈 고메 버거스",
  "RRR": "레드 락 리조트",
  "RRX": "리걸 렉스노드",
  "RS": "릴라이언스",
  "RSF": "RiverNorth Capital and Income Interval Fund",
  "RSG": "리퍼블릭 서비스",
  "RSI": "러시 스트리트 인터랙티브",
  "RSKD": "리스키파이드",
  "RSSS": "리서치 솔루션스",
  "RSVR": "레저보아르 미디어",
  "RTAC": "레나투스 택티컬 애퀴지션 I",
  "RTB": "RTB 디지털",
  "RTO": "렌토킬 이니셜 ADR",
  "RTX": "Rtx",
  "RUBI": "루비코",
  "RUM": "럼 그룹",
  "RUN": "선런",
  "RUSHA": "러시 엔터프라이즈 Class A",
  "RUSHB": "러시 엔터프라이즈 Class B",
  "RVI": "Robinhood Ventures Fund I",
  "RVLV": "리볼브 그룹",
  "RVMD": "레볼루션 메디신",
  "RVP": "리트랙터블 테크놀로지스",
  "RVSB": "리버뷰 뱅코프",
  "RVSN": "레일 비전",
  "RVT": "Royce Small-Cap Trust Inc",
  "RVTY": "레비티",
  "RWAY": "런웨이 그로스 파이낸스",
  "RWT": "레드우드 트러스트",
  "RWT-P-A": "레드우드 트러스트",
  "RXO": "Rxo",
  "RXRX": "리커젼 파마슈티컬스",
  "RXST": "Rx사이트",
  "RXT": "랙스페이스 테크놀로지",
  "RY": "로열 뱅크 오브 캐나다",
  "RYAAY": "라이언에어 홀딩스 ADR",
  "RYAM": "레이오니어 어드밴스드 머티리얼",
  "RYAN": "라이언 스페셜티 홀딩스",
  "RYDE": "라이드 그룹",
  "RYET": "루안윈 에다이 테크놀로지",
  "RYM": "리듬",
  "RYN": "레이어니어",
  "RYOJ": "rYojbaba",
  "RYTM": "리듬 파머수티컬스",
  "RYZ": "라이어슨 홀딩",
  "RZLT": "레졸루트",
  "RZLV": "리졸브 AI",
  "S": "센티넬원",
  "SA": "시브리지 골드",
  "SAAQ": "스페이스 애셋 애퀴지션",
  "SABA": "Saba Capital Income & Opportunities Fund II",
  "SABR": "세이버",
  "SABS": "SAB 바이오테라퓨틱스",
  "SAC": "세이프가드 애퀴지션",
  "SACH": "새켐 캐피털",
  "SACH-P-A": "새켐 캐피털",
  "SAFE": "세이프홀드",
  "SAFT": "세이프티 인슈어런스 그룹",
  "SAFX": "XCF 글로벌",
  "SAGT": "새그텍 글로벌",
  "SAGU": "슈레아 애퀴지션 그룹",
  "SAH": "소닉 오토모티브",
  "SAIA": "사이아",
  "SAIC": "사이언스 어플리케이션스 인터내셔널",
  "SAIH": "사이히트",
  "SAIL": "세일포인트",
  "SAM": "보스턴 비어",
  "SAMG": "실버크레스트 애셋 매니지먼트 그룹",
  "SAN": "방코 산탄데르 ADR",
  "SANA": "사나 바이오테크놀로지",
  "SANG": "샌고마 테크놀로지스",
  "SANM": "산미나",
  "SAP": "Sap Se",
  "SAR": "사라토가 인베스트먼트",
  "SARO": "스탠다드에어로",
  "SATA": "스트라이브 우선주 Series A",
  "SATL": "스텔로직",
  "SB": "세이프 벌커스",
  "SB-P-C": "세이프 벌커스",
  "SB-P-D": "세이프 벌커스",
  "SBAC": "SBA 커뮤니케이션스",
  "SBC": "SBC 메디컬 그룹 홀딩스",
  "SBCF": "시코스트 뱅킹 코퍼레이션 오브 플로리다",
  "SBET": "샤프링크",
  "SBEV": "스플래시 베버리지 그룹",
  "SBFG": "SB 파이낸셜 그룹",
  "SBFM": "선샤인 바이오파마",
  "SBGI": "싱클레어 브로드캐스트 그룹",
  "SBH": "샐리 뷰티 홀딩스",
  "SBI": "Western Asset Intermediate Muni Fund",
  "SBLK": "스타 벌크 캐리어스",
  "SBMT": "실버 보우 마이닝",
  "SBR": "Sabine Royalty Units",
  "SBRA": "사브라 헬스케어 리츠",
  "SBS": "콤파니아 데 사네아멘투 바지쿠 상파울루 - SABESP",
  "SBSI": "사우스사이드 뱅크셰어스",
  "SBSW": "시바니 스틸워터 ADR",
  "SBUX": "스타벅스",
  "SBXD": "실버박스 IV",
  "SBXE": "실버박스 V",
  "SCAG": "스케이지 퓨처 ADR",
  "SCCO": "서던 코퍼",
  "SCD": "LMP Capital and",
  "SCE-P-G": "SCE 트러스트 VII 우선주",
  "SCE-P-L": "SCE 트러스트 VII 우선주",
  "SCE-P-M": "SCE 트러스트 VII 우선주",
  "SCE-P-N": "SCE 트러스트 VII 우선주",
  "SCHL": "스콜라스틱",
  "SCHW": "찰스 슈왑",
  "SCHW-P-D": "찰스 슈왑",
  "SCHW-P-J": "찰스 슈왑",
  "SCI": "서비스 코퍼레이션 인터내셔널",
  "SCII": "SC II 애퀴지션",
  "SCKT": "소켓 모바일",
  "SCL": "스테판",
  "SCLX": "사일렉스 홀딩",
  "SCM": "스텔러스 캐피털 인베스트먼트",
  "SCNI": "시나이 이뮤노테라퓨틱스 ADR",
  "SCNX": "사이언처 홀딩스",
  "SCOR": "컴스코어",
  "SCPQ": "소셜 커머스 파트너스",
  "SCSC": "스캔소스",
  "SCTX": "스크라이브 테라퓨틱스",
  "SCWO": "374워터",
  "SCYX": "사이넥시스",
  "SCZM": "산타크루즈 실버 마이닝",
  "SD": "샌드리지 에너지",
  "SDA": "선카 테크놀로지 그룹",
  "SDEV": "스테이블코인 디벨롭먼트",
  "SDGR": "슈뢰딩거",
  "SDHC": "스미스 더글러스 홈스",
  "SDHI": "시디 애퀴지션",
  "SDHY": "PGIM Short Duration High Yield Opportunities Fund",
  "SDOT": "사돗 그룹",
  "SDRL": "시드릴",
  "SDST": "스타더스트 파워",
  "SE": "씨 ADR",
  "SEAT": "비비드 싯츠",
  "SEB": "씨보드",
  "SECZ": "캔터 에퀴티 파트너스 II",
  "SEDG": "솔라에지 테크놀로지스",
  "SEED": "오리진 애그리테크",
  "SEER": "시어",
  "SEG": "씨포트 엔터테인먼트 그룹",
  "SEGG": "스포 엔터",
  "SEI": "솔라리스 에너지 인프라스트럭처",
  "SEIC": "SEI 인베스트먼트",
  "SELF": "글로벌 셀프 스토리지",
  "SENEA": "세네카 푸즈 Class A",
  "SENEB": "세네카 푸즈 Class B",
  "SENS": "센서닉스 홀딩스",
  "SEPN": "셉테르나",
  "SER": "세리나 테라퓨틱스",
  "SERA": "세라 프로그노스틱스",
  "SERV": "서브 로보틱스",
  "SES": "Ses Ai",
  "SEV": "압테라 모터스",
  "SEVN": "세븐 힐즈 리얼티 트러스트",
  "SEZL": "세즐",
  "SF": "스티펄 파이낸셜",
  "SF-P-B": "스티펄 파이낸셜",
  "SF-P-C": "스티펄 파이낸셜",
  "SF-P-D": "스티펄 파이낸셜",
  "SFBC": "사운드 파이낸셜 뱅코프",
  "SFBS": "서비스퍼스트 뱅크셰어스",
  "SFD": "스미스필드 푸드",
  "SFHG": "샘파인 크리에이션 홀딩스 그룹",
  "SFIX": "스티치 픽스",
  "SFL": "SFL 코퍼레이션",
  "SFM": "스프라우츠 파머스 마켓",
  "SFNC": "시몬스 퍼스트 내셔널",
  "SFST": "서던 퍼스트 뱅크셰어스",
  "SFWL": "생풍 디벨롭먼트",
  "SG": "스윗그린",
  "SGA": "사가 커뮤니케이션스",
  "SGC": "슈페리어 유니폼 그룹",
  "SGHC": "SGHC",
  "SGHT": "사이트 사이언시스",
  "SGI": "솜니그룹 인터내셔널",
  "SGLY": "싱귤러리티 퓨처 테크놀로지",
  "SGML": "시그마 리튬",
  "SGMT": "새기멧 바이오사이언시스",
  "SGP": "스파이글래스 파마",
  "SGRY": "서저리 파트너스",
  "SGU": "Star Group, L.P. Common Units Representing",
  "SHAK": "쉐이크쉑",
  "SHAZ": "샤론AI 홀딩스",
  "SHBI": "쇼어 뱅크셰어스",
  "SHC": "소테라 헬스",
  "SHEL": "쉘 ADR",
  "SHEN": "셰넌도어 텔레커뮤니케이션스",
  "SHFS": "SHF 홀딩스",
  "SHG": "신한금융지주 ADR",
  "SHIM": "심믹",
  "SHIP": "시너지 마리타임 홀딩스",
  "SHLS": "숄즈 테크놀로지스 그룹",
  "SHMD": "슈미드 그룹",
  "SHO": "선스톤 호텔 인베스터스",
  "SHO-P-H": "선스톤 호텔 인베스터스",
  "SHO-P-I": "선스톤 호텔 인베스터스",
  "SHOE": "슈 스테이션 그룹",
  "SHOO": "스티븐 매든",
  "SHOP": "쇼피파이",
  "SHOT": "RMG ML Sports Holdings Class A",
  "SHPH": "셔틀 파마슈티컬스",
  "SHW": "셔윈-윌리엄즈",
  "SI": "숄더 이노베이션스",
  "SIBN": "시-본",
  "SID": "콤파니아 시데루르지카 나시오나우 ADR",
  "SIDU": "싸이더스 스페이스",
  "SIEB": "시버트 파이낸셜 코퍼레이션",
  "SIF": "SIFCO 인더스트리",
  "SIFY": "사이피 테크놀러지 ADR",
  "SIG": "시그넷 주얼러스",
  "SIGA": "시가 테크놀로지스",
  "SIGI": "셀렉티브 인슈어런스 그룹",
  "SIGIP": "셀렉티브 인슈어런스 그룹 우선주 시리즈 B 4.6%",
  "SII": "스프롯",
  "SILC": "실리콤",
  "SILO": "사일로 파마",
  "SIM": "그루포 시멕 ADR",
  "SIMA": "SIM 애퀴지션 I",
  "SIMO": "실리콘 모션 테크놀로지 ADR",
  "SIND": "신다",
  "SINT": "SINTX 테크놀로지스",
  "SION": "시오나 테라퓨틱스",
  "SIRI": "시리우스 XM 홀딩스",
  "SITC": "사이트 센터스",
  "SITE": "사이트원 랜드스케이프 서플라이",
  "SITM": "Si타임",
  "SJ": "사이언조이 홀딩",
  "SJM": "J.M. 스머커",
  "SJT": "San Juan Basin Royalty Trust UBI",
  "SKE": "스키나 리소시스",
  "SKHY": "SK하이닉스 ADR",
  "SKIL": "스킬소프트",
  "SKIN": "스킨헬스 시스템즈",
  "SKK": "SKK 홀딩스",
  "SKM": "SK텔레콤 ADR",
  "SKT": "텐저",
  "SKWD": "스카이워드 스페셜티 인슈어런스 그룹",
  "SKY": "챔피언 홈스",
  "SKYA": "SKYAI",
  "SKYE": "스카이 바이오사이언스",
  "SKYH": "스카이 하버 그룹",
  "SKYQ": "스카이 쿼리",
  "SKYW": "스카이웨스트",
  "SKYX": "스카이엑스 플랫폼스",
  "SLAB": "실리콘 래보라토리스",
  "SLB": "Slb",
  "SLBT": "Sl 사이언스 홀딩",
  "SLDB": "솔리드 바이오사이언스",
  "SLDE": "슬라이드 인슈어런스 홀딩스",
  "SLDP": "솔리드 파워",
  "SLE": "슈퍼 리그 엔터프라이즈",
  "SLF": "선 라이프 파이낸셜",
  "SLG": "SL 그린 리얼티",
  "SLG-P-I": "SL 그린 리얼티",
  "SLGB": "스마트 로지스틱스 글로벌",
  "SLGL": "솔젤 테크놀러지",
  "SLGN": "실간 홀딩스",
  "SLI": "스탠다드 리튬",
  "SLM": "Slm",
  "SLMBP": "SLM 우선주 시리즈 B",
  "SLMT": "브레라 홀딩스",
  "SLN": "사일런스 테라퓨틱스 ADR",
  "SLND": "사우스랜드 홀딩스",
  "SLNG": "스태빌리스 솔루션스",
  "SLNH": "솔루나 홀딩스",
  "SLNHP": "솔루나 홀딩스 우선주 시리즈 A 9%",
  "SLP": "시뮬레이션스 플러스",
  "SLQT": "셀렉트코트",
  "SLRC": "SLR 인베스트먼트",
  "SLS": "셀라스 라이프 사이언스 그룹",
  "SLSN": "솔레센스",
  "SLSR": "솔라리스 리소시스",
  "SLVM": "실바모",
  "SLXN": "실렉시온 테라퓨틱스",
  "SM": "SM 에너지",
  "SMA": "스마트스톱 셀프 스토리지 REIT",
  "SMBC": "서던 미주리 뱅코프",
  "SMBK": "스마트파이낸셜",
  "SMC": "서밋 미드스트림",
  "SMCI": "슈퍼 마이크로 컴퓨터",
  "SMCIP": "슈퍼 마이크로 컴퓨터 우선주 Series A",
  "SMFG": "스미토모 미쓰이 파이낸셜그룹 ADR",
  "SMG": "스코츠 미러클 그로",
  "SMHI": "시코 마린 홀딩스",
  "SMID": "스미스-미드랜드",
  "SMJF": "SMJ 인터내셔널 홀딩스",
  "SMMT": "Summit Therapeutics Inc",
  "SMP": "스탠다드 모터 프로덕츠",
  "SMPL": "더 심플리 굿 푸드",
  "SMR": "뉴스케일 파워",
  "SMRT": "스마트렌트",
  "SMSI": "스미스 마이크로 소프트웨어",
  "SMTC": "셈텍",
  "SMTI": "사나라 메드테크",
  "SMTK": "스마트켐",
  "SMWB": "시밀러웹",
  "SMX": "SMX (시큐리티 매터스)",
  "SMXT": "솔라맥스 테크놀로지",
  "SN": "샤크닌자",
  "SNA": "스냅-온",
  "SNAL": "스네일",
  "SNAP": "스냅",
  "SND": "스마트 샌드",
  "SNDA": "소니다 시니어 리빙",
  "SNDK": "샌디스크",
  "SNDL": "Sundial Growers",
  "SNDR": "슈나이더 내셔널",
  "SNDX": "신닥스 파마슈티컬스",
  "SNES": "시네스텍",
  "SNEX": "스토넥스 그룹",
  "SNFCA": "시큐리티 내셔널 파이낸셜",
  "SNGX": "솔리제닉스",
  "SNN": "스미스 & 네퓨 ADR",
  "SNOA": "소노마 파머수티컬스",
  "SNOW": "스노우플레이크",
  "SNPS": "시놉시스",
  "SNT": "센스타 테크놀로지스",
  "SNTG": "센티지 홀딩스",
  "SNTI": "센티 바이오사이언시스",
  "SNWV": "샌유웨이브 헬스",
  "SNX": "TD 시넥스",
  "SNY": "사노피 ADR",
  "SNYR": "시너지 CHC",
  "SO": "서던",
  "SOAR": "볼라토 그룹",
  "SOBO": "사우스 보우",
  "SOBR": "소버세이프",
  "SOC": "세이블 오프쇼어",
  "SOCA": "솔라리우스 캐피털 애퀴지션",
  "SOFI": "소파이 테크놀로지스",
  "SOGP": "사운드 그룹 ADR",
  "SOHU": "소후 닷컴 ADR",
  "SOLS": "Solstice Advanced Materials",
  "SOLV": "솔벤텀",
  "SON": "소노코 프로덕트",
  "SONM": "Dna X",
  "SONO": "소노스",
  "SONY": "소니 그룹 ADR",
  "SOPH": "소피아 제네틱스",
  "SOR": "Source Capital Beneficial Interest",
  "SORA": "아시아스트래티지",
  "SORN": "소렌 애퀴지션",
  "SOS": "에스오에스",
  "SOTK": "소노-테크",
  "SOUL": "소울파워 애퀴지션",
  "SOUN": "사운드하운드 AI",
  "SOWG": "소우 굿",
  "SPAI": "세이프 프로 그룹",
  "SPB": "스펙트럼 브랜즈 홀딩스",
  "SPCB": "슈퍼컴",
  "SPCE": "버진 갤럭틱 홀딩스",
  "SPCX": "스페이스X",
  "SPE": "Special Opportunities Fund，Inc.",
  "SPE-P-C": "Special Opportunities Fund，Inc.",
  "SPEG": "실버 페가수스 애퀴지션",
  "SPFI": "사우스 플레인 파이낸셜",
  "SPG": "사이먼 프로퍼티 그룹",
  "SPG-P-J": "사이먼 프로퍼티 그룹",
  "SPGI": "S&P 글로벌",
  "SPH": "Suburban Propane Partners L P",
  "SPHL": "스프링뷰 홀딩스",
  "SPHR": "스피어 엔터테인먼트",
  "SPIR": "스파이어 글로벌",
  "SPKL": "스파크 I 애퀴지션",
  "SPMA": "사운드 포인트 머리디어 캐피털 우선주 Seires A 8%",
  "SPMC": "사운드 포인트 머리디언 캐피털",
  "SPME": "사운드 포인트 메리디언 캐피털 우선주 Series B 7.875%",
  "SPNT": "시리우스포인트",
  "SPOK": "스폭 홀딩스",
  "SPOT": "스포티파이 테크놀러지",
  "SPPL": "심플",
  "SPRB": "스프루스 바이오사이언시스",
  "SPRC": "사이스파크",
  "SPRO": "스페로 테라퓨틱스",
  "SPRU": "스프러스 파워 홀딩",
  "SPRY": "ARS 파마슈티컬스",
  "SPSC": "SPS 커머스",
  "SPT": "스프라웃 소셜",
  "SPTX": "시포트 테라퓨틱스",
  "SPWH": "스포츠맨스 웨어하우스 홀딩스",
  "SPWR": "선파워",
  "SPXC": "SPX 테크놀로지스",
  "SPXX": "Nuveen S&P 500 Dynamic Overwrite Closed End Fund",
  "SQFT": "프레시디오 프로퍼티 트러스트",
  "SQFTP": "프레지디오 프로퍼티 트러스트 우선주 시리즈 D 9.375%",
  "SQM": "소시에다드 퀴미카 B ADR",
  "SQNS": "시퀀스 커뮤니케이션즈 ADR",
  "SR": "스파이어",
  "SRAD": "스포츠레이더 그룹",
  "SRBK": "SR 뱅코프",
  "SRCE": "퍼스트 소스",
  "SRE": "셈프라 에너지",
  "SRFM": "서프 에어 모빌리티",
  "SRG": "세리티지 그로스 프로퍼티스",
  "SRG-P-A": "세리티지 그로스 프로퍼티스",
  "SRI": "스톤리지",
  "SRL": "스컬리 로열티",
  "SRPT": "사렙타 테라퓨틱스",
  "SRRK": "스칼러 락 홀딩",
  "SRTA": "스트라타 크리티컬 메디컬",
  "SRTS": "센서스 헬스케어",
  "SRV": "NXG Cushing Midstream Energy Closed End Fund",
  "SRXH": "SRx 글로벌",
  "SRZN": "서로젠",
  "SSAC": "스팩스피어 애퀴지션",
  "SSB": "사우스스테이트 뱅크",
  "SSBI": "서밋 스테이트 뱅크",
  "SSD": "심슨 매뉴팩처링",
  "SSEA": "스태리 씨 애퀴지션",
  "SSII": "SS 이노베이션스 인터내셔널",
  "SSL": "사솔 ADR",
  "SSM": "소노 그룹",
  "SSMR": "선샤인 실버 마이닝 앤 리파이닝",
  "SSNC": "SS&C 테크놀로지스 홀딩스",
  "SSP": "E W 스크립스",
  "SSRM": "SSR 마이닝",
  "SST": "시스템원",
  "SSTI": "샷스포터",
  "SSTK": "셔터스톡",
  "SSYS": "스트라타시스",
  "ST": "센사타 테크놀로지스 홀딩",
  "STAA": "스타 서지컬",
  "STAG": "스태그 인더스트리얼",
  "STAK": "스탁",
  "STBA": "S&T 뱅코프",
  "STC": "스튜어트 인포메이션 서비스",
  "STDN": "스탠다드 뉴클리어",
  "STE": "스테리스",
  "STEM": "스템",
  "STEP": "스텝스톤 그룹",
  "STEW": "SRH Total Return Fund，Inc",
  "STEX": "스트리멕스",
  "STFS": "스타 패션 컬처 홀딩스",
  "STG": "선랜드 테크놀러지 그룹 ADR",
  "STGW": "스태그웰",
  "STHO": "스타 홀딩스",
  "STI": "솔리디온 테크놀로지",
  "STIM": "뉴로네틱스",
  "STK": "Columbia Seligman Premium Technology Growth Fund",
  "STKE": "솔 스트래티지스",
  "STKH": "스테이크홀더 푸즈 ADR",
  "STKS": "원 그룹 호스피탤리티",
  "STLA": "스텔란티스",
  "STLD": "스틸 다이내믹스",
  "STLN": "스타링 온콜로지",
  "STM": "ST 마이크로 일렉트로닉스 ADR",
  "STN": "스탠텍",
  "STNE": "스톤코",
  "STNG": "스콜피오 탱커스",
  "STOK": "스토케 테라퓨틱스",
  "STRA": "스트래티직 에듀케이션",
  "STRC": "스트래티지 우선주 Series A",
  "STRD": "스트래티지 우선주 Series A 10.00%",
  "STRF": "스트래티지 우선주 Series A 10.00%",
  "STRK": "스트래티지 우선주 Series A 8.00%",
  "STRL": "스털링 인프라스트럭처",
  "STRO": "수트로 바이오파머",
  "STRR": "스타 에퀴티 홀딩스",
  "STRRP": "스타 에퀴티 홀딩스 우선주 Series A 10%",
  "STRS": "스트라투스 프로퍼티스",
  "STRT": "스트라텍 시큐리티",
  "STRW": "스트로베리 필즈 리츠",
  "STRZ": "스타즈 엔터테인먼트",
  "STT": "스테이트 스트리트",
  "STT-P-G": "스테이트 스트리트",
  "STTK": "섀턱 랩",
  "STUB": "스텁허브 홀딩스",
  "STVN": "스테바나토 그룹",
  "STWD": "스타우드 프로퍼티 트러스트",
  "STX": "씨게이트",
  "STXS": "스테레오택시스",
  "STZ": "컨스텔레이션 브랜즈",
  "SU": "선코어 에너지",
  "SUGP": "SU 그룹 홀딩스",
  "SUI": "선 커뮤니티즈",
  "SUIG": "SUI 그룹 홀딩스",
  "SUJA": "수자 라이프",
  "SUMA": "SUMA 애퀴지션",
  "SUN": "Sunoco L.P.",
  "SUNB": "선벨트 렌탈스 홀딩스",
  "SUNC": "SunocoCorp",
  "SUNE": "선내션 에너지",
  "SUNS": "선라이즈 리얼티 트러스트",
  "SUPN": "슈퍼누스 파마슈티컬스",
  "SUPV": "그루포 수페르비엘 ADR",
  "SUPX": "슈퍼X AI 테크놀로지",
  "SURG": "서지페이즈",
  "SUZ": "수자노 ADR",
  "SVA": "시노백 바이오테크",
  "SVAQ": "실리콘밸리 애퀴지션",
  "SVC": "서비스 프로퍼티스 트러스트",
  "SVCC": "스텔라 V 캐피탈",
  "SVCO": "실바코 그룹",
  "SVIV": "스프링 밸리 애퀴지션 IV",
  "SVM": "실버코프 메탈스",
  "SVRA": "사바라",
  "SVRE": "세이버원 2014 ADR",
  "SVRN": "오션팰",
  "SVV": "세이버스 밸류 빌리지",
  "SW": "스머핏 웨스트락",
  "SWAG": "스트란앤컴퍼니",
  "SWBI": "스미스&웨슨 브랜드",
  "SWIM": "라탐 그룹",
  "SWK": "스탠리 블랙 & 데커",
  "SWKS": "스카이웍스 솔루션스",
  "SWMR": "스워머",
  "SWVL": "스워블 홀딩스",
  "SWX": "사우스웨스트 가스 홀딩스",
  "SWZ": "Total Return Securities Fund",
  "SXC": "선코크 에너지",
  "SXI": "스탠덱스 인터내셔널",
  "SXT": "센시언트 테크놀로지스",
  "SXTC": "차이나 SXT 파마슈티컬스",
  "SXTP": "60 디그리스 파마슈티컬스",
  "SY": "소영 인터내셔널 ADR",
  "SYBT": "스탁 야즈 뱅코프",
  "SYF": "싱크로니 파이낸셜",
  "SYF-P-A": "싱크로니 파이낸셜",
  "SYF-P-B": "싱크로니 파이낸셜",
  "SYK": "스트라이커",
  "SYM": "심보틱",
  "SYNA": "시냅틱스",
  "SYNX": "실링크스",
  "SYPR": "사이프리스 솔루션스",
  "SYRE": "스파이어 테라퓨틱스",
  "SYY": "시스코",
  "SZZL": "시즐 애퀴지션 II",
  "T": "At&T",
  "T-P-A": "At&T",
  "T-P-C": "At&T",
  "TAC": "트랜스알타",
  "TACH": "타이탄 애퀴지션",
  "TACO": "베르토 애퀴지션",
  "TACT": "트랜스액트 테크놀로지스",
  "TAK": "다케다 파마슈티컬 ADR",
  "TAL": "TAL 에듀케이션 그룹 ADR",
  "TALK": "토크스페이스",
  "TALO": "탈로스 에너지",
  "TANH": "탄테크 홀딩스",
  "TAOP": "타오핑",
  "TAOX": "TAO 시너지스",
  "TAP": "몰슨 쿠어스 베버리지 Class B",
  "TAP-A": "몰슨 쿠어스 베버리지 Class A",
  "TARA": "프로타라 테라퓨틱스",
  "TARS": "타서스 파마슈티컬스",
  "TASK": "태스크어스",
  "TATT": "TAT 테크놀러지",
  "TAVI": "타비아 애퀴지션",
  "TAYD": "테일러 디바이시스",
  "TBBB": "BBB 푸드",
  "TBBK": "뱅코프",
  "TBCH": "터틀 비치",
  "TBI": "트루블루",
  "TBLA": "타불라",
  "TBLD": "Thornburg Income Builder Opportunities Trust",
  "TBN": "탬보란 리소시스",
  "TBPH": "테라반스 바이오파마",
  "TC": "토큰 캣 ADR",
  "TCBI": "텍사스 캐피털 뱅크셰어스",
  "TCBIO": "텍사스 캐피털 뱅크셰어스 우선주 Series B 5.75%",
  "TCBK": "트라이코 뱅크셰어스",
  "TCBS": "텍사스 커뮤니티 뱅크셰어",
  "TCBX": "써드 코스트 뱅크셰어스",
  "TCGX": "TCGX 애퀴지션",
  "TCI": "트랜스컨티넨탈 리얼티 인베스터",
  "TCMD": "택타일 시스템 테크놀로지",
  "TCOM": "트립닷컴 그룹 ADR",
  "TCPC": "블랙록 TCP 캐피털",
  "TCRT": "알라우노스 테라퓨틱스",
  "TCRX": "T스캔 테라퓨틱스",
  "TCX": "투카우스",
  "TD": "토론토 도미니언 은행",
  "TDAC": "트랜스레이셔널 디벨롭먼트 애퀴지션",
  "TDAY": "USA 투데이",
  "TDC": "테라데이타",
  "TDF": "Templeton Dragon Closed Fund",
  "TDG": "트랜스다임 그룹",
  "TDIC": "드림랜드",
  "TDOC": "텔라닥 헬스",
  "TDS": "텔레폰 앤 데이터 시스템즈",
  "TDS-P-U": "텔레폰 앤 데이터 시스템즈",
  "TDS-P-V": "텔레폰 앤 데이터 시스템즈",
  "TDTH": "트라이던트 디지털 테크 홀딩스",
  "TDUP": "스레드업",
  "TDW": "타이드워터",
  "TDWD": "테일윈드 2.0 애퀴지션",
  "TDY": "텔레다인 테크놀로지스",
  "TE": "T1 에너지",
  "TEAD": "티즈 홀딩",
  "TEAM": "아틀라시안",
  "TECH": "바이오-테크네",
  "TECK": "텍 리소스",
  "TECX": "텍토닉 테라퓨틱",
  "TEI": "Templeton Emerging Markets Income Closed Fund",
  "TEL": "TE 커넥티비티",
  "TELA": "텔라 바이오",
  "TELO": "텔로미르 파마슈티컬스",
  "TEM": "템퍼스 AI",
  "TEN": "차코스 에너지 내비게이션",
  "TEN-P-E": "차코스 에너지 내비게이션",
  "TEN-P-F": "차코스 에너지 내비게이션",
  "TENB": "테너블 홀딩스",
  "TENX": "테낙스 테라퓨틱스",
  "TEO": "텔레콤 아르헨티나 ADR",
  "TER": "테라다인",
  "TEVA": "테바 파마슈티컬 인더스트리 ADR",
  "TEX": "테렉스",
  "TFC": "트루이스트 파이낸셜",
  "TFC-P-I": "트루이스트 파이낸셜",
  "TFC-P-O": "트루이스트 파이낸셜",
  "TFC-P-R": "트루이스트 파이낸셜",
  "TFII": "TFI 인터내셔널",
  "TFIN": "트라이엄프 파이낸셜",
  "TFIN-P": "트라이엄프 파이낸셜",
  "TFPM": "트리플 플래그 프레셔스 메탈스",
  "TFSL": "TFS 파이낸셜",
  "TFX": "텔레플렉스",
  "TG": "트레데가",
  "TGB": "트레코 메탈스",
  "TGE": "제너레이션 에센셜스 그룹",
  "TGEN": "테코젠",
  "TGHL": "그로우허브",
  "TGL": "트레저 글로벌",
  "TGLS": "테크노글래스 홀딩스",
  "TGS": "Transportadora de Gas del Sur S.A. ADS",
  "TGT": "타겟",
  "TGTX": "TG 테라퓨틱스",
  "TH": "타겟 호스피탈리티",
  "THC": "테넷 헬스케어",
  "THCH": "TH 인터내셔널",
  "THFF": "퍼스트 파이낸셜",
  "THG": "하노버 인슈어런스 그룹",
  "THH": "트라이하드 홀딩스",
  "THM": "인터내셔널 타워 힐 마인스",
  "THO": "소어 인더스트리스",
  "THQ": "abrdn Healthcare Opportunities Fund",
  "THRM": "젠섬",
  "THRY": "쓰리브 홀딩스",
  "THW": "abrdn World Healthcare Fund",
  "TIC": "TIC 솔루션스",
  "TIGO": "밀리콤 인터내셔널 셀룰러",
  "TIGR": "업 핀테크 홀딩스 ADR",
  "TII": "타이탄 마이닝",
  "TIL": "인스틸 바이오",
  "TILE": "인터페이스",
  "TIMB": "팀 ADR",
  "TIPT": "팁트리",
  "TISI": "팀",
  "TITN": "타이탄 머시너리",
  "TJGC": "TJGC 그룹",
  "TJX": "TJX 컴퍼니스",
  "TK": "티케이",
  "TKC": "투르크젤 을레티심 히즈메틀레리 ADR",
  "TKLF": "도쿄 라이프스타일 ADR",
  "TKNO": "알파 테크노바",
  "TKO": "TKO 그룹 홀딩스",
  "TKR": "팀켄",
  "TLF": "탠디 레더 팩토리",
  "TLIH": "텐리그 인터내셔널 홀딩스",
  "TLK": "텔콤 인도네시아 ADR",
  "TLN": "탈렌 에너지",
  "TLNC": "탈론 캐피털",
  "TLPH": "탈페라",
  "TLRY": "틸레이 브랜즈",
  "TLS": "텔로스",
  "TLSA": "Tiziana Life Sciences Ltd",
  "TLSI": "메드테크 애퀴지션",
  "TLX": "텔릭스 파마슈티컬스 ADR",
  "TLYS": "틸리스",
  "TM": "토요타자동차 ADR",
  "TMC": "TMC 더 메탈스 컴퍼니",
  "TMCI": "트리스 메디컬 컨셉트",
  "TMCR": "메탈스 로열티 컴퍼니",
  "TMDE": "TMD 에너지",
  "TMDX": "트랜스메딕스 그룹",
  "TME": "텐센트뮤직엔터테인먼트그룹 ADR",
  "TMO": "써모 피셔 사이언티픽",
  "TMP": "톰킨스 파이낸셜",
  "TMQ": "트릴로지 메탈",
  "TMS": "팀셰어스",
  "TMTS": "스파르타쿠스 애퀴지션 II",
  "TMUS": "T-모바일 US",
  "TNC": "테넌트",
  "TNDM": "탠덤 다이어비츠 케어",
  "TNET": "트라이넷 그룹",
  "TNGX": "탱고 테라퓨틱스",
  "TNK": "티케이 탱커스",
  "TNL": "트래블 앤 레저",
  "TNMG": "TNL 미디어진",
  "TNON": "테논 메디컬",
  "TNXP": "토닉스 파마슈티컬스 홀딩",
  "TNYA": "테나야 테라퓨틱스",
  "TOL": "톨 브라더스",
  "TOMZ": "토미 인바이런먼털 솔루션스",
  "TONT": "그라프 글로벌",
  "TONX": "톤 스트래티지",
  "TOON": "카툰 스튜디오스",
  "TOP": "탑 파이낸셜 그룹",
  "TOPP": "탑포인트 홀딩스",
  "TOPS": "탑 십스",
  "TORO": "토로",
  "TOST": "토스트",
  "TOUR": "투뉴 ADR",
  "TOVX": "테리바 바이오로직스",
  "TOWN": "타운뱅크",
  "TOYO": "토요",
  "TP": "Ticketplus Ltd",
  "TPB": "터닝 포인트 브랜드",
  "TPC": "튜터 페리니",
  "TPCS": "테크프레시젼",
  "TPET": "트리오 퍼트롤리엄",
  "TPG": "Tpg",
  "TPL": "텍사스 퍼시픽 랜드",
  "TPR": "태피스트리",
  "TPST": "템피스트 테라퓨틱스",
  "TPVG": "트리플포인트 벤처 그로스 BDC",
  "TR": "투시 롤 인더스트리스",
  "TRAD": "APEX 테크 애퀴지션",
  "TRAK": "레포지트랙",
  "TRAW": "트로스 파르마",
  "TRAX": "퍼스트 트랙스 바이오테라퓨틱",
  "TRC": "테혼 랜치",
  "TRDA": "엔트라다 테라퓨틱스",
  "TREE": "렌딩트리",
  "TREX": "트렉스",
  "TRGP": "타르가 리소스",
  "TRGS": "TRG 라틴 아메리카 애퀴지션스",
  "TRI": "톰슨 로이터",
  "TRIB": "트리니티 바이오테크 ADR",
  "TRIN": "트리니티 캐피탈",
  "TRIP": "트립어드바이저",
  "TRLV": "트룰리브 캐나비스",
  "TRMB": "트림블",
  "TRMD": "톰",
  "TRMK": "트러스트마크",
  "TRN": "트리니티 인더스트리스",
  "TRNO": "테레노 리얼티",
  "TRNR": "인터랙티브 스트랭스",
  "TRNS": "트랜스캣",
  "TRON": "Tron",
  "TROO": "트룹스",
  "TROW": "티 로웨 프라이스 그룹",
  "TROX": "트로녹스 홀딩스",
  "TRP": "TC 에너지",
  "TRS": "트리마스",
  "TRSG": "턴그레이 테크놀로지스",
  "TRST": "트러스트코 은행 N Y",
  "TRT": "트리오 테크 인터내셔널",
  "TRTN-P-A": "트라이턴 인터내셔널 우선주 시리즈 C 7.375%",
  "TRTN-P-B": "트라이턴 인터내셔널 우선주 시리즈 C 7.375%",
  "TRTN-P-C": "트라이턴 인터내셔널 우선주 시리즈 C 7.375%",
  "TRTN-P-D": "트라이턴 인터내셔널 우선주 시리즈 C 7.375%",
  "TRTN-P-E": "트라이턴 인터내셔널 우선주 시리즈 C 7.375%",
  "TRTN-P-F": "트라이턴 인터내셔널 우선주 시리즈 C 7.375%",
  "TRTN-P-G": "트라이턴 인터내셔널 우선주 시리즈 C 7.375%",
  "TRTX": "TPG 리 파이낸스 트러스트",
  "TRTX-P-C": "TPG 리 파이낸스 트러스트",
  "TRU": "트랜스유니온",
  "TRUG": "트루골프 홀딩스",
  "TRUP": "트루패니언",
  "TRV": "트래블러스 컴퍼니스",
  "TRVG": "트리바고 ADR",
  "TRVI": "트레비 테라퓨틱스",
  "TRX": "탄자니아 골드",
  "TS": "테나리스 ADR",
  "TSAT": "텔레샛",
  "TSBK": "팀버랜드 뱅코프",
  "TSCO": "트랙터 서플라이",
  "TSEM": "타워 세미컨덕터",
  "TSHA": "타이샤 젠 테라피",
  "TSI": "TCW Strategic Income Closed Fund",
  "TSLA": "테슬라",
  "TSLX": "TPG 스페셜티 렌딩",
  "TSM": "TSMC(타이완반도체제조) ADR",
  "TSN": "타이슨 푸드",
  "TSQ": "타운스퀘어 미디어",
  "TSSI": "Tss",
  "TT": "트레인 테크놀로지",
  "TTAM": "타이탄 아메리카",
  "TTAN": "서비스타이탄",
  "TTC": "토로",
  "TTD": "트레이드 데스크",
  "TTE": "토탈에너지스",
  "TTEC": "TTEC 홀딩스",
  "TTEK": "테트라 테크",
  "TTGT": "테크타겟",
  "TTI": "테트라 테크놀로지스",
  "TTMI": "TTM 테크놀로지스",
  "TTRX": "턴 테라퓨틱스",
  "TTWO": "테이크-투 인터랙티브 소프트웨어",
  "TU": "텔러스",
  "TULP": "블루미아 홀딩스",
  "TURB": "터보 에너지 ADR",
  "TUSK": "매머드 에너지서비스",
  "TUYA": "투야 ADR",
  "TV": "그루포 텔레비사 ADR",
  "TVA": "텍사스 벤처스 애퀴지션 III",
  "TVAI": "세이어 벤처스 애퀴지션 II",
  "TVC": "테네시 밸리 오쏘리티 선순위 채권 시리즈 D 만기 2028년",
  "TVE": "테네시 밸리 오쏘리티 선순위 채권 시리즈 A 만기 2029년",
  "TVGN": "티보젠",
  "TVIV": "텍사스 벤처스 애퀴지션 IV",
  "TVRD": "티발디 테라퓨틱스",
  "TVTX": "트래버 테라퓨틱스",
  "TW": "트레이드웹 마켓",
  "TWAV": "타오위브",
  "TWFG": "Twfg",
  "TWG": "탑 웰스 그룹 홀딩",
  "TWI": "타이탄 인터내셔널",
  "TWIN": "트윈 디스크",
  "TWLO": "트윌리오",
  "TWLV": "트웰브 시즈 인베스트먼트 컴퍼니 III",
  "TWN": "Taiwan Fund",
  "TWO": "투 하버스 인베스트먼트",
  "TWO-P-A": "투 하버스 인베스트먼트",
  "TWO-P-B": "투 하버스 인베스트먼트",
  "TWO-P-C": "투 하버스 인베스트먼트",
  "TWST": "트위스트 바이오사이언스",
  "TX": "테르니움 ADR",
  "TXG": "10X 제노믹스",
  "TXMD": "테라퓨틱스MD",
  "TXN": "텍사스 인스트루먼트",
  "TXNM": "TXNM 에너지",
  "TXO": "TXO Partners, L.P.",
  "TXRH": "텍사스 로드하우스",
  "TXT": "텍스트론",
  "TY": "TRI-Continental",
  "TY-P": "Tri Continental Closed Fund",
  "TYG": "Tortoise Energy Infrastructure Closed Fund",
  "TYGO": "티고 에너지",
  "TYL": "타일러 테크놀로지스",
  "TYRA": "타이라 바이오사이언시스",
  "TZOO": "트래블주",
  "U": "유니티소프트웨어",
  "UA": "언더 아머 Class C",
  "UAA": "언더 아머 Class A",
  "UAC": "유나이티드 애퀴지션 I",
  "UAL": "유나이티드 에어라인스 홀딩스",
  "UAMY": "유나이티드 스테이츠 앤티모니",
  "UAN": "CVR Partners, LP",
  "UAVS": "에이지이글 에어리얼 시스템",
  "UBCP": "유나이티드 뱅코프",
  "UBER": "우버",
  "UBS": "UBS 그룹 AG",
  "UBSI": "유나이티드 뱅크셰어스(Nasdaq GS)",
  "UCAR": "유 파워",
  "UCB": "유나이티드 커뮤니티 뱅크스",
  "UCFI": "CN 헬시 푸드 테크 그룹",
  "UCL": "유클라우드링크 그룹 ADR",
  "UCTT": "울트라 클린 홀딩스",
  "UDR": "Udr",
  "UE": "어반 에지 프로퍼티스",
  "UEC": "우라늄 에너지",
  "UEIC": "유니버설 일렉트로닉스",
  "UFCS": "유나이티드 파이어 그룹",
  "UFG": "유니-퓨얼 홀딩스",
  "UFI": "유니피",
  "UFPI": "UFP 인더스트리",
  "UFPT": "UFP 테크놀로지스",
  "UG": "유나이티드-가디언",
  "UGI": "Ugi",
  "UGP": "울트라파르 팔티시파코에스 ADR",
  "UHAL": "유홀 홀딩",
  "UHAL-B": "유홀 홀딩 시리즈 N",
  "UHS": "유니버셜 헬스 서비스",
  "UHT": "유니버설 헬스 리얼티 인컴 트러스트",
  "UI": "유비퀴티",
  "UIS": "유니시스",
  "UK": "유커뮨 인터내셔널",
  "UL": "유니레버 ADR",
  "ULBI": "울트라라이프",
  "ULCC": "프론티어 그룹 홀딩스",
  "ULH": "유니버셜 로지스틱스 홀딩스",
  "ULS": "UL 솔루션스",
  "ULTA": "울타 뷰티",
  "UMAC": "언유주얼 머신스",
  "UMBF": "UMB 파이낸셜",
  "UMBFO": "UMB 파이낸셜 우선주 Series B 7.750%",
  "UMC": "유나이티드 마이크로일렉트로닉 ADR",
  "UMH": "UMH 프로퍼티",
  "UMH-P-D": "UMH 프로퍼티",
  "UNB": "유니언 뱅크셰어스",
  "UNCY": "유니사이시브 테라퓨틱스",
  "UNF": "유니퍼스트",
  "UNFI": "유나이티드 내추럴 푸드",
  "UNH": "유나이티드헬스 그룹",
  "UNIT": "유니티 그룹 (델라웨어)",
  "UNM": "유넘그룹",
  "UNP": "유니온 퍼시픽",
  "UNTY": "유니티 뱅코프",
  "UONE": "어반 원 Class A",
  "UONEK": "어반 원 Class D",
  "UP": "휠즈 업 익스피리언스",
  "UPB": "업스트림 바이오",
  "UPBD": "업바운드 그룹",
  "UPC": "유니버스 파마슈티컬스",
  "UPLD": "업랜드 소프트웨어",
  "UPS": "UPS(유나이티드 파셀 서비스)",
  "UPST": "업스타트 홀딩스",
  "UPWK": "업워크",
  "UPXI": "유펙시",
  "URBN": "어반 아웃피터스",
  "URG": "유어-에너지",
  "URGN": "우로젠 파마",
  "URI": "유나이티드 렌탈스",
  "UROY": "우라늄 로열티",
  "USA": "Liberty All Star Equity Closed Fund",
  "USAC": "Usa Compression Partners Lp",
  "USAR": "USA 레어 어스",
  "USAS": "아메리칸 골드 앤 실버",
  "USAU": "US 골드",
  "USB": "US 뱅코프",
  "USB-P-A": "US 뱅코프",
  "USB-P-H": "US 뱅코프",
  "USB-P-P": "US 뱅코프",
  "USB-P-Q": "US 뱅코프",
  "USB-P-R": "US 뱅코프",
  "USB-P-S": "US 뱅코프",
  "USBC": "Usbc",
  "USCB": "US 센츄리 뱅크",
  "USDE": "스테이블코인엑스",
  "USEA": "유나이티드 마리타임",
  "USFD": "US 푸즈 홀딩",
  "USGO": "US 골드마이닝",
  "USIO": "유시오",
  "USLM": "유나이티드 스테이츠 라임 & 미네랄",
  "USNA": "유사나 헬스 사이언스",
  "USPH": "US 피지컬 테라피",
  "UTF": "CohenSteers  Infrastructure Fund",
  "UTG": "Reaves Utility Income Closed Fund",
  "UTHR": "유나이티드 테라퓨틱스",
  "UTI": "유니버설 테크니컬 인스티튜트",
  "UTL": "유니틸",
  "UTMD": "유타 메디컬 프로덕츠",
  "UTSI": "UT스타컴 홀딩스",
  "UTZ": "UTZ 브랜즈",
  "UUU": "유니버셜 세이프티 프로덕츠",
  "UUUU": "에너지 퓨얼스",
  "UVE": "유니버설 인슈어런스 홀딩스",
  "UVSP": "유니베스트 파이낸셜",
  "UVV": "유니버설",
  "UWMC": "UWM 홀딩스",
  "UXIN": "우신 ADR",
  "UYSC": "UY 스쿠티 애퀴지션",
  "UZX": "링키지 글로벌",
  "V": "비자",
  "VABK": "버지니아 내셔널 뱅크셰어",
  "VAC": "메리어트 버케이션 월드와이드",
  "VACI": "바이킹 애퀴지션 I",
  "VAL": "밸라리스",
  "VALE": "발레 ADR",
  "VALN": "발네바 ADR",
  "VALU": "밸류 라인",
  "VANI": "비바니 메디컬",
  "VATE": "이노베이트",
  "VBF": "Invesco  Bond Fund",
  "VBIO": "티빅 헬스 시스템스",
  "VBNK": "버사뱅크",
  "VC": "비스티온",
  "VCEL": "베리셀",
  "VCIG": "VCI 글로벌",
  "VCRE": "바이코어 파마 홀딩 ADR",
  "VCTR": "빅토리 캐피털 홀딩스",
  "VCV": "Invesco  California Value Muni",
  "VCX": "Fundrise Innovation Fund  LLC",
  "VCYT": "베라사이트",
  "VECA": "버널 캐피탈 애퀴지션",
  "VECO": "비코 인스트루먼츠",
  "VEEA": "비아",
  "VEEE": "트윈 비 파워캣츠",
  "VEEV": "비바 시스템즈",
  "VEL": "벨로시티 파이낸셜",
  "VELO": "벨로3D",
  "VENU": "베누 홀딩",
  "VEON": "베온 ADR",
  "VERA": "베라 테라퓨틱스",
  "VERI": "베리톤",
  "VERU": "베루",
  "VERX": "버텍스",
  "VET": "버밀리온 에너지",
  "VFC": "V.F.",
  "VFF": "빌리지 팜스 인터내셔널",
  "VFS": "빈패스트 오토",
  "VG": "벤처 글로벌",
  "VGAS": "베르데 클린 퓨얼스",
  "VGI": "Virtus Global Multi-Sector Income Fund",
  "VGM": "Invesco  Trust Investment Grade Municipals",
  "VGNT": "버시전트",
  "VGZ": "비스타 골드",
  "VHC": "버넷X 홀딩",
  "VHCP": "바인힐 캐피탈 인베스트먼트 II",
  "VHI": "밸히",
  "VHUB": "벤허브 글로벌",
  "VIA": "비아 트랜스포테이션",
  "VIAV": "비아비 솔루션스",
  "VICI": "비치 프로퍼티스",
  "VICR": "비코",
  "VIDA": "비다 글로벌",
  "VII": "바이킹 애퀴지션 II",
  "VIK": "바이킹 홀딩스",
  "VINP": "빈치 컴퍼스 인베스트먼츠",
  "VIOT": "비오미 테크놀러지 ADR",
  "VIP": "벌칸 인프라스트럭처 앤 파워",
  "VIPS": "브이아이피숍 홀딩스 ADR",
  "VIR": "버 바이오테크놀로지",
  "VIRC": "버코 매뉴팩처링",
  "VIRT": "버튜 파이낸셜",
  "VISN": "비스탄스 네트웍스",
  "VIST": "비스타 에너지",
  "VITL": "바이탈 팜스",
  "VIV": "텔레포니카 브라질 ADR",
  "VIVK": "비바코어",
  "VIVO": "비보파워",
  "VIVS": "비보심 랩스",
  "VKI": "Invesco Advantage Municipal Inc Tr II",
  "VKQ": "Invesco Municipal Trust",
  "VKTX": "바이킹 테라퓨틱스",
  "VLGEA": "빌리지 슈퍼 마켓",
  "VLN": "발렌스 세미컨덕터",
  "VLO": "발레로 에너지",
  "VLOS": "벨로스 애퀴지션 I",
  "VLRS": "콘트롤라도라 부엘라 콤파니아 아비아시온 ADR",
  "VLT": "Invesco  High",
  "VLTO": "베랄토",
  "VLY": "밸리 내셔널 뱅코프",
  "VLYPN": "밸리 내셔널 뱅코프 우선주 Series C 8.250%",
  "VLYPO": "밸리 내셔널 뱅코프 우선주 시리즈 B",
  "VLYPP": "밸리 내셔널 뱅코프 우선주 시리즈 A",
  "VMAR": "비전 마린 테크놀로지스",
  "VMC": "벌칸 머티리얼스",
  "VMD": "비메드 헬스케어",
  "VMET": "버사멧 로열티스",
  "VMI": "밸몬트 인더스트리스",
  "VMO": "Invesco Municipal Opportunity Trust",
  "VNCE": "빈스 홀딩",
  "VNDA": "반다 파마슈티컬스",
  "VNET": "브이넷 그룹 ADR",
  "VNME": "벤돔 애퀴지션 I",
  "VNO": "보나도 리얼티 트러스트",
  "VNO-P-L": "보나도 리얼티 트러스트",
  "VNO-P-M": "보나도 리얼티 트러스트",
  "VNO-P-N": "보나도 리얼티 트러스트",
  "VNO-P-O": "보나도 리얼티 트러스트",
  "VNOM": "바이퍼 에너지",
  "VNRX": "볼리션RX",
  "VNT": "본티어",
  "VNTG": "밴티지",
  "VOC": "Voc Energy Trust",
  "VOD": "보다폰 그룹 ADR",
  "VOR": "보어 바이오파마",
  "VOXR": "복스 로열티",
  "VOYA": "보야 파이낸셜",
  "VOYA-P-B": "보야 파이낸셜",
  "VOYG": "보이저 테크놀로지스",
  "VPG": "비샤이 프리시전 그룹",
  "VPV": "Invesco  Pennsylvania Value Municipal",
  "VRA": "베라 브래들리",
  "VRAX": "바이랙스 바이오랩스 그룹",
  "VRCA": "베리카 파마슈티컬",
  "VRDN": "비리디안 테라퓨틱스",
  "VREX": "바렉스 이미징",
  "VRM": "브룸",
  "VRME": "베리파이미",
  "VRNS": "바로니스 시스템즈",
  "VRRM": "베라 모빌리티",
  "VRSK": "베리스크 애널리틱스",
  "VRSN": "베리사인",
  "VRT": "버티브 홀딩스",
  "VRTS": "비르투스 인베스트먼트 파트너스",
  "VRTX": "버텍스 파마슈티컬",
  "VRXA": "베락사 바이오테크",
  "VS": "버서스 시스템즈",
  "VSA": "비전시스 AI ADR",
  "VSAT": "비아샛",
  "VSEC": "Vse",
  "VSH": "비샤이 인터테크놀로지",
  "VSME": "VS 미디어 홀딩스",
  "VSNT": "버산트 미디어 그룹",
  "VST": "비스트라 에너지",
  "VSTM": "베라스템",
  "VSTS": "베스티스",
  "VSXY": "빅토리아 시크릿",
  "VTAK": "카테터 프레시젼",
  "VTEX": "Vtex",
  "VTGN": "비스타젠 테라퓨틱스",
  "VTIX": "버툭스 홀딩스",
  "VTMX": "베스타 리얼 에스테이트 ADR",
  "VTN": "Invesco  Trust for Investment Grade New York Municipals",
  "VTOL": "브리스토우 그룹",
  "VTR": "벤타스",
  "VTRS": "비아트리스",
  "VTS": "비테스 에너지",
  "VTSI": "버트라",
  "VTVT": "vTv 테라퓨틱스",
  "VUZI": "뷰직스",
  "VVOS": "비보스 테라퓨틱스",
  "VVR": "Invesco  Senior",
  "VVV": "밸보라인",
  "VVX": "브이투엑스(V2X)",
  "VWAV": "비전웨이브 홀딩스",
  "VYGR": "보이저 테라퓨틱스",
  "VYX": "NCR 보익스",
  "VZ": "버라이존",
  "VZLA": "비즐라 실버",
  "W": "웨이페어",
  "WAB": "웨스팅하우스 에어 브레이크 테크놀로지",
  "WABC": "웨스트아메리카 뱅코프",
  "WAFD": "WaFd",
  "WAFDP": "WaFd 우선주 Series A",
  "WAFU": "와푸 에듀케이션",
  "WAL": "웨스턴 얼라이언스 뱅코프",
  "WAL-P-A": "웨스턴 얼라이언스 뱅코프",
  "WALD": "월든캐스트",
  "WASH": "워싱턴 트러스트 뱅코프",
  "WAT": "워터스",
  "WATT": "에너거스",
  "WAVE": "에코 웨이브 파워 글로벌 AB (publ) ADR",
  "WAY": "웨이스타 홀딩",
  "WB": "웨이보 ADR",
  "WBD": "워너 브로스 디스커버리",
  "WBI": "워터브리지 인프라스트럭처",
  "WBS": "웹스터 파이낸셜",
  "WBS-P-F": "웹스터 파이낸셜",
  "WBS-P-G": "웹스터 파이낸셜",
  "WBTN": "웹툰 엔터테인먼트",
  "WBUY": "위바이 글로벌",
  "WBX": "월박스",
  "WCC": "웨스코 인터내셔널",
  "WCN": "웨이스트 커넥션스",
  "WCT": "웰체인지 홀딩스",
  "WD": "워커 & 던롭",
  "WDAY": "워크데이",
  "WDC": "웨스턴 디지털",
  "WDFC": "Wd-40",
  "WDH": "워터드랍 ADR",
  "WDI": "Western Asset Diversified Income Fund",
  "WDS": "우드사이드 에너지 그룹 ADR",
  "WEA": "Western Asset Premier Bond Closed Fund",
  "WEAV": "위브 커뮤니케이션스",
  "WEC": "WEC 에너지 그룹",
  "WELL": "웰타워",
  "WEN": "웬디스",
  "WENC": "웨스트 엔클레이브 머저",
  "WENN": "웬 애퀴지션",
  "WERN": "웨너 엔터프라이즈",
  "WES": "Western Midstream Partners, LP",
  "WEST": "웨스트락 커피",
  "WETH": "위터치 테크놀로지",
  "WETO": "위투어 로보틱스",
  "WEX": "웩스",
  "WEYS": "웨이코 그룹",
  "WF": "우리금융지주 ADR",
  "WFC": "웰스파고",
  "WFC-P-A": "웰스파고",
  "WFC-P-C": "웰스파고",
  "WFC-P-D": "웰스파고",
  "WFC-P-L": "웰스파고",
  "WFC-P-Y": "웰스파고",
  "WFC-P-Z": "웰스파고",
  "WFCF": "웨어 푸드 컴스 프롬",
  "WFF": "WF 홀딩",
  "WFG": "웨스트 프레이저 팀버",
  "WFRD": "웨더포드 인터네셔널",
  "WGO": "위니바고 인더스트리",
  "WGS": "진디엑스 홀딩스",
  "WH": "윈덤 호텔 & 리조트",
  "WHD": "캑터스",
  "WHF": "화이트호스 파이낸스",
  "WHG": "웨스트우드 홀딩스 그룹",
  "WHK": "화이트호크 미네랄스",
  "WHLR": "휠러 리얼 에스테이트 인베스트",
  "WHLRD": "휠러 리얼 에스테이트 인베스트 우선주 시리즈 D 8.75%",
  "WHLRP": "휠러 리얼 에스테이트 인베스트 우선주 시리즈 B 9.000%",
  "WHR": "월풀",
  "WHR-P-A": "월풀",
  "WHWK": "화이트호크 테라퓨틱스",
  "WIA": "Western Asset Inflation Linked Income Closed End Fund",
  "WILC": "G 윌리 푸드 인터내셔널",
  "WIMI": "와이마이 홀로그램 클라우드",
  "WINA": "윈마크",
  "WING": "윙스톱",
  "WIT": "위프로 ADR",
  "WIW": "Western Asset Inflation Linked Opportunities Income Closed End Fund",
  "WIX": "윅스닷컴",
  "WK": "워키바",
  "WKC": "월드 키넥트",
  "WKEY": "와이즈키 인터내셔널 홀딩 AG ADR",
  "WKHS": "워크호스 그룹",
  "WKSP": "워크스포트",
  "WLDN": "윌댄 그룹",
  "WLDS": "웨어러블 디바이시스",
  "WLFC": "윌리스 리스 파이낸스",
  "WLII": "윌로우 레인 애퀴지션 II",
  "WLK": "웨스트레이크",
  "WLKP": "Westlake Chemical Partners Lp",
  "WLTH": "웰스프론트",
  "WLY": "존 윌리 앤 손 Class A",
  "WLYB": "존 윌리 앤 손 Class B",
  "WM": "웨이스트 매니지먼트",
  "WMB": "윌리엄스 컴퍼니즈",
  "WMG": "워너 뮤직 그룹",
  "WMK": "웨이스 마켓",
  "WMS": "어드밴스트 드레이니지 시스템즈",
  "WMT": "월마트",
  "WNC": "와바시 내셔널",
  "WNEB": "웨스턴 뉴 잉글랜드 뱅코프",
  "WNW": "메이우 테크놀로지",
  "WOK": "워크 메디컬 테크놀로지 그룹",
  "WOLF": "울프스피드",
  "WOOF": "펫코 헬스 앤 웰니스 컴퍼니",
  "WOR": "워딩턴 엔터프라이즈",
  "WPAC": "화이트 펄 애퀴지션",
  "WPC": "W.p. 케어리",
  "WPM": "휘턴 프레셔스 메탈스",
  "WPP": "Wpp",
  "WPRT": "웨스트포트 퓨얼 시스템즈",
  "WRAP": "랩 테크놀로지스",
  "WRB": "W. R. 버클리",
  "WRBY": "와비 파커",
  "WRD": "위라이드 ADR",
  "WRLD": "월드 억셉턴스",
  "WRN": "웨스턴 코퍼 & 골드",
  "WS": "워딩턴 스틸",
  "WSBC": "웨스뱅코",
  "WSBCO": "웨스뱅코 우선주 Series B 7.375%",
  "WSBF": "워터스톤 파이낸셜",
  "WSBK": "윈체스터 뱅코프",
  "WSC": "윌스콧 홀딩스",
  "WSE": "와이즈 그룹",
  "WSFS": "WSFS 파이낸셜",
  "WSHP": "위샵 홀딩스",
  "WSM": "윌리엄 소노마",
  "WSO": "와츠코",
  "WSO-B": "Watsco, Inc. Class B",
  "WST": "웨스트 파마슈티컬 서비시즈",
  "WSTN": "웨스틴 애퀴지션",
  "WT": "위즈덤트리",
  "WTBA": "웨스트 뱅코프",
  "WTF": "와튼 파이낸셜",
  "WTFC": "윈트러스트 파이낸셜",
  "WTFCN": "윈트러스트 파이낸셜 우선주 7.875%",
  "WTG": "윈터그린 애퀴지션",
  "WTI": "W&T 오프쇼어",
  "WTM": "화이트 마운틴스 인슈어런스 그룹",
  "WTRG": "에센셜 유틸리티스",
  "WTS": "와츠 워터 테크놀로지스",
  "WTTR": "셀렉트 에너지 서비스",
  "WTW": "윌리스 타워스 왓슨",
  "WU": "웨스턴유니온",
  "WULF": "테라울프",
  "WVE": "웨이브 라이프 사이언스",
  "WVVI": "윌라멧 밸리 빈야즈",
  "WVVIP": "윌래메트 밸리 바인야드 우선주 시리즈 A",
  "WW": "WW 인터내셔널",
  "WWD": "우드워드",
  "WWR": "웨스트워터 리소시스",
  "WWW": "울버린 월드 와이드",
  "WXM": "WF 인터내셔널",
  "WY": "와이어하우저",
  "WYFI": "화이트파이버",
  "WYHG": "윙입푸드홀딩스그룹 ADR",
  "WYNN": "윈 리조트",
  "WYY": "와이드포인트",
  "XAIR": "비욘드 에어",
  "XBIO": "제네틱 바이오사이언스",
  "XBIT": "엑스바이오텍",
  "XBP": "XBP 글로벌 홀딩스",
  "XCBE": "X3 애퀴지션",
  "XCH": "Xchg",
  "XCUR": "엑시큐어",
  "XE": "X-에너지",
  "XEL": "엑셀 에너지",
  "XELB": "엑셀 브랜즈",
  "XENE": "제논 파마슈티컬",
  "XERS": "제리스 바이오파마 홀딩스",
  "XFLH": "XFLH 캐피탈",
  "XFLT": "XAI Floating RateAlternative",
  "XFOR": "X4 파마슈티컬",
  "XGN": "엑사젠",
  "XHG": "X체인지 TEC.INC ADR",
  "XHLD": "TEN 홀딩스",
  "XHR": "제니아 호텔 & 리조트",
  "XIFR": "XPLR 인프라스트럭처",
  "XLO": "자일리오 테라퓨틱스",
  "XMAX": "Xmax",
  "XMTR": "조메트리",
  "XNCR": "젠코",
  "XNDU": "자나두 퀀텀 테크놀로지스",
  "XNET": "쉰레이 ADR",
  "XOM": "엑슨모빌 홀딩스",
  "XOS": "엑소스",
  "XP": "엑스피",
  "XPEL": "엑스펠",
  "XPER": "엑스페리",
  "XPEV": "샤오펑 ADR",
  "XPL": "솔리타리오 리소시스",
  "XPO": "엑스포",
  "XPOF": "엑스포넨셜 피트니스",
  "XPON": "엑스피언360",
  "XPRO": "엑스프로",
  "XRAY": "덴츠플라이 시로나",
  "XRN": "카이론 리얼 에스테이트",
  "XRN-P-A": "카이론 리얼 에스테이트",
  "XRN-P-B": "카이론 리얼 에스테이트",
  "XRPN": "아마다 애퀴지션 2",
  "XRTX": "졸트 테라퓨틱스",
  "XRX": "제록스 홀딩스",
  "XSLL": "엑솔라 스팩 1",
  "XTIA": "XTI 에어로스페이스",
  "XTLB": "X T L 바이오파마슈티컬 ADR",
  "XTNT": "엑스턴트 메디컬 홀딩스",
  "XWEL": "X웰",
  "XXI": "트웬티 원 캐피털",
  "XXII": "22세기 그룹",
  "XYF": "엑스 파이낸셜 ADR",
  "XYL": "자일럼",
  "XYZ": "블록",
  "XZO": "엑제오 그룹",
  "YAAS": "요신 테크놀로지",
  "YALA": "얄라 그룹 ADR",
  "YARW": "야로우 바이오사이언스",
  "YB": "위안바오 ADR",
  "YCBD": "씨비디엠디",
  "YCY": "AA 미션 애퀴지션 II",
  "YDDL": "원 앤 원 그린 테크놀로지스",
  "YDES": "YD 바이오",
  "YDKG": "위에다 디지털 홀딩",
  "YELP": "옐프",
  "YETI": "예티 홀딩스",
  "YEXT": "이엑스트",
  "YHC": "LQR 하우스",
  "YHGJ": "윤홍 그린 CTI",
  "YHNA": "YHN 애퀴지션 I",
  "YI": "111 ADR",
  "YIBO": "플래닛 이미지 인터내셔널",
  "YICC": "요크빌 인터내셔널 캐피털",
  "YJ": "윤지 ADR",
  "YMAT": "J스타 홀딩",
  "YMM": "풀 트럭 얼라이언스 ADR",
  "YMT": "이무톈 ADR",
  "YORW": "요크 워터",
  "YOU": "클리어 시큐어",
  "YOUL": "유라이프 그룹 ADR",
  "YPF": "YPF Sociedad Anonima",
  "YQ": "17 에듀케이션 앤 테크놀로지 ADR",
  "YRD": "이렌 디지털 ADR",
  "YSG": "얏센 홀딩 ADR",
  "YSS": "요크 스페이스 시스템즈",
  "YSWY": "예스웨이",
  "YSXT": "YSX 테크",
  "YTRA": "야트라 온라인",
  "YUM": "염 브랜즈",
  "YUMC": "염 차이나 홀딩스",
  "YXT": "YXT.컴 그룹 홀딩 ADR",
  "YYAI": "AiRWA",
  "YYGH": "YY 그룹 홀딩",
  "Z": "질로우 그룹 Class C",
  "ZBAO": "즈바오 테크놀로지",
  "ZBH": "짐머 바이오멧 홀딩스",
  "ZBIO": "제나스 바이오파마",
  "ZBRA": "지브라 테크놀로지스",
  "ZCMD": "중차오",
  "ZD": "지프 데이비스",
  "ZDAI": "다이렉트부킹 테크놀로지",
  "ZDGE": "젯지",
  "ZENA": "제나테크",
  "ZEO": "제오 에너지",
  "ZEPP": "젭 헬스 ADR",
  "ZETA": "제타 글로벌 홀딩스",
  "ZG": "질로우 그룹 Class A",
  "ZGN": "에르메네질도 제냐",
  "ZH": "즈후 ADR",
  "ZIM": "ZIM 인티그레이티드 시핑 서비시스",
  "ZION": "자이언스 뱅코프",
  "ZIONP": "자이언스 뱅코프 우선주 시리즈 A",
  "ZIP": "집리크루터",
  "ZJK": "ZJK 인터스트리얼",
  "ZJYL": "진 메디컬 인터내셔널",
  "ZKH": "ZKH 그룹 ADR",
  "ZKIN": "ZK 인터내셔널",
  "ZKP": "라파예트 디지털 애퀴지션 I",
  "ZLAB": "자이 랩 ADR",
  "ZM": "줌 커뮤니케이션스",
  "ZNB": "제타 네트워크 그룹",
  "ZNTL": "젠테일스 파마슈티컬",
  "ZONE": "클린코어 솔루션스",
  "ZOOZ": "주즈 스트래티지",
  "ZS": "지스케일러",
  "ZSQR": "Z 스퀘어드",
  "ZSTK": "제로스택",
  "ZTEK": "젠텍",
  "ZTG": "젠타 그룹",
  "ZTO": "ZTO 익스프레스 (케이먼) ADR",
  "ZTR": "Virtus Total Return Fund",
  "ZTS": "조에티스",
  "ZUMZ": "주미에즈",
  "ZURA": "주라 바이오",
  "ZVIA": "제비아",
  "ZVRA": "제브러 테라퓨틱스",
  "ZWS": "전 엘케이 워터 솔루션스",
  "ZYBT": "정업 바이오테크놀로지 홀딩",
  "ZYME": "자임웍스",
};

export const US_TICKER_TO_EXCHANGE: Record<string, string> = {
  "A": "NYSE",
  "AA": "NYSE",
  "AACB": "NASDAQ",
  "AACG": "NASDAQ",
  "AACI": "NASDAQ",
  "AACO": "NASDAQ",
  "AACP": "NASDAQ",
  "AADX": "NYSE",
  "AAL": "NASDAQ",
  "AAME": "NASDAQ",
  "AAMI": "NYSE",
  "AAOI": "NASDAQ",
  "AAON": "NASDAQ",
  "AAP": "NYSE",
  "AAPG": "NASDAQ",
  "AAPL": "NASDAQ",
  "AARD": "NASDAQ",
  "AAT": "NYSE",
  "AAUC": "NYSE",
  "AB": "NYSE",
  "ABAT": "NASDAQ",
  "ABBV": "NYSE",
  "ABCB": "NYSE",
  "ABCL": "NASDAQ",
  "ABEO": "NASDAQ",
  "ABEV": "NYSE",
  "ABG": "NYSE",
  "ABLV": "NASDAQ",
  "ABM": "NYSE",
  "ABNB": "NASDAQ",
  "ABOS": "NASDAQ",
  "ABR": "NYSE",
  "ABR-P-D": "NYSE",
  "ABR-P-E": "NYSE",
  "ABR-P-F": "NYSE",
  "ABSI": "NASDAQ",
  "ABT": "NYSE",
  "ABTC": "NASDAQ",
  "ABTS": "NASDAQ",
  "ABUS": "NASDAQ",
  "ABVC": "NASDAQ",
  "ABVX": "NASDAQ",
  "ABX": "NYSE",
  "ACA": "NYSE",
  "ACAA": "NASDAQ",
  "ACAD": "NASDAQ",
  "ACB": "NASDAQ",
  "ACCL": "NASDAQ",
  "ACCO": "NYSE",
  "ACCS": "NYSE",
  "ACDC": "NASDAQ",
  "ACEL": "NYSE",
  "ACET": "NASDAQ",
  "ACFN": "NASDAQ",
  "ACGC": "NASDAQ",
  "ACGL": "NASDAQ",
  "ACGLN": "NASDAQ",
  "ACGLO": "NASDAQ",
  "ACH": "NYSE",
  "ACHC": "NASDAQ",
  "ACHR": "NYSE",
  "ACHV": "NASDAQ",
  "ACI": "NYSE",
  "ACIC": "NASDAQ",
  "ACIU": "NASDAQ",
  "ACIW": "NASDAQ",
  "ACLS": "NASDAQ",
  "ACM": "NYSE",
  "ACMR": "NASDAQ",
  "ACN": "NYSE",
  "ACNB": "NASDAQ",
  "ACNT": "NASDAQ",
  "ACOG": "NASDAQ",
  "ACON": "NASDAQ",
  "ACP": "NYSE",
  "ACP-P-A": "NYSE",
  "ACR": "NYSE",
  "ACR-P-C": "NYSE",
  "ACR-P-D": "NYSE",
  "ACRE": "NYSE",
  "ACRS": "NASDAQ",
  "ACRV": "NASDAQ",
  "ACT": "NASDAQ",
  "ACTG": "NASDAQ",
  "ACTU": "NASDAQ",
  "ACU": "NYSE",
  "ACV": "NYSE",
  "ACVA": "NYSE",
  "ACXP": "NASDAQ",
  "AD": "NYSE",
  "ADAC": "NASDAQ",
  "ADAG": "NASDAQ",
  "ADAM": "NASDAQ",
  "ADAML": "NASDAQ",
  "ADAMM": "NASDAQ",
  "ADAMN": "NASDAQ",
  "ADAMZ": "NASDAQ",
  "ADBE": "NASDAQ",
  "ADC": "NYSE",
  "ADC-P-A": "NYSE",
  "ADCT": "NYSE",
  "ADEA": "NASDAQ",
  "ADGM": "NASDAQ",
  "ADI": "NASDAQ",
  "ADIG": "NYSE",
  "ADIL": "NASDAQ",
  "ADM": "NYSE",
  "ADMA": "NASDAQ",
  "ADNT": "NYSE",
  "ADP": "NASDAQ",
  "ADPT": "NASDAQ",
  "ADSE": "NASDAQ",
  "ADSK": "NASDAQ",
  "ADT": "NYSE",
  "ADTN": "NASDAQ",
  "ADUR": "NASDAQ",
  "ADUS": "NASDAQ",
  "ADV": "NASDAQ",
  "ADVB": "NASDAQ",
  "ADX": "NYSE",
  "ADXN": "NASDAQ",
  "AEAQ": "NASDAQ",
  "AEBI": "NASDAQ",
  "AEC": "NASDAQ",
  "AEE": "NYSE",
  "AEF": "NYSE",
  "AEG": "NYSE",
  "AEHL": "NASDAQ",
  "AEHR": "NASDAQ",
  "AEI": "NASDAQ",
  "AEIS": "NASDAQ",
  "AEM": "NYSE",
  "AEMD": "NASDAQ",
  "AENT": "NASDAQ",
  "AEO": "NYSE",
  "AEON": "NYSE",
  "AEP": "NASDAQ",
  "AER": "NYSE",
  "AERO": "NYSE",
  "AERT": "NASDAQ",
  "AES": "NYSE",
  "AESI": "NYSE",
  "AESP": "NASDAQ",
  "AEVA": "NASDAQ",
  "AEXA": "NYSE",
  "AEYE": "NASDAQ",
  "AFB": "NYSE",
  "AFCG": "NASDAQ",
  "AFG": "NYSE",
  "AFJK": "NASDAQ",
  "AFL": "NYSE",
  "AFRI": "NASDAQ",
  "AFRM": "NASDAQ",
  "AFYA": "NASDAQ",
  "AG": "NYSE",
  "AGBK": "NYSE",
  "AGCC": "NASDAQ",
  "AGCO": "NYSE",
  "AGD": "NYSE",
  "AGEN": "NASDAQ",
  "AGI": "NYSE",
  "AGIG": "NYSE",
  "AGIO": "NASDAQ",
  "AGL": "NYSE",
  "AGM": "NYSE",
  "AGM-A": "NYSE",
  "AGM-P-D": "NYSE",
  "AGM-P-E": "NYSE",
  "AGM-P-F": "NYSE",
  "AGM-P-G": "NYSE",
  "AGM-P-H": "NYSE",
  "AGM-P-I": "NYSE",
  "AGMB": "NASDAQ",
  "AGMH": "NASDAQ",
  "AGNC": "NASDAQ",
  "AGNCL": "NASDAQ",
  "AGNCM": "NASDAQ",
  "AGNCN": "NASDAQ",
  "AGNCO": "NASDAQ",
  "AGNCP": "NASDAQ",
  "AGNCZ": "NASDAQ",
  "AGNT": "NASDAQ",
  "AGO": "NYSE",
  "AGPU": "NASDAQ",
  "AGRO": "NYSE",
  "AGRZ": "NASDAQ",
  "AGX": "NYSE",
  "AGYS": "NASDAQ",
  "AHCO": "NASDAQ",
  "AHG": "NASDAQ",
  "AHL-P-D": "NYSE",
  "AHL-P-E": "NYSE",
  "AHL-P-F": "NYSE",
  "AHMA": "NASDAQ",
  "AHR": "NYSE",
  "AHRT": "NYSE",
  "AHRT-P-A": "NYSE",
  "AHT": "NYSE",
  "AHT-P-D": "NYSE",
  "AHT-P-F": "NYSE",
  "AHT-P-G": "NYSE",
  "AHT-P-H": "NYSE",
  "AHT-P-I": "NYSE",
  "AI": "NYSE",
  "AIAI": "NASDAQ",
  "AIB": "NYSE",
  "AIBZ": "NASDAQ",
  "AIDX": "NASDAQ",
  "AIFA": "NASDAQ",
  "AIFC": "NASDAQ",
  "AIFF": "NASDAQ",
  "AIFU": "NASDAQ",
  "AIG": "NYSE",
  "AIHS": "NASDAQ",
  "AII": "NYSE",
  "AIIA": "NYSE",
  "AIIO": "NASDAQ",
  "AIIR": "NASDAQ",
  "AIM": "NYSE",
  "AIMD": "NASDAQ",
  "AIN": "NYSE",
  "AIO": "NYSE",
  "AIOS": "NASDAQ",
  "AIOT": "NASDAQ",
  "AIP": "NASDAQ",
  "AIR": "NYSE",
  "AIRE": "NASDAQ",
  "AIRG": "NASDAQ",
  "AIRI": "NYSE",
  "AIRJ": "NASDAQ",
  "AIRO": "NASDAQ",
  "AIRS": "NASDAQ",
  "AIRT": "NASDAQ",
  "AIRTP": "NASDAQ",
  "AISP": "NASDAQ",
  "AIT": "NYSE",
  "AIV": "NYSE",
  "AIXC": "NASDAQ",
  "AIXI": "NASDAQ",
  "AIZ": "NYSE",
  "AJG": "NYSE",
  "AKA": "NYSE",
  "AKAM": "NASDAQ",
  "AKAN": "NASDAQ",
  "AKBA": "NASDAQ",
  "AKO-A": "NYSE",
  "AKO-B": "NYSE",
  "AKR": "NYSE",
  "AKTS": "NASDAQ",
  "AKTX": "NASDAQ",
  "ALAB": "NASDAQ",
  "ALAR": "NASDAQ",
  "ALB": "NYSE",
  "ALB-P-A": "NYSE",
  "ALC": "NYSE",
  "ALCO": "NASDAQ",
  "ALDF": "NASDAQ",
  "ALDX": "NASDAQ",
  "ALEC": "NASDAQ",
  "ALF": "NASDAQ",
  "ALG": "NYSE",
  "ALGM": "NASDAQ",
  "ALGN": "NASDAQ",
  "ALGS": "NASDAQ",
  "ALGT": "NASDAQ",
  "ALH": "NYSE",
  "ALHC": "NASDAQ",
  "ALIS": "NASDAQ",
  "ALIT": "NYSE",
  "ALK": "NYSE",
  "ALKS": "NASDAQ",
  "ALKT": "NASDAQ",
  "ALL": "NYSE",
  "ALL-P-H": "NYSE",
  "ALL-P-I": "NYSE",
  "ALL-P-J": "NYSE",
  "ALLE": "NYSE",
  "ALLO": "NASDAQ",
  "ALLR": "NASDAQ",
  "ALLT": "NASDAQ",
  "ALLY": "NYSE",
  "ALM": "NASDAQ",
  "ALMR": "NASDAQ",
  "ALMS": "NASDAQ",
  "ALMU": "NASDAQ",
  "ALNT": "NASDAQ",
  "ALNY": "NASDAQ",
  "ALOT": "NASDAQ",
  "ALOV": "NASDAQ",
  "ALOY": "NASDAQ",
  "ALP": "NASDAQ",
  "ALPS": "NASDAQ",
  "ALPX": "NASDAQ",
  "ALRM": "NASDAQ",
  "ALRS": "NASDAQ",
  "ALSN": "NYSE",
  "ALT": "NASDAQ",
  "ALTG": "NYSE",
  "ALTG-P-A": "NYSE",
  "ALTI": "NASDAQ",
  "ALTO": "NASDAQ",
  "ALUB": "NYSE",
  "ALV": "NYSE",
  "ALVO": "NASDAQ",
  "ALX": "NYSE",
  "ALXO": "NASDAQ",
  "ALZN": "NASDAQ",
  "AM": "NYSE",
  "AMAL": "NASDAQ",
  "AMAN": "NASDAQ",
  "AMAT": "NASDAQ",
  "AMBA": "NASDAQ",
  "AMBO": "NYSE",
  "AMBP": "NYSE",
  "AMBQ": "NYSE",
  "AMBR": "NASDAQ",
  "AMC": "NYSE",
  "AMCI": "NASDAQ",
  "AMCR": "NYSE",
  "AMCX": "NASDAQ",
  "AMD": "NASDAQ",
  "AME": "NYSE",
  "AMG": "NYSE",
  "AMGN": "NASDAQ",
  "AMH": "NYSE",
  "AMH-P-G": "NYSE",
  "AMH-P-H": "NYSE",
  "AMIX": "NASDAQ",
  "AMKR": "NASDAQ",
  "AMLX": "NASDAQ",
  "AMN": "NYSE",
  "AMOD": "NASDAQ",
  "AMP": "NYSE",
  "AMPG": "NASDAQ",
  "AMPH": "NASDAQ",
  "AMPL": "NASDAQ",
  "AMPX": "NYSE",
  "AMPY": "NYSE",
  "AMR": "NYSE",
  "AMRC": "NYSE",
  "AMRN": "NASDAQ",
  "AMRX": "NASDAQ",
  "AMRZ": "NYSE",
  "AMS": "NYSE",
  "AMSC": "NASDAQ",
  "AMSF": "NASDAQ",
  "AMSS": "NASDAQ",
  "AMST": "NASDAQ",
  "AMT": "NYSE",
  "AMTB": "NYSE",
  "AMTD": "NYSE",
  "AMTM": "NYSE",
  "AMTX": "NASDAQ",
  "AMWL": "NYSE",
  "AMX": "NYSE",
  "AMZE": "NYSE",
  "AMZN": "NASDAQ",
  "AN": "NYSE",
  "ANAB": "NASDAQ",
  "ANDE": "NASDAQ",
  "ANDG": "NYSE",
  "ANET": "NYSE",
  "ANF": "NYSE",
  "ANG-P-D": "NYSE",
  "ANGH": "NASDAQ",
  "ANGI": "NASDAQ",
  "ANGO": "NASDAQ",
  "ANGX": "NYSE",
  "ANIK": "NASDAQ",
  "ANIP": "NASDAQ",
  "ANIX": "NASDAQ",
  "ANL": "NASDAQ",
  "ANNA": "NASDAQ",
  "ANNX": "NASDAQ",
  "ANPA": "NASDAQ",
  "ANRO": "NYSE",
  "ANSC": "NASDAQ",
  "ANTA": "NASDAQ",
  "ANTX": "NASDAQ",
  "ANVS": "NYSE",
  "ANY": "NASDAQ",
  "AOD": "NYSE",
  "AOMR": "NYSE",
  "AON": "NYSE",
  "AORT": "NYSE",
  "AOS": "NYSE",
  "AOSL": "NASDAQ",
  "AOUT": "NASDAQ",
  "AP": "NYSE",
  "APA": "NASDAQ",
  "APAC": "NASDAQ",
  "APAM": "NYSE",
  "APC": "NASDAQ",
  "APD": "NYSE",
  "APEI": "NASDAQ",
  "APG": "NYSE",
  "APGE": "NASDAQ",
  "APH": "NYSE",
  "API": "NASDAQ",
  "APLD": "NASDAQ",
  "APLE": "NYSE",
  "APLM": "NASDAQ",
  "APMC": "NASDAQ",
  "APMD": "NASDAQ",
  "APO": "NYSE",
  "APOG": "NASDAQ",
  "APP": "NASDAQ",
  "APPF": "NASDAQ",
  "APPN": "NASDAQ",
  "APPS": "NASDAQ",
  "APRE": "NASDAQ",
  "APT": "NYSE",
  "APTV": "NYSE",
  "APUR": "NASDAQ",
  "APUS": "NYSE",
  "APVO": "NASDAQ",
  "APWC": "NASDAQ",
  "APXT": "NASDAQ",
  "APYX": "NASDAQ",
  "AQB": "NASDAQ",
  "AQMS": "NASDAQ",
  "AQN": "NYSE",
  "AQST": "NASDAQ",
  "AR": "NYSE",
  "ARAI": "NASDAQ",
  "ARAY": "NASDAQ",
  "ARBB": "NASDAQ",
  "ARBE": "NASDAQ",
  "ARBK": "NASDAQ",
  "ARCB": "NASDAQ",
  "ARCC": "NASDAQ",
  "ARCI": "NASDAQ",
  "ARCL": "NASDAQ",
  "ARCO": "NYSE",
  "ARCT": "NASDAQ",
  "ARDC": "NYSE",
  "ARDT": "NYSE",
  "ARDX": "NASDAQ",
  "ARE": "NYSE",
  "AREC": "NASDAQ",
  "AREN": "NYSE",
  "ARES": "NYSE",
  "ARES-P-B": "NYSE",
  "ARGX": "NASDAQ",
  "ARHS": "NASDAQ",
  "ARI": "NYSE",
  "ARIS": "NYSE",
  "ARKO": "NASDAQ",
  "ARKR": "NASDAQ",
  "ARL": "NYSE",
  "ARLO": "NYSE",
  "ARLP": "NASDAQ",
  "ARM": "NASDAQ",
  "ARMK": "NYSE",
  "ARMP": "NYSE",
  "AROC": "NYSE",
  "AROW": "NASDAQ",
  "ARQ": "NASDAQ",
  "ARQQ": "NASDAQ",
  "ARQT": "NASDAQ",
  "ARR": "NYSE",
  "ARR-P-C": "NYSE",
  "ARRY": "NASDAQ",
  "ARTC": "NASDAQ",
  "ARTL": "NASDAQ",
  "ARTNA": "NASDAQ",
  "ARTV": "NASDAQ",
  "ARTW": "NASDAQ",
  "ARVN": "NASDAQ",
  "ARW": "NYSE",
  "ARWR": "NASDAQ",
  "ARX": "NYSE",
  "ARXS": "NASDAQ",
  "AS": "NYSE",
  "ASA": "NYSE",
  "ASAN": "NYSE",
  "ASB": "NYSE",
  "ASB-P-E": "NYSE",
  "ASB-P-F": "NYSE",
  "ASBP": "NASDAQ",
  "ASC": "NYSE",
  "ASG": "NYSE",
  "ASGI": "NYSE",
  "ASH": "NYSE",
  "ASIC": "NYSE",
  "ASIX": "NYSE",
  "ASLE": "NASDAQ",
  "ASM": "NYSE",
  "ASMB": "NASDAQ",
  "ASML": "NASDAQ",
  "ASND": "NASDAQ",
  "ASO": "NASDAQ",
  "ASPC": "NASDAQ",
  "ASPI": "NASDAQ",
  "ASPN": "NYSE",
  "ASPS": "NASDAQ",
  "ASR": "NYSE",
  "ASRV": "NASDAQ",
  "ASST": "NASDAQ",
  "ASTC": "NASDAQ",
  "ASTE": "NASDAQ",
  "ASTH": "NASDAQ",
  "ASTI": "NASDAQ",
  "ASTL": "NASDAQ",
  "ASTS": "NASDAQ",
  "ASUR": "NASDAQ",
  "ASX": "NYSE",
  "ASYS": "NASDAQ",
  "ATAI": "NASDAQ",
  "ATAT": "NASDAQ",
  "ATCH": "NYSE",
  "ATCX": "NASDAQ",
  "ATEC": "NASDAQ",
  "ATEN": "NYSE",
  "ATER": "NASDAQ",
  "ATEX": "NASDAQ",
  "ATGL": "NASDAQ",
  "ATH-P-A": "NYSE",
  "ATH-P-B": "NYSE",
  "ATH-P-D": "NYSE",
  "ATH-P-E": "NYSE",
  "ATHE": "NASDAQ",
  "ATHM": "NYSE",
  "ATHR": "NASDAQ",
  "ATI": "NYSE",
  "ATII": "NASDAQ",
  "ATKR": "NYSE",
  "ATLC": "NASDAQ",
  "ATLCP": "NASDAQ",
  "ATLO": "NASDAQ",
  "ATLX": "NASDAQ",
  "ATMU": "NYSE",
  "ATNI": "NASDAQ",
  "ATNM": "NYSE",
  "ATO": "NYSE",
  "ATOM": "NASDAQ",
  "ATOS": "NASDAQ",
  "ATPC": "NASDAQ",
  "ATR": "NYSE",
  "ATRA": "NASDAQ",
  "ATRC": "NASDAQ",
  "ATRO": "NASDAQ",
  "ATS": "NYSE",
  "ATTO": "NASDAQ",
  "ATXG": "NASDAQ",
  "ATYR": "NASDAQ",
  "AU": "NYSE",
  "AUB": "NYSE",
  "AUB-P-A": "NYSE",
  "AUBN": "NASDAQ",
  "AUC": "NASDAQ",
  "AUDC": "NASDAQ",
  "AUGO": "NASDAQ",
  "AUID": "NASDAQ",
  "AUNA": "NYSE",
  "AUPH": "NASDAQ",
  "AUR": "NASDAQ",
  "AURA": "NASDAQ",
  "AURE": "NASDAQ",
  "AUST": "NYSE",
  "AUTL": "NASDAQ",
  "AUUD": "NASDAQ",
  "AVA": "NYSE",
  "AVAH": "NASDAQ",
  "AVAL": "NYSE",
  "AVAT": "NASDAQ",
  "AVAV": "NASDAQ",
  "AVB": "NYSE",
  "AVBC": "NYSE",
  "AVBH": "NASDAQ",
  "AVBP": "NASDAQ",
  "AVD": "NYSE",
  "AVEX": "NYSE",
  "AVGO": "NASDAQ",
  "AVIR": "NASDAQ",
  "AVK": "NYSE",
  "AVLN": "NASDAQ",
  "AVNT": "NYSE",
  "AVNW": "NASDAQ",
  "AVO": "NASDAQ",
  "AVPT": "NASDAQ",
  "AVR": "NASDAQ",
  "AVT": "NASDAQ",
  "AVTR": "NYSE",
  "AVTX": "NASDAQ",
  "AVX": "NASDAQ",
  "AVXL": "NASDAQ",
  "AVY": "NYSE",
  "AWF": "NYSE",
  "AWI": "NYSE",
  "AWK": "NYSE",
  "AWP": "NYSE",
  "AWR": "NYSE",
  "AWRE": "NASDAQ",
  "AWX": "NYSE",
  "AX": "NYSE",
  "AXG": "NASDAQ",
  "AXGN": "NASDAQ",
  "AXIL": "NYSE",
  "AXIN": "NASDAQ",
  "AXON": "NASDAQ",
  "AXP": "NYSE",
  "AXR": "NYSE",
  "AXS": "NYSE",
  "AXS-P-E": "NYSE",
  "AXSM": "NASDAQ",
  "AXTA": "NYSE",
  "AXTI": "NASDAQ",
  "AYA": "NASDAQ",
  "AYI": "NYSE",
  "AYTU": "NASDAQ",
  "AZ": "NASDAQ",
  "AZI": "NASDAQ",
  "AZIO": "NASDAQ",
  "AZN": "NYSE",
  "AZO": "NYSE",
  "AZTA": "NASDAQ",
  "AZTR": "NYSE",
  "AZUL": "NYSE",
  "AZZ": "NYSE",
  "B": "NYSE",
  "BA": "NYSE",
  "BA-P-A": "NYSE",
  "BABA": "NYSE",
  "BAC": "NYSE",
  "BAC-P-B": "NYSE",
  "BAC-P-E": "NYSE",
  "BAC-P-K": "NYSE",
  "BAC-P-L": "NYSE",
  "BAC-P-M": "NYSE",
  "BAC-P-N": "NYSE",
  "BAC-P-O": "NYSE",
  "BAC-P-P": "NYSE",
  "BAC-P-Q": "NYSE",
  "BAC-P-S": "NYSE",
  "BACC": "NASDAQ",
  "BAER": "NASDAQ",
  "BAFN": "NASDAQ",
  "BAH": "NYSE",
  "BAK": "NYSE",
  "BALL": "NYSE",
  "BALY": "NYSE",
  "BAM": "NYSE",
  "BANC": "NYSE",
  "BANC-P-F": "NYSE",
  "BAND": "NASDAQ",
  "BANF": "NASDAQ",
  "BANFP": "NASDAQ",
  "BANL": "NASDAQ",
  "BANR": "NASDAQ",
  "BANX": "NASDAQ",
  "BAOS": "NASDAQ",
  "BAP": "NYSE",
  "BARK": "NYSE",
  "BATL": "NYSE",
  "BATRA": "NASDAQ",
  "BATRK": "NASDAQ",
  "BAX": "NYSE",
  "BB": "NYSE",
  "BBAI": "NYSE",
  "BBAR": "NYSE",
  "BBBY": "NYSE",
  "BBCP": "NASDAQ",
  "BBCQ": "NASDAQ",
  "BBD": "NYSE",
  "BBDC": "NYSE",
  "BBDO": "NYSE",
  "BBGI": "NASDAQ",
  "BBIO": "NASDAQ",
  "BBLG": "NASDAQ",
  "BBN": "NYSE",
  "BBNX": "NASDAQ",
  "BBOT": "NASDAQ",
  "BBSI": "NASDAQ",
  "BBT": "NYSE",
  "BBUC": "NYSE",
  "BBVA": "NYSE",
  "BBW": "NYSE",
  "BBWI": "NYSE",
  "BBY": "NYSE",
  "BC": "NYSE",
  "BCAB": "NASDAQ",
  "BCAL": "NASDAQ",
  "BCAR": "NASDAQ",
  "BCAT": "NYSE",
  "BCAX": "NASDAQ",
  "BCBP": "NASDAQ",
  "BCC": "NYSE",
  "BCCQ": "NASDAQ",
  "BCDA": "NASDAQ",
  "BCE": "NYSE",
  "BCG": "NASDAQ",
  "BCH": "NYSE",
  "BCHT": "NYSE",
  "BCIC": "NASDAQ",
  "BCML": "NASDAQ",
  "BCO": "NYSE",
  "BCPC": "NASDAQ",
  "BCRX": "NASDAQ",
  "BCS": "NYSE",
  "BCSF": "NYSE",
  "BCSS": "NYSE",
  "BCTX": "NASDAQ",
  "BCV": "NYSE",
  "BCV-P-A": "NYSE",
  "BCX": "NYSE",
  "BCYC": "NASDAQ",
  "BDC": "NYSE",
  "BDCI": "NASDAQ",
  "BDJ": "NYSE",
  "BDL": "NYSE",
  "BDMD": "NASDAQ",
  "BDN": "NYSE",
  "BDRX": "NASDAQ",
  "BDSX": "NASDAQ",
  "BDTX": "NASDAQ",
  "BDX": "NYSE",
  "BE": "NYSE",
  "BEAG": "NASDAQ",
  "BEAM": "NASDAQ",
  "BEAT": "NASDAQ",
  "BEBE": "NYSE",
  "BEEM": "NASDAQ",
  "BEEP": "NASDAQ",
  "BEKE": "NYSE",
  "BELFA": "NASDAQ",
  "BELFB": "NASDAQ",
  "BEN": "NYSE",
  "BENF": "NASDAQ",
  "BEP": "NYSE",
  "BEP-P-A": "NYSE",
  "BEPC": "NYSE",
  "BESS": "NYSE",
  "BETA": "NYSE",
  "BETR": "NASDAQ",
  "BF-A": "NYSE",
  "BF-B": "NYSE",
  "BFAM": "NYSE",
  "BFC": "NASDAQ",
  "BFH": "NYSE",
  "BFH-P-A": "NYSE",
  "BFH-P-B": "NYSE",
  "BFLY": "NYSE",
  "BFRG": "NASDAQ",
  "BFRI": "NASDAQ",
  "BFS": "NYSE",
  "BFS-P-D": "NYSE",
  "BFS-P-E": "NYSE",
  "BFST": "NASDAQ",
  "BG": "NYSE",
  "BGB": "NYSE",
  "BGC": "NASDAQ",
  "BGDE": "NASDAQ",
  "BGH": "NYSE",
  "BGI": "NYSE",
  "BGIN": "NASDAQ",
  "BGL": "NASDAQ",
  "BGLC": "NASDAQ",
  "BGM": "NASDAQ",
  "BGMS": "NASDAQ",
  "BGR": "NYSE",
  "BGS": "NYSE",
  "BGSF": "NYSE",
  "BGSI": "NYSE",
  "BGT": "NYSE",
  "BGX": "NYSE",
  "BGY": "NYSE",
  "BH": "NYSE",
  "BH-A": "NYSE",
  "BHAV": "NASDAQ",
  "BHB": "NYSE",
  "BHC": "NYSE",
  "BHE": "NYSE",
  "BHF": "NASDAQ",
  "BHFAM": "NASDAQ",
  "BHFAN": "NASDAQ",
  "BHFAO": "NASDAQ",
  "BHFAP": "NASDAQ",
  "BHK": "NYSE",
  "BHM": "NYSE",
  "BHP": "NYSE",
  "BHR": "NYSE",
  "BHR-P-B": "NYSE",
  "BHR-P-D": "NYSE",
  "BHRB": "NASDAQ",
  "BHST": "NASDAQ",
  "BHV": "NYSE",
  "BHVN": "NYSE",
  "BIAF": "NASDAQ",
  "BID": "NASDAQ",
  "BIDU": "NASDAQ",
  "BIIB": "NASDAQ",
  "BIII": "NYSE",
  "BILI": "NASDAQ",
  "BILL": "NYSE",
  "BIO": "NYSE",
  "BIO-B": "NYSE",
  "BIOA": "NASDAQ",
  "BIOT": "NASDAQ",
  "BIOX": "NASDAQ",
  "BIP": "NYSE",
  "BIP-P-A": "NYSE",
  "BIP-P-B": "NYSE",
  "BIPC": "NYSE",
  "BIRD": "NASDAQ",
  "BIRK": "NYSE",
  "BIT": "NYSE",
  "BIVI": "NASDAQ",
  "BIXI": "NASDAQ",
  "BIYA": "NASDAQ",
  "BJ": "NYSE",
  "BJDX": "NASDAQ",
  "BJRI": "NASDAQ",
  "BKD": "NYSE",
  "BKE": "NYSE",
  "BKH": "NYSE",
  "BKHA": "NASDAQ",
  "BKKT": "NYSE",
  "BKNG": "NASDAQ",
  "BKR": "NASDAQ",
  "BKSY": "NYSE",
  "BKT": "NYSE",
  "BKTI": "NYSE",
  "BKU": "NYSE",
  "BKV": "NYSE",
  "BKYI": "NASDAQ",
  "BL": "NASDAQ",
  "BLBD": "NASDAQ",
  "BLCO": "NYSE",
  "BLDP": "NASDAQ",
  "BLDR": "NYSE",
  "BLFS": "NASDAQ",
  "BLIN": "NASDAQ",
  "BLIV": "NASDAQ",
  "BLK": "NYSE",
  "BLKB": "NASDAQ",
  "BLLN": "NASDAQ",
  "BLMN": "NASDAQ",
  "BLND": "NYSE",
  "BLNE": "NASDAQ",
  "BLNK": "NASDAQ",
  "BLRK": "NASDAQ",
  "BLRX": "NASDAQ",
  "BLSH": "NYSE",
  "BLSM": "NASDAQ",
  "BLTE": "NASDAQ",
  "BLUW": "NASDAQ",
  "BLW": "NYSE",
  "BLX": "NYSE",
  "BLZE": "NASDAQ",
  "BLZR": "NASDAQ",
  "BMA": "NYSE",
  "BMBL": "NASDAQ",
  "BME": "NYSE",
  "BMEA": "NASDAQ",
  "BMEZ": "NYSE",
  "BMGL": "NASDAQ",
  "BMHL": "NASDAQ",
  "BMI": "NYSE",
  "BML-P-G": "NYSE",
  "BML-P-H": "NYSE",
  "BML-P-J": "NYSE",
  "BML-P-L": "NYSE",
  "BMM": "NASDAQ",
  "BMN": "NYSE",
  "BMNP": "NYSE",
  "BMNR": "NYSE",
  "BMO": "NYSE",
  "BMR": "NASDAQ",
  "BMRA": "NASDAQ",
  "BMRC": "NASDAQ",
  "BMRN": "NASDAQ",
  "BMY": "NYSE",
  "BN": "NYSE",
  "BNAI": "NASDAQ",
  "BNC": "NASDAQ",
  "BNED": "NYSE",
  "BNGO": "NASDAQ",
  "BNKK": "NASDAQ",
  "BNL": "NYSE",
  "BNR": "NASDAQ",
  "BNRG": "NASDAQ",
  "BNS": "NYSE",
  "BNT": "NYSE",
  "BNTC": "NASDAQ",
  "BNTX": "NASDAQ",
  "BNY": "NYSE",
  "BNY-P-K": "NYSE",
  "BOBS": "NYSE",
  "BOC": "NYSE",
  "BODI": "NASDAQ",
  "BOE": "NYSE",
  "BOF": "NASDAQ",
  "BOH": "NYSE",
  "BOH-P-A": "NYSE",
  "BOH-P-B": "NYSE",
  "BOKF": "NASDAQ",
  "BOLD": "NASDAQ",
  "BOLT": "NASDAQ",
  "BON": "NASDAQ",
  "BOOM": "NASDAQ",
  "BOOT": "NYSE",
  "BORR": "NYSE",
  "BOSC": "NASDAQ",
  "BOT": "NASDAQ",
  "BOTJ": "NASDAQ",
  "BOW": "NYSE",
  "BOX": "NYSE",
  "BOXL": "NASDAQ",
  "BP": "NYSE",
  "BPAC": "NASDAQ",
  "BPOP": "NASDAQ",
  "BPOPM": "NASDAQ",
  "BPRE": "NYSE",
  "BPRN": "NASDAQ",
  "BQ": "NYSE",
  "BR": "NYSE",
  "BRAG": "NASDAQ",
  "BRAI": "NASDAQ",
  "BRBI": "NASDAQ",
  "BRBR": "NYSE",
  "BRBS": "NYSE",
  "BRC": "NYSE",
  "BRCB": "NASDAQ",
  "BRCC": "NYSE",
  "BREZ": "NASDAQ",
  "BRFH": "NASDAQ",
  "BRIA": "NYSE",
  "BRID": "NASDAQ",
  "BRK-A": "NYSE",
  "BRK-B": "NYSE",
  "BRKH": "NASDAQ",
  "BRKR": "NASDAQ",
  "BRKRP": "NASDAQ",
  "BRLS": "NASDAQ",
  "BRLT": "NASDAQ",
  "BRN": "NYSE",
  "BRNS": "NASDAQ",
  "BRO": "NYSE",
  "BROS": "NYSE",
  "BRR": "NASDAQ",
  "BRSL": "NYSE",
  "BRSP": "NYSE",
  "BRT": "NYSE",
  "BRTX": "NASDAQ",
  "BRUN": "NASDAQ",
  "BRVE": "NASDAQ",
  "BRW": "NYSE",
  "BRX": "NYSE",
  "BRZE": "NASDAQ",
  "BSAA": "NASDAQ",
  "BSAC": "NYSE",
  "BSBK": "NASDAQ",
  "BSBR": "NYSE",
  "BSEM": "NASDAQ",
  "BSET": "NASDAQ",
  "BSIN": "NASDAQ",
  "BSL": "NYSE",
  "BSM": "NYSE",
  "BSP": "NASDAQ",
  "BSRR": "NASDAQ",
  "BST": "NYSE",
  "BSTZ": "NYSE",
  "BSVN": "NASDAQ",
  "BSX": "NYSE",
  "BSY": "NASDAQ",
  "BTAI": "NASDAQ",
  "BTBD": "NASDAQ",
  "BTBT": "NASDAQ",
  "BTCS": "NASDAQ",
  "BTCT": "NASDAQ",
  "BTDR": "NASDAQ",
  "BTE": "NYSE",
  "BTG": "NYSE",
  "BTGO": "NYSE",
  "BTI": "NYSE",
  "BTMD": "NASDAQ",
  "BTO": "NYSE",
  "BTOC": "NASDAQ",
  "BTOG": "NASDAQ",
  "BTQ": "NASDAQ",
  "BTSG": "NASDAQ",
  "BTT": "NYSE",
  "BTTC": "NASDAQ",
  "BTU": "NYSE",
  "BTX": "NYSE",
  "BTZ": "NYSE",
  "BUD": "NYSE",
  "BUDA": "NYSE",
  "BUI": "NYSE",
  "BULL": "NASDAQ",
  "BUR": "NYSE",
  "BURL": "NYSE",
  "BUSE": "NASDAQ",
  "BUSEP": "NASDAQ",
  "BUUU": "NASDAQ",
  "BV": "NYSE",
  "BVC": "NASDAQ",
  "BVFL": "NASDAQ",
  "BVN": "NYSE",
  "BVS": "NASDAQ",
  "BW": "NYSE",
  "BW-P-A": "NYSE",
  "BWA": "NYSE",
  "BWAY": "NASDAQ",
  "BWB": "NASDAQ",
  "BWBBP": "NASDAQ",
  "BWEN": "NASDAQ",
  "BWFG": "NASDAQ",
  "BWG": "NYSE",
  "BWIN": "NASDAQ",
  "BWIV": "NYSE",
  "BWLP": "NYSE",
  "BWMN": "NASDAQ",
  "BWMX": "NYSE",
  "BWXT": "NYSE",
  "BX": "NYSE",
  "BXBL": "NASDAQ",
  "BXC": "NYSE",
  "BXDC": "NYSE",
  "BXMT": "NYSE",
  "BXP": "NYSE",
  "BXSL": "NYSE",
  "BY": "NYSE",
  "BYAH": "NASDAQ",
  "BYD": "NYSE",
  "BYFC": "NASDAQ",
  "BYND": "NASDAQ",
  "BYRN": "NASDAQ",
  "BYSI": "NASDAQ",
  "BZ": "NASDAQ",
  "BZAI": "NASDAQ",
  "BZFD": "NASDAQ",
  "BZH": "NYSE",
  "BZUN": "NASDAQ",
  "C": "NYSE",
  "C-P-N": "NYSE",
  "C-P-R": "NYSE",
  "CAAP": "NYSE",
  "CAAS": "NASDAQ",
  "CABA": "NASDAQ",
  "CABO": "NYSE",
  "CABR": "NASDAQ",
  "CAC": "NASDAQ",
  "CACC": "NASDAQ",
  "CACI": "NYSE",
  "CADL": "NASDAQ",
  "CAE": "NASDAQ",
  "CAES": "NASDAQ",
  "CAF": "NYSE",
  "CAG": "NYSE",
  "CAH": "NYSE",
  "CAI": "NASDAQ",
  "CAII": "NASDAQ",
  "CAKE": "NASDAQ",
  "CAL": "NYSE",
  "CALC": "NASDAQ",
  "CALM": "NASDAQ",
  "CALX": "NYSE",
  "CALY": "NYSE",
  "CAMP": "NASDAQ",
  "CAMT": "NASDAQ",
  "CAN": "NASDAQ",
  "CANF": "NYSE",
  "CANG": "NYSE",
  "CAPL": "NYSE",
  "CAPN": "NASDAQ",
  "CAPR": "NASDAQ",
  "CAPS": "NASDAQ",
  "CAQ": "NASDAQ",
  "CAR": "NASDAQ",
  "CARE": "NASDAQ",
  "CARG": "NASDAQ",
  "CARL": "NASDAQ",
  "CARR": "NYSE",
  "CARS": "NYSE",
  "CART": "NASDAQ",
  "CASH": "NASDAQ",
  "CASS": "NASDAQ",
  "CAST": "NASDAQ",
  "CASY": "NASDAQ",
  "CAT": "NYSE",
  "CATO": "NYSE",
  "CATX": "NYSE",
  "CATY": "NASDAQ",
  "CAVA": "NYSE",
  "CB": "NYSE",
  "CBAN": "NYSE",
  "CBAT": "NASDAQ",
  "CBC": "NASDAQ",
  "CBFV": "NASDAQ",
  "CBIO": "NASDAQ",
  "CBK": "NASDAQ",
  "CBL": "NYSE",
  "CBLL": "NASDAQ",
  "CBNA": "NYSE",
  "CBNK": "NASDAQ",
  "CBOE": "CBOE",
  "CBRE": "NYSE",
  "CBRL": "NASDAQ",
  "CBRS": "NASDAQ",
  "CBSH": "NASDAQ",
  "CBT": "NYSE",
  "CBU": "NYSE",
  "CBUS": "NASDAQ",
  "CBZ": "NYSE",
  "CC": "NYSE",
  "CCAP": "NASDAQ",
  "CCAQ": "NASDAQ",
  "CCB": "NASDAQ",
  "CCBG": "NASDAQ",
  "CCC": "NASDAQ",
  "CCCC": "NASDAQ",
  "CCCT": "NASDAQ",
  "CCD": "NASDAQ",
  "CCEC": "NASDAQ",
  "CCEL": "NYSE",
  "CCEP": "NASDAQ",
  "CCG": "NASDAQ",
  "CCHH": "NASDAQ",
  "CCI": "NYSE",
  "CCID": "NYSE",
  "CCIF": "NYSE",
  "CCII": "NASDAQ",
  "CCJ": "NYSE",
  "CCK": "NYSE",
  "CCL": "NYSE",
  "CCLD": "NASDAQ",
  "CCM": "NYSE",
  "CCNE": "NASDAQ",
  "CCNEP": "NASDAQ",
  "CCO": "NYSE",
  "CCOI": "NASDAQ",
  "CCS": "NYSE",
  "CCSI": "NASDAQ",
  "CCTG": "NASDAQ",
  "CCU": "NYSE",
  "CCXI": "NASDAQ",
  "CCZ": "NYSE",
  "CD": "NASDAQ",
  "CDE": "NYSE",
  "CDIO": "NASDAQ",
  "CDLR": "NYSE",
  "CDLX": "NASDAQ",
  "CDNA": "NASDAQ",
  "CDNL": "NASDAQ",
  "CDNS": "NASDAQ",
  "CDP": "NYSE",
  "CDR-P-B": "NYSE",
  "CDR-P-C": "NYSE",
  "CDRE": "NYSE",
  "CDRO": "NASDAQ",
  "CDT": "NASDAQ",
  "CDTG": "NASDAQ",
  "CDW": "NASDAQ",
  "CDXS": "NASDAQ",
  "CDZI": "NASDAQ",
  "CDZIP": "NASDAQ",
  "CE": "NYSE",
  "CECO": "NASDAQ",
  "CEE": "NYSE",
  "CEG": "NASDAQ",
  "CELC": "NASDAQ",
  "CELH": "NASDAQ",
  "CELU": "NASDAQ",
  "CELZ": "NASDAQ",
  "CENN": "NASDAQ",
  "CENT": "NASDAQ",
  "CENTA": "NASDAQ",
  "CENX": "NASDAQ",
  "CEPF": "NASDAQ",
  "CEPL": "NASDAQ",
  "CEPO": "NASDAQ",
  "CEPS": "NASDAQ",
  "CEPU": "NYSE",
  "CEPV": "NASDAQ",
  "CERS": "NASDAQ",
  "CERT": "NASDAQ",
  "CET": "NYSE",
  "CETX": "NASDAQ",
  "CETY": "NASDAQ",
  "CEV": "NYSE",
  "CEVA": "NASDAQ",
  "CF": "NYSE",
  "CFBK": "NASDAQ",
  "CFFI": "NASDAQ",
  "CFFN": "NASDAQ",
  "CFG": "NYSE",
  "CFG-P-E": "NYSE",
  "CFG-P-H": "NYSE",
  "CFG-P-I": "NYSE",
  "CFND": "NYSE",
  "CFR": "NYSE",
  "CFR-P-B": "NYSE",
  "CFTR-P-A": "NYSE",
  "CG": "NASDAQ",
  "CGAU": "NYSE",
  "CGBD": "NASDAQ",
  "CGC": "NASDAQ",
  "CGEM": "NASDAQ",
  "CGEN": "NASDAQ",
  "CGNT": "NASDAQ",
  "CGNX": "NASDAQ",
  "CGO": "NASDAQ",
  "CGON": "NASDAQ",
  "CGTL": "NASDAQ",
  "CGTX": "NASDAQ",
  "CHA": "NASDAQ",
  "CHAI": "NASDAQ",
  "CHAR": "NASDAQ",
  "CHCI": "NASDAQ",
  "CHCO": "NASDAQ",
  "CHCT": "NYSE",
  "CHD": "NYSE",
  "CHDN": "NASDAQ",
  "CHE": "NYSE",
  "CHEC": "NASDAQ",
  "CHEF": "NASDAQ",
  "CHGA": "NASDAQ",
  "CHGG": "NYSE",
  "CHH": "NYSE",
  "CHI": "NASDAQ",
  "CHKP": "NASDAQ",
  "CHMG": "NASDAQ",
  "CHMI": "NYSE",
  "CHMI-P-A": "NYSE",
  "CHMI-P-B": "NYSE",
  "CHNR": "NASDAQ",
  "CHOW": "NYSE",
  "CHPG": "NASDAQ",
  "CHPT": "NYSE",
  "CHR": "NASDAQ",
  "CHRD": "NASDAQ",
  "CHRN": "NASDAQ",
  "CHRS": "NASDAQ",
  "CHRW": "NASDAQ",
  "CHSCL": "NASDAQ",
  "CHSCM": "NASDAQ",
  "CHSCN": "NASDAQ",
  "CHSCO": "NASDAQ",
  "CHSCP": "NASDAQ",
  "CHSN": "NASDAQ",
  "CHT": "NYSE",
  "CHTR": "NASDAQ",
  "CHW": "NASDAQ",
  "CHWY": "NYSE",
  "CHY": "NASDAQ",
  "CHYM": "NASDAQ",
  "CI": "NYSE",
  "CIA": "NYSE",
  "CIB": "NYSE",
  "CIEN": "NYSE",
  "CIFR": "NASDAQ",
  "CIG": "NYSE",
  "CIG-C": "NYSE",
  "CIGI": "NASDAQ",
  "CIGL": "NASDAQ",
  "CII": "NYSE",
  "CIIT": "NASDAQ",
  "CIK": "NYSE",
  "CIM": "NYSE",
  "CIM-P-A": "NYSE",
  "CIM-P-B": "NYSE",
  "CIM-P-C": "NYSE",
  "CIM-P-D": "NYSE",
  "CINF": "NASDAQ",
  "CING": "NASDAQ",
  "CINT": "NYSE",
  "CION": "NYSE",
  "CIRC": "NASDAQ",
  "CISO": "NASDAQ",
  "CISS": "NASDAQ",
  "CITR": "NYSE",
  "CIVB": "NASDAQ",
  "CIX": "NYSE",
  "CJMB": "NASDAQ",
  "CKX": "NYSE",
  "CL": "NYSE",
  "CLAR": "NASDAQ",
  "CLB": "NYSE",
  "CLBK": "NASDAQ",
  "CLBR": "NYSE",
  "CLBT": "NASDAQ",
  "CLDI": "NYSE",
  "CLDT": "NYSE",
  "CLDT-P-A": "NYSE",
  "CLDX": "NASDAQ",
  "CLF": "NYSE",
  "CLFD": "NASDAQ",
  "CLGN": "NASDAQ",
  "CLH": "NYSE",
  "CLIK": "NASDAQ",
  "CLIR": "NASDAQ",
  "CLLS": "NASDAQ",
  "CLM": "NYSE",
  "CLMB": "NASDAQ",
  "CLMT": "NASDAQ",
  "CLNE": "NASDAQ",
  "CLNN": "NASDAQ",
  "CLOV": "NASDAQ",
  "CLPR": "NYSE",
  "CLPS": "NASDAQ",
  "CLPT": "NASDAQ",
  "CLRB": "NASDAQ",
  "CLRO": "NASDAQ",
  "CLS": "NYSE",
  "CLSK": "NASDAQ",
  "CLST": "NASDAQ",
  "CLVT": "NYSE",
  "CLW": "NYSE",
  "CLWT": "NASDAQ",
  "CLX": "NYSE",
  "CLYM": "NASDAQ",
  "CM": "NYSE",
  "CMBT": "NYSE",
  "CMC": "NYSE",
  "CMCL": "NYSE",
  "CMCM": "NYSE",
  "CMCO": "NASDAQ",
  "CMCSA": "NASDAQ",
  "CMCT": "NASDAQ",
  "CMDB": "NYSE",
  "CME": "NASDAQ",
  "CMG": "NYSE",
  "CMI": "NYSE",
  "CMII": "NASDAQ",
  "CMMB": "NASDAQ",
  "CMND": "NASDAQ",
  "CMP": "NYSE",
  "CMPR": "NASDAQ",
  "CMPS": "NASDAQ",
  "CMPX": "NASDAQ",
  "CMRC": "NASDAQ",
  "CMRE": "NYSE",
  "CMRE-P-B": "NYSE",
  "CMRE-P-C": "NYSE",
  "CMRE-P-D": "NYSE",
  "CMS": "NYSE",
  "CMS-P-B": "NYSE",
  "CMS-P-C": "NYSE",
  "CMT": "NYSE",
  "CMTG": "NYSE",
  "CMTL": "NASDAQ",
  "CMTV": "NASDAQ",
  "CNA": "NYSE",
  "CNC": "NYSE",
  "CNCK": "NASDAQ",
  "CNDT": "NASDAQ",
  "CNET": "NASDAQ",
  "CNEY": "NASDAQ",
  "CNF": "NYSE",
  "CNH": "NYSE",
  "CNI": "NYSE",
  "CNK": "NYSE",
  "CNL": "NYSE",
  "CNM": "NYSE",
  "CNMD": "NYSE",
  "CNNE": "NYSE",
  "CNO": "NYSE",
  "CNOB": "NASDAQ",
  "CNOBP": "NASDAQ",
  "CNP": "NYSE",
  "CNQ": "NYSE",
  "CNR": "NYSE",
  "CNS": "NYSE",
  "CNSP": "NASDAQ",
  "CNSY": "NASDAQ",
  "CNTB": "NASDAQ",
  "CNTN": "NASDAQ",
  "CNTX": "NASDAQ",
  "CNTY": "NASDAQ",
  "CNVS": "NASDAQ",
  "CNX": "NYSE",
  "CNXC": "NASDAQ",
  "CNXN": "NASDAQ",
  "CNXU": "NASDAQ",
  "COAG": "NASDAQ",
  "COCH": "NASDAQ",
  "COCO": "NASDAQ",
  "COCP": "NASDAQ",
  "CODA": "NASDAQ",
  "CODI": "NYSE",
  "CODI-P-A": "NYSE",
  "CODI-P-B": "NYSE",
  "CODI-P-C": "NYSE",
  "CODX": "NASDAQ",
  "COE": "NYSE",
  "COF": "NYSE",
  "COF-P-I": "NYSE",
  "COF-P-J": "NYSE",
  "COF-P-K": "NYSE",
  "COF-P-L": "NYSE",
  "COF-P-N": "NYSE",
  "COFS": "NASDAQ",
  "COGT": "NASDAQ",
  "COHN": "NYSE",
  "COHR": "NYSE",
  "COHU": "NASDAQ",
  "COIN": "NASDAQ",
  "COKE": "NASDAQ",
  "COLA": "NASDAQ",
  "COLB": "NASDAQ",
  "COLD": "NYSE",
  "COLL": "NASDAQ",
  "COLM": "NASDAQ",
  "COMP": "NYSE",
  "CON": "NYSE",
  "COO": "NASDAQ",
  "COOK": "NYSE",
  "COOT": "NASDAQ",
  "COP": "NYSE",
  "COPL": "NYSE",
  "COPR": "NYSE",
  "COR": "NYSE",
  "CORT": "NASDAQ",
  "CORZ": "NASDAQ",
  "COSM": "NASDAQ",
  "COSO": "NYSE",
  "COST": "NASDAQ",
  "COTY": "NYSE",
  "COUR": "NYSE",
  "COYA": "NASDAQ",
  "CP": "NYSE",
  "CPA": "NYSE",
  "CPAC": "NYSE",
  "CPAY": "NYSE",
  "CPB": "NASDAQ",
  "CPBI": "NASDAQ",
  "CPF": "NYSE",
  "CPHC": "NASDAQ",
  "CPHI": "NYSE",
  "CPIX": "NASDAQ",
  "CPK": "NYSE",
  "CPNG": "NYSE",
  "CPOP": "NASDAQ",
  "CPRI": "NYSE",
  "CPRT": "NASDAQ",
  "CPS": "NYSE",
  "CPSH": "NASDAQ",
  "CPSS": "NASDAQ",
  "CPT": "NYSE",
  "CPZ": "NASDAQ",
  "CQP": "NYSE",
  "CR": "NYSE",
  "CRAC": "NASDAQ",
  "CRAI": "NASDAQ",
  "CRAN": "NASDAQ",
  "CRAQ": "NASDAQ",
  "CRBG": "NYSE",
  "CRBP": "NASDAQ",
  "CRBU": "NASDAQ",
  "CRC": "NYSE",
  "CRCL": "NYSE",
  "CRCT": "NASDAQ",
  "CRD-A": "NYSE",
  "CRD-B": "NYSE",
  "CRDF": "NASDAQ",
  "CRDL": "NASDAQ",
  "CRDO": "NASDAQ",
  "CRE": "NASDAQ",
  "CRESY": "NASDAQ",
  "CREX": "NASDAQ",
  "CRF": "NYSE",
  "CRGO": "NASDAQ",
  "CRGY": "NYSE",
  "CRH": "NYSE",
  "CRI": "NYSE",
  "CRIS": "NASDAQ",
  "CRK": "NYSE",
  "CRL": "NYSE",
  "CRM": "NYSE",
  "CRMD": "NASDAQ",
  "CRML": "NASDAQ",
  "CRMT": "NASDAQ",
  "CRNC": "NASDAQ",
  "CRNT": "NASDAQ",
  "CRNX": "NASDAQ",
  "CRON": "NASDAQ",
  "CROX": "NASDAQ",
  "CRS": "NYSE",
  "CRSP": "NASDAQ",
  "CRSR": "NASDAQ",
  "CRT": "NYSE",
  "CRTO": "NASDAQ",
  "CRUS": "NASDAQ",
  "CRVL": "NASDAQ",
  "CRVO": "NASDAQ",
  "CRVS": "NASDAQ",
  "CRWD": "NASDAQ",
  "CRWS": "NASDAQ",
  "CRWV": "NASDAQ",
  "CSAI": "NASDAQ",
  "CSAN": "NYSE",
  "CSBR": "NASDAQ",
  "CSCO": "NASDAQ",
  "CSGP": "NASDAQ",
  "CSHR": "NASDAQ",
  "CSIQ": "NASDAQ",
  "CSL": "NYSE",
  "CSPI": "NASDAQ",
  "CSQ": "NASDAQ",
  "CSQR": "NYSE",
  "CSR": "NYSE",
  "CSTE": "NASDAQ",
  "CSTL": "NASDAQ",
  "CSTM": "NYSE",
  "CSV": "NYSE",
  "CSW": "NYSE",
  "CSWC": "NASDAQ",
  "CSX": "NASDAQ",
  "CTA-P-A": "NYSE",
  "CTA-P-B": "NYSE",
  "CTAA": "NASDAQ",
  "CTAS": "NASDAQ",
  "CTBI": "NASDAQ",
  "CTEV": "NYSE",
  "CTGO": "NYSE",
  "CTKB": "NASDAQ",
  "CTM": "NYSE",
  "CTMX": "NASDAQ",
  "CTNM": "NASDAQ",
  "CTNT": "NASDAQ",
  "CTO": "NYSE",
  "CTO-P-A": "NYSE",
  "CTOR": "NASDAQ",
  "CTOS": "NYSE",
  "CTRE": "NYSE",
  "CTRI": "NYSE",
  "CTRM": "NASDAQ",
  "CTRN": "NASDAQ",
  "CTS": "NYSE",
  "CTSH": "NASDAQ",
  "CTSO": "NASDAQ",
  "CTVA": "NYSE",
  "CTW": "NASDAQ",
  "CTXR": "NASDAQ",
  "CUB": "NASDAQ",
  "CUBE": "NYSE",
  "CUBI": "NYSE",
  "CUE": "NASDAQ",
  "CULP": "NASDAQ",
  "CUPR": "NASDAQ",
  "CURB": "NYSE",
  "CURI": "NASDAQ",
  "CURR": "NASDAQ",
  "CURV": "NYSE",
  "CURX": "NASDAQ",
  "CUVL": "NASDAQ",
  "CUZ": "NYSE",
  "CV": "NASDAQ",
  "CVBF": "NASDAQ",
  "CVCO": "NASDAQ",
  "CVE": "NYSE",
  "CVEO": "NYSE",
  "CVGI": "NASDAQ",
  "CVI": "NYSE",
  "CVKD": "NASDAQ",
  "CVLG": "NYSE",
  "CVLT": "NASDAQ",
  "CVM": "NYSE",
  "CVNA": "NYSE",
  "CVR": "NYSE",
  "CVRX": "NASDAQ",
  "CVS": "NYSE",
  "CVSA": "NYSE",
  "CVU": "NYSE",
  "CVV": "NASDAQ",
  "CVX": "NYSE",
  "CW": "NYSE",
  "CWBC": "NASDAQ",
  "CWCO": "NASDAQ",
  "CWD": "NASDAQ",
  "CWEN": "NYSE",
  "CWH": "NYSE",
  "CWK": "NYSE",
  "CWST": "NASDAQ",
  "CWT": "NYSE",
  "CX": "NYSE",
  "CXAI": "NASDAQ",
  "CXDO": "NASDAQ",
  "CXII": "NASDAQ",
  "CXM": "NYSE",
  "CXT": "NYSE",
  "CXW": "NYSE",
  "CYAB": "NASDAQ",
  "CYCN": "NASDAQ",
  "CYCU": "NASDAQ",
  "CYD": "NYSE",
  "CYH": "NYSE",
  "CYN": "NASDAQ",
  "CYPH": "NASDAQ",
  "CYRX": "NASDAQ",
  "CYTK": "NASDAQ",
  "CZFS": "NASDAQ",
  "CZNC": "NASDAQ",
  "CZR": "NASDAQ",
  "CZWI": "NASDAQ",
  "D": "NYSE",
  "DAAQ": "NASDAQ",
  "DAC": "NYSE",
  "DAIC": "NASDAQ",
  "DAIO": "NASDAQ",
  "DAKT": "NASDAQ",
  "DAL": "NYSE",
  "DAN": "NYSE",
  "DAO": "NYSE",
  "DAR": "NYSE",
  "DARE": "NASDAQ",
  "DASH": "NASDAQ",
  "DAVA": "NYSE",
  "DAVE": "NASDAQ",
  "DB": "NYSE",
  "DBCA": "NASDAQ",
  "DBD": "NYSE",
  "DBGI": "NASDAQ",
  "DBI": "NYSE",
  "DBL": "NYSE",
  "DBRG": "NYSE",
  "DBRG-P-H": "NYSE",
  "DBRG-P-I": "NYSE",
  "DBRG-P-J": "NYSE",
  "DBVT": "NASDAQ",
  "DBX": "NASDAQ",
  "DC": "NYSE",
  "DCBO": "NASDAQ",
  "DCGO": "NASDAQ",
  "DCH": "NYSE",
  "DCI": "NYSE",
  "DCO": "NYSE",
  "DCOM": "NYSE",
  "DCOM-P": "NYSE",
  "DCOY": "NASDAQ",
  "DCTH": "NASDAQ",
  "DCX": "NASDAQ",
  "DD": "NYSE",
  "DDC": "NYSE",
  "DDD": "NYSE",
  "DDI": "NASDAQ",
  "DDL": "NYSE",
  "DDOG": "NASDAQ",
  "DDS": "NYSE",
  "DDT": "NYSE",
  "DE": "NYSE",
  "DEA": "NYSE",
  "DEC": "NYSE",
  "DECK": "NYSE",
  "DEFT": "NASDAQ",
  "DEI": "NYSE",
  "DELL": "NYSE",
  "DEO": "NYSE",
  "DERM": "NASDAQ",
  "DETX": "NASDAQ",
  "DFDV": "NASDAQ",
  "DFH": "NYSE",
  "DFIN": "NYSE",
  "DFLI": "NASDAQ",
  "DFNS": "NASDAQ",
  "DFP": "NYSE",
  "DFSC": "NASDAQ",
  "DFTX": "NASDAQ",
  "DG": "NYSE",
  "DGAC": "NYSE",
  "DGICA": "NASDAQ",
  "DGICB": "NASDAQ",
  "DGII": "NASDAQ",
  "DGNX": "NASDAQ",
  "DGX": "NYSE",
  "DGXX": "NASDAQ",
  "DH": "NASDAQ",
  "DHC": "NASDAQ",
  "DHF": "NYSE",
  "DHI": "NYSE",
  "DHR": "NYSE",
  "DHT": "NYSE",
  "DHX": "NYSE",
  "DHY": "NYSE",
  "DIBS": "NASDAQ",
  "DIN": "NYSE",
  "DINO": "NYSE",
  "DIOD": "NASDAQ",
  "DIS": "NYSE",
  "DIT": "NYSE",
  "DJCO": "NASDAQ",
  "DJT": "NASDAQ",
  "DK": "NYSE",
  "DKI": "NASDAQ",
  "DKL": "NYSE",
  "DKNG": "NASDAQ",
  "DKS": "NYSE",
  "DLB": "NYSE",
  "DLHC": "NASDAQ",
  "DLNG": "NYSE",
  "DLO": "NASDAQ",
  "DLPN": "NASDAQ",
  "DLR": "NYSE",
  "DLR-P-J": "NYSE",
  "DLR-P-K": "NYSE",
  "DLR-P-L": "NYSE",
  "DLTH": "NASDAQ",
  "DLTR": "NASDAQ",
  "DLX": "NYSE",
  "DLXY": "NASDAQ",
  "DLY": "NYSE",
  "DMA": "NYSE",
  "DMAA": "NASDAQ",
  "DMAC": "NASDAQ",
  "DMB": "NYSE",
  "DMC": "NYSE",
  "DMII": "NASDAQ",
  "DMLP": "NASDAQ",
  "DMO": "NYSE",
  "DMRA": "NASDAQ",
  "DMRC": "NASDAQ",
  "DNA": "NYSE",
  "DNLI": "NASDAQ",
  "DNMX": "NASDAQ",
  "DNN": "NYSE",
  "DNOW": "NYSE",
  "DNP": "NYSE",
  "DNTH": "NASDAQ",
  "DNUT": "NASDAQ",
  "DOC": "NYSE",
  "DOCN": "NYSE",
  "DOCS": "NYSE",
  "DOCU": "NASDAQ",
  "DOGZ": "NASDAQ",
  "DOLE": "NYSE",
  "DOMH": "NASDAQ",
  "DOMO": "NASDAQ",
  "DOO": "NASDAQ",
  "DORM": "NASDAQ",
  "DOUG": "NYSE",
  "DOV": "NYSE",
  "DOW": "NYSE",
  "DOX": "NASDAQ",
  "DOYU": "NASDAQ",
  "DPC": "NYSE",
  "DPG": "NYSE",
  "DPRO": "NASDAQ",
  "DPU": "NASDAQ",
  "DPZ": "NASDAQ",
  "DQ": "NYSE",
  "DRCT": "NASDAQ",
  "DRD": "NYSE",
  "DRDB": "NASDAQ",
  "DRH": "NASDAQ",
  "DRI": "NYSE",
  "DRIO": "NASDAQ",
  "DRMA": "NASDAQ",
  "DRS": "NASDAQ",
  "DRTS": "NASDAQ",
  "DRUG": "NASDAQ",
  "DRVN": "NASDAQ",
  "DSAC": "NASDAQ",
  "DSC": "NASDAQ",
  "DSGN": "NASDAQ",
  "DSGR": "NASDAQ",
  "DSGX": "NASDAQ",
  "DSL": "NYSE",
  "DSM": "NYSE",
  "DSP": "NASDAQ",
  "DSS": "NYSE",
  "DSU": "NYSE",
  "DSWL": "NASDAQ",
  "DSX": "NYSE",
  "DSX-P-B": "NYSE",
  "DSY": "NASDAQ",
  "DT": "NYSE",
  "DTCX": "NASDAQ",
  "DTE": "NYSE",
  "DTF": "NYSE",
  "DTI": "NASDAQ",
  "DTIL": "NASDAQ",
  "DTM": "NYSE",
  "DTSQ": "NASDAQ",
  "DTSS": "NASDAQ",
  "DTST": "NASDAQ",
  "DUK": "NYSE",
  "DUK-P-A": "NYSE",
  "DUKR": "NASDAQ",
  "DUO": "NASDAQ",
  "DUOL": "NASDAQ",
  "DUOT": "NASDAQ",
  "DV": "NYSE",
  "DVA": "NYSE",
  "DVLT": "NASDAQ",
  "DVN": "NYSE",
  "DWSN": "NASDAQ",
  "DWTX": "NASDAQ",
  "DX": "NYSE",
  "DX-P-C": "NYSE",
  "DXC": "NYSE",
  "DXCM": "NASDAQ",
  "DXF": "NYSE",
  "DXLG": "NASDAQ",
  "DXPE": "NASDAQ",
  "DXR": "NASDAQ",
  "DXST": "NASDAQ",
  "DXYZ": "NYSE",
  "DY": "NYSE",
  "DYAI": "NASDAQ",
  "DYN": "NASDAQ",
  "DYNC": "NASDAQ",
  "DYOR": "NASDAQ",
  "E": "NYSE",
  "EAD": "NYSE",
  "EAF": "NYSE",
  "EAI": "NYSE",
  "EARN": "NYSE",
  "EAT": "NYSE",
  "EBAY": "NASDAQ",
  "EBC": "NASDAQ",
  "EBF": "NYSE",
  "EBMT": "NASDAQ",
  "EBON": "NASDAQ",
  "EBS": "NYSE",
  "EC": "NYSE",
  "ECAT": "NYSE",
  "ECBK": "NASDAQ",
  "ECC": "NYSE",
  "ECC-P-D": "NYSE",
  "ECCC": "NYSE",
  "ECF": "NYSE",
  "ECF-P-A": "NYSE",
  "ECG": "NYSE",
  "ECHO": "NASDAQ",
  "ECL": "NYSE",
  "ECO": "NYSE",
  "ECOR": "NASDAQ",
  "ECPG": "NASDAQ",
  "ECVT": "NYSE",
  "ECX": "NASDAQ",
  "ED": "NYSE",
  "EDBL": "NASDAQ",
  "EDD": "NYSE",
  "EDF": "NYSE",
  "EDHL": "NASDAQ",
  "EDIT": "NASDAQ",
  "EDN": "NYSE",
  "EDRY": "NASDAQ",
  "EDSA": "NASDAQ",
  "EDTK": "NASDAQ",
  "EDU": "NYSE",
  "EDUC": "NASDAQ",
  "EE": "NYSE",
  "EEA": "NYSE",
  "EEFT": "NASDAQ",
  "EEIQ": "NASDAQ",
  "EFC": "NYSE",
  "EFC-P-B": "NYSE",
  "EFC-P-C": "NYSE",
  "EFC-P-D": "NYSE",
  "EFOI": "NASDAQ",
  "EFOR": "NYSE",
  "EFR": "NYSE",
  "EFSC": "NASDAQ",
  "EFSCP": "NASDAQ",
  "EFSI": "NASDAQ",
  "EFT": "NYSE",
  "EFTY": "NASDAQ",
  "EFX": "NYSE",
  "EFXT": "NYSE",
  "EG": "NYSE",
  "EGAN": "NASDAQ",
  "EGBN": "NASDAQ",
  "EGG": "NYSE",
  "EGHA": "NASDAQ",
  "EGHT": "NASDAQ",
  "EGO": "NYSE",
  "EGP": "NYSE",
  "EGY": "NYSE",
  "EH": "NASDAQ",
  "EHC": "NYSE",
  "EHGO": "NASDAQ",
  "EHI": "NYSE",
  "EHLD": "NASDAQ",
  "EHTH": "NASDAQ",
  "EIC": "NYSE",
  "EICA": "NYSE",
  "EIG": "NYSE",
  "EIIA": "NYSE",
  "EIKN": "NASDAQ",
  "EIM": "NYSE",
  "EIX": "NYSE",
  "EJH": "NASDAQ",
  "EL": "NYSE",
  "ELA": "NYSE",
  "ELAB": "NASDAQ",
  "ELAN": "NYSE",
  "ELBM": "NASDAQ",
  "ELC": "NYSE",
  "ELDN": "NASDAQ",
  "ELE": "NASDAQ",
  "ELF": "NYSE",
  "ELLO": "NYSE",
  "ELMD": "NYSE",
  "ELME": "NYSE",
  "ELMT": "NASDAQ",
  "ELOG": "NASDAQ",
  "ELOX": "NASDAQ",
  "ELPC": "NYSE",
  "ELPW": "NASDAQ",
  "ELS": "NYSE",
  "ELTK": "NASDAQ",
  "ELTX": "NASDAQ",
  "ELUT": "NASDAQ",
  "ELV": "NYSE",
  "ELVA": "NASDAQ",
  "ELVN": "NASDAQ",
  "ELVR": "NASDAQ",
  "ELWT": "NASDAQ",
  "EMA": "NYSE",
  "EMAT": "NASDAQ",
  "EMBC": "NASDAQ",
  "EMBJ": "NYSE",
  "EMD": "NYSE",
  "EME": "NYSE",
  "EMF": "NYSE",
  "EMIS": "NASDAQ",
  "EML": "NASDAQ",
  "EMN": "NYSE",
  "EMO": "NYSE",
  "EMP": "NYSE",
  "EMPD": "NASDAQ",
  "EMR": "NYSE",
  "ENB": "NYSE",
  "ENGN": "NASDAQ",
  "ENGS": "NASDAQ",
  "ENHA": "NYSE",
  "ENIC": "NYSE",
  "ENJ": "NYSE",
  "ENLT": "NASDAQ",
  "ENLV": "NASDAQ",
  "ENO": "NYSE",
  "ENOV": "NYSE",
  "ENPH": "NASDAQ",
  "ENR": "NYSE",
  "ENRD": "NASDAQ",
  "ENS": "NYSE",
  "ENSC": "NASDAQ",
  "ENSG": "NASDAQ",
  "ENTA": "NASDAQ",
  "ENTG": "NASDAQ",
  "ENTX": "NASDAQ",
  "ENVA": "NYSE",
  "ENVB": "NASDAQ",
  "ENVX": "NASDAQ",
  "EOD": "NYSE",
  "EOG": "NYSE",
  "EOI": "NYSE",
  "EOLS": "NASDAQ",
  "EONR": "NYSE",
  "EOS": "NYSE",
  "EOSE": "NASDAQ",
  "EOT": "NYSE",
  "EP": "NYSE",
  "EP-P-C": "NYSE",
  "EPAC": "NYSE",
  "EPAM": "NYSE",
  "EPC": "NYSE",
  "EPD": "NYSE",
  "EPM": "NYSE",
  "EPOW": "NASDAQ",
  "EPR": "NYSE",
  "EPR-P-C": "NYSE",
  "EPR-P-E": "NYSE",
  "EPR-P-G": "NYSE",
  "EPRT": "NYSE",
  "EPRX": "NASDAQ",
  "EPSM": "NASDAQ",
  "EPSN": "NASDAQ",
  "EQ": "NASDAQ",
  "EQBK": "NYSE",
  "EQH": "NYSE",
  "EQH-P-A": "NYSE",
  "EQH-P-C": "NYSE",
  "EQIX": "NASDAQ",
  "EQNR": "NYSE",
  "EQPT": "NASDAQ",
  "EQR": "NYSE",
  "EQS": "NYSE",
  "EQT": "NYSE",
  "EQX": "NYSE",
  "ERAS": "NASDAQ",
  "ERC": "NYSE",
  "ERH": "NYSE",
  "ERIC": "NASDAQ",
  "ERIE": "NASDAQ",
  "ERII": "NASDAQ",
  "ERNA": "NASDAQ",
  "ERO": "NYSE",
  "EROC": "NYSE",
  "EROK": "NYSE",
  "ES": "NYSE",
  "ESAB": "NYSE",
  "ESBA": "NYSE",
  "ESCA": "NASDAQ",
  "ESE": "NYSE",
  "ESEA": "NASDAQ",
  "ESI": "NYSE",
  "ESLA": "NASDAQ",
  "ESLT": "NASDAQ",
  "ESNT": "NYSE",
  "ESOA": "NASDAQ",
  "ESP": "NYSE",
  "ESQ": "NASDAQ",
  "ESRT": "NYSE",
  "ESS": "NYSE",
  "ESTA": "NASDAQ",
  "ESTC": "NYSE",
  "ET": "NYSE",
  "ETB": "NYSE",
  "ETD": "NYSE",
  "ETG": "NYSE",
  "ETI-P": "NYSE",
  "ETJ": "NYSE",
  "ETN": "NYSE",
  "ETO": "NYSE",
  "ETON": "NASDAQ",
  "ETOR": "NASDAQ",
  "ETR": "NYSE",
  "ETS": "NASDAQ",
  "ETSS": "NYSE",
  "ETSY": "NYSE",
  "ETV": "NYSE",
  "ETW": "NYSE",
  "ETX": "NYSE",
  "ETY": "NYSE",
  "EU": "NASDAQ",
  "EUDA": "NASDAQ",
  "EURK": "NASDAQ",
  "EVAC": "NYSE",
  "EVAX": "NASDAQ",
  "EVC": "NYSE",
  "EVCM": "NASDAQ",
  "EVER": "NASDAQ",
  "EVEX": "NYSE",
  "EVF": "NYSE",
  "EVG": "NYSE",
  "EVGN": "NASDAQ",
  "EVGO": "NASDAQ",
  "EVH": "NYSE",
  "EVI": "NYSE",
  "EVLV": "NASDAQ",
  "EVMN": "NYSE",
  "EVN": "NYSE",
  "EVO": "NASDAQ",
  "EVOX": "NASDAQ",
  "EVR": "NYSE",
  "EVRG": "NASDAQ",
  "EVT": "NYSE",
  "EVTC": "NYSE",
  "EVTL": "NYSE",
  "EVV": "NYSE",
  "EW": "NYSE",
  "EWBC": "NASDAQ",
  "EWTX": "NASDAQ",
  "EXC": "NASDAQ",
  "EXE": "NASDAQ",
  "EXEL": "NASDAQ",
  "EXFY": "NASDAQ",
  "EXG": "NYSE",
  "EXK": "NYSE",
  "EXLS": "NASDAQ",
  "EXOD": "NYSE",
  "EXOZ": "NASDAQ",
  "EXP": "NYSE",
  "EXPD": "NYSE",
  "EXPE": "NASDAQ",
  "EXPO": "NASDAQ",
  "EXR": "NYSE",
  "EXTR": "NASDAQ",
  "EXYN": "NASDAQ",
  "EYE": "NASDAQ",
  "EYPT": "NASDAQ",
  "EZGO": "NASDAQ",
  "EZPW": "NASDAQ",
  "EZRA": "NASDAQ",
  "F": "NYSE",
  "FA": "NASDAQ",
  "FABC": "NASDAQ",
  "FAC": "NASDAQ",
  "FACT": "NASDAQ",
  "FAF": "NYSE",
  "FAMI": "NASDAQ",
  "FANG": "NASDAQ",
  "FAST": "NASDAQ",
  "FATE": "NASDAQ",
  "FATN": "NASDAQ",
  "FAX": "NYSE",
  "FBGL": "NASDAQ",
  "FBIN": "NYSE",
  "FBIO": "NASDAQ",
  "FBIOP": "NASDAQ",
  "FBIZ": "NASDAQ",
  "FBK": "NYSE",
  "FBLA": "NASDAQ",
  "FBLG": "NASDAQ",
  "FBNC": "NASDAQ",
  "FBP": "NYSE",
  "FBRT": "NYSE",
  "FBRT-P-E": "NYSE",
  "FBRX": "NASDAQ",
  "FBYD": "NASDAQ",
  "FBYDP": "NASDAQ",
  "FC": "NYSE",
  "FCAP": "NASDAQ",
  "FCBC": "NASDAQ",
  "FCBM": "NYSE",
  "FCCO": "NASDAQ",
  "FCEL": "NASDAQ",
  "FCF": "NYSE",
  "FCFS": "NASDAQ",
  "FCHL": "NASDAQ",
  "FCN": "NYSE",
  "FCNCA": "NASDAQ",
  "FCNCN": "NASDAQ",
  "FCNCO": "NASDAQ",
  "FCNCP": "NASDAQ",
  "FCPT": "NYSE",
  "FCRS": "NYSE",
  "FCT": "NYSE",
  "FCUV": "NASDAQ",
  "FCX": "NYSE",
  "FDBC": "NASDAQ",
  "FDMM": "NASDAQ",
  "FDMT": "NASDAQ",
  "FDS": "NYSE",
  "FDSB": "NASDAQ",
  "FDUS": "NASDAQ",
  "FDX": "NYSE",
  "FDXF": "NYSE",
  "FE": "NYSE",
  "FEAM": "NASDAQ",
  "FEBO": "NASDAQ",
  "FEDU": "NYSE",
  "FEED": "NASDAQ",
  "FEIM": "NASDAQ",
  "FELE": "NASDAQ",
  "FEMY": "NASDAQ",
  "FENC": "NASDAQ",
  "FENG": "NYSE",
  "FER": "NASDAQ",
  "FERA": "NASDAQ",
  "FERG": "NYSE",
  "FET": "NYSE",
  "FF": "NYSE",
  "FFA": "NYSE",
  "FFAI": "NASDAQ",
  "FFBC": "NASDAQ",
  "FFC": "NYSE",
  "FFIN": "NASDAQ",
  "FFIV": "NASDAQ",
  "FG": "NYSE",
  "FGBI": "NASDAQ",
  "FGBIP": "NASDAQ",
  "FGI": "NASDAQ",
  "FGII": "NASDAQ",
  "FGL": "NASDAQ",
  "FGNX": "NASDAQ",
  "FGNXP": "NASDAQ",
  "FHB": "NASDAQ",
  "FHI": "NYSE",
  "FHN": "NYSE",
  "FHN-P-E": "NYSE",
  "FHN-P-F": "NYSE",
  "FHN-P-H": "NYSE",
  "FHTX": "NASDAQ",
  "FIBK": "NASDAQ",
  "FICO": "NYSE",
  "FIEE": "NASDAQ",
  "FIG": "NYSE",
  "FIGR": "NASDAQ",
  "FIGS": "NYSE",
  "FIGX": "NASDAQ",
  "FINS": "NYSE",
  "FINV": "NYSE",
  "FINW": "NASDAQ",
  "FIP": "NASDAQ",
  "FIRY": "NYSE",
  "FIS": "NYSE",
  "FISI": "NASDAQ",
  "FISK": "NYSE",
  "FISN": "NASDAQ",
  "FISV": "NASDAQ",
  "FITB": "NYSE",
  "FITB-P-A": "NYSE",
  "FITB-P-I": "NYSE",
  "FITB-P-K": "NYSE",
  "FITB-P-M": "NYSE",
  "FIVE": "NASDAQ",
  "FIVN": "NASDAQ",
  "FIX": "NYSE",
  "FIZZ": "NASDAQ",
  "FJET": "NYSE",
  "FKWL": "NASDAQ",
  "FLC": "NYSE",
  "FLD": "NASDAQ",
  "FLEX": "NASDAQ",
  "FLG": "NYSE",
  "FLG-P-A": "NYSE",
  "FLGT": "NASDAQ",
  "FLL": "NASDAQ",
  "FLNA": "NASDAQ",
  "FLNC": "NASDAQ",
  "FLNG": "NYSE",
  "FLNT": "NASDAQ",
  "FLO": "NYSE",
  "FLOC": "NYSE",
  "FLR": "NYSE",
  "FLS": "NYSE",
  "FLUT": "NYSE",
  "FLUX": "NASDAQ",
  "FLWS": "NASDAQ",
  "FLX": "NASDAQ",
  "FLXS": "NASDAQ",
  "FLY": "NASDAQ",
  "FLYE": "NASDAQ",
  "FLYW": "NASDAQ",
  "FLYX": "NYSE",
  "FLZH": "NASDAQ",
  "FMAC": "NASDAQ",
  "FMAO": "NASDAQ",
  "FMBH": "NASDAQ",
  "FMC": "NYSE",
  "FMFC": "NASDAQ",
  "FMN": "NYSE",
  "FMNB": "NASDAQ",
  "FMS": "NYSE",
  "FMST": "NASDAQ",
  "FMX": "NYSE",
  "FMY": "NYSE",
  "FN": "NYSE",
  "FNB": "NYSE",
  "FND": "NYSE",
  "FNF": "NYSE",
  "FNGR": "NASDAQ",
  "FNKO": "NASDAQ",
  "FNLC": "NASDAQ",
  "FNRN": "NASDAQ",
  "FNUC": "NASDAQ",
  "FNV": "NYSE",
  "FNWB": "NASDAQ",
  "FNWD": "NASDAQ",
  "FOA": "NYSE",
  "FOCL": "NASDAQ",
  "FOF": "NYSE",
  "FOFO": "NASDAQ",
  "FOR": "NYSE",
  "FORM": "NASDAQ",
  "FORR": "NASDAQ",
  "FORTY": "NASDAQ",
  "FOSL": "NASDAQ",
  "FOUR": "NYSE",
  "FOUR-P-A": "NYSE",
  "FOX": "NASDAQ",
  "FOXA": "NASDAQ",
  "FOXF": "NASDAQ",
  "FOXX": "NASDAQ",
  "FPF": "NYSE",
  "FPH": "NYSE",
  "FPI": "NYSE",
  "FPS": "NYSE",
  "FR": "NYSE",
  "FRA": "NYSE",
  "FRAF": "NASDAQ",
  "FRBA": "NASDAQ",
  "FRBT": "NASDAQ",
  "FRD": "NASDAQ",
  "FRGT": "NASDAQ",
  "FRHC": "NASDAQ",
  "FRME": "NASDAQ",
  "FRMEP": "NASDAQ",
  "FRMI": "NASDAQ",
  "FRMM": "NASDAQ",
  "FRNM": "NASDAQ",
  "FRO": "NYSE",
  "FROG": "NASDAQ",
  "FRPH": "NASDAQ",
  "FRPT": "NASDAQ",
  "FRSH": "NASDAQ",
  "FRST": "NASDAQ",
  "FRSX": "NASDAQ",
  "FRT": "NYSE",
  "FRT-P-C": "NYSE",
  "FRTT": "NASDAQ",
  "FRVO": "NASDAQ",
  "FSBC": "NASDAQ",
  "FSBW": "NASDAQ",
  "FSCO": "NYSE",
  "FSEA": "NASDAQ",
  "FSHP": "NASDAQ",
  "FSI": "NYSE",
  "FSK": "NYSE",
  "FSLR": "NASDAQ",
  "FSLY": "NASDAQ",
  "FSM": "NYSE",
  "FSP": "NYSE",
  "FSS": "NYSE",
  "FSSL": "NYSE",
  "FSTR": "NASDAQ",
  "FSUN": "NASDAQ",
  "FSV": "NASDAQ",
  "FT": "NYSE",
  "FTAI": "NASDAQ",
  "FTAIM": "NASDAQ",
  "FTCI": "NASDAQ",
  "FTDR": "NASDAQ",
  "FTEK": "NASDAQ",
  "FTF": "NYSE",
  "FTFT": "NASDAQ",
  "FTH": "NASDAQ",
  "FTHA": "NASDAQ",
  "FTHM": "NASDAQ",
  "FTHY": "NYSE",
  "FTI": "NYSE",
  "FTK": "NYSE",
  "FTLF": "NASDAQ",
  "FTNT": "NASDAQ",
  "FTRA": "NYSE",
  "FTRE": "NASDAQ",
  "FTRK": "NASDAQ",
  "FTS": "NYSE",
  "FTV": "NYSE",
  "FTW": "NYSE",
  "FUBO": "NYSE",
  "FUFU": "NASDAQ",
  "FUL": "NYSE",
  "FULC": "NASDAQ",
  "FULT": "NASDAQ",
  "FULTP": "NASDAQ",
  "FUN": "NYSE",
  "FUNC": "NASDAQ",
  "FUND": "NASDAQ",
  "FURY": "NYSE",
  "FUSB": "NASDAQ",
  "FUSE": "NASDAQ",
  "FUTU": "NASDAQ",
  "FVAV": "NASDAQ",
  "FVCB": "NASDAQ",
  "FVN": "NASDAQ",
  "FVR": "NYSE",
  "FVRR": "NYSE",
  "FWAC": "NASDAQ",
  "FWDI": "NASDAQ",
  "FWONA": "NASDAQ",
  "FWONK": "NASDAQ",
  "FWRD": "NASDAQ",
  "FWRG": "NASDAQ",
  "FXAC": "NASDAQ",
  "FXHO": "NASDAQ",
  "FXNC": "NASDAQ",
  "G": "NYSE",
  "GAB": "NYSE",
  "GAB-P-G": "NYSE",
  "GAB-P-H": "NYSE",
  "GAB-P-K": "NYSE",
  "GABC": "NASDAQ",
  "GAIA": "NASDAQ",
  "GAIN": "NASDAQ",
  "GALT": "NASDAQ",
  "GAM": "NYSE",
  "GAM-P-B": "NYSE",
  "GAME": "NASDAQ",
  "GANX": "NASDAQ",
  "GAP": "NYSE",
  "GASS": "NASDAQ",
  "GATX": "NYSE",
  "GAU": "NYSE",
  "GAUZ": "NASDAQ",
  "GBAB": "NYSE",
  "GBCI": "NYSE",
  "GBDC": "NASDAQ",
  "GBFH": "NASDAQ",
  "GBLI": "NASDAQ",
  "GBR": "NYSE",
  "GBTG": "NYSE",
  "GBX": "NYSE",
  "GCBC": "NASDAQ",
  "GCDT": "NYSE",
  "GCGR": "NASDAQ",
  "GCL": "NASDAQ",
  "GCMG": "NASDAQ",
  "GCO": "NYSE",
  "GCT": "NASDAQ",
  "GCTK": "NASDAQ",
  "GCTS": "NYSE",
  "GCV": "NYSE",
  "GD": "NYSE",
  "GDC": "NASDAQ",
  "GDDY": "NYSE",
  "GDEV": "NASDAQ",
  "GDHG": "NASDAQ",
  "GDL": "NYSE",
  "GDO": "NYSE",
  "GDOT": "NYSE",
  "GDRX": "NASDAQ",
  "GDS": "NASDAQ",
  "GDTC": "NASDAQ",
  "GDV": "NYSE",
  "GDV-P-H": "NYSE",
  "GDV-P-K": "NYSE",
  "GDYN": "NASDAQ",
  "GE": "NYSE",
  "GECC": "NASDAQ",
  "GEF": "NYSE",
  "GEF-B": "NYSE",
  "GEG": "NASDAQ",
  "GEHC": "NASDAQ",
  "GEL": "NYSE",
  "GELS": "NASDAQ",
  "GEMI": "NASDAQ",
  "GEN": "NASDAQ",
  "GENB": "NASDAQ",
  "GENC": "NYSE",
  "GENI": "NYSE",
  "GENK": "NASDAQ",
  "GEO": "NYSE",
  "GEOS": "NASDAQ",
  "GERN": "NASDAQ",
  "GETY": "NYSE",
  "GEV": "NYSE",
  "GEVO": "NASDAQ",
  "GF": "NYSE",
  "GFAI": "NASDAQ",
  "GFF": "NYSE",
  "GFI": "NYSE",
  "GFL": "NYSE",
  "GFR": "NYSE",
  "GFS": "NASDAQ",
  "GFUZ": "NASDAQ",
  "GGAL": "NASDAQ",
  "GGB": "NYSE",
  "GGG": "NYSE",
  "GGN": "NYSE",
  "GGN-P-B": "NYSE",
  "GGR": "NASDAQ",
  "GGRP": "NASDAQ",
  "GGT": "NYSE",
  "GGT-P-E": "NYSE",
  "GGT-P-G": "NYSE",
  "GGZ": "NYSE",
  "GH": "NASDAQ",
  "GHC": "NYSE",
  "GHG": "NYSE",
  "GHI": "NYSE",
  "GHM": "NYSE",
  "GHRS": "NASDAQ",
  "GHY": "NYSE",
  "GIB": "NYSE",
  "GIBO": "NASDAQ",
  "GIC": "NYSE",
  "GIFT": "NASDAQ",
  "GIGM": "NASDAQ",
  "GIII": "NASDAQ",
  "GIL": "NYSE",
  "GILD": "NASDAQ",
  "GILT": "NASDAQ",
  "GIPR": "NASDAQ",
  "GIS": "NYSE",
  "GITS": "NASDAQ",
  "GIW": "NASDAQ",
  "GIX": "NASDAQ",
  "GJH": "NYSE",
  "GJO": "NYSE",
  "GJP": "NYSE",
  "GJR": "NYSE",
  "GJS": "NYSE",
  "GJT": "NYSE",
  "GKOS": "NYSE",
  "GL": "NYSE",
  "GLAD": "NASDAQ",
  "GLAS": "NYSE",
  "GLBE": "NASDAQ",
  "GLBS": "NASDAQ",
  "GLDG": "NYSE",
  "GLE": "NASDAQ",
  "GLED": "NYSE",
  "GLIBA": "NASDAQ",
  "GLIBK": "NASDAQ",
  "GLMD": "NASDAQ",
  "GLND": "NASDAQ",
  "GLNG": "NASDAQ",
  "GLO": "NYSE",
  "GLOB": "NYSE",
  "GLOO": "NASDAQ",
  "GLOP-P-A": "NYSE",
  "GLOP-P-B": "NYSE",
  "GLOP-P-C": "NYSE",
  "GLP": "NYSE",
  "GLPI": "NASDAQ",
  "GLQ": "NYSE",
  "GLRE": "NASDAQ",
  "GLSI": "NASDAQ",
  "GLU": "NYSE",
  "GLU-P-A": "NYSE",
  "GLU-P-B": "NYSE",
  "GLUE": "NASDAQ",
  "GLV": "NYSE",
  "GLW": "NYSE",
  "GLXG": "NASDAQ",
  "GLXY": "NASDAQ",
  "GM": "NYSE",
  "GMAB": "NASDAQ",
  "GME": "NYSE",
  "GMED": "NYSE",
  "GMEX": "NASDAQ",
  "GMHS": "NASDAQ",
  "GMM": "NASDAQ",
  "GMRS": "NYSE",
  "GMTL": "NYSE",
  "GNE": "NYSE",
  "GNK": "NYSE",
  "GNL": "NYSE",
  "GNL-P-A": "NYSE",
  "GNL-P-B": "NYSE",
  "GNL-P-D": "NYSE",
  "GNL-P-E": "NYSE",
  "GNLN": "NASDAQ",
  "GNLX": "NASDAQ",
  "GNPX": "NASDAQ",
  "GNRC": "NYSE",
  "GNS": "NYSE",
  "GNSS": "NASDAQ",
  "GNT": "NYSE",
  "GNT-P-A": "NYSE",
  "GNTA": "NASDAQ",
  "GNTX": "NASDAQ",
  "GNW": "NYSE",
  "GO": "NASDAQ",
  "GOAI": "NASDAQ",
  "GOF": "NYSE",
  "GOGO": "NASDAQ",
  "GOLD": "NYSE",
  "GOLF": "NYSE",
  "GOOD": "NASDAQ",
  "GOODN": "NASDAQ",
  "GOODO": "NASDAQ",
  "GOOG": "NASDAQ",
  "GOOGL": "NASDAQ",
  "GOOGM": "NASDAQ",
  "GOOGN": "NASDAQ",
  "GOOS": "NYSE",
  "GORO": "NYSE",
  "GOSS": "NASDAQ",
  "GOTU": "NYSE",
  "GOVX": "NASDAQ",
  "GP": "NASDAQ",
  "GPAC": "NASDAQ",
  "GPAT": "NASDAQ",
  "GPC": "NYSE",
  "GPCR": "NASDAQ",
  "GPGI": "NYSE",
  "GPI": "NYSE",
  "GPK": "NYSE",
  "GPMT": "NYSE",
  "GPMT-P-A": "NYSE",
  "GPN": "NYSE",
  "GPOR": "NYSE",
  "GPRE": "NASDAQ",
  "GPRK": "NYSE",
  "GPRO": "NASDAQ",
  "GPUS": "NYSE",
  "GPUS-P-D": "NYSE",
  "GRAB": "NASDAQ",
  "GRAL": "NASDAQ",
  "GRAN": "NASDAQ",
  "GRBK": "NYSE",
  "GRBK-P-A": "NYSE",
  "GRC": "NYSE",
  "GRCE": "NASDAQ",
  "GRDN": "NYSE",
  "GRDX": "NASDAQ",
  "GRF": "NYSE",
  "GRFS": "NASDAQ",
  "GRI": "NASDAQ",
  "GRML": "NASDAQ",
  "GRMN": "NYSE",
  "GRND": "NYSE",
  "GRNQ": "NASDAQ",
  "GRNT": "NYSE",
  "GRO": "NYSE",
  "GROV": "NYSE",
  "GROW": "NASDAQ",
  "GROY": "NYSE",
  "GRPN": "NASDAQ",
  "GRRR": "NASDAQ",
  "GRSD": "NASDAQ",
  "GRVY": "NASDAQ",
  "GRWG": "NASDAQ",
  "GRX": "NYSE",
  "GS": "NYSE",
  "GS-P-A": "NYSE",
  "GS-P-C": "NYSE",
  "GS-P-D": "NYSE",
  "GSAT": "NASDAQ",
  "GSBC": "NASDAQ",
  "GSBD": "NYSE",
  "GSHD": "NASDAQ",
  "GSHR": "NASDAQ",
  "GSIT": "NASDAQ",
  "GSIW": "NASDAQ",
  "GSK": "NYSE",
  "GSL": "NYSE",
  "GSL-P-B": "NYSE",
  "GSM": "NASDAQ",
  "GSRF": "NASDAQ",
  "GSRV": "NASDAQ",
  "GSUN": "NASDAQ",
  "GT": "NASDAQ",
  "GTBP": "NASDAQ",
  "GTE": "NYSE",
  "GTEC": "NASDAQ",
  "GTEN": "NASDAQ",
  "GTERA": "NASDAQ",
  "GTES": "NYSE",
  "GTIM": "NASDAQ",
  "GTLB": "NASDAQ",
  "GTM": "NASDAQ",
  "GTN": "NYSE",
  "GTN-A": "NYSE",
  "GTX": "NASDAQ",
  "GTY": "NYSE",
  "GUAC": "NASDAQ",
  "GUG": "NYSE",
  "GURE": "NASDAQ",
  "GUT": "NYSE",
  "GUT-P-C": "NYSE",
  "GUTS": "NASDAQ",
  "GVA": "NYSE",
  "GVH": "NASDAQ",
  "GWAV": "NASDAQ",
  "GWH": "NYSE",
  "GWRE": "NYSE",
  "GWRS": "NASDAQ",
  "GWW": "NYSE",
  "GXAI": "NASDAQ",
  "GXO": "NYSE",
  "GYGY": "NASDAQ",
  "GYRE": "NASDAQ",
  "GYRO": "NASDAQ",
  "H": "NYSE",
  "HACQ": "NASDAQ",
  "HAE": "NYSE",
  "HAFC": "NASDAQ",
  "HAFN": "NYSE",
  "HAIN": "NASDAQ",
  "HAL": "NYSE",
  "HALO": "NASDAQ",
  "HAO": "NASDAQ",
  "HAPN": "NASDAQ",
  "HAS": "NASDAQ",
  "HASI": "NYSE",
  "HAVA": "NASDAQ",
  "HAWK": "NYSE",
  "HAYW": "NYSE",
  "HBAN": "NASDAQ",
  "HBANL": "NASDAQ",
  "HBANM": "NASDAQ",
  "HBANP": "NASDAQ",
  "HBANZ": "NASDAQ",
  "HBB": "NYSE",
  "HBCP": "NASDAQ",
  "HBIO": "NASDAQ",
  "HBM": "NYSE",
  "HBNB": "NASDAQ",
  "HBNC": "NASDAQ",
  "HBT": "NASDAQ",
  "HCA": "NYSE",
  "HCAC": "NASDAQ",
  "HCAI": "NASDAQ",
  "HCAT": "NASDAQ",
  "HCC": "NYSE",
  "HCHL": "NASDAQ",
  "HCI": "NYSE",
  "HCIC": "NASDAQ",
  "HCKT": "NASDAQ",
  "HCM": "NASDAQ",
  "HCMA": "NASDAQ",
  "HCSG": "NASDAQ",
  "HCTI": "NASDAQ",
  "HCWB": "NASDAQ",
  "HCWC": "NYSE",
  "HD": "NYSE",
  "HDB": "NYSE",
  "HDL": "NASDAQ",
  "HDRN": "NASDAQ",
  "HDSN": "NASDAQ",
  "HE": "NYSE",
  "HEI": "NYSE",
  "HEI-A": "NYSE",
  "HELE": "NASDAQ",
  "HELP": "NASDAQ",
  "HEPS": "NASDAQ",
  "HEQ": "NYSE",
  "HERE": "NASDAQ",
  "HERZ": "NASDAQ",
  "HESM": "NYSE",
  "HFBL": "NASDAQ",
  "HFFG": "NASDAQ",
  "HFRO": "NYSE",
  "HFRO-P-A": "NYSE",
  "HFRO-P-B": "NYSE",
  "HFWA": "NASDAQ",
  "HG": "NYSE",
  "HGBL": "NASDAQ",
  "HGLB": "NYSE",
  "HGTY": "NYSE",
  "HGV": "NYSE",
  "HHH": "NYSE",
  "HHS": "NASDAQ",
  "HIFS": "NASDAQ",
  "HIG": "NYSE",
  "HIG-P-G": "NYSE",
  "HIHO": "NASDAQ",
  "HII": "NYSE",
  "HIMS": "NYSE",
  "HIMX": "NASDAQ",
  "HIND": "NASDAQ",
  "HIO": "NYSE",
  "HIPO": "NYSE",
  "HIT": "NASDAQ",
  "HITI": "NASDAQ",
  "HIVE": "NASDAQ",
  "HIW": "NYSE",
  "HIX": "NYSE",
  "HKD": "NYSE",
  "HKIT": "NASDAQ",
  "HKPD": "NASDAQ",
  "HL": "NYSE",
  "HL-P-B": "NYSE",
  "HLF": "NYSE",
  "HLI": "NYSE",
  "HLIO": "NYSE",
  "HLIT": "NASDAQ",
  "HLLY": "NYSE",
  "HLMN": "NASDAQ",
  "HLN": "NYSE",
  "HLNE": "NASDAQ",
  "HLP": "NASDAQ",
  "HLT": "NYSE",
  "HLX": "NYSE",
  "HLXC": "NASDAQ",
  "HMC": "NYSE",
  "HMH": "NASDAQ",
  "HMN": "NYSE",
  "HMR": "NASDAQ",
  "HMY": "NYSE",
  "HNGE": "NYSE",
  "HNI": "NYSE",
  "HNNA": "NASDAQ",
  "HNRG": "NASDAQ",
  "HNST": "NASDAQ",
  "HNVR": "NASDAQ",
  "HODO": "NASDAQ",
  "HOFT": "NASDAQ",
  "HOG": "NYSE",
  "HOLO": "NASDAQ",
  "HOMB": "NYSE",
  "HON": "NASDAQ",
  "HONA": "NASDAQ",
  "HOOD": "NASDAQ",
  "HOPE": "NASDAQ",
  "HOUR": "NASDAQ",
  "HOV": "NYSE",
  "HOVNP": "NASDAQ",
  "HOVR": "NASDAQ",
  "HOWL": "NASDAQ",
  "HP": "NYSE",
  "HPAI": "NASDAQ",
  "HPE": "NYSE",
  "HPE-P-C": "NYSE",
  "HPF": "NYSE",
  "HPI": "NYSE",
  "HPK": "NASDAQ",
  "HPP": "NYSE",
  "HPP-P-C": "NYSE",
  "HPQ": "NYSE",
  "HPS": "NYSE",
  "HQ": "NASDAQ",
  "HQH": "NYSE",
  "HQI": "NASDAQ",
  "HQL": "NYSE",
  "HQY": "NASDAQ",
  "HR": "NYSE",
  "HRB": "NYSE",
  "HRI": "NYSE",
  "HRL": "NYSE",
  "HRMY": "NASDAQ",
  "HROW": "NASDAQ",
  "HRTG": "NYSE",
  "HRTX": "NASDAQ",
  "HRZN": "NASDAQ",
  "HSAI": "NASDAQ",
  "HSBC": "NYSE",
  "HSCS": "NASDAQ",
  "HSDT": "NASDAQ",
  "HSHP": "NYSE",
  "HSIC": "NASDAQ",
  "HSLV": "NYSE",
  "HST": "NASDAQ",
  "HSTM": "NASDAQ",
  "HSY": "NYSE",
  "HTB": "NYSE",
  "HTCO": "NASDAQ",
  "HTCR": "NASDAQ",
  "HTD": "NYSE",
  "HTFL": "NASDAQ",
  "HTGC": "NYSE",
  "HTH": "NYSE",
  "HTHT": "NASDAQ",
  "HTLD": "NASDAQ",
  "HTLM": "NASDAQ",
  "HTO": "NASDAQ",
  "HTOO": "NASDAQ",
  "HTT": "NYSE",
  "HTZ": "NASDAQ",
  "HUBB": "NYSE",
  "HUBC": "NASDAQ",
  "HUBG": "NASDAQ",
  "HUBS": "NYSE",
  "HUDI": "NASDAQ",
  "HUHU": "NASDAQ",
  "HUIZ": "NASDAQ",
  "HUM": "NYSE",
  "HUMA": "NASDAQ",
  "HUN": "NYSE",
  "HURA": "NASDAQ",
  "HURC": "NASDAQ",
  "HURN": "NASDAQ",
  "HUT": "NASDAQ",
  "HUYA": "NYSE",
  "HVII": "NASDAQ",
  "HVMC": "NASDAQ",
  "HVT": "NYSE",
  "HVT-A": "NYSE",
  "HWBK": "NASDAQ",
  "HWC": "NASDAQ",
  "HWH": "NASDAQ",
  "HWKN": "NASDAQ",
  "HWM": "NYSE",
  "HXHX": "NASDAQ",
  "HXL": "NYSE",
  "HY": "NYSE",
  "HYFM": "NASDAQ",
  "HYFT": "NASDAQ",
  "HYI": "NYSE",
  "HYLN": "NYSE",
  "HYMC": "NASDAQ",
  "HYNE": "NASDAQ",
  "HYPD": "NASDAQ",
  "HYPR": "NASDAQ",
  "HYT": "NYSE",
  "HZO": "NYSE",
  "IACO": "NASDAQ",
  "IACQ": "NASDAQ",
  "IAE": "NYSE",
  "IAF": "NYSE",
  "IAG": "NYSE",
  "IART": "NASDAQ",
  "IAUX": "NYSE",
  "IBAC": "NASDAQ",
  "IBCP": "NASDAQ",
  "IBEX": "NASDAQ",
  "IBG": "NASDAQ",
  "IBIO": "NASDAQ",
  "IBKR": "NASDAQ",
  "IBM": "NYSE",
  "IBN": "NYSE",
  "IBO": "NYSE",
  "IBOC": "NASDAQ",
  "IBP": "NYSE",
  "IBRX": "NASDAQ",
  "IBTA": "NYSE",
  "ICCC": "NASDAQ",
  "ICCM": "NASDAQ",
  "ICE": "NYSE",
  "ICFI": "NASDAQ",
  "ICG": "NASDAQ",
  "ICHR": "NASDAQ",
  "ICL": "NYSE",
  "ICLR": "NASDAQ",
  "ICMB": "NASDAQ",
  "ICON": "NASDAQ",
  "ICR-P-A": "NYSE",
  "ICU": "NASDAQ",
  "ICUI": "NASDAQ",
  "IDA": "NYSE",
  "IDAC": "NASDAQ",
  "IDAI": "NASDAQ",
  "IDCC": "NASDAQ",
  "IDE": "NYSE",
  "IDN": "NASDAQ",
  "IDR": "NYSE",
  "IDT": "NYSE",
  "IDXX": "NASDAQ",
  "IDYA": "NASDAQ",
  "IE": "NYSE",
  "IEAG": "NASDAQ",
  "IEP": "NASDAQ",
  "IESC": "NASDAQ",
  "IEX": "NYSE",
  "IFBD": "NASDAQ",
  "IFF": "NYSE",
  "IFN": "NYSE",
  "IFRX": "NASDAQ",
  "IFS": "NYSE",
  "IGA": "NYSE",
  "IGAC": "NASDAQ",
  "IGC": "NYSE",
  "IGD": "NYSE",
  "IGI": "NYSE",
  "IGIC": "NASDAQ",
  "IGR": "NYSE",
  "IH": "NYSE",
  "IHD": "NYSE",
  "IHG": "NYSE",
  "IHRT": "NASDAQ",
  "IHS": "NYSE",
  "IHT": "NYSE",
  "IIF": "NYSE",
  "III": "NASDAQ",
  "IIIN": "NYSE",
  "IIIV": "NASDAQ",
  "IIM": "NYSE",
  "IIPR": "NYSE",
  "IIPR-P-A": "NYSE",
  "IKT": "NASDAQ",
  "ILAG": "NASDAQ",
  "ILLR": "NASDAQ",
  "ILLU": "NASDAQ",
  "ILMN": "NASDAQ",
  "ILPT": "NASDAQ",
  "IMA": "NASDAQ",
  "IMAX": "NYSE",
  "IMC": "NYSE",
  "IMCC": "NASDAQ",
  "IMCR": "NASDAQ",
  "IMDX": "NASDAQ",
  "IMKTA": "NASDAQ",
  "IMMP": "NASDAQ",
  "IMMR": "NASDAQ",
  "IMMX": "NASDAQ",
  "IMNM": "NASDAQ",
  "IMNN": "NASDAQ",
  "IMO": "NYSE",
  "IMOS": "NASDAQ",
  "IMPP": "NASDAQ",
  "IMPPP": "NASDAQ",
  "IMRN": "NASDAQ",
  "IMRX": "NASDAQ",
  "IMSR": "NASDAQ",
  "IMTE": "NASDAQ",
  "IMTX": "NASDAQ",
  "IMUX": "NASDAQ",
  "IMVT": "NASDAQ",
  "IMXI": "NASDAQ",
  "INAB": "NASDAQ",
  "INAC": "NASDAQ",
  "INBK": "NASDAQ",
  "INBS": "NASDAQ",
  "INBX": "NASDAQ",
  "INCR": "NASDAQ",
  "INCY": "NASDAQ",
  "INDB": "NASDAQ",
  "INDI": "NASDAQ",
  "INDO": "NYSE",
  "INDP": "NASDAQ",
  "INDV": "NASDAQ",
  "INEO": "NASDAQ",
  "INFQ": "NYSE",
  "INFU": "NYSE",
  "INFY": "NYSE",
  "ING": "NYSE",
  "INGM": "NYSE",
  "INGN": "NASDAQ",
  "INGR": "NYSE",
  "INHD": "NASDAQ",
  "INIO": "NASDAQ",
  "INKT": "NASDAQ",
  "INLF": "NASDAQ",
  "INLX": "NYSE",
  "INM": "NASDAQ",
  "INMB": "NASDAQ",
  "INMD": "NASDAQ",
  "INN": "NYSE",
  "INN-P-E": "NYSE",
  "INN-P-F": "NYSE",
  "INNV": "NASDAQ",
  "INO": "NASDAQ",
  "INOD": "NASDAQ",
  "INR": "NYSE",
  "INSE": "NASDAQ",
  "INSG": "NASDAQ",
  "INSM": "NASDAQ",
  "INSP": "NYSE",
  "INSW": "NYSE",
  "INTA": "NASDAQ",
  "INTC": "NASDAQ",
  "INTG": "NASDAQ",
  "INTJ": "NASDAQ",
  "INTR": "NASDAQ",
  "INTS": "NASDAQ",
  "INTT": "NYSE",
  "INTU": "NASDAQ",
  "INTZ": "NASDAQ",
  "INUV": "NYSE",
  "INV": "NASDAQ",
  "INVA": "NASDAQ",
  "INVE": "NASDAQ",
  "INVH": "NYSE",
  "INVX": "NYSE",
  "INVZ": "NASDAQ",
  "IOND": "NASDAQ",
  "IONQ": "NYSE",
  "IONR": "NASDAQ",
  "IONS": "NASDAQ",
  "IOR": "NYSE",
  "IOSP": "NASDAQ",
  "IOT": "NYSE",
  "IOTR": "NASDAQ",
  "IOVA": "NASDAQ",
  "IP": "NYSE",
  "IPAR": "NASDAQ",
  "IPCX": "NASDAQ",
  "IPDN": "NASDAQ",
  "IPEX": "NASDAQ",
  "IPFX": "NASDAQ",
  "IPGP": "NASDAQ",
  "IPHA": "NASDAQ",
  "IPI": "NYSE",
  "IPM": "NASDAQ",
  "IPSC": "NASDAQ",
  "IPST": "NASDAQ",
  "IPVV": "NASDAQ",
  "IPW": "NASDAQ",
  "IPWR": "NASDAQ",
  "IPX": "NASDAQ",
  "IQ": "NASDAQ",
  "IQI": "NYSE",
  "IQMX": "NASDAQ",
  "IQST": "NASDAQ",
  "IQV": "NYSE",
  "IR": "NYSE",
  "IRAB": "NYSE",
  "IRD": "NASDAQ",
  "IRDM": "NASDAQ",
  "IREN": "NASDAQ",
  "IRHO": "NASDAQ",
  "IRIX": "NASDAQ",
  "IRM": "NYSE",
  "IRMD": "NASDAQ",
  "IRON": "NASDAQ",
  "IRS": "NYSE",
  "IRT": "NYSE",
  "IRTC": "NASDAQ",
  "IRWD": "NASDAQ",
  "ISBA": "NASDAQ",
  "ISD": "NYSE",
  "ISNR": "NASDAQ",
  "ISOU": "NYSE",
  "ISPC": "NASDAQ",
  "ISPR": "NASDAQ",
  "ISRG": "NASDAQ",
  "ISSC": "NASDAQ",
  "ISTR": "NASDAQ",
  "IT": "NYSE",
  "ITG": "NASDAQ",
  "ITGR": "NYSE",
  "ITHA": "NASDAQ",
  "ITIC": "NASDAQ",
  "ITOC": "NASDAQ",
  "ITP": "NYSE",
  "ITRG": "NYSE",
  "ITRI": "NASDAQ",
  "ITRN": "NASDAQ",
  "ITT": "NYSE",
  "ITUB": "NYSE",
  "ITW": "NYSE",
  "IVA": "NASDAQ",
  "IVDA": "NASDAQ",
  "IVF": "NASDAQ",
  "IVR": "NYSE",
  "IVR-P-C": "NYSE",
  "IVT": "NYSE",
  "IVVD": "NASDAQ",
  "IVZ": "NYSE",
  "IX": "NYSE",
  "IXHL": "NASDAQ",
  "IZEA": "NASDAQ",
  "IZM": "NASDAQ",
  "J": "NYSE",
  "JAB": "NASDAQ",
  "JACK": "NASDAQ",
  "JACS": "NYSE",
  "JAGU": "NYSE",
  "JAGX": "NASDAQ",
  "JAKK": "NASDAQ",
  "JAN": "NYSE",
  "JANX": "NASDAQ",
  "JATT": "NASDAQ",
  "JAZZ": "NASDAQ",
  "JBDI": "NASDAQ",
  "JBGS": "NYSE",
  "JBHT": "NASDAQ",
  "JBI": "NYSE",
  "JBIO": "NASDAQ",
  "JBK": "NYSE",
  "JBL": "NYSE",
  "JBLU": "NASDAQ",
  "JBS": "NYSE",
  "JBSS": "NASDAQ",
  "JBTM": "NYSE",
  "JCAP": "NASDAQ",
  "JCE": "NYSE",
  "JCI": "NYSE",
  "JCSE": "NASDAQ",
  "JCTC": "NASDAQ",
  "JD": "NASDAQ",
  "JDZG": "NASDAQ",
  "JEF": "NYSE",
  "JELD": "NYSE",
  "JEM": "NASDAQ",
  "JENA": "NYSE",
  "JF": "NASDAQ",
  "JFB": "NASDAQ",
  "JFIN": "NASDAQ",
  "JFR": "NYSE",
  "JFU": "NASDAQ",
  "JG": "NASDAQ",
  "JGH": "NYSE",
  "JHI": "NYSE",
  "JHS": "NYSE",
  "JHX": "NYSE",
  "JILL": "NYSE",
  "JJSF": "NASDAQ",
  "JKHY": "NASDAQ",
  "JKS": "NYSE",
  "JL": "NASDAQ",
  "JLHL": "NASDAQ",
  "JLL": "NYSE",
  "JLS": "NYSE",
  "JMIA": "NYSE",
  "JMKE": "NYSE",
  "JMM": "NYSE",
  "JMSB": "NASDAQ",
  "JNJ": "NYSE",
  "JOB": "NYSE",
  "JOBY": "NYSE",
  "JOE": "NYSE",
  "JOF": "NYSE",
  "JOUT": "NASDAQ",
  "JOYY": "NASDAQ",
  "JPC": "NYSE",
  "JPM": "NYSE",
  "JPM-P-C": "NYSE",
  "JPM-P-D": "NYSE",
  "JPM-P-J": "NYSE",
  "JPM-P-K": "NYSE",
  "JPM-P-L": "NYSE",
  "JPM-P-M": "NYSE",
  "JQC": "NYSE",
  "JRI": "NYSE",
  "JRS": "NYSE",
  "JRSH": "NASDAQ",
  "JRVR": "NASDAQ",
  "JSPR": "NASDAQ",
  "JTAI": "NASDAQ",
  "JUNS": "NASDAQ",
  "JVA": "NASDAQ",
  "JWEL": "NASDAQ",
  "JXG": "NASDAQ",
  "JXN": "NYSE",
  "JXN-P-A": "NYSE",
  "JYD": "NASDAQ",
  "JYNT": "NASDAQ",
  "JZ": "NASDAQ",
  "JZXN": "NASDAQ",
  "KAI": "NYSE",
  "KALA": "NASDAQ",
  "KALU": "NASDAQ",
  "KAPA": "NYSE",
  "KARD": "NASDAQ",
  "KARO": "NASDAQ",
  "KAZR": "NASDAQ",
  "KB": "NYSE",
  "KBDC": "NYSE",
  "KBH": "NYSE",
  "KBON": "NASDAQ",
  "KBR": "NYSE",
  "KBSX": "NASDAQ",
  "KC": "NASDAQ",
  "KCHV": "NASDAQ",
  "KD": "NYSE",
  "KDK": "NASDAQ",
  "KDP": "NASDAQ",
  "KE": "NASDAQ",
  "KEEL": "NASDAQ",
  "KELYA": "NASDAQ",
  "KELYB": "NASDAQ",
  "KEN": "NYSE",
  "KEP": "NYSE",
  "KEQU": "NASDAQ",
  "KEX": "NYSE",
  "KEY": "NYSE",
  "KEY-P-I": "NYSE",
  "KEY-P-J": "NYSE",
  "KEY-P-K": "NYSE",
  "KEY-P-L": "NYSE",
  "KEYS": "NYSE",
  "KEYY": "NASDAQ",
  "KF": "NYSE",
  "KFFB": "NASDAQ",
  "KFII": "NASDAQ",
  "KFRC": "NYSE",
  "KFY": "NYSE",
  "KG": "NASDAQ",
  "KGC": "NYSE",
  "KGEI": "NASDAQ",
  "KGS": "NYSE",
  "KHC": "NASDAQ",
  "KIDS": "NASDAQ",
  "KIDZ": "NASDAQ",
  "KIM": "NYSE",
  "KIM-P-L": "NYSE",
  "KIM-P-M": "NYSE",
  "KIM-P-N": "NYSE",
  "KINS": "NASDAQ",
  "KIO": "NYSE",
  "KITT": "NASDAQ",
  "KKR": "NYSE",
  "KKR-P-D": "NYSE",
  "KLAC": "NASDAQ",
  "KLAR": "NYSE",
  "KLC": "NYSE",
  "KLIC": "NASDAQ",
  "KLRA": "NASDAQ",
  "KLRS": "NASDAQ",
  "KLTR": "NASDAQ",
  "KLXE": "NASDAQ",
  "KMB": "NASDAQ",
  "KMDA": "NASDAQ",
  "KMI": "NYSE",
  "KMPR": "NYSE",
  "KMRK": "NASDAQ",
  "KMT": "NYSE",
  "KMTS": "NASDAQ",
  "KMX": "NYSE",
  "KN": "NYSE",
  "KNDI": "NASDAQ",
  "KNF": "NYSE",
  "KNOP": "NYSE",
  "KNRX": "NYSE",
  "KNSA": "NASDAQ",
  "KNSL": "NYSE",
  "KNTK": "NYSE",
  "KNX": "NYSE",
  "KO": "NYSE",
  "KOD": "NASDAQ",
  "KODK": "NYSE",
  "KOF": "NYSE",
  "KOP": "NYSE",
  "KOPN": "NASDAQ",
  "KOS": "NYSE",
  "KOSS": "NASDAQ",
  "KOYN": "NASDAQ",
  "KPET": "NYSE",
  "KPLT": "NASDAQ",
  "KPRX": "NASDAQ",
  "KPTI": "NASDAQ",
  "KR": "NYSE",
  "KRAQ": "NASDAQ",
  "KRC": "NYSE",
  "KREF": "NYSE",
  "KREF-P-A": "NYSE",
  "KRG": "NYSE",
  "KRKR": "NASDAQ",
  "KRMD": "NASDAQ",
  "KRMN": "NYSE",
  "KRNT": "NASDAQ",
  "KRNY": "NASDAQ",
  "KRO": "NYSE",
  "KROS": "NASDAQ",
  "KRP": "NYSE",
  "KRRO": "NASDAQ",
  "KRSP": "NYSE",
  "KRT": "NASDAQ",
  "KRUS": "NASDAQ",
  "KRYS": "NASDAQ",
  "KSCP": "NASDAQ",
  "KSPI": "NASDAQ",
  "KSS": "NYSE",
  "KT": "NYSE",
  "KTB": "NYSE",
  "KTCC": "NASDAQ",
  "KTF": "NYSE",
  "KTH": "NYSE",
  "KTN": "NYSE",
  "KTOS": "NASDAQ",
  "KTTA": "NASDAQ",
  "KTWO": "NASDAQ",
  "KULR": "NYSE",
  "KURA": "NASDAQ",
  "KUST": "NASDAQ",
  "KVHI": "NASDAQ",
  "KVUE": "NYSE",
  "KVYO": "NYSE",
  "KWM": "NASDAQ",
  "KWR": "NYSE",
  "KWY": "NYSE",
  "KXIN": "NASDAQ",
  "KYIV": "NASDAQ",
  "KYMR": "NASDAQ",
  "KYN": "NYSE",
  "KYNB": "NASDAQ",
  "KYTX": "NASDAQ",
  "KZIA": "NASDAQ",
  "L": "NYSE",
  "LAB": "NASDAQ",
  "LABT": "NASDAQ",
  "LAC": "NYSE",
  "LAD": "NYSE",
  "LADR": "NYSE",
  "LAES": "NASDAQ",
  "LAFA": "NASDAQ",
  "LAKE": "NASDAQ",
  "LAMR": "NASDAQ",
  "LAND": "NASDAQ",
  "LANDO": "NASDAQ",
  "LANDP": "NASDAQ",
  "LANV": "NYSE",
  "LAR": "NYSE",
  "LARK": "NASDAQ",
  "LASE": "NASDAQ",
  "LASR": "NASDAQ",
  "LATA": "NASDAQ",
  "LAUR": "NASDAQ",
  "LAW": "NYSE",
  "LAWR": "NASDAQ",
  "LAZ": "NYSE",
  "LB": "NYSE",
  "LBGJ": "NASDAQ",
  "LBRDA": "NASDAQ",
  "LBRDK": "NASDAQ",
  "LBRDP": "NASDAQ",
  "LBRT": "NYSE",
  "LBRX": "NASDAQ",
  "LBTYA": "NASDAQ",
  "LBTYB": "NASDAQ",
  "LBTYK": "NASDAQ",
  "LCCC": "NASDAQ",
  "LCFY": "NASDAQ",
  "LCID": "NASDAQ",
  "LCII": "NYSE",
  "LCLN": "NYSE",
  "LCNB": "NASDAQ",
  "LCTX": "NYSE",
  "LCUT": "NASDAQ",
  "LDI": "NYSE",
  "LDOS": "NYSE",
  "LDP": "NYSE",
  "LE": "NASDAQ",
  "LEA": "NYSE",
  "LECO": "NASDAQ",
  "LEDS": "NASDAQ",
  "LEE": "NASDAQ",
  "LEG": "NYSE",
  "LEGH": "NASDAQ",
  "LEGN": "NASDAQ",
  "LEGO": "NYSE",
  "LEN": "NYSE",
  "LEN-B": "NYSE",
  "LENZ": "NASDAQ",
  "LEO": "NYSE",
  "LESL": "NASDAQ",
  "LEU": "NYSE",
  "LEVI": "NYSE",
  "LEXX": "NASDAQ",
  "LFAC": "NASDAQ",
  "LFCR": "NASDAQ",
  "LFMD": "NASDAQ",
  "LFMDP": "NASDAQ",
  "LFS": "NASDAQ",
  "LFST": "NASDAQ",
  "LFT": "NYSE",
  "LFT-P-A": "NYSE",
  "LFTO": "NASDAQ",
  "LFUS": "NASDAQ",
  "LFVN": "NASDAQ",
  "LFWD": "NASDAQ",
  "LGCL": "NASDAQ",
  "LGCY": "NYSE",
  "LGHL": "NASDAQ",
  "LGI": "NYSE",
  "LGIH": "NASDAQ",
  "LGL": "NYSE",
  "LGN": "NASDAQ",
  "LGND": "NASDAQ",
  "LGO": "NASDAQ",
  "LGPS": "NYSE",
  "LGVN": "NASDAQ",
  "LH": "NYSE",
  "LHAI": "NASDAQ",
  "LHSW": "NASDAQ",
  "LHX": "NYSE",
  "LI": "NASDAQ",
  "LICN": "NASDAQ",
  "LIDR": "NASDAQ",
  "LIEN": "NASDAQ",
  "LIF": "NASDAQ",
  "LIFE": "NASDAQ",
  "LII": "NYSE",
  "LILA": "NASDAQ",
  "LILAK": "NASDAQ",
  "LILAP": "NASDAQ",
  "LIME": "NASDAQ",
  "LIMN": "NASDAQ",
  "LIN": "NASDAQ",
  "LINC": "NASDAQ",
  "LIND": "NASDAQ",
  "LINE": "NASDAQ",
  "LINK": "NASDAQ",
  "LION": "NYSE",
  "LIQT": "NASDAQ",
  "LITB": "NYSE",
  "LITE": "NASDAQ",
  "LITS": "NASDAQ",
  "LIVE": "NASDAQ",
  "LIVN": "NASDAQ",
  "LKFN": "NASDAQ",
  "LKFT": "NASDAQ",
  "LKQ": "NASDAQ",
  "LKSP": "NASDAQ",
  "LLY": "NYSE",
  "LLYVA": "NASDAQ",
  "LLYVK": "NASDAQ",
  "LMAT": "NASDAQ",
  "LMB": "NASDAQ",
  "LMND": "NYSE",
  "LMNR": "NASDAQ",
  "LMRI": "NASDAQ",
  "LMT": "NYSE",
  "LNAI": "NASDAQ",
  "LNC": "NYSE",
  "LNC-P-D": "NYSE",
  "LND": "NYSE",
  "LNG": "NYSE",
  "LNKS": "NASDAQ",
  "LNN": "NYSE",
  "LNSR": "NASDAQ",
  "LNT": "NASDAQ",
  "LNTH": "NASDAQ",
  "LNZA": "NASDAQ",
  "LOAN": "NASDAQ",
  "LOAR": "NYSE",
  "LOB": "NYSE",
  "LOB-P-A": "NYSE",
  "LOBO": "NASDAQ",
  "LOCL": "NYSE",
  "LOCO": "NASDAQ",
  "LODE": "NYSE",
  "LOGI": "NASDAQ",
  "LOMA": "NYSE",
  "LONA": "NASDAQ",
  "LOOP": "NASDAQ",
  "LOPE": "NASDAQ",
  "LOT": "NASDAQ",
  "LOVE": "NASDAQ",
  "LOW": "NYSE",
  "LPA": "NYSE",
  "LPAA": "NASDAQ",
  "LPBB": "NASDAQ",
  "LPCN": "NASDAQ",
  "LPCV": "NASDAQ",
  "LPG": "NYSE",
  "LPL": "NYSE",
  "LPLA": "NASDAQ",
  "LPSN": "NASDAQ",
  "LPTH": "NASDAQ",
  "LPX": "NYSE",
  "LQDA": "NASDAQ",
  "LQDT": "NASDAQ",
  "LRCX": "NASDAQ",
  "LRE": "NASDAQ",
  "LRHC": "NASDAQ",
  "LRMR": "NASDAQ",
  "LRN": "NYSE",
  "LSAK": "NASDAQ",
  "LSBK": "NASDAQ",
  "LSCC": "NASDAQ",
  "LSE": "NASDAQ",
  "LSF": "NYSE",
  "LSPD": "NYSE",
  "LSTA": "NASDAQ",
  "LSTR": "NASDAQ",
  "LTBR": "NASDAQ",
  "LTC": "NYSE",
  "LTGO": "NASDAQ",
  "LTGR": "NASDAQ",
  "LTH": "NYSE",
  "LTM": "NYSE",
  "LTRN": "NASDAQ",
  "LTRX": "NASDAQ",
  "LU": "NYSE",
  "LUCD": "NASDAQ",
  "LUCK": "NYSE",
  "LUCY": "NASDAQ",
  "LUD": "NYSE",
  "LULU": "NASDAQ",
  "LUMN": "NYSE",
  "LUNG": "NASDAQ",
  "LUNR": "NASDAQ",
  "LUV": "NYSE",
  "LUXE": "NYSE",
  "LVLU": "NASDAQ",
  "LVO": "NASDAQ",
  "LVS": "NYSE",
  "LVWR": "NYSE",
  "LW": "NYSE",
  "LWAC": "NASDAQ",
  "LWAY": "NASDAQ",
  "LWLG": "NASDAQ",
  "LX": "NASDAQ",
  "LXEH": "NASDAQ",
  "LXEO": "NASDAQ",
  "LXFR": "NYSE",
  "LXP": "NYSE",
  "LXP-P-C": "NYSE",
  "LXRX": "NASDAQ",
  "LXU": "NYSE",
  "LYB": "NYSE",
  "LYEL": "NASDAQ",
  "LYFT": "NASDAQ",
  "LYG": "NYSE",
  "LYTS": "NASDAQ",
  "LYV": "NYSE",
  "LZ": "NASDAQ",
  "LZB": "NYSE",
  "LZM": "NYSE",
  "LZMH": "NASDAQ",
  "M": "NYSE",
  "MA": "NYSE",
  "MAA": "NYSE",
  "MAA-P-I": "NYSE",
  "MAAS": "NASDAQ",
  "MAC": "NYSE",
  "MACI": "NASDAQ",
  "MAGH": "NASDAQ",
  "MAGN": "NYSE",
  "MAIA": "NYSE",
  "MAIN": "NYSE",
  "MAIR": "NYSE",
  "MAKO": "NASDAQ",
  "MAMA": "NASDAQ",
  "MAMK": "NASDAQ",
  "MAMO": "NASDAQ",
  "MAN": "NYSE",
  "MANE": "NYSE",
  "MANH": "NASDAQ",
  "MANU": "NYSE",
  "MAR": "NASDAQ",
  "MARA": "NASDAQ",
  "MAS": "NYSE",
  "MASK": "NASDAQ",
  "MASS": "NASDAQ",
  "MAT": "NASDAQ",
  "MATH": "NASDAQ",
  "MATV": "NYSE",
  "MATW": "NASDAQ",
  "MATX": "NYSE",
  "MAX": "NYSE",
  "MAYS": "NASDAQ",
  "MAZE": "NASDAQ",
  "MB": "NASDAQ",
  "MBAI": "NASDAQ",
  "MBBC": "NASDAQ",
  "MBC": "NYSE",
  "MBGL": "NYSE",
  "MBI": "NYSE",
  "MBIN": "NASDAQ",
  "MBINL": "NASDAQ",
  "MBINM": "NASDAQ",
  "MBINN": "NASDAQ",
  "MBIO": "NASDAQ",
  "MBLY": "NASDAQ",
  "MBNKO": "NASDAQ",
  "MBOT": "NASDAQ",
  "MBRX": "NASDAQ",
  "MBUU": "NASDAQ",
  "MBVI": "NASDAQ",
  "MBWM": "NASDAQ",
  "MBX": "NASDAQ",
  "MC": "NYSE",
  "MCAH": "NASDAQ",
  "MCB": "NYSE",
  "MCBS": "NASDAQ",
  "MCD": "NYSE",
  "MCFT": "NASDAQ",
  "MCGA": "NASDAQ",
  "MCHB": "NASDAQ",
  "MCHP": "NASDAQ",
  "MCHPP": "NASDAQ",
  "MCHX": "NASDAQ",
  "MCI": "NYSE",
  "MCK": "NYSE",
  "MCN": "NYSE",
  "MCO": "NYSE",
  "MCRB": "NASDAQ",
  "MCRI": "NASDAQ",
  "MCRP": "NYSE",
  "MCS": "NYSE",
  "MCTA": "NASDAQ",
  "MCY": "NYSE",
  "MD": "NYSE",
  "MDA": "NYSE",
  "MDAI": "NASDAQ",
  "MDB": "NASDAQ",
  "MDBH": "NASDAQ",
  "MDCX": "NASDAQ",
  "MDGL": "NASDAQ",
  "MDIA": "NASDAQ",
  "MDLN": "NASDAQ",
  "MDLZ": "NASDAQ",
  "MDRR": "NASDAQ",
  "MDT": "NYSE",
  "MDU": "NYSE",
  "MDV": "NYSE",
  "MDV-P-A": "NYSE",
  "MDWD": "NASDAQ",
  "MDXG": "NASDAQ",
  "MDXH": "NASDAQ",
  "MEC": "NYSE",
  "MED": "NYSE",
  "MEDP": "NASDAQ",
  "MEDS": "NASDAQ",
  "MEGI": "NYSE",
  "MEGL": "NASDAQ",
  "MEI": "NYSE",
  "MELI": "NASDAQ",
  "MENS": "NASDAQ",
  "MEOH": "NASDAQ",
  "MERC": "NASDAQ",
  "MESH": "NASDAQ",
  "MESO": "NASDAQ",
  "MET": "NYSE",
  "MET-P-A": "NYSE",
  "MET-P-E": "NYSE",
  "MET-P-F": "NYSE",
  "META": "NASDAQ",
  "METC": "NASDAQ",
  "METCB": "NASDAQ",
  "MEVO": "NASDAQ",
  "MF": "NASDAQ",
  "MFA": "NYSE",
  "MFA-P-B": "NYSE",
  "MFA-P-C": "NYSE",
  "MFC": "NYSE",
  "MFG": "NYSE",
  "MFI": "NASDAQ",
  "MFIC": "NASDAQ",
  "MFIN": "NASDAQ",
  "MFM": "NYSE",
  "MFP": "NASDAQ",
  "MG": "NYSE",
  "MGA": "NYSE",
  "MGEE": "NASDAQ",
  "MGF": "NYSE",
  "MGIH": "NASDAQ",
  "MGLD": "NYSE",
  "MGM": "NYSE",
  "MGN": "NASDAQ",
  "MGNI": "NASDAQ",
  "MGNX": "NASDAQ",
  "MGPI": "NASDAQ",
  "MGRC": "NASDAQ",
  "MGRT": "NASDAQ",
  "MGRX": "NASDAQ",
  "MGTX": "NASDAQ",
  "MGX": "NASDAQ",
  "MGY": "NYSE",
  "MGYR": "NASDAQ",
  "MH": "NYSE",
  "MHD": "NYSE",
  "MHF": "NYSE",
  "MHH": "NYSE",
  "MHK": "NYSE",
  "MHO": "NYSE",
  "MI": "NYSE",
  "MIAX": "NYSE",
  "MICC": "NYSE",
  "MIDD": "NASDAQ",
  "MIMI": "NASDAQ",
  "MIN": "NYSE",
  "MIND": "NASDAQ",
  "MINE": "NYSE",
  "MIR": "NYSE",
  "MIRA": "NASDAQ",
  "MIRM": "NASDAQ",
  "MIST": "NASDAQ",
  "MITK": "NASDAQ",
  "MITQ": "NYSE",
  "MITT": "NYSE",
  "MITT-P-A": "NYSE",
  "MITT-P-B": "NYSE",
  "MITT-P-C": "NYSE",
  "MIY": "NYSE",
  "MKC": "NYSE",
  "MKC-V": "NYSE",
  "MKDW": "NASDAQ",
  "MKL": "NYSE",
  "MKLY": "NASDAQ",
  "MKSI": "NASDAQ",
  "MKTW": "NASDAQ",
  "MKTX": "NASDAQ",
  "MKZR": "NASDAQ",
  "MLAA": "NASDAQ",
  "MLAB": "NASDAQ",
  "MLCI": "NASDAQ",
  "MLCO": "NASDAQ",
  "MLEC": "NASDAQ",
  "MLGO": "NASDAQ",
  "MLI": "NYSE",
  "MLKN": "NASDAQ",
  "MLM": "NYSE",
  "MLP": "NYSE",
  "MLR": "NYSE",
  "MLSS": "NYSE",
  "MLTX": "NASDAQ",
  "MLYS": "NASDAQ",
  "MMA": "NYSE",
  "MMD": "NYSE",
  "MMED": "NASDAQ",
  "MMI": "NYSE",
  "MMLP": "NASDAQ",
  "MMM": "NYSE",
  "MMS": "NYSE",
  "MMSI": "NASDAQ",
  "MMT": "NYSE",
  "MMTX": "NASDAQ",
  "MMU": "NYSE",
  "MMYT": "NASDAQ",
  "MNDO": "NASDAQ",
  "MNDR": "NASDAQ",
  "MNDY": "NASDAQ",
  "MNKD": "NASDAQ",
  "MNOV": "NASDAQ",
  "MNPR": "NASDAQ",
  "MNR": "NYSE",
  "MNRO": "NASDAQ",
  "MNSB": "NASDAQ",
  "MNSBP": "NASDAQ",
  "MNSO": "NYSE",
  "MNST": "NASDAQ",
  "MNTK": "NASDAQ",
  "MNTN": "NYSE",
  "MNTS": "NASDAQ",
  "MNY": "NASDAQ",
  "MO": "NYSE",
  "MOB": "NASDAQ",
  "MOBI": "NASDAQ",
  "MOBX": "NASDAQ",
  "MOD": "NYSE",
  "MODD": "NASDAQ",
  "MOG-A": "NYSE",
  "MOG-B": "NYSE",
  "MOGU": "NYSE",
  "MOH": "NYSE",
  "MOLN": "NASDAQ",
  "MOMO": "NASDAQ",
  "MORN": "NASDAQ",
  "MOS": "NYSE",
  "MOV": "NYSE",
  "MOVE": "NASDAQ",
  "MP": "NYSE",
  "MPA": "NYSE",
  "MPAA": "NASDAQ",
  "MPB": "NASDAQ",
  "MPC": "NYSE",
  "MPLT": "NASDAQ",
  "MPLX": "NYSE",
  "MPT": "NYSE",
  "MPTI": "NYSE",
  "MPU": "NYSE",
  "MPV": "NYSE",
  "MPWR": "NASDAQ",
  "MQ": "NASDAQ",
  "MQY": "NYSE",
  "MRAM": "NASDAQ",
  "MRBK": "NASDAQ",
  "MRCY": "NASDAQ",
  "MRDN": "NASDAQ",
  "MREO": "NASDAQ",
  "MRK": "NYSE",
  "MRKR": "NASDAQ",
  "MRLN": "NASDAQ",
  "MRM": "NASDAQ",
  "MRNA": "NASDAQ",
  "MRNO": "NASDAQ",
  "MRP": "NYSE",
  "MRSH": "NYSE",
  "MRT": "NYSE",
  "MRTN": "NASDAQ",
  "MRVI": "NASDAQ",
  "MRVL": "NASDAQ",
  "MRX": "NASDAQ",
  "MS": "NYSE",
  "MS-P-A": "NYSE",
  "MS-P-E": "NYSE",
  "MS-P-F": "NYSE",
  "MS-P-I": "NYSE",
  "MS-P-K": "NYSE",
  "MS-P-L": "NYSE",
  "MS-P-O": "NYSE",
  "MS-P-P": "NYSE",
  "MS-P-Q": "NYSE",
  "MSA": "NYSE",
  "MSAI": "NASDAQ",
  "MSB": "NYSE",
  "MSBI": "NASDAQ",
  "MSBIP": "NASDAQ",
  "MSC": "NYSE",
  "MSCI": "NYSE",
  "MSD": "NYSE",
  "MSDL": "NYSE",
  "MSEX": "NASDAQ",
  "MSFT": "NASDAQ",
  "MSGE": "NYSE",
  "MSGM": "NASDAQ",
  "MSGS": "NYSE",
  "MSGY": "NASDAQ",
  "MSI": "NYSE",
  "MSIF": "NYSE",
  "MSLE": "NASDAQ",
  "MSM": "NYSE",
  "MSN": "NYSE",
  "MSS": "NASDAQ",
  "MSTR": "NASDAQ",
  "MT": "NYSE",
  "MTA": "NYSE",
  "MTAL": "NYSE",
  "MTB": "NYSE",
  "MTB-P-H": "NYSE",
  "MTB-P-J": "NYSE",
  "MTB-P-K": "NYSE",
  "MTB-P-L": "NYSE",
  "MTC": "NASDAQ",
  "MTCH": "NASDAQ",
  "MTD": "NYSE",
  "MTDR": "NYSE",
  "MTEK": "NASDAQ",
  "MTEN": "NASDAQ",
  "MTEX": "NASDAQ",
  "MTG": "NYSE",
  "MTH": "NYSE",
  "MTLS": "NASDAQ",
  "MTN": "NYSE",
  "MTNB": "NYSE",
  "MTNE": "NYSE",
  "MTR": "NYSE",
  "MTRN": "NYSE",
  "MTRX": "NASDAQ",
  "MTSI": "NASDAQ",
  "MTUS": "NYSE",
  "MTVA": "NASDAQ",
  "MTW": "NYSE",
  "MTX": "NYSE",
  "MTZ": "NYSE",
  "MU": "NASDAQ",
  "MUA": "NYSE",
  "MUC": "NYSE",
  "MUFG": "NYSE",
  "MUJ": "NYSE",
  "MUR": "NYSE",
  "MUSA": "NYSE",
  "MUX": "NYSE",
  "MUZE": "NASDAQ",
  "MVBF": "NASDAQ",
  "MVIS": "NASDAQ",
  "MVST": "NASDAQ",
  "MWA": "NYSE",
  "MWC": "NASDAQ",
  "MWG": "NYSE",
  "MWH": "NASDAQ",
  "MWYN": "NASDAQ",
  "MX": "NYSE",
  "MXC": "NYSE",
  "MXCT": "NASDAQ",
  "MXE": "NYSE",
  "MXF": "NYSE",
  "MXL": "NASDAQ",
  "MYE": "NYSE",
  "MYFW": "NASDAQ",
  "MYGN": "NASDAQ",
  "MYI": "NYSE",
  "MYN": "NYSE",
  "MYND": "NYSE",
  "MYO": "NYSE",
  "MYPS": "NASDAQ",
  "MYRG": "NASDAQ",
  "MYSE": "NASDAQ",
  "MYSZ": "NASDAQ",
  "MYX": "NASDAQ",
  "MZTI": "NASDAQ",
  "MZYX": "NYSE",
  "NA": "NASDAQ",
  "NAAS": "NASDAQ",
  "NABL": "NYSE",
  "NAC": "NYSE",
  "NAD": "NYSE",
  "NAGE": "NASDAQ",
  "NAII": "NASDAQ",
  "NAK": "NYSE",
  "NAKA": "NASDAQ",
  "NAMI": "NASDAQ",
  "NAMM": "NASDAQ",
  "NAMS": "NASDAQ",
  "NAN": "NYSE",
  "NAT": "NYSE",
  "NATH": "NASDAQ",
  "NATL": "NYSE",
  "NATR": "NASDAQ",
  "NAUT": "NASDAQ",
  "NAVI": "NASDAQ",
  "NAVN": "NASDAQ",
  "NAZ": "NYSE",
  "NB": "NASDAQ",
  "NBB": "NYSE",
  "NBBK": "NASDAQ",
  "NBH": "NYSE",
  "NBHC": "NYSE",
  "NBIS": "NASDAQ",
  "NBIX": "NASDAQ",
  "NBN": "NASDAQ",
  "NBP": "NASDAQ",
  "NBR": "NYSE",
  "NBRG": "NASDAQ",
  "NBTB": "NASDAQ",
  "NBTX": "NASDAQ",
  "NBXG": "NYSE",
  "NC": "NYSE",
  "NCA": "NYSE",
  "NCDL": "NYSE",
  "NCEL": "NASDAQ",
  "NCEW": "NASDAQ",
  "NCI": "NASDAQ",
  "NCL": "NYSE",
  "NCLH": "NYSE",
  "NCMI": "NASDAQ",
  "NCNA": "NASDAQ",
  "NCNO": "NASDAQ",
  "NCO": "NASDAQ",
  "NCPL": "NASDAQ",
  "NCRA": "NASDAQ",
  "NCSM": "NASDAQ",
  "NCT": "NASDAQ",
  "NCTY": "NASDAQ",
  "NCV": "NYSE",
  "NCV-P-A": "NYSE",
  "NCZ": "NYSE",
  "NCZ-P-A": "NYSE",
  "NDAQ": "NASDAQ",
  "NDLS": "NASDAQ",
  "NDMO": "NYSE",
  "NDRA": "NASDAQ",
  "NDSN": "NASDAQ",
  "NE": "NYSE",
  "NEA": "NYSE",
  "NECB": "NASDAQ",
  "NEE": "NYSE",
  "NEGG": "NASDAQ",
  "NEM": "NYSE",
  "NEN": "NYSE",
  "NEO": "NASDAQ",
  "NEOG": "NASDAQ",
  "NEON": "NASDAQ",
  "NEOV": "NASDAQ",
  "NEPH": "NASDAQ",
  "NERV": "NASDAQ",
  "NESR": "NASDAQ",
  "NET": "NYSE",
  "NEU": "NYSE",
  "NEUP": "NASDAQ",
  "NEWP": "NYSE",
  "NEWT": "NASDAQ",
  "NEWTP": "NASDAQ",
  "NEXA": "NYSE",
  "NEXM": "NASDAQ",
  "NEXN": "NASDAQ",
  "NEXR": "NASDAQ",
  "NEXT": "NASDAQ",
  "NFE": "NASDAQ",
  "NFG": "NYSE",
  "NFGC": "NYSE",
  "NFJ": "NYSE",
  "NFLX": "NASDAQ",
  "NG": "NYSE",
  "NGEN": "NASDAQ",
  "NGG": "NYSE",
  "NGL": "NYSE",
  "NGNE": "NASDAQ",
  "NGS": "NYSE",
  "NGVC": "NYSE",
  "NGVT": "NYSE",
  "NHC": "NYSE",
  "NHI": "NYSE",
  "NHIC": "NASDAQ",
  "NHIV": "NASDAQ",
  "NHP": "NASDAQ",
  "NHPAP": "NASDAQ",
  "NHPBP": "NASDAQ",
  "NHS": "NYSE",
  "NHTC": "NASDAQ",
  "NI": "NYSE",
  "NIC": "NYSE",
  "NICE": "NASDAQ",
  "NICM": "NASDAQ",
  "NIE": "NYSE",
  "NIKI": "NASDAQ",
  "NIM": "NYSE",
  "NINE": "NYSE",
  "NIO": "NYSE",
  "NIPG": "NASDAQ",
  "NIQ": "NYSE",
  "NIU": "NASDAQ",
  "NIVF": "NASDAQ",
  "NIXX": "NASDAQ",
  "NJR": "NYSE",
  "NKE": "NYSE",
  "NKLR": "NASDAQ",
  "NKSH": "NASDAQ",
  "NKTR": "NASDAQ",
  "NKTX": "NASDAQ",
  "NKX": "NYSE",
  "NL": "NYSE",
  "NLOP": "NYSE",
  "NLY": "NYSE",
  "NLY-P-F": "NYSE",
  "NLY-P-G": "NYSE",
  "NLY-P-I": "NYSE",
  "NLY-P-J": "NYSE",
  "NMAD": "NASDAQ",
  "NMAI": "NYSE",
  "NMAX": "NYSE",
  "NMCO": "NYSE",
  "NMFC": "NASDAQ",
  "NMG": "NYSE",
  "NMI": "NYSE",
  "NMIH": "NASDAQ",
  "NML": "NYSE",
  "NMM": "NYSE",
  "NMP": "NASDAQ",
  "NMR": "NYSE",
  "NMRA": "NASDAQ",
  "NMRK": "NASDAQ",
  "NMS": "NYSE",
  "NMT": "NYSE",
  "NMTC": "NASDAQ",
  "NMZ": "NYSE",
  "NN": "NASDAQ",
  "NNBR": "NASDAQ",
  "NNDM": "NASDAQ",
  "NNE": "NASDAQ",
  "NNI": "NYSE",
  "NNN": "NYSE",
  "NNNN": "NASDAQ",
  "NNOX": "NASDAQ",
  "NNVC": "NYSE",
  "NNY": "NYSE",
  "NOA": "NYSE",
  "NOAH": "NYSE",
  "NOC": "NYSE",
  "NODK": "NASDAQ",
  "NOEM": "NASDAQ",
  "NOG": "NYSE",
  "NOK": "NYSE",
  "NOMA": "NASDAQ",
  "NOMD": "NYSE",
  "NOV": "NYSE",
  "NOVT": "NASDAQ",
  "NOW": "NYSE",
  "NP": "NYSE",
  "NPAC": "NASDAQ",
  "NPB": "NYSE",
  "NPCE": "NASDAQ",
  "NPCT": "NYSE",
  "NPFD": "NYSE",
  "NPK": "NYSE",
  "NPKI": "NYSE",
  "NPO": "NYSE",
  "NPT": "NASDAQ",
  "NPV": "NYSE",
  "NPWR": "NYSE",
  "NRC": "NASDAQ",
  "NRDS": "NASDAQ",
  "NRDY": "NYSE",
  "NREF": "NYSE",
  "NREF-P-A": "NYSE",
  "NRG": "NYSE",
  "NRGV": "NYSE",
  "NRIM": "NASDAQ",
  "NRIX": "NASDAQ",
  "NRK": "NYSE",
  "NRO": "NYSE",
  "NRP": "NYSE",
  "NRSN": "NASDAQ",
  "NRT": "NYSE",
  "NRXP": "NASDAQ",
  "NRXS": "NYSE",
  "NSC": "NYSE",
  "NSIT": "NASDAQ",
  "NSLR": "NASDAQ",
  "NSP": "NYSE",
  "NSPR": "NASDAQ",
  "NSRX": "NYSE",
  "NSSC": "NASDAQ",
  "NSTS": "NASDAQ",
  "NSYS": "NASDAQ",
  "NTAP": "NASDAQ",
  "NTB": "NYSE",
  "NTCL": "NASDAQ",
  "NTCT": "NASDAQ",
  "NTES": "NASDAQ",
  "NTGR": "NASDAQ",
  "NTHI": "NASDAQ",
  "NTIC": "NASDAQ",
  "NTIP": "NYSE",
  "NTLA": "NASDAQ",
  "NTNX": "NASDAQ",
  "NTR": "NYSE",
  "NTRA": "NASDAQ",
  "NTRB": "NASDAQ",
  "NTRP": "NASDAQ",
  "NTRS": "NASDAQ",
  "NTRSO": "NASDAQ",
  "NTSK": "NASDAQ",
  "NTST": "NYSE",
  "NTWK": "NASDAQ",
  "NTWO": "NASDAQ",
  "NTZ": "NYSE",
  "NU": "NYSE",
  "NUAI": "NASDAQ",
  "NUCL": "NASDAQ",
  "NUE": "NYSE",
  "NUS": "NYSE",
  "NUTR": "NASDAQ",
  "NUTX": "NASDAQ",
  "NUV": "NYSE",
  "NUVB": "NYSE",
  "NUW": "NYSE",
  "NUWE": "NASDAQ",
  "NVA": "NYSE",
  "NVAX": "NASDAQ",
  "NVCR": "NASDAQ",
  "NVCT": "NASDAQ",
  "NVDA": "NASDAQ",
  "NVEC": "NASDAQ",
  "NVG": "NYSE",
  "NVGS": "NYSE",
  "NVMI": "NASDAQ",
  "NVNI": "NASDAQ",
  "NVNO": "NASDAQ",
  "NVO": "NYSE",
  "NVR": "NYSE",
  "NVRI": "NYSE",
  "NVS": "NYSE",
  "NVST": "NYSE",
  "NVT": "NYSE",
  "NVTS": "NASDAQ",
  "NVX": "NASDAQ",
  "NWAX": "NYSE",
  "NWBI": "NASDAQ",
  "NWE": "NASDAQ",
  "NWFL": "NASDAQ",
  "NWG": "NYSE",
  "NWGL": "NASDAQ",
  "NWL": "NASDAQ",
  "NWN": "NYSE",
  "NWPX": "NASDAQ",
  "NWS": "NASDAQ",
  "NWSA": "NASDAQ",
  "NWTG": "NASDAQ",
  "NX": "NYSE",
  "NXB": "NYSE",
  "NXDR": "NYSE",
  "NXDT": "NYSE",
  "NXDT-P-A": "NYSE",
  "NXE": "NYSE",
  "NXG": "NYSE",
  "NXGL": "NASDAQ",
  "NXL": "NASDAQ",
  "NXP": "NYSE",
  "NXPI": "NASDAQ",
  "NXPL": "NASDAQ",
  "NXRT": "NYSE",
  "NXST": "NASDAQ",
  "NXT": "NASDAQ",
  "NXTC": "NASDAQ",
  "NXTS": "NASDAQ",
  "NXTT": "NASDAQ",
  "NXXT": "NASDAQ",
  "NYAX": "NASDAQ",
  "NYC": "NYSE",
  "NYT": "NYSE",
  "NYXH": "NASDAQ",
  "NZF": "NYSE",
  "O": "NYSE",
  "OABI": "NASDAQ",
  "OACC": "NASDAQ",
  "OBA": "NASDAQ",
  "OBAI": "NASDAQ",
  "OBDC": "NYSE",
  "OBE": "NYSE",
  "OBIO": "NASDAQ",
  "OBK": "NYSE",
  "OBT": "NASDAQ",
  "OBX": "NASDAQ",
  "OC": "NYSE",
  "OCAC": "NYSE",
  "OCC": "NASDAQ",
  "OCCI": "NASDAQ",
  "OCCIM": "NASDAQ",
  "OCCIN": "NASDAQ",
  "OCFC": "NASDAQ",
  "OCG": "NASDAQ",
  "OCGN": "NASDAQ",
  "OCS": "NASDAQ",
  "OCSL": "NASDAQ",
  "OCTV": "NASDAQ",
  "OCUL": "NASDAQ",
  "ODC": "NYSE",
  "ODD": "NASDAQ",
  "ODFL": "NASDAQ",
  "ODTX": "NASDAQ",
  "ODYS": "NASDAQ",
  "OEC": "NYSE",
  "OESX": "NASDAQ",
  "OFAL": "NASDAQ",
  "OFG": "NYSE",
  "OFIX": "NASDAQ",
  "OFLX": "NASDAQ",
  "OFRM": "NYSE",
  "OFS": "NASDAQ",
  "OGC": "NYSE",
  "OGCP": "NYSE",
  "OGE": "NYSE",
  "OGEN": "NYSE",
  "OGG": "NYSE",
  "OGI": "NASDAQ",
  "OGN": "NYSE",
  "OGS": "NYSE",
  "OHAC": "NASDAQ",
  "OHI": "NYSE",
  "OI": "NYSE",
  "OIA": "NYSE",
  "OII": "NYSE",
  "OIM": "NASDAQ",
  "OIO": "NASDAQ",
  "OIS": "NYSE",
  "OKE": "NYSE",
  "OKLO": "NYSE",
  "OKTA": "NASDAQ",
  "OKUR": "NASDAQ",
  "OKYO": "NASDAQ",
  "OLB": "NASDAQ",
  "OLED": "NASDAQ",
  "OLLI": "NASDAQ",
  "OLMA": "NASDAQ",
  "OLN": "NYSE",
  "OLOX": "NASDAQ",
  "OLP": "NYSE",
  "OM": "NASDAQ",
  "OMAB": "NASDAQ",
  "OMC": "NYSE",
  "OMCL": "NASDAQ",
  "OMDA": "NASDAQ",
  "OMER": "NASDAQ",
  "OMEX": "NASDAQ",
  "OMF": "NYSE",
  "OMH": "NASDAQ",
  "OMSE": "NASDAQ",
  "ON": "NASDAQ",
  "ONB": "NASDAQ",
  "ONBPO": "NASDAQ",
  "ONBPP": "NASDAQ",
  "ONC": "NASDAQ",
  "ONCH": "NASDAQ",
  "ONCO": "NASDAQ",
  "ONCY": "NASDAQ",
  "ONDS": "NASDAQ",
  "ONEG": "NASDAQ",
  "ONEW": "NASDAQ",
  "ONFO": "NASDAQ",
  "ONIT": "NYSE",
  "ONL": "NYSE",
  "ONMD": "NASDAQ",
  "ONON": "NYSE",
  "ONT": "NYSE",
  "ONTO": "NYSE",
  "OOMA": "NYSE",
  "OPAD": "NYSE",
  "OPAL": "NASDAQ",
  "OPBK": "NASDAQ",
  "OPCH": "NASDAQ",
  "OPEN": "NASDAQ",
  "OPFI": "NYSE",
  "OPHC": "NYSE",
  "OPI": "NASDAQ",
  "OPK": "NASDAQ",
  "OPLN": "NYSE",
  "OPP": "NYSE",
  "OPP-P-A": "NYSE",
  "OPP-P-B": "NYSE",
  "OPP-P-C": "NYSE",
  "OPRA": "NASDAQ",
  "OPRT": "NASDAQ",
  "OPRX": "NASDAQ",
  "OPTH": "NASDAQ",
  "OPTT": "NYSE",
  "OPTU": "NYSE",
  "OPTX": "NASDAQ",
  "OPXS": "NASDAQ",
  "OPY": "NYSE",
  "OR": "NYSE",
  "ORA": "NYSE",
  "ORBS": "NASDAQ",
  "ORC": "NYSE",
  "ORCL": "NYSE",
  "ORCL-P-D": "NYSE",
  "ORGO": "NASDAQ",
  "ORI": "NYSE",
  "ORIC": "NASDAQ",
  "ORIO": "NASDAQ",
  "ORIQ": "NASDAQ",
  "ORKA": "NASDAQ",
  "ORKT": "NASDAQ",
  "ORLY": "NASDAQ",
  "ORMP": "NASDAQ",
  "ORN": "NYSE",
  "ORRF": "NASDAQ",
  "OSBC": "NASDAQ",
  "OSCR": "NYSE",
  "OSG": "NYSE",
  "OSIS": "NASDAQ",
  "OSK": "NYSE",
  "OSPN": "NASDAQ",
  "OSRH": "NASDAQ",
  "OSS": "NASDAQ",
  "OST": "NASDAQ",
  "OSTX": "NYSE",
  "OSUR": "NASDAQ",
  "OSW": "NASDAQ",
  "OTAI": "NYSE",
  "OTEX": "NASDAQ",
  "OTF": "NYSE",
  "OTGA": "NASDAQ",
  "OTIS": "NYSE",
  "OTLK": "NASDAQ",
  "OTLY": "NASDAQ",
  "OTTR": "NASDAQ",
  "OUST": "NASDAQ",
  "OUT": "NYSE",
  "OVBC": "NASDAQ",
  "OVID": "NASDAQ",
  "OVLY": "NASDAQ",
  "OVV": "NYSE",
  "OWL": "NYSE",
  "OWLS": "NASDAQ",
  "OWLT": "NYSE",
  "OXBR": "NASDAQ",
  "OXLC": "NASDAQ",
  "OXLCM": "NASDAQ",
  "OXLCN": "NASDAQ",
  "OXLCO": "NASDAQ",
  "OXM": "NYSE",
  "OXSQ": "NASDAQ",
  "OXY": "NYSE",
  "OYSE": "NASDAQ",
  "OZK": "NASDAQ",
  "OZKAP": "NASDAQ",
  "P": "NYSE",
  "PAA": "NASDAQ",
  "PAAC": "NASDAQ",
  "PAAS": "NYSE",
  "PAC": "NYSE",
  "PACB": "NASDAQ",
  "PACH": "NASDAQ",
  "PACK": "NYSE",
  "PACS": "NYSE",
  "PAG": "NYSE",
  "PAGP": "NASDAQ",
  "PAGS": "NYSE",
  "PAHC": "NASDAQ",
  "PAI": "NYSE",
  "PAII": "NYSE",
  "PAL": "NASDAQ",
  "PALI": "NASDAQ",
  "PALO": "NASDAQ",
  "PAM": "NYSE",
  "PAMT": "NASDAQ",
  "PANL": "NASDAQ",
  "PANW": "NASDAQ",
  "PAPL": "NYSE",
  "PAR": "NYSE",
  "PARA": "NASDAQ",
  "PARK": "NASDAQ",
  "PARR": "NYSE",
  "PASG": "NASDAQ",
  "PASW": "NASDAQ",
  "PATH": "NYSE",
  "PATK": "NASDAQ",
  "PAVM": "NASDAQ",
  "PAVS": "NASDAQ",
  "PAX": "NASDAQ",
  "PAXS": "NYSE",
  "PAY": "NYSE",
  "PAYC": "NYSE",
  "PAYO": "NASDAQ",
  "PAYP": "NASDAQ",
  "PAYS": "NASDAQ",
  "PAYX": "NASDAQ",
  "PB": "NYSE",
  "PBA": "NYSE",
  "PBAM": "NASDAQ",
  "PBF": "NYSE",
  "PBFS": "NASDAQ",
  "PBH": "NYSE",
  "PBHC": "NASDAQ",
  "PBI": "NYSE",
  "PBK": "NASDAQ",
  "PBLS": "NASDAQ",
  "PBM": "NASDAQ",
  "PBR": "NYSE",
  "PBR-A": "NYSE",
  "PBT": "NYSE",
  "PBYI": "NASDAQ",
  "PC": "NASDAQ",
  "PCAP": "NASDAQ",
  "PCAR": "NASDAQ",
  "PCB": "NASDAQ",
  "PCF": "NYSE",
  "PCG": "NYSE",
  "PCG-P-A": "NYSE",
  "PCG-P-B": "NYSE",
  "PCG-P-C": "NYSE",
  "PCG-P-D": "NYSE",
  "PCG-P-E": "NYSE",
  "PCG-P-G": "NYSE",
  "PCG-P-H": "NYSE",
  "PCG-P-I": "NYSE",
  "PCG-P-X": "NYSE",
  "PCLA": "NASDAQ",
  "PCM": "NYSE",
  "PCN": "NYSE",
  "PCOR": "NYSE",
  "PCQ": "NYSE",
  "PCRX": "NASDAQ",
  "PCSA": "NASDAQ",
  "PCT": "NASDAQ",
  "PCTY": "NASDAQ",
  "PCVX": "NASDAQ",
  "PCYO": "NASDAQ",
  "PD": "NYSE",
  "PDC": "NASDAQ",
  "PDCC": "NYSE",
  "PDD": "NASDAQ",
  "PDEX": "NASDAQ",
  "PDFS": "NASDAQ",
  "PDI": "NYSE",
  "PDLB": "NASDAQ",
  "PDM": "NYSE",
  "PDO": "NYSE",
  "PDPA": "NYSE",
  "PDS": "NYSE",
  "PDSB": "NASDAQ",
  "PDT": "NYSE",
  "PDX": "NYSE",
  "PDYN": "NASDAQ",
  "PEB": "NYSE",
  "PEB-P-E": "NYSE",
  "PEB-P-F": "NYSE",
  "PEB-P-G": "NYSE",
  "PEB-P-H": "NYSE",
  "PEBK": "NASDAQ",
  "PEBO": "NASDAQ",
  "PECE": "NASDAQ",
  "PECO": "NASDAQ",
  "PED": "NYSE",
  "PEG": "NYSE",
  "PEGA": "NASDAQ",
  "PEN": "NYSE",
  "PENG": "NASDAQ",
  "PENN": "NASDAQ",
  "PEO": "NYSE",
  "PEP": "NASDAQ",
  "PEPG": "NASDAQ",
  "PERF": "NYSE",
  "PERI": "NASDAQ",
  "PESI": "NASDAQ",
  "PETS": "NASDAQ",
  "PETZ": "NASDAQ",
  "PEW": "NYSE",
  "PFAI": "NASDAQ",
  "PFBC": "NASDAQ",
  "PFD": "NYSE",
  "PFE": "NYSE",
  "PFG": "NASDAQ",
  "PFGC": "NYSE",
  "PFIS": "NASDAQ",
  "PFL": "NYSE",
  "PFLT": "NYSE",
  "PFN": "NYSE",
  "PFO": "NYSE",
  "PFS": "NYSE",
  "PFSA": "NASDAQ",
  "PFSI": "NYSE",
  "PFX": "NASDAQ",
  "PG": "NYSE",
  "PGAC": "NASDAQ",
  "PGC": "NASDAQ",
  "PGEN": "NASDAQ",
  "PGNY": "NASDAQ",
  "PGP": "NYSE",
  "PGR": "NYSE",
  "PGY": "NASDAQ",
  "PGZ": "NYSE",
  "PH": "NYSE",
  "PHAR": "NASDAQ",
  "PHAT": "NASDAQ",
  "PHG": "NYSE",
  "PHGE": "NYSE",
  "PHI": "NYSE",
  "PHIN": "NYSE",
  "PHIO": "NASDAQ",
  "PHK": "NYSE",
  "PHM": "NYSE",
  "PHOE": "NASDAQ",
  "PHR": "NYSE",
  "PHUN": "NASDAQ",
  "PHVS": "NASDAQ",
  "PHXE-P": "NYSE",
  "PI": "NASDAQ",
  "PICS": "NASDAQ",
  "PII": "NYSE",
  "PIII": "NASDAQ",
  "PIM": "NYSE",
  "PINE": "NYSE",
  "PINE-P-A": "NYSE",
  "PINS": "NYSE",
  "PIPR": "NYSE",
  "PJT": "NYSE",
  "PK": "NYSE",
  "PKBK": "NASDAQ",
  "PKE": "NYSE",
  "PKG": "NYSE",
  "PKOH": "NASDAQ",
  "PKX": "NYSE",
  "PL": "NYSE",
  "PLAB": "NASDAQ",
  "PLAG": "NYSE",
  "PLAY": "NASDAQ",
  "PLBC": "NASDAQ",
  "PLBL": "NASDAQ",
  "PLBY": "NASDAQ",
  "PLCE": "NASDAQ",
  "PLD": "NYSE",
  "PLG": "NYSE",
  "PLGO": "NYSE",
  "PLMK": "NASDAQ",
  "PLMR": "NASDAQ",
  "PLNT": "NYSE",
  "PLOW": "NYSE",
  "PLPC": "NASDAQ",
  "PLRX": "NASDAQ",
  "PLRZ": "NASDAQ",
  "PLSE": "NASDAQ",
  "PLSM": "NASDAQ",
  "PLTK": "NASDAQ",
  "PLTR": "NASDAQ",
  "PLTS": "NASDAQ",
  "PLUG": "NASDAQ",
  "PLUN": "NYSE",
  "PLUR": "NASDAQ",
  "PLUS": "NASDAQ",
  "PLUT": "NASDAQ",
  "PLX": "NYSE",
  "PLXS": "NASDAQ",
  "PLYX": "NASDAQ",
  "PM": "NYSE",
  "PMA": "NASDAQ",
  "PMAX": "NASDAQ",
  "PMCB": "NASDAQ",
  "PMEC": "NASDAQ",
  "PMI": "NYSE",
  "PML": "NYSE",
  "PMM": "NYSE",
  "PMN": "NASDAQ",
  "PMO": "NYSE",
  "PMT": "NYSE",
  "PMT-P-A": "NYSE",
  "PMT-P-B": "NYSE",
  "PMT-P-C": "NYSE",
  "PMTR": "NASDAQ",
  "PMTS": "NASDAQ",
  "PMVP": "NASDAQ",
  "PN": "NASDAQ",
  "PNBK": "NASDAQ",
  "PNC": "NYSE",
  "PNFP": "NYSE",
  "PNFP-P-A": "NYSE",
  "PNFP-P-B": "NYSE",
  "PNFP-P-C": "NYSE",
  "PNI": "NYSE",
  "PNNT": "NYSE",
  "PNR": "NYSE",
  "PNRG": "NASDAQ",
  "PNTG": "NASDAQ",
  "PNW": "NYSE",
  "POAS": "NYSE",
  "POCI": "NASDAQ",
  "PODC": "NASDAQ",
  "PODD": "NASDAQ",
  "POET": "NASDAQ",
  "POLA": "NASDAQ",
  "POLE": "NASDAQ",
  "POM": "NASDAQ",
  "PONO": "NASDAQ",
  "PONY": "NASDAQ",
  "POOL": "NASDAQ",
  "POR": "NYSE",
  "POST": "NYSE",
  "POWI": "NASDAQ",
  "POWL": "NASDAQ",
  "POWW": "NASDAQ",
  "POWWP": "NASDAQ",
  "PPBT": "NASDAQ",
  "PPC": "NASDAQ",
  "PPCB": "NASDAQ",
  "PPG": "NYSE",
  "PPHC": "NASDAQ",
  "PPIH": "NASDAQ",
  "PPL": "NYSE",
  "PPLI": "NASDAQ",
  "PPSI": "NASDAQ",
  "PPT": "NYSE",
  "PPTA": "NASDAQ",
  "PR": "NYSE",
  "PRAA": "NASDAQ",
  "PRAX": "NASDAQ",
  "PRCH": "NASDAQ",
  "PRCT": "NASDAQ",
  "PRDO": "NASDAQ",
  "PRE": "NASDAQ",
  "PRFX": "NASDAQ",
  "PRG": "NYSE",
  "PRGO": "NYSE",
  "PRGS": "NASDAQ",
  "PRHI": "NASDAQ",
  "PRI": "NYSE",
  "PRIF-P-D": "NYSE",
  "PRIF-P-K": "NYSE",
  "PRIF-P-L": "NYSE",
  "PRIM": "NYSE",
  "PRK": "NYSE",
  "PRKS": "NYSE",
  "PRLB": "NYSE",
  "PRLD": "NASDAQ",
  "PRM": "NYSE",
  "PRMB": "NYSE",
  "PRME": "NASDAQ",
  "PROF": "NASDAQ",
  "PROK": "NASDAQ",
  "PROP": "NASDAQ",
  "PROV": "NASDAQ",
  "PRPL": "NASDAQ",
  "PRPO": "NASDAQ",
  "PRQR": "NASDAQ",
  "PRSO": "NASDAQ",
  "PRSU": "NYSE",
  "PRT": "NYSE",
  "PRTA": "NASDAQ",
  "PRTH": "NASDAQ",
  "PRTS": "NASDAQ",
  "PRU": "NYSE",
  "PRVA": "NASDAQ",
  "PRZO": "NASDAQ",
  "PS": "NYSE",
  "PSA": "NYSE",
  "PSA-P-F": "NYSE",
  "PSA-P-G": "NYSE",
  "PSA-P-H": "NYSE",
  "PSA-P-I": "NYSE",
  "PSA-P-J": "NYSE",
  "PSA-P-K": "NYSE",
  "PSA-P-L": "NYSE",
  "PSA-P-M": "NYSE",
  "PSA-P-N": "NYSE",
  "PSA-P-O": "NYSE",
  "PSA-P-P": "NYSE",
  "PSA-P-Q": "NYSE",
  "PSA-P-R": "NYSE",
  "PSA-P-S": "NYSE",
  "PSA-P-T": "NYSE",
  "PSA-P-U": "NYSE",
  "PSBD": "NYSE",
  "PSEC": "NASDAQ",
  "PSEC-P-A": "NYSE",
  "PSF": "NYSE",
  "PSFE": "NYSE",
  "PSHG": "NASDAQ",
  "PSIG": "NASDAQ",
  "PSIX": "NASDAQ",
  "PSKY": "NASDAQ",
  "PSMT": "NASDAQ",
  "PSN": "NYSE",
  "PSNL": "NASDAQ",
  "PSNY": "NASDAQ",
  "PSNYW": "NASDAQ",
  "PSO": "NYSE",
  "PSQH": "NYSE",
  "PSTL": "NYSE",
  "PSUS": "NYSE",
  "PSX": "NYSE",
  "PTA": "NYSE",
  "PTAC": "NASDAQ",
  "PTC": "NASDAQ",
  "PTCT": "NASDAQ",
  "PTEN": "NASDAQ",
  "PTGX": "NASDAQ",
  "PTHS": "NYSE",
  "PTLE": "NASDAQ",
  "PTLO": "NASDAQ",
  "PTN": "NASDAQ",
  "PTON": "NASDAQ",
  "PTOR": "NASDAQ",
  "PTRN": "NASDAQ",
  "PTY": "NYSE",
  "PUBM": "NASDAQ",
  "PUK": "NYSE",
  "PULM": "NASDAQ",
  "PUMP": "NYSE",
  "PURR": "NASDAQ",
  "PUSA": "NASDAQ",
  "PVH": "NYSE",
  "PVL": "NYSE",
  "PVLA": "NASDAQ",
  "PW": "NYSE",
  "PW-P-A": "NYSE",
  "PWCM": "NASDAQ",
  "PWP": "NASDAQ",
  "PWR": "NYSE",
  "PWRL": "NASDAQ",
  "PXED": "NYSE",
  "PXLW": "NASDAQ",
  "PXS": "NASDAQ",
  "PYPD": "NASDAQ",
  "PYPL": "NASDAQ",
  "PYT": "NYSE",
  "PYXS": "NASDAQ",
  "PZG": "NYSE",
  "PZZA": "NASDAQ",
  "Q": "NYSE",
  "QADR": "NASDAQ",
  "QBTS": "NASDAQ",
  "QCLS": "NASDAQ",
  "QCOM": "NASDAQ",
  "QCRH": "NASDAQ",
  "QDEL": "NASDAQ",
  "QETA": "NASDAQ",
  "QFIN": "NASDAQ",
  "QGEN": "NYSE",
  "QH": "NASDAQ",
  "QLEP": "NYSE",
  "QLYS": "NASDAQ",
  "QMCO": "NASDAQ",
  "QMLS": "NASDAQ",
  "QMMM": "NASDAQ",
  "QNC": "NYSE",
  "QNCX": "NASDAQ",
  "QNME": "NASDAQ",
  "QNRX": "NASDAQ",
  "QNST": "NASDAQ",
  "QNT": "NASDAQ",
  "QNTM": "NASDAQ",
  "QQQX": "NASDAQ",
  "QRED": "NYSE",
  "QRHC": "NASDAQ",
  "QRVO": "NASDAQ",
  "QS": "NASDAQ",
  "QSEA": "NASDAQ",
  "QSI": "NASDAQ",
  "QSR": "NYSE",
  "QTEX": "NASDAQ",
  "QTI": "NASDAQ",
  "QTRX": "NASDAQ",
  "QTTB": "NASDAQ",
  "QTWO": "NYSE",
  "QUAD": "NYSE",
  "QUBT": "NASDAQ",
  "QUCY": "NASDAQ",
  "QUIK": "NASDAQ",
  "QUMS": "NASDAQ",
  "QURE": "NASDAQ",
  "QVC": "NASDAQ",
  "QXL": "NASDAQ",
  "QXO": "NYSE",
  "QXO-P-B": "NYSE",
  "R": "NYSE",
  "RA": "NYSE",
  "RAC": "NYSE",
  "RACC": "NASDAQ",
  "RACD": "NASDAQ",
  "RACE": "NYSE",
  "RADX": "NASDAQ",
  "RAIL": "NASDAQ",
  "RAIN": "NASDAQ",
  "RAL": "NYSE",
  "RAMP": "NYSE",
  "RAND": "NASDAQ",
  "RANG": "NASDAQ",
  "RANI": "NASDAQ",
  "RAPP": "NASDAQ",
  "RARE": "NASDAQ",
  "RAVE": "NASDAQ",
  "RAY": "NASDAQ",
  "RAYA": "NASDAQ",
  "RBA": "NYSE",
  "RBB": "NASDAQ",
  "RBBN": "NASDAQ",
  "RBC": "NYSE",
  "RBCAA": "NASDAQ",
  "RBKB": "NASDAQ",
  "RBLX": "NYSE",
  "RBNE": "NASDAQ",
  "RBRK": "NYSE",
  "RC": "NYSE",
  "RC-P-C": "NYSE",
  "RC-P-E": "NYSE",
  "RCAT": "NASDAQ",
  "RCBC": "NASDAQ",
  "RCEL": "NASDAQ",
  "RCG": "NYSE",
  "RCI": "NYSE",
  "RCKT": "NASDAQ",
  "RCKY": "NASDAQ",
  "RCL": "NYSE",
  "RCMT": "NASDAQ",
  "RCON": "NASDAQ",
  "RCS": "NYSE",
  "RCT": "NASDAQ",
  "RCUS": "NYSE",
  "RDAC": "NASDAQ",
  "RDAG": "NASDAQ",
  "RDCM": "NASDAQ",
  "RDDT": "NYSE",
  "RDGT": "NASDAQ",
  "RDHL": "NASDAQ",
  "RDI": "NASDAQ",
  "RDIB": "NASDAQ",
  "RDN": "NYSE",
  "RDNT": "NASDAQ",
  "RDNW": "NASDAQ",
  "RDVT": "NASDAQ",
  "RDW": "NYSE",
  "RDWR": "NASDAQ",
  "RDY": "NYSE",
  "RDZN": "NASDAQ",
  "REA": "NYSE",
  "REAL": "NASDAQ",
  "REAX": "NASDAQ",
  "REBN": "NASDAQ",
  "RECT": "NASDAQ",
  "REED": "NYSE",
  "REF": "NYSE",
  "REFI": "NASDAQ",
  "REFR": "NASDAQ",
  "REG": "NASDAQ",
  "REGCO": "NASDAQ",
  "REGCP": "NASDAQ",
  "REGN": "NASDAQ",
  "REI": "NYSE",
  "REKR": "NASDAQ",
  "RELL": "NASDAQ",
  "RELX": "NYSE",
  "RELY": "NASDAQ",
  "RENT": "NASDAQ",
  "RENX": "NASDAQ",
  "REPL": "NASDAQ",
  "REPX": "NYSE",
  "RERE": "NYSE",
  "RES": "NYSE",
  "RETO": "NASDAQ",
  "REVB": "NASDAQ",
  "REX": "NYSE",
  "REXR": "NYSE",
  "REXR-P-B": "NYSE",
  "REXR-P-C": "NYSE",
  "REYN": "NASDAQ",
  "REZI": "NYSE",
  "RF": "NYSE",
  "RF-P-C": "NYSE",
  "RF-P-E": "NYSE",
  "RF-P-F": "NYSE",
  "RFAI": "NASDAQ",
  "RFAM": "NASDAQ",
  "RFI": "NYSE",
  "RFIL": "NASDAQ",
  "RFL": "NYSE",
  "RFM": "NYSE",
  "RFMZ": "NYSE",
  "RGA": "NYSE",
  "RGC": "NASDAQ",
  "RGCO": "NASDAQ",
  "RGEN": "NASDAQ",
  "RGLD": "NASDAQ",
  "RGNT": "NYSE",
  "RGNX": "NASDAQ",
  "RGP": "NASDAQ",
  "RGR": "NYSE",
  "RGS": "NASDAQ",
  "RGT": "NYSE",
  "RGTI": "NASDAQ",
  "RH": "NYSE",
  "RHI": "NYSE",
  "RHLD": "NYSE",
  "RHP": "NYSE",
  "RIBB": "NASDAQ",
  "RICK": "NASDAQ",
  "RIG": "NYSE",
  "RIGL": "NASDAQ",
  "RILY": "NASDAQ",
  "RILYL": "NASDAQ",
  "RILYP": "NASDAQ",
  "RIME": "NASDAQ",
  "RIO": "NYSE",
  "RIOT": "NASDAQ",
  "RITM": "NYSE",
  "RITM-P-A": "NYSE",
  "RITM-P-B": "NYSE",
  "RITM-P-C": "NYSE",
  "RITM-P-D": "NYSE",
  "RITM-P-E": "NYSE",
  "RITM-P-F": "NYSE",
  "RITR": "NASDAQ",
  "RIV": "NYSE",
  "RIV-P-A": "NYSE",
  "RIVN": "NASDAQ",
  "RJET": "NASDAQ",
  "RJF": "NYSE",
  "RKDA": "NASDAQ",
  "RKLB": "NASDAQ",
  "RKT": "NYSE",
  "RKTO": "NASDAQ",
  "RL": "NYSE",
  "RLAY": "NASDAQ",
  "RLGT": "NYSE",
  "RLI": "NYSE",
  "RLJ": "NYSE",
  "RLJ-P-A": "NYSE",
  "RLMD": "NASDAQ",
  "RLTY": "NYSE",
  "RLX": "NYSE",
  "RLYB": "NASDAQ",
  "RM": "NYSE",
  "RMAX": "NYSE",
  "RMBI": "NASDAQ",
  "RMBS": "NASDAQ",
  "RMCF": "NASDAQ",
  "RMCO": "NASDAQ",
  "RMD": "NYSE",
  "RMI": "NYSE",
  "RMIX": "NASDAQ",
  "RMM": "NYSE",
  "RMMZ": "NYSE",
  "RMNI": "NASDAQ",
  "RMR": "NASDAQ",
  "RMSG": "NASDAQ",
  "RMT": "NYSE",
  "RMTI": "NASDAQ",
  "RNA": "NASDAQ",
  "RNAC": "NASDAQ",
  "RNAZ": "NASDAQ",
  "RNG": "NYSE",
  "RNGR": "NYSE",
  "RNGT": "NASDAQ",
  "RNP": "NYSE",
  "RNR": "NYSE",
  "RNR-P-F": "NYSE",
  "RNR-P-G": "NYSE",
  "RNST": "NYSE",
  "RNTX": "NASDAQ",
  "RNW": "NASDAQ",
  "RNXT": "NASDAQ",
  "ROAD": "NASDAQ",
  "ROC": "NASDAQ",
  "ROCK": "NASDAQ",
  "ROG": "NYSE",
  "ROIV": "NASDAQ",
  "ROK": "NYSE",
  "ROKU": "NASDAQ",
  "ROL": "NYSE",
  "ROLR": "NYSE",
  "ROMA": "NASDAQ",
  "ROOT": "NASDAQ",
  "ROP": "NASDAQ",
  "ROST": "NASDAQ",
  "RPAY": "NASDAQ",
  "RPC": "NYSE",
  "RPD": "NASDAQ",
  "RPGL": "NASDAQ",
  "RPID": "NASDAQ",
  "RPM": "NYSE",
  "RPRX": "NASDAQ",
  "RPT": "NYSE",
  "RPT-P-C": "NYSE",
  "RQI": "NYSE",
  "RR": "NASDAQ",
  "RRBI": "NASDAQ",
  "RRC": "NYSE",
  "RREV": "NASDAQ",
  "RRGB": "NASDAQ",
  "RRR": "NASDAQ",
  "RRX": "NYSE",
  "RS": "NYSE",
  "RSF": "NYSE",
  "RSG": "NYSE",
  "RSI": "NYSE",
  "RSKD": "NYSE",
  "RSSS": "NASDAQ",
  "RSVR": "NASDAQ",
  "RTAC": "NASDAQ",
  "RTB": "NASDAQ",
  "RTO": "NYSE",
  "RTX": "NYSE",
  "RUBI": "NASDAQ",
  "RUM": "NASDAQ",
  "RUN": "NASDAQ",
  "RUSHA": "NASDAQ",
  "RUSHB": "NASDAQ",
  "RVI": "NYSE",
  "RVLV": "NYSE",
  "RVMD": "NASDAQ",
  "RVP": "NYSE",
  "RVSB": "NASDAQ",
  "RVSN": "NASDAQ",
  "RVT": "NYSE",
  "RVTY": "NYSE",
  "RWAY": "NASDAQ",
  "RWT": "NYSE",
  "RWT-P-A": "NYSE",
  "RXO": "NYSE",
  "RXRX": "NASDAQ",
  "RXST": "NASDAQ",
  "RXT": "NASDAQ",
  "RY": "NYSE",
  "RYAAY": "NASDAQ",
  "RYAM": "NYSE",
  "RYAN": "NYSE",
  "RYDE": "NYSE",
  "RYET": "NASDAQ",
  "RYM": "NASDAQ",
  "RYN": "NYSE",
  "RYOJ": "NASDAQ",
  "RYTM": "NASDAQ",
  "RYZ": "NYSE",
  "RZLT": "NASDAQ",
  "RZLV": "NASDAQ",
  "S": "NYSE",
  "SA": "NYSE",
  "SAAQ": "NASDAQ",
  "SABA": "NYSE",
  "SABR": "NASDAQ",
  "SABS": "NASDAQ",
  "SAC": "NYSE",
  "SACH": "NYSE",
  "SACH-P-A": "NYSE",
  "SAFE": "NYSE",
  "SAFT": "NASDAQ",
  "SAFX": "NASDAQ",
  "SAGT": "NASDAQ",
  "SAGU": "NYSE",
  "SAH": "NYSE",
  "SAIA": "NASDAQ",
  "SAIC": "NASDAQ",
  "SAIH": "NASDAQ",
  "SAIL": "NASDAQ",
  "SAM": "NYSE",
  "SAMG": "NASDAQ",
  "SAN": "NYSE",
  "SANA": "NASDAQ",
  "SANG": "NASDAQ",
  "SANM": "NASDAQ",
  "SAP": "NYSE",
  "SAR": "NYSE",
  "SARO": "NYSE",
  "SATA": "NASDAQ",
  "SATL": "NASDAQ",
  "SB": "NYSE",
  "SB-P-C": "NYSE",
  "SB-P-D": "NYSE",
  "SBAC": "NASDAQ",
  "SBC": "NASDAQ",
  "SBCF": "NASDAQ",
  "SBET": "NASDAQ",
  "SBEV": "NYSE",
  "SBFG": "NASDAQ",
  "SBFM": "NASDAQ",
  "SBGI": "NASDAQ",
  "SBH": "NYSE",
  "SBI": "NYSE",
  "SBLK": "NASDAQ",
  "SBMT": "NYSE",
  "SBR": "NYSE",
  "SBRA": "NASDAQ",
  "SBS": "NYSE",
  "SBSI": "NYSE",
  "SBSW": "NYSE",
  "SBUX": "NASDAQ",
  "SBXD": "NYSE",
  "SBXE": "NYSE",
  "SCAG": "NASDAQ",
  "SCCO": "NYSE",
  "SCD": "NYSE",
  "SCE-P-G": "NYSE",
  "SCE-P-L": "NYSE",
  "SCE-P-M": "NYSE",
  "SCE-P-N": "NYSE",
  "SCHL": "NASDAQ",
  "SCHW": "NYSE",
  "SCHW-P-D": "NYSE",
  "SCHW-P-J": "NYSE",
  "SCI": "NYSE",
  "SCII": "NASDAQ",
  "SCKT": "NASDAQ",
  "SCL": "NYSE",
  "SCLX": "NASDAQ",
  "SCM": "NYSE",
  "SCNI": "NASDAQ",
  "SCNX": "NASDAQ",
  "SCOR": "NASDAQ",
  "SCPQ": "NASDAQ",
  "SCSC": "NASDAQ",
  "SCTX": "NASDAQ",
  "SCWO": "NASDAQ",
  "SCYX": "NASDAQ",
  "SCZM": "NASDAQ",
  "SD": "NYSE",
  "SDA": "NASDAQ",
  "SDEV": "NYSE",
  "SDGR": "NASDAQ",
  "SDHC": "NYSE",
  "SDHI": "NASDAQ",
  "SDHY": "NYSE",
  "SDOT": "NASDAQ",
  "SDRL": "NYSE",
  "SDST": "NASDAQ",
  "SE": "NYSE",
  "SEAT": "NASDAQ",
  "SEB": "NYSE",
  "SECZ": "NYSE",
  "SEDG": "NASDAQ",
  "SEED": "NASDAQ",
  "SEER": "NASDAQ",
  "SEG": "NYSE",
  "SEGG": "NASDAQ",
  "SEI": "NYSE",
  "SEIC": "NASDAQ",
  "SELF": "NASDAQ",
  "SENEA": "NASDAQ",
  "SENEB": "NASDAQ",
  "SENS": "NASDAQ",
  "SEPN": "NASDAQ",
  "SER": "NYSE",
  "SERA": "NASDAQ",
  "SERV": "NASDAQ",
  "SES": "NYSE",
  "SEV": "NASDAQ",
  "SEVN": "NASDAQ",
  "SEZL": "NASDAQ",
  "SF": "NYSE",
  "SF-P-B": "NYSE",
  "SF-P-C": "NYSE",
  "SF-P-D": "NYSE",
  "SFBC": "NASDAQ",
  "SFBS": "NYSE",
  "SFD": "NASDAQ",
  "SFHG": "NASDAQ",
  "SFIX": "NASDAQ",
  "SFL": "NYSE",
  "SFM": "NASDAQ",
  "SFNC": "NASDAQ",
  "SFST": "NASDAQ",
  "SFWL": "NASDAQ",
  "SG": "NYSE",
  "SGA": "NASDAQ",
  "SGC": "NASDAQ",
  "SGHC": "NYSE",
  "SGHT": "NASDAQ",
  "SGI": "NYSE",
  "SGLY": "NASDAQ",
  "SGML": "NASDAQ",
  "SGMT": "NASDAQ",
  "SGP": "NASDAQ",
  "SGRY": "NASDAQ",
  "SGU": "NYSE",
  "SHAK": "NYSE",
  "SHAZ": "NASDAQ",
  "SHBI": "NASDAQ",
  "SHC": "NASDAQ",
  "SHEL": "NYSE",
  "SHEN": "NASDAQ",
  "SHFS": "NASDAQ",
  "SHG": "NYSE",
  "SHIM": "NASDAQ",
  "SHIP": "NASDAQ",
  "SHLS": "NASDAQ",
  "SHMD": "NASDAQ",
  "SHO": "NYSE",
  "SHO-P-H": "NYSE",
  "SHO-P-I": "NYSE",
  "SHOE": "NASDAQ",
  "SHOO": "NASDAQ",
  "SHOP": "NASDAQ",
  "SHOT": "NASDAQ",
  "SHPH": "NASDAQ",
  "SHW": "NYSE",
  "SI": "NYSE",
  "SIBN": "NASDAQ",
  "SID": "NYSE",
  "SIDU": "NASDAQ",
  "SIEB": "NASDAQ",
  "SIF": "NYSE",
  "SIFY": "NASDAQ",
  "SIG": "NYSE",
  "SIGA": "NASDAQ",
  "SIGI": "NASDAQ",
  "SIGIP": "NASDAQ",
  "SII": "NYSE",
  "SILC": "NASDAQ",
  "SILO": "NASDAQ",
  "SIM": "NYSE",
  "SIMA": "NASDAQ",
  "SIMO": "NASDAQ",
  "SIND": "NYSE",
  "SINT": "NASDAQ",
  "SION": "NASDAQ",
  "SIRI": "NASDAQ",
  "SITC": "NYSE",
  "SITE": "NYSE",
  "SITM": "NASDAQ",
  "SJ": "NASDAQ",
  "SJM": "NYSE",
  "SJT": "NYSE",
  "SKE": "NYSE",
  "SKHY": "NASDAQ",
  "SKIL": "NYSE",
  "SKIN": "NASDAQ",
  "SKK": "NASDAQ",
  "SKM": "NYSE",
  "SKT": "NYSE",
  "SKWD": "NASDAQ",
  "SKY": "NYSE",
  "SKYA": "NASDAQ",
  "SKYE": "NASDAQ",
  "SKYH": "NYSE",
  "SKYQ": "NASDAQ",
  "SKYW": "NASDAQ",
  "SKYX": "NASDAQ",
  "SLAB": "NASDAQ",
  "SLB": "NYSE",
  "SLBT": "NASDAQ",
  "SLDB": "NASDAQ",
  "SLDE": "NASDAQ",
  "SLDP": "NASDAQ",
  "SLE": "NASDAQ",
  "SLF": "NYSE",
  "SLG": "NYSE",
  "SLG-P-I": "NYSE",
  "SLGB": "NASDAQ",
  "SLGL": "NASDAQ",
  "SLGN": "NYSE",
  "SLI": "NYSE",
  "SLM": "NASDAQ",
  "SLMBP": "NASDAQ",
  "SLMT": "NASDAQ",
  "SLN": "NASDAQ",
  "SLND": "NYSE",
  "SLNG": "NASDAQ",
  "SLNH": "NASDAQ",
  "SLNHP": "NASDAQ",
  "SLP": "NASDAQ",
  "SLQT": "NYSE",
  "SLRC": "NASDAQ",
  "SLS": "NASDAQ",
  "SLSN": "NASDAQ",
  "SLSR": "NYSE",
  "SLVM": "NYSE",
  "SLXN": "NASDAQ",
  "SM": "NYSE",
  "SMA": "NYSE",
  "SMBC": "NASDAQ",
  "SMBK": "NYSE",
  "SMC": "NYSE",
  "SMCI": "NASDAQ",
  "SMCIP": "NASDAQ",
  "SMFG": "NYSE",
  "SMG": "NYSE",
  "SMHI": "NYSE",
  "SMID": "NASDAQ",
  "SMJF": "NYSE",
  "SMMT": "NASDAQ",
  "SMP": "NYSE",
  "SMPL": "NASDAQ",
  "SMR": "NYSE",
  "SMRT": "NYSE",
  "SMSI": "NASDAQ",
  "SMTC": "NASDAQ",
  "SMTI": "NASDAQ",
  "SMTK": "NASDAQ",
  "SMWB": "NYSE",
  "SMX": "NASDAQ",
  "SMXT": "NASDAQ",
  "SN": "NYSE",
  "SNA": "NYSE",
  "SNAL": "NASDAQ",
  "SNAP": "NYSE",
  "SND": "NASDAQ",
  "SNDA": "NYSE",
  "SNDK": "NASDAQ",
  "SNDL": "NASDAQ",
  "SNDR": "NYSE",
  "SNDX": "NASDAQ",
  "SNES": "NASDAQ",
  "SNEX": "NASDAQ",
  "SNFCA": "NASDAQ",
  "SNGX": "NASDAQ",
  "SNN": "NYSE",
  "SNOA": "NASDAQ",
  "SNOW": "NYSE",
  "SNPS": "NASDAQ",
  "SNT": "NASDAQ",
  "SNTG": "NASDAQ",
  "SNTI": "NASDAQ",
  "SNWV": "NASDAQ",
  "SNX": "NYSE",
  "SNY": "NASDAQ",
  "SNYR": "NASDAQ",
  "SO": "NYSE",
  "SOAR": "NYSE",
  "SOBO": "NYSE",
  "SOBR": "NASDAQ",
  "SOC": "NYSE",
  "SOCA": "NASDAQ",
  "SOFI": "NASDAQ",
  "SOGP": "NASDAQ",
  "SOHU": "NASDAQ",
  "SOLS": "NASDAQ",
  "SOLV": "NYSE",
  "SON": "NYSE",
  "SONM": "NASDAQ",
  "SONO": "NASDAQ",
  "SONY": "NYSE",
  "SOPH": "NASDAQ",
  "SOR": "NYSE",
  "SORA": "NASDAQ",
  "SORN": "NASDAQ",
  "SOS": "NYSE",
  "SOTK": "NASDAQ",
  "SOUL": "NYSE",
  "SOUN": "NASDAQ",
  "SOWG": "NASDAQ",
  "SPAI": "NASDAQ",
  "SPB": "NYSE",
  "SPCB": "NASDAQ",
  "SPCE": "NYSE",
  "SPCX": "NASDAQ",
  "SPE": "NYSE",
  "SPE-P-C": "NYSE",
  "SPEG": "NASDAQ",
  "SPFI": "NASDAQ",
  "SPG": "NYSE",
  "SPG-P-J": "NYSE",
  "SPGI": "NYSE",
  "SPH": "NYSE",
  "SPHL": "NASDAQ",
  "SPHR": "NYSE",
  "SPIR": "NYSE",
  "SPKL": "NASDAQ",
  "SPMA": "NYSE",
  "SPMC": "NYSE",
  "SPME": "NYSE",
  "SPNT": "NYSE",
  "SPOK": "NASDAQ",
  "SPOT": "NYSE",
  "SPPL": "NASDAQ",
  "SPRB": "NASDAQ",
  "SPRC": "NASDAQ",
  "SPRO": "NASDAQ",
  "SPRU": "NYSE",
  "SPRY": "NASDAQ",
  "SPSC": "NASDAQ",
  "SPT": "NASDAQ",
  "SPTX": "NASDAQ",
  "SPWH": "NASDAQ",
  "SPWR": "NASDAQ",
  "SPXC": "NYSE",
  "SPXX": "NYSE",
  "SQFT": "NASDAQ",
  "SQFTP": "NASDAQ",
  "SQM": "NYSE",
  "SQNS": "NYSE",
  "SR": "NYSE",
  "SRAD": "NASDAQ",
  "SRBK": "NASDAQ",
  "SRCE": "NASDAQ",
  "SRE": "NYSE",
  "SRFM": "NYSE",
  "SRG": "NYSE",
  "SRG-P-A": "NYSE",
  "SRI": "NYSE",
  "SRL": "NYSE",
  "SRPT": "NASDAQ",
  "SRRK": "NASDAQ",
  "SRTA": "NASDAQ",
  "SRTS": "NASDAQ",
  "SRV": "NYSE",
  "SRXH": "NYSE",
  "SRZN": "NASDAQ",
  "SSAC": "NASDAQ",
  "SSB": "NYSE",
  "SSBI": "NASDAQ",
  "SSD": "NYSE",
  "SSEA": "NASDAQ",
  "SSII": "NASDAQ",
  "SSL": "NYSE",
  "SSM": "NASDAQ",
  "SSMR": "NYSE",
  "SSNC": "NASDAQ",
  "SSP": "NASDAQ",
  "SSRM": "NASDAQ",
  "SST": "NYSE",
  "SSTI": "NASDAQ",
  "SSTK": "NYSE",
  "SSYS": "NASDAQ",
  "ST": "NYSE",
  "STAA": "NASDAQ",
  "STAG": "NYSE",
  "STAK": "NASDAQ",
  "STBA": "NASDAQ",
  "STC": "NYSE",
  "STDN": "NYSE",
  "STE": "NYSE",
  "STEM": "NYSE",
  "STEP": "NASDAQ",
  "STEW": "NYSE",
  "STEX": "NASDAQ",
  "STFS": "NASDAQ",
  "STG": "NYSE",
  "STGW": "NASDAQ",
  "STHO": "NASDAQ",
  "STI": "NASDAQ",
  "STIM": "NASDAQ",
  "STK": "NYSE",
  "STKE": "NASDAQ",
  "STKH": "NASDAQ",
  "STKS": "NASDAQ",
  "STLA": "NYSE",
  "STLD": "NASDAQ",
  "STLN": "NASDAQ",
  "STM": "NYSE",
  "STN": "NYSE",
  "STNE": "NASDAQ",
  "STNG": "NYSE",
  "STOK": "NASDAQ",
  "STRA": "NASDAQ",
  "STRC": "NASDAQ",
  "STRD": "NASDAQ",
  "STRF": "NASDAQ",
  "STRK": "NASDAQ",
  "STRL": "NASDAQ",
  "STRO": "NASDAQ",
  "STRR": "NASDAQ",
  "STRRP": "NASDAQ",
  "STRS": "NASDAQ",
  "STRT": "NASDAQ",
  "STRW": "NYSE",
  "STRZ": "NASDAQ",
  "STT": "NYSE",
  "STT-P-G": "NYSE",
  "STTK": "NASDAQ",
  "STUB": "NYSE",
  "STVN": "NYSE",
  "STWD": "NYSE",
  "STX": "NASDAQ",
  "STXS": "NYSE",
  "STZ": "NYSE",
  "SU": "NYSE",
  "SUGP": "NASDAQ",
  "SUI": "NYSE",
  "SUIG": "NASDAQ",
  "SUJA": "NASDAQ",
  "SUMA": "NASDAQ",
  "SUN": "NYSE",
  "SUNB": "NYSE",
  "SUNC": "NYSE",
  "SUNE": "NASDAQ",
  "SUNS": "NASDAQ",
  "SUPN": "NASDAQ",
  "SUPV": "NYSE",
  "SUPX": "NASDAQ",
  "SURG": "NASDAQ",
  "SUZ": "NYSE",
  "SVA": "NASDAQ",
  "SVAQ": "NASDAQ",
  "SVC": "NASDAQ",
  "SVCC": "NASDAQ",
  "SVCO": "NASDAQ",
  "SVIV": "NASDAQ",
  "SVM": "NYSE",
  "SVRA": "NASDAQ",
  "SVRE": "NASDAQ",
  "SVRN": "NASDAQ",
  "SVV": "NYSE",
  "SW": "NYSE",
  "SWAG": "NASDAQ",
  "SWBI": "NASDAQ",
  "SWIM": "NASDAQ",
  "SWK": "NYSE",
  "SWKS": "NASDAQ",
  "SWMR": "NASDAQ",
  "SWVL": "NASDAQ",
  "SWX": "NYSE",
  "SWZ": "NYSE",
  "SXC": "NYSE",
  "SXI": "NYSE",
  "SXT": "NYSE",
  "SXTC": "NASDAQ",
  "SXTP": "NASDAQ",
  "SY": "NASDAQ",
  "SYBT": "NASDAQ",
  "SYF": "NYSE",
  "SYF-P-A": "NYSE",
  "SYF-P-B": "NYSE",
  "SYK": "NYSE",
  "SYM": "NASDAQ",
  "SYNA": "NASDAQ",
  "SYNX": "NYSE",
  "SYPR": "NASDAQ",
  "SYRE": "NASDAQ",
  "SYY": "NYSE",
  "SZZL": "NASDAQ",
  "T": "NYSE",
  "T-P-A": "NYSE",
  "T-P-C": "NYSE",
  "TAC": "NYSE",
  "TACH": "NASDAQ",
  "TACO": "NASDAQ",
  "TACT": "NASDAQ",
  "TAK": "NYSE",
  "TAL": "NYSE",
  "TALK": "NASDAQ",
  "TALO": "NYSE",
  "TANH": "NASDAQ",
  "TAOP": "NASDAQ",
  "TAOX": "NASDAQ",
  "TAP": "NYSE",
  "TAP-A": "NYSE",
  "TARA": "NASDAQ",
  "TARS": "NASDAQ",
  "TASK": "NASDAQ",
  "TATT": "NASDAQ",
  "TAVI": "NASDAQ",
  "TAYD": "NASDAQ",
  "TBBB": "NYSE",
  "TBBK": "NASDAQ",
  "TBCH": "NASDAQ",
  "TBI": "NYSE",
  "TBLA": "NASDAQ",
  "TBLD": "NASDAQ",
  "TBN": "NYSE",
  "TBPH": "NASDAQ",
  "TC": "NASDAQ",
  "TCBI": "NASDAQ",
  "TCBIO": "NASDAQ",
  "TCBK": "NASDAQ",
  "TCBS": "NASDAQ",
  "TCBX": "NYSE",
  "TCGX": "NASDAQ",
  "TCI": "NYSE",
  "TCMD": "NASDAQ",
  "TCOM": "NASDAQ",
  "TCPC": "NASDAQ",
  "TCRT": "NASDAQ",
  "TCRX": "NASDAQ",
  "TCX": "NASDAQ",
  "TD": "NYSE",
  "TDAC": "NASDAQ",
  "TDAY": "NYSE",
  "TDC": "NYSE",
  "TDF": "NYSE",
  "TDG": "NYSE",
  "TDIC": "NASDAQ",
  "TDOC": "NYSE",
  "TDS": "NYSE",
  "TDS-P-U": "NYSE",
  "TDS-P-V": "NYSE",
  "TDTH": "NASDAQ",
  "TDUP": "NASDAQ",
  "TDW": "NYSE",
  "TDWD": "NASDAQ",
  "TDY": "NYSE",
  "TE": "NYSE",
  "TEAD": "NASDAQ",
  "TEAM": "NASDAQ",
  "TECH": "NASDAQ",
  "TECK": "NYSE",
  "TECX": "NASDAQ",
  "TEI": "NYSE",
  "TEL": "NYSE",
  "TELA": "NASDAQ",
  "TELO": "NASDAQ",
  "TEM": "NASDAQ",
  "TEN": "NYSE",
  "TEN-P-E": "NYSE",
  "TEN-P-F": "NYSE",
  "TENB": "NASDAQ",
  "TENX": "NASDAQ",
  "TEO": "NYSE",
  "TER": "NASDAQ",
  "TEVA": "NYSE",
  "TEX": "NYSE",
  "TFC": "NYSE",
  "TFC-P-I": "NYSE",
  "TFC-P-O": "NYSE",
  "TFC-P-R": "NYSE",
  "TFII": "NYSE",
  "TFIN": "NYSE",
  "TFIN-P": "NYSE",
  "TFPM": "NYSE",
  "TFSL": "NASDAQ",
  "TFX": "NYSE",
  "TG": "NYSE",
  "TGB": "NYSE",
  "TGE": "NYSE",
  "TGEN": "NYSE",
  "TGHL": "NASDAQ",
  "TGL": "NASDAQ",
  "TGLS": "NYSE",
  "TGS": "NYSE",
  "TGT": "NYSE",
  "TGTX": "NASDAQ",
  "TH": "NASDAQ",
  "THC": "NYSE",
  "THCH": "NASDAQ",
  "THFF": "NASDAQ",
  "THG": "NYSE",
  "THH": "NASDAQ",
  "THM": "NYSE",
  "THO": "NYSE",
  "THQ": "NYSE",
  "THRM": "NASDAQ",
  "THRY": "NASDAQ",
  "THW": "NYSE",
  "TIC": "NYSE",
  "TIGO": "NASDAQ",
  "TIGR": "NASDAQ",
  "TII": "NYSE",
  "TIL": "NASDAQ",
  "TILE": "NASDAQ",
  "TIMB": "NYSE",
  "TIPT": "NASDAQ",
  "TISI": "NYSE",
  "TITN": "NASDAQ",
  "TJGC": "NASDAQ",
  "TJX": "NYSE",
  "TK": "NYSE",
  "TKC": "NYSE",
  "TKLF": "NASDAQ",
  "TKNO": "NASDAQ",
  "TKO": "NYSE",
  "TKR": "NYSE",
  "TLF": "NASDAQ",
  "TLIH": "NASDAQ",
  "TLK": "NYSE",
  "TLN": "NASDAQ",
  "TLNC": "NASDAQ",
  "TLPH": "NASDAQ",
  "TLRY": "NASDAQ",
  "TLS": "NASDAQ",
  "TLSA": "NASDAQ",
  "TLSI": "NASDAQ",
  "TLX": "NASDAQ",
  "TLYS": "NYSE",
  "TM": "NYSE",
  "TMC": "NASDAQ",
  "TMCI": "NASDAQ",
  "TMCR": "NASDAQ",
  "TMDE": "NYSE",
  "TMDX": "NASDAQ",
  "TME": "NYSE",
  "TMO": "NYSE",
  "TMP": "NYSE",
  "TMQ": "NYSE",
  "TMS": "NASDAQ",
  "TMTS": "NASDAQ",
  "TMUS": "NASDAQ",
  "TNC": "NYSE",
  "TNDM": "NASDAQ",
  "TNET": "NYSE",
  "TNGX": "NASDAQ",
  "TNK": "NYSE",
  "TNL": "NYSE",
  "TNMG": "NASDAQ",
  "TNON": "NASDAQ",
  "TNXP": "NASDAQ",
  "TNYA": "NASDAQ",
  "TOL": "NYSE",
  "TOMZ": "NASDAQ",
  "TONT": "NYSE",
  "TONX": "NASDAQ",
  "TOON": "NYSE",
  "TOP": "NASDAQ",
  "TOPP": "NYSE",
  "TOPS": "NYSE",
  "TORO": "NASDAQ",
  "TOST": "NYSE",
  "TOUR": "NASDAQ",
  "TOVX": "NYSE",
  "TOWN": "NASDAQ",
  "TOYO": "NASDAQ",
  "TP": "NYSE",
  "TPB": "NYSE",
  "TPC": "NYSE",
  "TPCS": "NASDAQ",
  "TPET": "NYSE",
  "TPG": "NASDAQ",
  "TPL": "NYSE",
  "TPR": "NYSE",
  "TPST": "NASDAQ",
  "TPVG": "NYSE",
  "TR": "NYSE",
  "TRAD": "NYSE",
  "TRAK": "NYSE",
  "TRAW": "NASDAQ",
  "TRAX": "NASDAQ",
  "TRC": "NYSE",
  "TRDA": "NASDAQ",
  "TREE": "NASDAQ",
  "TREX": "NYSE",
  "TRGP": "NYSE",
  "TRGS": "NASDAQ",
  "TRI": "NASDAQ",
  "TRIB": "NASDAQ",
  "TRIN": "NYSE",
  "TRIP": "NASDAQ",
  "TRLV": "NYSE",
  "TRMB": "NASDAQ",
  "TRMD": "NASDAQ",
  "TRMK": "NASDAQ",
  "TRN": "NYSE",
  "TRNO": "NYSE",
  "TRNR": "NASDAQ",
  "TRNS": "NASDAQ",
  "TRON": "NASDAQ",
  "TROO": "NASDAQ",
  "TROW": "NASDAQ",
  "TROX": "NYSE",
  "TRP": "NYSE",
  "TRS": "NASDAQ",
  "TRSG": "NASDAQ",
  "TRST": "NASDAQ",
  "TRT": "NYSE",
  "TRTN-P-A": "NYSE",
  "TRTN-P-B": "NYSE",
  "TRTN-P-C": "NYSE",
  "TRTN-P-D": "NYSE",
  "TRTN-P-E": "NYSE",
  "TRTN-P-F": "NYSE",
  "TRTN-P-G": "NYSE",
  "TRTX": "NYSE",
  "TRTX-P-C": "NYSE",
  "TRU": "NYSE",
  "TRUG": "NASDAQ",
  "TRUP": "NASDAQ",
  "TRV": "NYSE",
  "TRVG": "NASDAQ",
  "TRVI": "NASDAQ",
  "TRX": "NYSE",
  "TS": "NYSE",
  "TSAT": "NASDAQ",
  "TSBK": "NASDAQ",
  "TSCO": "NASDAQ",
  "TSEM": "NASDAQ",
  "TSHA": "NASDAQ",
  "TSI": "NYSE",
  "TSLA": "NASDAQ",
  "TSLX": "NYSE",
  "TSM": "NYSE",
  "TSN": "NYSE",
  "TSQ": "NYSE",
  "TSSI": "NASDAQ",
  "TT": "NYSE",
  "TTAM": "NYSE",
  "TTAN": "NASDAQ",
  "TTC": "NYSE",
  "TTD": "NASDAQ",
  "TTE": "NYSE",
  "TTEC": "NASDAQ",
  "TTEK": "NASDAQ",
  "TTGT": "NASDAQ",
  "TTI": "NYSE",
  "TTMI": "NASDAQ",
  "TTRX": "NASDAQ",
  "TTWO": "NASDAQ",
  "TU": "NYSE",
  "TULP": "NASDAQ",
  "TURB": "NASDAQ",
  "TUSK": "NASDAQ",
  "TUYA": "NYSE",
  "TV": "NYSE",
  "TVA": "NASDAQ",
  "TVAI": "NASDAQ",
  "TVC": "NYSE",
  "TVE": "NYSE",
  "TVGN": "NASDAQ",
  "TVIV": "NASDAQ",
  "TVRD": "NASDAQ",
  "TVTX": "NASDAQ",
  "TW": "NASDAQ",
  "TWAV": "NASDAQ",
  "TWFG": "NASDAQ",
  "TWG": "NASDAQ",
  "TWI": "NYSE",
  "TWIN": "NASDAQ",
  "TWLO": "NYSE",
  "TWLV": "NASDAQ",
  "TWN": "NYSE",
  "TWO": "NYSE",
  "TWO-P-A": "NYSE",
  "TWO-P-B": "NYSE",
  "TWO-P-C": "NYSE",
  "TWST": "NASDAQ",
  "TX": "NYSE",
  "TXG": "NASDAQ",
  "TXMD": "NASDAQ",
  "TXN": "NASDAQ",
  "TXNM": "NYSE",
  "TXO": "NYSE",
  "TXRH": "NASDAQ",
  "TXT": "NYSE",
  "TY": "NYSE",
  "TY-P": "NYSE",
  "TYG": "NYSE",
  "TYGO": "NASDAQ",
  "TYL": "NYSE",
  "TYRA": "NASDAQ",
  "TZOO": "NASDAQ",
  "U": "NYSE",
  "UA": "NYSE",
  "UAA": "NYSE",
  "UAC": "NYSE",
  "UAL": "NASDAQ",
  "UAMY": "NYSE",
  "UAN": "NYSE",
  "UAVS": "NYSE",
  "UBCP": "NASDAQ",
  "UBER": "NYSE",
  "UBS": "NYSE",
  "UBSI": "NASDAQ",
  "UCAR": "NASDAQ",
  "UCB": "NYSE",
  "UCFI": "NASDAQ",
  "UCL": "NASDAQ",
  "UCTT": "NASDAQ",
  "UDR": "NYSE",
  "UE": "NYSE",
  "UEC": "NYSE",
  "UEIC": "NASDAQ",
  "UFCS": "NASDAQ",
  "UFG": "NASDAQ",
  "UFI": "NYSE",
  "UFPI": "NASDAQ",
  "UFPT": "NASDAQ",
  "UG": "NASDAQ",
  "UGI": "NYSE",
  "UGP": "NYSE",
  "UHAL": "NYSE",
  "UHAL-B": "NYSE",
  "UHS": "NYSE",
  "UHT": "NYSE",
  "UI": "NYSE",
  "UIS": "NYSE",
  "UK": "NASDAQ",
  "UL": "NYSE",
  "ULBI": "NASDAQ",
  "ULCC": "NASDAQ",
  "ULH": "NASDAQ",
  "ULS": "NYSE",
  "ULTA": "NASDAQ",
  "UMAC": "NYSE",
  "UMBF": "NASDAQ",
  "UMBFO": "NASDAQ",
  "UMC": "NYSE",
  "UMH": "NYSE",
  "UMH-P-D": "NYSE",
  "UNB": "NASDAQ",
  "UNCY": "NASDAQ",
  "UNF": "NYSE",
  "UNFI": "NYSE",
  "UNH": "NYSE",
  "UNIT": "NASDAQ",
  "UNM": "NYSE",
  "UNP": "NYSE",
  "UNTY": "NASDAQ",
  "UONE": "NASDAQ",
  "UONEK": "NASDAQ",
  "UP": "NYSE",
  "UPB": "NASDAQ",
  "UPBD": "NASDAQ",
  "UPC": "NASDAQ",
  "UPLD": "NASDAQ",
  "UPS": "NYSE",
  "UPST": "NASDAQ",
  "UPWK": "NASDAQ",
  "UPXI": "NASDAQ",
  "URBN": "NASDAQ",
  "URG": "NYSE",
  "URGN": "NASDAQ",
  "URI": "NYSE",
  "UROY": "NASDAQ",
  "USA": "NYSE",
  "USAC": "NYSE",
  "USAR": "NASDAQ",
  "USAS": "NYSE",
  "USAU": "NASDAQ",
  "USB": "NYSE",
  "USB-P-A": "NYSE",
  "USB-P-H": "NYSE",
  "USB-P-P": "NYSE",
  "USB-P-Q": "NYSE",
  "USB-P-R": "NYSE",
  "USB-P-S": "NYSE",
  "USBC": "NYSE",
  "USCB": "NASDAQ",
  "USDE": "NASDAQ",
  "USEA": "NASDAQ",
  "USFD": "NYSE",
  "USGO": "NASDAQ",
  "USIO": "NASDAQ",
  "USLM": "NASDAQ",
  "USNA": "NYSE",
  "USPH": "NYSE",
  "UTF": "NYSE",
  "UTG": "NYSE",
  "UTHR": "NASDAQ",
  "UTI": "NYSE",
  "UTL": "NYSE",
  "UTMD": "NASDAQ",
  "UTSI": "NASDAQ",
  "UTZ": "NYSE",
  "UUU": "NYSE",
  "UUUU": "NYSE",
  "UVE": "NYSE",
  "UVSP": "NASDAQ",
  "UVV": "NYSE",
  "UWMC": "NYSE",
  "UXIN": "NASDAQ",
  "UYSC": "NASDAQ",
  "UZX": "NASDAQ",
  "V": "NYSE",
  "VABK": "NASDAQ",
  "VAC": "NYSE",
  "VACI": "NYSE",
  "VAL": "NYSE",
  "VALE": "NYSE",
  "VALN": "NASDAQ",
  "VALU": "NASDAQ",
  "VANI": "NASDAQ",
  "VATE": "NYSE",
  "VBF": "NYSE",
  "VBIO": "NASDAQ",
  "VBNK": "NASDAQ",
  "VC": "NASDAQ",
  "VCEL": "NASDAQ",
  "VCIG": "NASDAQ",
  "VCRE": "NASDAQ",
  "VCTR": "NASDAQ",
  "VCV": "NYSE",
  "VCX": "NYSE",
  "VCYT": "NASDAQ",
  "VECA": "NYSE",
  "VECO": "NASDAQ",
  "VEEA": "NASDAQ",
  "VEEE": "NASDAQ",
  "VEEV": "NYSE",
  "VEL": "NYSE",
  "VELO": "NASDAQ",
  "VENU": "NYSE",
  "VEON": "NASDAQ",
  "VERA": "NASDAQ",
  "VERI": "NASDAQ",
  "VERU": "NASDAQ",
  "VERX": "NASDAQ",
  "VET": "NYSE",
  "VFC": "NYSE",
  "VFF": "NASDAQ",
  "VFS": "NASDAQ",
  "VG": "NYSE",
  "VGAS": "NASDAQ",
  "VGI": "NYSE",
  "VGM": "NYSE",
  "VGNT": "NYSE",
  "VGZ": "NYSE",
  "VHC": "NASDAQ",
  "VHCP": "NASDAQ",
  "VHI": "NYSE",
  "VHUB": "NASDAQ",
  "VIA": "NYSE",
  "VIAV": "NASDAQ",
  "VICI": "NYSE",
  "VICR": "NASDAQ",
  "VIDA": "NYSE",
  "VII": "NYSE",
  "VIK": "NYSE",
  "VINP": "NASDAQ",
  "VIOT": "NASDAQ",
  "VIP": "NASDAQ",
  "VIPS": "NYSE",
  "VIR": "NASDAQ",
  "VIRC": "NASDAQ",
  "VIRT": "NYSE",
  "VISN": "NASDAQ",
  "VIST": "NYSE",
  "VITL": "NASDAQ",
  "VIV": "NYSE",
  "VIVK": "NASDAQ",
  "VIVO": "NASDAQ",
  "VIVS": "NASDAQ",
  "VKI": "NYSE",
  "VKQ": "NYSE",
  "VKTX": "NASDAQ",
  "VLGEA": "NASDAQ",
  "VLN": "NYSE",
  "VLO": "NYSE",
  "VLOS": "NASDAQ",
  "VLRS": "NYSE",
  "VLT": "NYSE",
  "VLTO": "NYSE",
  "VLY": "NASDAQ",
  "VLYPN": "NASDAQ",
  "VLYPO": "NASDAQ",
  "VLYPP": "NASDAQ",
  "VMAR": "NASDAQ",
  "VMC": "NYSE",
  "VMD": "NASDAQ",
  "VMET": "NASDAQ",
  "VMI": "NYSE",
  "VMO": "NYSE",
  "VNCE": "NASDAQ",
  "VNDA": "NASDAQ",
  "VNET": "NASDAQ",
  "VNME": "NASDAQ",
  "VNO": "NYSE",
  "VNO-P-L": "NYSE",
  "VNO-P-M": "NYSE",
  "VNO-P-N": "NYSE",
  "VNO-P-O": "NYSE",
  "VNOM": "NASDAQ",
  "VNRX": "NYSE",
  "VNT": "NYSE",
  "VNTG": "NYSE",
  "VOC": "NYSE",
  "VOD": "NASDAQ",
  "VOR": "NASDAQ",
  "VOXR": "NASDAQ",
  "VOYA": "NYSE",
  "VOYA-P-B": "NYSE",
  "VOYG": "NYSE",
  "VPG": "NYSE",
  "VPV": "NYSE",
  "VRA": "NASDAQ",
  "VRAX": "NASDAQ",
  "VRCA": "NASDAQ",
  "VRDN": "NASDAQ",
  "VREX": "NASDAQ",
  "VRM": "NASDAQ",
  "VRME": "NASDAQ",
  "VRNS": "NASDAQ",
  "VRRM": "NASDAQ",
  "VRSK": "NASDAQ",
  "VRSN": "NASDAQ",
  "VRT": "NYSE",
  "VRTS": "NYSE",
  "VRTX": "NASDAQ",
  "VRXA": "NASDAQ",
  "VS": "NASDAQ",
  "VSA": "NASDAQ",
  "VSAT": "NASDAQ",
  "VSEC": "NASDAQ",
  "VSH": "NYSE",
  "VSME": "NASDAQ",
  "VSNT": "NASDAQ",
  "VST": "NYSE",
  "VSTM": "NASDAQ",
  "VSTS": "NYSE",
  "VSXY": "NYSE",
  "VTAK": "NYSE",
  "VTEX": "NYSE",
  "VTGN": "NASDAQ",
  "VTIX": "NASDAQ",
  "VTMX": "NYSE",
  "VTN": "NYSE",
  "VTOL": "NYSE",
  "VTR": "NYSE",
  "VTRS": "NASDAQ",
  "VTS": "NYSE",
  "VTSI": "NASDAQ",
  "VTVT": "NASDAQ",
  "VUZI": "NASDAQ",
  "VVOS": "NASDAQ",
  "VVR": "NYSE",
  "VVV": "NYSE",
  "VVX": "NYSE",
  "VWAV": "NASDAQ",
  "VYGR": "NASDAQ",
  "VYX": "NYSE",
  "VZ": "NYSE",
  "VZLA": "NYSE",
  "W": "NYSE",
  "WAB": "NYSE",
  "WABC": "NASDAQ",
  "WAFD": "NASDAQ",
  "WAFDP": "NASDAQ",
  "WAFU": "NASDAQ",
  "WAL": "NYSE",
  "WAL-P-A": "NYSE",
  "WALD": "NASDAQ",
  "WASH": "NASDAQ",
  "WAT": "NYSE",
  "WATT": "NASDAQ",
  "WAVE": "NASDAQ",
  "WAY": "NASDAQ",
  "WB": "NASDAQ",
  "WBD": "NASDAQ",
  "WBI": "NYSE",
  "WBS": "NYSE",
  "WBS-P-F": "NYSE",
  "WBS-P-G": "NYSE",
  "WBTN": "NASDAQ",
  "WBUY": "NASDAQ",
  "WBX": "NYSE",
  "WCC": "NYSE",
  "WCN": "NYSE",
  "WCT": "NASDAQ",
  "WD": "NYSE",
  "WDAY": "NASDAQ",
  "WDC": "NASDAQ",
  "WDFC": "NASDAQ",
  "WDH": "NYSE",
  "WDI": "NYSE",
  "WDS": "NYSE",
  "WEA": "NYSE",
  "WEAV": "NYSE",
  "WEC": "NYSE",
  "WELL": "NYSE",
  "WEN": "NASDAQ",
  "WENC": "NYSE",
  "WENN": "NASDAQ",
  "WERN": "NASDAQ",
  "WES": "NYSE",
  "WEST": "NASDAQ",
  "WETH": "NASDAQ",
  "WETO": "NASDAQ",
  "WEX": "NYSE",
  "WEYS": "NASDAQ",
  "WF": "NYSE",
  "WFC": "NYSE",
  "WFC-P-A": "NYSE",
  "WFC-P-C": "NYSE",
  "WFC-P-D": "NYSE",
  "WFC-P-L": "NYSE",
  "WFC-P-Y": "NYSE",
  "WFC-P-Z": "NYSE",
  "WFCF": "NASDAQ",
  "WFF": "NASDAQ",
  "WFG": "NYSE",
  "WFRD": "NASDAQ",
  "WGO": "NYSE",
  "WGS": "NASDAQ",
  "WH": "NYSE",
  "WHD": "NYSE",
  "WHF": "NASDAQ",
  "WHG": "NYSE",
  "WHK": "NYSE",
  "WHLR": "NASDAQ",
  "WHLRD": "NASDAQ",
  "WHLRP": "NASDAQ",
  "WHR": "NYSE",
  "WHR-P-A": "NYSE",
  "WHWK": "NASDAQ",
  "WIA": "NYSE",
  "WILC": "NASDAQ",
  "WIMI": "NASDAQ",
  "WINA": "NASDAQ",
  "WING": "NASDAQ",
  "WIT": "NYSE",
  "WIW": "NYSE",
  "WIX": "NASDAQ",
  "WK": "NYSE",
  "WKC": "NYSE",
  "WKEY": "NASDAQ",
  "WKHS": "NASDAQ",
  "WKSP": "NASDAQ",
  "WLDN": "NASDAQ",
  "WLDS": "NASDAQ",
  "WLFC": "NASDAQ",
  "WLII": "NASDAQ",
  "WLK": "NYSE",
  "WLKP": "NYSE",
  "WLTH": "NASDAQ",
  "WLY": "NYSE",
  "WLYB": "NYSE",
  "WM": "NYSE",
  "WMB": "NYSE",
  "WMG": "NASDAQ",
  "WMK": "NYSE",
  "WMS": "NYSE",
  "WMT": "NASDAQ",
  "WNC": "NYSE",
  "WNEB": "NASDAQ",
  "WNW": "NASDAQ",
  "WOK": "NASDAQ",
  "WOLF": "NYSE",
  "WOOF": "NASDAQ",
  "WOR": "NYSE",
  "WPAC": "NYSE",
  "WPC": "NYSE",
  "WPM": "NYSE",
  "WPP": "NYSE",
  "WPRT": "NASDAQ",
  "WRAP": "NASDAQ",
  "WRB": "NYSE",
  "WRBY": "NYSE",
  "WRD": "NASDAQ",
  "WRLD": "NASDAQ",
  "WRN": "NYSE",
  "WS": "NYSE",
  "WSBC": "NASDAQ",
  "WSBCO": "NASDAQ",
  "WSBF": "NASDAQ",
  "WSBK": "NASDAQ",
  "WSC": "NASDAQ",
  "WSE": "NASDAQ",
  "WSFS": "NASDAQ",
  "WSHP": "NASDAQ",
  "WSM": "NYSE",
  "WSO": "NYSE",
  "WSO-B": "NYSE",
  "WST": "NYSE",
  "WSTN": "NASDAQ",
  "WT": "NYSE",
  "WTBA": "NASDAQ",
  "WTF": "NASDAQ",
  "WTFC": "NASDAQ",
  "WTFCN": "NASDAQ",
  "WTG": "NASDAQ",
  "WTI": "NYSE",
  "WTM": "NYSE",
  "WTRG": "NYSE",
  "WTS": "NYSE",
  "WTTR": "NYSE",
  "WTW": "NASDAQ",
  "WU": "NYSE",
  "WULF": "NASDAQ",
  "WVE": "NASDAQ",
  "WVVI": "NASDAQ",
  "WVVIP": "NASDAQ",
  "WW": "NASDAQ",
  "WWD": "NASDAQ",
  "WWR": "NYSE",
  "WWW": "NYSE",
  "WXM": "NASDAQ",
  "WY": "NYSE",
  "WYFI": "NASDAQ",
  "WYHG": "NASDAQ",
  "WYNN": "NASDAQ",
  "WYY": "NYSE",
  "XAIR": "NASDAQ",
  "XBIO": "NASDAQ",
  "XBIT": "NASDAQ",
  "XBP": "NASDAQ",
  "XCBE": "NASDAQ",
  "XCH": "NASDAQ",
  "XCUR": "NASDAQ",
  "XE": "NASDAQ",
  "XEL": "NASDAQ",
  "XELB": "NASDAQ",
  "XENE": "NASDAQ",
  "XERS": "NASDAQ",
  "XFLH": "NYSE",
  "XFLT": "NYSE",
  "XFOR": "NASDAQ",
  "XGN": "NASDAQ",
  "XHG": "NASDAQ",
  "XHLD": "NASDAQ",
  "XHR": "NYSE",
  "XIFR": "NYSE",
  "XLO": "NASDAQ",
  "XMAX": "NASDAQ",
  "XMTR": "NASDAQ",
  "XNCR": "NASDAQ",
  "XNDU": "NASDAQ",
  "XNET": "NASDAQ",
  "XOM": "NYSE",
  "XOS": "NASDAQ",
  "XP": "NASDAQ",
  "XPEL": "NASDAQ",
  "XPER": "NYSE",
  "XPEV": "NYSE",
  "XPL": "NYSE",
  "XPO": "NYSE",
  "XPOF": "NYSE",
  "XPON": "NASDAQ",
  "XPRO": "NYSE",
  "XRAY": "NASDAQ",
  "XRN": "NYSE",
  "XRN-P-A": "NYSE",
  "XRN-P-B": "NYSE",
  "XRPN": "NASDAQ",
  "XRTX": "NASDAQ",
  "XRX": "NASDAQ",
  "XSLL": "NASDAQ",
  "XTIA": "NASDAQ",
  "XTLB": "NASDAQ",
  "XTNT": "NYSE",
  "XWEL": "NASDAQ",
  "XXI": "NYSE",
  "XXII": "NASDAQ",
  "XYF": "NYSE",
  "XYL": "NYSE",
  "XYZ": "NYSE",
  "XZO": "NYSE",
  "YAAS": "NASDAQ",
  "YALA": "NYSE",
  "YARW": "NASDAQ",
  "YB": "NASDAQ",
  "YCBD": "NYSE",
  "YCY": "NYSE",
  "YDDL": "NASDAQ",
  "YDES": "NASDAQ",
  "YDKG": "NASDAQ",
  "YELP": "NYSE",
  "YETI": "NYSE",
  "YEXT": "NYSE",
  "YHC": "NASDAQ",
  "YHGJ": "NASDAQ",
  "YHNA": "NASDAQ",
  "YI": "NASDAQ",
  "YIBO": "NASDAQ",
  "YICC": "NASDAQ",
  "YJ": "NASDAQ",
  "YMAT": "NASDAQ",
  "YMM": "NYSE",
  "YMT": "NASDAQ",
  "YORW": "NASDAQ",
  "YOU": "NYSE",
  "YOUL": "NASDAQ",
  "YPF": "NYSE",
  "YQ": "NASDAQ",
  "YRD": "NYSE",
  "YSG": "NYSE",
  "YSS": "NYSE",
  "YSWY": "NASDAQ",
  "YSXT": "NASDAQ",
  "YTRA": "NASDAQ",
  "YUM": "NYSE",
  "YUMC": "NYSE",
  "YXT": "NASDAQ",
  "YYAI": "NASDAQ",
  "YYGH": "NASDAQ",
  "Z": "NASDAQ",
  "ZBAO": "NASDAQ",
  "ZBH": "NYSE",
  "ZBIO": "NASDAQ",
  "ZBRA": "NASDAQ",
  "ZCMD": "NASDAQ",
  "ZD": "NASDAQ",
  "ZDAI": "NASDAQ",
  "ZDGE": "NYSE",
  "ZENA": "NASDAQ",
  "ZEO": "NASDAQ",
  "ZEPP": "NYSE",
  "ZETA": "NYSE",
  "ZG": "NASDAQ",
  "ZGN": "NYSE",
  "ZH": "NYSE",
  "ZIM": "NYSE",
  "ZION": "NASDAQ",
  "ZIONP": "NASDAQ",
  "ZIP": "NYSE",
  "ZJK": "NASDAQ",
  "ZJYL": "NASDAQ",
  "ZKH": "NYSE",
  "ZKIN": "NASDAQ",
  "ZKP": "NASDAQ",
  "ZLAB": "NASDAQ",
  "ZM": "NASDAQ",
  "ZNB": "NASDAQ",
  "ZNTL": "NASDAQ",
  "ZONE": "NYSE",
  "ZOOZ": "NASDAQ",
  "ZS": "NASDAQ",
  "ZSQR": "NASDAQ",
  "ZSTK": "NASDAQ",
  "ZTEK": "NASDAQ",
  "ZTG": "NASDAQ",
  "ZTO": "NYSE",
  "ZTR": "NYSE",
  "ZTS": "NYSE",
  "ZUMZ": "NASDAQ",
  "ZURA": "NASDAQ",
  "ZVIA": "NYSE",
  "ZVRA": "NASDAQ",
  "ZWS": "NYSE",
  "ZYBT": "NASDAQ",
  "ZYME": "NASDAQ",
};
